/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountDeletionRequest,
  AccountGoneResponse,
  ActivationAdminSubmissionListResponse,
  ActivationsAdminProjectTemplatesListParams,
  ActivationsAdminProjectTemplatesSubmissionsListParams,
  ActivationsAdminStudentProjectsListParams,
  ActivationsAdminStudentProjectsSubmissionsListParams,
  ActivationsAdminThematicTasksListParams,
  ActivationsAdminThematicTasksSubmissionsListParams,
  ActivitiesAdminDefinitionsListParams,
  ActivitiesCurrentParams,
  ActivityAcceptRequest,
  ActivityAcceptResponse,
  ActivityCurrentFeed,
  ActivityCurrentItem,
  ActivityDeclarationError,
  ActivityDeclarationRequest,
  ActivityDeclarationResponse,
  AdminAccountInviteRequest,
  AdminAccountPasswordResetResponse,
  AdminAccountReset2FARequestRequest,
  AdminAccountRoleRequest,
  AdminAccountRow,
  AdminAccountTemporaryPasswordRequestRequest,
  AdminAccountTemporaryPasswordResponse,
  AdminAccountsListParams,
  AdminActivationReminder,
  AdminActivationReminderCreateRequest,
  AdminActivityCapabilities,
  AdminActivityDefinition,
  AdminActivityDefinitionCreateRequest,
  AdminActivityDefinitions,
  AdminActivityError,
  AdminActivityRevision,
  AdminActivityRevisionCreateRequest,
  AdminActivityRevisionUpdateRequest,
  AdminActivityRevisions,
  AdminAnnualCalendarImportCommit,
  AdminAnnualCalendarImportError,
  AdminAnnualCalendarImportPreview,
  AdminAnnualCalendarImportUploadRequest,
  AdminCalendarSlot,
  AdminCalendarSlotList,
  AdminCalendarSlotRequest,
  AdminCurriculumConflict,
  AdminCurriculumEnrollment,
  AdminCurriculumEnrollmentCreateRequest,
  AdminCurriculumNextDraftRequestRequest,
  AdminCurriculumPlan,
  AdminCurriculumPlanVersion,
  AdminCurriculumPlanVersionDetail,
  AdminCurriculumPublicationError,
  AdminCurriculumPublishRequestRequest,
  AdminKnowledgeHint,
  AdminKnowledgeHintRequest,
  AdminKnowledgeTopic,
  AdminKnowledgeTopicRequest,
  AdminMissionCadencePreview,
  AdminMissionCadenceRecipe,
  AdminMissionCadenceRecipeRevision,
  AdminMissionCadenceRecipeRevisions,
  AdminMissionCadenceRecipeValidation,
  AdminMissionCadenceRecipeWriteRequest,
  AdminMissionCadenceRecipes,
  AdminNotificationTestSendListParams,
  AdminPoll,
  AdminPollCancelRequest,
  AdminPollPreview,
  AdminPollResults,
  AdminPollScheduleRequest,
  AdminPollWriteRequest,
  AdminProjectTemplate,
  AdminProjectTemplateWriteRequest,
  AdminPushQuiz,
  AdminPushQuizCancelRequest,
  AdminPushQuizDistributionPreview,
  AdminPushQuizPreview,
  AdminPushQuizResults,
  AdminPushQuizScheduleRequest,
  AdminPushQuizWriteRequest,
  AdminQuestion,
  AdminQuestionBulkPublishConflict,
  AdminQuestionBulkPublishRequest,
  AdminQuestionBulkPublishResponse,
  AdminQuestionCreateRequest,
  AdminQuestionImportCommit,
  AdminQuestionImportPreview,
  AdminQuestionImportUploadRequest,
  AdminQuestionReviseRequest,
  AdminQuizCapabilities,
  AdminQuizCyclePreview,
  AdminQuizCyclePreviewRequestRequest,
  AdminQuizCycleRecipe,
  AdminQuizCycleRecipeRevision,
  AdminQuizCycleRecipeRevisions,
  AdminQuizCycleRecipeValidation,
  AdminQuizCycleRecipeWriteRequest,
  AdminQuizCycleRecipes,
  AdminQuizTopic,
  AdminQuizTopicRequest,
  AdminSeasonalCampaign,
  AdminSeasonalCampaignCreateRequest,
  AdminSeasonalCampaigns,
  AdminStudentProject,
  AdminStudentProjectPreview,
  AdminStudentProjectPublishRequest,
  AdminStudentProjectWriteRequest,
  AdminSubmissionDetail,
  AdminThematicTask,
  AdminThematicTaskWriteRequest,
  AdminWeeklyOverview,
  AdminWeeklyPublication,
  AdminWeeklySet,
  AdminWeeklySetPublishRequest,
  AdminWeeklySetWithdrawRequest,
  AllauthAuthEnvelope,
  AllauthAuthenticatedByPasswordAnd2FAResponse,
  AllauthAuthenticatedByPasswordResponse,
  AllauthAuthenticatedResponse,
  AllauthAuthenticationResponse,
  AllauthConfigurationResponse,
  AllauthConflictResponse,
  AllauthEmailVerificationInfoResponse,
  AllauthErrorResponse,
  AllauthForbiddenResponse,
  AllauthLoginBody,
  AllauthMFAAuthenticateBody,
  AllauthPasswordResetInfoResponse,
  AllauthReauthenticateBody,
  AllauthRefreshTokenBody,
  AllauthRefreshTokenResponse,
  AllauthRequestPasswordBody,
  AllauthResetPasswordBody,
  AllauthSessionGoneResponse,
  AllauthSignupBody,
  AllauthStatusOKResponse,
  AllauthTooManyRequestsResponse,
  AllauthUnauthenticatedResponse,
  AllauthVerifyEmailBody,
  AnswerResult,
  AttachmentEmailProfile,
  AttachmentEmailProfileWriteRequest,
  Auth2faEnrollActivateBody,
  AuthPasswordChangeRequiredBody,
  AuthRecoverySetupRequiredBody,
  Availability,
  AvatarConfig,
  AvatarConfigWriteRequest,
  AvatarOptions,
  AvatarStyle,
  BarometerMonths,
  BarometerRead,
  BlockRequestRequest,
  BudgetEntryOptions,
  BudgetSettings,
  BudgetSettingsRequest,
  BugReportCreate,
  BugReportCreateRequest,
  BulkOperationRequest,
  CalendarQuizList,
  CalendarQuizSummary,
  CascadeInitiateRequest,
  Catalogs,
  CategorySelection,
  CategorySelectionRequest,
  ChallengeAdminRead,
  ChallengeList,
  ChallengeRead,
  ChallengeWriteRequest,
  Class,
  ClassDeleteRequest,
  ClassLeaderboard,
  ClassModulesSummary,
  ClassProgressResponse,
  ClassRequest,
  Currency,
  CurrencyImportError,
  CurrencyImportSummary,
  CurrencyImportUploadRequest,
  CurrencyRequest,
  DecisionRequest,
  Device,
  DeviceDeregisterRequest,
  DeviceRequest,
  EmailChangePending,
  EmailChangeReauthRequest,
  EmailChangeStartRequest,
  ErrorEnvelope,
  FinCoinMovementList,
  FinCoinSummary,
  ForcePasswordChangePreview,
  ForcePasswordChangeRequestRequest,
  ForcePasswordChangeResponse,
  GamificationRevisionList,
  GamificationSummary,
  GecResponseEditRequest,
  GecResponseList,
  GlobalConfigRead,
  GoalLimitConfig,
  GoalMovementRevisionPage,
  Invitation,
  InvitationActivateRequest,
  KnowledgeBase,
  KnowledgeBaseAdminHintsListParams,
  KnowledgeBaseAdminTopicsListParams,
  KnowledgeHintVisibility,
  KnowledgeHintVisibilityWriteRequest,
  KnowledgePlacement,
  LifeLineBootstrap,
  ManualEntryRead,
  ManualEntryWriteRequest,
  Me,
  MeBadges,
  MeFincoinsMovementsParams,
  MeGamificationRevisionsParams,
  MeModules,
  MeRanking,
  MeStreakRetrieveParams,
  MeUpdateRequest,
  Mission,
  MissionAdvanceRequestRequest,
  MissionClaim,
  MissionDay,
  MissionError,
  MissionPeriodRetrieveParams,
  ModuleCatalogItem,
  ModuleLevelConfig,
  ModuleOverrideWriteRequest,
  ModulesConfigAuditListParams,
  ModulesConfigGlobalRetrieveParams,
  ModulesConfigGlobalSetParams,
  NotificationCampaign,
  NotificationCampaignRequest,
  NotificationIntent,
  NotificationPolicy,
  NotificationPolicyRequest,
  NotificationPreference,
  NotificationPreferenceRequest,
  NotificationReceipt,
  NotificationReceiptCommandRequest,
  NotificationTemplate,
  NotificationTemplateRequest,
  NotificationTestCapabilities,
  NotificationTestCommandRequest,
  NotificationTestPreviewResponse,
  NotificationTestSend,
  NotificationTestSendCreateRequest,
  NotificationType,
  NotificationTypeRequest,
  OverrideStudentPasswordRequest,
  OverrideStudentPasswordResponse,
  PaginatedAdminAccountRowList,
  PaginatedAdminCurriculumEnrollmentList,
  PaginatedAdminPollList,
  PaginatedAdminProjectTemplateList,
  PaginatedAdminPushQuizList,
  PaginatedAdminQuestionList,
  PaginatedAdminQuizTopicList,
  PaginatedAdminStudentProjectList,
  PaginatedAdminThematicTaskList,
  PaginatedBudgetEntryPullList,
  PaginatedBudgetEntryReportRowList,
  PaginatedBulkOperationRequestList,
  PaginatedCategoryLimitPullList,
  PaginatedChestClaimPullList,
  PaginatedClassListList,
  PaginatedCompanyGoalPullList,
  PaginatedCurrencyList,
  PaginatedGoalAllocationPullList,
  PaginatedGoalDepositPullList,
  PaginatedGoalMapPlanPullList,
  PaginatedGoalPullList,
  PaginatedLifeLineScenarioPullList,
  PaginatedManualEntryHistoryList,
  PaginatedModuleAuditEntryList,
  PaginatedMonthOpeningPullList,
  PaginatedMonthlyLimitPullList,
  PaginatedMoodEntryPullList,
  PaginatedNoIncomeDeclarationPullList,
  PaginatedNoSpendDeclarationPullList,
  PaginatedNotificationAdminDeviceList,
  PaginatedNotificationCampaignList,
  PaginatedNotificationIntentList,
  PaginatedNotificationTargetList,
  PaginatedNotificationTemplateList,
  PaginatedNotificationTestSendList,
  PaginatedNotificationTypeList,
  PaginatedPollResponseReportRowList,
  PaginatedRspoInstitutionListList,
  PaginatedSchoolChangeProposalList,
  PaginatedSchoolListList,
  PaginatedSchoolNameEntryListList,
  PaginatedSchoolTypeListList,
  PaginatedStudentFinancialPlanPullList,
  PaginatedSubGoalPullList,
  PaginatedSyncDeadLetterList,
  PaginatedSyncDemoEntryList,
  PaginatedTeacherAccountRowList,
  PaginatedTeacherAssignedSchoolList,
  PaginatedWhimsLimitPullList,
  PairPickRequest,
  PairPickResult,
  PatchedAdminActivityRevisionUpdateRequest,
  PatchedAdminCalendarSlotRequest,
  PatchedAdminCurriculumEnrollmentUpdateRequest,
  PatchedAdminCurriculumVersionWriteRequest,
  PatchedAdminKnowledgeHintRequest,
  PatchedAdminKnowledgeTopicRequest,
  PatchedAdminPollWriteRequest,
  PatchedAdminProjectTemplateWriteRequest,
  PatchedAdminPushQuizWriteRequest,
  PatchedAdminQuestionModulesRequest,
  PatchedAdminQuestionTopicsRequest,
  PatchedAdminQuizTopicRequest,
  PatchedAdminStudentProjectWriteRequest,
  PatchedAdminThematicTaskWriteRequest,
  PatchedChallengeEditRequest,
  PatchedClassRequest,
  PatchedCurrencyRequest,
  PatchedGlobalConfigWriteRequest,
  PatchedMeUpdateRequest,
  PatchedNotificationTemplateRequest,
  PatchedNotificationTypeRequest,
  PatchedSchoolRequest,
  PatchedSubmissionUpdateRequest,
  PatchedTeacherAccountUpdateRequest,
  PeriodCatalog,
  PeriodClosedError,
  PeriodDocument,
  PeriodResponseWriteRequest,
  PeriodTask,
  PointsBalance,
  PollCapabilities,
  PollDiscovery,
  PollError,
  PollResponseAck,
  PollResponseOptions,
  PollResponseWriteRequest,
  PollSession,
  PollSessionComplete,
  PollSessionCompleteInputRequest,
  PricingDocument,
  PricingError,
  PricingPublishRequest,
  ProjectTemplateEntry,
  ProjectTemplateList,
  PushQuizList,
  QuizAnswerSubmissionRequest,
  QuizSessionStartRequestRequest,
  RankingVisibility,
  RankingVisibilityWriteRequest,
  RankingsManualEntriesListParams,
  RecoveryCompleteRequestRequest,
  RecoveryCompleteResponse,
  RecoveryCredentialsUpdateRequest,
  RecoveryCredentialsUpdateResponse,
  RecoveryError,
  RecoveryQuestionsResponse,
  RecoveryStartRequestRequest,
  RecoveryVerifyRequestRequest,
  RecoveryVerifyResponse,
  ReferencePack,
  ReplayPairPickResult,
  ResetByCodeRequestRequest,
  ResetByCodeResponse,
  ResetStudentError,
  ResetStudentQuestionRequestRequest,
  ResetStudentQuestionResponse,
  RestoreRequestRequest,
  RspoInstitutionDetail,
  School,
  SchoolChangeProposal,
  SchoolChangeProposalApproveRequest,
  SchoolChangeProposalConflict,
  SchoolChangeProposalRequest,
  SchoolChangeProposalsAssignedSchoolsParams,
  SchoolChangeProposalsListParams,
  SchoolCities,
  SchoolEditResult,
  SchoolLeaderboard,
  SchoolLogoUploadRequest,
  SchoolNameCheckRequest,
  SchoolNameCheckResponse,
  SchoolProgressResponse,
  SchoolRequest,
  ScoringRulesWriteRequest,
  SessionReplay,
  SessionResult,
  SessionRevokeResult,
  SessionStart,
  SessionsCount,
  SessionsList,
  SessionsLogoutOthersRequest,
  SheetCancelInfo,
  SheetCreateRequest,
  SheetInfo,
  Streak,
  StudentAccountCreateResponse,
  StudentLeaderboard,
  StudentModulesRow,
  StudentPoll,
  StudentProgressResponse,
  StudentProjectEntry,
  StudentProjectList,
  StudentProjectSubmissionDetail,
  StudentProjectSubmissionList,
  StudentRecoveryStartResponse,
  StudentRosterResponse,
  StudentRosterRow,
  StudentSubmissionDetail,
  StudentSubmissionList,
  SubmissionCreateRequest,
  SubmissionCreated,
  SubmissionReviewRequest,
  SyncDeadLetter,
  SyncDeadLetterCreateRequest,
  SyncError,
  SyncOperationResult,
  SyncOperationVariantsRequest,
  TeacherAccountArchiveResponse,
  TeacherAccountCreateRequest,
  TeacherAccountCreateResponse,
  TeacherAccountDeleteRequest,
  TeacherAccountDetail,
  TeacherAccountRestoreResponse,
  TeacherAccountSchoolRemoveResponse,
  TeacherAccountUpdateResponse,
  TeacherAccountsListParams,
  TeacherClassLinkAddRequest,
  TeacherInvitationResendResponse,
  TeacherPasswordResetResponse,
  TeacherSchoolAssignmentAddRequest,
  ThematicTaskEntry,
  ThematicTaskList,
  TotpExchangeDecisionRequest,
  TotpExchangeRequest,
  TotpExchangeSecret,
  TotpExchangeStartRequest,
  TotpExchangeStatus,
  TotpExchangeVerifyRequest,
  TransferPreviewRequestRequest,
  TransferPreviewResponse,
  TransferRequestRequest,
  UnauthorizedResponse,
  V1AdminNotificationsCampaignsListParams,
  V1AdminNotificationsIntentsListParams,
  V1AdminNotificationsTemplatesListParams,
  V1AdminNotificationsTestConsoleTargetsDevicesListParams,
  V1AdminNotificationsTestConsoleTargetsListParams,
  V1AdminNotificationsTypesListParams,
  V1BarometerChestClaimsListParams,
  V1BudgetCategoryLimitsListParams,
  V1BudgetEntriesListParams,
  V1BudgetMonthOpeningsListParams,
  V1BudgetMonthlyLimitsListParams,
  V1BudgetWhimsLimitsListParams,
  V1BulkOperationsListParams,
  V1ClassesListParams,
  V1ClassesStudentsDestroyBody,
  V1ClassesStudentsRetrieveParams,
  V1CompanyGoalsListParams,
  V1CurrenciesListParams,
  V1CurriculumAdminEnrollmentsListParams,
  V1CurriculumAdminPlanVersionsCalendarSlotsDestroyParams,
  V1GoalsAllocationsListParams,
  V1GoalsDepositsListParams,
  V1GoalsListParams,
  V1GoalsMapPlansListParams,
  V1GoalsMovementsRetrieveParams,
  V1GoalsSubGoalsListParams,
  V1LifeLineScenariosListParams,
  V1MoodEntriesListParams,
  V1NoIncomeDeclarationsListParams,
  V1NoSpendDeclarationsListParams,
  V1PlansFinancialListParams,
  V1PollsAdminPollsListParams,
  V1QuizAdminPushQuizzesListParams,
  V1QuizAdminQuestionsListParams,
  V1QuizAdminTopicsListParams,
  V1QuizCalendarRetrieveParams,
  V1ReportingBudgetEntriesExportRetrieveParams,
  V1ReportingBudgetEntriesListParams,
  V1ReportingPollResponsesExportRetrieveParams,
  V1ReportingPollResponsesListParams,
  V1RspoInstitutionsListParams,
  V1SchoolNamesListParams,
  V1SchoolTypesListParams,
  V1SchoolsListParams,
  V1SyncDemoEntriesListParams,
  V1SystemErrorsListParams
} from './model';

import { customFetch } from './fetcher';
import { knowledgeHintFormData } from '../lib/knowledge-form-data';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type accountsForcePasswordChangePreviewResponse200 = {
  data: ForcePasswordChangePreview
  status: 200
}

export type accountsForcePasswordChangePreviewResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type accountsForcePasswordChangePreviewResponse403 = {
  data: void
  status: 403
}

export type accountsForcePasswordChangePreviewResponse404 = {
  data: void
  status: 404
}

export type accountsForcePasswordChangePreviewResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type accountsForcePasswordChangePreviewResponseSuccess = (accountsForcePasswordChangePreviewResponse200) & {
  headers: Headers;
};
export type accountsForcePasswordChangePreviewResponseError = (accountsForcePasswordChangePreviewResponse401 | accountsForcePasswordChangePreviewResponse403 | accountsForcePasswordChangePreviewResponse404 | accountsForcePasswordChangePreviewResponse410) & {
  headers: Headers;
};

export type accountsForcePasswordChangePreviewResponse = (accountsForcePasswordChangePreviewResponseSuccess | accountsForcePasswordChangePreviewResponseError)

export const getAccountsForcePasswordChangePreviewUrl = (id: number,) => {




  return `/api/v1/accounts/${id}/force-password-change/`
}

/**
 * GET — dane ekranu potwierdzenia (§3.1 krok 2); POST — wykonanie operacji.
 *
 * Tylko sesja przeglądarki: aktor re-autoryzuje bieżącą pełną sesję cookie
 * (jak TR-123). Klient app/JWT nie ma tu zastosowania — akcja jest panelowa.
 * @summary Podgląd operacji wymuszenia zmiany hasła (TR-125 §3.1)
 */
export const accountsForcePasswordChangePreview = async (id: number, options?: RequestInit): Promise<accountsForcePasswordChangePreviewResponse> => {

  return customFetch<accountsForcePasswordChangePreviewResponse>(getAccountsForcePasswordChangePreviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAccountsForcePasswordChangePreviewQueryKey = (id: number,) => {
    return [
    `/api/v1/accounts/${id}/force-password-change/`
    ] as const;
    }


export const getAccountsForcePasswordChangePreviewQueryOptions = <TData = Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountsForcePasswordChangePreviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>> = ({ signal }) => accountsForcePasswordChangePreview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountsForcePasswordChangePreviewQueryResult = NonNullable<Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>>
export type AccountsForcePasswordChangePreviewQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useAccountsForcePasswordChangePreview<TData = Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>,
          TError,
          Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountsForcePasswordChangePreview<TData = Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>,
          TError,
          Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountsForcePasswordChangePreview<TData = Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Podgląd operacji wymuszenia zmiany hasła (TR-125 §3.1)
 */

export function useAccountsForcePasswordChangePreview<TData = Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsForcePasswordChangePreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountsForcePasswordChangePreviewQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type accountsForcePasswordChangeResponse200 = {
  data: ForcePasswordChangeResponse
  status: 200
}

export type accountsForcePasswordChangeResponse400 = {
  data: void
  status: 400
}

export type accountsForcePasswordChangeResponse401 = {
  data: void
  status: 401
}

export type accountsForcePasswordChangeResponse403 = {
  data: void
  status: 403
}

export type accountsForcePasswordChangeResponse404 = {
  data: void
  status: 404
}

export type accountsForcePasswordChangeResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type accountsForcePasswordChangeResponseSuccess = (accountsForcePasswordChangeResponse200) & {
  headers: Headers;
};
export type accountsForcePasswordChangeResponseError = (accountsForcePasswordChangeResponse400 | accountsForcePasswordChangeResponse401 | accountsForcePasswordChangeResponse403 | accountsForcePasswordChangeResponse404 | accountsForcePasswordChangeResponse410) & {
  headers: Headers;
};

export type accountsForcePasswordChangeResponse = (accountsForcePasswordChangeResponseSuccess | accountsForcePasswordChangeResponseError)

export const getAccountsForcePasswordChangeUrl = (id: number,) => {




  return `/api/v1/accounts/${id}/force-password-change/`
}

/**
 * GET — dane ekranu potwierdzenia (§3.1 krok 2); POST — wykonanie operacji.
 *
 * Tylko sesja przeglądarki: aktor re-autoryzuje bieżącą pełną sesję cookie
 * (jak TR-123). Klient app/JWT nie ma tu zastosowania — akcja jest panelowa.
 * @summary Wymuś zmianę hasła i zakończ wszystkie sesje (TR-125 §3.1)
 */
export const accountsForcePasswordChange = async (id: number,
    forcePasswordChangeRequestRequest: ForcePasswordChangeRequestRequest, options?: RequestInit): Promise<accountsForcePasswordChangeResponse> => {

  return customFetch<accountsForcePasswordChangeResponse>(getAccountsForcePasswordChangeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forcePasswordChangeRequestRequest)
  }
);}




export const getAccountsForcePasswordChangeMutationOptions = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountsForcePasswordChange>>, TError,{id: number;data: ForcePasswordChangeRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof accountsForcePasswordChange>>, TError,{id: number;data: ForcePasswordChangeRequestRequest}, TContext> => {

const mutationKey = ['accountsForcePasswordChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountsForcePasswordChange>>, {id: number;data: ForcePasswordChangeRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  accountsForcePasswordChange(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountsForcePasswordChangeMutationResult = NonNullable<Awaited<ReturnType<typeof accountsForcePasswordChange>>>
    export type AccountsForcePasswordChangeMutationBody = ForcePasswordChangeRequestRequest
    export type AccountsForcePasswordChangeMutationError = void | AccountGoneResponse

    /**
 * @summary Wymuś zmianę hasła i zakończ wszystkie sesje (TR-125 §3.1)
 */
export const useAccountsForcePasswordChange = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountsForcePasswordChange>>, TError,{id: number;data: ForcePasswordChangeRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountsForcePasswordChange>>,
        TError,
        {id: number;data: ForcePasswordChangeRequestRequest},
        TContext
      > => {
      return useMutation(getAccountsForcePasswordChangeMutationOptions(options), queryClient);
    }

export type activationsAdminProjectTemplatesListResponse200 = {
  data: PaginatedAdminProjectTemplateList
  status: 200
}

export type activationsAdminProjectTemplatesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesListResponseSuccess = (activationsAdminProjectTemplatesListResponse200) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesListResponseError = (activationsAdminProjectTemplatesListResponse401 | activationsAdminProjectTemplatesListResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesListResponse = (activationsAdminProjectTemplatesListResponseSuccess | activationsAdminProjectTemplatesListResponseError)

export const getActivationsAdminProjectTemplatesListUrl = (params?: ActivationsAdminProjectTemplatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/activations/admin/project-templates/?${stringifiedParams}` : `/api/v1/activations/admin/project-templates/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Lista szablonów projektów uczniowskich (operator)
 */
export const activationsAdminProjectTemplatesList = async (params?: ActivationsAdminProjectTemplatesListParams, options?: RequestInit): Promise<activationsAdminProjectTemplatesListResponse> => {

  return customFetch<activationsAdminProjectTemplatesListResponse>(getActivationsAdminProjectTemplatesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminProjectTemplatesListQueryKey = (params?: ActivationsAdminProjectTemplatesListParams,) => {
    return [
    `/api/v1/activations/admin/project-templates/`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivationsAdminProjectTemplatesListQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: ActivationsAdminProjectTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminProjectTemplatesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>> = ({ signal }) => activationsAdminProjectTemplatesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminProjectTemplatesListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>>
export type ActivationsAdminProjectTemplatesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminProjectTemplatesList<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  ActivationsAdminProjectTemplatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminProjectTemplatesList<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ActivationsAdminProjectTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminProjectTemplatesList<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ActivationsAdminProjectTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Lista szablonów projektów uczniowskich (operator)
 */

export function useActivationsAdminProjectTemplatesList<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ActivationsAdminProjectTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminProjectTemplatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminProjectTemplatesCreateResponse201 = {
  data: AdminProjectTemplate
  status: 201
}

export type activationsAdminProjectTemplatesCreateResponse400 = {
  data: void
  status: 400
}

export type activationsAdminProjectTemplatesCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesCreateResponseSuccess = (activationsAdminProjectTemplatesCreateResponse201) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesCreateResponseError = (activationsAdminProjectTemplatesCreateResponse400 | activationsAdminProjectTemplatesCreateResponse401 | activationsAdminProjectTemplatesCreateResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesCreateResponse = (activationsAdminProjectTemplatesCreateResponseSuccess | activationsAdminProjectTemplatesCreateResponseError)

export const getActivationsAdminProjectTemplatesCreateUrl = () => {




  return `/api/v1/activations/admin/project-templates/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Utworzenie szkicu szablonu projektu
 */
export const activationsAdminProjectTemplatesCreate = async (adminProjectTemplateWriteRequest: AdminProjectTemplateWriteRequest, options?: RequestInit): Promise<activationsAdminProjectTemplatesCreateResponse> => {

  return customFetch<activationsAdminProjectTemplatesCreateResponse>(getActivationsAdminProjectTemplatesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminProjectTemplateWriteRequest)
  }
);}




export const getActivationsAdminProjectTemplatesCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesCreate>>, TError,{data: AdminProjectTemplateWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesCreate>>, TError,{data: AdminProjectTemplateWriteRequest}, TContext> => {

const mutationKey = ['activationsAdminProjectTemplatesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesCreate>>, {data: AdminProjectTemplateWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  activationsAdminProjectTemplatesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminProjectTemplatesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesCreate>>>
    export type ActivationsAdminProjectTemplatesCreateMutationBody = AdminProjectTemplateWriteRequest
    export type ActivationsAdminProjectTemplatesCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Utworzenie szkicu szablonu projektu
 */
export const useActivationsAdminProjectTemplatesCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesCreate>>, TError,{data: AdminProjectTemplateWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminProjectTemplatesCreate>>,
        TError,
        {data: AdminProjectTemplateWriteRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminProjectTemplatesCreateMutationOptions(options), queryClient);
    }

export type activationsAdminProjectTemplatesRetrieveResponse200 = {
  data: AdminProjectTemplate
  status: 200
}

export type activationsAdminProjectTemplatesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesRetrieveResponseSuccess = (activationsAdminProjectTemplatesRetrieveResponse200) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesRetrieveResponseError = (activationsAdminProjectTemplatesRetrieveResponse401 | activationsAdminProjectTemplatesRetrieveResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesRetrieveResponse = (activationsAdminProjectTemplatesRetrieveResponseSuccess | activationsAdminProjectTemplatesRetrieveResponseError)

export const getActivationsAdminProjectTemplatesRetrieveUrl = (uid: string,) => {




  return `/api/v1/activations/admin/project-templates/${uid}/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Szczegóły szablonu projektu (operator)
 */
export const activationsAdminProjectTemplatesRetrieve = async (uid: string, options?: RequestInit): Promise<activationsAdminProjectTemplatesRetrieveResponse> => {

  return customFetch<activationsAdminProjectTemplatesRetrieveResponse>(getActivationsAdminProjectTemplatesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminProjectTemplatesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/admin/project-templates/${uid}/`
    ] as const;
    }


export const getActivationsAdminProjectTemplatesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminProjectTemplatesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>> = ({ signal }) => activationsAdminProjectTemplatesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminProjectTemplatesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>>
export type ActivationsAdminProjectTemplatesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminProjectTemplatesRetrieve<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminProjectTemplatesRetrieve<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminProjectTemplatesRetrieve<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Szczegóły szablonu projektu (operator)
 */

export function useActivationsAdminProjectTemplatesRetrieve<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminProjectTemplatesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminProjectTemplatesUpdateResponse200 = {
  data: AdminProjectTemplate
  status: 200
}

export type activationsAdminProjectTemplatesUpdateResponse400 = {
  data: void
  status: 400
}

export type activationsAdminProjectTemplatesUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesUpdateResponseSuccess = (activationsAdminProjectTemplatesUpdateResponse200) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesUpdateResponseError = (activationsAdminProjectTemplatesUpdateResponse400 | activationsAdminProjectTemplatesUpdateResponse401 | activationsAdminProjectTemplatesUpdateResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesUpdateResponse = (activationsAdminProjectTemplatesUpdateResponseSuccess | activationsAdminProjectTemplatesUpdateResponseError)

export const getActivationsAdminProjectTemplatesUpdateUrl = (uid: string,) => {




  return `/api/v1/activations/admin/project-templates/${uid}/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Edycja szablonu projektu (szkic: wszystkie pola; opublikowany: nazwa i opis)
 */
export const activationsAdminProjectTemplatesUpdate = async (uid: string,
    adminProjectTemplateWriteRequest: AdminProjectTemplateWriteRequest, options?: RequestInit): Promise<activationsAdminProjectTemplatesUpdateResponse> => {

  return customFetch<activationsAdminProjectTemplatesUpdateResponse>(getActivationsAdminProjectTemplatesUpdateUrl(uid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminProjectTemplateWriteRequest)
  }
);}




export const getActivationsAdminProjectTemplatesUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesUpdate>>, TError,{uid: string;data: AdminProjectTemplateWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesUpdate>>, TError,{uid: string;data: AdminProjectTemplateWriteRequest}, TContext> => {

const mutationKey = ['activationsAdminProjectTemplatesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesUpdate>>, {uid: string;data: AdminProjectTemplateWriteRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsAdminProjectTemplatesUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminProjectTemplatesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesUpdate>>>
    export type ActivationsAdminProjectTemplatesUpdateMutationBody = AdminProjectTemplateWriteRequest
    export type ActivationsAdminProjectTemplatesUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Edycja szablonu projektu (szkic: wszystkie pola; opublikowany: nazwa i opis)
 */
export const useActivationsAdminProjectTemplatesUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesUpdate>>, TError,{uid: string;data: AdminProjectTemplateWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminProjectTemplatesUpdate>>,
        TError,
        {uid: string;data: AdminProjectTemplateWriteRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminProjectTemplatesUpdateMutationOptions(options), queryClient);
    }

export type activationsAdminProjectTemplatesPartialUpdateResponse200 = {
  data: AdminProjectTemplate
  status: 200
}

export type activationsAdminProjectTemplatesPartialUpdateResponse400 = {
  data: void
  status: 400
}

export type activationsAdminProjectTemplatesPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesPartialUpdateResponseSuccess = (activationsAdminProjectTemplatesPartialUpdateResponse200) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesPartialUpdateResponseError = (activationsAdminProjectTemplatesPartialUpdateResponse400 | activationsAdminProjectTemplatesPartialUpdateResponse401 | activationsAdminProjectTemplatesPartialUpdateResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesPartialUpdateResponse = (activationsAdminProjectTemplatesPartialUpdateResponseSuccess | activationsAdminProjectTemplatesPartialUpdateResponseError)

export const getActivationsAdminProjectTemplatesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/activations/admin/project-templates/${uid}/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Częściowa edycja szablonu projektu
 */
export const activationsAdminProjectTemplatesPartialUpdate = async (uid: string,
    patchedAdminProjectTemplateWriteRequest?: PatchedAdminProjectTemplateWriteRequest, options?: RequestInit): Promise<activationsAdminProjectTemplatesPartialUpdateResponse> => {

  return customFetch<activationsAdminProjectTemplatesPartialUpdateResponse>(getActivationsAdminProjectTemplatesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminProjectTemplateWriteRequest)
  }
);}




export const getActivationsAdminProjectTemplatesPartialUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesPartialUpdate>>, TError,{uid: string;data?: PatchedAdminProjectTemplateWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesPartialUpdate>>, TError,{uid: string;data?: PatchedAdminProjectTemplateWriteRequest}, TContext> => {

const mutationKey = ['activationsAdminProjectTemplatesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesPartialUpdate>>, {uid: string;data?: PatchedAdminProjectTemplateWriteRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsAdminProjectTemplatesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminProjectTemplatesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesPartialUpdate>>>
    export type ActivationsAdminProjectTemplatesPartialUpdateMutationBody = PatchedAdminProjectTemplateWriteRequest | undefined
    export type ActivationsAdminProjectTemplatesPartialUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Częściowa edycja szablonu projektu
 */
export const useActivationsAdminProjectTemplatesPartialUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesPartialUpdate>>, TError,{uid: string;data?: PatchedAdminProjectTemplateWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminProjectTemplatesPartialUpdate>>,
        TError,
        {uid: string;data?: PatchedAdminProjectTemplateWriteRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminProjectTemplatesPartialUpdateMutationOptions(options), queryClient);
    }

export type activationsAdminProjectTemplatesDestroyResponse204 = {
  data: void
  status: 204
}

export type activationsAdminProjectTemplatesDestroyResponse400 = {
  data: void
  status: 400
}

export type activationsAdminProjectTemplatesDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesDestroyResponseSuccess = (activationsAdminProjectTemplatesDestroyResponse204) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesDestroyResponseError = (activationsAdminProjectTemplatesDestroyResponse400 | activationsAdminProjectTemplatesDestroyResponse401 | activationsAdminProjectTemplatesDestroyResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesDestroyResponse = (activationsAdminProjectTemplatesDestroyResponseSuccess | activationsAdminProjectTemplatesDestroyResponseError)

export const getActivationsAdminProjectTemplatesDestroyUrl = (uid: string,) => {




  return `/api/v1/activations/admin/project-templates/${uid}/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Usunięcie szablonu projektu (tylko szkic)
 */
export const activationsAdminProjectTemplatesDestroy = async (uid: string, options?: RequestInit): Promise<activationsAdminProjectTemplatesDestroyResponse> => {

  return customFetch<activationsAdminProjectTemplatesDestroyResponse>(getActivationsAdminProjectTemplatesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getActivationsAdminProjectTemplatesDestroyMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesDestroy>>, TError,{uid: string}, TContext> => {

const mutationKey = ['activationsAdminProjectTemplatesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesDestroy>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  activationsAdminProjectTemplatesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminProjectTemplatesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesDestroy>>>

    export type ActivationsAdminProjectTemplatesDestroyMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Usunięcie szablonu projektu (tylko szkic)
 */
export const useActivationsAdminProjectTemplatesDestroy = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminProjectTemplatesDestroy>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getActivationsAdminProjectTemplatesDestroyMutationOptions(options), queryClient);
    }

export type activationsAdminProjectTemplatesArchiveResponse200 = {
  data: AdminProjectTemplate
  status: 200
}

export type activationsAdminProjectTemplatesArchiveResponse400 = {
  data: void
  status: 400
}

export type activationsAdminProjectTemplatesArchiveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesArchiveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesArchiveResponseSuccess = (activationsAdminProjectTemplatesArchiveResponse200) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesArchiveResponseError = (activationsAdminProjectTemplatesArchiveResponse400 | activationsAdminProjectTemplatesArchiveResponse401 | activationsAdminProjectTemplatesArchiveResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesArchiveResponse = (activationsAdminProjectTemplatesArchiveResponseSuccess | activationsAdminProjectTemplatesArchiveResponseError)

export const getActivationsAdminProjectTemplatesArchiveUrl = (uid: string,) => {




  return `/api/v1/activations/admin/project-templates/${uid}/archive/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Archiwizacja szablonu projektu (tylko opublikowany; nieodwracalna)
 */
export const activationsAdminProjectTemplatesArchive = async (uid: string, options?: RequestInit): Promise<activationsAdminProjectTemplatesArchiveResponse> => {

  return customFetch<activationsAdminProjectTemplatesArchiveResponse>(getActivationsAdminProjectTemplatesArchiveUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivationsAdminProjectTemplatesArchiveMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesArchive>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesArchive>>, TError,{uid: string}, TContext> => {

const mutationKey = ['activationsAdminProjectTemplatesArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesArchive>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  activationsAdminProjectTemplatesArchive(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminProjectTemplatesArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesArchive>>>

    export type ActivationsAdminProjectTemplatesArchiveMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Archiwizacja szablonu projektu (tylko opublikowany; nieodwracalna)
 */
export const useActivationsAdminProjectTemplatesArchive = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesArchive>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminProjectTemplatesArchive>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getActivationsAdminProjectTemplatesArchiveMutationOptions(options), queryClient);
    }

export type activationsAdminProjectTemplatesPublishResponse200 = {
  data: AdminProjectTemplate
  status: 200
}

export type activationsAdminProjectTemplatesPublishResponse400 = {
  data: void
  status: 400
}

export type activationsAdminProjectTemplatesPublishResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesPublishResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesPublishResponseSuccess = (activationsAdminProjectTemplatesPublishResponse200) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesPublishResponseError = (activationsAdminProjectTemplatesPublishResponse400 | activationsAdminProjectTemplatesPublishResponse401 | activationsAdminProjectTemplatesPublishResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesPublishResponse = (activationsAdminProjectTemplatesPublishResponseSuccess | activationsAdminProjectTemplatesPublishResponseError)

export const getActivationsAdminProjectTemplatesPublishUrl = (uid: string,) => {




  return `/api/v1/activations/admin/project-templates/${uid}/publish/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Publikacja szablonu projektu — zaproszenie i centralne powiadomienia uczniów
 */
export const activationsAdminProjectTemplatesPublish = async (uid: string, options?: RequestInit): Promise<activationsAdminProjectTemplatesPublishResponse> => {

  return customFetch<activationsAdminProjectTemplatesPublishResponse>(getActivationsAdminProjectTemplatesPublishUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivationsAdminProjectTemplatesPublishMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesPublish>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesPublish>>, TError,{uid: string}, TContext> => {

const mutationKey = ['activationsAdminProjectTemplatesPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesPublish>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  activationsAdminProjectTemplatesPublish(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminProjectTemplatesPublishMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesPublish>>>

    export type ActivationsAdminProjectTemplatesPublishMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Publikacja szablonu projektu — zaproszenie i centralne powiadomienia uczniów
 */
export const useActivationsAdminProjectTemplatesPublish = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesPublish>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminProjectTemplatesPublish>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getActivationsAdminProjectTemplatesPublishMutationOptions(options), queryClient);
    }

export type activationsAdminProjectTemplatesSubmissionsListResponse200 = {
  data: ActivationAdminSubmissionListResponse
  status: 200
}

export type activationsAdminProjectTemplatesSubmissionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesSubmissionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesSubmissionsListResponseSuccess = (activationsAdminProjectTemplatesSubmissionsListResponse200) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesSubmissionsListResponseError = (activationsAdminProjectTemplatesSubmissionsListResponse401 | activationsAdminProjectTemplatesSubmissionsListResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesSubmissionsListResponse = (activationsAdminProjectTemplatesSubmissionsListResponseSuccess | activationsAdminProjectTemplatesSubmissionsListResponseError)

export const getActivationsAdminProjectTemplatesSubmissionsListUrl = (uid: string,
    params?: ActivationsAdminProjectTemplatesSubmissionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/activations/admin/project-templates/${uid}/submissions/?${stringifiedParams}` : `/api/v1/activations/admin/project-templates/${uid}/submissions/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Lista zgłoszeń projektów do szablonu (pseudonimowa)
 */
export const activationsAdminProjectTemplatesSubmissionsList = async (uid: string,
    params?: ActivationsAdminProjectTemplatesSubmissionsListParams, options?: RequestInit): Promise<activationsAdminProjectTemplatesSubmissionsListResponse> => {

  return customFetch<activationsAdminProjectTemplatesSubmissionsListResponse>(getActivationsAdminProjectTemplatesSubmissionsListUrl(uid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminProjectTemplatesSubmissionsListQueryKey = (uid: string,
    params?: ActivationsAdminProjectTemplatesSubmissionsListParams,) => {
    return [
    `/api/v1/activations/admin/project-templates/${uid}/submissions/`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivationsAdminProjectTemplatesSubmissionsListQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string,
    params?: ActivationsAdminProjectTemplatesSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminProjectTemplatesSubmissionsListQueryKey(uid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>> = ({ signal }) => activationsAdminProjectTemplatesSubmissionsList(uid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminProjectTemplatesSubmissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>>
export type ActivationsAdminProjectTemplatesSubmissionsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminProjectTemplatesSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params: undefined |  ActivationsAdminProjectTemplatesSubmissionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminProjectTemplatesSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params?: ActivationsAdminProjectTemplatesSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminProjectTemplatesSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params?: ActivationsAdminProjectTemplatesSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Lista zgłoszeń projektów do szablonu (pseudonimowa)
 */

export function useActivationsAdminProjectTemplatesSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params?: ActivationsAdminProjectTemplatesSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminProjectTemplatesSubmissionsListQueryOptions(uid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminProjectTemplatesSubmissionsRetrieveResponse200 = {
  data: AdminSubmissionDetail
  status: 200
}

export type activationsAdminProjectTemplatesSubmissionsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesSubmissionsRetrieveResponse404 = {
  data: void
  status: 404
}

export type activationsAdminProjectTemplatesSubmissionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesSubmissionsRetrieveResponseSuccess = (activationsAdminProjectTemplatesSubmissionsRetrieveResponse200) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesSubmissionsRetrieveResponseError = (activationsAdminProjectTemplatesSubmissionsRetrieveResponse401 | activationsAdminProjectTemplatesSubmissionsRetrieveResponse404 | activationsAdminProjectTemplatesSubmissionsRetrieveResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesSubmissionsRetrieveResponse = (activationsAdminProjectTemplatesSubmissionsRetrieveResponseSuccess | activationsAdminProjectTemplatesSubmissionsRetrieveResponseError)

export const getActivationsAdminProjectTemplatesSubmissionsRetrieveUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/admin/project-templates/${uid}/submissions/${submissionUid}/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Szczegóły zgłoszenia projektu (pseudonimowe)
 */
export const activationsAdminProjectTemplatesSubmissionsRetrieve = async (uid: string,
    submissionUid: string, options?: RequestInit): Promise<activationsAdminProjectTemplatesSubmissionsRetrieveResponse> => {

  return customFetch<activationsAdminProjectTemplatesSubmissionsRetrieveResponse>(getActivationsAdminProjectTemplatesSubmissionsRetrieveUrl(uid,submissionUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminProjectTemplatesSubmissionsRetrieveQueryKey = (uid: string,
    submissionUid: string,) => {
    return [
    `/api/v1/activations/admin/project-templates/${uid}/submissions/${submissionUid}/`
    ] as const;
    }


export const getActivationsAdminProjectTemplatesSubmissionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminProjectTemplatesSubmissionsRetrieveQueryKey(uid,submissionUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>> = ({ signal }) => activationsAdminProjectTemplatesSubmissionsRetrieve(uid,submissionUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined && submissionUid !== null && submissionUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminProjectTemplatesSubmissionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>>
export type ActivationsAdminProjectTemplatesSubmissionsRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useActivationsAdminProjectTemplatesSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminProjectTemplatesSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminProjectTemplatesSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Szczegóły zgłoszenia projektu (pseudonimowe)
 */

export function useActivationsAdminProjectTemplatesSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminProjectTemplatesSubmissionsRetrieveQueryOptions(uid,submissionUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminProjectTemplatesSubmissionsReviewResponse200 = {
  data: AdminSubmissionDetail
  status: 200
}

export type activationsAdminProjectTemplatesSubmissionsReviewResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminProjectTemplatesSubmissionsReviewResponse404 = {
  data: void
  status: 404
}

export type activationsAdminProjectTemplatesSubmissionsReviewResponse409 = {
  data: void
  status: 409
}

export type activationsAdminProjectTemplatesSubmissionsReviewResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminProjectTemplatesSubmissionsReviewResponseSuccess = (activationsAdminProjectTemplatesSubmissionsReviewResponse200) & {
  headers: Headers;
};
export type activationsAdminProjectTemplatesSubmissionsReviewResponseError = (activationsAdminProjectTemplatesSubmissionsReviewResponse401 | activationsAdminProjectTemplatesSubmissionsReviewResponse404 | activationsAdminProjectTemplatesSubmissionsReviewResponse409 | activationsAdminProjectTemplatesSubmissionsReviewResponse410) & {
  headers: Headers;
};

export type activationsAdminProjectTemplatesSubmissionsReviewResponse = (activationsAdminProjectTemplatesSubmissionsReviewResponseSuccess | activationsAdminProjectTemplatesSubmissionsReviewResponseError)

export const getActivationsAdminProjectTemplatesSubmissionsReviewUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/admin/project-templates/${uid}/submissions/${submissionUid}/review/`
}

/**
 * Project-template compose/lifecycle/review surface (TR-1401).
 * @deprecated
 * @summary Rozpatrzenie zgłoszenia projektu z feedbackiem (bez punktów)
 */
export const activationsAdminProjectTemplatesSubmissionsReview = async (uid: string,
    submissionUid: string,
    submissionReviewRequest?: SubmissionReviewRequest, options?: RequestInit): Promise<activationsAdminProjectTemplatesSubmissionsReviewResponse> => {

  return customFetch<activationsAdminProjectTemplatesSubmissionsReviewResponse>(getActivationsAdminProjectTemplatesSubmissionsReviewUrl(uid,submissionUid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submissionReviewRequest)
  }
);}




export const getActivationsAdminProjectTemplatesSubmissionsReviewMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsReview>>, TError,{uid: string;submissionUid: string;data?: SubmissionReviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsReview>>, TError,{uid: string;submissionUid: string;data?: SubmissionReviewRequest}, TContext> => {

const mutationKey = ['activationsAdminProjectTemplatesSubmissionsReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsReview>>, {uid: string;submissionUid: string;data?: SubmissionReviewRequest}> = (props) => {
          const {uid,submissionUid,data} = props ?? {};

          return  activationsAdminProjectTemplatesSubmissionsReview(uid,submissionUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminProjectTemplatesSubmissionsReviewMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsReview>>>
    export type ActivationsAdminProjectTemplatesSubmissionsReviewMutationBody = SubmissionReviewRequest | undefined
    export type ActivationsAdminProjectTemplatesSubmissionsReviewMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @deprecated
 * @summary Rozpatrzenie zgłoszenia projektu z feedbackiem (bez punktów)
 */
export const useActivationsAdminProjectTemplatesSubmissionsReview = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsReview>>, TError,{uid: string;submissionUid: string;data?: SubmissionReviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminProjectTemplatesSubmissionsReview>>,
        TError,
        {uid: string;submissionUid: string;data?: SubmissionReviewRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminProjectTemplatesSubmissionsReviewMutationOptions(options), queryClient);
    }

export type activationsAdminStudentProjectsListResponse200 = {
  data: PaginatedAdminStudentProjectList
  status: 200
}

export type activationsAdminStudentProjectsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsListResponseSuccess = (activationsAdminStudentProjectsListResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsListResponseError = (activationsAdminStudentProjectsListResponse401 | activationsAdminStudentProjectsListResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsListResponse = (activationsAdminStudentProjectsListResponseSuccess | activationsAdminStudentProjectsListResponseError)

export const getActivationsAdminStudentProjectsListUrl = (params?: ActivationsAdminStudentProjectsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/activations/admin/student-projects/?${stringifiedParams}` : `/api/v1/activations/admin/student-projects/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Lista projektów uczniowskich (operator)
 */
export const activationsAdminStudentProjectsList = async (params?: ActivationsAdminStudentProjectsListParams, options?: RequestInit): Promise<activationsAdminStudentProjectsListResponse> => {

  return customFetch<activationsAdminStudentProjectsListResponse>(getActivationsAdminStudentProjectsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminStudentProjectsListQueryKey = (params?: ActivationsAdminStudentProjectsListParams,) => {
    return [
    `/api/v1/activations/admin/student-projects/`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivationsAdminStudentProjectsListQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: ActivationsAdminStudentProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminStudentProjectsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>> = ({ signal }) => activationsAdminStudentProjectsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminStudentProjectsListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>>
export type ActivationsAdminStudentProjectsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminStudentProjectsList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  ActivationsAdminStudentProjectsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ActivationsAdminStudentProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ActivationsAdminStudentProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista projektów uczniowskich (operator)
 */

export function useActivationsAdminStudentProjectsList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ActivationsAdminStudentProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminStudentProjectsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminStudentProjectsCreateResponse201 = {
  data: AdminStudentProject
  status: 201
}

export type activationsAdminStudentProjectsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsCreateResponseSuccess = (activationsAdminStudentProjectsCreateResponse201) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsCreateResponseError = (activationsAdminStudentProjectsCreateResponse401 | activationsAdminStudentProjectsCreateResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsCreateResponse = (activationsAdminStudentProjectsCreateResponseSuccess | activationsAdminStudentProjectsCreateResponseError)

export const getActivationsAdminStudentProjectsCreateUrl = () => {




  return `/api/v1/activations/admin/student-projects/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Utworzenie szkicu projektu uczniowskiego
 */
export const activationsAdminStudentProjectsCreate = async (adminStudentProjectWriteRequest?: AdminStudentProjectWriteRequest, options?: RequestInit): Promise<activationsAdminStudentProjectsCreateResponse> => {

  return customFetch<activationsAdminStudentProjectsCreateResponse>(getActivationsAdminStudentProjectsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminStudentProjectWriteRequest)
  }
);}




export const getActivationsAdminStudentProjectsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsCreate>>, TError,{data?: AdminStudentProjectWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsCreate>>, TError,{data?: AdminStudentProjectWriteRequest}, TContext> => {

const mutationKey = ['activationsAdminStudentProjectsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsCreate>>, {data?: AdminStudentProjectWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  activationsAdminStudentProjectsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminStudentProjectsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsCreate>>>
    export type ActivationsAdminStudentProjectsCreateMutationBody = AdminStudentProjectWriteRequest | undefined
    export type ActivationsAdminStudentProjectsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Utworzenie szkicu projektu uczniowskiego
 */
export const useActivationsAdminStudentProjectsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsCreate>>, TError,{data?: AdminStudentProjectWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminStudentProjectsCreate>>,
        TError,
        {data?: AdminStudentProjectWriteRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminStudentProjectsCreateMutationOptions(options), queryClient);
    }

export type activationsAdminStudentProjectsRetrieveResponse200 = {
  data: AdminStudentProject
  status: 200
}

export type activationsAdminStudentProjectsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsRetrieveResponseSuccess = (activationsAdminStudentProjectsRetrieveResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsRetrieveResponseError = (activationsAdminStudentProjectsRetrieveResponse401 | activationsAdminStudentProjectsRetrieveResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsRetrieveResponse = (activationsAdminStudentProjectsRetrieveResponseSuccess | activationsAdminStudentProjectsRetrieveResponseError)

export const getActivationsAdminStudentProjectsRetrieveUrl = (uid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Szczegóły projektu uczniowskiego (operator)
 */
export const activationsAdminStudentProjectsRetrieve = async (uid: string, options?: RequestInit): Promise<activationsAdminStudentProjectsRetrieveResponse> => {

  return customFetch<activationsAdminStudentProjectsRetrieveResponse>(getActivationsAdminStudentProjectsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminStudentProjectsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/admin/student-projects/${uid}/`
    ] as const;
    }


export const getActivationsAdminStudentProjectsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminStudentProjectsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>> = ({ signal }) => activationsAdminStudentProjectsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminStudentProjectsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>>
export type ActivationsAdminStudentProjectsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminStudentProjectsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły projektu uczniowskiego (operator)
 */

export function useActivationsAdminStudentProjectsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminStudentProjectsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminStudentProjectsUpdateResponse200 = {
  data: AdminStudentProject
  status: 200
}

export type activationsAdminStudentProjectsUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsUpdateResponseSuccess = (activationsAdminStudentProjectsUpdateResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsUpdateResponseError = (activationsAdminStudentProjectsUpdateResponse401 | activationsAdminStudentProjectsUpdateResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsUpdateResponse = (activationsAdminStudentProjectsUpdateResponseSuccess | activationsAdminStudentProjectsUpdateResponseError)

export const getActivationsAdminStudentProjectsUpdateUrl = (uid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Edycja projektu uczniowskiego
 */
export const activationsAdminStudentProjectsUpdate = async (uid: string,
    adminStudentProjectWriteRequest?: AdminStudentProjectWriteRequest, options?: RequestInit): Promise<activationsAdminStudentProjectsUpdateResponse> => {

  return customFetch<activationsAdminStudentProjectsUpdateResponse>(getActivationsAdminStudentProjectsUpdateUrl(uid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminStudentProjectWriteRequest)
  }
);}




export const getActivationsAdminStudentProjectsUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsUpdate>>, TError,{uid: string;data?: AdminStudentProjectWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsUpdate>>, TError,{uid: string;data?: AdminStudentProjectWriteRequest}, TContext> => {

const mutationKey = ['activationsAdminStudentProjectsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsUpdate>>, {uid: string;data?: AdminStudentProjectWriteRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsAdminStudentProjectsUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminStudentProjectsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsUpdate>>>
    export type ActivationsAdminStudentProjectsUpdateMutationBody = AdminStudentProjectWriteRequest | undefined
    export type ActivationsAdminStudentProjectsUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Edycja projektu uczniowskiego
 */
export const useActivationsAdminStudentProjectsUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsUpdate>>, TError,{uid: string;data?: AdminStudentProjectWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminStudentProjectsUpdate>>,
        TError,
        {uid: string;data?: AdminStudentProjectWriteRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminStudentProjectsUpdateMutationOptions(options), queryClient);
    }

export type activationsAdminStudentProjectsPartialUpdateResponse200 = {
  data: AdminStudentProject
  status: 200
}

export type activationsAdminStudentProjectsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsPartialUpdateResponseSuccess = (activationsAdminStudentProjectsPartialUpdateResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsPartialUpdateResponseError = (activationsAdminStudentProjectsPartialUpdateResponse401 | activationsAdminStudentProjectsPartialUpdateResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsPartialUpdateResponse = (activationsAdminStudentProjectsPartialUpdateResponseSuccess | activationsAdminStudentProjectsPartialUpdateResponseError)

export const getActivationsAdminStudentProjectsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Częściowa edycja projektu uczniowskiego
 */
export const activationsAdminStudentProjectsPartialUpdate = async (uid: string,
    patchedAdminStudentProjectWriteRequest?: PatchedAdminStudentProjectWriteRequest, options?: RequestInit): Promise<activationsAdminStudentProjectsPartialUpdateResponse> => {

  return customFetch<activationsAdminStudentProjectsPartialUpdateResponse>(getActivationsAdminStudentProjectsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminStudentProjectWriteRequest)
  }
);}




export const getActivationsAdminStudentProjectsPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPartialUpdate>>, TError,{uid: string;data?: PatchedAdminStudentProjectWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPartialUpdate>>, TError,{uid: string;data?: PatchedAdminStudentProjectWriteRequest}, TContext> => {

const mutationKey = ['activationsAdminStudentProjectsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsPartialUpdate>>, {uid: string;data?: PatchedAdminStudentProjectWriteRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsAdminStudentProjectsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminStudentProjectsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsPartialUpdate>>>
    export type ActivationsAdminStudentProjectsPartialUpdateMutationBody = PatchedAdminStudentProjectWriteRequest | undefined
    export type ActivationsAdminStudentProjectsPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Częściowa edycja projektu uczniowskiego
 */
export const useActivationsAdminStudentProjectsPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPartialUpdate>>, TError,{uid: string;data?: PatchedAdminStudentProjectWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminStudentProjectsPartialUpdate>>,
        TError,
        {uid: string;data?: PatchedAdminStudentProjectWriteRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminStudentProjectsPartialUpdateMutationOptions(options), queryClient);
    }

export type activationsAdminStudentProjectsDestroyResponse204 = {
  data: void
  status: 204
}

export type activationsAdminStudentProjectsDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsDestroyResponseSuccess = (activationsAdminStudentProjectsDestroyResponse204) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsDestroyResponseError = (activationsAdminStudentProjectsDestroyResponse401 | activationsAdminStudentProjectsDestroyResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsDestroyResponse = (activationsAdminStudentProjectsDestroyResponseSuccess | activationsAdminStudentProjectsDestroyResponseError)

export const getActivationsAdminStudentProjectsDestroyUrl = (uid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Usunięcie szkicu projektu uczniowskiego
 */
export const activationsAdminStudentProjectsDestroy = async (uid: string, options?: RequestInit): Promise<activationsAdminStudentProjectsDestroyResponse> => {

  return customFetch<activationsAdminStudentProjectsDestroyResponse>(getActivationsAdminStudentProjectsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getActivationsAdminStudentProjectsDestroyMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsDestroy>>, TError,{uid: string}, TContext> => {

const mutationKey = ['activationsAdminStudentProjectsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsDestroy>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  activationsAdminStudentProjectsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminStudentProjectsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsDestroy>>>

    export type ActivationsAdminStudentProjectsDestroyMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Usunięcie szkicu projektu uczniowskiego
 */
export const useActivationsAdminStudentProjectsDestroy = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminStudentProjectsDestroy>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getActivationsAdminStudentProjectsDestroyMutationOptions(options), queryClient);
    }

export type activationsAdminStudentProjectsArchiveResponse200 = {
  data: AdminStudentProject
  status: 200
}

export type activationsAdminStudentProjectsArchiveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsArchiveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsArchiveResponseSuccess = (activationsAdminStudentProjectsArchiveResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsArchiveResponseError = (activationsAdminStudentProjectsArchiveResponse401 | activationsAdminStudentProjectsArchiveResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsArchiveResponse = (activationsAdminStudentProjectsArchiveResponseSuccess | activationsAdminStudentProjectsArchiveResponseError)

export const getActivationsAdminStudentProjectsArchiveUrl = (uid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/archive/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Archiwizacja projektu uczniowskiego
 */
export const activationsAdminStudentProjectsArchive = async (uid: string, options?: RequestInit): Promise<activationsAdminStudentProjectsArchiveResponse> => {

  return customFetch<activationsAdminStudentProjectsArchiveResponse>(getActivationsAdminStudentProjectsArchiveUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivationsAdminStudentProjectsArchiveMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsArchive>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsArchive>>, TError,{uid: string}, TContext> => {

const mutationKey = ['activationsAdminStudentProjectsArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsArchive>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  activationsAdminStudentProjectsArchive(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminStudentProjectsArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsArchive>>>

    export type ActivationsAdminStudentProjectsArchiveMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Archiwizacja projektu uczniowskiego
 */
export const useActivationsAdminStudentProjectsArchive = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsArchive>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminStudentProjectsArchive>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getActivationsAdminStudentProjectsArchiveMutationOptions(options), queryClient);
    }

export type activationsAdminStudentProjectsPreviewResponse200 = {
  data: AdminStudentProjectPreview
  status: 200
}

export type activationsAdminStudentProjectsPreviewResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsPreviewResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsPreviewResponseSuccess = (activationsAdminStudentProjectsPreviewResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsPreviewResponseError = (activationsAdminStudentProjectsPreviewResponse401 | activationsAdminStudentProjectsPreviewResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsPreviewResponse = (activationsAdminStudentProjectsPreviewResponseSuccess | activationsAdminStudentProjectsPreviewResponseError)

export const getActivationsAdminStudentProjectsPreviewUrl = (uid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/preview/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Podgląd gotowości i bieżącego zakresu projektu uczniowskiego
 */
export const activationsAdminStudentProjectsPreview = async (uid: string, options?: RequestInit): Promise<activationsAdminStudentProjectsPreviewResponse> => {

  return customFetch<activationsAdminStudentProjectsPreviewResponse>(getActivationsAdminStudentProjectsPreviewUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminStudentProjectsPreviewQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/admin/student-projects/${uid}/preview/`
    ] as const;
    }


export const getActivationsAdminStudentProjectsPreviewQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminStudentProjectsPreviewQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>> = ({ signal }) => activationsAdminStudentProjectsPreview(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminStudentProjectsPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>>
export type ActivationsAdminStudentProjectsPreviewQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminStudentProjectsPreview<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsPreview<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsPreview<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Podgląd gotowości i bieżącego zakresu projektu uczniowskiego
 */

export function useActivationsAdminStudentProjectsPreview<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminStudentProjectsPreviewQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminStudentProjectsPublishResponse200 = {
  data: AdminStudentProject
  status: 200
}

export type activationsAdminStudentProjectsPublishResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsPublishResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsPublishResponseSuccess = (activationsAdminStudentProjectsPublishResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsPublishResponseError = (activationsAdminStudentProjectsPublishResponse401 | activationsAdminStudentProjectsPublishResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsPublishResponse = (activationsAdminStudentProjectsPublishResponseSuccess | activationsAdminStudentProjectsPublishResponseError)

export const getActivationsAdminStudentProjectsPublishUrl = (uid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/publish/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Publikacja projektu uczniowskiego z opcjonalnym powiadomieniem uczniów
 */
export const activationsAdminStudentProjectsPublish = async (uid: string,
    adminStudentProjectPublishRequest?: AdminStudentProjectPublishRequest, options?: RequestInit): Promise<activationsAdminStudentProjectsPublishResponse> => {

  return customFetch<activationsAdminStudentProjectsPublishResponse>(getActivationsAdminStudentProjectsPublishUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminStudentProjectPublishRequest)
  }
);}




export const getActivationsAdminStudentProjectsPublishMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPublish>>, TError,{uid: string;data?: AdminStudentProjectPublishRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPublish>>, TError,{uid: string;data?: AdminStudentProjectPublishRequest}, TContext> => {

const mutationKey = ['activationsAdminStudentProjectsPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsPublish>>, {uid: string;data?: AdminStudentProjectPublishRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsAdminStudentProjectsPublish(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminStudentProjectsPublishMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsPublish>>>
    export type ActivationsAdminStudentProjectsPublishMutationBody = AdminStudentProjectPublishRequest | undefined
    export type ActivationsAdminStudentProjectsPublishMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Publikacja projektu uczniowskiego z opcjonalnym powiadomieniem uczniów
 */
export const useActivationsAdminStudentProjectsPublish = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsPublish>>, TError,{uid: string;data?: AdminStudentProjectPublishRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminStudentProjectsPublish>>,
        TError,
        {uid: string;data?: AdminStudentProjectPublishRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminStudentProjectsPublishMutationOptions(options), queryClient);
    }

export type activationsAdminStudentProjectsRemindersListResponse200 = {
  data: AdminActivationReminder[]
  status: 200
}

export type activationsAdminStudentProjectsRemindersListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsRemindersListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsRemindersListResponseSuccess = (activationsAdminStudentProjectsRemindersListResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsRemindersListResponseError = (activationsAdminStudentProjectsRemindersListResponse401 | activationsAdminStudentProjectsRemindersListResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsRemindersListResponse = (activationsAdminStudentProjectsRemindersListResponseSuccess | activationsAdminStudentProjectsRemindersListResponseError)

export const getActivationsAdminStudentProjectsRemindersListUrl = (uid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/reminders/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Przypomnienia o projekcie uczniowskim
 */
export const activationsAdminStudentProjectsRemindersList = async (uid: string, options?: RequestInit): Promise<activationsAdminStudentProjectsRemindersListResponse> => {

  return customFetch<activationsAdminStudentProjectsRemindersListResponse>(getActivationsAdminStudentProjectsRemindersListUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminStudentProjectsRemindersListQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/admin/student-projects/${uid}/reminders/`
    ] as const;
    }


export const getActivationsAdminStudentProjectsRemindersListQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminStudentProjectsRemindersListQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>> = ({ signal }) => activationsAdminStudentProjectsRemindersList(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminStudentProjectsRemindersListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>>
export type ActivationsAdminStudentProjectsRemindersListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminStudentProjectsRemindersList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsRemindersList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsRemindersList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Przypomnienia o projekcie uczniowskim
 */

export function useActivationsAdminStudentProjectsRemindersList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminStudentProjectsRemindersListQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminStudentProjectsRemindersCreateResponse201 = {
  data: AdminActivationReminder
  status: 201
}

export type activationsAdminStudentProjectsRemindersCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsRemindersCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsRemindersCreateResponseSuccess = (activationsAdminStudentProjectsRemindersCreateResponse201) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsRemindersCreateResponseError = (activationsAdminStudentProjectsRemindersCreateResponse401 | activationsAdminStudentProjectsRemindersCreateResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsRemindersCreateResponse = (activationsAdminStudentProjectsRemindersCreateResponseSuccess | activationsAdminStudentProjectsRemindersCreateResponseError)

export const getActivationsAdminStudentProjectsRemindersCreateUrl = (uid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/reminders/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Zaplanowanie przypomnienia o opublikowanym projekcie uczniowskim
 */
export const activationsAdminStudentProjectsRemindersCreate = async (uid: string,
    adminActivationReminderCreateRequest: AdminActivationReminderCreateRequest, options?: RequestInit): Promise<activationsAdminStudentProjectsRemindersCreateResponse> => {

  return customFetch<activationsAdminStudentProjectsRemindersCreateResponse>(getActivationsAdminStudentProjectsRemindersCreateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminActivationReminderCreateRequest)
  }
);}




export const getActivationsAdminStudentProjectsRemindersCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersCreate>>, TError,{uid: string;data: AdminActivationReminderCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersCreate>>, TError,{uid: string;data: AdminActivationReminderCreateRequest}, TContext> => {

const mutationKey = ['activationsAdminStudentProjectsRemindersCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersCreate>>, {uid: string;data: AdminActivationReminderCreateRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsAdminStudentProjectsRemindersCreate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminStudentProjectsRemindersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersCreate>>>
    export type ActivationsAdminStudentProjectsRemindersCreateMutationBody = AdminActivationReminderCreateRequest
    export type ActivationsAdminStudentProjectsRemindersCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Zaplanowanie przypomnienia o opublikowanym projekcie uczniowskim
 */
export const useActivationsAdminStudentProjectsRemindersCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersCreate>>, TError,{uid: string;data: AdminActivationReminderCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminStudentProjectsRemindersCreate>>,
        TError,
        {uid: string;data: AdminActivationReminderCreateRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminStudentProjectsRemindersCreateMutationOptions(options), queryClient);
    }

export type activationsAdminStudentProjectsSubmissionsListResponse200 = {
  data: ActivationAdminSubmissionListResponse
  status: 200
}

export type activationsAdminStudentProjectsSubmissionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsSubmissionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsSubmissionsListResponseSuccess = (activationsAdminStudentProjectsSubmissionsListResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsSubmissionsListResponseError = (activationsAdminStudentProjectsSubmissionsListResponse401 | activationsAdminStudentProjectsSubmissionsListResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsSubmissionsListResponse = (activationsAdminStudentProjectsSubmissionsListResponseSuccess | activationsAdminStudentProjectsSubmissionsListResponseError)

export const getActivationsAdminStudentProjectsSubmissionsListUrl = (uid: string,
    params?: ActivationsAdminStudentProjectsSubmissionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/activations/admin/student-projects/${uid}/submissions/?${stringifiedParams}` : `/api/v1/activations/admin/student-projects/${uid}/submissions/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Lista zgłoszeń projektu uczniowskiego
 */
export const activationsAdminStudentProjectsSubmissionsList = async (uid: string,
    params?: ActivationsAdminStudentProjectsSubmissionsListParams, options?: RequestInit): Promise<activationsAdminStudentProjectsSubmissionsListResponse> => {

  return customFetch<activationsAdminStudentProjectsSubmissionsListResponse>(getActivationsAdminStudentProjectsSubmissionsListUrl(uid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminStudentProjectsSubmissionsListQueryKey = (uid: string,
    params?: ActivationsAdminStudentProjectsSubmissionsListParams,) => {
    return [
    `/api/v1/activations/admin/student-projects/${uid}/submissions/`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivationsAdminStudentProjectsSubmissionsListQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string,
    params?: ActivationsAdminStudentProjectsSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminStudentProjectsSubmissionsListQueryKey(uid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>> = ({ signal }) => activationsAdminStudentProjectsSubmissionsList(uid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminStudentProjectsSubmissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>>
export type ActivationsAdminStudentProjectsSubmissionsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminStudentProjectsSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params: undefined |  ActivationsAdminStudentProjectsSubmissionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params?: ActivationsAdminStudentProjectsSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params?: ActivationsAdminStudentProjectsSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista zgłoszeń projektu uczniowskiego
 */

export function useActivationsAdminStudentProjectsSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params?: ActivationsAdminStudentProjectsSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminStudentProjectsSubmissionsListQueryOptions(uid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminStudentProjectsSubmissionsRetrieveResponse200 = {
  data: AdminSubmissionDetail
  status: 200
}

export type activationsAdminStudentProjectsSubmissionsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsSubmissionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsSubmissionsRetrieveResponseSuccess = (activationsAdminStudentProjectsSubmissionsRetrieveResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsSubmissionsRetrieveResponseError = (activationsAdminStudentProjectsSubmissionsRetrieveResponse401 | activationsAdminStudentProjectsSubmissionsRetrieveResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsSubmissionsRetrieveResponse = (activationsAdminStudentProjectsSubmissionsRetrieveResponseSuccess | activationsAdminStudentProjectsSubmissionsRetrieveResponseError)

export const getActivationsAdminStudentProjectsSubmissionsRetrieveUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/submissions/${submissionUid}/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Szczegóły zgłoszenia projektu uczniowskiego
 */
export const activationsAdminStudentProjectsSubmissionsRetrieve = async (uid: string,
    submissionUid: string, options?: RequestInit): Promise<activationsAdminStudentProjectsSubmissionsRetrieveResponse> => {

  return customFetch<activationsAdminStudentProjectsSubmissionsRetrieveResponse>(getActivationsAdminStudentProjectsSubmissionsRetrieveUrl(uid,submissionUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminStudentProjectsSubmissionsRetrieveQueryKey = (uid: string,
    submissionUid: string,) => {
    return [
    `/api/v1/activations/admin/student-projects/${uid}/submissions/${submissionUid}/`
    ] as const;
    }


export const getActivationsAdminStudentProjectsSubmissionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminStudentProjectsSubmissionsRetrieveQueryKey(uid,submissionUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>> = ({ signal }) => activationsAdminStudentProjectsSubmissionsRetrieve(uid,submissionUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined && submissionUid !== null && submissionUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminStudentProjectsSubmissionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>>
export type ActivationsAdminStudentProjectsSubmissionsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminStudentProjectsSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły zgłoszenia projektu uczniowskiego
 */

export function useActivationsAdminStudentProjectsSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminStudentProjectsSubmissionsRetrieveQueryOptions(uid,submissionUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminStudentProjectsSubmissionsReviewResponse200 = {
  data: AdminSubmissionDetail
  status: 200
}

export type activationsAdminStudentProjectsSubmissionsReviewResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsSubmissionsReviewResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsSubmissionsReviewResponseSuccess = (activationsAdminStudentProjectsSubmissionsReviewResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsSubmissionsReviewResponseError = (activationsAdminStudentProjectsSubmissionsReviewResponse401 | activationsAdminStudentProjectsSubmissionsReviewResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsSubmissionsReviewResponse = (activationsAdminStudentProjectsSubmissionsReviewResponseSuccess | activationsAdminStudentProjectsSubmissionsReviewResponseError)

export const getActivationsAdminStudentProjectsSubmissionsReviewUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/admin/student-projects/${uid}/submissions/${submissionUid}/review/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Rozpatrzenie zgłoszenia projektu uczniowskiego
 */
export const activationsAdminStudentProjectsSubmissionsReview = async (uid: string,
    submissionUid: string,
    submissionReviewRequest?: SubmissionReviewRequest, options?: RequestInit): Promise<activationsAdminStudentProjectsSubmissionsReviewResponse> => {

  return customFetch<activationsAdminStudentProjectsSubmissionsReviewResponse>(getActivationsAdminStudentProjectsSubmissionsReviewUrl(uid,submissionUid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submissionReviewRequest)
  }
);}




export const getActivationsAdminStudentProjectsSubmissionsReviewMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsReview>>, TError,{uid: string;submissionUid: string;data?: SubmissionReviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsReview>>, TError,{uid: string;submissionUid: string;data?: SubmissionReviewRequest}, TContext> => {

const mutationKey = ['activationsAdminStudentProjectsSubmissionsReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsReview>>, {uid: string;submissionUid: string;data?: SubmissionReviewRequest}> = (props) => {
          const {uid,submissionUid,data} = props ?? {};

          return  activationsAdminStudentProjectsSubmissionsReview(uid,submissionUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminStudentProjectsSubmissionsReviewMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsReview>>>
    export type ActivationsAdminStudentProjectsSubmissionsReviewMutationBody = SubmissionReviewRequest | undefined
    export type ActivationsAdminStudentProjectsSubmissionsReviewMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Rozpatrzenie zgłoszenia projektu uczniowskiego
 */
export const useActivationsAdminStudentProjectsSubmissionsReview = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsReview>>, TError,{uid: string;submissionUid: string;data?: SubmissionReviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminStudentProjectsSubmissionsReview>>,
        TError,
        {uid: string;submissionUid: string;data?: SubmissionReviewRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminStudentProjectsSubmissionsReviewMutationOptions(options), queryClient);
    }

export type activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponse200 = {
  data: AttachmentEmailProfile
  status: 200
}

export type activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponseSuccess = (activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponseError = (activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponse401 | activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponse = (activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponseSuccess | activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponseError)

export const getActivationsAdminStudentProjectsAttachmentEmailProfileRetrieveUrl = () => {




  return `/api/v1/activations/admin/student-projects/attachment-email-profile/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Profil organizacji odbioru załączników e-mail
 */
export const activationsAdminStudentProjectsAttachmentEmailProfileRetrieve = async ( options?: RequestInit): Promise<activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponse> => {

  return customFetch<activationsAdminStudentProjectsAttachmentEmailProfileRetrieveResponse>(getActivationsAdminStudentProjectsAttachmentEmailProfileRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminStudentProjectsAttachmentEmailProfileRetrieveQueryKey = () => {
    return [
    `/api/v1/activations/admin/student-projects/attachment-email-profile/`
    ] as const;
    }


export const getActivationsAdminStudentProjectsAttachmentEmailProfileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminStudentProjectsAttachmentEmailProfileRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>> = ({ signal }) => activationsAdminStudentProjectsAttachmentEmailProfileRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminStudentProjectsAttachmentEmailProfileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>>
export type ActivationsAdminStudentProjectsAttachmentEmailProfileRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminStudentProjectsAttachmentEmailProfileRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsAttachmentEmailProfileRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminStudentProjectsAttachmentEmailProfileRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Profil organizacji odbioru załączników e-mail
 */

export function useActivationsAdminStudentProjectsAttachmentEmailProfileRetrieve<TData = Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminStudentProjectsAttachmentEmailProfileRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponse200 = {
  data: AttachmentEmailProfile
  status: 200
}

export type activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponseSuccess = (activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponse200) & {
  headers: Headers;
};
export type activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponseError = (activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponse401 | activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponse410) & {
  headers: Headers;
};

export type activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponse = (activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponseSuccess | activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponseError)

export const getActivationsAdminStudentProjectsAttachmentEmailProfileUpdateUrl = () => {




  return `/api/v1/activations/admin/student-projects/attachment-email-profile/`
}

/**
 * Shared compose/lifecycle/review shape of both container types (the
 * `AdminPushQuizViewSet` idiom). Concrete classes pin the model, the
 * serializers, the audit identity and the per-entity Polish copy.
 * @summary Zastąpienie profilu organizacji odbioru załączników e-mail
 */
export const activationsAdminStudentProjectsAttachmentEmailProfileUpdate = async (attachmentEmailProfileWriteRequest?: AttachmentEmailProfileWriteRequest, options?: RequestInit): Promise<activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponse> => {

  return customFetch<activationsAdminStudentProjectsAttachmentEmailProfileUpdateResponse>(getActivationsAdminStudentProjectsAttachmentEmailProfileUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(attachmentEmailProfileWriteRequest)
  }
);}




export const getActivationsAdminStudentProjectsAttachmentEmailProfileUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileUpdate>>, TError,{data?: AttachmentEmailProfileWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileUpdate>>, TError,{data?: AttachmentEmailProfileWriteRequest}, TContext> => {

const mutationKey = ['activationsAdminStudentProjectsAttachmentEmailProfileUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileUpdate>>, {data?: AttachmentEmailProfileWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  activationsAdminStudentProjectsAttachmentEmailProfileUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminStudentProjectsAttachmentEmailProfileUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileUpdate>>>
    export type ActivationsAdminStudentProjectsAttachmentEmailProfileUpdateMutationBody = AttachmentEmailProfileWriteRequest | undefined
    export type ActivationsAdminStudentProjectsAttachmentEmailProfileUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Zastąpienie profilu organizacji odbioru załączników e-mail
 */
export const useActivationsAdminStudentProjectsAttachmentEmailProfileUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileUpdate>>, TError,{data?: AttachmentEmailProfileWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminStudentProjectsAttachmentEmailProfileUpdate>>,
        TError,
        {data?: AttachmentEmailProfileWriteRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminStudentProjectsAttachmentEmailProfileUpdateMutationOptions(options), queryClient);
    }

export type activationsAdminThematicTasksListResponse200 = {
  data: PaginatedAdminThematicTaskList
  status: 200
}

export type activationsAdminThematicTasksListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksListResponseSuccess = (activationsAdminThematicTasksListResponse200) & {
  headers: Headers;
};
export type activationsAdminThematicTasksListResponseError = (activationsAdminThematicTasksListResponse401 | activationsAdminThematicTasksListResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksListResponse = (activationsAdminThematicTasksListResponseSuccess | activationsAdminThematicTasksListResponseError)

export const getActivationsAdminThematicTasksListUrl = (params?: ActivationsAdminThematicTasksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/activations/admin/thematic-tasks/?${stringifiedParams}` : `/api/v1/activations/admin/thematic-tasks/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Lista zadań tematycznych (operator)
 */
export const activationsAdminThematicTasksList = async (params?: ActivationsAdminThematicTasksListParams, options?: RequestInit): Promise<activationsAdminThematicTasksListResponse> => {

  return customFetch<activationsAdminThematicTasksListResponse>(getActivationsAdminThematicTasksListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminThematicTasksListQueryKey = (params?: ActivationsAdminThematicTasksListParams,) => {
    return [
    `/api/v1/activations/admin/thematic-tasks/`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivationsAdminThematicTasksListQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: ActivationsAdminThematicTasksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminThematicTasksListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksList>>> = ({ signal }) => activationsAdminThematicTasksList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminThematicTasksListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksList>>>
export type ActivationsAdminThematicTasksListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminThematicTasksList<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  ActivationsAdminThematicTasksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminThematicTasksList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminThematicTasksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminThematicTasksList<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ActivationsAdminThematicTasksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminThematicTasksList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminThematicTasksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminThematicTasksList<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ActivationsAdminThematicTasksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Lista zadań tematycznych (operator)
 */

export function useActivationsAdminThematicTasksList<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ActivationsAdminThematicTasksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminThematicTasksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminThematicTasksCreateResponse201 = {
  data: AdminThematicTask
  status: 201
}

export type activationsAdminThematicTasksCreateResponse400 = {
  data: void
  status: 400
}

export type activationsAdminThematicTasksCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksCreateResponseSuccess = (activationsAdminThematicTasksCreateResponse201) & {
  headers: Headers;
};
export type activationsAdminThematicTasksCreateResponseError = (activationsAdminThematicTasksCreateResponse400 | activationsAdminThematicTasksCreateResponse401 | activationsAdminThematicTasksCreateResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksCreateResponse = (activationsAdminThematicTasksCreateResponseSuccess | activationsAdminThematicTasksCreateResponseError)

export const getActivationsAdminThematicTasksCreateUrl = () => {




  return `/api/v1/activations/admin/thematic-tasks/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Utworzenie szkicu zadania tematycznego
 */
export const activationsAdminThematicTasksCreate = async (adminThematicTaskWriteRequest: AdminThematicTaskWriteRequest, options?: RequestInit): Promise<activationsAdminThematicTasksCreateResponse> => {

  return customFetch<activationsAdminThematicTasksCreateResponse>(getActivationsAdminThematicTasksCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminThematicTaskWriteRequest)
  }
);}




export const getActivationsAdminThematicTasksCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksCreate>>, TError,{data: AdminThematicTaskWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksCreate>>, TError,{data: AdminThematicTaskWriteRequest}, TContext> => {

const mutationKey = ['activationsAdminThematicTasksCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksCreate>>, {data: AdminThematicTaskWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  activationsAdminThematicTasksCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminThematicTasksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksCreate>>>
    export type ActivationsAdminThematicTasksCreateMutationBody = AdminThematicTaskWriteRequest
    export type ActivationsAdminThematicTasksCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Utworzenie szkicu zadania tematycznego
 */
export const useActivationsAdminThematicTasksCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksCreate>>, TError,{data: AdminThematicTaskWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminThematicTasksCreate>>,
        TError,
        {data: AdminThematicTaskWriteRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminThematicTasksCreateMutationOptions(options), queryClient);
    }

export type activationsAdminThematicTasksRetrieveResponse200 = {
  data: AdminThematicTask
  status: 200
}

export type activationsAdminThematicTasksRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksRetrieveResponseSuccess = (activationsAdminThematicTasksRetrieveResponse200) & {
  headers: Headers;
};
export type activationsAdminThematicTasksRetrieveResponseError = (activationsAdminThematicTasksRetrieveResponse401 | activationsAdminThematicTasksRetrieveResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksRetrieveResponse = (activationsAdminThematicTasksRetrieveResponseSuccess | activationsAdminThematicTasksRetrieveResponseError)

export const getActivationsAdminThematicTasksRetrieveUrl = (uid: string,) => {




  return `/api/v1/activations/admin/thematic-tasks/${uid}/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Szczegóły zadania tematycznego (operator)
 */
export const activationsAdminThematicTasksRetrieve = async (uid: string, options?: RequestInit): Promise<activationsAdminThematicTasksRetrieveResponse> => {

  return customFetch<activationsAdminThematicTasksRetrieveResponse>(getActivationsAdminThematicTasksRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminThematicTasksRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/admin/thematic-tasks/${uid}/`
    ] as const;
    }


export const getActivationsAdminThematicTasksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminThematicTasksRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>> = ({ signal }) => activationsAdminThematicTasksRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminThematicTasksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>>
export type ActivationsAdminThematicTasksRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminThematicTasksRetrieve<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminThematicTasksRetrieve<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminThematicTasksRetrieve<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Szczegóły zadania tematycznego (operator)
 */

export function useActivationsAdminThematicTasksRetrieve<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminThematicTasksRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminThematicTasksUpdateResponse200 = {
  data: AdminThematicTask
  status: 200
}

export type activationsAdminThematicTasksUpdateResponse400 = {
  data: void
  status: 400
}

export type activationsAdminThematicTasksUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksUpdateResponseSuccess = (activationsAdminThematicTasksUpdateResponse200) & {
  headers: Headers;
};
export type activationsAdminThematicTasksUpdateResponseError = (activationsAdminThematicTasksUpdateResponse400 | activationsAdminThematicTasksUpdateResponse401 | activationsAdminThematicTasksUpdateResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksUpdateResponse = (activationsAdminThematicTasksUpdateResponseSuccess | activationsAdminThematicTasksUpdateResponseError)

export const getActivationsAdminThematicTasksUpdateUrl = (uid: string,) => {




  return `/api/v1/activations/admin/thematic-tasks/${uid}/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Edycja zadania tematycznego (szkic: wszystkie pola; opublikowane: nazwa i opis)
 */
export const activationsAdminThematicTasksUpdate = async (uid: string,
    adminThematicTaskWriteRequest: AdminThematicTaskWriteRequest, options?: RequestInit): Promise<activationsAdminThematicTasksUpdateResponse> => {

  return customFetch<activationsAdminThematicTasksUpdateResponse>(getActivationsAdminThematicTasksUpdateUrl(uid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminThematicTaskWriteRequest)
  }
);}




export const getActivationsAdminThematicTasksUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksUpdate>>, TError,{uid: string;data: AdminThematicTaskWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksUpdate>>, TError,{uid: string;data: AdminThematicTaskWriteRequest}, TContext> => {

const mutationKey = ['activationsAdminThematicTasksUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksUpdate>>, {uid: string;data: AdminThematicTaskWriteRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsAdminThematicTasksUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminThematicTasksUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksUpdate>>>
    export type ActivationsAdminThematicTasksUpdateMutationBody = AdminThematicTaskWriteRequest
    export type ActivationsAdminThematicTasksUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Edycja zadania tematycznego (szkic: wszystkie pola; opublikowane: nazwa i opis)
 */
export const useActivationsAdminThematicTasksUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksUpdate>>, TError,{uid: string;data: AdminThematicTaskWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminThematicTasksUpdate>>,
        TError,
        {uid: string;data: AdminThematicTaskWriteRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminThematicTasksUpdateMutationOptions(options), queryClient);
    }

export type activationsAdminThematicTasksPartialUpdateResponse200 = {
  data: AdminThematicTask
  status: 200
}

export type activationsAdminThematicTasksPartialUpdateResponse400 = {
  data: void
  status: 400
}

export type activationsAdminThematicTasksPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksPartialUpdateResponseSuccess = (activationsAdminThematicTasksPartialUpdateResponse200) & {
  headers: Headers;
};
export type activationsAdminThematicTasksPartialUpdateResponseError = (activationsAdminThematicTasksPartialUpdateResponse400 | activationsAdminThematicTasksPartialUpdateResponse401 | activationsAdminThematicTasksPartialUpdateResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksPartialUpdateResponse = (activationsAdminThematicTasksPartialUpdateResponseSuccess | activationsAdminThematicTasksPartialUpdateResponseError)

export const getActivationsAdminThematicTasksPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/activations/admin/thematic-tasks/${uid}/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Częściowa edycja zadania tematycznego
 */
export const activationsAdminThematicTasksPartialUpdate = async (uid: string,
    patchedAdminThematicTaskWriteRequest?: PatchedAdminThematicTaskWriteRequest, options?: RequestInit): Promise<activationsAdminThematicTasksPartialUpdateResponse> => {

  return customFetch<activationsAdminThematicTasksPartialUpdateResponse>(getActivationsAdminThematicTasksPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminThematicTaskWriteRequest)
  }
);}




export const getActivationsAdminThematicTasksPartialUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksPartialUpdate>>, TError,{uid: string;data?: PatchedAdminThematicTaskWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksPartialUpdate>>, TError,{uid: string;data?: PatchedAdminThematicTaskWriteRequest}, TContext> => {

const mutationKey = ['activationsAdminThematicTasksPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksPartialUpdate>>, {uid: string;data?: PatchedAdminThematicTaskWriteRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsAdminThematicTasksPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminThematicTasksPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksPartialUpdate>>>
    export type ActivationsAdminThematicTasksPartialUpdateMutationBody = PatchedAdminThematicTaskWriteRequest | undefined
    export type ActivationsAdminThematicTasksPartialUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Częściowa edycja zadania tematycznego
 */
export const useActivationsAdminThematicTasksPartialUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksPartialUpdate>>, TError,{uid: string;data?: PatchedAdminThematicTaskWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminThematicTasksPartialUpdate>>,
        TError,
        {uid: string;data?: PatchedAdminThematicTaskWriteRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminThematicTasksPartialUpdateMutationOptions(options), queryClient);
    }

export type activationsAdminThematicTasksDestroyResponse204 = {
  data: void
  status: 204
}

export type activationsAdminThematicTasksDestroyResponse400 = {
  data: void
  status: 400
}

export type activationsAdminThematicTasksDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksDestroyResponseSuccess = (activationsAdminThematicTasksDestroyResponse204) & {
  headers: Headers;
};
export type activationsAdminThematicTasksDestroyResponseError = (activationsAdminThematicTasksDestroyResponse400 | activationsAdminThematicTasksDestroyResponse401 | activationsAdminThematicTasksDestroyResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksDestroyResponse = (activationsAdminThematicTasksDestroyResponseSuccess | activationsAdminThematicTasksDestroyResponseError)

export const getActivationsAdminThematicTasksDestroyUrl = (uid: string,) => {




  return `/api/v1/activations/admin/thematic-tasks/${uid}/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Usunięcie zadania tematycznego (tylko szkic)
 */
export const activationsAdminThematicTasksDestroy = async (uid: string, options?: RequestInit): Promise<activationsAdminThematicTasksDestroyResponse> => {

  return customFetch<activationsAdminThematicTasksDestroyResponse>(getActivationsAdminThematicTasksDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getActivationsAdminThematicTasksDestroyMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksDestroy>>, TError,{uid: string}, TContext> => {

const mutationKey = ['activationsAdminThematicTasksDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksDestroy>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  activationsAdminThematicTasksDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminThematicTasksDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksDestroy>>>

    export type ActivationsAdminThematicTasksDestroyMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Usunięcie zadania tematycznego (tylko szkic)
 */
export const useActivationsAdminThematicTasksDestroy = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminThematicTasksDestroy>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getActivationsAdminThematicTasksDestroyMutationOptions(options), queryClient);
    }

export type activationsAdminThematicTasksArchiveResponse200 = {
  data: AdminThematicTask
  status: 200
}

export type activationsAdminThematicTasksArchiveResponse400 = {
  data: void
  status: 400
}

export type activationsAdminThematicTasksArchiveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksArchiveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksArchiveResponseSuccess = (activationsAdminThematicTasksArchiveResponse200) & {
  headers: Headers;
};
export type activationsAdminThematicTasksArchiveResponseError = (activationsAdminThematicTasksArchiveResponse400 | activationsAdminThematicTasksArchiveResponse401 | activationsAdminThematicTasksArchiveResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksArchiveResponse = (activationsAdminThematicTasksArchiveResponseSuccess | activationsAdminThematicTasksArchiveResponseError)

export const getActivationsAdminThematicTasksArchiveUrl = (uid: string,) => {




  return `/api/v1/activations/admin/thematic-tasks/${uid}/archive/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Archiwizacja zadania tematycznego (tylko opublikowane; nieodwracalna)
 */
export const activationsAdminThematicTasksArchive = async (uid: string, options?: RequestInit): Promise<activationsAdminThematicTasksArchiveResponse> => {

  return customFetch<activationsAdminThematicTasksArchiveResponse>(getActivationsAdminThematicTasksArchiveUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivationsAdminThematicTasksArchiveMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksArchive>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksArchive>>, TError,{uid: string}, TContext> => {

const mutationKey = ['activationsAdminThematicTasksArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksArchive>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  activationsAdminThematicTasksArchive(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminThematicTasksArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksArchive>>>

    export type ActivationsAdminThematicTasksArchiveMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Archiwizacja zadania tematycznego (tylko opublikowane; nieodwracalna)
 */
export const useActivationsAdminThematicTasksArchive = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksArchive>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminThematicTasksArchive>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getActivationsAdminThematicTasksArchiveMutationOptions(options), queryClient);
    }

export type activationsAdminThematicTasksPublishResponse200 = {
  data: AdminThematicTask
  status: 200
}

export type activationsAdminThematicTasksPublishResponse400 = {
  data: void
  status: 400
}

export type activationsAdminThematicTasksPublishResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksPublishResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksPublishResponseSuccess = (activationsAdminThematicTasksPublishResponse200) & {
  headers: Headers;
};
export type activationsAdminThematicTasksPublishResponseError = (activationsAdminThematicTasksPublishResponse400 | activationsAdminThematicTasksPublishResponse401 | activationsAdminThematicTasksPublishResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksPublishResponse = (activationsAdminThematicTasksPublishResponseSuccess | activationsAdminThematicTasksPublishResponseError)

export const getActivationsAdminThematicTasksPublishUrl = (uid: string,) => {




  return `/api/v1/activations/admin/thematic-tasks/${uid}/publish/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Publikacja zadania tematycznego — uruchamia powiadomienia push
 */
export const activationsAdminThematicTasksPublish = async (uid: string, options?: RequestInit): Promise<activationsAdminThematicTasksPublishResponse> => {

  return customFetch<activationsAdminThematicTasksPublishResponse>(getActivationsAdminThematicTasksPublishUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivationsAdminThematicTasksPublishMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksPublish>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksPublish>>, TError,{uid: string}, TContext> => {

const mutationKey = ['activationsAdminThematicTasksPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksPublish>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  activationsAdminThematicTasksPublish(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminThematicTasksPublishMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksPublish>>>

    export type ActivationsAdminThematicTasksPublishMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @deprecated
 * @summary Publikacja zadania tematycznego — uruchamia powiadomienia push
 */
export const useActivationsAdminThematicTasksPublish = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksPublish>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminThematicTasksPublish>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getActivationsAdminThematicTasksPublishMutationOptions(options), queryClient);
    }

export type activationsAdminThematicTasksSubmissionsListResponse200 = {
  data: ActivationAdminSubmissionListResponse
  status: 200
}

export type activationsAdminThematicTasksSubmissionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksSubmissionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksSubmissionsListResponseSuccess = (activationsAdminThematicTasksSubmissionsListResponse200) & {
  headers: Headers;
};
export type activationsAdminThematicTasksSubmissionsListResponseError = (activationsAdminThematicTasksSubmissionsListResponse401 | activationsAdminThematicTasksSubmissionsListResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksSubmissionsListResponse = (activationsAdminThematicTasksSubmissionsListResponseSuccess | activationsAdminThematicTasksSubmissionsListResponseError)

export const getActivationsAdminThematicTasksSubmissionsListUrl = (uid: string,
    params?: ActivationsAdminThematicTasksSubmissionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/activations/admin/thematic-tasks/${uid}/submissions/?${stringifiedParams}` : `/api/v1/activations/admin/thematic-tasks/${uid}/submissions/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Lista zgłoszeń realizacji zadania (pseudonimowa)
 */
export const activationsAdminThematicTasksSubmissionsList = async (uid: string,
    params?: ActivationsAdminThematicTasksSubmissionsListParams, options?: RequestInit): Promise<activationsAdminThematicTasksSubmissionsListResponse> => {

  return customFetch<activationsAdminThematicTasksSubmissionsListResponse>(getActivationsAdminThematicTasksSubmissionsListUrl(uid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminThematicTasksSubmissionsListQueryKey = (uid: string,
    params?: ActivationsAdminThematicTasksSubmissionsListParams,) => {
    return [
    `/api/v1/activations/admin/thematic-tasks/${uid}/submissions/`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivationsAdminThematicTasksSubmissionsListQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string,
    params?: ActivationsAdminThematicTasksSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminThematicTasksSubmissionsListQueryKey(uid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>> = ({ signal }) => activationsAdminThematicTasksSubmissionsList(uid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminThematicTasksSubmissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>>
export type ActivationsAdminThematicTasksSubmissionsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsAdminThematicTasksSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params: undefined |  ActivationsAdminThematicTasksSubmissionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminThematicTasksSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params?: ActivationsAdminThematicTasksSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminThematicTasksSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params?: ActivationsAdminThematicTasksSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Lista zgłoszeń realizacji zadania (pseudonimowa)
 */

export function useActivationsAdminThematicTasksSubmissionsList<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    params?: ActivationsAdminThematicTasksSubmissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminThematicTasksSubmissionsListQueryOptions(uid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminThematicTasksSubmissionsRetrieveResponse200 = {
  data: AdminSubmissionDetail
  status: 200
}

export type activationsAdminThematicTasksSubmissionsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksSubmissionsRetrieveResponse404 = {
  data: void
  status: 404
}

export type activationsAdminThematicTasksSubmissionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksSubmissionsRetrieveResponseSuccess = (activationsAdminThematicTasksSubmissionsRetrieveResponse200) & {
  headers: Headers;
};
export type activationsAdminThematicTasksSubmissionsRetrieveResponseError = (activationsAdminThematicTasksSubmissionsRetrieveResponse401 | activationsAdminThematicTasksSubmissionsRetrieveResponse404 | activationsAdminThematicTasksSubmissionsRetrieveResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksSubmissionsRetrieveResponse = (activationsAdminThematicTasksSubmissionsRetrieveResponseSuccess | activationsAdminThematicTasksSubmissionsRetrieveResponseError)

export const getActivationsAdminThematicTasksSubmissionsRetrieveUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/admin/thematic-tasks/${uid}/submissions/${submissionUid}/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Szczegóły zgłoszenia realizacji (pseudonimowe)
 */
export const activationsAdminThematicTasksSubmissionsRetrieve = async (uid: string,
    submissionUid: string, options?: RequestInit): Promise<activationsAdminThematicTasksSubmissionsRetrieveResponse> => {

  return customFetch<activationsAdminThematicTasksSubmissionsRetrieveResponse>(getActivationsAdminThematicTasksSubmissionsRetrieveUrl(uid,submissionUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsAdminThematicTasksSubmissionsRetrieveQueryKey = (uid: string,
    submissionUid: string,) => {
    return [
    `/api/v1/activations/admin/thematic-tasks/${uid}/submissions/${submissionUid}/`
    ] as const;
    }


export const getActivationsAdminThematicTasksSubmissionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsAdminThematicTasksSubmissionsRetrieveQueryKey(uid,submissionUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>> = ({ signal }) => activationsAdminThematicTasksSubmissionsRetrieve(uid,submissionUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined && submissionUid !== null && submissionUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsAdminThematicTasksSubmissionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>>
export type ActivationsAdminThematicTasksSubmissionsRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useActivationsAdminThematicTasksSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminThematicTasksSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsAdminThematicTasksSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Szczegóły zgłoszenia realizacji (pseudonimowe)
 */

export function useActivationsAdminThematicTasksSubmissionsRetrieve<TData = Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsAdminThematicTasksSubmissionsRetrieveQueryOptions(uid,submissionUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsAdminThematicTasksSubmissionsReviewResponse200 = {
  data: AdminSubmissionDetail
  status: 200
}

export type activationsAdminThematicTasksSubmissionsReviewResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsAdminThematicTasksSubmissionsReviewResponse404 = {
  data: void
  status: 404
}

export type activationsAdminThematicTasksSubmissionsReviewResponse409 = {
  data: void
  status: 409
}

export type activationsAdminThematicTasksSubmissionsReviewResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsAdminThematicTasksSubmissionsReviewResponseSuccess = (activationsAdminThematicTasksSubmissionsReviewResponse200) & {
  headers: Headers;
};
export type activationsAdminThematicTasksSubmissionsReviewResponseError = (activationsAdminThematicTasksSubmissionsReviewResponse401 | activationsAdminThematicTasksSubmissionsReviewResponse404 | activationsAdminThematicTasksSubmissionsReviewResponse409 | activationsAdminThematicTasksSubmissionsReviewResponse410) & {
  headers: Headers;
};

export type activationsAdminThematicTasksSubmissionsReviewResponse = (activationsAdminThematicTasksSubmissionsReviewResponseSuccess | activationsAdminThematicTasksSubmissionsReviewResponseError)

export const getActivationsAdminThematicTasksSubmissionsReviewUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/admin/thematic-tasks/${uid}/submissions/${submissionUid}/review/`
}

/**
 * Thematic-task compose/lifecycle/review surface (TR-1402).
 * @deprecated
 * @summary Rozpatrzenie zgłoszenia realizacji z feedbackiem (bez punktów)
 */
export const activationsAdminThematicTasksSubmissionsReview = async (uid: string,
    submissionUid: string,
    submissionReviewRequest?: SubmissionReviewRequest, options?: RequestInit): Promise<activationsAdminThematicTasksSubmissionsReviewResponse> => {

  return customFetch<activationsAdminThematicTasksSubmissionsReviewResponse>(getActivationsAdminThematicTasksSubmissionsReviewUrl(uid,submissionUid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submissionReviewRequest)
  }
);}




export const getActivationsAdminThematicTasksSubmissionsReviewMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsReview>>, TError,{uid: string;submissionUid: string;data?: SubmissionReviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsReview>>, TError,{uid: string;submissionUid: string;data?: SubmissionReviewRequest}, TContext> => {

const mutationKey = ['activationsAdminThematicTasksSubmissionsReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsReview>>, {uid: string;submissionUid: string;data?: SubmissionReviewRequest}> = (props) => {
          const {uid,submissionUid,data} = props ?? {};

          return  activationsAdminThematicTasksSubmissionsReview(uid,submissionUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsAdminThematicTasksSubmissionsReviewMutationResult = NonNullable<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsReview>>>
    export type ActivationsAdminThematicTasksSubmissionsReviewMutationBody = SubmissionReviewRequest | undefined
    export type ActivationsAdminThematicTasksSubmissionsReviewMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @deprecated
 * @summary Rozpatrzenie zgłoszenia realizacji z feedbackiem (bez punktów)
 */
export const useActivationsAdminThematicTasksSubmissionsReview = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsReview>>, TError,{uid: string;submissionUid: string;data?: SubmissionReviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsAdminThematicTasksSubmissionsReview>>,
        TError,
        {uid: string;submissionUid: string;data?: SubmissionReviewRequest},
        TContext
      > => {
      return useMutation(getActivationsAdminThematicTasksSubmissionsReviewMutationOptions(options), queryClient);
    }

export type activationsProjectTemplatesListResponse200 = {
  data: ProjectTemplateList
  status: 200
}

export type activationsProjectTemplatesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsProjectTemplatesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsProjectTemplatesListResponseSuccess = (activationsProjectTemplatesListResponse200) & {
  headers: Headers;
};
export type activationsProjectTemplatesListResponseError = (activationsProjectTemplatesListResponse401 | activationsProjectTemplatesListResponse410) & {
  headers: Headers;
};

export type activationsProjectTemplatesListResponse = (activationsProjectTemplatesListResponseSuccess | activationsProjectTemplatesListResponseError)

export const getActivationsProjectTemplatesListUrl = () => {




  return `/api/v1/activations/project-templates/`
}

/**
 * `GET /api/v1/activations/project-templates/` — published invitations
 * covering the caller AT READ TIME, newest first, each with the caller's
 * OWN submission count. An archived template appears ONLY while the caller
 * has a submission on it (the read-only history handle).
 * @deprecated
 * @summary Lista szablonów projektów dostępnych dla ucznia
 */
export const activationsProjectTemplatesList = async ( options?: RequestInit): Promise<activationsProjectTemplatesListResponse> => {

  return customFetch<activationsProjectTemplatesListResponse>(getActivationsProjectTemplatesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsProjectTemplatesListQueryKey = () => {
    return [
    `/api/v1/activations/project-templates/`
    ] as const;
    }


export const getActivationsProjectTemplatesListQueryOptions = <TData = Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsProjectTemplatesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsProjectTemplatesList>>> = ({ signal }) => activationsProjectTemplatesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsProjectTemplatesListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsProjectTemplatesList>>>
export type ActivationsProjectTemplatesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsProjectTemplatesList<TData = Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsProjectTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof activationsProjectTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsProjectTemplatesList<TData = Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsProjectTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof activationsProjectTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsProjectTemplatesList<TData = Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Lista szablonów projektów dostępnych dla ucznia
 */

export function useActivationsProjectTemplatesList<TData = Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsProjectTemplatesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsProjectTemplatesRetrieveResponse200 = {
  data: ProjectTemplateEntry
  status: 200
}

export type activationsProjectTemplatesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsProjectTemplatesRetrieveResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type activationsProjectTemplatesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsProjectTemplatesRetrieveResponseSuccess = (activationsProjectTemplatesRetrieveResponse200) & {
  headers: Headers;
};
export type activationsProjectTemplatesRetrieveResponseError = (activationsProjectTemplatesRetrieveResponse401 | activationsProjectTemplatesRetrieveResponse404 | activationsProjectTemplatesRetrieveResponse410) & {
  headers: Headers;
};

export type activationsProjectTemplatesRetrieveResponse = (activationsProjectTemplatesRetrieveResponseSuccess | activationsProjectTemplatesRetrieveResponseError)

export const getActivationsProjectTemplatesRetrieveUrl = (uid: string,) => {




  return `/api/v1/activations/project-templates/${uid}/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @deprecated
 * @summary Szczegóły szablonu projektu (uczeń)
 */
export const activationsProjectTemplatesRetrieve = async (uid: string, options?: RequestInit): Promise<activationsProjectTemplatesRetrieveResponse> => {

  return customFetch<activationsProjectTemplatesRetrieveResponse>(getActivationsProjectTemplatesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsProjectTemplatesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/project-templates/${uid}/`
    ] as const;
    }


export const getActivationsProjectTemplatesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsProjectTemplatesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>> = ({ signal }) => activationsProjectTemplatesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsProjectTemplatesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>>
export type ActivationsProjectTemplatesRetrieveQueryError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse


export function useActivationsProjectTemplatesRetrieve<TData = Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsProjectTemplatesRetrieve<TData = Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsProjectTemplatesRetrieve<TData = Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Szczegóły szablonu projektu (uczeń)
 */

export function useActivationsProjectTemplatesRetrieve<TData = Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsProjectTemplatesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsProjectTemplateSubmissionsListResponse200 = {
  data: StudentSubmissionList
  status: 200
}

export type activationsProjectTemplateSubmissionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsProjectTemplateSubmissionsListResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type activationsProjectTemplateSubmissionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsProjectTemplateSubmissionsListResponseSuccess = (activationsProjectTemplateSubmissionsListResponse200) & {
  headers: Headers;
};
export type activationsProjectTemplateSubmissionsListResponseError = (activationsProjectTemplateSubmissionsListResponse401 | activationsProjectTemplateSubmissionsListResponse404 | activationsProjectTemplateSubmissionsListResponse410) & {
  headers: Headers;
};

export type activationsProjectTemplateSubmissionsListResponse = (activationsProjectTemplateSubmissionsListResponseSuccess | activationsProjectTemplateSubmissionsListResponseError)

export const getActivationsProjectTemplateSubmissionsListUrl = (uid: string,) => {




  return `/api/v1/activations/project-templates/${uid}/submissions/`
}

/**
 * Own-submission collection plus the existing create contract.
 * @deprecated
 * @summary Lista własnych zgłoszeń projektów ucznia
 */
export const activationsProjectTemplateSubmissionsList = async (uid: string, options?: RequestInit): Promise<activationsProjectTemplateSubmissionsListResponse> => {

  return customFetch<activationsProjectTemplateSubmissionsListResponse>(getActivationsProjectTemplateSubmissionsListUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsProjectTemplateSubmissionsListQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/project-templates/${uid}/submissions/`
    ] as const;
    }


export const getActivationsProjectTemplateSubmissionsListQueryOptions = <TData = Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsProjectTemplateSubmissionsListQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>> = ({ signal }) => activationsProjectTemplateSubmissionsList(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsProjectTemplateSubmissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>>
export type ActivationsProjectTemplateSubmissionsListQueryError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse


export function useActivationsProjectTemplateSubmissionsList<TData = Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsProjectTemplateSubmissionsList<TData = Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsProjectTemplateSubmissionsList<TData = Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Lista własnych zgłoszeń projektów ucznia
 */

export function useActivationsProjectTemplateSubmissionsList<TData = Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsProjectTemplateSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsProjectTemplateSubmissionsListQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsProjectTemplatesSubmitResponse201 = {
  data: SubmissionCreated
  status: 201
}

export type activationsProjectTemplatesSubmitResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsProjectTemplatesSubmitResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type activationsProjectTemplatesSubmitResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type activationsProjectTemplatesSubmitResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsProjectTemplatesSubmitResponse422 = {
  data: ErrorEnvelope
  status: 422
}

export type activationsProjectTemplatesSubmitResponseSuccess = (activationsProjectTemplatesSubmitResponse201) & {
  headers: Headers;
};
export type activationsProjectTemplatesSubmitResponseError = (activationsProjectTemplatesSubmitResponse401 | activationsProjectTemplatesSubmitResponse404 | activationsProjectTemplatesSubmitResponse409 | activationsProjectTemplatesSubmitResponse410 | activationsProjectTemplatesSubmitResponse422) & {
  headers: Headers;
};

export type activationsProjectTemplatesSubmitResponse = (activationsProjectTemplatesSubmitResponseSuccess | activationsProjectTemplatesSubmitResponseError)

export const getActivationsProjectTemplatesSubmitUrl = (uid: string,) => {




  return `/api/v1/activations/project-templates/${uid}/submissions/`
}

/**
 * Own-submission collection plus the existing create contract.
 * @deprecated
 * @summary Zgłoszenie projektu do szablonu (uczeń; wiele zgłoszeń dozwolone)
 */
export const activationsProjectTemplatesSubmit = async (uid: string,
    submissionCreateRequest: SubmissionCreateRequest, options?: RequestInit): Promise<activationsProjectTemplatesSubmitResponse> => {

  return customFetch<activationsProjectTemplatesSubmitResponse>(getActivationsProjectTemplatesSubmitUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submissionCreateRequest)
  }
);}




export const getActivationsProjectTemplatesSubmitMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsProjectTemplatesSubmit>>, TError,{uid: string;data: SubmissionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsProjectTemplatesSubmit>>, TError,{uid: string;data: SubmissionCreateRequest}, TContext> => {

const mutationKey = ['activationsProjectTemplatesSubmit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsProjectTemplatesSubmit>>, {uid: string;data: SubmissionCreateRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsProjectTemplatesSubmit(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsProjectTemplatesSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof activationsProjectTemplatesSubmit>>>
    export type ActivationsProjectTemplatesSubmitMutationBody = SubmissionCreateRequest
    export type ActivationsProjectTemplatesSubmitMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @deprecated
 * @summary Zgłoszenie projektu do szablonu (uczeń; wiele zgłoszeń dozwolone)
 */
export const useActivationsProjectTemplatesSubmit = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsProjectTemplatesSubmit>>, TError,{uid: string;data: SubmissionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsProjectTemplatesSubmit>>,
        TError,
        {uid: string;data: SubmissionCreateRequest},
        TContext
      > => {
      return useMutation(getActivationsProjectTemplatesSubmitMutationOptions(options), queryClient);
    }

export type v1ActivationsProjectTemplatesSubmissionsRetrieveResponse200 = {
  data: StudentSubmissionDetail
  status: 200
}

export type v1ActivationsProjectTemplatesSubmissionsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ActivationsProjectTemplatesSubmissionsRetrieveResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type v1ActivationsProjectTemplatesSubmissionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ActivationsProjectTemplatesSubmissionsRetrieveResponseSuccess = (v1ActivationsProjectTemplatesSubmissionsRetrieveResponse200) & {
  headers: Headers;
};
export type v1ActivationsProjectTemplatesSubmissionsRetrieveResponseError = (v1ActivationsProjectTemplatesSubmissionsRetrieveResponse401 | v1ActivationsProjectTemplatesSubmissionsRetrieveResponse404 | v1ActivationsProjectTemplatesSubmissionsRetrieveResponse410) & {
  headers: Headers;
};

export type v1ActivationsProjectTemplatesSubmissionsRetrieveResponse = (v1ActivationsProjectTemplatesSubmissionsRetrieveResponseSuccess | v1ActivationsProjectTemplatesSubmissionsRetrieveResponseError)

export const getV1ActivationsProjectTemplatesSubmissionsRetrieveUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/project-templates/${uid}/submissions/${submissionUid}/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @deprecated
 * @summary Szczegóły własnego zgłoszenia ucznia
 */
export const v1ActivationsProjectTemplatesSubmissionsRetrieve = async (uid: string,
    submissionUid: string, options?: RequestInit): Promise<v1ActivationsProjectTemplatesSubmissionsRetrieveResponse> => {

  return customFetch<v1ActivationsProjectTemplatesSubmissionsRetrieveResponse>(getV1ActivationsProjectTemplatesSubmissionsRetrieveUrl(uid,submissionUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ActivationsProjectTemplatesSubmissionsRetrieveQueryKey = (uid: string,
    submissionUid: string,) => {
    return [
    `/api/v1/activations/project-templates/${uid}/submissions/${submissionUid}/`
    ] as const;
    }


export const getV1ActivationsProjectTemplatesSubmissionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ActivationsProjectTemplatesSubmissionsRetrieveQueryKey(uid,submissionUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>> = ({ signal }) => v1ActivationsProjectTemplatesSubmissionsRetrieve(uid,submissionUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined && submissionUid !== null && submissionUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ActivationsProjectTemplatesSubmissionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>>
export type V1ActivationsProjectTemplatesSubmissionsRetrieveQueryError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse


export function useV1ActivationsProjectTemplatesSubmissionsRetrieve<TData = Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ActivationsProjectTemplatesSubmissionsRetrieve<TData = Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ActivationsProjectTemplatesSubmissionsRetrieve<TData = Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Szczegóły własnego zgłoszenia ucznia
 */

export function useV1ActivationsProjectTemplatesSubmissionsRetrieve<TData = Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ActivationsProjectTemplatesSubmissionsRetrieveQueryOptions(uid,submissionUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse200 = {
  data: StudentSubmissionDetail
  status: 200
}

export type v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse422 = {
  data: ErrorEnvelope
  status: 422
}

export type v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponseSuccess = (v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponseError = (v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse401 | v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse404 | v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse409 | v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse410 | v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse422) & {
  headers: Headers;
};

export type v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse = (v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponseSuccess | v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponseError)

export const getV1ActivationsProjectTemplatesSubmissionsPartialUpdateUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/project-templates/${uid}/submissions/${submissionUid}/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @deprecated
 * @summary Poprawa własnego, nierozpatrzonego zgłoszenia
 */
export const v1ActivationsProjectTemplatesSubmissionsPartialUpdate = async (uid: string,
    submissionUid: string,
    patchedSubmissionUpdateRequest?: PatchedSubmissionUpdateRequest, options?: RequestInit): Promise<v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse> => {

  return customFetch<v1ActivationsProjectTemplatesSubmissionsPartialUpdateResponse>(getV1ActivationsProjectTemplatesSubmissionsPartialUpdateUrl(uid,submissionUid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedSubmissionUpdateRequest)
  }
);}




export const getV1ActivationsProjectTemplatesSubmissionsPartialUpdateMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsPartialUpdate>>, TError,{uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsPartialUpdate>>, TError,{uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}, TContext> => {

const mutationKey = ['v1ActivationsProjectTemplatesSubmissionsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsPartialUpdate>>, {uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}> = (props) => {
          const {uid,submissionUid,data} = props ?? {};

          return  v1ActivationsProjectTemplatesSubmissionsPartialUpdate(uid,submissionUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ActivationsProjectTemplatesSubmissionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsPartialUpdate>>>
    export type V1ActivationsProjectTemplatesSubmissionsPartialUpdateMutationBody = PatchedSubmissionUpdateRequest | undefined
    export type V1ActivationsProjectTemplatesSubmissionsPartialUpdateMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @deprecated
 * @summary Poprawa własnego, nierozpatrzonego zgłoszenia
 */
export const useV1ActivationsProjectTemplatesSubmissionsPartialUpdate = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsPartialUpdate>>, TError,{uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsPartialUpdate>>,
        TError,
        {uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest},
        TContext
      > => {
      return useMutation(getV1ActivationsProjectTemplatesSubmissionsPartialUpdateMutationOptions(options), queryClient);
    }

export type v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse200 = {
  data: StudentSubmissionDetail
  status: 200
}

export type v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponseSuccess = (v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse200) & {
  headers: Headers;
};
export type v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponseError = (v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse401 | v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse404 | v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse409 | v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse410) & {
  headers: Headers;
};

export type v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse = (v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponseSuccess | v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponseError)

export const getV1ActivationsProjectTemplatesSubmissionsWithdrawCreateUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/project-templates/${uid}/submissions/${submissionUid}/withdraw/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @deprecated
 * @summary Wycofanie własnego, nierozpatrzonego zgłoszenia
 */
export const v1ActivationsProjectTemplatesSubmissionsWithdrawCreate = async (uid: string,
    submissionUid: string, options?: RequestInit): Promise<v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse> => {

  return customFetch<v1ActivationsProjectTemplatesSubmissionsWithdrawCreateResponse>(getV1ActivationsProjectTemplatesSubmissionsWithdrawCreateUrl(uid,submissionUid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1ActivationsProjectTemplatesSubmissionsWithdrawCreateMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsWithdrawCreate>>, TError,{uid: string;submissionUid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsWithdrawCreate>>, TError,{uid: string;submissionUid: string}, TContext> => {

const mutationKey = ['v1ActivationsProjectTemplatesSubmissionsWithdrawCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsWithdrawCreate>>, {uid: string;submissionUid: string}> = (props) => {
          const {uid,submissionUid} = props ?? {};

          return  v1ActivationsProjectTemplatesSubmissionsWithdrawCreate(uid,submissionUid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ActivationsProjectTemplatesSubmissionsWithdrawCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsWithdrawCreate>>>

    export type V1ActivationsProjectTemplatesSubmissionsWithdrawCreateMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @deprecated
 * @summary Wycofanie własnego, nierozpatrzonego zgłoszenia
 */
export const useV1ActivationsProjectTemplatesSubmissionsWithdrawCreate = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsWithdrawCreate>>, TError,{uid: string;submissionUid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ActivationsProjectTemplatesSubmissionsWithdrawCreate>>,
        TError,
        {uid: string;submissionUid: string},
        TContext
      > => {
      return useMutation(getV1ActivationsProjectTemplatesSubmissionsWithdrawCreateMutationOptions(options), queryClient);
    }

export type activationsStudentProjectsListResponse200 = {
  data: StudentProjectList
  status: 200
}

export type activationsStudentProjectsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsStudentProjectsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsStudentProjectsListResponseSuccess = (activationsStudentProjectsListResponse200) & {
  headers: Headers;
};
export type activationsStudentProjectsListResponseError = (activationsStudentProjectsListResponse401 | activationsStudentProjectsListResponse410) & {
  headers: Headers;
};

export type activationsStudentProjectsListResponse = (activationsStudentProjectsListResponseSuccess | activationsStudentProjectsListResponseError)

export const getActivationsStudentProjectsListUrl = () => {




  return `/api/v1/activations/student-projects/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @summary Lista projektów uczniowskich dostępnych dla ucznia
 */
export const activationsStudentProjectsList = async ( options?: RequestInit): Promise<activationsStudentProjectsListResponse> => {

  return customFetch<activationsStudentProjectsListResponse>(getActivationsStudentProjectsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsStudentProjectsListQueryKey = () => {
    return [
    `/api/v1/activations/student-projects/`
    ] as const;
    }


export const getActivationsStudentProjectsListQueryOptions = <TData = Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsStudentProjectsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsStudentProjectsList>>> = ({ signal }) => activationsStudentProjectsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsStudentProjectsListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsStudentProjectsList>>>
export type ActivationsStudentProjectsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsStudentProjectsList<TData = Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsStudentProjectsList>>,
          TError,
          Awaited<ReturnType<typeof activationsStudentProjectsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsStudentProjectsList<TData = Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsStudentProjectsList>>,
          TError,
          Awaited<ReturnType<typeof activationsStudentProjectsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsStudentProjectsList<TData = Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista projektów uczniowskich dostępnych dla ucznia
 */

export function useActivationsStudentProjectsList<TData = Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsStudentProjectsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsStudentProjectsRetrieveResponse200 = {
  data: StudentProjectEntry
  status: 200
}

export type activationsStudentProjectsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsStudentProjectsRetrieveResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type activationsStudentProjectsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsStudentProjectsRetrieveResponseSuccess = (activationsStudentProjectsRetrieveResponse200) & {
  headers: Headers;
};
export type activationsStudentProjectsRetrieveResponseError = (activationsStudentProjectsRetrieveResponse401 | activationsStudentProjectsRetrieveResponse404 | activationsStudentProjectsRetrieveResponse410) & {
  headers: Headers;
};

export type activationsStudentProjectsRetrieveResponse = (activationsStudentProjectsRetrieveResponseSuccess | activationsStudentProjectsRetrieveResponseError)

export const getActivationsStudentProjectsRetrieveUrl = (uid: string,) => {




  return `/api/v1/activations/student-projects/${uid}/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @summary Szczegóły projektu uczniowskiego (uczeń)
 */
export const activationsStudentProjectsRetrieve = async (uid: string, options?: RequestInit): Promise<activationsStudentProjectsRetrieveResponse> => {

  return customFetch<activationsStudentProjectsRetrieveResponse>(getActivationsStudentProjectsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsStudentProjectsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/student-projects/${uid}/`
    ] as const;
    }


export const getActivationsStudentProjectsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsStudentProjectsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>> = ({ signal }) => activationsStudentProjectsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsStudentProjectsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>>
export type ActivationsStudentProjectsRetrieveQueryError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse


export function useActivationsStudentProjectsRetrieve<TData = Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsStudentProjectsRetrieve<TData = Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsStudentProjectsRetrieve<TData = Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły projektu uczniowskiego (uczeń)
 */

export function useActivationsStudentProjectsRetrieve<TData = Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsStudentProjectsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsStudentProjectSubmissionsListResponse200 = {
  data: StudentProjectSubmissionList
  status: 200
}

export type activationsStudentProjectSubmissionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsStudentProjectSubmissionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsStudentProjectSubmissionsListResponseSuccess = (activationsStudentProjectSubmissionsListResponse200) & {
  headers: Headers;
};
export type activationsStudentProjectSubmissionsListResponseError = (activationsStudentProjectSubmissionsListResponse401 | activationsStudentProjectSubmissionsListResponse410) & {
  headers: Headers;
};

export type activationsStudentProjectSubmissionsListResponse = (activationsStudentProjectSubmissionsListResponseSuccess | activationsStudentProjectSubmissionsListResponseError)

export const getActivationsStudentProjectSubmissionsListUrl = (uid: string,) => {




  return `/api/v1/activations/student-projects/${uid}/submissions/`
}

/**
 * Own-submission collection plus the existing create contract.
 * @summary Lista własnych zgłoszeń projektu uczniowskiego
 */
export const activationsStudentProjectSubmissionsList = async (uid: string, options?: RequestInit): Promise<activationsStudentProjectSubmissionsListResponse> => {

  return customFetch<activationsStudentProjectSubmissionsListResponse>(getActivationsStudentProjectSubmissionsListUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsStudentProjectSubmissionsListQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/student-projects/${uid}/submissions/`
    ] as const;
    }


export const getActivationsStudentProjectSubmissionsListQueryOptions = <TData = Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsStudentProjectSubmissionsListQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>> = ({ signal }) => activationsStudentProjectSubmissionsList(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsStudentProjectSubmissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>>
export type ActivationsStudentProjectSubmissionsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsStudentProjectSubmissionsList<TData = Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsStudentProjectSubmissionsList<TData = Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsStudentProjectSubmissionsList<TData = Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista własnych zgłoszeń projektu uczniowskiego
 */

export function useActivationsStudentProjectSubmissionsList<TData = Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsStudentProjectSubmissionsListQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsStudentProjectsSubmitResponse201 = {
  data: SubmissionCreated
  status: 201
}

export type activationsStudentProjectsSubmitResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsStudentProjectsSubmitResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type activationsStudentProjectsSubmitResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type activationsStudentProjectsSubmitResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsStudentProjectsSubmitResponse422 = {
  data: ErrorEnvelope
  status: 422
}

export type activationsStudentProjectsSubmitResponseSuccess = (activationsStudentProjectsSubmitResponse201) & {
  headers: Headers;
};
export type activationsStudentProjectsSubmitResponseError = (activationsStudentProjectsSubmitResponse401 | activationsStudentProjectsSubmitResponse404 | activationsStudentProjectsSubmitResponse409 | activationsStudentProjectsSubmitResponse410 | activationsStudentProjectsSubmitResponse422) & {
  headers: Headers;
};

export type activationsStudentProjectsSubmitResponse = (activationsStudentProjectsSubmitResponseSuccess | activationsStudentProjectsSubmitResponseError)

export const getActivationsStudentProjectsSubmitUrl = (uid: string,) => {




  return `/api/v1/activations/student-projects/${uid}/submissions/`
}

/**
 * Own-submission collection plus the existing create contract.
 * @summary Zgłoszenie projektu uczniowskiego
 */
export const activationsStudentProjectsSubmit = async (uid: string,
    submissionCreateRequest: SubmissionCreateRequest, options?: RequestInit): Promise<activationsStudentProjectsSubmitResponse> => {

  return customFetch<activationsStudentProjectsSubmitResponse>(getActivationsStudentProjectsSubmitUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submissionCreateRequest)
  }
);}




export const getActivationsStudentProjectsSubmitMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsStudentProjectsSubmit>>, TError,{uid: string;data: SubmissionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsStudentProjectsSubmit>>, TError,{uid: string;data: SubmissionCreateRequest}, TContext> => {

const mutationKey = ['activationsStudentProjectsSubmit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsStudentProjectsSubmit>>, {uid: string;data: SubmissionCreateRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsStudentProjectsSubmit(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsStudentProjectsSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof activationsStudentProjectsSubmit>>>
    export type ActivationsStudentProjectsSubmitMutationBody = SubmissionCreateRequest
    export type ActivationsStudentProjectsSubmitMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @summary Zgłoszenie projektu uczniowskiego
 */
export const useActivationsStudentProjectsSubmit = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsStudentProjectsSubmit>>, TError,{uid: string;data: SubmissionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsStudentProjectsSubmit>>,
        TError,
        {uid: string;data: SubmissionCreateRequest},
        TContext
      > => {
      return useMutation(getActivationsStudentProjectsSubmitMutationOptions(options), queryClient);
    }

export type activationsStudentProjectSubmissionRetrieveResponse200 = {
  data: StudentProjectSubmissionDetail
  status: 200
}

export type activationsStudentProjectSubmissionRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsStudentProjectSubmissionRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsStudentProjectSubmissionRetrieveResponseSuccess = (activationsStudentProjectSubmissionRetrieveResponse200) & {
  headers: Headers;
};
export type activationsStudentProjectSubmissionRetrieveResponseError = (activationsStudentProjectSubmissionRetrieveResponse401 | activationsStudentProjectSubmissionRetrieveResponse410) & {
  headers: Headers;
};

export type activationsStudentProjectSubmissionRetrieveResponse = (activationsStudentProjectSubmissionRetrieveResponseSuccess | activationsStudentProjectSubmissionRetrieveResponseError)

export const getActivationsStudentProjectSubmissionRetrieveUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/student-projects/${uid}/submissions/${submissionUid}/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @summary Szczegóły własnego zgłoszenia ucznia
 */
export const activationsStudentProjectSubmissionRetrieve = async (uid: string,
    submissionUid: string, options?: RequestInit): Promise<activationsStudentProjectSubmissionRetrieveResponse> => {

  return customFetch<activationsStudentProjectSubmissionRetrieveResponse>(getActivationsStudentProjectSubmissionRetrieveUrl(uid,submissionUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsStudentProjectSubmissionRetrieveQueryKey = (uid: string,
    submissionUid: string,) => {
    return [
    `/api/v1/activations/student-projects/${uid}/submissions/${submissionUid}/`
    ] as const;
    }


export const getActivationsStudentProjectSubmissionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsStudentProjectSubmissionRetrieveQueryKey(uid,submissionUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>> = ({ signal }) => activationsStudentProjectSubmissionRetrieve(uid,submissionUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined && submissionUid !== null && submissionUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsStudentProjectSubmissionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>>
export type ActivationsStudentProjectSubmissionRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsStudentProjectSubmissionRetrieve<TData = Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsStudentProjectSubmissionRetrieve<TData = Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsStudentProjectSubmissionRetrieve<TData = Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły własnego zgłoszenia ucznia
 */

export function useActivationsStudentProjectSubmissionRetrieve<TData = Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsStudentProjectSubmissionRetrieveQueryOptions(uid,submissionUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsStudentProjectSubmissionUpdateResponse200 = {
  data: StudentProjectSubmissionDetail
  status: 200
}

export type activationsStudentProjectSubmissionUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsStudentProjectSubmissionUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsStudentProjectSubmissionUpdateResponseSuccess = (activationsStudentProjectSubmissionUpdateResponse200) & {
  headers: Headers;
};
export type activationsStudentProjectSubmissionUpdateResponseError = (activationsStudentProjectSubmissionUpdateResponse401 | activationsStudentProjectSubmissionUpdateResponse410) & {
  headers: Headers;
};

export type activationsStudentProjectSubmissionUpdateResponse = (activationsStudentProjectSubmissionUpdateResponseSuccess | activationsStudentProjectSubmissionUpdateResponseError)

export const getActivationsStudentProjectSubmissionUpdateUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/student-projects/${uid}/submissions/${submissionUid}/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @summary Poprawa własnego, nierozpatrzonego zgłoszenia
 */
export const activationsStudentProjectSubmissionUpdate = async (uid: string,
    submissionUid: string,
    patchedSubmissionUpdateRequest?: PatchedSubmissionUpdateRequest, options?: RequestInit): Promise<activationsStudentProjectSubmissionUpdateResponse> => {

  return customFetch<activationsStudentProjectSubmissionUpdateResponse>(getActivationsStudentProjectSubmissionUpdateUrl(uid,submissionUid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedSubmissionUpdateRequest)
  }
);}




export const getActivationsStudentProjectSubmissionUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionUpdate>>, TError,{uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionUpdate>>, TError,{uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}, TContext> => {

const mutationKey = ['activationsStudentProjectSubmissionUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsStudentProjectSubmissionUpdate>>, {uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}> = (props) => {
          const {uid,submissionUid,data} = props ?? {};

          return  activationsStudentProjectSubmissionUpdate(uid,submissionUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsStudentProjectSubmissionUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activationsStudentProjectSubmissionUpdate>>>
    export type ActivationsStudentProjectSubmissionUpdateMutationBody = PatchedSubmissionUpdateRequest | undefined
    export type ActivationsStudentProjectSubmissionUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Poprawa własnego, nierozpatrzonego zgłoszenia
 */
export const useActivationsStudentProjectSubmissionUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionUpdate>>, TError,{uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsStudentProjectSubmissionUpdate>>,
        TError,
        {uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest},
        TContext
      > => {
      return useMutation(getActivationsStudentProjectSubmissionUpdateMutationOptions(options), queryClient);
    }

export type activationsStudentProjectSubmissionWithdrawResponse200 = {
  data: StudentProjectSubmissionDetail
  status: 200
}

export type activationsStudentProjectSubmissionWithdrawResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsStudentProjectSubmissionWithdrawResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsStudentProjectSubmissionWithdrawResponseSuccess = (activationsStudentProjectSubmissionWithdrawResponse200) & {
  headers: Headers;
};
export type activationsStudentProjectSubmissionWithdrawResponseError = (activationsStudentProjectSubmissionWithdrawResponse401 | activationsStudentProjectSubmissionWithdrawResponse410) & {
  headers: Headers;
};

export type activationsStudentProjectSubmissionWithdrawResponse = (activationsStudentProjectSubmissionWithdrawResponseSuccess | activationsStudentProjectSubmissionWithdrawResponseError)

export const getActivationsStudentProjectSubmissionWithdrawUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/student-projects/${uid}/submissions/${submissionUid}/withdraw/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @summary Wycofanie własnego, nierozpatrzonego zgłoszenia
 */
export const activationsStudentProjectSubmissionWithdraw = async (uid: string,
    submissionUid: string, options?: RequestInit): Promise<activationsStudentProjectSubmissionWithdrawResponse> => {

  return customFetch<activationsStudentProjectSubmissionWithdrawResponse>(getActivationsStudentProjectSubmissionWithdrawUrl(uid,submissionUid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivationsStudentProjectSubmissionWithdrawMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionWithdraw>>, TError,{uid: string;submissionUid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionWithdraw>>, TError,{uid: string;submissionUid: string}, TContext> => {

const mutationKey = ['activationsStudentProjectSubmissionWithdraw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsStudentProjectSubmissionWithdraw>>, {uid: string;submissionUid: string}> = (props) => {
          const {uid,submissionUid} = props ?? {};

          return  activationsStudentProjectSubmissionWithdraw(uid,submissionUid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsStudentProjectSubmissionWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof activationsStudentProjectSubmissionWithdraw>>>

    export type ActivationsStudentProjectSubmissionWithdrawMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Wycofanie własnego, nierozpatrzonego zgłoszenia
 */
export const useActivationsStudentProjectSubmissionWithdraw = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsStudentProjectSubmissionWithdraw>>, TError,{uid: string;submissionUid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsStudentProjectSubmissionWithdraw>>,
        TError,
        {uid: string;submissionUid: string},
        TContext
      > => {
      return useMutation(getActivationsStudentProjectSubmissionWithdrawMutationOptions(options), queryClient);
    }

export type activationsThematicTasksListResponse200 = {
  data: ThematicTaskList
  status: 200
}

export type activationsThematicTasksListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsThematicTasksListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsThematicTasksListResponseSuccess = (activationsThematicTasksListResponse200) & {
  headers: Headers;
};
export type activationsThematicTasksListResponseError = (activationsThematicTasksListResponse401 | activationsThematicTasksListResponse410) & {
  headers: Headers;
};

export type activationsThematicTasksListResponse = (activationsThematicTasksListResponseSuccess | activationsThematicTasksListResponseError)

export const getActivationsThematicTasksListUrl = () => {




  return `/api/v1/activations/thematic-tasks/`
}

/**
 * `GET /api/v1/activations/thematic-tasks/` — published briefs covering
 * the caller, each with the caller's own `notSubmitted`/`submitted` status.
 * An archived task appears ONLY while the caller has a submission on it.
 * @deprecated
 * @summary Lista zadań tematycznych dostępnych dla ucznia
 */
export const activationsThematicTasksList = async ( options?: RequestInit): Promise<activationsThematicTasksListResponse> => {

  return customFetch<activationsThematicTasksListResponse>(getActivationsThematicTasksListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsThematicTasksListQueryKey = () => {
    return [
    `/api/v1/activations/thematic-tasks/`
    ] as const;
    }


export const getActivationsThematicTasksListQueryOptions = <TData = Awaited<ReturnType<typeof activationsThematicTasksList>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsThematicTasksListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsThematicTasksList>>> = ({ signal }) => activationsThematicTasksList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsThematicTasksListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsThematicTasksList>>>
export type ActivationsThematicTasksListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivationsThematicTasksList<TData = Awaited<ReturnType<typeof activationsThematicTasksList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsThematicTasksList>>,
          TError,
          Awaited<ReturnType<typeof activationsThematicTasksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsThematicTasksList<TData = Awaited<ReturnType<typeof activationsThematicTasksList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsThematicTasksList>>,
          TError,
          Awaited<ReturnType<typeof activationsThematicTasksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsThematicTasksList<TData = Awaited<ReturnType<typeof activationsThematicTasksList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Lista zadań tematycznych dostępnych dla ucznia
 */

export function useActivationsThematicTasksList<TData = Awaited<ReturnType<typeof activationsThematicTasksList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsThematicTasksListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsThematicTasksRetrieveResponse200 = {
  data: ThematicTaskEntry
  status: 200
}

export type activationsThematicTasksRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsThematicTasksRetrieveResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type activationsThematicTasksRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsThematicTasksRetrieveResponseSuccess = (activationsThematicTasksRetrieveResponse200) & {
  headers: Headers;
};
export type activationsThematicTasksRetrieveResponseError = (activationsThematicTasksRetrieveResponse401 | activationsThematicTasksRetrieveResponse404 | activationsThematicTasksRetrieveResponse410) & {
  headers: Headers;
};

export type activationsThematicTasksRetrieveResponse = (activationsThematicTasksRetrieveResponseSuccess | activationsThematicTasksRetrieveResponseError)

export const getActivationsThematicTasksRetrieveUrl = (uid: string,) => {




  return `/api/v1/activations/thematic-tasks/${uid}/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @deprecated
 * @summary Szczegóły zadania tematycznego (uczeń)
 */
export const activationsThematicTasksRetrieve = async (uid: string, options?: RequestInit): Promise<activationsThematicTasksRetrieveResponse> => {

  return customFetch<activationsThematicTasksRetrieveResponse>(getActivationsThematicTasksRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsThematicTasksRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/thematic-tasks/${uid}/`
    ] as const;
    }


export const getActivationsThematicTasksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsThematicTasksRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>> = ({ signal }) => activationsThematicTasksRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsThematicTasksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>>
export type ActivationsThematicTasksRetrieveQueryError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse


export function useActivationsThematicTasksRetrieve<TData = Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsThematicTasksRetrieve<TData = Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsThematicTasksRetrieve<TData = Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Szczegóły zadania tematycznego (uczeń)
 */

export function useActivationsThematicTasksRetrieve<TData = Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTasksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsThematicTasksRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsThematicTaskSubmissionsListResponse200 = {
  data: StudentSubmissionList
  status: 200
}

export type activationsThematicTaskSubmissionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsThematicTaskSubmissionsListResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type activationsThematicTaskSubmissionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsThematicTaskSubmissionsListResponseSuccess = (activationsThematicTaskSubmissionsListResponse200) & {
  headers: Headers;
};
export type activationsThematicTaskSubmissionsListResponseError = (activationsThematicTaskSubmissionsListResponse401 | activationsThematicTaskSubmissionsListResponse404 | activationsThematicTaskSubmissionsListResponse410) & {
  headers: Headers;
};

export type activationsThematicTaskSubmissionsListResponse = (activationsThematicTaskSubmissionsListResponseSuccess | activationsThematicTaskSubmissionsListResponseError)

export const getActivationsThematicTaskSubmissionsListUrl = (uid: string,) => {




  return `/api/v1/activations/thematic-tasks/${uid}/submissions/`
}

/**
 * Own-submission collection plus the existing create contract.
 * @deprecated
 * @summary Lista własnych zgłoszeń realizacji ucznia
 */
export const activationsThematicTaskSubmissionsList = async (uid: string, options?: RequestInit): Promise<activationsThematicTaskSubmissionsListResponse> => {

  return customFetch<activationsThematicTaskSubmissionsListResponse>(getActivationsThematicTaskSubmissionsListUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivationsThematicTaskSubmissionsListQueryKey = (uid: string,) => {
    return [
    `/api/v1/activations/thematic-tasks/${uid}/submissions/`
    ] as const;
    }


export const getActivationsThematicTaskSubmissionsListQueryOptions = <TData = Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivationsThematicTaskSubmissionsListQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>> = ({ signal }) => activationsThematicTaskSubmissionsList(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivationsThematicTaskSubmissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>>
export type ActivationsThematicTaskSubmissionsListQueryError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse


export function useActivationsThematicTaskSubmissionsList<TData = Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsThematicTaskSubmissionsList<TData = Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>,
          TError,
          Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivationsThematicTaskSubmissionsList<TData = Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Lista własnych zgłoszeń realizacji ucznia
 */

export function useActivationsThematicTaskSubmissionsList<TData = Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activationsThematicTaskSubmissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivationsThematicTaskSubmissionsListQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activationsThematicTasksSubmitResponse201 = {
  data: SubmissionCreated
  status: 201
}

export type activationsThematicTasksSubmitResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activationsThematicTasksSubmitResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type activationsThematicTasksSubmitResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type activationsThematicTasksSubmitResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activationsThematicTasksSubmitResponse422 = {
  data: ErrorEnvelope
  status: 422
}

export type activationsThematicTasksSubmitResponseSuccess = (activationsThematicTasksSubmitResponse201) & {
  headers: Headers;
};
export type activationsThematicTasksSubmitResponseError = (activationsThematicTasksSubmitResponse401 | activationsThematicTasksSubmitResponse404 | activationsThematicTasksSubmitResponse409 | activationsThematicTasksSubmitResponse410 | activationsThematicTasksSubmitResponse422) & {
  headers: Headers;
};

export type activationsThematicTasksSubmitResponse = (activationsThematicTasksSubmitResponseSuccess | activationsThematicTasksSubmitResponseError)

export const getActivationsThematicTasksSubmitUrl = (uid: string,) => {




  return `/api/v1/activations/thematic-tasks/${uid}/submissions/`
}

/**
 * Own-submission collection plus the existing create contract.
 * @deprecated
 * @summary Zgłoszenie realizacji zadania tematycznego (uczeń; jedno zgłoszenie)
 */
export const activationsThematicTasksSubmit = async (uid: string,
    submissionCreateRequest: SubmissionCreateRequest, options?: RequestInit): Promise<activationsThematicTasksSubmitResponse> => {

  return customFetch<activationsThematicTasksSubmitResponse>(getActivationsThematicTasksSubmitUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submissionCreateRequest)
  }
);}




export const getActivationsThematicTasksSubmitMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsThematicTasksSubmit>>, TError,{uid: string;data: SubmissionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activationsThematicTasksSubmit>>, TError,{uid: string;data: SubmissionCreateRequest}, TContext> => {

const mutationKey = ['activationsThematicTasksSubmit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activationsThematicTasksSubmit>>, {uid: string;data: SubmissionCreateRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  activationsThematicTasksSubmit(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivationsThematicTasksSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof activationsThematicTasksSubmit>>>
    export type ActivationsThematicTasksSubmitMutationBody = SubmissionCreateRequest
    export type ActivationsThematicTasksSubmitMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @deprecated
 * @summary Zgłoszenie realizacji zadania tematycznego (uczeń; jedno zgłoszenie)
 */
export const useActivationsThematicTasksSubmit = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activationsThematicTasksSubmit>>, TError,{uid: string;data: SubmissionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activationsThematicTasksSubmit>>,
        TError,
        {uid: string;data: SubmissionCreateRequest},
        TContext
      > => {
      return useMutation(getActivationsThematicTasksSubmitMutationOptions(options), queryClient);
    }

export type v1ActivationsThematicTasksSubmissionsRetrieveResponse200 = {
  data: StudentSubmissionDetail
  status: 200
}

export type v1ActivationsThematicTasksSubmissionsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ActivationsThematicTasksSubmissionsRetrieveResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type v1ActivationsThematicTasksSubmissionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ActivationsThematicTasksSubmissionsRetrieveResponseSuccess = (v1ActivationsThematicTasksSubmissionsRetrieveResponse200) & {
  headers: Headers;
};
export type v1ActivationsThematicTasksSubmissionsRetrieveResponseError = (v1ActivationsThematicTasksSubmissionsRetrieveResponse401 | v1ActivationsThematicTasksSubmissionsRetrieveResponse404 | v1ActivationsThematicTasksSubmissionsRetrieveResponse410) & {
  headers: Headers;
};

export type v1ActivationsThematicTasksSubmissionsRetrieveResponse = (v1ActivationsThematicTasksSubmissionsRetrieveResponseSuccess | v1ActivationsThematicTasksSubmissionsRetrieveResponseError)

export const getV1ActivationsThematicTasksSubmissionsRetrieveUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/thematic-tasks/${uid}/submissions/${submissionUid}/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @deprecated
 * @summary Szczegóły własnego zgłoszenia ucznia
 */
export const v1ActivationsThematicTasksSubmissionsRetrieve = async (uid: string,
    submissionUid: string, options?: RequestInit): Promise<v1ActivationsThematicTasksSubmissionsRetrieveResponse> => {

  return customFetch<v1ActivationsThematicTasksSubmissionsRetrieveResponse>(getV1ActivationsThematicTasksSubmissionsRetrieveUrl(uid,submissionUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ActivationsThematicTasksSubmissionsRetrieveQueryKey = (uid: string,
    submissionUid: string,) => {
    return [
    `/api/v1/activations/thematic-tasks/${uid}/submissions/${submissionUid}/`
    ] as const;
    }


export const getV1ActivationsThematicTasksSubmissionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ActivationsThematicTasksSubmissionsRetrieveQueryKey(uid,submissionUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>> = ({ signal }) => v1ActivationsThematicTasksSubmissionsRetrieve(uid,submissionUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined && submissionUid !== null && submissionUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ActivationsThematicTasksSubmissionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>>
export type V1ActivationsThematicTasksSubmissionsRetrieveQueryError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse


export function useV1ActivationsThematicTasksSubmissionsRetrieve<TData = Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ActivationsThematicTasksSubmissionsRetrieve<TData = Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ActivationsThematicTasksSubmissionsRetrieve<TData = Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Szczegóły własnego zgłoszenia ucznia
 */

export function useV1ActivationsThematicTasksSubmissionsRetrieve<TData = Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 uid: string,
    submissionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ActivationsThematicTasksSubmissionsRetrieveQueryOptions(uid,submissionUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ActivationsThematicTasksSubmissionsPartialUpdateResponse200 = {
  data: StudentSubmissionDetail
  status: 200
}

export type v1ActivationsThematicTasksSubmissionsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ActivationsThematicTasksSubmissionsPartialUpdateResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type v1ActivationsThematicTasksSubmissionsPartialUpdateResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type v1ActivationsThematicTasksSubmissionsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ActivationsThematicTasksSubmissionsPartialUpdateResponse422 = {
  data: ErrorEnvelope
  status: 422
}

export type v1ActivationsThematicTasksSubmissionsPartialUpdateResponseSuccess = (v1ActivationsThematicTasksSubmissionsPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1ActivationsThematicTasksSubmissionsPartialUpdateResponseError = (v1ActivationsThematicTasksSubmissionsPartialUpdateResponse401 | v1ActivationsThematicTasksSubmissionsPartialUpdateResponse404 | v1ActivationsThematicTasksSubmissionsPartialUpdateResponse409 | v1ActivationsThematicTasksSubmissionsPartialUpdateResponse410 | v1ActivationsThematicTasksSubmissionsPartialUpdateResponse422) & {
  headers: Headers;
};

export type v1ActivationsThematicTasksSubmissionsPartialUpdateResponse = (v1ActivationsThematicTasksSubmissionsPartialUpdateResponseSuccess | v1ActivationsThematicTasksSubmissionsPartialUpdateResponseError)

export const getV1ActivationsThematicTasksSubmissionsPartialUpdateUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/thematic-tasks/${uid}/submissions/${submissionUid}/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @deprecated
 * @summary Poprawa własnego, nierozpatrzonego zgłoszenia
 */
export const v1ActivationsThematicTasksSubmissionsPartialUpdate = async (uid: string,
    submissionUid: string,
    patchedSubmissionUpdateRequest?: PatchedSubmissionUpdateRequest, options?: RequestInit): Promise<v1ActivationsThematicTasksSubmissionsPartialUpdateResponse> => {

  return customFetch<v1ActivationsThematicTasksSubmissionsPartialUpdateResponse>(getV1ActivationsThematicTasksSubmissionsPartialUpdateUrl(uid,submissionUid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedSubmissionUpdateRequest)
  }
);}




export const getV1ActivationsThematicTasksSubmissionsPartialUpdateMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsPartialUpdate>>, TError,{uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsPartialUpdate>>, TError,{uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}, TContext> => {

const mutationKey = ['v1ActivationsThematicTasksSubmissionsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsPartialUpdate>>, {uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}> = (props) => {
          const {uid,submissionUid,data} = props ?? {};

          return  v1ActivationsThematicTasksSubmissionsPartialUpdate(uid,submissionUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ActivationsThematicTasksSubmissionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsPartialUpdate>>>
    export type V1ActivationsThematicTasksSubmissionsPartialUpdateMutationBody = PatchedSubmissionUpdateRequest | undefined
    export type V1ActivationsThematicTasksSubmissionsPartialUpdateMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @deprecated
 * @summary Poprawa własnego, nierozpatrzonego zgłoszenia
 */
export const useV1ActivationsThematicTasksSubmissionsPartialUpdate = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsPartialUpdate>>, TError,{uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsPartialUpdate>>,
        TError,
        {uid: string;submissionUid: string;data?: PatchedSubmissionUpdateRequest},
        TContext
      > => {
      return useMutation(getV1ActivationsThematicTasksSubmissionsPartialUpdateMutationOptions(options), queryClient);
    }

export type v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse200 = {
  data: StudentSubmissionDetail
  status: 200
}

export type v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ActivationsThematicTasksSubmissionsWithdrawCreateResponseSuccess = (v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse200) & {
  headers: Headers;
};
export type v1ActivationsThematicTasksSubmissionsWithdrawCreateResponseError = (v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse401 | v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse404 | v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse409 | v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse410) & {
  headers: Headers;
};

export type v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse = (v1ActivationsThematicTasksSubmissionsWithdrawCreateResponseSuccess | v1ActivationsThematicTasksSubmissionsWithdrawCreateResponseError)

export const getV1ActivationsThematicTasksSubmissionsWithdrawCreateUrl = (uid: string,
    submissionUid: string,) => {




  return `/api/v1/activations/thematic-tasks/${uid}/submissions/${submissionUid}/withdraw/`
}

/**
 * Student-only, envelope errors, no filters/pagination (the quiz
 * discovery posture). Ownership/visibility is queryset filtering → 404,
 * NEVER object permissions (anti-enumeration).
 * @deprecated
 * @summary Wycofanie własnego, nierozpatrzonego zgłoszenia
 */
export const v1ActivationsThematicTasksSubmissionsWithdrawCreate = async (uid: string,
    submissionUid: string, options?: RequestInit): Promise<v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse> => {

  return customFetch<v1ActivationsThematicTasksSubmissionsWithdrawCreateResponse>(getV1ActivationsThematicTasksSubmissionsWithdrawCreateUrl(uid,submissionUid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1ActivationsThematicTasksSubmissionsWithdrawCreateMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsWithdrawCreate>>, TError,{uid: string;submissionUid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsWithdrawCreate>>, TError,{uid: string;submissionUid: string}, TContext> => {

const mutationKey = ['v1ActivationsThematicTasksSubmissionsWithdrawCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsWithdrawCreate>>, {uid: string;submissionUid: string}> = (props) => {
          const {uid,submissionUid} = props ?? {};

          return  v1ActivationsThematicTasksSubmissionsWithdrawCreate(uid,submissionUid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ActivationsThematicTasksSubmissionsWithdrawCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsWithdrawCreate>>>

    export type V1ActivationsThematicTasksSubmissionsWithdrawCreateMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @deprecated
 * @summary Wycofanie własnego, nierozpatrzonego zgłoszenia
 */
export const useV1ActivationsThematicTasksSubmissionsWithdrawCreate = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsWithdrawCreate>>, TError,{uid: string;submissionUid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ActivationsThematicTasksSubmissionsWithdrawCreate>>,
        TError,
        {uid: string;submissionUid: string},
        TContext
      > => {
      return useMutation(getV1ActivationsThematicTasksSubmissionsWithdrawCreateMutationOptions(options), queryClient);
    }

export type activitiesRetrieveResponse200 = {
  data: ActivityCurrentItem
  status: 200
}

export type activitiesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activitiesRetrieveResponse404 = {
  data: ActivityDeclarationError
  status: 404
}

export type activitiesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesRetrieveResponseSuccess = (activitiesRetrieveResponse200) & {
  headers: Headers;
};
export type activitiesRetrieveResponseError = (activitiesRetrieveResponse401 | activitiesRetrieveResponse404 | activitiesRetrieveResponse410) & {
  headers: Headers;
};

export type activitiesRetrieveResponse = (activitiesRetrieveResponseSuccess | activitiesRetrieveResponseError)

export const getActivitiesRetrieveUrl = (assignmentUid: string,) => {




  return `/api/v1/activities/${assignmentUid}/`
}

/**
 * @summary Szczegóły własnej aktywności
 */
export const activitiesRetrieve = async (assignmentUid: string, options?: RequestInit): Promise<activitiesRetrieveResponse> => {

  return customFetch<activitiesRetrieveResponse>(getActivitiesRetrieveUrl(assignmentUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivitiesRetrieveQueryKey = (assignmentUid: string,) => {
    return [
    `/api/v1/activities/${assignmentUid}/`
    ] as const;
    }


export const getActivitiesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activitiesRetrieve>>, TError = UnauthorizedResponse | ActivityDeclarationError | AccountGoneResponse>(assignmentUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitiesRetrieveQueryKey(assignmentUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitiesRetrieve>>> = ({ signal }) => activitiesRetrieve(assignmentUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: assignmentUid !== null && assignmentUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitiesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitiesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activitiesRetrieve>>>
export type ActivitiesRetrieveQueryError = UnauthorizedResponse | ActivityDeclarationError | AccountGoneResponse


export function useActivitiesRetrieve<TData = Awaited<ReturnType<typeof activitiesRetrieve>>, TError = UnauthorizedResponse | ActivityDeclarationError | AccountGoneResponse>(
 assignmentUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activitiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesRetrieve<TData = Awaited<ReturnType<typeof activitiesRetrieve>>, TError = UnauthorizedResponse | ActivityDeclarationError | AccountGoneResponse>(
 assignmentUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activitiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesRetrieve<TData = Awaited<ReturnType<typeof activitiesRetrieve>>, TError = UnauthorizedResponse | ActivityDeclarationError | AccountGoneResponse>(
 assignmentUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły własnej aktywności
 */

export function useActivitiesRetrieve<TData = Awaited<ReturnType<typeof activitiesRetrieve>>, TError = UnauthorizedResponse | ActivityDeclarationError | AccountGoneResponse>(
 assignmentUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitiesRetrieveQueryOptions(assignmentUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activitiesDeclareResponse200 = {
  data: ActivityDeclarationResponse
  status: 200
}

export type activitiesDeclareResponse400 = {
  data: ActivityDeclarationError
  status: 400
}

export type activitiesDeclareResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activitiesDeclareResponse403 = {
  data: ActivityDeclarationError
  status: 403
}

export type activitiesDeclareResponse404 = {
  data: ActivityDeclarationError
  status: 404
}

export type activitiesDeclareResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesDeclareResponse422 = {
  data: ActivityDeclarationError
  status: 422
}

export type activitiesDeclareResponseSuccess = (activitiesDeclareResponse200) & {
  headers: Headers;
};
export type activitiesDeclareResponseError = (activitiesDeclareResponse400 | activitiesDeclareResponse401 | activitiesDeclareResponse403 | activitiesDeclareResponse404 | activitiesDeclareResponse410 | activitiesDeclareResponse422) & {
  headers: Headers;
};

export type activitiesDeclareResponse = (activitiesDeclareResponseSuccess | activitiesDeclareResponseError)

export const getActivitiesDeclareUrl = (assignmentUid: string,) => {




  return `/api/v1/activities/${assignmentUid}/declare/`
}

/**
 * @summary Deklaracja wykonania komponentu aktywności
 */
export const activitiesDeclare = async (assignmentUid: string,
    activityDeclarationRequest: ActivityDeclarationRequest, options?: RequestInit): Promise<activitiesDeclareResponse> => {

  return customFetch<activitiesDeclareResponse>(getActivitiesDeclareUrl(assignmentUid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(activityDeclarationRequest)
  }
);}




export const getActivitiesDeclareMutationOptions = <TError = ActivityDeclarationError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesDeclare>>, TError,{assignmentUid: string;data: ActivityDeclarationRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesDeclare>>, TError,{assignmentUid: string;data: ActivityDeclarationRequest}, TContext> => {

const mutationKey = ['activitiesDeclare'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesDeclare>>, {assignmentUid: string;data: ActivityDeclarationRequest}> = (props) => {
          const {assignmentUid,data} = props ?? {};

          return  activitiesDeclare(assignmentUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesDeclareMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesDeclare>>>
    export type ActivitiesDeclareMutationBody = ActivityDeclarationRequest
    export type ActivitiesDeclareMutationError = ActivityDeclarationError | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Deklaracja wykonania komponentu aktywności
 */
export const useActivitiesDeclare = <TError = ActivityDeclarationError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesDeclare>>, TError,{assignmentUid: string;data: ActivityDeclarationRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesDeclare>>,
        TError,
        {assignmentUid: string;data: ActivityDeclarationRequest},
        TContext
      > => {
      return useMutation(getActivitiesDeclareMutationOptions(options), queryClient);
    }

export type activitiesAdminCapabilitiesRetrieveResponse200 = {
  data: AdminActivityCapabilities
  status: 200
}

export type activitiesAdminCapabilitiesRetrieveResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminCapabilitiesRetrieveResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminCapabilitiesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminCapabilitiesRetrieveResponseSuccess = (activitiesAdminCapabilitiesRetrieveResponse200) & {
  headers: Headers;
};
export type activitiesAdminCapabilitiesRetrieveResponseError = (activitiesAdminCapabilitiesRetrieveResponse401 | activitiesAdminCapabilitiesRetrieveResponse403 | activitiesAdminCapabilitiesRetrieveResponse410) & {
  headers: Headers;
};

export type activitiesAdminCapabilitiesRetrieveResponse = (activitiesAdminCapabilitiesRetrieveResponseSuccess | activitiesAdminCapabilitiesRetrieveResponseError)

export const getActivitiesAdminCapabilitiesRetrieveUrl = () => {




  return `/api/v1/activities/admin/capabilities/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminCapabilitiesRetrieve = async ( options?: RequestInit): Promise<activitiesAdminCapabilitiesRetrieveResponse> => {

  return customFetch<activitiesAdminCapabilitiesRetrieveResponse>(getActivitiesAdminCapabilitiesRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivitiesAdminCapabilitiesRetrieveQueryKey = () => {
    return [
    `/api/v1/activities/admin/capabilities/`
    ] as const;
    }


export const getActivitiesAdminCapabilitiesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError = AdminActivityError | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitiesAdminCapabilitiesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>> = ({ signal }) => activitiesAdminCapabilitiesRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitiesAdminCapabilitiesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>>
export type ActivitiesAdminCapabilitiesRetrieveQueryError = AdminActivityError | AccountGoneResponse


export function useActivitiesAdminCapabilitiesRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminCapabilitiesRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminCapabilitiesRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivitiesAdminCapabilitiesRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminCapabilitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitiesAdminCapabilitiesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activitiesAdminDefinitionsListResponse200 = {
  data: AdminActivityDefinitions
  status: 200
}

export type activitiesAdminDefinitionsListResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminDefinitionsListResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminDefinitionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminDefinitionsListResponseSuccess = (activitiesAdminDefinitionsListResponse200) & {
  headers: Headers;
};
export type activitiesAdminDefinitionsListResponseError = (activitiesAdminDefinitionsListResponse401 | activitiesAdminDefinitionsListResponse403 | activitiesAdminDefinitionsListResponse410) & {
  headers: Headers;
};

export type activitiesAdminDefinitionsListResponse = (activitiesAdminDefinitionsListResponseSuccess | activitiesAdminDefinitionsListResponseError)

export const getActivitiesAdminDefinitionsListUrl = (params?: ActivitiesAdminDefinitionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/activities/admin/definitions/?${stringifiedParams}` : `/api/v1/activities/admin/definitions/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminDefinitionsList = async (params?: ActivitiesAdminDefinitionsListParams, options?: RequestInit): Promise<activitiesAdminDefinitionsListResponse> => {

  return customFetch<activitiesAdminDefinitionsListResponse>(getActivitiesAdminDefinitionsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivitiesAdminDefinitionsListQueryKey = (params?: ActivitiesAdminDefinitionsListParams,) => {
    return [
    `/api/v1/activities/admin/definitions/`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivitiesAdminDefinitionsListQueryOptions = <TData = Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError = AdminActivityError | AccountGoneResponse>(params?: ActivitiesAdminDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitiesAdminDefinitionsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>> = ({ signal }) => activitiesAdminDefinitionsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitiesAdminDefinitionsListQueryResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>>
export type ActivitiesAdminDefinitionsListQueryError = AdminActivityError | AccountGoneResponse


export function useActivitiesAdminDefinitionsList<TData = Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError = AdminActivityError | AccountGoneResponse>(
 params: undefined |  ActivitiesAdminDefinitionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminDefinitionsList<TData = Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError = AdminActivityError | AccountGoneResponse>(
 params?: ActivitiesAdminDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminDefinitionsList<TData = Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError = AdminActivityError | AccountGoneResponse>(
 params?: ActivitiesAdminDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivitiesAdminDefinitionsList<TData = Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError = AdminActivityError | AccountGoneResponse>(
 params?: ActivitiesAdminDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitiesAdminDefinitionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activitiesAdminDefinitionsCreateResponse201 = {
  data: AdminActivityDefinition
  status: 201
}

export type activitiesAdminDefinitionsCreateResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminDefinitionsCreateResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminDefinitionsCreateResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminDefinitionsCreateResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminDefinitionsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminDefinitionsCreateResponse422 = {
  data: AdminActivityError
  status: 422
}

export type activitiesAdminDefinitionsCreateResponseSuccess = (activitiesAdminDefinitionsCreateResponse201) & {
  headers: Headers;
};
export type activitiesAdminDefinitionsCreateResponseError = (activitiesAdminDefinitionsCreateResponse401 | activitiesAdminDefinitionsCreateResponse403 | activitiesAdminDefinitionsCreateResponse404 | activitiesAdminDefinitionsCreateResponse409 | activitiesAdminDefinitionsCreateResponse410 | activitiesAdminDefinitionsCreateResponse422) & {
  headers: Headers;
};

export type activitiesAdminDefinitionsCreateResponse = (activitiesAdminDefinitionsCreateResponseSuccess | activitiesAdminDefinitionsCreateResponseError)

export const getActivitiesAdminDefinitionsCreateUrl = () => {




  return `/api/v1/activities/admin/definitions/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminDefinitionsCreate = async (adminActivityDefinitionCreateRequest: AdminActivityDefinitionCreateRequest, options?: RequestInit): Promise<activitiesAdminDefinitionsCreateResponse> => {

  return customFetch<activitiesAdminDefinitionsCreateResponse>(getActivitiesAdminDefinitionsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminActivityDefinitionCreateRequest)
  }
);}




export const getActivitiesAdminDefinitionsCreateMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsCreate>>, TError,{data: AdminActivityDefinitionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsCreate>>, TError,{data: AdminActivityDefinitionCreateRequest}, TContext> => {

const mutationKey = ['activitiesAdminDefinitionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminDefinitionsCreate>>, {data: AdminActivityDefinitionCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  activitiesAdminDefinitionsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminDefinitionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminDefinitionsCreate>>>
    export type ActivitiesAdminDefinitionsCreateMutationBody = AdminActivityDefinitionCreateRequest
    export type ActivitiesAdminDefinitionsCreateMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminDefinitionsCreate = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsCreate>>, TError,{data: AdminActivityDefinitionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminDefinitionsCreate>>,
        TError,
        {data: AdminActivityDefinitionCreateRequest},
        TContext
      > => {
      return useMutation(getActivitiesAdminDefinitionsCreateMutationOptions(options), queryClient);
    }

export type activitiesAdminDefinitionsRetrieveResponse200 = {
  data: AdminActivityDefinition
  status: 200
}

export type activitiesAdminDefinitionsRetrieveResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminDefinitionsRetrieveResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminDefinitionsRetrieveResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminDefinitionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminDefinitionsRetrieveResponseSuccess = (activitiesAdminDefinitionsRetrieveResponse200) & {
  headers: Headers;
};
export type activitiesAdminDefinitionsRetrieveResponseError = (activitiesAdminDefinitionsRetrieveResponse401 | activitiesAdminDefinitionsRetrieveResponse403 | activitiesAdminDefinitionsRetrieveResponse404 | activitiesAdminDefinitionsRetrieveResponse410) & {
  headers: Headers;
};

export type activitiesAdminDefinitionsRetrieveResponse = (activitiesAdminDefinitionsRetrieveResponseSuccess | activitiesAdminDefinitionsRetrieveResponseError)

export const getActivitiesAdminDefinitionsRetrieveUrl = (definitionUid: string,) => {




  return `/api/v1/activities/admin/definitions/${definitionUid}/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminDefinitionsRetrieve = async (definitionUid: string, options?: RequestInit): Promise<activitiesAdminDefinitionsRetrieveResponse> => {

  return customFetch<activitiesAdminDefinitionsRetrieveResponse>(getActivitiesAdminDefinitionsRetrieveUrl(definitionUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivitiesAdminDefinitionsRetrieveQueryKey = (definitionUid: string,) => {
    return [
    `/api/v1/activities/admin/definitions/${definitionUid}/`
    ] as const;
    }


export const getActivitiesAdminDefinitionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(definitionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitiesAdminDefinitionsRetrieveQueryKey(definitionUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>> = ({ signal }) => activitiesAdminDefinitionsRetrieve(definitionUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: definitionUid !== null && definitionUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitiesAdminDefinitionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>>
export type ActivitiesAdminDefinitionsRetrieveQueryError = AdminActivityError | AccountGoneResponse


export function useActivitiesAdminDefinitionsRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminDefinitionsRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminDefinitionsRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivitiesAdminDefinitionsRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminDefinitionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitiesAdminDefinitionsRetrieveQueryOptions(definitionUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activitiesAdminRevisionsListResponse200 = {
  data: AdminActivityRevisions
  status: 200
}

export type activitiesAdminRevisionsListResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminRevisionsListResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminRevisionsListResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminRevisionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminRevisionsListResponseSuccess = (activitiesAdminRevisionsListResponse200) & {
  headers: Headers;
};
export type activitiesAdminRevisionsListResponseError = (activitiesAdminRevisionsListResponse401 | activitiesAdminRevisionsListResponse403 | activitiesAdminRevisionsListResponse404 | activitiesAdminRevisionsListResponse410) & {
  headers: Headers;
};

export type activitiesAdminRevisionsListResponse = (activitiesAdminRevisionsListResponseSuccess | activitiesAdminRevisionsListResponseError)

export const getActivitiesAdminRevisionsListUrl = (definitionUid: string,) => {




  return `/api/v1/activities/admin/definitions/${definitionUid}/revisions/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminRevisionsList = async (definitionUid: string, options?: RequestInit): Promise<activitiesAdminRevisionsListResponse> => {

  return customFetch<activitiesAdminRevisionsListResponse>(getActivitiesAdminRevisionsListUrl(definitionUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivitiesAdminRevisionsListQueryKey = (definitionUid: string,) => {
    return [
    `/api/v1/activities/admin/definitions/${definitionUid}/revisions/`
    ] as const;
    }


export const getActivitiesAdminRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError = AdminActivityError | AccountGoneResponse>(definitionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitiesAdminRevisionsListQueryKey(definitionUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitiesAdminRevisionsList>>> = ({ signal }) => activitiesAdminRevisionsList(definitionUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: definitionUid !== null && definitionUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitiesAdminRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminRevisionsList>>>
export type ActivitiesAdminRevisionsListQueryError = AdminActivityError | AccountGoneResponse


export function useActivitiesAdminRevisionsList<TData = Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminRevisionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminRevisionsList<TData = Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminRevisionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminRevisionsList<TData = Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivitiesAdminRevisionsList<TData = Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitiesAdminRevisionsListQueryOptions(definitionUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activitiesAdminRevisionsCreateResponse201 = {
  data: AdminActivityRevision
  status: 201
}

export type activitiesAdminRevisionsCreateResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminRevisionsCreateResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminRevisionsCreateResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminRevisionsCreateResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminRevisionsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminRevisionsCreateResponse422 = {
  data: AdminActivityError
  status: 422
}

export type activitiesAdminRevisionsCreateResponseSuccess = (activitiesAdminRevisionsCreateResponse201) & {
  headers: Headers;
};
export type activitiesAdminRevisionsCreateResponseError = (activitiesAdminRevisionsCreateResponse401 | activitiesAdminRevisionsCreateResponse403 | activitiesAdminRevisionsCreateResponse404 | activitiesAdminRevisionsCreateResponse409 | activitiesAdminRevisionsCreateResponse410 | activitiesAdminRevisionsCreateResponse422) & {
  headers: Headers;
};

export type activitiesAdminRevisionsCreateResponse = (activitiesAdminRevisionsCreateResponseSuccess | activitiesAdminRevisionsCreateResponseError)

export const getActivitiesAdminRevisionsCreateUrl = (definitionUid: string,) => {




  return `/api/v1/activities/admin/definitions/${definitionUid}/revisions/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminRevisionsCreate = async (definitionUid: string,
    adminActivityRevisionCreateRequest: AdminActivityRevisionCreateRequest, options?: RequestInit): Promise<activitiesAdminRevisionsCreateResponse> => {

  return customFetch<activitiesAdminRevisionsCreateResponse>(getActivitiesAdminRevisionsCreateUrl(definitionUid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminActivityRevisionCreateRequest)
  }
);}




export const getActivitiesAdminRevisionsCreateMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsCreate>>, TError,{definitionUid: string;data: AdminActivityRevisionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsCreate>>, TError,{definitionUid: string;data: AdminActivityRevisionCreateRequest}, TContext> => {

const mutationKey = ['activitiesAdminRevisionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminRevisionsCreate>>, {definitionUid: string;data: AdminActivityRevisionCreateRequest}> = (props) => {
          const {definitionUid,data} = props ?? {};

          return  activitiesAdminRevisionsCreate(definitionUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminRevisionsCreate>>>
    export type ActivitiesAdminRevisionsCreateMutationBody = AdminActivityRevisionCreateRequest
    export type ActivitiesAdminRevisionsCreateMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminRevisionsCreate = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsCreate>>, TError,{definitionUid: string;data: AdminActivityRevisionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminRevisionsCreate>>,
        TError,
        {definitionUid: string;data: AdminActivityRevisionCreateRequest},
        TContext
      > => {
      return useMutation(getActivitiesAdminRevisionsCreateMutationOptions(options), queryClient);
    }

export type activitiesAdminRevisionsRetrieveResponse200 = {
  data: AdminActivityRevision
  status: 200
}

export type activitiesAdminRevisionsRetrieveResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminRevisionsRetrieveResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminRevisionsRetrieveResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminRevisionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminRevisionsRetrieveResponseSuccess = (activitiesAdminRevisionsRetrieveResponse200) & {
  headers: Headers;
};
export type activitiesAdminRevisionsRetrieveResponseError = (activitiesAdminRevisionsRetrieveResponse401 | activitiesAdminRevisionsRetrieveResponse403 | activitiesAdminRevisionsRetrieveResponse404 | activitiesAdminRevisionsRetrieveResponse410) & {
  headers: Headers;
};

export type activitiesAdminRevisionsRetrieveResponse = (activitiesAdminRevisionsRetrieveResponseSuccess | activitiesAdminRevisionsRetrieveResponseError)

export const getActivitiesAdminRevisionsRetrieveUrl = (definitionUid: string,
    number: number,) => {




  return `/api/v1/activities/admin/definitions/${definitionUid}/revisions/${number}/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminRevisionsRetrieve = async (definitionUid: string,
    number: number, options?: RequestInit): Promise<activitiesAdminRevisionsRetrieveResponse> => {

  return customFetch<activitiesAdminRevisionsRetrieveResponse>(getActivitiesAdminRevisionsRetrieveUrl(definitionUid,number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivitiesAdminRevisionsRetrieveQueryKey = (definitionUid: string,
    number: number,) => {
    return [
    `/api/v1/activities/admin/definitions/${definitionUid}/revisions/${number}/`
    ] as const;
    }


export const getActivitiesAdminRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(definitionUid: string,
    number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitiesAdminRevisionsRetrieveQueryKey(definitionUid,number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>> = ({ signal }) => activitiesAdminRevisionsRetrieve(definitionUid,number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: definitionUid !== null && definitionUid !== undefined && number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitiesAdminRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>>
export type ActivitiesAdminRevisionsRetrieveQueryError = AdminActivityError | AccountGoneResponse


export function useActivitiesAdminRevisionsRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string,
    number: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminRevisionsRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string,
    number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminRevisionsRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string,
    number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivitiesAdminRevisionsRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
 definitionUid: string,
    number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitiesAdminRevisionsRetrieveQueryOptions(definitionUid,number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activitiesAdminRevisionsReplaceResponse200 = {
  data: AdminActivityRevision
  status: 200
}

export type activitiesAdminRevisionsReplaceResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminRevisionsReplaceResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminRevisionsReplaceResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminRevisionsReplaceResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminRevisionsReplaceResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminRevisionsReplaceResponse422 = {
  data: AdminActivityError
  status: 422
}

export type activitiesAdminRevisionsReplaceResponseSuccess = (activitiesAdminRevisionsReplaceResponse200) & {
  headers: Headers;
};
export type activitiesAdminRevisionsReplaceResponseError = (activitiesAdminRevisionsReplaceResponse401 | activitiesAdminRevisionsReplaceResponse403 | activitiesAdminRevisionsReplaceResponse404 | activitiesAdminRevisionsReplaceResponse409 | activitiesAdminRevisionsReplaceResponse410 | activitiesAdminRevisionsReplaceResponse422) & {
  headers: Headers;
};

export type activitiesAdminRevisionsReplaceResponse = (activitiesAdminRevisionsReplaceResponseSuccess | activitiesAdminRevisionsReplaceResponseError)

export const getActivitiesAdminRevisionsReplaceUrl = (definitionUid: string,
    number: number,) => {




  return `/api/v1/activities/admin/definitions/${definitionUid}/revisions/${number}/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminRevisionsReplace = async (definitionUid: string,
    number: number,
    adminActivityRevisionUpdateRequest: AdminActivityRevisionUpdateRequest, options?: RequestInit): Promise<activitiesAdminRevisionsReplaceResponse> => {

  return customFetch<activitiesAdminRevisionsReplaceResponse>(getActivitiesAdminRevisionsReplaceUrl(definitionUid,number),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminActivityRevisionUpdateRequest)
  }
);}




export const getActivitiesAdminRevisionsReplaceMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsReplace>>, TError,{definitionUid: string;number: number;data: AdminActivityRevisionUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsReplace>>, TError,{definitionUid: string;number: number;data: AdminActivityRevisionUpdateRequest}, TContext> => {

const mutationKey = ['activitiesAdminRevisionsReplace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminRevisionsReplace>>, {definitionUid: string;number: number;data: AdminActivityRevisionUpdateRequest}> = (props) => {
          const {definitionUid,number,data} = props ?? {};

          return  activitiesAdminRevisionsReplace(definitionUid,number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminRevisionsReplaceMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminRevisionsReplace>>>
    export type ActivitiesAdminRevisionsReplaceMutationBody = AdminActivityRevisionUpdateRequest
    export type ActivitiesAdminRevisionsReplaceMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminRevisionsReplace = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsReplace>>, TError,{definitionUid: string;number: number;data: AdminActivityRevisionUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminRevisionsReplace>>,
        TError,
        {definitionUid: string;number: number;data: AdminActivityRevisionUpdateRequest},
        TContext
      > => {
      return useMutation(getActivitiesAdminRevisionsReplaceMutationOptions(options), queryClient);
    }

export type activitiesAdminRevisionsPartialUpdateResponse200 = {
  data: AdminActivityRevision
  status: 200
}

export type activitiesAdminRevisionsPartialUpdateResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminRevisionsPartialUpdateResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminRevisionsPartialUpdateResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminRevisionsPartialUpdateResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminRevisionsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminRevisionsPartialUpdateResponse422 = {
  data: AdminActivityError
  status: 422
}

export type activitiesAdminRevisionsPartialUpdateResponseSuccess = (activitiesAdminRevisionsPartialUpdateResponse200) & {
  headers: Headers;
};
export type activitiesAdminRevisionsPartialUpdateResponseError = (activitiesAdminRevisionsPartialUpdateResponse401 | activitiesAdminRevisionsPartialUpdateResponse403 | activitiesAdminRevisionsPartialUpdateResponse404 | activitiesAdminRevisionsPartialUpdateResponse409 | activitiesAdminRevisionsPartialUpdateResponse410 | activitiesAdminRevisionsPartialUpdateResponse422) & {
  headers: Headers;
};

export type activitiesAdminRevisionsPartialUpdateResponse = (activitiesAdminRevisionsPartialUpdateResponseSuccess | activitiesAdminRevisionsPartialUpdateResponseError)

export const getActivitiesAdminRevisionsPartialUpdateUrl = (definitionUid: string,
    number: number,) => {




  return `/api/v1/activities/admin/definitions/${definitionUid}/revisions/${number}/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminRevisionsPartialUpdate = async (definitionUid: string,
    number: number,
    patchedAdminActivityRevisionUpdateRequest?: PatchedAdminActivityRevisionUpdateRequest, options?: RequestInit): Promise<activitiesAdminRevisionsPartialUpdateResponse> => {

  return customFetch<activitiesAdminRevisionsPartialUpdateResponse>(getActivitiesAdminRevisionsPartialUpdateUrl(definitionUid,number),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminActivityRevisionUpdateRequest)
  }
);}




export const getActivitiesAdminRevisionsPartialUpdateMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsPartialUpdate>>, TError,{definitionUid: string;number: number;data?: PatchedAdminActivityRevisionUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsPartialUpdate>>, TError,{definitionUid: string;number: number;data?: PatchedAdminActivityRevisionUpdateRequest}, TContext> => {

const mutationKey = ['activitiesAdminRevisionsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminRevisionsPartialUpdate>>, {definitionUid: string;number: number;data?: PatchedAdminActivityRevisionUpdateRequest}> = (props) => {
          const {definitionUid,number,data} = props ?? {};

          return  activitiesAdminRevisionsPartialUpdate(definitionUid,number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminRevisionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminRevisionsPartialUpdate>>>
    export type ActivitiesAdminRevisionsPartialUpdateMutationBody = PatchedAdminActivityRevisionUpdateRequest | undefined
    export type ActivitiesAdminRevisionsPartialUpdateMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminRevisionsPartialUpdate = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsPartialUpdate>>, TError,{definitionUid: string;number: number;data?: PatchedAdminActivityRevisionUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminRevisionsPartialUpdate>>,
        TError,
        {definitionUid: string;number: number;data?: PatchedAdminActivityRevisionUpdateRequest},
        TContext
      > => {
      return useMutation(getActivitiesAdminRevisionsPartialUpdateMutationOptions(options), queryClient);
    }

export type activitiesAdminRevisionsDestroyResponse204 = {
  data: void
  status: 204
}

export type activitiesAdminRevisionsDestroyResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminRevisionsDestroyResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminRevisionsDestroyResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminRevisionsDestroyResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminRevisionsDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminRevisionsDestroyResponseSuccess = (activitiesAdminRevisionsDestroyResponse204) & {
  headers: Headers;
};
export type activitiesAdminRevisionsDestroyResponseError = (activitiesAdminRevisionsDestroyResponse401 | activitiesAdminRevisionsDestroyResponse403 | activitiesAdminRevisionsDestroyResponse404 | activitiesAdminRevisionsDestroyResponse409 | activitiesAdminRevisionsDestroyResponse410) & {
  headers: Headers;
};

export type activitiesAdminRevisionsDestroyResponse = (activitiesAdminRevisionsDestroyResponseSuccess | activitiesAdminRevisionsDestroyResponseError)

export const getActivitiesAdminRevisionsDestroyUrl = (definitionUid: string,
    number: number,) => {




  return `/api/v1/activities/admin/definitions/${definitionUid}/revisions/${number}/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminRevisionsDestroy = async (definitionUid: string,
    number: number, options?: RequestInit): Promise<activitiesAdminRevisionsDestroyResponse> => {

  return customFetch<activitiesAdminRevisionsDestroyResponse>(getActivitiesAdminRevisionsDestroyUrl(definitionUid,number),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getActivitiesAdminRevisionsDestroyMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsDestroy>>, TError,{definitionUid: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsDestroy>>, TError,{definitionUid: string;number: number}, TContext> => {

const mutationKey = ['activitiesAdminRevisionsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminRevisionsDestroy>>, {definitionUid: string;number: number}> = (props) => {
          const {definitionUid,number} = props ?? {};

          return  activitiesAdminRevisionsDestroy(definitionUid,number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminRevisionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminRevisionsDestroy>>>

    export type ActivitiesAdminRevisionsDestroyMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminRevisionsDestroy = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsDestroy>>, TError,{definitionUid: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminRevisionsDestroy>>,
        TError,
        {definitionUid: string;number: number},
        TContext
      > => {
      return useMutation(getActivitiesAdminRevisionsDestroyMutationOptions(options), queryClient);
    }

export type activitiesAdminRevisionsPublishResponse200 = {
  data: AdminActivityRevision
  status: 200
}

export type activitiesAdminRevisionsPublishResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminRevisionsPublishResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminRevisionsPublishResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminRevisionsPublishResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminRevisionsPublishResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminRevisionsPublishResponse422 = {
  data: AdminActivityError
  status: 422
}

export type activitiesAdminRevisionsPublishResponseSuccess = (activitiesAdminRevisionsPublishResponse200) & {
  headers: Headers;
};
export type activitiesAdminRevisionsPublishResponseError = (activitiesAdminRevisionsPublishResponse401 | activitiesAdminRevisionsPublishResponse403 | activitiesAdminRevisionsPublishResponse404 | activitiesAdminRevisionsPublishResponse409 | activitiesAdminRevisionsPublishResponse410 | activitiesAdminRevisionsPublishResponse422) & {
  headers: Headers;
};

export type activitiesAdminRevisionsPublishResponse = (activitiesAdminRevisionsPublishResponseSuccess | activitiesAdminRevisionsPublishResponseError)

export const getActivitiesAdminRevisionsPublishUrl = (definitionUid: string,
    number: number,) => {




  return `/api/v1/activities/admin/definitions/${definitionUid}/revisions/${number}/publish/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminRevisionsPublish = async (definitionUid: string,
    number: number, options?: RequestInit): Promise<activitiesAdminRevisionsPublishResponse> => {

  return customFetch<activitiesAdminRevisionsPublishResponse>(getActivitiesAdminRevisionsPublishUrl(definitionUid,number),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivitiesAdminRevisionsPublishMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsPublish>>, TError,{definitionUid: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsPublish>>, TError,{definitionUid: string;number: number}, TContext> => {

const mutationKey = ['activitiesAdminRevisionsPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminRevisionsPublish>>, {definitionUid: string;number: number}> = (props) => {
          const {definitionUid,number} = props ?? {};

          return  activitiesAdminRevisionsPublish(definitionUid,number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminRevisionsPublishMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminRevisionsPublish>>>

    export type ActivitiesAdminRevisionsPublishMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminRevisionsPublish = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsPublish>>, TError,{definitionUid: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminRevisionsPublish>>,
        TError,
        {definitionUid: string;number: number},
        TContext
      > => {
      return useMutation(getActivitiesAdminRevisionsPublishMutationOptions(options), queryClient);
    }

export type activitiesAdminRevisionsWithdrawResponse200 = {
  data: AdminActivityRevision
  status: 200
}

export type activitiesAdminRevisionsWithdrawResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminRevisionsWithdrawResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminRevisionsWithdrawResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminRevisionsWithdrawResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminRevisionsWithdrawResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminRevisionsWithdrawResponse422 = {
  data: AdminActivityError
  status: 422
}

export type activitiesAdminRevisionsWithdrawResponseSuccess = (activitiesAdminRevisionsWithdrawResponse200) & {
  headers: Headers;
};
export type activitiesAdminRevisionsWithdrawResponseError = (activitiesAdminRevisionsWithdrawResponse401 | activitiesAdminRevisionsWithdrawResponse403 | activitiesAdminRevisionsWithdrawResponse404 | activitiesAdminRevisionsWithdrawResponse409 | activitiesAdminRevisionsWithdrawResponse410 | activitiesAdminRevisionsWithdrawResponse422) & {
  headers: Headers;
};

export type activitiesAdminRevisionsWithdrawResponse = (activitiesAdminRevisionsWithdrawResponseSuccess | activitiesAdminRevisionsWithdrawResponseError)

export const getActivitiesAdminRevisionsWithdrawUrl = (definitionUid: string,
    number: number,) => {




  return `/api/v1/activities/admin/definitions/${definitionUid}/revisions/${number}/withdraw/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminRevisionsWithdraw = async (definitionUid: string,
    number: number, options?: RequestInit): Promise<activitiesAdminRevisionsWithdrawResponse> => {

  return customFetch<activitiesAdminRevisionsWithdrawResponse>(getActivitiesAdminRevisionsWithdrawUrl(definitionUid,number),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivitiesAdminRevisionsWithdrawMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsWithdraw>>, TError,{definitionUid: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsWithdraw>>, TError,{definitionUid: string;number: number}, TContext> => {

const mutationKey = ['activitiesAdminRevisionsWithdraw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminRevisionsWithdraw>>, {definitionUid: string;number: number}> = (props) => {
          const {definitionUid,number} = props ?? {};

          return  activitiesAdminRevisionsWithdraw(definitionUid,number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminRevisionsWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminRevisionsWithdraw>>>

    export type ActivitiesAdminRevisionsWithdrawMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminRevisionsWithdraw = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminRevisionsWithdraw>>, TError,{definitionUid: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminRevisionsWithdraw>>,
        TError,
        {definitionUid: string;number: number},
        TContext
      > => {
      return useMutation(getActivitiesAdminRevisionsWithdrawMutationOptions(options), queryClient);
    }

export type activitiesAdminSeasonalCampaignsListResponse200 = {
  data: AdminSeasonalCampaigns
  status: 200
}

export type activitiesAdminSeasonalCampaignsListResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminSeasonalCampaignsListResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminSeasonalCampaignsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminSeasonalCampaignsListResponseSuccess = (activitiesAdminSeasonalCampaignsListResponse200) & {
  headers: Headers;
};
export type activitiesAdminSeasonalCampaignsListResponseError = (activitiesAdminSeasonalCampaignsListResponse401 | activitiesAdminSeasonalCampaignsListResponse403 | activitiesAdminSeasonalCampaignsListResponse410) & {
  headers: Headers;
};

export type activitiesAdminSeasonalCampaignsListResponse = (activitiesAdminSeasonalCampaignsListResponseSuccess | activitiesAdminSeasonalCampaignsListResponseError)

export const getActivitiesAdminSeasonalCampaignsListUrl = () => {




  return `/api/v1/activities/admin/seasonal-campaigns/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminSeasonalCampaignsList = async ( options?: RequestInit): Promise<activitiesAdminSeasonalCampaignsListResponse> => {

  return customFetch<activitiesAdminSeasonalCampaignsListResponse>(getActivitiesAdminSeasonalCampaignsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivitiesAdminSeasonalCampaignsListQueryKey = () => {
    return [
    `/api/v1/activities/admin/seasonal-campaigns/`
    ] as const;
    }


export const getActivitiesAdminSeasonalCampaignsListQueryOptions = <TData = Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError = AdminActivityError | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitiesAdminSeasonalCampaignsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>> = ({ signal }) => activitiesAdminSeasonalCampaignsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitiesAdminSeasonalCampaignsListQueryResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>>
export type ActivitiesAdminSeasonalCampaignsListQueryError = AdminActivityError | AccountGoneResponse


export function useActivitiesAdminSeasonalCampaignsList<TData = Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError = AdminActivityError | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminSeasonalCampaignsList<TData = Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError = AdminActivityError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminSeasonalCampaignsList<TData = Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError = AdminActivityError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivitiesAdminSeasonalCampaignsList<TData = Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError = AdminActivityError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitiesAdminSeasonalCampaignsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activitiesAdminSeasonalCampaignsCreateResponse201 = {
  data: AdminSeasonalCampaign
  status: 201
}

export type activitiesAdminSeasonalCampaignsCreateResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminSeasonalCampaignsCreateResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminSeasonalCampaignsCreateResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminSeasonalCampaignsCreateResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminSeasonalCampaignsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminSeasonalCampaignsCreateResponse422 = {
  data: AdminActivityError
  status: 422
}

export type activitiesAdminSeasonalCampaignsCreateResponseSuccess = (activitiesAdminSeasonalCampaignsCreateResponse201) & {
  headers: Headers;
};
export type activitiesAdminSeasonalCampaignsCreateResponseError = (activitiesAdminSeasonalCampaignsCreateResponse401 | activitiesAdminSeasonalCampaignsCreateResponse403 | activitiesAdminSeasonalCampaignsCreateResponse404 | activitiesAdminSeasonalCampaignsCreateResponse409 | activitiesAdminSeasonalCampaignsCreateResponse410 | activitiesAdminSeasonalCampaignsCreateResponse422) & {
  headers: Headers;
};

export type activitiesAdminSeasonalCampaignsCreateResponse = (activitiesAdminSeasonalCampaignsCreateResponseSuccess | activitiesAdminSeasonalCampaignsCreateResponseError)

export const getActivitiesAdminSeasonalCampaignsCreateUrl = () => {




  return `/api/v1/activities/admin/seasonal-campaigns/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminSeasonalCampaignsCreate = async (adminSeasonalCampaignCreateRequest: AdminSeasonalCampaignCreateRequest, options?: RequestInit): Promise<activitiesAdminSeasonalCampaignsCreateResponse> => {

  return customFetch<activitiesAdminSeasonalCampaignsCreateResponse>(getActivitiesAdminSeasonalCampaignsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminSeasonalCampaignCreateRequest)
  }
);}




export const getActivitiesAdminSeasonalCampaignsCreateMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsCreate>>, TError,{data: AdminSeasonalCampaignCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsCreate>>, TError,{data: AdminSeasonalCampaignCreateRequest}, TContext> => {

const mutationKey = ['activitiesAdminSeasonalCampaignsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsCreate>>, {data: AdminSeasonalCampaignCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  activitiesAdminSeasonalCampaignsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminSeasonalCampaignsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsCreate>>>
    export type ActivitiesAdminSeasonalCampaignsCreateMutationBody = AdminSeasonalCampaignCreateRequest
    export type ActivitiesAdminSeasonalCampaignsCreateMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminSeasonalCampaignsCreate = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsCreate>>, TError,{data: AdminSeasonalCampaignCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsCreate>>,
        TError,
        {data: AdminSeasonalCampaignCreateRequest},
        TContext
      > => {
      return useMutation(getActivitiesAdminSeasonalCampaignsCreateMutationOptions(options), queryClient);
    }

export type activitiesAdminSeasonalCampaignsWithdrawResponse200 = {
  data: AdminSeasonalCampaign
  status: 200
}

export type activitiesAdminSeasonalCampaignsWithdrawResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminSeasonalCampaignsWithdrawResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminSeasonalCampaignsWithdrawResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminSeasonalCampaignsWithdrawResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminSeasonalCampaignsWithdrawResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminSeasonalCampaignsWithdrawResponseSuccess = (activitiesAdminSeasonalCampaignsWithdrawResponse200) & {
  headers: Headers;
};
export type activitiesAdminSeasonalCampaignsWithdrawResponseError = (activitiesAdminSeasonalCampaignsWithdrawResponse401 | activitiesAdminSeasonalCampaignsWithdrawResponse403 | activitiesAdminSeasonalCampaignsWithdrawResponse404 | activitiesAdminSeasonalCampaignsWithdrawResponse409 | activitiesAdminSeasonalCampaignsWithdrawResponse410) & {
  headers: Headers;
};

export type activitiesAdminSeasonalCampaignsWithdrawResponse = (activitiesAdminSeasonalCampaignsWithdrawResponseSuccess | activitiesAdminSeasonalCampaignsWithdrawResponseError)

export const getActivitiesAdminSeasonalCampaignsWithdrawUrl = (campaignUid: string,) => {




  return `/api/v1/activities/admin/seasonal-campaigns/${campaignUid}/withdraw/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminSeasonalCampaignsWithdraw = async (campaignUid: string, options?: RequestInit): Promise<activitiesAdminSeasonalCampaignsWithdrawResponse> => {

  return customFetch<activitiesAdminSeasonalCampaignsWithdrawResponse>(getActivitiesAdminSeasonalCampaignsWithdrawUrl(campaignUid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivitiesAdminSeasonalCampaignsWithdrawMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsWithdraw>>, TError,{campaignUid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsWithdraw>>, TError,{campaignUid: string}, TContext> => {

const mutationKey = ['activitiesAdminSeasonalCampaignsWithdraw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsWithdraw>>, {campaignUid: string}> = (props) => {
          const {campaignUid} = props ?? {};

          return  activitiesAdminSeasonalCampaignsWithdraw(campaignUid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminSeasonalCampaignsWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsWithdraw>>>

    export type ActivitiesAdminSeasonalCampaignsWithdrawMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminSeasonalCampaignsWithdraw = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsWithdraw>>, TError,{campaignUid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminSeasonalCampaignsWithdraw>>,
        TError,
        {campaignUid: string},
        TContext
      > => {
      return useMutation(getActivitiesAdminSeasonalCampaignsWithdrawMutationOptions(options), queryClient);
    }

export type activitiesAdminWeeklyPublicationRetrieveResponse200 = {
  data: AdminWeeklyOverview
  status: 200
}

export type activitiesAdminWeeklyPublicationRetrieveResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminWeeklyPublicationRetrieveResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminWeeklyPublicationRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminWeeklyPublicationRetrieveResponseSuccess = (activitiesAdminWeeklyPublicationRetrieveResponse200) & {
  headers: Headers;
};
export type activitiesAdminWeeklyPublicationRetrieveResponseError = (activitiesAdminWeeklyPublicationRetrieveResponse401 | activitiesAdminWeeklyPublicationRetrieveResponse403 | activitiesAdminWeeklyPublicationRetrieveResponse410) & {
  headers: Headers;
};

export type activitiesAdminWeeklyPublicationRetrieveResponse = (activitiesAdminWeeklyPublicationRetrieveResponseSuccess | activitiesAdminWeeklyPublicationRetrieveResponseError)

export const getActivitiesAdminWeeklyPublicationRetrieveUrl = () => {




  return `/api/v1/activities/admin/weekly-publication/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminWeeklyPublicationRetrieve = async ( options?: RequestInit): Promise<activitiesAdminWeeklyPublicationRetrieveResponse> => {

  return customFetch<activitiesAdminWeeklyPublicationRetrieveResponse>(getActivitiesAdminWeeklyPublicationRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivitiesAdminWeeklyPublicationRetrieveQueryKey = () => {
    return [
    `/api/v1/activities/admin/weekly-publication/`
    ] as const;
    }


export const getActivitiesAdminWeeklyPublicationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError = AdminActivityError | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitiesAdminWeeklyPublicationRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>> = ({ signal }) => activitiesAdminWeeklyPublicationRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitiesAdminWeeklyPublicationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>>
export type ActivitiesAdminWeeklyPublicationRetrieveQueryError = AdminActivityError | AccountGoneResponse


export function useActivitiesAdminWeeklyPublicationRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminWeeklyPublicationRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesAdminWeeklyPublicationRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivitiesAdminWeeklyPublicationRetrieve<TData = Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError = AdminActivityError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitiesAdminWeeklyPublicationRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activitiesAdminWeeklyPublicationPublishResponse200 = {
  data: AdminWeeklySet
  status: 200
}

export type activitiesAdminWeeklyPublicationPublishResponse201 = {
  data: AdminWeeklyPublication
  status: 201
}

export type activitiesAdminWeeklyPublicationPublishResponse400 = {
  data: AdminActivityError
  status: 400
}

export type activitiesAdminWeeklyPublicationPublishResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminWeeklyPublicationPublishResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminWeeklyPublicationPublishResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminWeeklyPublicationPublishResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminWeeklyPublicationPublishResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminWeeklyPublicationPublishResponse422 = {
  data: AdminActivityError
  status: 422
}

export type activitiesAdminWeeklyPublicationPublishResponseSuccess = (activitiesAdminWeeklyPublicationPublishResponse200 | activitiesAdminWeeklyPublicationPublishResponse201) & {
  headers: Headers;
};
export type activitiesAdminWeeklyPublicationPublishResponseError = (activitiesAdminWeeklyPublicationPublishResponse400 | activitiesAdminWeeklyPublicationPublishResponse401 | activitiesAdminWeeklyPublicationPublishResponse403 | activitiesAdminWeeklyPublicationPublishResponse404 | activitiesAdminWeeklyPublicationPublishResponse409 | activitiesAdminWeeklyPublicationPublishResponse410 | activitiesAdminWeeklyPublicationPublishResponse422) & {
  headers: Headers;
};

export type activitiesAdminWeeklyPublicationPublishResponse = (activitiesAdminWeeklyPublicationPublishResponseSuccess | activitiesAdminWeeklyPublicationPublishResponseError)

export const getActivitiesAdminWeeklyPublicationPublishUrl = () => {




  return `/api/v1/activities/admin/weekly-publication/publish/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminWeeklyPublicationPublish = async (adminWeeklySetPublishRequest: AdminWeeklySetPublishRequest, options?: RequestInit): Promise<activitiesAdminWeeklyPublicationPublishResponse> => {

  return customFetch<activitiesAdminWeeklyPublicationPublishResponse>(getActivitiesAdminWeeklyPublicationPublishUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminWeeklySetPublishRequest)
  }
);}




export const getActivitiesAdminWeeklyPublicationPublishMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationPublish>>, TError,{data: AdminWeeklySetPublishRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationPublish>>, TError,{data: AdminWeeklySetPublishRequest}, TContext> => {

const mutationKey = ['activitiesAdminWeeklyPublicationPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationPublish>>, {data: AdminWeeklySetPublishRequest}> = (props) => {
          const {data} = props ?? {};

          return  activitiesAdminWeeklyPublicationPublish(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminWeeklyPublicationPublishMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationPublish>>>
    export type ActivitiesAdminWeeklyPublicationPublishMutationBody = AdminWeeklySetPublishRequest
    export type ActivitiesAdminWeeklyPublicationPublishMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminWeeklyPublicationPublish = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationPublish>>, TError,{data: AdminWeeklySetPublishRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationPublish>>,
        TError,
        {data: AdminWeeklySetPublishRequest},
        TContext
      > => {
      return useMutation(getActivitiesAdminWeeklyPublicationPublishMutationOptions(options), queryClient);
    }

export type activitiesAdminWeeklyPublicationLegacyWithdrawResponse200 = {
  data: AdminWeeklySet
  status: 200
}

export type activitiesAdminWeeklyPublicationLegacyWithdrawResponse400 = {
  data: AdminActivityError
  status: 400
}

export type activitiesAdminWeeklyPublicationLegacyWithdrawResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminWeeklyPublicationLegacyWithdrawResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminWeeklyPublicationLegacyWithdrawResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminWeeklyPublicationLegacyWithdrawResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminWeeklyPublicationLegacyWithdrawResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminWeeklyPublicationLegacyWithdrawResponse422 = {
  data: AdminActivityError
  status: 422
}

export type activitiesAdminWeeklyPublicationLegacyWithdrawResponseSuccess = (activitiesAdminWeeklyPublicationLegacyWithdrawResponse200) & {
  headers: Headers;
};
export type activitiesAdminWeeklyPublicationLegacyWithdrawResponseError = (activitiesAdminWeeklyPublicationLegacyWithdrawResponse400 | activitiesAdminWeeklyPublicationLegacyWithdrawResponse401 | activitiesAdminWeeklyPublicationLegacyWithdrawResponse403 | activitiesAdminWeeklyPublicationLegacyWithdrawResponse404 | activitiesAdminWeeklyPublicationLegacyWithdrawResponse409 | activitiesAdminWeeklyPublicationLegacyWithdrawResponse410 | activitiesAdminWeeklyPublicationLegacyWithdrawResponse422) & {
  headers: Headers;
};

export type activitiesAdminWeeklyPublicationLegacyWithdrawResponse = (activitiesAdminWeeklyPublicationLegacyWithdrawResponseSuccess | activitiesAdminWeeklyPublicationLegacyWithdrawResponseError)

export const getActivitiesAdminWeeklyPublicationLegacyWithdrawUrl = () => {




  return `/api/v1/activities/admin/weekly-publication/withdraw/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 * @deprecated
 */
export const activitiesAdminWeeklyPublicationLegacyWithdraw = async (adminWeeklySetWithdrawRequest: AdminWeeklySetWithdrawRequest, options?: RequestInit): Promise<activitiesAdminWeeklyPublicationLegacyWithdrawResponse> => {

  return customFetch<activitiesAdminWeeklyPublicationLegacyWithdrawResponse>(getActivitiesAdminWeeklyPublicationLegacyWithdrawUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminWeeklySetWithdrawRequest)
  }
);}




export const getActivitiesAdminWeeklyPublicationLegacyWithdrawMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationLegacyWithdraw>>, TError,{data: AdminWeeklySetWithdrawRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationLegacyWithdraw>>, TError,{data: AdminWeeklySetWithdrawRequest}, TContext> => {

const mutationKey = ['activitiesAdminWeeklyPublicationLegacyWithdraw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationLegacyWithdraw>>, {data: AdminWeeklySetWithdrawRequest}> = (props) => {
          const {data} = props ?? {};

          return  activitiesAdminWeeklyPublicationLegacyWithdraw(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminWeeklyPublicationLegacyWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationLegacyWithdraw>>>
    export type ActivitiesAdminWeeklyPublicationLegacyWithdrawMutationBody = AdminWeeklySetWithdrawRequest
    export type ActivitiesAdminWeeklyPublicationLegacyWithdrawMutationError = AdminActivityError | AccountGoneResponse

    /**
 * @deprecated
 */
export const useActivitiesAdminWeeklyPublicationLegacyWithdraw = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationLegacyWithdraw>>, TError,{data: AdminWeeklySetWithdrawRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationLegacyWithdraw>>,
        TError,
        {data: AdminWeeklySetWithdrawRequest},
        TContext
      > => {
      return useMutation(getActivitiesAdminWeeklyPublicationLegacyWithdrawMutationOptions(options), queryClient);
    }

export type activitiesAdminWeeklyPublicationWithdrawResponse200 = {
  data: AdminWeeklyPublication
  status: 200
}

export type activitiesAdminWeeklyPublicationWithdrawResponse400 = {
  data: AdminActivityError
  status: 400
}

export type activitiesAdminWeeklyPublicationWithdrawResponse401 = {
  data: AdminActivityError
  status: 401
}

export type activitiesAdminWeeklyPublicationWithdrawResponse403 = {
  data: AdminActivityError
  status: 403
}

export type activitiesAdminWeeklyPublicationWithdrawResponse404 = {
  data: AdminActivityError
  status: 404
}

export type activitiesAdminWeeklyPublicationWithdrawResponse409 = {
  data: AdminActivityError
  status: 409
}

export type activitiesAdminWeeklyPublicationWithdrawResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAdminWeeklyPublicationWithdrawResponse422 = {
  data: AdminActivityError
  status: 422
}

export type activitiesAdminWeeklyPublicationWithdrawResponseSuccess = (activitiesAdminWeeklyPublicationWithdrawResponse200) & {
  headers: Headers;
};
export type activitiesAdminWeeklyPublicationWithdrawResponseError = (activitiesAdminWeeklyPublicationWithdrawResponse400 | activitiesAdminWeeklyPublicationWithdrawResponse401 | activitiesAdminWeeklyPublicationWithdrawResponse403 | activitiesAdminWeeklyPublicationWithdrawResponse404 | activitiesAdminWeeklyPublicationWithdrawResponse409 | activitiesAdminWeeklyPublicationWithdrawResponse410 | activitiesAdminWeeklyPublicationWithdrawResponse422) & {
  headers: Headers;
};

export type activitiesAdminWeeklyPublicationWithdrawResponse = (activitiesAdminWeeklyPublicationWithdrawResponseSuccess | activitiesAdminWeeklyPublicationWithdrawResponseError)

export const getActivitiesAdminWeeklyPublicationWithdrawUrl = (publicationUid: string,) => {




  return `/api/v1/activities/admin/weekly-publications/${publicationUid}/withdraw/`
}

/**
 * Shared auth/error contract; reads are broader than all mutations.
 */
export const activitiesAdminWeeklyPublicationWithdraw = async (publicationUid: string, options?: RequestInit): Promise<activitiesAdminWeeklyPublicationWithdrawResponse> => {

  return customFetch<activitiesAdminWeeklyPublicationWithdrawResponse>(getActivitiesAdminWeeklyPublicationWithdrawUrl(publicationUid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivitiesAdminWeeklyPublicationWithdrawMutationOptions = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationWithdraw>>, TError,{publicationUid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationWithdraw>>, TError,{publicationUid: string}, TContext> => {

const mutationKey = ['activitiesAdminWeeklyPublicationWithdraw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationWithdraw>>, {publicationUid: string}> = (props) => {
          const {publicationUid} = props ?? {};

          return  activitiesAdminWeeklyPublicationWithdraw(publicationUid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAdminWeeklyPublicationWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationWithdraw>>>

    export type ActivitiesAdminWeeklyPublicationWithdrawMutationError = AdminActivityError | AccountGoneResponse

    export const useActivitiesAdminWeeklyPublicationWithdraw = <TError = AdminActivityError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationWithdraw>>, TError,{publicationUid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAdminWeeklyPublicationWithdraw>>,
        TError,
        {publicationUid: string},
        TContext
      > => {
      return useMutation(getActivitiesAdminWeeklyPublicationWithdrawMutationOptions(options), queryClient);
    }

export type activitiesCurrentResponse200 = {
  data: ActivityCurrentFeed
  status: 200
}

export type activitiesCurrentResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activitiesCurrentResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesCurrentResponseSuccess = (activitiesCurrentResponse200) & {
  headers: Headers;
};
export type activitiesCurrentResponseError = (activitiesCurrentResponse401 | activitiesCurrentResponse410) & {
  headers: Headers;
};

export type activitiesCurrentResponse = (activitiesCurrentResponseSuccess | activitiesCurrentResponseError)

export const getActivitiesCurrentUrl = (params: ActivitiesCurrentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/activities/current/?${stringifiedParams}` : `/api/v1/activities/current/`
}

/**
 * @summary Bieżące aktywności ucznia
 */
export const activitiesCurrent = async (params: ActivitiesCurrentParams, options?: RequestInit): Promise<activitiesCurrentResponse> => {

  return customFetch<activitiesCurrentResponse>(getActivitiesCurrentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivitiesCurrentQueryKey = (params?: ActivitiesCurrentParams,) => {
    return [
    `/api/v1/activities/current/`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivitiesCurrentQueryOptions = <TData = Awaited<ReturnType<typeof activitiesCurrent>>, TError = UnauthorizedResponse | AccountGoneResponse>(params: ActivitiesCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesCurrent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitiesCurrentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitiesCurrent>>> = ({ signal }) => activitiesCurrent(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitiesCurrent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitiesCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof activitiesCurrent>>>
export type ActivitiesCurrentQueryError = UnauthorizedResponse | AccountGoneResponse


export function useActivitiesCurrent<TData = Awaited<ReturnType<typeof activitiesCurrent>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: ActivitiesCurrentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesCurrent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesCurrent>>,
          TError,
          Awaited<ReturnType<typeof activitiesCurrent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesCurrent<TData = Awaited<ReturnType<typeof activitiesCurrent>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: ActivitiesCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesCurrent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitiesCurrent>>,
          TError,
          Awaited<ReturnType<typeof activitiesCurrent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitiesCurrent<TData = Awaited<ReturnType<typeof activitiesCurrent>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: ActivitiesCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesCurrent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Bieżące aktywności ucznia
 */

export function useActivitiesCurrent<TData = Awaited<ReturnType<typeof activitiesCurrent>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: ActivitiesCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitiesCurrent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitiesCurrentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type activitiesAcceptResponse200 = {
  data: ActivityAcceptResponse
  status: 200
}

export type activitiesAcceptResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type activitiesAcceptResponse404 = {
  data: ActivityDeclarationError
  status: 404
}

export type activitiesAcceptResponse409 = {
  data: ActivityDeclarationError
  status: 409
}

export type activitiesAcceptResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type activitiesAcceptResponse422 = {
  data: ActivityDeclarationError
  status: 422
}

export type activitiesAcceptResponseSuccess = (activitiesAcceptResponse200) & {
  headers: Headers;
};
export type activitiesAcceptResponseError = (activitiesAcceptResponse401 | activitiesAcceptResponse404 | activitiesAcceptResponse409 | activitiesAcceptResponse410 | activitiesAcceptResponse422) & {
  headers: Headers;
};

export type activitiesAcceptResponse = (activitiesAcceptResponseSuccess | activitiesAcceptResponseError)

export const getActivitiesAcceptUrl = (definitionUid: string,) => {




  return `/api/v1/activities/offers/${definitionUid}/accept/`
}

/**
 * @summary Świadome przyjęcie oferowanego wyzwania
 */
export const activitiesAccept = async (definitionUid: string,
    activityAcceptRequest: ActivityAcceptRequest, options?: RequestInit): Promise<activitiesAcceptResponse> => {

  return customFetch<activitiesAcceptResponse>(getActivitiesAcceptUrl(definitionUid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(activityAcceptRequest)
  }
);}




export const getActivitiesAcceptMutationOptions = <TError = UnauthorizedResponse | ActivityDeclarationError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAccept>>, TError,{definitionUid: string;data: ActivityAcceptRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activitiesAccept>>, TError,{definitionUid: string;data: ActivityAcceptRequest}, TContext> => {

const mutationKey = ['activitiesAccept'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitiesAccept>>, {definitionUid: string;data: ActivityAcceptRequest}> = (props) => {
          const {definitionUid,data} = props ?? {};

          return  activitiesAccept(definitionUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitiesAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof activitiesAccept>>>
    export type ActivitiesAcceptMutationBody = ActivityAcceptRequest
    export type ActivitiesAcceptMutationError = UnauthorizedResponse | ActivityDeclarationError | AccountGoneResponse

    /**
 * @summary Świadome przyjęcie oferowanego wyzwania
 */
export const useActivitiesAccept = <TError = UnauthorizedResponse | ActivityDeclarationError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitiesAccept>>, TError,{definitionUid: string;data: ActivityAcceptRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitiesAccept>>,
        TError,
        {definitionUid: string;data: ActivityAcceptRequest},
        TContext
      > => {
      return useMutation(getActivitiesAcceptMutationOptions(options), queryClient);
    }

export type adminAccountsListResponse200 = {
  data: PaginatedAdminAccountRowList
  status: 200
}

export type adminAccountsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminAccountsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminAccountsListResponseSuccess = (adminAccountsListResponse200) & {
  headers: Headers;
};
export type adminAccountsListResponseError = (adminAccountsListResponse401 | adminAccountsListResponse410) & {
  headers: Headers;
};

export type adminAccountsListResponse = (adminAccountsListResponseSuccess | adminAccountsListResponseError)

export const getAdminAccountsListUrl = (params?: AdminAccountsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin-accounts/?${stringifiedParams}` : `/api/v1/admin-accounts/`
}

/**
 * @summary Lista kont administracyjnych (TR-100 R9)
 */
export const adminAccountsList = async (params?: AdminAccountsListParams, options?: RequestInit): Promise<adminAccountsListResponse> => {

  return customFetch<adminAccountsListResponse>(getAdminAccountsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminAccountsListQueryKey = (params?: AdminAccountsListParams,) => {
    return [
    `/api/v1/admin-accounts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminAccountsListQueryOptions = <TData = Awaited<ReturnType<typeof adminAccountsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: AdminAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAccountsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAccountsList>>> = ({ signal }) => adminAccountsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAccountsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAccountsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminAccountsList>>>
export type AdminAccountsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useAdminAccountsList<TData = Awaited<ReturnType<typeof adminAccountsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  AdminAccountsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccountsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAccountsList>>,
          TError,
          Awaited<ReturnType<typeof adminAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAccountsList<TData = Awaited<ReturnType<typeof adminAccountsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: AdminAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccountsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAccountsList>>,
          TError,
          Awaited<ReturnType<typeof adminAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAccountsList<TData = Awaited<ReturnType<typeof adminAccountsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: AdminAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista kont administracyjnych (TR-100 R9)
 */

export function useAdminAccountsList<TData = Awaited<ReturnType<typeof adminAccountsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: AdminAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAccountsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type adminAccountsInviteResponse201 = {
  data: AdminAccountRow
  status: 201
}

export type adminAccountsInviteResponse400 = {
  data: void
  status: 400
}

export type adminAccountsInviteResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminAccountsInviteResponse403 = {
  data: void
  status: 403
}

export type adminAccountsInviteResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminAccountsInviteResponseSuccess = (adminAccountsInviteResponse201) & {
  headers: Headers;
};
export type adminAccountsInviteResponseError = (adminAccountsInviteResponse400 | adminAccountsInviteResponse401 | adminAccountsInviteResponse403 | adminAccountsInviteResponse410) & {
  headers: Headers;
};

export type adminAccountsInviteResponse = (adminAccountsInviteResponseSuccess | adminAccountsInviteResponseError)

export const getAdminAccountsInviteUrl = () => {




  return `/api/v1/admin-accounts/`
}

/**
 * @summary Zaproszenie nowego konta administracyjnego
 */
export const adminAccountsInvite = async (adminAccountInviteRequest: AdminAccountInviteRequest, options?: RequestInit): Promise<adminAccountsInviteResponse> => {

  return customFetch<adminAccountsInviteResponse>(getAdminAccountsInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAccountInviteRequest)
  }
);}




export const getAdminAccountsInviteMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsInvite>>, TError,{data: AdminAccountInviteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAccountsInvite>>, TError,{data: AdminAccountInviteRequest}, TContext> => {

const mutationKey = ['adminAccountsInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccountsInvite>>, {data: AdminAccountInviteRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminAccountsInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAccountsInviteMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccountsInvite>>>
    export type AdminAccountsInviteMutationBody = AdminAccountInviteRequest
    export type AdminAccountsInviteMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Zaproszenie nowego konta administracyjnego
 */
export const useAdminAccountsInvite = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsInvite>>, TError,{data: AdminAccountInviteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAccountsInvite>>,
        TError,
        {data: AdminAccountInviteRequest},
        TContext
      > => {
      return useMutation(getAdminAccountsInviteMutationOptions(options), queryClient);
    }

export type adminAccountsRetrieveResponse200 = {
  data: AdminAccountRow
  status: 200
}

export type adminAccountsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminAccountsRetrieveResponse404 = {
  data: void
  status: 404
}

export type adminAccountsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminAccountsRetrieveResponseSuccess = (adminAccountsRetrieveResponse200) & {
  headers: Headers;
};
export type adminAccountsRetrieveResponseError = (adminAccountsRetrieveResponse401 | adminAccountsRetrieveResponse404 | adminAccountsRetrieveResponse410) & {
  headers: Headers;
};

export type adminAccountsRetrieveResponse = (adminAccountsRetrieveResponseSuccess | adminAccountsRetrieveResponseError)

export const getAdminAccountsRetrieveUrl = (id: number,) => {




  return `/api/v1/admin-accounts/${id}/`
}

/**
 * @summary Szczegóły konta administracyjnego
 */
export const adminAccountsRetrieve = async (id: number, options?: RequestInit): Promise<adminAccountsRetrieveResponse> => {

  return customFetch<adminAccountsRetrieveResponse>(getAdminAccountsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminAccountsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/v1/admin-accounts/${id}/`
    ] as const;
    }


export const getAdminAccountsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAccountsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAccountsRetrieve>>> = ({ signal }) => adminAccountsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAccountsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminAccountsRetrieve>>>
export type AdminAccountsRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useAdminAccountsRetrieve<TData = Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAccountsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminAccountsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAccountsRetrieve<TData = Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAccountsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminAccountsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAccountsRetrieve<TData = Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły konta administracyjnego
 */

export function useAdminAccountsRetrieve<TData = Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAccountsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type adminAccountsDisableResponse200 = {
  data: AdminAccountRow
  status: 200
}

export type adminAccountsDisableResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminAccountsDisableResponse403 = {
  data: void
  status: 403
}

export type adminAccountsDisableResponse404 = {
  data: void
  status: 404
}

export type adminAccountsDisableResponse409 = {
  data: void
  status: 409
}

export type adminAccountsDisableResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminAccountsDisableResponseSuccess = (adminAccountsDisableResponse200) & {
  headers: Headers;
};
export type adminAccountsDisableResponseError = (adminAccountsDisableResponse401 | adminAccountsDisableResponse403 | adminAccountsDisableResponse404 | adminAccountsDisableResponse409 | adminAccountsDisableResponse410) & {
  headers: Headers;
};

export type adminAccountsDisableResponse = (adminAccountsDisableResponseSuccess | adminAccountsDisableResponseError)

export const getAdminAccountsDisableUrl = (id: number,) => {




  return `/api/v1/admin-accounts/${id}/disable/`
}

/**
 * @summary Wyłączenie konta administracyjnego
 */
export const adminAccountsDisable = async (id: number, options?: RequestInit): Promise<adminAccountsDisableResponse> => {

  return customFetch<adminAccountsDisableResponse>(getAdminAccountsDisableUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAdminAccountsDisableMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsDisable>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAccountsDisable>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminAccountsDisable'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccountsDisable>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminAccountsDisable(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAccountsDisableMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccountsDisable>>>

    export type AdminAccountsDisableMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Wyłączenie konta administracyjnego
 */
export const useAdminAccountsDisable = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsDisable>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAccountsDisable>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminAccountsDisableMutationOptions(options), queryClient);
    }

export type adminAccountsEnableResponse200 = {
  data: AdminAccountRow
  status: 200
}

export type adminAccountsEnableResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminAccountsEnableResponse404 = {
  data: void
  status: 404
}

export type adminAccountsEnableResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminAccountsEnableResponseSuccess = (adminAccountsEnableResponse200) & {
  headers: Headers;
};
export type adminAccountsEnableResponseError = (adminAccountsEnableResponse401 | adminAccountsEnableResponse404 | adminAccountsEnableResponse410) & {
  headers: Headers;
};

export type adminAccountsEnableResponse = (adminAccountsEnableResponseSuccess | adminAccountsEnableResponseError)

export const getAdminAccountsEnableUrl = (id: number,) => {




  return `/api/v1/admin-accounts/${id}/enable/`
}

/**
 * @summary Ponowne włączenie konta administracyjnego
 */
export const adminAccountsEnable = async (id: number, options?: RequestInit): Promise<adminAccountsEnableResponse> => {

  return customFetch<adminAccountsEnableResponse>(getAdminAccountsEnableUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAdminAccountsEnableMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsEnable>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAccountsEnable>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminAccountsEnable'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccountsEnable>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminAccountsEnable(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAccountsEnableMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccountsEnable>>>

    export type AdminAccountsEnableMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Ponowne włączenie konta administracyjnego
 */
export const useAdminAccountsEnable = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsEnable>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAccountsEnable>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminAccountsEnableMutationOptions(options), queryClient);
    }

export type adminAccountsPasswordResetResponse200 = {
  data: AdminAccountPasswordResetResponse
  status: 200
}

export type adminAccountsPasswordResetResponse400 = {
  data: void
  status: 400
}

export type adminAccountsPasswordResetResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminAccountsPasswordResetResponse404 = {
  data: void
  status: 404
}

export type adminAccountsPasswordResetResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminAccountsPasswordResetResponseSuccess = (adminAccountsPasswordResetResponse200) & {
  headers: Headers;
};
export type adminAccountsPasswordResetResponseError = (adminAccountsPasswordResetResponse400 | adminAccountsPasswordResetResponse401 | adminAccountsPasswordResetResponse404 | adminAccountsPasswordResetResponse410) & {
  headers: Headers;
};

export type adminAccountsPasswordResetResponse = (adminAccountsPasswordResetResponseSuccess | adminAccountsPasswordResetResponseError)

export const getAdminAccountsPasswordResetUrl = (id: number,) => {




  return `/api/v1/admin-accounts/${id}/password-reset/`
}

/**
 * @summary Zainicjowanie resetu hasła konta administracyjnego
 */
export const adminAccountsPasswordReset = async (id: number, options?: RequestInit): Promise<adminAccountsPasswordResetResponse> => {

  return customFetch<adminAccountsPasswordResetResponse>(getAdminAccountsPasswordResetUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAdminAccountsPasswordResetMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsPasswordReset>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAccountsPasswordReset>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminAccountsPasswordReset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccountsPasswordReset>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminAccountsPasswordReset(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAccountsPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccountsPasswordReset>>>

    export type AdminAccountsPasswordResetMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Zainicjowanie resetu hasła konta administracyjnego
 */
export const useAdminAccountsPasswordReset = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsPasswordReset>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAccountsPasswordReset>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminAccountsPasswordResetMutationOptions(options), queryClient);
    }

export type adminAccountsReset2faResponse200 = {
  data: AdminAccountRow
  status: 200
}

export type adminAccountsReset2faResponse400 = {
  data: void
  status: 400
}

export type adminAccountsReset2faResponse401 = {
  data: void
  status: 401
}

export type adminAccountsReset2faResponse403 = {
  data: void
  status: 403
}

export type adminAccountsReset2faResponse404 = {
  data: void
  status: 404
}

export type adminAccountsReset2faResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminAccountsReset2faResponseSuccess = (adminAccountsReset2faResponse200) & {
  headers: Headers;
};
export type adminAccountsReset2faResponseError = (adminAccountsReset2faResponse400 | adminAccountsReset2faResponse401 | adminAccountsReset2faResponse403 | adminAccountsReset2faResponse404 | adminAccountsReset2faResponse410) & {
  headers: Headers;
};

export type adminAccountsReset2faResponse = (adminAccountsReset2faResponseSuccess | adminAccountsReset2faResponseError)

export const getAdminAccountsReset2faUrl = (id: number,) => {




  return `/api/v1/admin-accounts/${id}/reset-2fa/`
}

/**
 * TR-116: administracyjny reset 2FA. Superadmin usuwa aktywny sekret TOTP
 * innego konta administracyjnego po re-autoryzacji hasłem (limit 5 prób →
 * unieważnienie WŁASNEJ sesji aktora, R2). Sesje konta docelowego NIE są
 * kończone (R6) — to jedyne miejsce, w którym ta operacja celowo różni się
 * od tymczasowej akcji Django-admin `reset_mfa_and_end_sessions`.
 * @summary Reset 2FA konta administracyjnego (TR-116)
 */
export const adminAccountsReset2fa = async (id: number,
    adminAccountReset2FARequestRequest: AdminAccountReset2FARequestRequest, options?: RequestInit): Promise<adminAccountsReset2faResponse> => {

  return customFetch<adminAccountsReset2faResponse>(getAdminAccountsReset2faUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAccountReset2FARequestRequest)
  }
);}




export const getAdminAccountsReset2faMutationOptions = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsReset2fa>>, TError,{id: number;data: AdminAccountReset2FARequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAccountsReset2fa>>, TError,{id: number;data: AdminAccountReset2FARequestRequest}, TContext> => {

const mutationKey = ['adminAccountsReset2fa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccountsReset2fa>>, {id: number;data: AdminAccountReset2FARequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  adminAccountsReset2fa(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAccountsReset2faMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccountsReset2fa>>>
    export type AdminAccountsReset2faMutationBody = AdminAccountReset2FARequestRequest
    export type AdminAccountsReset2faMutationError = void | AccountGoneResponse

    /**
 * @summary Reset 2FA konta administracyjnego (TR-116)
 */
export const useAdminAccountsReset2fa = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsReset2fa>>, TError,{id: number;data: AdminAccountReset2FARequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAccountsReset2fa>>,
        TError,
        {id: number;data: AdminAccountReset2FARequestRequest},
        TContext
      > => {
      return useMutation(getAdminAccountsReset2faMutationOptions(options), queryClient);
    }

export type adminAccountsChangeRoleResponse200 = {
  data: AdminAccountRow
  status: 200
}

export type adminAccountsChangeRoleResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminAccountsChangeRoleResponse403 = {
  data: void
  status: 403
}

export type adminAccountsChangeRoleResponse404 = {
  data: void
  status: 404
}

export type adminAccountsChangeRoleResponse409 = {
  data: void
  status: 409
}

export type adminAccountsChangeRoleResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminAccountsChangeRoleResponseSuccess = (adminAccountsChangeRoleResponse200) & {
  headers: Headers;
};
export type adminAccountsChangeRoleResponseError = (adminAccountsChangeRoleResponse401 | adminAccountsChangeRoleResponse403 | adminAccountsChangeRoleResponse404 | adminAccountsChangeRoleResponse409 | adminAccountsChangeRoleResponse410) & {
  headers: Headers;
};

export type adminAccountsChangeRoleResponse = (adminAccountsChangeRoleResponseSuccess | adminAccountsChangeRoleResponseError)

export const getAdminAccountsChangeRoleUrl = (id: number,) => {




  return `/api/v1/admin-accounts/${id}/role/`
}

/**
 * @summary Zmiana roli konta administracyjnego
 */
export const adminAccountsChangeRole = async (id: number,
    adminAccountRoleRequest: AdminAccountRoleRequest, options?: RequestInit): Promise<adminAccountsChangeRoleResponse> => {

  return customFetch<adminAccountsChangeRoleResponse>(getAdminAccountsChangeRoleUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAccountRoleRequest)
  }
);}




export const getAdminAccountsChangeRoleMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsChangeRole>>, TError,{id: number;data: AdminAccountRoleRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAccountsChangeRole>>, TError,{id: number;data: AdminAccountRoleRequest}, TContext> => {

const mutationKey = ['adminAccountsChangeRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccountsChangeRole>>, {id: number;data: AdminAccountRoleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  adminAccountsChangeRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAccountsChangeRoleMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccountsChangeRole>>>
    export type AdminAccountsChangeRoleMutationBody = AdminAccountRoleRequest
    export type AdminAccountsChangeRoleMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Zmiana roli konta administracyjnego
 */
export const useAdminAccountsChangeRole = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsChangeRole>>, TError,{id: number;data: AdminAccountRoleRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAccountsChangeRole>>,
        TError,
        {id: number;data: AdminAccountRoleRequest},
        TContext
      > => {
      return useMutation(getAdminAccountsChangeRoleMutationOptions(options), queryClient);
    }

export type adminAccountsTemporaryPasswordResponse200 = {
  data: AdminAccountTemporaryPasswordResponse
  status: 200
}

export type adminAccountsTemporaryPasswordResponse400 = {
  data: void
  status: 400
}

export type adminAccountsTemporaryPasswordResponse401 = {
  data: void
  status: 401
}

export type adminAccountsTemporaryPasswordResponse403 = {
  data: void
  status: 403
}

export type adminAccountsTemporaryPasswordResponse404 = {
  data: void
  status: 404
}

export type adminAccountsTemporaryPasswordResponse409 = {
  data: void
  status: 409
}

export type adminAccountsTemporaryPasswordResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminAccountsTemporaryPasswordResponse429 = {
  data: void
  status: 429
}

export type adminAccountsTemporaryPasswordResponseSuccess = (adminAccountsTemporaryPasswordResponse200) & {
  headers: Headers;
};
export type adminAccountsTemporaryPasswordResponseError = (adminAccountsTemporaryPasswordResponse400 | adminAccountsTemporaryPasswordResponse401 | adminAccountsTemporaryPasswordResponse403 | adminAccountsTemporaryPasswordResponse404 | adminAccountsTemporaryPasswordResponse409 | adminAccountsTemporaryPasswordResponse410 | adminAccountsTemporaryPasswordResponse429) & {
  headers: Headers;
};

export type adminAccountsTemporaryPasswordResponse = (adminAccountsTemporaryPasswordResponseSuccess | adminAccountsTemporaryPasswordResponseError)

export const getAdminAccountsTemporaryPasswordUrl = (id: number,) => {




  return `/api/v1/admin-accounts/${id}/temporary-password/`
}

/**
 * Superadmin nadaje innemu kontu administracyjnemu hasło tymczasowe ważne 24 h.
 *
 * Hasło wraca w odpowiedzi jeden raz, a operator przekazuje je poza systemem.
 * Konto docelowe przy logowaniu przechodzi zwykłe 2FA, a potem wymuszoną zmianę
 * hasła. Po terminie hasło przestaje logować. 2FA konta zostaje bez zmian.
 * @summary Hasło tymczasowe konta administracyjnego
 */
export const adminAccountsTemporaryPassword = async (id: number,
    adminAccountTemporaryPasswordRequestRequest: AdminAccountTemporaryPasswordRequestRequest, options?: RequestInit): Promise<adminAccountsTemporaryPasswordResponse> => {

  return customFetch<adminAccountsTemporaryPasswordResponse>(getAdminAccountsTemporaryPasswordUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAccountTemporaryPasswordRequestRequest)
  }
);}




export const getAdminAccountsTemporaryPasswordMutationOptions = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsTemporaryPassword>>, TError,{id: number;data: AdminAccountTemporaryPasswordRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAccountsTemporaryPassword>>, TError,{id: number;data: AdminAccountTemporaryPasswordRequestRequest}, TContext> => {

const mutationKey = ['adminAccountsTemporaryPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccountsTemporaryPassword>>, {id: number;data: AdminAccountTemporaryPasswordRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  adminAccountsTemporaryPassword(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAccountsTemporaryPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccountsTemporaryPassword>>>
    export type AdminAccountsTemporaryPasswordMutationBody = AdminAccountTemporaryPasswordRequestRequest
    export type AdminAccountsTemporaryPasswordMutationError = void | AccountGoneResponse

    /**
 * @summary Hasło tymczasowe konta administracyjnego
 */
export const useAdminAccountsTemporaryPassword = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsTemporaryPassword>>, TError,{id: number;data: AdminAccountTemporaryPasswordRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAccountsTemporaryPassword>>,
        TError,
        {id: number;data: AdminAccountTemporaryPasswordRequestRequest},
        TContext
      > => {
      return useMutation(getAdminAccountsTemporaryPasswordMutationOptions(options), queryClient);
    }

export type adminAccountsInvitationResendResponse200 = {
  data: AdminAccountRow
  status: 200
}

export type adminAccountsInvitationResendResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminAccountsInvitationResendResponse404 = {
  data: void
  status: 404
}

export type adminAccountsInvitationResendResponse409 = {
  data: void
  status: 409
}

export type adminAccountsInvitationResendResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminAccountsInvitationResendResponseSuccess = (adminAccountsInvitationResendResponse200) & {
  headers: Headers;
};
export type adminAccountsInvitationResendResponseError = (adminAccountsInvitationResendResponse401 | adminAccountsInvitationResendResponse404 | adminAccountsInvitationResendResponse409 | adminAccountsInvitationResendResponse410) & {
  headers: Headers;
};

export type adminAccountsInvitationResendResponse = (adminAccountsInvitationResendResponseSuccess | adminAccountsInvitationResendResponseError)

export const getAdminAccountsInvitationResendUrl = (invitationId: number,) => {




  return `/api/v1/admin-accounts/invitations/${invitationId}/resend/`
}

/**
 * @summary Ponowne wysłanie zaproszenia
 */
export const adminAccountsInvitationResend = async (invitationId: number, options?: RequestInit): Promise<adminAccountsInvitationResendResponse> => {

  return customFetch<adminAccountsInvitationResendResponse>(getAdminAccountsInvitationResendUrl(invitationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAdminAccountsInvitationResendMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsInvitationResend>>, TError,{invitationId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAccountsInvitationResend>>, TError,{invitationId: number}, TContext> => {

const mutationKey = ['adminAccountsInvitationResend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccountsInvitationResend>>, {invitationId: number}> = (props) => {
          const {invitationId} = props ?? {};

          return  adminAccountsInvitationResend(invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAccountsInvitationResendMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccountsInvitationResend>>>

    export type AdminAccountsInvitationResendMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Ponowne wysłanie zaproszenia
 */
export const useAdminAccountsInvitationResend = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccountsInvitationResend>>, TError,{invitationId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAccountsInvitationResend>>,
        TError,
        {invitationId: number},
        TContext
      > => {
      return useMutation(getAdminAccountsInvitationResendMutationOptions(options), queryClient);
    }

export type v1AdminNotificationsCampaignsListResponse200 = {
  data: PaginatedNotificationCampaignList
  status: 200
}

export type v1AdminNotificationsCampaignsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsCampaignsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsCampaignsListResponseSuccess = (v1AdminNotificationsCampaignsListResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsCampaignsListResponseError = (v1AdminNotificationsCampaignsListResponse401 | v1AdminNotificationsCampaignsListResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsCampaignsListResponse = (v1AdminNotificationsCampaignsListResponseSuccess | v1AdminNotificationsCampaignsListResponseError)

export const getV1AdminNotificationsCampaignsListUrl = (params?: V1AdminNotificationsCampaignsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/notifications/campaigns/?${stringifiedParams}` : `/api/v1/admin/notifications/campaigns/`
}

export const v1AdminNotificationsCampaignsList = async (params?: V1AdminNotificationsCampaignsListParams, options?: RequestInit): Promise<v1AdminNotificationsCampaignsListResponse> => {

  return customFetch<v1AdminNotificationsCampaignsListResponse>(getV1AdminNotificationsCampaignsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsCampaignsListQueryKey = (params?: V1AdminNotificationsCampaignsListParams,) => {
    return [
    `/api/v1/admin/notifications/campaigns/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1AdminNotificationsCampaignsListQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1AdminNotificationsCampaignsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsCampaignsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>> = ({ signal }) => v1AdminNotificationsCampaignsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsCampaignsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>>
export type V1AdminNotificationsCampaignsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsCampaignsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1AdminNotificationsCampaignsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsCampaignsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsCampaignsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsCampaignsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsCampaignsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsCampaignsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsCampaignsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsCampaignsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsCampaignsCreateResponse201 = {
  data: NotificationCampaign
  status: 201
}

export type v1AdminNotificationsCampaignsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsCampaignsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsCampaignsCreateResponseSuccess = (v1AdminNotificationsCampaignsCreateResponse201) & {
  headers: Headers;
};
export type v1AdminNotificationsCampaignsCreateResponseError = (v1AdminNotificationsCampaignsCreateResponse401 | v1AdminNotificationsCampaignsCreateResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsCampaignsCreateResponse = (v1AdminNotificationsCampaignsCreateResponseSuccess | v1AdminNotificationsCampaignsCreateResponseError)

export const getV1AdminNotificationsCampaignsCreateUrl = () => {




  return `/api/v1/admin/notifications/campaigns/`
}

export const v1AdminNotificationsCampaignsCreate = async (notificationCampaignRequest: NotificationCampaignRequest, options?: RequestInit): Promise<v1AdminNotificationsCampaignsCreateResponse> => {

  return customFetch<v1AdminNotificationsCampaignsCreateResponse>(getV1AdminNotificationsCampaignsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationCampaignRequest)
  }
);}




export const getV1AdminNotificationsCampaignsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsCreate>>, TError,{data: NotificationCampaignRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsCreate>>, TError,{data: NotificationCampaignRequest}, TContext> => {

const mutationKey = ['v1AdminNotificationsCampaignsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsCreate>>, {data: NotificationCampaignRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1AdminNotificationsCampaignsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AdminNotificationsCampaignsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsCreate>>>
    export type V1AdminNotificationsCampaignsCreateMutationBody = NotificationCampaignRequest
    export type V1AdminNotificationsCampaignsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1AdminNotificationsCampaignsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsCreate>>, TError,{data: NotificationCampaignRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AdminNotificationsCampaignsCreate>>,
        TError,
        {data: NotificationCampaignRequest},
        TContext
      > => {
      return useMutation(getV1AdminNotificationsCampaignsCreateMutationOptions(options), queryClient);
    }

export type v1AdminNotificationsCampaignsRetrieveResponse200 = {
  data: NotificationCampaign
  status: 200
}

export type v1AdminNotificationsCampaignsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsCampaignsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsCampaignsRetrieveResponseSuccess = (v1AdminNotificationsCampaignsRetrieveResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsCampaignsRetrieveResponseError = (v1AdminNotificationsCampaignsRetrieveResponse401 | v1AdminNotificationsCampaignsRetrieveResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsCampaignsRetrieveResponse = (v1AdminNotificationsCampaignsRetrieveResponseSuccess | v1AdminNotificationsCampaignsRetrieveResponseError)

export const getV1AdminNotificationsCampaignsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/campaigns/${uid}/`
}

export const v1AdminNotificationsCampaignsRetrieve = async (uid: string, options?: RequestInit): Promise<v1AdminNotificationsCampaignsRetrieveResponse> => {

  return customFetch<v1AdminNotificationsCampaignsRetrieveResponse>(getV1AdminNotificationsCampaignsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsCampaignsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/notifications/campaigns/${uid}/`
    ] as const;
    }


export const getV1AdminNotificationsCampaignsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsCampaignsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>> = ({ signal }) => v1AdminNotificationsCampaignsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsCampaignsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>>
export type V1AdminNotificationsCampaignsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsCampaignsRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsCampaignsRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsCampaignsRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsCampaignsRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsCampaignsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsCampaignsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsIntentsListResponse200 = {
  data: PaginatedNotificationIntentList
  status: 200
}

export type v1AdminNotificationsIntentsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsIntentsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsIntentsListResponseSuccess = (v1AdminNotificationsIntentsListResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsIntentsListResponseError = (v1AdminNotificationsIntentsListResponse401 | v1AdminNotificationsIntentsListResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsIntentsListResponse = (v1AdminNotificationsIntentsListResponseSuccess | v1AdminNotificationsIntentsListResponseError)

export const getV1AdminNotificationsIntentsListUrl = (params?: V1AdminNotificationsIntentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/notifications/intents/?${stringifiedParams}` : `/api/v1/admin/notifications/intents/`
}

export const v1AdminNotificationsIntentsList = async (params?: V1AdminNotificationsIntentsListParams, options?: RequestInit): Promise<v1AdminNotificationsIntentsListResponse> => {

  return customFetch<v1AdminNotificationsIntentsListResponse>(getV1AdminNotificationsIntentsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsIntentsListQueryKey = (params?: V1AdminNotificationsIntentsListParams,) => {
    return [
    `/api/v1/admin/notifications/intents/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1AdminNotificationsIntentsListQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1AdminNotificationsIntentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsIntentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>> = ({ signal }) => v1AdminNotificationsIntentsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsIntentsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>>
export type V1AdminNotificationsIntentsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsIntentsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1AdminNotificationsIntentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsIntentsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsIntentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsIntentsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsIntentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsIntentsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsIntentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsIntentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsIntentsRetrieveResponse200 = {
  data: NotificationIntent
  status: 200
}

export type v1AdminNotificationsIntentsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsIntentsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsIntentsRetrieveResponseSuccess = (v1AdminNotificationsIntentsRetrieveResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsIntentsRetrieveResponseError = (v1AdminNotificationsIntentsRetrieveResponse401 | v1AdminNotificationsIntentsRetrieveResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsIntentsRetrieveResponse = (v1AdminNotificationsIntentsRetrieveResponseSuccess | v1AdminNotificationsIntentsRetrieveResponseError)

export const getV1AdminNotificationsIntentsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/intents/${uid}/`
}

export const v1AdminNotificationsIntentsRetrieve = async (uid: string, options?: RequestInit): Promise<v1AdminNotificationsIntentsRetrieveResponse> => {

  return customFetch<v1AdminNotificationsIntentsRetrieveResponse>(getV1AdminNotificationsIntentsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsIntentsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/notifications/intents/${uid}/`
    ] as const;
    }


export const getV1AdminNotificationsIntentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsIntentsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>> = ({ signal }) => v1AdminNotificationsIntentsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsIntentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>>
export type V1AdminNotificationsIntentsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsIntentsRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsIntentsRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsIntentsRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsIntentsRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsIntentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsIntentsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsPolicyRetrieveResponse200 = {
  data: NotificationPolicy
  status: 200
}

export type v1AdminNotificationsPolicyRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsPolicyRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsPolicyRetrieveResponseSuccess = (v1AdminNotificationsPolicyRetrieveResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsPolicyRetrieveResponseError = (v1AdminNotificationsPolicyRetrieveResponse401 | v1AdminNotificationsPolicyRetrieveResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsPolicyRetrieveResponse = (v1AdminNotificationsPolicyRetrieveResponseSuccess | v1AdminNotificationsPolicyRetrieveResponseError)

export const getV1AdminNotificationsPolicyRetrieveUrl = () => {




  return `/api/v1/admin/notifications/policy/`
}

export const v1AdminNotificationsPolicyRetrieve = async ( options?: RequestInit): Promise<v1AdminNotificationsPolicyRetrieveResponse> => {

  return customFetch<v1AdminNotificationsPolicyRetrieveResponse>(getV1AdminNotificationsPolicyRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsPolicyRetrieveQueryKey = () => {
    return [
    `/api/v1/admin/notifications/policy/`
    ] as const;
    }


export const getV1AdminNotificationsPolicyRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsPolicyRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>> = ({ signal }) => v1AdminNotificationsPolicyRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsPolicyRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>>
export type V1AdminNotificationsPolicyRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsPolicyRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsPolicyRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsPolicyRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsPolicyRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsPolicyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsPolicyRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsPolicyUpdateResponse200 = {
  data: NotificationPolicy
  status: 200
}

export type v1AdminNotificationsPolicyUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsPolicyUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsPolicyUpdateResponseSuccess = (v1AdminNotificationsPolicyUpdateResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsPolicyUpdateResponseError = (v1AdminNotificationsPolicyUpdateResponse401 | v1AdminNotificationsPolicyUpdateResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsPolicyUpdateResponse = (v1AdminNotificationsPolicyUpdateResponseSuccess | v1AdminNotificationsPolicyUpdateResponseError)

export const getV1AdminNotificationsPolicyUpdateUrl = () => {




  return `/api/v1/admin/notifications/policy/`
}

export const v1AdminNotificationsPolicyUpdate = async (notificationPolicyRequest: NotificationPolicyRequest, options?: RequestInit): Promise<v1AdminNotificationsPolicyUpdateResponse> => {

  return customFetch<v1AdminNotificationsPolicyUpdateResponse>(getV1AdminNotificationsPolicyUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationPolicyRequest)
  }
);}




export const getV1AdminNotificationsPolicyUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsPolicyUpdate>>, TError,{data: NotificationPolicyRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsPolicyUpdate>>, TError,{data: NotificationPolicyRequest}, TContext> => {

const mutationKey = ['v1AdminNotificationsPolicyUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AdminNotificationsPolicyUpdate>>, {data: NotificationPolicyRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1AdminNotificationsPolicyUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AdminNotificationsPolicyUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsPolicyUpdate>>>
    export type V1AdminNotificationsPolicyUpdateMutationBody = NotificationPolicyRequest
    export type V1AdminNotificationsPolicyUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1AdminNotificationsPolicyUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsPolicyUpdate>>, TError,{data: NotificationPolicyRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AdminNotificationsPolicyUpdate>>,
        TError,
        {data: NotificationPolicyRequest},
        TContext
      > => {
      return useMutation(getV1AdminNotificationsPolicyUpdateMutationOptions(options), queryClient);
    }

export type v1AdminNotificationsTemplatesListResponse200 = {
  data: PaginatedNotificationTemplateList
  status: 200
}

export type v1AdminNotificationsTemplatesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTemplatesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTemplatesListResponseSuccess = (v1AdminNotificationsTemplatesListResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsTemplatesListResponseError = (v1AdminNotificationsTemplatesListResponse401 | v1AdminNotificationsTemplatesListResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTemplatesListResponse = (v1AdminNotificationsTemplatesListResponseSuccess | v1AdminNotificationsTemplatesListResponseError)

export const getV1AdminNotificationsTemplatesListUrl = (params?: V1AdminNotificationsTemplatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/notifications/templates/?${stringifiedParams}` : `/api/v1/admin/notifications/templates/`
}

export const v1AdminNotificationsTemplatesList = async (params?: V1AdminNotificationsTemplatesListParams, options?: RequestInit): Promise<v1AdminNotificationsTemplatesListResponse> => {

  return customFetch<v1AdminNotificationsTemplatesListResponse>(getV1AdminNotificationsTemplatesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsTemplatesListQueryKey = (params?: V1AdminNotificationsTemplatesListParams,) => {
    return [
    `/api/v1/admin/notifications/templates/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1AdminNotificationsTemplatesListQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1AdminNotificationsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsTemplatesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>> = ({ signal }) => v1AdminNotificationsTemplatesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsTemplatesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>>
export type V1AdminNotificationsTemplatesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsTemplatesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1AdminNotificationsTemplatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTemplatesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTemplatesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsTemplatesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsTemplatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsTemplatesCreateResponse201 = {
  data: NotificationTemplate
  status: 201
}

export type v1AdminNotificationsTemplatesCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTemplatesCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTemplatesCreateResponseSuccess = (v1AdminNotificationsTemplatesCreateResponse201) & {
  headers: Headers;
};
export type v1AdminNotificationsTemplatesCreateResponseError = (v1AdminNotificationsTemplatesCreateResponse401 | v1AdminNotificationsTemplatesCreateResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTemplatesCreateResponse = (v1AdminNotificationsTemplatesCreateResponseSuccess | v1AdminNotificationsTemplatesCreateResponseError)

export const getV1AdminNotificationsTemplatesCreateUrl = () => {




  return `/api/v1/admin/notifications/templates/`
}

export const v1AdminNotificationsTemplatesCreate = async (notificationTemplateRequest: NotificationTemplateRequest, options?: RequestInit): Promise<v1AdminNotificationsTemplatesCreateResponse> => {

  return customFetch<v1AdminNotificationsTemplatesCreateResponse>(getV1AdminNotificationsTemplatesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationTemplateRequest)
  }
);}




export const getV1AdminNotificationsTemplatesCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesCreate>>, TError,{data: NotificationTemplateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesCreate>>, TError,{data: NotificationTemplateRequest}, TContext> => {

const mutationKey = ['v1AdminNotificationsTemplatesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesCreate>>, {data: NotificationTemplateRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1AdminNotificationsTemplatesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AdminNotificationsTemplatesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesCreate>>>
    export type V1AdminNotificationsTemplatesCreateMutationBody = NotificationTemplateRequest
    export type V1AdminNotificationsTemplatesCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1AdminNotificationsTemplatesCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesCreate>>, TError,{data: NotificationTemplateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AdminNotificationsTemplatesCreate>>,
        TError,
        {data: NotificationTemplateRequest},
        TContext
      > => {
      return useMutation(getV1AdminNotificationsTemplatesCreateMutationOptions(options), queryClient);
    }

export type v1AdminNotificationsTemplatesRetrieveResponse200 = {
  data: NotificationTemplate
  status: 200
}

export type v1AdminNotificationsTemplatesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTemplatesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTemplatesRetrieveResponseSuccess = (v1AdminNotificationsTemplatesRetrieveResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsTemplatesRetrieveResponseError = (v1AdminNotificationsTemplatesRetrieveResponse401 | v1AdminNotificationsTemplatesRetrieveResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTemplatesRetrieveResponse = (v1AdminNotificationsTemplatesRetrieveResponseSuccess | v1AdminNotificationsTemplatesRetrieveResponseError)

export const getV1AdminNotificationsTemplatesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/templates/${uid}/`
}

export const v1AdminNotificationsTemplatesRetrieve = async (uid: string, options?: RequestInit): Promise<v1AdminNotificationsTemplatesRetrieveResponse> => {

  return customFetch<v1AdminNotificationsTemplatesRetrieveResponse>(getV1AdminNotificationsTemplatesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsTemplatesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/notifications/templates/${uid}/`
    ] as const;
    }


export const getV1AdminNotificationsTemplatesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsTemplatesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>> = ({ signal }) => v1AdminNotificationsTemplatesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsTemplatesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>>
export type V1AdminNotificationsTemplatesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsTemplatesRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTemplatesRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTemplatesRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsTemplatesRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsTemplatesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsTemplatesUpdateResponse200 = {
  data: NotificationTemplate
  status: 200
}

export type v1AdminNotificationsTemplatesUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTemplatesUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTemplatesUpdateResponseSuccess = (v1AdminNotificationsTemplatesUpdateResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsTemplatesUpdateResponseError = (v1AdminNotificationsTemplatesUpdateResponse401 | v1AdminNotificationsTemplatesUpdateResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTemplatesUpdateResponse = (v1AdminNotificationsTemplatesUpdateResponseSuccess | v1AdminNotificationsTemplatesUpdateResponseError)

export const getV1AdminNotificationsTemplatesUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/templates/${uid}/`
}

export const v1AdminNotificationsTemplatesUpdate = async (uid: string,
    notificationTemplateRequest: NotificationTemplateRequest, options?: RequestInit): Promise<v1AdminNotificationsTemplatesUpdateResponse> => {

  return customFetch<v1AdminNotificationsTemplatesUpdateResponse>(getV1AdminNotificationsTemplatesUpdateUrl(uid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationTemplateRequest)
  }
);}




export const getV1AdminNotificationsTemplatesUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesUpdate>>, TError,{uid: string;data: NotificationTemplateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesUpdate>>, TError,{uid: string;data: NotificationTemplateRequest}, TContext> => {

const mutationKey = ['v1AdminNotificationsTemplatesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesUpdate>>, {uid: string;data: NotificationTemplateRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1AdminNotificationsTemplatesUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AdminNotificationsTemplatesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesUpdate>>>
    export type V1AdminNotificationsTemplatesUpdateMutationBody = NotificationTemplateRequest
    export type V1AdminNotificationsTemplatesUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1AdminNotificationsTemplatesUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesUpdate>>, TError,{uid: string;data: NotificationTemplateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AdminNotificationsTemplatesUpdate>>,
        TError,
        {uid: string;data: NotificationTemplateRequest},
        TContext
      > => {
      return useMutation(getV1AdminNotificationsTemplatesUpdateMutationOptions(options), queryClient);
    }

export type v1AdminNotificationsTemplatesPartialUpdateResponse200 = {
  data: NotificationTemplate
  status: 200
}

export type v1AdminNotificationsTemplatesPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTemplatesPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTemplatesPartialUpdateResponseSuccess = (v1AdminNotificationsTemplatesPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsTemplatesPartialUpdateResponseError = (v1AdminNotificationsTemplatesPartialUpdateResponse401 | v1AdminNotificationsTemplatesPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTemplatesPartialUpdateResponse = (v1AdminNotificationsTemplatesPartialUpdateResponseSuccess | v1AdminNotificationsTemplatesPartialUpdateResponseError)

export const getV1AdminNotificationsTemplatesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/templates/${uid}/`
}

export const v1AdminNotificationsTemplatesPartialUpdate = async (uid: string,
    patchedNotificationTemplateRequest?: PatchedNotificationTemplateRequest, options?: RequestInit): Promise<v1AdminNotificationsTemplatesPartialUpdateResponse> => {

  return customFetch<v1AdminNotificationsTemplatesPartialUpdateResponse>(getV1AdminNotificationsTemplatesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedNotificationTemplateRequest)
  }
);}




export const getV1AdminNotificationsTemplatesPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesPartialUpdate>>, TError,{uid: string;data?: PatchedNotificationTemplateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesPartialUpdate>>, TError,{uid: string;data?: PatchedNotificationTemplateRequest}, TContext> => {

const mutationKey = ['v1AdminNotificationsTemplatesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesPartialUpdate>>, {uid: string;data?: PatchedNotificationTemplateRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1AdminNotificationsTemplatesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AdminNotificationsTemplatesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesPartialUpdate>>>
    export type V1AdminNotificationsTemplatesPartialUpdateMutationBody = PatchedNotificationTemplateRequest | undefined
    export type V1AdminNotificationsTemplatesPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1AdminNotificationsTemplatesPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesPartialUpdate>>, TError,{uid: string;data?: PatchedNotificationTemplateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AdminNotificationsTemplatesPartialUpdate>>,
        TError,
        {uid: string;data?: PatchedNotificationTemplateRequest},
        TContext
      > => {
      return useMutation(getV1AdminNotificationsTemplatesPartialUpdateMutationOptions(options), queryClient);
    }

export type v1AdminNotificationsTemplatesDestroyResponse204 = {
  data: void
  status: 204
}

export type v1AdminNotificationsTemplatesDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTemplatesDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTemplatesDestroyResponseSuccess = (v1AdminNotificationsTemplatesDestroyResponse204) & {
  headers: Headers;
};
export type v1AdminNotificationsTemplatesDestroyResponseError = (v1AdminNotificationsTemplatesDestroyResponse401 | v1AdminNotificationsTemplatesDestroyResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTemplatesDestroyResponse = (v1AdminNotificationsTemplatesDestroyResponseSuccess | v1AdminNotificationsTemplatesDestroyResponseError)

export const getV1AdminNotificationsTemplatesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/templates/${uid}/`
}

export const v1AdminNotificationsTemplatesDestroy = async (uid: string, options?: RequestInit): Promise<v1AdminNotificationsTemplatesDestroyResponse> => {

  return customFetch<v1AdminNotificationsTemplatesDestroyResponse>(getV1AdminNotificationsTemplatesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getV1AdminNotificationsTemplatesDestroyMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesDestroy>>, TError,{uid: string}, TContext> => {

const mutationKey = ['v1AdminNotificationsTemplatesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesDestroy>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  v1AdminNotificationsTemplatesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AdminNotificationsTemplatesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesDestroy>>>

    export type V1AdminNotificationsTemplatesDestroyMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1AdminNotificationsTemplatesDestroy = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTemplatesDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AdminNotificationsTemplatesDestroy>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getV1AdminNotificationsTemplatesDestroyMutationOptions(options), queryClient);
    }

export type adminNotificationTestCapabilitiesResponse200 = {
  data: NotificationTestCapabilities
  status: 200
}

export type adminNotificationTestCapabilitiesResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminNotificationTestCapabilitiesResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminNotificationTestCapabilitiesResponseSuccess = (adminNotificationTestCapabilitiesResponse200) & {
  headers: Headers;
};
export type adminNotificationTestCapabilitiesResponseError = (adminNotificationTestCapabilitiesResponse401 | adminNotificationTestCapabilitiesResponse410) & {
  headers: Headers;
};

export type adminNotificationTestCapabilitiesResponse = (adminNotificationTestCapabilitiesResponseSuccess | adminNotificationTestCapabilitiesResponseError)

export const getAdminNotificationTestCapabilitiesUrl = () => {




  return `/api/v1/admin/notifications/test-console/capabilities/`
}

export const adminNotificationTestCapabilities = async ( options?: RequestInit): Promise<adminNotificationTestCapabilitiesResponse> => {

  return customFetch<adminNotificationTestCapabilitiesResponse>(getAdminNotificationTestCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminNotificationTestCapabilitiesQueryKey = () => {
    return [
    `/api/v1/admin/notifications/test-console/capabilities/`
    ] as const;
    }


export const getAdminNotificationTestCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminNotificationTestCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationTestCapabilities>>> = ({ signal }) => adminNotificationTestCapabilities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminNotificationTestCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationTestCapabilities>>>
export type AdminNotificationTestCapabilitiesQueryError = UnauthorizedResponse | AccountGoneResponse


export function useAdminNotificationTestCapabilities<TData = Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationTestCapabilities>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationTestCapabilities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationTestCapabilities<TData = Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationTestCapabilities>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationTestCapabilities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationTestCapabilities<TData = Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminNotificationTestCapabilities<TData = Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestCapabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationTestCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type adminNotificationTestPreviewResponse200 = {
  data: NotificationTestPreviewResponse
  status: 200
}

export type adminNotificationTestPreviewResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminNotificationTestPreviewResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminNotificationTestPreviewResponseSuccess = (adminNotificationTestPreviewResponse200) & {
  headers: Headers;
};
export type adminNotificationTestPreviewResponseError = (adminNotificationTestPreviewResponse401 | adminNotificationTestPreviewResponse410) & {
  headers: Headers;
};

export type adminNotificationTestPreviewResponse = (adminNotificationTestPreviewResponseSuccess | adminNotificationTestPreviewResponseError)

export const getAdminNotificationTestPreviewUrl = () => {




  return `/api/v1/admin/notifications/test-console/preview/`
}

export const adminNotificationTestPreview = async (notificationTestCommandRequest: NotificationTestCommandRequest, options?: RequestInit): Promise<adminNotificationTestPreviewResponse> => {

  return customFetch<adminNotificationTestPreviewResponse>(getAdminNotificationTestPreviewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationTestCommandRequest)
  }
);}




export const getAdminNotificationTestPreviewMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationTestPreview>>, TError,{data: NotificationTestCommandRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminNotificationTestPreview>>, TError,{data: NotificationTestCommandRequest}, TContext> => {

const mutationKey = ['adminNotificationTestPreview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminNotificationTestPreview>>, {data: NotificationTestCommandRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminNotificationTestPreview(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminNotificationTestPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof adminNotificationTestPreview>>>
    export type AdminNotificationTestPreviewMutationBody = NotificationTestCommandRequest
    export type AdminNotificationTestPreviewMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useAdminNotificationTestPreview = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationTestPreview>>, TError,{data: NotificationTestCommandRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminNotificationTestPreview>>,
        TError,
        {data: NotificationTestCommandRequest},
        TContext
      > => {
      return useMutation(getAdminNotificationTestPreviewMutationOptions(options), queryClient);
    }

export type v1AdminNotificationsTestConsoleTargetsListResponse200 = {
  data: PaginatedNotificationTargetList
  status: 200
}

export type v1AdminNotificationsTestConsoleTargetsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTestConsoleTargetsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTestConsoleTargetsListResponseSuccess = (v1AdminNotificationsTestConsoleTargetsListResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsTestConsoleTargetsListResponseError = (v1AdminNotificationsTestConsoleTargetsListResponse401 | v1AdminNotificationsTestConsoleTargetsListResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTestConsoleTargetsListResponse = (v1AdminNotificationsTestConsoleTargetsListResponseSuccess | v1AdminNotificationsTestConsoleTargetsListResponseError)

export const getV1AdminNotificationsTestConsoleTargetsListUrl = (params?: V1AdminNotificationsTestConsoleTargetsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/notifications/test-console/targets/?${stringifiedParams}` : `/api/v1/admin/notifications/test-console/targets/`
}

export const v1AdminNotificationsTestConsoleTargetsList = async (params?: V1AdminNotificationsTestConsoleTargetsListParams, options?: RequestInit): Promise<v1AdminNotificationsTestConsoleTargetsListResponse> => {

  return customFetch<v1AdminNotificationsTestConsoleTargetsListResponse>(getV1AdminNotificationsTestConsoleTargetsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsTestConsoleTargetsListQueryKey = (params?: V1AdminNotificationsTestConsoleTargetsListParams,) => {
    return [
    `/api/v1/admin/notifications/test-console/targets/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1AdminNotificationsTestConsoleTargetsListQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1AdminNotificationsTestConsoleTargetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsTestConsoleTargetsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>> = ({ signal }) => v1AdminNotificationsTestConsoleTargetsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsTestConsoleTargetsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>>
export type V1AdminNotificationsTestConsoleTargetsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsTestConsoleTargetsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1AdminNotificationsTestConsoleTargetsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTestConsoleTargetsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsTestConsoleTargetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTestConsoleTargetsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsTestConsoleTargetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsTestConsoleTargetsList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsTestConsoleTargetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsTestConsoleTargetsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsTestConsoleTargetsDevicesListResponse200 = {
  data: PaginatedNotificationAdminDeviceList
  status: 200
}

export type v1AdminNotificationsTestConsoleTargetsDevicesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTestConsoleTargetsDevicesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTestConsoleTargetsDevicesListResponseSuccess = (v1AdminNotificationsTestConsoleTargetsDevicesListResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsTestConsoleTargetsDevicesListResponseError = (v1AdminNotificationsTestConsoleTargetsDevicesListResponse401 | v1AdminNotificationsTestConsoleTargetsDevicesListResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTestConsoleTargetsDevicesListResponse = (v1AdminNotificationsTestConsoleTargetsDevicesListResponseSuccess | v1AdminNotificationsTestConsoleTargetsDevicesListResponseError)

export const getV1AdminNotificationsTestConsoleTargetsDevicesListUrl = (recipientId: number,
    params?: V1AdminNotificationsTestConsoleTargetsDevicesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/notifications/test-console/targets/${recipientId}/devices/?${stringifiedParams}` : `/api/v1/admin/notifications/test-console/targets/${recipientId}/devices/`
}

export const v1AdminNotificationsTestConsoleTargetsDevicesList = async (recipientId: number,
    params?: V1AdminNotificationsTestConsoleTargetsDevicesListParams, options?: RequestInit): Promise<v1AdminNotificationsTestConsoleTargetsDevicesListResponse> => {

  return customFetch<v1AdminNotificationsTestConsoleTargetsDevicesListResponse>(getV1AdminNotificationsTestConsoleTargetsDevicesListUrl(recipientId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsTestConsoleTargetsDevicesListQueryKey = (recipientId: number,
    params?: V1AdminNotificationsTestConsoleTargetsDevicesListParams,) => {
    return [
    `/api/v1/admin/notifications/test-console/targets/${recipientId}/devices/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1AdminNotificationsTestConsoleTargetsDevicesListQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(recipientId: number,
    params?: V1AdminNotificationsTestConsoleTargetsDevicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsTestConsoleTargetsDevicesListQueryKey(recipientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>> = ({ signal }) => v1AdminNotificationsTestConsoleTargetsDevicesList(recipientId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recipientId !== null && recipientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsTestConsoleTargetsDevicesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>>
export type V1AdminNotificationsTestConsoleTargetsDevicesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsTestConsoleTargetsDevicesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 recipientId: number,
    params: undefined |  V1AdminNotificationsTestConsoleTargetsDevicesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTestConsoleTargetsDevicesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 recipientId: number,
    params?: V1AdminNotificationsTestConsoleTargetsDevicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTestConsoleTargetsDevicesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 recipientId: number,
    params?: V1AdminNotificationsTestConsoleTargetsDevicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsTestConsoleTargetsDevicesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 recipientId: number,
    params?: V1AdminNotificationsTestConsoleTargetsDevicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTestConsoleTargetsDevicesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsTestConsoleTargetsDevicesListQueryOptions(recipientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type adminNotificationTestSendListResponse200 = {
  data: PaginatedNotificationTestSendList
  status: 200
}

export type adminNotificationTestSendListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminNotificationTestSendListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminNotificationTestSendListResponseSuccess = (adminNotificationTestSendListResponse200) & {
  headers: Headers;
};
export type adminNotificationTestSendListResponseError = (adminNotificationTestSendListResponse401 | adminNotificationTestSendListResponse410) & {
  headers: Headers;
};

export type adminNotificationTestSendListResponse = (adminNotificationTestSendListResponseSuccess | adminNotificationTestSendListResponseError)

export const getAdminNotificationTestSendListUrl = (params?: AdminNotificationTestSendListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/notifications/test-console/test-sends/?${stringifiedParams}` : `/api/v1/admin/notifications/test-console/test-sends/`
}

export const adminNotificationTestSendList = async (params?: AdminNotificationTestSendListParams, options?: RequestInit): Promise<adminNotificationTestSendListResponse> => {

  return customFetch<adminNotificationTestSendListResponse>(getAdminNotificationTestSendListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminNotificationTestSendListQueryKey = (params?: AdminNotificationTestSendListParams,) => {
    return [
    `/api/v1/admin/notifications/test-console/test-sends/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminNotificationTestSendListQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: AdminNotificationTestSendListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminNotificationTestSendListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationTestSendList>>> = ({ signal }) => adminNotificationTestSendList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminNotificationTestSendListQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationTestSendList>>>
export type AdminNotificationTestSendListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useAdminNotificationTestSendList<TData = Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  AdminNotificationTestSendListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationTestSendList>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationTestSendList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationTestSendList<TData = Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: AdminNotificationTestSendListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationTestSendList>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationTestSendList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationTestSendList<TData = Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: AdminNotificationTestSendListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminNotificationTestSendList<TData = Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: AdminNotificationTestSendListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationTestSendListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type adminNotificationTestSendCreateResponse202 = {
  data: NotificationTestSend
  status: 202
}

export type adminNotificationTestSendCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminNotificationTestSendCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminNotificationTestSendCreateResponseSuccess = (adminNotificationTestSendCreateResponse202) & {
  headers: Headers;
};
export type adminNotificationTestSendCreateResponseError = (adminNotificationTestSendCreateResponse401 | adminNotificationTestSendCreateResponse410) & {
  headers: Headers;
};

export type adminNotificationTestSendCreateResponse = (adminNotificationTestSendCreateResponseSuccess | adminNotificationTestSendCreateResponseError)

export const getAdminNotificationTestSendCreateUrl = () => {




  return `/api/v1/admin/notifications/test-console/test-sends/`
}

export const adminNotificationTestSendCreate = async (notificationTestSendCreateRequest: NotificationTestSendCreateRequest, options?: RequestInit): Promise<adminNotificationTestSendCreateResponse> => {

  return customFetch<adminNotificationTestSendCreateResponse>(getAdminNotificationTestSendCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationTestSendCreateRequest)
  }
);}




export const getAdminNotificationTestSendCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationTestSendCreate>>, TError,{data: NotificationTestSendCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminNotificationTestSendCreate>>, TError,{data: NotificationTestSendCreateRequest}, TContext> => {

const mutationKey = ['adminNotificationTestSendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminNotificationTestSendCreate>>, {data: NotificationTestSendCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminNotificationTestSendCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminNotificationTestSendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminNotificationTestSendCreate>>>
    export type AdminNotificationTestSendCreateMutationBody = NotificationTestSendCreateRequest
    export type AdminNotificationTestSendCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useAdminNotificationTestSendCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationTestSendCreate>>, TError,{data: NotificationTestSendCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminNotificationTestSendCreate>>,
        TError,
        {data: NotificationTestSendCreateRequest},
        TContext
      > => {
      return useMutation(getAdminNotificationTestSendCreateMutationOptions(options), queryClient);
    }

export type adminNotificationTestSendRetrieveResponse200 = {
  data: NotificationTestSend
  status: 200
}

export type adminNotificationTestSendRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminNotificationTestSendRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type adminNotificationTestSendRetrieveResponseSuccess = (adminNotificationTestSendRetrieveResponse200) & {
  headers: Headers;
};
export type adminNotificationTestSendRetrieveResponseError = (adminNotificationTestSendRetrieveResponse401 | adminNotificationTestSendRetrieveResponse410) & {
  headers: Headers;
};

export type adminNotificationTestSendRetrieveResponse = (adminNotificationTestSendRetrieveResponseSuccess | adminNotificationTestSendRetrieveResponseError)

export const getAdminNotificationTestSendRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/test-console/test-sends/${uid}/`
}

export const adminNotificationTestSendRetrieve = async (uid: string, options?: RequestInit): Promise<adminNotificationTestSendRetrieveResponse> => {

  return customFetch<adminNotificationTestSendRetrieveResponse>(getAdminNotificationTestSendRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminNotificationTestSendRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/notifications/test-console/test-sends/${uid}/`
    ] as const;
    }


export const getAdminNotificationTestSendRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminNotificationTestSendRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>> = ({ signal }) => adminNotificationTestSendRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminNotificationTestSendRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>>
export type AdminNotificationTestSendRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useAdminNotificationTestSendRetrieve<TData = Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationTestSendRetrieve<TData = Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationTestSendRetrieve<TData = Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminNotificationTestSendRetrieve<TData = Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationTestSendRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationTestSendRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsTypesListResponse200 = {
  data: PaginatedNotificationTypeList
  status: 200
}

export type v1AdminNotificationsTypesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTypesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTypesListResponseSuccess = (v1AdminNotificationsTypesListResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsTypesListResponseError = (v1AdminNotificationsTypesListResponse401 | v1AdminNotificationsTypesListResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTypesListResponse = (v1AdminNotificationsTypesListResponseSuccess | v1AdminNotificationsTypesListResponseError)

export const getV1AdminNotificationsTypesListUrl = (params?: V1AdminNotificationsTypesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/notifications/types/?${stringifiedParams}` : `/api/v1/admin/notifications/types/`
}

export const v1AdminNotificationsTypesList = async (params?: V1AdminNotificationsTypesListParams, options?: RequestInit): Promise<v1AdminNotificationsTypesListResponse> => {

  return customFetch<v1AdminNotificationsTypesListResponse>(getV1AdminNotificationsTypesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsTypesListQueryKey = (params?: V1AdminNotificationsTypesListParams,) => {
    return [
    `/api/v1/admin/notifications/types/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1AdminNotificationsTypesListQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1AdminNotificationsTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsTypesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>> = ({ signal }) => v1AdminNotificationsTypesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsTypesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>>
export type V1AdminNotificationsTypesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsTypesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1AdminNotificationsTypesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTypesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTypesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsTypesList<TData = Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1AdminNotificationsTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsTypesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsTypesCreateResponse201 = {
  data: NotificationType
  status: 201
}

export type v1AdminNotificationsTypesCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTypesCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTypesCreateResponseSuccess = (v1AdminNotificationsTypesCreateResponse201) & {
  headers: Headers;
};
export type v1AdminNotificationsTypesCreateResponseError = (v1AdminNotificationsTypesCreateResponse401 | v1AdminNotificationsTypesCreateResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTypesCreateResponse = (v1AdminNotificationsTypesCreateResponseSuccess | v1AdminNotificationsTypesCreateResponseError)

export const getV1AdminNotificationsTypesCreateUrl = () => {




  return `/api/v1/admin/notifications/types/`
}

export const v1AdminNotificationsTypesCreate = async (notificationTypeRequest: NotificationTypeRequest, options?: RequestInit): Promise<v1AdminNotificationsTypesCreateResponse> => {

  return customFetch<v1AdminNotificationsTypesCreateResponse>(getV1AdminNotificationsTypesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationTypeRequest)
  }
);}




export const getV1AdminNotificationsTypesCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesCreate>>, TError,{data: NotificationTypeRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesCreate>>, TError,{data: NotificationTypeRequest}, TContext> => {

const mutationKey = ['v1AdminNotificationsTypesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AdminNotificationsTypesCreate>>, {data: NotificationTypeRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1AdminNotificationsTypesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AdminNotificationsTypesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTypesCreate>>>
    export type V1AdminNotificationsTypesCreateMutationBody = NotificationTypeRequest
    export type V1AdminNotificationsTypesCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1AdminNotificationsTypesCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesCreate>>, TError,{data: NotificationTypeRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AdminNotificationsTypesCreate>>,
        TError,
        {data: NotificationTypeRequest},
        TContext
      > => {
      return useMutation(getV1AdminNotificationsTypesCreateMutationOptions(options), queryClient);
    }

export type v1AdminNotificationsTypesRetrieveResponse200 = {
  data: NotificationType
  status: 200
}

export type v1AdminNotificationsTypesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTypesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTypesRetrieveResponseSuccess = (v1AdminNotificationsTypesRetrieveResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsTypesRetrieveResponseError = (v1AdminNotificationsTypesRetrieveResponse401 | v1AdminNotificationsTypesRetrieveResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTypesRetrieveResponse = (v1AdminNotificationsTypesRetrieveResponseSuccess | v1AdminNotificationsTypesRetrieveResponseError)

export const getV1AdminNotificationsTypesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/types/${uid}/`
}

export const v1AdminNotificationsTypesRetrieve = async (uid: string, options?: RequestInit): Promise<v1AdminNotificationsTypesRetrieveResponse> => {

  return customFetch<v1AdminNotificationsTypesRetrieveResponse>(getV1AdminNotificationsTypesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1AdminNotificationsTypesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/notifications/types/${uid}/`
    ] as const;
    }


export const getV1AdminNotificationsTypesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1AdminNotificationsTypesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>> = ({ signal }) => v1AdminNotificationsTypesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1AdminNotificationsTypesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>>
export type V1AdminNotificationsTypesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1AdminNotificationsTypesRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTypesRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1AdminNotificationsTypesRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1AdminNotificationsTypesRetrieve<TData = Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1AdminNotificationsTypesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1AdminNotificationsTypesUpdateResponse200 = {
  data: NotificationType
  status: 200
}

export type v1AdminNotificationsTypesUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTypesUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTypesUpdateResponseSuccess = (v1AdminNotificationsTypesUpdateResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsTypesUpdateResponseError = (v1AdminNotificationsTypesUpdateResponse401 | v1AdminNotificationsTypesUpdateResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTypesUpdateResponse = (v1AdminNotificationsTypesUpdateResponseSuccess | v1AdminNotificationsTypesUpdateResponseError)

export const getV1AdminNotificationsTypesUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/types/${uid}/`
}

export const v1AdminNotificationsTypesUpdate = async (uid: string,
    notificationTypeRequest: NotificationTypeRequest, options?: RequestInit): Promise<v1AdminNotificationsTypesUpdateResponse> => {

  return customFetch<v1AdminNotificationsTypesUpdateResponse>(getV1AdminNotificationsTypesUpdateUrl(uid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationTypeRequest)
  }
);}




export const getV1AdminNotificationsTypesUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesUpdate>>, TError,{uid: string;data: NotificationTypeRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesUpdate>>, TError,{uid: string;data: NotificationTypeRequest}, TContext> => {

const mutationKey = ['v1AdminNotificationsTypesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AdminNotificationsTypesUpdate>>, {uid: string;data: NotificationTypeRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1AdminNotificationsTypesUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AdminNotificationsTypesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTypesUpdate>>>
    export type V1AdminNotificationsTypesUpdateMutationBody = NotificationTypeRequest
    export type V1AdminNotificationsTypesUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1AdminNotificationsTypesUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesUpdate>>, TError,{uid: string;data: NotificationTypeRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AdminNotificationsTypesUpdate>>,
        TError,
        {uid: string;data: NotificationTypeRequest},
        TContext
      > => {
      return useMutation(getV1AdminNotificationsTypesUpdateMutationOptions(options), queryClient);
    }

export type v1AdminNotificationsTypesPartialUpdateResponse200 = {
  data: NotificationType
  status: 200
}

export type v1AdminNotificationsTypesPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTypesPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTypesPartialUpdateResponseSuccess = (v1AdminNotificationsTypesPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1AdminNotificationsTypesPartialUpdateResponseError = (v1AdminNotificationsTypesPartialUpdateResponse401 | v1AdminNotificationsTypesPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTypesPartialUpdateResponse = (v1AdminNotificationsTypesPartialUpdateResponseSuccess | v1AdminNotificationsTypesPartialUpdateResponseError)

export const getV1AdminNotificationsTypesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/types/${uid}/`
}

export const v1AdminNotificationsTypesPartialUpdate = async (uid: string,
    patchedNotificationTypeRequest?: PatchedNotificationTypeRequest, options?: RequestInit): Promise<v1AdminNotificationsTypesPartialUpdateResponse> => {

  return customFetch<v1AdminNotificationsTypesPartialUpdateResponse>(getV1AdminNotificationsTypesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedNotificationTypeRequest)
  }
);}




export const getV1AdminNotificationsTypesPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesPartialUpdate>>, TError,{uid: string;data?: PatchedNotificationTypeRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesPartialUpdate>>, TError,{uid: string;data?: PatchedNotificationTypeRequest}, TContext> => {

const mutationKey = ['v1AdminNotificationsTypesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AdminNotificationsTypesPartialUpdate>>, {uid: string;data?: PatchedNotificationTypeRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1AdminNotificationsTypesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AdminNotificationsTypesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTypesPartialUpdate>>>
    export type V1AdminNotificationsTypesPartialUpdateMutationBody = PatchedNotificationTypeRequest | undefined
    export type V1AdminNotificationsTypesPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1AdminNotificationsTypesPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesPartialUpdate>>, TError,{uid: string;data?: PatchedNotificationTypeRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AdminNotificationsTypesPartialUpdate>>,
        TError,
        {uid: string;data?: PatchedNotificationTypeRequest},
        TContext
      > => {
      return useMutation(getV1AdminNotificationsTypesPartialUpdateMutationOptions(options), queryClient);
    }

export type v1AdminNotificationsTypesDestroyResponse204 = {
  data: void
  status: 204
}

export type v1AdminNotificationsTypesDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1AdminNotificationsTypesDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1AdminNotificationsTypesDestroyResponseSuccess = (v1AdminNotificationsTypesDestroyResponse204) & {
  headers: Headers;
};
export type v1AdminNotificationsTypesDestroyResponseError = (v1AdminNotificationsTypesDestroyResponse401 | v1AdminNotificationsTypesDestroyResponse410) & {
  headers: Headers;
};

export type v1AdminNotificationsTypesDestroyResponse = (v1AdminNotificationsTypesDestroyResponseSuccess | v1AdminNotificationsTypesDestroyResponseError)

export const getV1AdminNotificationsTypesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/types/${uid}/`
}

export const v1AdminNotificationsTypesDestroy = async (uid: string, options?: RequestInit): Promise<v1AdminNotificationsTypesDestroyResponse> => {

  return customFetch<v1AdminNotificationsTypesDestroyResponse>(getV1AdminNotificationsTypesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getV1AdminNotificationsTypesDestroyMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesDestroy>>, TError,{uid: string}, TContext> => {

const mutationKey = ['v1AdminNotificationsTypesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1AdminNotificationsTypesDestroy>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  v1AdminNotificationsTypesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1AdminNotificationsTypesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1AdminNotificationsTypesDestroy>>>

    export type V1AdminNotificationsTypesDestroyMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1AdminNotificationsTypesDestroy = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1AdminNotificationsTypesDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1AdminNotificationsTypesDestroy>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getV1AdminNotificationsTypesDestroyMutationOptions(options), queryClient);
    }

export type avatarOptionsResponse200 = {
  data: AvatarOptions
  status: 200
}

export type avatarOptionsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type avatarOptionsResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type avatarOptionsResponseSuccess = (avatarOptionsResponse200) & {
  headers: Headers;
};
export type avatarOptionsResponseError = (avatarOptionsResponse401 | avatarOptionsResponse410) & {
  headers: Headers;
};

export type avatarOptionsResponse = (avatarOptionsResponseSuccess | avatarOptionsResponseError)

export const getAvatarOptionsUrl = () => {




  return `/api/v1/avatars/options/`
}

/**
 * `GET /api/v1/avatars/options/` — the native-keyed options overlay.
 * @summary Katalog opcji awatara (wymiary, warianty, podglądy)
 */
export const avatarOptions = async ( options?: RequestInit): Promise<avatarOptionsResponse> => {

  return customFetch<avatarOptionsResponse>(getAvatarOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAvatarOptionsQueryKey = () => {
    return [
    `/api/v1/avatars/options/`
    ] as const;
    }


export const getAvatarOptionsQueryOptions = <TData = Awaited<ReturnType<typeof avatarOptions>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAvatarOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof avatarOptions>>> = ({ signal }) => avatarOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof avatarOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AvatarOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof avatarOptions>>>
export type AvatarOptionsQueryError = UnauthorizedResponse | AccountGoneResponse


export function useAvatarOptions<TData = Awaited<ReturnType<typeof avatarOptions>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof avatarOptions>>,
          TError,
          Awaited<ReturnType<typeof avatarOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAvatarOptions<TData = Awaited<ReturnType<typeof avatarOptions>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof avatarOptions>>,
          TError,
          Awaited<ReturnType<typeof avatarOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAvatarOptions<TData = Awaited<ReturnType<typeof avatarOptions>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Katalog opcji awatara (wymiary, warianty, podglądy)
 */

export function useAvatarOptions<TData = Awaited<ReturnType<typeof avatarOptions>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAvatarOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type avatarStyleResponse200 = {
  data: AvatarStyle
  status: 200
}

export type avatarStyleResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type avatarStyleResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type avatarStyleResponseSuccess = (avatarStyleResponse200) & {
  headers: Headers;
};
export type avatarStyleResponseError = (avatarStyleResponse401 | avatarStyleResponse410) & {
  headers: Headers;
};

export type avatarStyleResponse = (avatarStyleResponseSuccess | avatarStyleResponseError)

export const getAvatarStyleUrl = () => {




  return `/api/v1/avatars/style/`
}

/**
 * `GET /api/v1/avatars/style/` — the artwork, so a client can draw it itself.
 *
 * Exists because no other endpoint yields a *composite* preview. Every catalog
 * control shows one option in isolation, so the creator can show "grey" and
 * "happy eyes" as swatches but never the student's own assembly reacting to a
 * colour drag. Serving the definition lets the panel render that locally, with
 * no round-trip per interaction (B1 removed the server-side render seam this
 * once needed to stay honest against).
 *
 * `artwork_hash` is the definition file's own hash — the version tag every
 * client-side render should key its cache on.
 *
 * Authorization is the global default `IsAuthenticated`, as on the options
 * endpoint beside it.
 *
 * Unlike that endpoint this one sets `Cache-Control`. `private` because the
 * response sits behind a session cookie (the middleware appends `Vary: Cookie`
 * after the view returns), and `no-cache` — store it, but revalidate — because
 * the active style can rotate at any time (an admin activating a different
 * upload changes `artwork_hash` with no deploy involved), and the whole point
 * is to fetch once and then pay a bodiless 304 until that ETag actually moves.
 *
 * The definition is ~49 KB of SVG and deflates about tenfold, so the gzipped twin
 * `style_document` caches is served to any client that advertises it. That is done
 * here rather than through `GZipMiddleware` on purpose: the middleware would append
 * `;gzip` to the outgoing ETag and break the exact-string comparison below, and it
 * is a stack-wide decision besides. `etag_matches` normalises that suffix away
 * anyway, so the conditional GET keeps paying even if a middleware or an
 * intermediary reintroduces it.
 * @summary Definicja stylu awatara (do renderowania po stronie klienta)
 */
export const avatarStyle = async ( options?: RequestInit): Promise<avatarStyleResponse> => {

  return customFetch<avatarStyleResponse>(getAvatarStyleUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAvatarStyleQueryKey = () => {
    return [
    `/api/v1/avatars/style/`
    ] as const;
    }


export const getAvatarStyleQueryOptions = <TData = Awaited<ReturnType<typeof avatarStyle>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarStyle>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAvatarStyleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof avatarStyle>>> = ({ signal }) => avatarStyle({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof avatarStyle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AvatarStyleQueryResult = NonNullable<Awaited<ReturnType<typeof avatarStyle>>>
export type AvatarStyleQueryError = UnauthorizedResponse | AccountGoneResponse


export function useAvatarStyle<TData = Awaited<ReturnType<typeof avatarStyle>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarStyle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof avatarStyle>>,
          TError,
          Awaited<ReturnType<typeof avatarStyle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAvatarStyle<TData = Awaited<ReturnType<typeof avatarStyle>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarStyle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof avatarStyle>>,
          TError,
          Awaited<ReturnType<typeof avatarStyle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAvatarStyle<TData = Awaited<ReturnType<typeof avatarStyle>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarStyle>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Definicja stylu awatara (do renderowania po stronie klienta)
 */

export function useAvatarStyle<TData = Awaited<ReturnType<typeof avatarStyle>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarStyle>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAvatarStyleQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BarometerChestClaimsListResponse200 = {
  data: PaginatedChestClaimPullList
  status: 200
}

export type v1BarometerChestClaimsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BarometerChestClaimsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BarometerChestClaimsListResponseSuccess = (v1BarometerChestClaimsListResponse200) & {
  headers: Headers;
};
export type v1BarometerChestClaimsListResponseError = (v1BarometerChestClaimsListResponse401 | v1BarometerChestClaimsListResponse410) & {
  headers: Headers;
};

export type v1BarometerChestClaimsListResponse = (v1BarometerChestClaimsListResponseSuccess | v1BarometerChestClaimsListResponseError)

export const getV1BarometerChestClaimsListUrl = (params?: V1BarometerChestClaimsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/barometer/chest-claims/?${stringifiedParams}` : `/api/v1/barometer/chest-claims/`
}

/**
 * Historia odbiorów skrzynki wraz z ich rozliczeniem (cloud restore).
 *
 * Owner scoping, filtr `updated_since` i koperta kursora są dziedziczone z
 * `SyncPullView`. Push (wyłącznie `create`) jedzie wspólnym
 * `POST /api/v1/sync/operations/`.
 */
export const v1BarometerChestClaimsList = async (params?: V1BarometerChestClaimsListParams, options?: RequestInit): Promise<v1BarometerChestClaimsListResponse> => {

  return customFetch<v1BarometerChestClaimsListResponse>(getV1BarometerChestClaimsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1BarometerChestClaimsListQueryKey = (params?: V1BarometerChestClaimsListParams,) => {
    return [
    `/api/v1/barometer/chest-claims/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1BarometerChestClaimsListQueryOptions = <TData = Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1BarometerChestClaimsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1BarometerChestClaimsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1BarometerChestClaimsList>>> = ({ signal }) => v1BarometerChestClaimsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1BarometerChestClaimsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1BarometerChestClaimsList>>>
export type V1BarometerChestClaimsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1BarometerChestClaimsList<TData = Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1BarometerChestClaimsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BarometerChestClaimsList>>,
          TError,
          Awaited<ReturnType<typeof v1BarometerChestClaimsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BarometerChestClaimsList<TData = Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BarometerChestClaimsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BarometerChestClaimsList>>,
          TError,
          Awaited<ReturnType<typeof v1BarometerChestClaimsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BarometerChestClaimsList<TData = Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BarometerChestClaimsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1BarometerChestClaimsList<TData = Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BarometerChestClaimsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BarometerChestClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1BarometerChestClaimsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BudgetCatalogsRetrieveResponse200 = {
  data: Catalogs
  status: 200
}

export type v1BudgetCatalogsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BudgetCatalogsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BudgetCatalogsRetrieveResponseSuccess = (v1BudgetCatalogsRetrieveResponse200) & {
  headers: Headers;
};
export type v1BudgetCatalogsRetrieveResponseError = (v1BudgetCatalogsRetrieveResponse401 | v1BudgetCatalogsRetrieveResponse410) & {
  headers: Headers;
};

export type v1BudgetCatalogsRetrieveResponse = (v1BudgetCatalogsRetrieveResponseSuccess | v1BudgetCatalogsRetrieveResponseError)

export const getV1BudgetCatalogsRetrieveUrl = () => {




  return `/api/v1/budget/catalogs/`
}

/**
 * `GET /api/v1/budget/catalogs/` — the four budget reference dictionaries.
 * @summary Katalogi referencyjne budżetu (słowniki jako dane)
 */
export const v1BudgetCatalogsRetrieve = async ( options?: RequestInit): Promise<v1BudgetCatalogsRetrieveResponse> => {

  return customFetch<v1BudgetCatalogsRetrieveResponse>(getV1BudgetCatalogsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1BudgetCatalogsRetrieveQueryKey = () => {
    return [
    `/api/v1/budget/catalogs/`
    ] as const;
    }


export const getV1BudgetCatalogsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1BudgetCatalogsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>> = ({ signal }) => v1BudgetCatalogsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1BudgetCatalogsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>>
export type V1BudgetCatalogsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1BudgetCatalogsRetrieve<TData = Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetCatalogsRetrieve<TData = Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetCatalogsRetrieve<TData = Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Katalogi referencyjne budżetu (słowniki jako dane)
 */

export function useV1BudgetCatalogsRetrieve<TData = Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCatalogsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1BudgetCatalogsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BudgetCategoryLimitsListResponse200 = {
  data: PaginatedCategoryLimitPullList
  status: 200
}

export type v1BudgetCategoryLimitsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BudgetCategoryLimitsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BudgetCategoryLimitsListResponseSuccess = (v1BudgetCategoryLimitsListResponse200) & {
  headers: Headers;
};
export type v1BudgetCategoryLimitsListResponseError = (v1BudgetCategoryLimitsListResponse401 | v1BudgetCategoryLimitsListResponse410) & {
  headers: Headers;
};

export type v1BudgetCategoryLimitsListResponse = (v1BudgetCategoryLimitsListResponseSuccess | v1BudgetCategoryLimitsListResponseError)

export const getV1BudgetCategoryLimitsListUrl = (params?: V1BudgetCategoryLimitsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/budget/category-limits/?${stringifiedParams}` : `/api/v1/budget/category-limits/`
}

/**
 * Base GET view for pulling a syncable entity to a fresh device.
 *
 * Subclasses set `queryset`/`model` + `serializer_class`. Owner scoping and the
 * `updated_since` filter are applied here; tombstones are intentionally retained.
 */
export const v1BudgetCategoryLimitsList = async (params?: V1BudgetCategoryLimitsListParams, options?: RequestInit): Promise<v1BudgetCategoryLimitsListResponse> => {

  return customFetch<v1BudgetCategoryLimitsListResponse>(getV1BudgetCategoryLimitsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1BudgetCategoryLimitsListQueryKey = (params?: V1BudgetCategoryLimitsListParams,) => {
    return [
    `/api/v1/budget/category-limits/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1BudgetCategoryLimitsListQueryOptions = <TData = Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1BudgetCategoryLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1BudgetCategoryLimitsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>> = ({ signal }) => v1BudgetCategoryLimitsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1BudgetCategoryLimitsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>>
export type V1BudgetCategoryLimitsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1BudgetCategoryLimitsList<TData = Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1BudgetCategoryLimitsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetCategoryLimitsList<TData = Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetCategoryLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetCategoryLimitsList<TData = Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetCategoryLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1BudgetCategoryLimitsList<TData = Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetCategoryLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetCategoryLimitsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1BudgetCategoryLimitsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BudgetEntriesListResponse200 = {
  data: PaginatedBudgetEntryPullList
  status: 200
}

export type v1BudgetEntriesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BudgetEntriesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BudgetEntriesListResponseSuccess = (v1BudgetEntriesListResponse200) & {
  headers: Headers;
};
export type v1BudgetEntriesListResponseError = (v1BudgetEntriesListResponse401 | v1BudgetEntriesListResponse410) & {
  headers: Headers;
};

export type v1BudgetEntriesListResponse = (v1BudgetEntriesListResponseSuccess | v1BudgetEntriesListResponseError)

export const getV1BudgetEntriesListUrl = (params?: V1BudgetEntriesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/budget/entries/?${stringifiedParams}` : `/api/v1/budget/entries/`
}

/**
 * Pull the account's budget history on a fresh device (cloud restore).
 *
 * Owner scoping, the `updated_since` filter, tombstone retention, and the cursor
 * envelope are inherited from `SyncPullView`/`SyncCursorPagination`. Push
 * (create/update/delete) rides the shared `POST /api/v1/sync/operations/`.
 */
export const v1BudgetEntriesList = async (params?: V1BudgetEntriesListParams, options?: RequestInit): Promise<v1BudgetEntriesListResponse> => {

  return customFetch<v1BudgetEntriesListResponse>(getV1BudgetEntriesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1BudgetEntriesListQueryKey = (params?: V1BudgetEntriesListParams,) => {
    return [
    `/api/v1/budget/entries/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1BudgetEntriesListQueryOptions = <TData = Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1BudgetEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1BudgetEntriesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1BudgetEntriesList>>> = ({ signal }) => v1BudgetEntriesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1BudgetEntriesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1BudgetEntriesList>>>
export type V1BudgetEntriesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1BudgetEntriesList<TData = Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1BudgetEntriesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetEntriesList>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetEntriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetEntriesList<TData = Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetEntriesList>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetEntriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetEntriesList<TData = Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1BudgetEntriesList<TData = Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1BudgetEntriesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BudgetMonthOpeningsListResponse200 = {
  data: PaginatedMonthOpeningPullList
  status: 200
}

export type v1BudgetMonthOpeningsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BudgetMonthOpeningsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BudgetMonthOpeningsListResponseSuccess = (v1BudgetMonthOpeningsListResponse200) & {
  headers: Headers;
};
export type v1BudgetMonthOpeningsListResponseError = (v1BudgetMonthOpeningsListResponse401 | v1BudgetMonthOpeningsListResponse410) & {
  headers: Headers;
};

export type v1BudgetMonthOpeningsListResponse = (v1BudgetMonthOpeningsListResponseSuccess | v1BudgetMonthOpeningsListResponseError)

export const getV1BudgetMonthOpeningsListUrl = (params?: V1BudgetMonthOpeningsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/budget/month-openings/?${stringifiedParams}` : `/api/v1/budget/month-openings/`
}

/**
 * Pull potwierdzeń salda na świeżym urządzeniu (odtworzenie z chmury).
 *
 * Zakres właściciela, filtr `updated_since`, retencja tombstone'ów i koperta
 * kursora są dziedziczone z `SyncPullView`. Push jedzie wspólnym
 * `POST /api/v1/sync/operations/`.
 */
export const v1BudgetMonthOpeningsList = async (params?: V1BudgetMonthOpeningsListParams, options?: RequestInit): Promise<v1BudgetMonthOpeningsListResponse> => {

  return customFetch<v1BudgetMonthOpeningsListResponse>(getV1BudgetMonthOpeningsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1BudgetMonthOpeningsListQueryKey = (params?: V1BudgetMonthOpeningsListParams,) => {
    return [
    `/api/v1/budget/month-openings/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1BudgetMonthOpeningsListQueryOptions = <TData = Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1BudgetMonthOpeningsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1BudgetMonthOpeningsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>> = ({ signal }) => v1BudgetMonthOpeningsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1BudgetMonthOpeningsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>>
export type V1BudgetMonthOpeningsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1BudgetMonthOpeningsList<TData = Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1BudgetMonthOpeningsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetMonthOpeningsList<TData = Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetMonthOpeningsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetMonthOpeningsList<TData = Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetMonthOpeningsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1BudgetMonthOpeningsList<TData = Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetMonthOpeningsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthOpeningsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1BudgetMonthOpeningsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BudgetMonthlyLimitsListResponse200 = {
  data: PaginatedMonthlyLimitPullList
  status: 200
}

export type v1BudgetMonthlyLimitsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BudgetMonthlyLimitsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BudgetMonthlyLimitsListResponseSuccess = (v1BudgetMonthlyLimitsListResponse200) & {
  headers: Headers;
};
export type v1BudgetMonthlyLimitsListResponseError = (v1BudgetMonthlyLimitsListResponse401 | v1BudgetMonthlyLimitsListResponse410) & {
  headers: Headers;
};

export type v1BudgetMonthlyLimitsListResponse = (v1BudgetMonthlyLimitsListResponseSuccess | v1BudgetMonthlyLimitsListResponseError)

export const getV1BudgetMonthlyLimitsListUrl = (params?: V1BudgetMonthlyLimitsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/budget/monthly-limits/?${stringifiedParams}` : `/api/v1/budget/monthly-limits/`
}

/**
 * Base GET view for pulling a syncable entity to a fresh device.
 *
 * Subclasses set `queryset`/`model` + `serializer_class`. Owner scoping and the
 * `updated_since` filter are applied here; tombstones are intentionally retained.
 */
export const v1BudgetMonthlyLimitsList = async (params?: V1BudgetMonthlyLimitsListParams, options?: RequestInit): Promise<v1BudgetMonthlyLimitsListResponse> => {

  return customFetch<v1BudgetMonthlyLimitsListResponse>(getV1BudgetMonthlyLimitsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1BudgetMonthlyLimitsListQueryKey = (params?: V1BudgetMonthlyLimitsListParams,) => {
    return [
    `/api/v1/budget/monthly-limits/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1BudgetMonthlyLimitsListQueryOptions = <TData = Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1BudgetMonthlyLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1BudgetMonthlyLimitsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>> = ({ signal }) => v1BudgetMonthlyLimitsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1BudgetMonthlyLimitsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>>
export type V1BudgetMonthlyLimitsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1BudgetMonthlyLimitsList<TData = Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1BudgetMonthlyLimitsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetMonthlyLimitsList<TData = Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetMonthlyLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetMonthlyLimitsList<TData = Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetMonthlyLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1BudgetMonthlyLimitsList<TData = Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetMonthlyLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetMonthlyLimitsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1BudgetMonthlyLimitsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BudgetWhimsLimitsListResponse200 = {
  data: PaginatedWhimsLimitPullList
  status: 200
}

export type v1BudgetWhimsLimitsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BudgetWhimsLimitsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BudgetWhimsLimitsListResponseSuccess = (v1BudgetWhimsLimitsListResponse200) & {
  headers: Headers;
};
export type v1BudgetWhimsLimitsListResponseError = (v1BudgetWhimsLimitsListResponse401 | v1BudgetWhimsLimitsListResponse410) & {
  headers: Headers;
};

export type v1BudgetWhimsLimitsListResponse = (v1BudgetWhimsLimitsListResponseSuccess | v1BudgetWhimsLimitsListResponseError)

export const getV1BudgetWhimsLimitsListUrl = (params?: V1BudgetWhimsLimitsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/budget/whims-limits/?${stringifiedParams}` : `/api/v1/budget/whims-limits/`
}

/**
 * Base GET view for pulling a syncable entity to a fresh device.
 *
 * Subclasses set `queryset`/`model` + `serializer_class`. Owner scoping and the
 * `updated_since` filter are applied here; tombstones are intentionally retained.
 */
export const v1BudgetWhimsLimitsList = async (params?: V1BudgetWhimsLimitsListParams, options?: RequestInit): Promise<v1BudgetWhimsLimitsListResponse> => {

  return customFetch<v1BudgetWhimsLimitsListResponse>(getV1BudgetWhimsLimitsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1BudgetWhimsLimitsListQueryKey = (params?: V1BudgetWhimsLimitsListParams,) => {
    return [
    `/api/v1/budget/whims-limits/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1BudgetWhimsLimitsListQueryOptions = <TData = Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1BudgetWhimsLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1BudgetWhimsLimitsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>> = ({ signal }) => v1BudgetWhimsLimitsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1BudgetWhimsLimitsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>>
export type V1BudgetWhimsLimitsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1BudgetWhimsLimitsList<TData = Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1BudgetWhimsLimitsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetWhimsLimitsList<TData = Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetWhimsLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>,
          TError,
          Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BudgetWhimsLimitsList<TData = Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetWhimsLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1BudgetWhimsLimitsList<TData = Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BudgetWhimsLimitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BudgetWhimsLimitsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1BudgetWhimsLimitsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BugReportsCreateResponse201 = {
  data: BugReportCreate
  status: 201
}

export type v1BugReportsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BugReportsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BugReportsCreateResponseSuccess = (v1BugReportsCreateResponse201) & {
  headers: Headers;
};
export type v1BugReportsCreateResponseError = (v1BugReportsCreateResponse401 | v1BugReportsCreateResponse410) & {
  headers: Headers;
};

export type v1BugReportsCreateResponse = (v1BugReportsCreateResponseSuccess | v1BugReportsCreateResponseError)

export const getV1BugReportsCreateUrl = () => {




  return `/api/v1/bug-reports/`
}

export const v1BugReportsCreate = async (bugReportCreateRequest: BugReportCreateRequest, options?: RequestInit): Promise<v1BugReportsCreateResponse> => {

  return customFetch<v1BugReportsCreateResponse>(getV1BugReportsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bugReportCreateRequest)
  }
);}




export const getV1BugReportsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1BugReportsCreate>>, TError,{data: BugReportCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1BugReportsCreate>>, TError,{data: BugReportCreateRequest}, TContext> => {

const mutationKey = ['v1BugReportsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1BugReportsCreate>>, {data: BugReportCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1BugReportsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1BugReportsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1BugReportsCreate>>>
    export type V1BugReportsCreateMutationBody = BugReportCreateRequest
    export type V1BugReportsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1BugReportsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1BugReportsCreate>>, TError,{data: BugReportCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1BugReportsCreate>>,
        TError,
        {data: BugReportCreateRequest},
        TContext
      > => {
      return useMutation(getV1BugReportsCreateMutationOptions(options), queryClient);
    }

export type v1BulkOperationsListResponse200 = {
  data: PaginatedBulkOperationRequestList
  status: 200
}

export type v1BulkOperationsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BulkOperationsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BulkOperationsListResponseSuccess = (v1BulkOperationsListResponse200) & {
  headers: Headers;
};
export type v1BulkOperationsListResponseError = (v1BulkOperationsListResponse401 | v1BulkOperationsListResponse410) & {
  headers: Headers;
};

export type v1BulkOperationsListResponse = (v1BulkOperationsListResponseSuccess | v1BulkOperationsListResponseError)

export const getV1BulkOperationsListUrl = (params?: V1BulkOperationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/bulk-operations/?${stringifiedParams}` : `/api/v1/bulk-operations/`
}

/**
 * Read + decision surface for bulk-operation requests. Operators only.
 * @summary Lista operacji masowych
 */
export const v1BulkOperationsList = async (params?: V1BulkOperationsListParams, options?: RequestInit): Promise<v1BulkOperationsListResponse> => {

  return customFetch<v1BulkOperationsListResponse>(getV1BulkOperationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1BulkOperationsListQueryKey = (params?: V1BulkOperationsListParams,) => {
    return [
    `/api/v1/bulk-operations/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1BulkOperationsListQueryOptions = <TData = Awaited<ReturnType<typeof v1BulkOperationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1BulkOperationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1BulkOperationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1BulkOperationsList>>> = ({ signal }) => v1BulkOperationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1BulkOperationsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1BulkOperationsList>>>
export type V1BulkOperationsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1BulkOperationsList<TData = Awaited<ReturnType<typeof v1BulkOperationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1BulkOperationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BulkOperationsList>>,
          TError,
          Awaited<ReturnType<typeof v1BulkOperationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BulkOperationsList<TData = Awaited<ReturnType<typeof v1BulkOperationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BulkOperationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BulkOperationsList>>,
          TError,
          Awaited<ReturnType<typeof v1BulkOperationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BulkOperationsList<TData = Awaited<ReturnType<typeof v1BulkOperationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BulkOperationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista operacji masowych
 */

export function useV1BulkOperationsList<TData = Awaited<ReturnType<typeof v1BulkOperationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1BulkOperationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1BulkOperationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BulkOperationsRetrieveResponse200 = {
  data: BulkOperationRequest
  status: 200
}

export type v1BulkOperationsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BulkOperationsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BulkOperationsRetrieveResponseSuccess = (v1BulkOperationsRetrieveResponse200) & {
  headers: Headers;
};
export type v1BulkOperationsRetrieveResponseError = (v1BulkOperationsRetrieveResponse401 | v1BulkOperationsRetrieveResponse410) & {
  headers: Headers;
};

export type v1BulkOperationsRetrieveResponse = (v1BulkOperationsRetrieveResponseSuccess | v1BulkOperationsRetrieveResponseError)

export const getV1BulkOperationsRetrieveUrl = (id: number,) => {




  return `/api/v1/bulk-operations/${id}/`
}

/**
 * Read + decision surface for bulk-operation requests. Operators only.
 */
export const v1BulkOperationsRetrieve = async (id: number, options?: RequestInit): Promise<v1BulkOperationsRetrieveResponse> => {

  return customFetch<v1BulkOperationsRetrieveResponse>(getV1BulkOperationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1BulkOperationsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/v1/bulk-operations/${id}/`
    ] as const;
    }


export const getV1BulkOperationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1BulkOperationsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>> = ({ signal }) => v1BulkOperationsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1BulkOperationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>>
export type V1BulkOperationsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1BulkOperationsRetrieve<TData = Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BulkOperationsRetrieve<TData = Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BulkOperationsRetrieve<TData = Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1BulkOperationsRetrieve<TData = Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1BulkOperationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BulkOperationsDecisionCreateResponse200 = {
  data: BulkOperationRequest
  status: 200
}

export type v1BulkOperationsDecisionCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BulkOperationsDecisionCreateResponse403 = {
  data: void
  status: 403
}

export type v1BulkOperationsDecisionCreateResponse409 = {
  data: void
  status: 409
}

export type v1BulkOperationsDecisionCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BulkOperationsDecisionCreateResponseSuccess = (v1BulkOperationsDecisionCreateResponse200) & {
  headers: Headers;
};
export type v1BulkOperationsDecisionCreateResponseError = (v1BulkOperationsDecisionCreateResponse401 | v1BulkOperationsDecisionCreateResponse403 | v1BulkOperationsDecisionCreateResponse409 | v1BulkOperationsDecisionCreateResponse410) & {
  headers: Headers;
};

export type v1BulkOperationsDecisionCreateResponse = (v1BulkOperationsDecisionCreateResponseSuccess | v1BulkOperationsDecisionCreateResponseError)

export const getV1BulkOperationsDecisionCreateUrl = (id: number,) => {




  return `/api/v1/bulk-operations/${id}/decision/`
}

/**
 * Read + decision surface for bulk-operation requests. Operators only.
 * @summary Decyzja o operacji masowej (zatwierdź / odrzuć)
 */
export const v1BulkOperationsDecisionCreate = async (id: number,
    decisionRequest: DecisionRequest, options?: RequestInit): Promise<v1BulkOperationsDecisionCreateResponse> => {

  return customFetch<v1BulkOperationsDecisionCreateResponse>(getV1BulkOperationsDecisionCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(decisionRequest)
  }
);}




export const getV1BulkOperationsDecisionCreateMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1BulkOperationsDecisionCreate>>, TError,{id: number;data: DecisionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1BulkOperationsDecisionCreate>>, TError,{id: number;data: DecisionRequest}, TContext> => {

const mutationKey = ['v1BulkOperationsDecisionCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1BulkOperationsDecisionCreate>>, {id: number;data: DecisionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1BulkOperationsDecisionCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1BulkOperationsDecisionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1BulkOperationsDecisionCreate>>>
    export type V1BulkOperationsDecisionCreateMutationBody = DecisionRequest
    export type V1BulkOperationsDecisionCreateMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Decyzja o operacji masowej (zatwierdź / odrzuć)
 */
export const useV1BulkOperationsDecisionCreate = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1BulkOperationsDecisionCreate>>, TError,{id: number;data: DecisionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1BulkOperationsDecisionCreate>>,
        TError,
        {id: number;data: DecisionRequest},
        TContext
      > => {
      return useMutation(getV1BulkOperationsDecisionCreateMutationOptions(options), queryClient);
    }

export type v1BulkOperationsReportRetrieveResponse200 = {
  data: void
  status: 200
}

export type v1BulkOperationsReportRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BulkOperationsReportRetrieveResponse404 = {
  data: void
  status: 404
}

export type v1BulkOperationsReportRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BulkOperationsReportRetrieveResponseSuccess = (v1BulkOperationsReportRetrieveResponse200) & {
  headers: Headers;
};
export type v1BulkOperationsReportRetrieveResponseError = (v1BulkOperationsReportRetrieveResponse401 | v1BulkOperationsReportRetrieveResponse404 | v1BulkOperationsReportRetrieveResponse410) & {
  headers: Headers;
};

export type v1BulkOperationsReportRetrieveResponse = (v1BulkOperationsReportRetrieveResponseSuccess | v1BulkOperationsReportRetrieveResponseError)

export const getV1BulkOperationsReportRetrieveUrl = (id: number,) => {




  return `/api/v1/bulk-operations/${id}/report/`
}

/**
 * Read + decision surface for bulk-operation requests. Operators only.
 * @summary Pobranie trwałego raportu PDF operacji masowej
 */
export const v1BulkOperationsReportRetrieve = async (id: number, options?: RequestInit): Promise<v1BulkOperationsReportRetrieveResponse> => {

  return customFetch<v1BulkOperationsReportRetrieveResponse>(getV1BulkOperationsReportRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1BulkOperationsReportRetrieveQueryKey = (id: number,) => {
    return [
    `/api/v1/bulk-operations/${id}/report/`
    ] as const;
    }


export const getV1BulkOperationsReportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1BulkOperationsReportRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>> = ({ signal }) => v1BulkOperationsReportRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1BulkOperationsReportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>>
export type V1BulkOperationsReportRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1BulkOperationsReportRetrieve<TData = Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BulkOperationsReportRetrieve<TData = Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1BulkOperationsReportRetrieve<TData = Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pobranie trwałego raportu PDF operacji masowej
 */

export function useV1BulkOperationsReportRetrieve<TData = Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1BulkOperationsReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1BulkOperationsReportRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1BulkOperationsWithdrawCreateResponse200 = {
  data: BulkOperationRequest
  status: 200
}

export type v1BulkOperationsWithdrawCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1BulkOperationsWithdrawCreateResponse403 = {
  data: void
  status: 403
}

export type v1BulkOperationsWithdrawCreateResponse409 = {
  data: void
  status: 409
}

export type v1BulkOperationsWithdrawCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1BulkOperationsWithdrawCreateResponseSuccess = (v1BulkOperationsWithdrawCreateResponse200) & {
  headers: Headers;
};
export type v1BulkOperationsWithdrawCreateResponseError = (v1BulkOperationsWithdrawCreateResponse401 | v1BulkOperationsWithdrawCreateResponse403 | v1BulkOperationsWithdrawCreateResponse409 | v1BulkOperationsWithdrawCreateResponse410) & {
  headers: Headers;
};

export type v1BulkOperationsWithdrawCreateResponse = (v1BulkOperationsWithdrawCreateResponseSuccess | v1BulkOperationsWithdrawCreateResponseError)

export const getV1BulkOperationsWithdrawCreateUrl = (id: number,) => {




  return `/api/v1/bulk-operations/${id}/withdraw/`
}

/**
 * Read + decision surface for bulk-operation requests. Operators only.
 * @summary Wycofanie własnego żądania operacji masowej
 */
export const v1BulkOperationsWithdrawCreate = async (id: number, options?: RequestInit): Promise<v1BulkOperationsWithdrawCreateResponse> => {

  return customFetch<v1BulkOperationsWithdrawCreateResponse>(getV1BulkOperationsWithdrawCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1BulkOperationsWithdrawCreateMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1BulkOperationsWithdrawCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1BulkOperationsWithdrawCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1BulkOperationsWithdrawCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1BulkOperationsWithdrawCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1BulkOperationsWithdrawCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1BulkOperationsWithdrawCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1BulkOperationsWithdrawCreate>>>

    export type V1BulkOperationsWithdrawCreateMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Wycofanie własnego żądania operacji masowej
 */
export const useV1BulkOperationsWithdrawCreate = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1BulkOperationsWithdrawCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1BulkOperationsWithdrawCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1BulkOperationsWithdrawCreateMutationOptions(options), queryClient);
    }

export type v1ClassesListResponse200 = {
  data: PaginatedClassListList
  status: 200
}

export type v1ClassesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesListResponseSuccess = (v1ClassesListResponse200) & {
  headers: Headers;
};
export type v1ClassesListResponseError = (v1ClassesListResponse401 | v1ClassesListResponse410) & {
  headers: Headers;
};

export type v1ClassesListResponse = (v1ClassesListResponseSuccess | v1ClassesListResponseError)

export const getV1ClassesListUrl = (params?: V1ClassesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/classes/?${stringifiedParams}` : `/api/v1/classes/`
}

/**
 * Class CRUD + TR-602 list + archive/restore (TR-603) + delete (TR-604).
 *
 * Explicit mixin composition (not `ModelViewSet`) so no unguarded DELETE route
 * is registered — TR-604 delete is a superadmin-only named action instead.
 * @summary Lista klas (TR-602)
 */
export const v1ClassesList = async (params?: V1ClassesListParams, options?: RequestInit): Promise<v1ClassesListResponse> => {

  return customFetch<v1ClassesListResponse>(getV1ClassesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ClassesListQueryKey = (params?: V1ClassesListParams,) => {
    return [
    `/api/v1/classes/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1ClassesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ClassesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1ClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ClassesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ClassesList>>> = ({ signal }) => v1ClassesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ClassesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ClassesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ClassesList>>>
export type V1ClassesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1ClassesList<TData = Awaited<ReturnType<typeof v1ClassesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1ClassesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ClassesList>>,
          TError,
          Awaited<ReturnType<typeof v1ClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ClassesList<TData = Awaited<ReturnType<typeof v1ClassesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1ClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ClassesList>>,
          TError,
          Awaited<ReturnType<typeof v1ClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ClassesList<TData = Awaited<ReturnType<typeof v1ClassesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1ClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista klas (TR-602)
 */

export function useV1ClassesList<TData = Awaited<ReturnType<typeof v1ClassesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1ClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ClassesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ClassesCreateResponse201 = {
  data: Class
  status: 201
}

export type v1ClassesCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesCreateResponseSuccess = (v1ClassesCreateResponse201) & {
  headers: Headers;
};
export type v1ClassesCreateResponseError = (v1ClassesCreateResponse401 | v1ClassesCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesCreateResponse = (v1ClassesCreateResponseSuccess | v1ClassesCreateResponseError)

export const getV1ClassesCreateUrl = () => {




  return `/api/v1/classes/`
}

/**
 * Class CRUD + TR-602 list + archive/restore (TR-603) + delete (TR-604).
 *
 * Explicit mixin composition (not `ModelViewSet`) so no unguarded DELETE route
 * is registered — TR-604 delete is a superadmin-only named action instead.
 * @summary Założenie klasy (TR-600)
 */
export const v1ClassesCreate = async (classRequest: ClassRequest, options?: RequestInit): Promise<v1ClassesCreateResponse> => {

  return customFetch<v1ClassesCreateResponse>(getV1ClassesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(classRequest)
  }
);}




export const getV1ClassesCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesCreate>>, TError,{data: ClassRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesCreate>>, TError,{data: ClassRequest}, TContext> => {

const mutationKey = ['v1ClassesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesCreate>>, {data: ClassRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1ClassesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesCreate>>>
    export type V1ClassesCreateMutationBody = ClassRequest
    export type V1ClassesCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Założenie klasy (TR-600)
 */
export const useV1ClassesCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesCreate>>, TError,{data: ClassRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesCreate>>,
        TError,
        {data: ClassRequest},
        TContext
      > => {
      return useMutation(getV1ClassesCreateMutationOptions(options), queryClient);
    }

export type v1ClassesRetrieveResponse200 = {
  data: Class
  status: 200
}

export type v1ClassesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesRetrieveResponseSuccess = (v1ClassesRetrieveResponse200) & {
  headers: Headers;
};
export type v1ClassesRetrieveResponseError = (v1ClassesRetrieveResponse401 | v1ClassesRetrieveResponse410) & {
  headers: Headers;
};

export type v1ClassesRetrieveResponse = (v1ClassesRetrieveResponseSuccess | v1ClassesRetrieveResponseError)

export const getV1ClassesRetrieveUrl = (id: number,) => {




  return `/api/v1/classes/${id}/`
}

/**
 * Class CRUD + TR-602 list + archive/restore (TR-603) + delete (TR-604).
 *
 * Explicit mixin composition (not `ModelViewSet`) so no unguarded DELETE route
 * is registered — TR-604 delete is a superadmin-only named action instead.
 * @summary Szczegóły klasy (TR-600/601)
 */
export const v1ClassesRetrieve = async (id: number, options?: RequestInit): Promise<v1ClassesRetrieveResponse> => {

  return customFetch<v1ClassesRetrieveResponse>(getV1ClassesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ClassesRetrieveQueryKey = (id: number,) => {
    return [
    `/api/v1/classes/${id}/`
    ] as const;
    }


export const getV1ClassesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ClassesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ClassesRetrieve>>> = ({ signal }) => v1ClassesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ClassesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ClassesRetrieve>>>
export type V1ClassesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1ClassesRetrieve<TData = Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ClassesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ClassesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ClassesRetrieve<TData = Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ClassesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ClassesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ClassesRetrieve<TData = Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły klasy (TR-600/601)
 */

export function useV1ClassesRetrieve<TData = Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ClassesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ClassesUpdateResponse200 = {
  data: Class
  status: 200
}

export type v1ClassesUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesUpdateResponseSuccess = (v1ClassesUpdateResponse200) & {
  headers: Headers;
};
export type v1ClassesUpdateResponseError = (v1ClassesUpdateResponse401 | v1ClassesUpdateResponse410) & {
  headers: Headers;
};

export type v1ClassesUpdateResponse = (v1ClassesUpdateResponseSuccess | v1ClassesUpdateResponseError)

export const getV1ClassesUpdateUrl = (id: number,) => {




  return `/api/v1/classes/${id}/`
}

/**
 * Class CRUD + TR-602 list + archive/restore (TR-603) + delete (TR-604).
 *
 * Explicit mixin composition (not `ModelViewSet`) so no unguarded DELETE route
 * is registered — TR-604 delete is a superadmin-only named action instead.
 * @summary Edycja klasy (TR-601)
 */
export const v1ClassesUpdate = async (id: number,
    classRequest: ClassRequest, options?: RequestInit): Promise<v1ClassesUpdateResponse> => {

  return customFetch<v1ClassesUpdateResponse>(getV1ClassesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(classRequest)
  }
);}




export const getV1ClassesUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesUpdate>>, TError,{id: number;data: ClassRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesUpdate>>, TError,{id: number;data: ClassRequest}, TContext> => {

const mutationKey = ['v1ClassesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesUpdate>>, {id: number;data: ClassRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ClassesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesUpdate>>>
    export type V1ClassesUpdateMutationBody = ClassRequest
    export type V1ClassesUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Edycja klasy (TR-601)
 */
export const useV1ClassesUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesUpdate>>, TError,{id: number;data: ClassRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesUpdate>>,
        TError,
        {id: number;data: ClassRequest},
        TContext
      > => {
      return useMutation(getV1ClassesUpdateMutationOptions(options), queryClient);
    }

export type v1ClassesPartialUpdateResponse200 = {
  data: Class
  status: 200
}

export type v1ClassesPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesPartialUpdateResponseSuccess = (v1ClassesPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1ClassesPartialUpdateResponseError = (v1ClassesPartialUpdateResponse401 | v1ClassesPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1ClassesPartialUpdateResponse = (v1ClassesPartialUpdateResponseSuccess | v1ClassesPartialUpdateResponseError)

export const getV1ClassesPartialUpdateUrl = (id: number,) => {




  return `/api/v1/classes/${id}/`
}

/**
 * Class CRUD + TR-602 list + archive/restore (TR-603) + delete (TR-604).
 *
 * Explicit mixin composition (not `ModelViewSet`) so no unguarded DELETE route
 * is registered — TR-604 delete is a superadmin-only named action instead.
 * @summary Częściowa edycja klasy (TR-601)
 */
export const v1ClassesPartialUpdate = async (id: number,
    patchedClassRequest?: PatchedClassRequest, options?: RequestInit): Promise<v1ClassesPartialUpdateResponse> => {

  return customFetch<v1ClassesPartialUpdateResponse>(getV1ClassesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedClassRequest)
  }
);}




export const getV1ClassesPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesPartialUpdate>>, TError,{id: number;data?: PatchedClassRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesPartialUpdate>>, TError,{id: number;data?: PatchedClassRequest}, TContext> => {

const mutationKey = ['v1ClassesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesPartialUpdate>>, {id: number;data?: PatchedClassRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ClassesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesPartialUpdate>>>
    export type V1ClassesPartialUpdateMutationBody = PatchedClassRequest | undefined
    export type V1ClassesPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Częściowa edycja klasy (TR-601)
 */
export const useV1ClassesPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesPartialUpdate>>, TError,{id: number;data?: PatchedClassRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedClassRequest},
        TContext
      > => {
      return useMutation(getV1ClassesPartialUpdateMutationOptions(options), queryClient);
    }

export type v1ClassesArchiveCreateResponse200 = {
  data: Class
  status: 200
}

export type v1ClassesArchiveCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesArchiveCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesArchiveCreateResponseSuccess = (v1ClassesArchiveCreateResponse200) & {
  headers: Headers;
};
export type v1ClassesArchiveCreateResponseError = (v1ClassesArchiveCreateResponse401 | v1ClassesArchiveCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesArchiveCreateResponse = (v1ClassesArchiveCreateResponseSuccess | v1ClassesArchiveCreateResponseError)

export const getV1ClassesArchiveCreateUrl = (id: number,) => {




  return `/api/v1/classes/${id}/archive/`
}

/**
 * Class CRUD + TR-602 list + archive/restore (TR-603) + delete (TR-604).
 *
 * Explicit mixin composition (not `ModelViewSet`) so no unguarded DELETE route
 * is registered — TR-604 delete is a superadmin-only named action instead.
 * @summary Archiwizacja klasy (TR-603)
 */
export const v1ClassesArchiveCreate = async (id: number, options?: RequestInit): Promise<v1ClassesArchiveCreateResponse> => {

  return customFetch<v1ClassesArchiveCreateResponse>(getV1ClassesArchiveCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1ClassesArchiveCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesArchiveCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesArchiveCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1ClassesArchiveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesArchiveCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1ClassesArchiveCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesArchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesArchiveCreate>>>

    export type V1ClassesArchiveCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Archiwizacja klasy (TR-603)
 */
export const useV1ClassesArchiveCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesArchiveCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesArchiveCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1ClassesArchiveCreateMutationOptions(options), queryClient);
    }

export type v1ClassesBulkCascadeDeleteCreateResponse201 = {
  data: BulkOperationRequest
  status: 201
}

export type v1ClassesBulkCascadeDeleteCreateResponse400 = {
  data: void
  status: 400
}

export type v1ClassesBulkCascadeDeleteCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesBulkCascadeDeleteCreateResponse409 = {
  data: void
  status: 409
}

export type v1ClassesBulkCascadeDeleteCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesBulkCascadeDeleteCreateResponseSuccess = (v1ClassesBulkCascadeDeleteCreateResponse201) & {
  headers: Headers;
};
export type v1ClassesBulkCascadeDeleteCreateResponseError = (v1ClassesBulkCascadeDeleteCreateResponse400 | v1ClassesBulkCascadeDeleteCreateResponse401 | v1ClassesBulkCascadeDeleteCreateResponse409 | v1ClassesBulkCascadeDeleteCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesBulkCascadeDeleteCreateResponse = (v1ClassesBulkCascadeDeleteCreateResponseSuccess | v1ClassesBulkCascadeDeleteCreateResponseError)

export const getV1ClassesBulkCascadeDeleteCreateUrl = (id: number,) => {




  return `/api/v1/classes/${id}/bulk-cascade-delete/`
}

/**
 * TR-1103: initiate a cascade delete of the class + all its student accounts
 * (superadmin only). Three-step safeguard (acknowledgement + exact class name +
 * password) then a second-superadmin approval before two-phase execution. An
 * active OR archived class qualifies; a `deleted` class is already a tombstone.
 * @summary Kaskadowe usunięcie klasy z kontami uczniów (TR-1103)
 */
export const v1ClassesBulkCascadeDeleteCreate = async (id: number,
    cascadeInitiateRequest: CascadeInitiateRequest, options?: RequestInit): Promise<v1ClassesBulkCascadeDeleteCreateResponse> => {

  return customFetch<v1ClassesBulkCascadeDeleteCreateResponse>(getV1ClassesBulkCascadeDeleteCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cascadeInitiateRequest)
  }
);}




export const getV1ClassesBulkCascadeDeleteCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesBulkCascadeDeleteCreate>>, TError,{id: number;data: CascadeInitiateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesBulkCascadeDeleteCreate>>, TError,{id: number;data: CascadeInitiateRequest}, TContext> => {

const mutationKey = ['v1ClassesBulkCascadeDeleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesBulkCascadeDeleteCreate>>, {id: number;data: CascadeInitiateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ClassesBulkCascadeDeleteCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesBulkCascadeDeleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesBulkCascadeDeleteCreate>>>
    export type V1ClassesBulkCascadeDeleteCreateMutationBody = CascadeInitiateRequest
    export type V1ClassesBulkCascadeDeleteCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Kaskadowe usunięcie klasy z kontami uczniów (TR-1103)
 */
export const useV1ClassesBulkCascadeDeleteCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesBulkCascadeDeleteCreate>>, TError,{id: number;data: CascadeInitiateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesBulkCascadeDeleteCreate>>,
        TError,
        {id: number;data: CascadeInitiateRequest},
        TContext
      > => {
      return useMutation(getV1ClassesBulkCascadeDeleteCreateMutationOptions(options), queryClient);
    }

export type v1ClassesBulkDisableCreateResponse201 = {
  data: BulkOperationRequest
  status: 201
}

export type v1ClassesBulkDisableCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesBulkDisableCreateResponse409 = {
  data: void
  status: 409
}

export type v1ClassesBulkDisableCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesBulkDisableCreateResponseSuccess = (v1ClassesBulkDisableCreateResponse201) & {
  headers: Headers;
};
export type v1ClassesBulkDisableCreateResponseError = (v1ClassesBulkDisableCreateResponse401 | v1ClassesBulkDisableCreateResponse409 | v1ClassesBulkDisableCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesBulkDisableCreateResponse = (v1ClassesBulkDisableCreateResponseSuccess | v1ClassesBulkDisableCreateResponseError)

export const getV1ClassesBulkDisableCreateUrl = (id: number,) => {




  return `/api/v1/classes/${id}/bulk-disable/`
}

/**
 * TR-1102: initiate a mass disable of the class's active student accounts
 * (superadmin/admin). Requires second-operator approval before execution.
 * @summary Masowe wyłączenie kont uczniów klasy (TR-1102)
 */
export const v1ClassesBulkDisableCreate = async (id: number, options?: RequestInit): Promise<v1ClassesBulkDisableCreateResponse> => {

  return customFetch<v1ClassesBulkDisableCreateResponse>(getV1ClassesBulkDisableCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1ClassesBulkDisableCreateMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesBulkDisableCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesBulkDisableCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1ClassesBulkDisableCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesBulkDisableCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1ClassesBulkDisableCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesBulkDisableCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesBulkDisableCreate>>>

    export type V1ClassesBulkDisableCreateMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Masowe wyłączenie kont uczniów klasy (TR-1102)
 */
export const useV1ClassesBulkDisableCreate = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesBulkDisableCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesBulkDisableCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1ClassesBulkDisableCreateMutationOptions(options), queryClient);
    }

export type v1ClassesDeleteCreateResponse204 = {
  data: void
  status: 204
}

export type v1ClassesDeleteCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesDeleteCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesDeleteCreateResponseSuccess = (v1ClassesDeleteCreateResponse204) & {
  headers: Headers;
};
export type v1ClassesDeleteCreateResponseError = (v1ClassesDeleteCreateResponse401 | v1ClassesDeleteCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesDeleteCreateResponse = (v1ClassesDeleteCreateResponseSuccess | v1ClassesDeleteCreateResponseError)

export const getV1ClassesDeleteCreateUrl = (id: number,) => {




  return `/api/v1/classes/${id}/delete/`
}

/**
 * TR-604: irreversible, superadmin-only, name-confirmed, atomic delete.
 *
 * Severs the class↔student and class↔teacher-coordinator associations while
 * leaving those accounts intact, then deletes the class. Severing the student
 * memberships is what frees the `StudentMembership.klass` PROTECT so the
 * row-delete below can proceed — the students become unplaced (TR-604 R6),
 * their accounts untouched (FR-032).
 * @summary Usunięcie klasy (TR-604, superadmin)
 */
export const v1ClassesDeleteCreate = async (id: number,
    classDeleteRequest: ClassDeleteRequest, options?: RequestInit): Promise<v1ClassesDeleteCreateResponse> => {

  return customFetch<v1ClassesDeleteCreateResponse>(getV1ClassesDeleteCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(classDeleteRequest)
  }
);}




export const getV1ClassesDeleteCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesDeleteCreate>>, TError,{id: number;data: ClassDeleteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesDeleteCreate>>, TError,{id: number;data: ClassDeleteRequest}, TContext> => {

const mutationKey = ['v1ClassesDeleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesDeleteCreate>>, {id: number;data: ClassDeleteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ClassesDeleteCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesDeleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesDeleteCreate>>>
    export type V1ClassesDeleteCreateMutationBody = ClassDeleteRequest
    export type V1ClassesDeleteCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Usunięcie klasy (TR-604, superadmin)
 */
export const useV1ClassesDeleteCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesDeleteCreate>>, TError,{id: number;data: ClassDeleteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesDeleteCreate>>,
        TError,
        {id: number;data: ClassDeleteRequest},
        TContext
      > => {
      return useMutation(getV1ClassesDeleteCreateMutationOptions(options), queryClient);
    }

export type v1ClassesRestoreCreateResponse200 = {
  data: Class
  status: 200
}

export type v1ClassesRestoreCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesRestoreCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesRestoreCreateResponseSuccess = (v1ClassesRestoreCreateResponse200) & {
  headers: Headers;
};
export type v1ClassesRestoreCreateResponseError = (v1ClassesRestoreCreateResponse401 | v1ClassesRestoreCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesRestoreCreateResponse = (v1ClassesRestoreCreateResponseSuccess | v1ClassesRestoreCreateResponseError)

export const getV1ClassesRestoreCreateUrl = (id: number,) => {




  return `/api/v1/classes/${id}/restore/`
}

/**
 * Class CRUD + TR-602 list + archive/restore (TR-603) + delete (TR-604).
 *
 * Explicit mixin composition (not `ModelViewSet`) so no unguarded DELETE route
 * is registered — TR-604 delete is a superadmin-only named action instead.
 * @summary Przywrócenie klasy (TR-603)
 */
export const v1ClassesRestoreCreate = async (id: number, options?: RequestInit): Promise<v1ClassesRestoreCreateResponse> => {

  return customFetch<v1ClassesRestoreCreateResponse>(getV1ClassesRestoreCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1ClassesRestoreCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesRestoreCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesRestoreCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1ClassesRestoreCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesRestoreCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1ClassesRestoreCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesRestoreCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesRestoreCreate>>>

    export type V1ClassesRestoreCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Przywrócenie klasy (TR-603)
 */
export const useV1ClassesRestoreCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesRestoreCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesRestoreCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1ClassesRestoreCreateMutationOptions(options), queryClient);
    }

export type v1ClassesStudentsRetrieveResponse200 = {
  data: StudentRosterResponse
  status: 200
}

export type v1ClassesStudentsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsRetrieveResponseSuccess = (v1ClassesStudentsRetrieveResponse200) & {
  headers: Headers;
};
export type v1ClassesStudentsRetrieveResponseError = (v1ClassesStudentsRetrieveResponse401 | v1ClassesStudentsRetrieveResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsRetrieveResponse = (v1ClassesStudentsRetrieveResponseSuccess | v1ClassesStudentsRetrieveResponseError)

export const getV1ClassesStudentsRetrieveUrl = (id: number,
    params?: V1ClassesStudentsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/classes/${id}/students/?${stringifiedParams}` : `/api/v1/classes/${id}/students/`
}

/**
 * TR-802 roster (GET) + TR-800 single-account create (POST) on one class resource.
 *
 * Both verbs share `get_permissions`/`get_queryset` (they branch on the action name,
 * not the HTTP verb): operators reach any class, a teacher only classes they
 * coordinate — an out-of-scope class 404s via get_object(), indistinguishable from an
 * unknown id (FR-003). GET lists the anonymous roster; POST adds one student account
 * (FR-001).
 * @summary Roster kont uczniów w klasie (TR-802)
 */
export const v1ClassesStudentsRetrieve = async (id: number,
    params?: V1ClassesStudentsRetrieveParams, options?: RequestInit): Promise<v1ClassesStudentsRetrieveResponse> => {

  return customFetch<v1ClassesStudentsRetrieveResponse>(getV1ClassesStudentsRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ClassesStudentsRetrieveQueryKey = (id: number,
    params?: V1ClassesStudentsRetrieveParams,) => {
    return [
    `/api/v1/classes/${id}/students/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1ClassesStudentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(id: number,
    params?: V1ClassesStudentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ClassesStudentsRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>> = ({ signal }) => v1ClassesStudentsRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ClassesStudentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>>
export type V1ClassesStudentsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1ClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number,
    params: undefined |  V1ClassesStudentsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number,
    params?: V1ClassesStudentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number,
    params?: V1ClassesStudentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Roster kont uczniów w klasie (TR-802)
 */

export function useV1ClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number,
    params?: V1ClassesStudentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ClassesStudentsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ClassesStudentsCreateResponse201 = {
  data: StudentAccountCreateResponse
  status: 201
}

export type v1ClassesStudentsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsCreateResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsCreateResponse409 = {
  data: void
  status: 409
}

export type v1ClassesStudentsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsCreateResponseSuccess = (v1ClassesStudentsCreateResponse201) & {
  headers: Headers;
};
export type v1ClassesStudentsCreateResponseError = (v1ClassesStudentsCreateResponse401 | v1ClassesStudentsCreateResponse404 | v1ClassesStudentsCreateResponse409 | v1ClassesStudentsCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsCreateResponse = (v1ClassesStudentsCreateResponseSuccess | v1ClassesStudentsCreateResponseError)

export const getV1ClassesStudentsCreateUrl = (id: number,) => {




  return `/api/v1/classes/${id}/students/`
}

/**
 * TR-802 roster (GET) + TR-800 single-account create (POST) on one class resource.
 *
 * Both verbs share `get_permissions`/`get_queryset` (they branch on the action name,
 * not the HTTP verb): operators reach any class, a teacher only classes they
 * coordinate — an out-of-scope class 404s via get_object(), indistinguishable from an
 * unknown id (FR-003). GET lists the anonymous roster; POST adds one student account
 * (FR-001).
 * @summary Dodanie konta ucznia (TR-800)
 */
export const v1ClassesStudentsCreate = async (id: number, options?: RequestInit): Promise<v1ClassesStudentsCreateResponse> => {

  return customFetch<v1ClassesStudentsCreateResponse>(getV1ClassesStudentsCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1ClassesStudentsCreateMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1ClassesStudentsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesStudentsCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1ClassesStudentsCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesStudentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsCreate>>>

    export type V1ClassesStudentsCreateMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Dodanie konta ucznia (TR-800)
 */
export const useV1ClassesStudentsCreate = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesStudentsCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1ClassesStudentsCreateMutationOptions(options), queryClient);
    }

export type v1ClassesStudentsDestroyResponse204 = {
  data: void
  status: 204
}

export type v1ClassesStudentsDestroyResponse400 = {
  data: void
  status: 400
}

export type v1ClassesStudentsDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsDestroyResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsDestroyResponse409 = {
  data: void
  status: 409
}

export type v1ClassesStudentsDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsDestroyResponseSuccess = (v1ClassesStudentsDestroyResponse204) & {
  headers: Headers;
};
export type v1ClassesStudentsDestroyResponseError = (v1ClassesStudentsDestroyResponse400 | v1ClassesStudentsDestroyResponse401 | v1ClassesStudentsDestroyResponse404 | v1ClassesStudentsDestroyResponse409 | v1ClassesStudentsDestroyResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsDestroyResponse = (v1ClassesStudentsDestroyResponseSuccess | v1ClassesStudentsDestroyResponseError)

export const getV1ClassesStudentsDestroyUrl = (id: number,
    membershipPk: string,) => {




  return `/api/v1/classes/${id}/students/${membershipPk}/`
}

/**
 * TR-1101: irreversibly anonymize a student account (any state except deleted).
 *
 * Gated by an EXACT typed control text — the student's display code (FR-017), matched
 * server-side byte-for-byte, case-sensitive, no whitespace normalization. Refused with
 * 409 while a pending credential sheet covers the account (FR-019), because deleting
 * would leave the printed temp password recoverable. Anonymization (login token, nulled
 * e-mails, severed membership, killed sessions, deleted device rows, month-truncated
 * last_login, retired journal number) runs in one atomic transaction (FR-014/023).
 * @summary Usunięcie (anonimizacja) konta ucznia (TR-1101)
 */
export const v1ClassesStudentsDestroy = async (id: number,
    membershipPk: string,
    v1ClassesStudentsDestroyBody: V1ClassesStudentsDestroyBody, options?: RequestInit): Promise<v1ClassesStudentsDestroyResponse> => {

  return customFetch<v1ClassesStudentsDestroyResponse>(getV1ClassesStudentsDestroyUrl(id,membershipPk),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(v1ClassesStudentsDestroyBody)
  }
);}




export const getV1ClassesStudentsDestroyMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsDestroy>>, TError,{id: number;membershipPk: string;data: V1ClassesStudentsDestroyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsDestroy>>, TError,{id: number;membershipPk: string;data: V1ClassesStudentsDestroyBody}, TContext> => {

const mutationKey = ['v1ClassesStudentsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesStudentsDestroy>>, {id: number;membershipPk: string;data: V1ClassesStudentsDestroyBody}> = (props) => {
          const {id,membershipPk,data} = props ?? {};

          return  v1ClassesStudentsDestroy(id,membershipPk,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesStudentsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsDestroy>>>
    export type V1ClassesStudentsDestroyMutationBody = V1ClassesStudentsDestroyBody
    export type V1ClassesStudentsDestroyMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Usunięcie (anonimizacja) konta ucznia (TR-1101)
 */
export const useV1ClassesStudentsDestroy = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsDestroy>>, TError,{id: number;membershipPk: string;data: V1ClassesStudentsDestroyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesStudentsDestroy>>,
        TError,
        {id: number;membershipPk: string;data: V1ClassesStudentsDestroyBody},
        TContext
      > => {
      return useMutation(getV1ClassesStudentsDestroyMutationOptions(options), queryClient);
    }

export type v1ClassesStudentsBlockCreateResponse200 = {
  data: StudentRosterRow
  status: 200
}

export type v1ClassesStudentsBlockCreateResponse400 = {
  data: void
  status: 400
}

export type v1ClassesStudentsBlockCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsBlockCreateResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsBlockCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsBlockCreateResponseSuccess = (v1ClassesStudentsBlockCreateResponse200) & {
  headers: Headers;
};
export type v1ClassesStudentsBlockCreateResponseError = (v1ClassesStudentsBlockCreateResponse400 | v1ClassesStudentsBlockCreateResponse401 | v1ClassesStudentsBlockCreateResponse404 | v1ClassesStudentsBlockCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsBlockCreateResponse = (v1ClassesStudentsBlockCreateResponseSuccess | v1ClassesStudentsBlockCreateResponseError)

export const getV1ClassesStudentsBlockCreateUrl = (id: number,
    membershipPk: string,) => {




  return `/api/v1/classes/${id}/students/${membershipPk}/block/`
}

/**
 * TR-803: block a student account (active → blocked), with an optional reason.
 *
 * The block is immediate and reversible (FR-004): it does not delete/archive the
 * account or touch the password. Sessions + tokens die via the state flip (FR-005).
 * @summary Blokada konta ucznia (TR-803)
 */
export const v1ClassesStudentsBlockCreate = async (id: number,
    membershipPk: string,
    blockRequestRequest?: BlockRequestRequest, options?: RequestInit): Promise<v1ClassesStudentsBlockCreateResponse> => {

  return customFetch<v1ClassesStudentsBlockCreateResponse>(getV1ClassesStudentsBlockCreateUrl(id,membershipPk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(blockRequestRequest)
  }
);}




export const getV1ClassesStudentsBlockCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsBlockCreate>>, TError,{id: number;membershipPk: string;data?: BlockRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsBlockCreate>>, TError,{id: number;membershipPk: string;data?: BlockRequestRequest}, TContext> => {

const mutationKey = ['v1ClassesStudentsBlockCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesStudentsBlockCreate>>, {id: number;membershipPk: string;data?: BlockRequestRequest}> = (props) => {
          const {id,membershipPk,data} = props ?? {};

          return  v1ClassesStudentsBlockCreate(id,membershipPk,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesStudentsBlockCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsBlockCreate>>>
    export type V1ClassesStudentsBlockCreateMutationBody = BlockRequestRequest | undefined
    export type V1ClassesStudentsBlockCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Blokada konta ucznia (TR-803)
 */
export const useV1ClassesStudentsBlockCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsBlockCreate>>, TError,{id: number;membershipPk: string;data?: BlockRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesStudentsBlockCreate>>,
        TError,
        {id: number;membershipPk: string;data?: BlockRequestRequest},
        TContext
      > => {
      return useMutation(getV1ClassesStudentsBlockCreateMutationOptions(options), queryClient);
    }

export type v1ClassesStudentsDisableCreateResponse200 = {
  data: StudentRosterRow
  status: 200
}

export type v1ClassesStudentsDisableCreateResponse400 = {
  data: void
  status: 400
}

export type v1ClassesStudentsDisableCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsDisableCreateResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsDisableCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsDisableCreateResponseSuccess = (v1ClassesStudentsDisableCreateResponse200) & {
  headers: Headers;
};
export type v1ClassesStudentsDisableCreateResponseError = (v1ClassesStudentsDisableCreateResponse400 | v1ClassesStudentsDisableCreateResponse401 | v1ClassesStudentsDisableCreateResponse404 | v1ClassesStudentsDisableCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsDisableCreateResponse = (v1ClassesStudentsDisableCreateResponseSuccess | v1ClassesStudentsDisableCreateResponseError)

export const getV1ClassesStudentsDisableCreateUrl = (id: number,
    membershipPk: string,) => {




  return `/api/v1/classes/${id}/students/${membershipPk}/disable/`
}

/**
 * TR-1100: disable a student account (active → disabled), reversibly.
 *
 * Kills every session via the state flip (FR-005), clears the forced-password-change
 * flag (FR-006), leaves all other data untouched. A pending credential sheet is
 * neither read nor blocking (FR-008). Rejects any non-active source (FR-007).
 * @summary Wyłączenie konta ucznia (TR-1100)
 */
export const v1ClassesStudentsDisableCreate = async (id: number,
    membershipPk: string, options?: RequestInit): Promise<v1ClassesStudentsDisableCreateResponse> => {

  return customFetch<v1ClassesStudentsDisableCreateResponse>(getV1ClassesStudentsDisableCreateUrl(id,membershipPk),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1ClassesStudentsDisableCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsDisableCreate>>, TError,{id: number;membershipPk: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsDisableCreate>>, TError,{id: number;membershipPk: string}, TContext> => {

const mutationKey = ['v1ClassesStudentsDisableCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesStudentsDisableCreate>>, {id: number;membershipPk: string}> = (props) => {
          const {id,membershipPk} = props ?? {};

          return  v1ClassesStudentsDisableCreate(id,membershipPk,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesStudentsDisableCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsDisableCreate>>>

    export type V1ClassesStudentsDisableCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Wyłączenie konta ucznia (TR-1100)
 */
export const useV1ClassesStudentsDisableCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsDisableCreate>>, TError,{id: number;membershipPk: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesStudentsDisableCreate>>,
        TError,
        {id: number;membershipPk: string},
        TContext
      > => {
      return useMutation(getV1ClassesStudentsDisableCreateMutationOptions(options), queryClient);
    }

export type v1ClassesStudentsRestoreCreateResponse200 = {
  data: StudentRosterRow
  status: 200
}

export type v1ClassesStudentsRestoreCreateResponse400 = {
  data: void
  status: 400
}

export type v1ClassesStudentsRestoreCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsRestoreCreateResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsRestoreCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsRestoreCreateResponseSuccess = (v1ClassesStudentsRestoreCreateResponse200) & {
  headers: Headers;
};
export type v1ClassesStudentsRestoreCreateResponseError = (v1ClassesStudentsRestoreCreateResponse400 | v1ClassesStudentsRestoreCreateResponse401 | v1ClassesStudentsRestoreCreateResponse404 | v1ClassesStudentsRestoreCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsRestoreCreateResponse = (v1ClassesStudentsRestoreCreateResponseSuccess | v1ClassesStudentsRestoreCreateResponseError)

export const getV1ClassesStudentsRestoreCreateUrl = (id: number,
    membershipPk: string,) => {




  return `/api/v1/classes/${id}/students/${membershipPk}/restore/`
}

/**
 * TR-1100: restore a disabled student account (disabled → active).
 *
 * Allowed only while the class and its school are active (FR-010). Sessions stay dead
 * — the student logs in afresh (FR-011). The forced-password-change flag follows the
 * request, EXCEPT it is forced True for an account that never completed first login
 * (FR-012): the checkbox is checked-and-locked in the UI, but the server is the
 * authority.
 * @summary Przywrócenie konta ucznia (TR-1100)
 */
export const v1ClassesStudentsRestoreCreate = async (id: number,
    membershipPk: string,
    restoreRequestRequest?: RestoreRequestRequest, options?: RequestInit): Promise<v1ClassesStudentsRestoreCreateResponse> => {

  return customFetch<v1ClassesStudentsRestoreCreateResponse>(getV1ClassesStudentsRestoreCreateUrl(id,membershipPk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(restoreRequestRequest)
  }
);}




export const getV1ClassesStudentsRestoreCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsRestoreCreate>>, TError,{id: number;membershipPk: string;data?: RestoreRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsRestoreCreate>>, TError,{id: number;membershipPk: string;data?: RestoreRequestRequest}, TContext> => {

const mutationKey = ['v1ClassesStudentsRestoreCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesStudentsRestoreCreate>>, {id: number;membershipPk: string;data?: RestoreRequestRequest}> = (props) => {
          const {id,membershipPk,data} = props ?? {};

          return  v1ClassesStudentsRestoreCreate(id,membershipPk,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesStudentsRestoreCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsRestoreCreate>>>
    export type V1ClassesStudentsRestoreCreateMutationBody = RestoreRequestRequest | undefined
    export type V1ClassesStudentsRestoreCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Przywrócenie konta ucznia (TR-1100)
 */
export const useV1ClassesStudentsRestoreCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsRestoreCreate>>, TError,{id: number;membershipPk: string;data?: RestoreRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesStudentsRestoreCreate>>,
        TError,
        {id: number;membershipPk: string;data?: RestoreRequestRequest},
        TContext
      > => {
      return useMutation(getV1ClassesStudentsRestoreCreateMutationOptions(options), queryClient);
    }

export type v1ClassesStudentsTransferCreateResponse200 = {
  data: StudentRosterRow
  status: 200
}

export type v1ClassesStudentsTransferCreateResponse400 = {
  data: void
  status: 400
}

export type v1ClassesStudentsTransferCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsTransferCreateResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsTransferCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsTransferCreateResponseSuccess = (v1ClassesStudentsTransferCreateResponse200) & {
  headers: Headers;
};
export type v1ClassesStudentsTransferCreateResponseError = (v1ClassesStudentsTransferCreateResponse400 | v1ClassesStudentsTransferCreateResponse401 | v1ClassesStudentsTransferCreateResponse404 | v1ClassesStudentsTransferCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsTransferCreateResponse = (v1ClassesStudentsTransferCreateResponseSuccess | v1ClassesStudentsTransferCreateResponseError)

export const getV1ClassesStudentsTransferCreateUrl = (id: number,
    membershipPk: string,) => {




  return `/api/v1/classes/${id}/students/${membershipPk}/transfer/`
}

/**
 * TR-605: move an Active student to a different Active class, superadmin-only.
 *
 * Resolves the source membership first (anti-enumeration, superadmin-only), validates the
 * body, resolves + pre-checks the target class, then delegates the atomic re-point to
 * `core.students.transfer_student` (target-class lock, operator-chosen free journal number,
 * high-water bump, audit). The number defaults to the proposed next-free when omitted; a
 * number already taken in the target class comes back as a readable 400 (never a raw DB
 * error). On success the student is told their class changed while the immutable login
 * stays unchanged; the best-effort push is enqueued post-commit, so a rolled-back transfer
 * never notifies. Password/history are untouched.
 * @summary Przeniesienie ucznia do innej klasy (TR-605)
 */
export const v1ClassesStudentsTransferCreate = async (id: number,
    membershipPk: string,
    transferRequestRequest: TransferRequestRequest, options?: RequestInit): Promise<v1ClassesStudentsTransferCreateResponse> => {

  return customFetch<v1ClassesStudentsTransferCreateResponse>(getV1ClassesStudentsTransferCreateUrl(id,membershipPk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(transferRequestRequest)
  }
);}




export const getV1ClassesStudentsTransferCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsTransferCreate>>, TError,{id: number;membershipPk: string;data: TransferRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsTransferCreate>>, TError,{id: number;membershipPk: string;data: TransferRequestRequest}, TContext> => {

const mutationKey = ['v1ClassesStudentsTransferCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesStudentsTransferCreate>>, {id: number;membershipPk: string;data: TransferRequestRequest}> = (props) => {
          const {id,membershipPk,data} = props ?? {};

          return  v1ClassesStudentsTransferCreate(id,membershipPk,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesStudentsTransferCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsTransferCreate>>>
    export type V1ClassesStudentsTransferCreateMutationBody = TransferRequestRequest
    export type V1ClassesStudentsTransferCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Przeniesienie ucznia do innej klasy (TR-605)
 */
export const useV1ClassesStudentsTransferCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsTransferCreate>>, TError,{id: number;membershipPk: string;data: TransferRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesStudentsTransferCreate>>,
        TError,
        {id: number;membershipPk: string;data: TransferRequestRequest},
        TContext
      > => {
      return useMutation(getV1ClassesStudentsTransferCreateMutationOptions(options), queryClient);
    }

export type v1ClassesStudentsTransferPreviewCreateResponse200 = {
  data: TransferPreviewResponse
  status: 200
}

export type v1ClassesStudentsTransferPreviewCreateResponse400 = {
  data: void
  status: 400
}

export type v1ClassesStudentsTransferPreviewCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsTransferPreviewCreateResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsTransferPreviewCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsTransferPreviewCreateResponseSuccess = (v1ClassesStudentsTransferPreviewCreateResponse200) & {
  headers: Headers;
};
export type v1ClassesStudentsTransferPreviewCreateResponseError = (v1ClassesStudentsTransferPreviewCreateResponse400 | v1ClassesStudentsTransferPreviewCreateResponse401 | v1ClassesStudentsTransferPreviewCreateResponse404 | v1ClassesStudentsTransferPreviewCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsTransferPreviewCreateResponse = (v1ClassesStudentsTransferPreviewCreateResponseSuccess | v1ClassesStudentsTransferPreviewCreateResponseError)

export const getV1ClassesStudentsTransferPreviewCreateUrl = (id: number,
    membershipPk: string,) => {




  return `/api/v1/classes/${id}/students/${membershipPk}/transfer-preview/`
}

/**
 * TR-605: for a candidate target class, return the proposed journal number + occupied set.
 *
 * Read-only. Resolves the source membership first (anti-enumeration, superadmin-only), then
 * the target class, then computes `next_journal_number(target)` (the default proposal) and
 * the numbers already taken there so the client can pre-fill and validate the operator's
 * choice (a taken number is flagged; any other free number, incl. a mid-range hole, is OK).
 * @summary Podgląd przeniesienia ucznia — propozycja numeru (TR-605)
 */
export const v1ClassesStudentsTransferPreviewCreate = async (id: number,
    membershipPk: string,
    transferPreviewRequestRequest: TransferPreviewRequestRequest, options?: RequestInit): Promise<v1ClassesStudentsTransferPreviewCreateResponse> => {

  return customFetch<v1ClassesStudentsTransferPreviewCreateResponse>(getV1ClassesStudentsTransferPreviewCreateUrl(id,membershipPk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(transferPreviewRequestRequest)
  }
);}




export const getV1ClassesStudentsTransferPreviewCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsTransferPreviewCreate>>, TError,{id: number;membershipPk: string;data: TransferPreviewRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsTransferPreviewCreate>>, TError,{id: number;membershipPk: string;data: TransferPreviewRequestRequest}, TContext> => {

const mutationKey = ['v1ClassesStudentsTransferPreviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesStudentsTransferPreviewCreate>>, {id: number;membershipPk: string;data: TransferPreviewRequestRequest}> = (props) => {
          const {id,membershipPk,data} = props ?? {};

          return  v1ClassesStudentsTransferPreviewCreate(id,membershipPk,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesStudentsTransferPreviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsTransferPreviewCreate>>>
    export type V1ClassesStudentsTransferPreviewCreateMutationBody = TransferPreviewRequestRequest
    export type V1ClassesStudentsTransferPreviewCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Podgląd przeniesienia ucznia — propozycja numeru (TR-605)
 */
export const useV1ClassesStudentsTransferPreviewCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsTransferPreviewCreate>>, TError,{id: number;membershipPk: string;data: TransferPreviewRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesStudentsTransferPreviewCreate>>,
        TError,
        {id: number;membershipPk: string;data: TransferPreviewRequestRequest},
        TContext
      > => {
      return useMutation(getV1ClassesStudentsTransferPreviewCreateMutationOptions(options), queryClient);
    }

export type v1ClassesStudentsUnblockCreateResponse200 = {
  data: StudentRosterRow
  status: 200
}

export type v1ClassesStudentsUnblockCreateResponse400 = {
  data: void
  status: 400
}

export type v1ClassesStudentsUnblockCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsUnblockCreateResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsUnblockCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsUnblockCreateResponseSuccess = (v1ClassesStudentsUnblockCreateResponse200) & {
  headers: Headers;
};
export type v1ClassesStudentsUnblockCreateResponseError = (v1ClassesStudentsUnblockCreateResponse400 | v1ClassesStudentsUnblockCreateResponse401 | v1ClassesStudentsUnblockCreateResponse404 | v1ClassesStudentsUnblockCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsUnblockCreateResponse = (v1ClassesStudentsUnblockCreateResponseSuccess | v1ClassesStudentsUnblockCreateResponseError)

export const getV1ClassesStudentsUnblockCreateUrl = (id: number,
    membershipPk: string,) => {




  return `/api/v1/classes/${id}/students/${membershipPk}/unblock/`
}

/**
 * TR-803: unblock a student account (blocked → active).
 *
 * Restores login with the existing password — no new password, no forced change
 * (FR-007). If the student forgot it, recovery is a separate reset flow.
 * @summary Odblokowanie konta ucznia (TR-803)
 */
export const v1ClassesStudentsUnblockCreate = async (id: number,
    membershipPk: string, options?: RequestInit): Promise<v1ClassesStudentsUnblockCreateResponse> => {

  return customFetch<v1ClassesStudentsUnblockCreateResponse>(getV1ClassesStudentsUnblockCreateUrl(id,membershipPk),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1ClassesStudentsUnblockCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsUnblockCreate>>, TError,{id: number;membershipPk: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsUnblockCreate>>, TError,{id: number;membershipPk: string}, TContext> => {

const mutationKey = ['v1ClassesStudentsUnblockCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesStudentsUnblockCreate>>, {id: number;membershipPk: string}> = (props) => {
          const {id,membershipPk} = props ?? {};

          return  v1ClassesStudentsUnblockCreate(id,membershipPk,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesStudentsUnblockCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsUnblockCreate>>>

    export type V1ClassesStudentsUnblockCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Odblokowanie konta ucznia (TR-803)
 */
export const useV1ClassesStudentsUnblockCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsUnblockCreate>>, TError,{id: number;membershipPk: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesStudentsUnblockCreate>>,
        TError,
        {id: number;membershipPk: string},
        TContext
      > => {
      return useMutation(getV1ClassesStudentsUnblockCreateMutationOptions(options), queryClient);
    }

export type v1ClassesStudentsSheetRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type v1ClassesStudentsSheetRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsSheetRetrieveResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsSheetRetrieveResponse409 = {
  data: void
  status: 409
}

export type v1ClassesStudentsSheetRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsSheetRetrieveResponseSuccess = (v1ClassesStudentsSheetRetrieveResponse200) & {
  headers: Headers;
};
export type v1ClassesStudentsSheetRetrieveResponseError = (v1ClassesStudentsSheetRetrieveResponse401 | v1ClassesStudentsSheetRetrieveResponse404 | v1ClassesStudentsSheetRetrieveResponse409 | v1ClassesStudentsSheetRetrieveResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsSheetRetrieveResponse = (v1ClassesStudentsSheetRetrieveResponseSuccess | v1ClassesStudentsSheetRetrieveResponseError)

export const getV1ClassesStudentsSheetRetrieveUrl = (id: number,) => {




  return `/api/v1/classes/${id}/students/sheet/`
}

/**
 * The class's pending credential sheet as a singleton sub-resource (R11 makes
 * it at-most-one, so no artifact id ever reaches the wire — anti-enumeration).
 *
 * POST generates (pack or secondary), GET is the one-time download, DELETE
 * cancels. Scoping is the explicit 024-style guard, not get_queryset (the
 * queryset branch applies only to the `students` action): operators and the
 * class's coordinators pass; for GET/DELETE the artifact's initiator passes
 * too, even after losing the coordinator link (R9; Clarifications 2026-07-10).
 * Everyone else gets a 404 byte-identical to an unknown class.
 * @summary Jednorazowe pobranie arkusza kont (TR-800 R10)
 */
export const v1ClassesStudentsSheetRetrieve = async (id: number, options?: RequestInit): Promise<v1ClassesStudentsSheetRetrieveResponse> => {

  return customFetch<v1ClassesStudentsSheetRetrieveResponse>(getV1ClassesStudentsSheetRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ClassesStudentsSheetRetrieveQueryKey = (id: number,) => {
    return [
    `/api/v1/classes/${id}/students/sheet/`
    ] as const;
    }


export const getV1ClassesStudentsSheetRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ClassesStudentsSheetRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>> = ({ signal }) => v1ClassesStudentsSheetRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ClassesStudentsSheetRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>>
export type V1ClassesStudentsSheetRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1ClassesStudentsSheetRetrieve<TData = Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ClassesStudentsSheetRetrieve<TData = Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ClassesStudentsSheetRetrieve<TData = Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Jednorazowe pobranie arkusza kont (TR-800 R10)
 */

export function useV1ClassesStudentsSheetRetrieve<TData = Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ClassesStudentsSheetRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ClassesStudentsSheetCreateResponse201 = {
  data: SheetInfo
  status: 201
}

export type v1ClassesStudentsSheetCreateResponse400 = {
  data: void
  status: 400
}

export type v1ClassesStudentsSheetCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsSheetCreateResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsSheetCreateResponse409 = {
  data: void
  status: 409
}

export type v1ClassesStudentsSheetCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsSheetCreateResponseSuccess = (v1ClassesStudentsSheetCreateResponse201) & {
  headers: Headers;
};
export type v1ClassesStudentsSheetCreateResponseError = (v1ClassesStudentsSheetCreateResponse400 | v1ClassesStudentsSheetCreateResponse401 | v1ClassesStudentsSheetCreateResponse404 | v1ClassesStudentsSheetCreateResponse409 | v1ClassesStudentsSheetCreateResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsSheetCreateResponse = (v1ClassesStudentsSheetCreateResponseSuccess | v1ClassesStudentsSheetCreateResponseError)

export const getV1ClassesStudentsSheetCreateUrl = (id: number,) => {




  return `/api/v1/classes/${id}/students/sheet/`
}

/**
 * The class's pending credential sheet as a singleton sub-resource (R11 makes
 * it at-most-one, so no artifact id ever reaches the wire — anti-enumeration).
 *
 * POST generates (pack or secondary), GET is the one-time download, DELETE
 * cancels. Scoping is the explicit 024-style guard, not get_queryset (the
 * queryset branch applies only to the `students` action): operators and the
 * class's coordinators pass; for GET/DELETE the artifact's initiator passes
 * too, even after losing the coordinator link (R9; Clarifications 2026-07-10).
 * Everyone else gets a 404 byte-identical to an unknown class.
 * @summary Generowanie arkusza kont uczniów: paczka lub wtórny (TR-800)
 */
export const v1ClassesStudentsSheetCreate = async (id: number,
    sheetCreateRequest: SheetCreateRequest, options?: RequestInit): Promise<v1ClassesStudentsSheetCreateResponse> => {

  return customFetch<v1ClassesStudentsSheetCreateResponse>(getV1ClassesStudentsSheetCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sheetCreateRequest)
  }
);}




export const getV1ClassesStudentsSheetCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetCreate>>, TError,{id: number;data: SheetCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetCreate>>, TError,{id: number;data: SheetCreateRequest}, TContext> => {

const mutationKey = ['v1ClassesStudentsSheetCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesStudentsSheetCreate>>, {id: number;data: SheetCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ClassesStudentsSheetCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesStudentsSheetCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsSheetCreate>>>
    export type V1ClassesStudentsSheetCreateMutationBody = SheetCreateRequest
    export type V1ClassesStudentsSheetCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Generowanie arkusza kont uczniów: paczka lub wtórny (TR-800)
 */
export const useV1ClassesStudentsSheetCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetCreate>>, TError,{id: number;data: SheetCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesStudentsSheetCreate>>,
        TError,
        {id: number;data: SheetCreateRequest},
        TContext
      > => {
      return useMutation(getV1ClassesStudentsSheetCreateMutationOptions(options), queryClient);
    }

export type v1ClassesStudentsSheetDestroyResponse200 = {
  data: SheetCancelInfo
  status: 200
}

export type v1ClassesStudentsSheetDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ClassesStudentsSheetDestroyResponse404 = {
  data: void
  status: 404
}

export type v1ClassesStudentsSheetDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ClassesStudentsSheetDestroyResponseSuccess = (v1ClassesStudentsSheetDestroyResponse200) & {
  headers: Headers;
};
export type v1ClassesStudentsSheetDestroyResponseError = (v1ClassesStudentsSheetDestroyResponse401 | v1ClassesStudentsSheetDestroyResponse404 | v1ClassesStudentsSheetDestroyResponse410) & {
  headers: Headers;
};

export type v1ClassesStudentsSheetDestroyResponse = (v1ClassesStudentsSheetDestroyResponseSuccess | v1ClassesStudentsSheetDestroyResponseError)

export const getV1ClassesStudentsSheetDestroyUrl = (id: number,) => {




  return `/api/v1/classes/${id}/students/sheet/`
}

/**
 * The class's pending credential sheet as a singleton sub-resource (R11 makes
 * it at-most-one, so no artifact id ever reaches the wire — anti-enumeration).
 *
 * POST generates (pack or secondary), GET is the one-time download, DELETE
 * cancels. Scoping is the explicit 024-style guard, not get_queryset (the
 * queryset branch applies only to the `students` action): operators and the
 * class's coordinators pass; for GET/DELETE the artifact's initiator passes
 * too, even after losing the coordinator link (R9; Clarifications 2026-07-10).
 * Everyone else gets a 404 byte-identical to an unknown class.
 * @summary Anulowanie niepobranego arkusza (TR-800 R12)
 */
export const v1ClassesStudentsSheetDestroy = async (id: number, options?: RequestInit): Promise<v1ClassesStudentsSheetDestroyResponse> => {

  return customFetch<v1ClassesStudentsSheetDestroyResponse>(getV1ClassesStudentsSheetDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getV1ClassesStudentsSheetDestroyMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1ClassesStudentsSheetDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ClassesStudentsSheetDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1ClassesStudentsSheetDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1ClassesStudentsSheetDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ClassesStudentsSheetDestroy>>>

    export type V1ClassesStudentsSheetDestroyMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Anulowanie niepobranego arkusza (TR-800 R12)
 */
export const useV1ClassesStudentsSheetDestroy = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ClassesStudentsSheetDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ClassesStudentsSheetDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1ClassesStudentsSheetDestroyMutationOptions(options), queryClient);
    }

export type v1CompanyGoalsListResponse200 = {
  data: PaginatedCompanyGoalPullList
  status: 200
}

export type v1CompanyGoalsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CompanyGoalsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CompanyGoalsListResponseSuccess = (v1CompanyGoalsListResponse200) & {
  headers: Headers;
};
export type v1CompanyGoalsListResponseError = (v1CompanyGoalsListResponse401 | v1CompanyGoalsListResponse410) & {
  headers: Headers;
};

export type v1CompanyGoalsListResponse = (v1CompanyGoalsListResponseSuccess | v1CompanyGoalsListResponseError)

export const getV1CompanyGoalsListUrl = (params?: V1CompanyGoalsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/company-goals/?${stringifiedParams}` : `/api/v1/company-goals/`
}

/**
 * Pull listy celów firmy na świeżym urządzeniu (odtworzenie z chmury).
 *
 * Zakres właściciela, filtr `updated_since`, retencja tombstone'ów i koperta
 * kursora są dziedziczone z `SyncPullView`. Push (create/update/delete) jedzie
 * wspólnym `POST /api/v1/sync/operations/`.
 */
export const v1CompanyGoalsList = async (params?: V1CompanyGoalsListParams, options?: RequestInit): Promise<v1CompanyGoalsListResponse> => {

  return customFetch<v1CompanyGoalsListResponse>(getV1CompanyGoalsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1CompanyGoalsListQueryKey = (params?: V1CompanyGoalsListParams,) => {
    return [
    `/api/v1/company-goals/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1CompanyGoalsListQueryOptions = <TData = Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1CompanyGoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CompanyGoalsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CompanyGoalsList>>> = ({ signal }) => v1CompanyGoalsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1CompanyGoalsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1CompanyGoalsList>>>
export type V1CompanyGoalsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1CompanyGoalsList<TData = Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1CompanyGoalsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CompanyGoalsList>>,
          TError,
          Awaited<ReturnType<typeof v1CompanyGoalsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CompanyGoalsList<TData = Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1CompanyGoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CompanyGoalsList>>,
          TError,
          Awaited<ReturnType<typeof v1CompanyGoalsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CompanyGoalsList<TData = Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1CompanyGoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1CompanyGoalsList<TData = Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1CompanyGoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CompanyGoalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1CompanyGoalsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1CurrenciesListResponse200 = {
  data: PaginatedCurrencyList
  status: 200
}

export type v1CurrenciesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurrenciesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurrenciesListResponseSuccess = (v1CurrenciesListResponse200) & {
  headers: Headers;
};
export type v1CurrenciesListResponseError = (v1CurrenciesListResponse401 | v1CurrenciesListResponse410) & {
  headers: Headers;
};

export type v1CurrenciesListResponse = (v1CurrenciesListResponseSuccess | v1CurrenciesListResponseError)

export const getV1CurrenciesListUrl = (params?: V1CurrenciesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/currencies/?${stringifiedParams}` : `/api/v1/currencies/`
}

/**
 * Słownik kodów klasowych: lista dla operatora, zapisy dla superadmina.
 * @summary Lista kodów klasowych (słownik, spec 208)
 */
export const v1CurrenciesList = async (params?: V1CurrenciesListParams, options?: RequestInit): Promise<v1CurrenciesListResponse> => {

  return customFetch<v1CurrenciesListResponse>(getV1CurrenciesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1CurrenciesListQueryKey = (params?: V1CurrenciesListParams,) => {
    return [
    `/api/v1/currencies/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1CurrenciesListQueryOptions = <TData = Awaited<ReturnType<typeof v1CurrenciesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1CurrenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CurrenciesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CurrenciesList>>> = ({ signal }) => v1CurrenciesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1CurrenciesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1CurrenciesList>>>
export type V1CurrenciesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1CurrenciesList<TData = Awaited<ReturnType<typeof v1CurrenciesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1CurrenciesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurrenciesList>>,
          TError,
          Awaited<ReturnType<typeof v1CurrenciesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurrenciesList<TData = Awaited<ReturnType<typeof v1CurrenciesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1CurrenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurrenciesList>>,
          TError,
          Awaited<ReturnType<typeof v1CurrenciesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurrenciesList<TData = Awaited<ReturnType<typeof v1CurrenciesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1CurrenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista kodów klasowych (słownik, spec 208)
 */

export function useV1CurrenciesList<TData = Awaited<ReturnType<typeof v1CurrenciesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1CurrenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1CurrenciesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1CurrenciesCreateResponse201 = {
  data: Currency
  status: 201
}

export type v1CurrenciesCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurrenciesCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurrenciesCreateResponseSuccess = (v1CurrenciesCreateResponse201) & {
  headers: Headers;
};
export type v1CurrenciesCreateResponseError = (v1CurrenciesCreateResponse401 | v1CurrenciesCreateResponse410) & {
  headers: Headers;
};

export type v1CurrenciesCreateResponse = (v1CurrenciesCreateResponseSuccess | v1CurrenciesCreateResponseError)

export const getV1CurrenciesCreateUrl = () => {




  return `/api/v1/currencies/`
}

/**
 * Słownik kodów klasowych: lista dla operatora, zapisy dla superadmina.
 * @summary Dodaj kod klasowy do słownika (superadmin)
 */
export const v1CurrenciesCreate = async (currencyRequest: CurrencyRequest, options?: RequestInit): Promise<v1CurrenciesCreateResponse> => {

  return customFetch<v1CurrenciesCreateResponse>(getV1CurrenciesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(currencyRequest)
  }
);}




export const getV1CurrenciesCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesCreate>>, TError,{data: CurrencyRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesCreate>>, TError,{data: CurrencyRequest}, TContext> => {

const mutationKey = ['v1CurrenciesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurrenciesCreate>>, {data: CurrencyRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1CurrenciesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurrenciesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurrenciesCreate>>>
    export type V1CurrenciesCreateMutationBody = CurrencyRequest
    export type V1CurrenciesCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Dodaj kod klasowy do słownika (superadmin)
 */
export const useV1CurrenciesCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesCreate>>, TError,{data: CurrencyRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurrenciesCreate>>,
        TError,
        {data: CurrencyRequest},
        TContext
      > => {
      return useMutation(getV1CurrenciesCreateMutationOptions(options), queryClient);
    }

export type v1CurrenciesPartialUpdateResponse200 = {
  data: Currency
  status: 200
}

export type v1CurrenciesPartialUpdateResponse400 = {
  data: void
  status: 400
}

export type v1CurrenciesPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurrenciesPartialUpdateResponse404 = {
  data: void
  status: 404
}

export type v1CurrenciesPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurrenciesPartialUpdateResponseSuccess = (v1CurrenciesPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1CurrenciesPartialUpdateResponseError = (v1CurrenciesPartialUpdateResponse400 | v1CurrenciesPartialUpdateResponse401 | v1CurrenciesPartialUpdateResponse404 | v1CurrenciesPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1CurrenciesPartialUpdateResponse = (v1CurrenciesPartialUpdateResponseSuccess | v1CurrenciesPartialUpdateResponseError)

export const getV1CurrenciesPartialUpdateUrl = (id: number,) => {




  return `/api/v1/currencies/${id}/`
}

/**
 * Słownik kodów klasowych: lista dla operatora, zapisy dla superadmina.
 * @summary Zmień kod klasowy (superadmin; kod tylko gdy nieużyty)
 */
export const v1CurrenciesPartialUpdate = async (id: number,
    patchedCurrencyRequest?: PatchedCurrencyRequest, options?: RequestInit): Promise<v1CurrenciesPartialUpdateResponse> => {

  return customFetch<v1CurrenciesPartialUpdateResponse>(getV1CurrenciesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedCurrencyRequest)
  }
);}




export const getV1CurrenciesPartialUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesPartialUpdate>>, TError,{id: number;data?: PatchedCurrencyRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesPartialUpdate>>, TError,{id: number;data?: PatchedCurrencyRequest}, TContext> => {

const mutationKey = ['v1CurrenciesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurrenciesPartialUpdate>>, {id: number;data?: PatchedCurrencyRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1CurrenciesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurrenciesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurrenciesPartialUpdate>>>
    export type V1CurrenciesPartialUpdateMutationBody = PatchedCurrencyRequest | undefined
    export type V1CurrenciesPartialUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Zmień kod klasowy (superadmin; kod tylko gdy nieużyty)
 */
export const useV1CurrenciesPartialUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesPartialUpdate>>, TError,{id: number;data?: PatchedCurrencyRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurrenciesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedCurrencyRequest},
        TContext
      > => {
      return useMutation(getV1CurrenciesPartialUpdateMutationOptions(options), queryClient);
    }

export type v1CurrenciesDestroyResponse204 = {
  data: void
  status: 204
}

export type v1CurrenciesDestroyResponse400 = {
  data: void
  status: 400
}

export type v1CurrenciesDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurrenciesDestroyResponse404 = {
  data: void
  status: 404
}

export type v1CurrenciesDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurrenciesDestroyResponseSuccess = (v1CurrenciesDestroyResponse204) & {
  headers: Headers;
};
export type v1CurrenciesDestroyResponseError = (v1CurrenciesDestroyResponse400 | v1CurrenciesDestroyResponse401 | v1CurrenciesDestroyResponse404 | v1CurrenciesDestroyResponse410) & {
  headers: Headers;
};

export type v1CurrenciesDestroyResponse = (v1CurrenciesDestroyResponseSuccess | v1CurrenciesDestroyResponseError)

export const getV1CurrenciesDestroyUrl = (id: number,) => {




  return `/api/v1/currencies/${id}/`
}

/**
 * Słownik kodów klasowych: lista dla operatora, zapisy dla superadmina.
 * @summary Usuń nieużyty kod klasowy (superadmin)
 */
export const v1CurrenciesDestroy = async (id: number, options?: RequestInit): Promise<v1CurrenciesDestroyResponse> => {

  return customFetch<v1CurrenciesDestroyResponse>(getV1CurrenciesDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getV1CurrenciesDestroyMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1CurrenciesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurrenciesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1CurrenciesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurrenciesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurrenciesDestroy>>>

    export type V1CurrenciesDestroyMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Usuń nieużyty kod klasowy (superadmin)
 */
export const useV1CurrenciesDestroy = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurrenciesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1CurrenciesDestroyMutationOptions(options), queryClient);
    }

export type v1CurrenciesImportCreateResponse200 = {
  data: CurrencyImportSummary
  status: 200
}

export type v1CurrenciesImportCreateResponse400 = {
  data: CurrencyImportError
  status: 400
}

export type v1CurrenciesImportCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurrenciesImportCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurrenciesImportCreateResponseSuccess = (v1CurrenciesImportCreateResponse200) & {
  headers: Headers;
};
export type v1CurrenciesImportCreateResponseError = (v1CurrenciesImportCreateResponse400 | v1CurrenciesImportCreateResponse401 | v1CurrenciesImportCreateResponse410) & {
  headers: Headers;
};

export type v1CurrenciesImportCreateResponse = (v1CurrenciesImportCreateResponseSuccess | v1CurrenciesImportCreateResponseError)

export const getV1CurrenciesImportCreateUrl = () => {




  return `/api/v1/currencies/import/`
}

/**
 * Słownik kodów klasowych: lista dla operatora, zapisy dla superadmina.
 * @summary Importuj do 100 kodów klasowych z XLSX (superadmin)
 */
export const v1CurrenciesImportCreate = async (currencyImportUploadRequest: CurrencyImportUploadRequest, options?: RequestInit): Promise<v1CurrenciesImportCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, currencyImportUploadRequest.file);

  return customFetch<v1CurrenciesImportCreateResponse>(getV1CurrenciesImportCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getV1CurrenciesImportCreateMutationOptions = <TError = CurrencyImportError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesImportCreate>>, TError,{data: CurrencyImportUploadRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesImportCreate>>, TError,{data: CurrencyImportUploadRequest}, TContext> => {

const mutationKey = ['v1CurrenciesImportCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurrenciesImportCreate>>, {data: CurrencyImportUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1CurrenciesImportCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurrenciesImportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurrenciesImportCreate>>>
    export type V1CurrenciesImportCreateMutationBody = CurrencyImportUploadRequest
    export type V1CurrenciesImportCreateMutationError = CurrencyImportError | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Importuj do 100 kodów klasowych z XLSX (superadmin)
 */
export const useV1CurrenciesImportCreate = <TError = CurrencyImportError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurrenciesImportCreate>>, TError,{data: CurrencyImportUploadRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurrenciesImportCreate>>,
        TError,
        {data: CurrencyImportUploadRequest},
        TContext
      > => {
      return useMutation(getV1CurrenciesImportCreateMutationOptions(options), queryClient);
    }

export type v1CurrenciesImportTemplateRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type v1CurrenciesImportTemplateRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurrenciesImportTemplateRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurrenciesImportTemplateRetrieveResponseSuccess = (v1CurrenciesImportTemplateRetrieveResponse200) & {
  headers: Headers;
};
export type v1CurrenciesImportTemplateRetrieveResponseError = (v1CurrenciesImportTemplateRetrieveResponse401 | v1CurrenciesImportTemplateRetrieveResponse410) & {
  headers: Headers;
};

export type v1CurrenciesImportTemplateRetrieveResponse = (v1CurrenciesImportTemplateRetrieveResponseSuccess | v1CurrenciesImportTemplateRetrieveResponseError)

export const getV1CurrenciesImportTemplateRetrieveUrl = () => {




  return `/api/v1/currencies/import-template/`
}

/**
 * Słownik kodów klasowych: lista dla operatora, zapisy dla superadmina.
 * @summary Pobierz szablon XLSX importu kodów klasowych (superadmin)
 */
export const v1CurrenciesImportTemplateRetrieve = async ( options?: RequestInit): Promise<v1CurrenciesImportTemplateRetrieveResponse> => {

  return customFetch<v1CurrenciesImportTemplateRetrieveResponse>(getV1CurrenciesImportTemplateRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1CurrenciesImportTemplateRetrieveQueryKey = () => {
    return [
    `/api/v1/currencies/import-template/`
    ] as const;
    }


export const getV1CurrenciesImportTemplateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CurrenciesImportTemplateRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>> = ({ signal }) => v1CurrenciesImportTemplateRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1CurrenciesImportTemplateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>>
export type V1CurrenciesImportTemplateRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1CurrenciesImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurrenciesImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurrenciesImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pobierz szablon XLSX importu kodów klasowych (superadmin)
 */

export function useV1CurrenciesImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurrenciesImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1CurrenciesImportTemplateRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1CurriculumAdminEnrollmentsListResponse200 = {
  data: PaginatedAdminCurriculumEnrollmentList
  status: 200
}

export type v1CurriculumAdminEnrollmentsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminEnrollmentsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminEnrollmentsListResponseSuccess = (v1CurriculumAdminEnrollmentsListResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminEnrollmentsListResponseError = (v1CurriculumAdminEnrollmentsListResponse401 | v1CurriculumAdminEnrollmentsListResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminEnrollmentsListResponse = (v1CurriculumAdminEnrollmentsListResponseSuccess | v1CurriculumAdminEnrollmentsListResponseError)

export const getV1CurriculumAdminEnrollmentsListUrl = (params?: V1CurriculumAdminEnrollmentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/curriculum/admin/enrollments/?${stringifiedParams}` : `/api/v1/curriculum/admin/enrollments/`
}

/**
 * List prepared class timelines and enroll a class into a published version.
 * @summary Lista zapisów klas do planu nauczania
 */
export const v1CurriculumAdminEnrollmentsList = async (params?: V1CurriculumAdminEnrollmentsListParams, options?: RequestInit): Promise<v1CurriculumAdminEnrollmentsListResponse> => {

  return customFetch<v1CurriculumAdminEnrollmentsListResponse>(getV1CurriculumAdminEnrollmentsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1CurriculumAdminEnrollmentsListQueryKey = (params?: V1CurriculumAdminEnrollmentsListParams,) => {
    return [
    `/api/v1/curriculum/admin/enrollments/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1CurriculumAdminEnrollmentsListQueryOptions = <TData = Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1CurriculumAdminEnrollmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CurriculumAdminEnrollmentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>> = ({ signal }) => v1CurriculumAdminEnrollmentsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1CurriculumAdminEnrollmentsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>>
export type V1CurriculumAdminEnrollmentsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1CurriculumAdminEnrollmentsList<TData = Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1CurriculumAdminEnrollmentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>,
          TError,
          Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurriculumAdminEnrollmentsList<TData = Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1CurriculumAdminEnrollmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>,
          TError,
          Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurriculumAdminEnrollmentsList<TData = Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1CurriculumAdminEnrollmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista zapisów klas do planu nauczania
 */

export function useV1CurriculumAdminEnrollmentsList<TData = Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1CurriculumAdminEnrollmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1CurriculumAdminEnrollmentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1CurriculumAdminEnrollmentsCreateResponse201 = {
  data: AdminCurriculumEnrollment
  status: 201
}

export type v1CurriculumAdminEnrollmentsCreateResponse400 = {
  data: void
  status: 400
}

export type v1CurriculumAdminEnrollmentsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminEnrollmentsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminEnrollmentsCreateResponseSuccess = (v1CurriculumAdminEnrollmentsCreateResponse201) & {
  headers: Headers;
};
export type v1CurriculumAdminEnrollmentsCreateResponseError = (v1CurriculumAdminEnrollmentsCreateResponse400 | v1CurriculumAdminEnrollmentsCreateResponse401 | v1CurriculumAdminEnrollmentsCreateResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminEnrollmentsCreateResponse = (v1CurriculumAdminEnrollmentsCreateResponseSuccess | v1CurriculumAdminEnrollmentsCreateResponseError)

export const getV1CurriculumAdminEnrollmentsCreateUrl = () => {




  return `/api/v1/curriculum/admin/enrollments/`
}

/**
 * List prepared class timelines and enroll a class into a published version.
 * @summary Zapis klasy do opublikowanej wersji planu
 */
export const v1CurriculumAdminEnrollmentsCreate = async (adminCurriculumEnrollmentCreateRequest: AdminCurriculumEnrollmentCreateRequest, options?: RequestInit): Promise<v1CurriculumAdminEnrollmentsCreateResponse> => {

  return customFetch<v1CurriculumAdminEnrollmentsCreateResponse>(getV1CurriculumAdminEnrollmentsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminCurriculumEnrollmentCreateRequest)
  }
);}




export const getV1CurriculumAdminEnrollmentsCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsCreate>>, TError,{data: AdminCurriculumEnrollmentCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsCreate>>, TError,{data: AdminCurriculumEnrollmentCreateRequest}, TContext> => {

const mutationKey = ['v1CurriculumAdminEnrollmentsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsCreate>>, {data: AdminCurriculumEnrollmentCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1CurriculumAdminEnrollmentsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminEnrollmentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsCreate>>>
    export type V1CurriculumAdminEnrollmentsCreateMutationBody = AdminCurriculumEnrollmentCreateRequest
    export type V1CurriculumAdminEnrollmentsCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Zapis klasy do opublikowanej wersji planu
 */
export const useV1CurriculumAdminEnrollmentsCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsCreate>>, TError,{data: AdminCurriculumEnrollmentCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsCreate>>,
        TError,
        {data: AdminCurriculumEnrollmentCreateRequest},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminEnrollmentsCreateMutationOptions(options), queryClient);
    }

export type v1CurriculumAdminEnrollmentsPartialUpdateResponse200 = {
  data: AdminCurriculumEnrollment
  status: 200
}

export type v1CurriculumAdminEnrollmentsPartialUpdateResponse400 = {
  data: void
  status: 400
}

export type v1CurriculumAdminEnrollmentsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminEnrollmentsPartialUpdateResponse404 = {
  data: void
  status: 404
}

export type v1CurriculumAdminEnrollmentsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminEnrollmentsPartialUpdateResponseSuccess = (v1CurriculumAdminEnrollmentsPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminEnrollmentsPartialUpdateResponseError = (v1CurriculumAdminEnrollmentsPartialUpdateResponse400 | v1CurriculumAdminEnrollmentsPartialUpdateResponse401 | v1CurriculumAdminEnrollmentsPartialUpdateResponse404 | v1CurriculumAdminEnrollmentsPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminEnrollmentsPartialUpdateResponse = (v1CurriculumAdminEnrollmentsPartialUpdateResponseSuccess | v1CurriculumAdminEnrollmentsPartialUpdateResponseError)

export const getV1CurriculumAdminEnrollmentsPartialUpdateUrl = (enrollmentId: number,) => {




  return `/api/v1/curriculum/admin/enrollments/${enrollmentId}/`
}

/**
 * Read side of the plan surface: admins and superadmins alike.
 *
 * `filter_backends` / `pagination_class` are cleared because
 * `DEFAULT_FILTER_BACKENDS` is set globally and drf-spectacular would otherwise
 * document filter parameters no view here implements.
 * @summary Zmiana stanu zapisu klasy
 */
export const v1CurriculumAdminEnrollmentsPartialUpdate = async (enrollmentId: number,
    patchedAdminCurriculumEnrollmentUpdateRequest?: PatchedAdminCurriculumEnrollmentUpdateRequest, options?: RequestInit): Promise<v1CurriculumAdminEnrollmentsPartialUpdateResponse> => {

  return customFetch<v1CurriculumAdminEnrollmentsPartialUpdateResponse>(getV1CurriculumAdminEnrollmentsPartialUpdateUrl(enrollmentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminCurriculumEnrollmentUpdateRequest)
  }
);}




export const getV1CurriculumAdminEnrollmentsPartialUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsPartialUpdate>>, TError,{enrollmentId: number;data?: PatchedAdminCurriculumEnrollmentUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsPartialUpdate>>, TError,{enrollmentId: number;data?: PatchedAdminCurriculumEnrollmentUpdateRequest}, TContext> => {

const mutationKey = ['v1CurriculumAdminEnrollmentsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsPartialUpdate>>, {enrollmentId: number;data?: PatchedAdminCurriculumEnrollmentUpdateRequest}> = (props) => {
          const {enrollmentId,data} = props ?? {};

          return  v1CurriculumAdminEnrollmentsPartialUpdate(enrollmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminEnrollmentsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsPartialUpdate>>>
    export type V1CurriculumAdminEnrollmentsPartialUpdateMutationBody = PatchedAdminCurriculumEnrollmentUpdateRequest | undefined
    export type V1CurriculumAdminEnrollmentsPartialUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Zmiana stanu zapisu klasy
 */
export const useV1CurriculumAdminEnrollmentsPartialUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsPartialUpdate>>, TError,{enrollmentId: number;data?: PatchedAdminCurriculumEnrollmentUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminEnrollmentsPartialUpdate>>,
        TError,
        {enrollmentId: number;data?: PatchedAdminCurriculumEnrollmentUpdateRequest},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminEnrollmentsPartialUpdateMutationOptions(options), queryClient);
    }

export type v1CurriculumAdminPlanRetrieveResponse200 = {
  data: AdminCurriculumPlan
  status: 200
}

export type v1CurriculumAdminPlanRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanRetrieveResponseSuccess = (v1CurriculumAdminPlanRetrieveResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanRetrieveResponseError = (v1CurriculumAdminPlanRetrieveResponse401 | v1CurriculumAdminPlanRetrieveResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanRetrieveResponse = (v1CurriculumAdminPlanRetrieveResponseSuccess | v1CurriculumAdminPlanRetrieveResponseError)

export const getV1CurriculumAdminPlanRetrieveUrl = () => {




  return `/api/v1/curriculum/admin/plan/`
}

/**
 * Read side of the plan surface: admins and superadmins alike.
 *
 * `filter_backends` / `pagination_class` are cleared because
 * `DEFAULT_FILTER_BACKENDS` is set globally and drf-spectacular would otherwise
 * document filter parameters no view here implements.
 * @summary Plan nauczania i historia jego wersji
 */
export const v1CurriculumAdminPlanRetrieve = async ( options?: RequestInit): Promise<v1CurriculumAdminPlanRetrieveResponse> => {

  return customFetch<v1CurriculumAdminPlanRetrieveResponse>(getV1CurriculumAdminPlanRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1CurriculumAdminPlanRetrieveQueryKey = () => {
    return [
    `/api/v1/curriculum/admin/plan/`
    ] as const;
    }


export const getV1CurriculumAdminPlanRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CurriculumAdminPlanRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>> = ({ signal }) => v1CurriculumAdminPlanRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1CurriculumAdminPlanRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>>
export type V1CurriculumAdminPlanRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1CurriculumAdminPlanRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurriculumAdminPlanRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurriculumAdminPlanRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Plan nauczania i historia jego wersji
 */

export function useV1CurriculumAdminPlanRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1CurriculumAdminPlanRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1CurriculumAdminPlanVersionsCreateResponse201 = {
  data: AdminCurriculumPlanVersion
  status: 201
}

export type v1CurriculumAdminPlanVersionsCreateResponse400 = {
  data: void
  status: 400
}

export type v1CurriculumAdminPlanVersionsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionsCreateResponse409 = {
  data: AdminCurriculumConflict
  status: 409
}

export type v1CurriculumAdminPlanVersionsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionsCreateResponseSuccess = (v1CurriculumAdminPlanVersionsCreateResponse201) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionsCreateResponseError = (v1CurriculumAdminPlanVersionsCreateResponse400 | v1CurriculumAdminPlanVersionsCreateResponse401 | v1CurriculumAdminPlanVersionsCreateResponse409 | v1CurriculumAdminPlanVersionsCreateResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionsCreateResponse = (v1CurriculumAdminPlanVersionsCreateResponseSuccess | v1CurriculumAdminPlanVersionsCreateResponseError)

export const getV1CurriculumAdminPlanVersionsCreateUrl = () => {




  return `/api/v1/curriculum/admin/plan/versions/`
}

/**
 * Every state change to the plan — superadmin only.
 *
 * The rule is the one the quiz and mission recipe/revision surfaces follow:
 * reading a configuration is an admin's job, changing what students will be
 * served is not. The teaching plan is global and single, and publishing it
 * replaces the schedule for every class at once, so it sits on the same side
 * as `quiz/admin/cycle-recipes/.../activate/`.
 *
 * One deliberate divergence from `quiz`, so a later wave does not "fix" it
 * back: a closed authoring gate answers 400 with a `state` key here where
 * `quiz/rollout.py` answers 404 — see that module's docstring for why a
 * service that commands and tests call cannot pretend not to exist.
 * @summary Otwarcie kolejnego szkicu jako kopii najnowszej wersji
 */
export const v1CurriculumAdminPlanVersionsCreate = async (adminCurriculumNextDraftRequestRequest: AdminCurriculumNextDraftRequestRequest, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionsCreateResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionsCreateResponse>(getV1CurriculumAdminPlanVersionsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminCurriculumNextDraftRequestRequest)
  }
);}




export const getV1CurriculumAdminPlanVersionsCreateMutationOptions = <TError = void | UnauthorizedResponse | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCreate>>, TError,{data: AdminCurriculumNextDraftRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCreate>>, TError,{data: AdminCurriculumNextDraftRequestRequest}, TContext> => {

const mutationKey = ['v1CurriculumAdminPlanVersionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCreate>>, {data: AdminCurriculumNextDraftRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1CurriculumAdminPlanVersionsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminPlanVersionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCreate>>>
    export type V1CurriculumAdminPlanVersionsCreateMutationBody = AdminCurriculumNextDraftRequestRequest
    export type V1CurriculumAdminPlanVersionsCreateMutationError = void | UnauthorizedResponse | AdminCurriculumConflict | AccountGoneResponse

    /**
 * @summary Otwarcie kolejnego szkicu jako kopii najnowszej wersji
 */
export const useV1CurriculumAdminPlanVersionsCreate = <TError = void | UnauthorizedResponse | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCreate>>, TError,{data: AdminCurriculumNextDraftRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCreate>>,
        TError,
        {data: AdminCurriculumNextDraftRequestRequest},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminPlanVersionsCreateMutationOptions(options), queryClient);
    }

export type v1CurriculumAdminPlanVersionRetrieveResponse200 = {
  data: AdminCurriculumPlanVersionDetail
  status: 200
}

export type v1CurriculumAdminPlanVersionRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionRetrieveResponse404 = {
  data: void
  status: 404
}

export type v1CurriculumAdminPlanVersionRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionRetrieveResponseSuccess = (v1CurriculumAdminPlanVersionRetrieveResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionRetrieveResponseError = (v1CurriculumAdminPlanVersionRetrieveResponse401 | v1CurriculumAdminPlanVersionRetrieveResponse404 | v1CurriculumAdminPlanVersionRetrieveResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionRetrieveResponse = (v1CurriculumAdminPlanVersionRetrieveResponseSuccess | v1CurriculumAdminPlanVersionRetrieveResponseError)

export const getV1CurriculumAdminPlanVersionRetrieveUrl = (number: number,) => {




  return `/api/v1/curriculum/admin/plan/versions/${number}/`
}

/**
 * The one route here whose two methods sit on different sides of the role line.
 *
 * Everywhere else in this module a route is entirely a read or entirely a
 * write, and the base class settles it. The version snapshot and the version's
 * own title share a URL, so the permission has to be per method: reading the
 * plan is an admin's job, renaming a draft is not.
 *
 * `get_permissions` rather than a second route: `PATCH .../versions/3/name/`
 * would be a URL invented to dodge a two-line override, and the panel would
 * have to know that one field of the resource lives somewhere else.
 * @summary Wersja planu wraz z gotowością do publikacji
 */
export const v1CurriculumAdminPlanVersionRetrieve = async (number: number, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionRetrieveResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionRetrieveResponse>(getV1CurriculumAdminPlanVersionRetrieveUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1CurriculumAdminPlanVersionRetrieveQueryKey = (number: number,) => {
    return [
    `/api/v1/curriculum/admin/plan/versions/${number}/`
    ] as const;
    }


export const getV1CurriculumAdminPlanVersionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CurriculumAdminPlanVersionRetrieveQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>> = ({ signal }) => v1CurriculumAdminPlanVersionRetrieve(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1CurriculumAdminPlanVersionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>>
export type V1CurriculumAdminPlanVersionRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1CurriculumAdminPlanVersionRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 number: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurriculumAdminPlanVersionRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurriculumAdminPlanVersionRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Wersja planu wraz z gotowością do publikacji
 */

export function useV1CurriculumAdminPlanVersionRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1CurriculumAdminPlanVersionRetrieveQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1CurriculumAdminPlanVersionUpdateResponse200 = {
  data: AdminCurriculumPlanVersion
  status: 200
}

export type v1CurriculumAdminPlanVersionUpdateResponse400 = {
  data: void
  status: 400
}

export type v1CurriculumAdminPlanVersionUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionUpdateResponse404 = {
  data: void
  status: 404
}

export type v1CurriculumAdminPlanVersionUpdateResponse409 = {
  data: AdminCurriculumConflict
  status: 409
}

export type v1CurriculumAdminPlanVersionUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionUpdateResponseSuccess = (v1CurriculumAdminPlanVersionUpdateResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionUpdateResponseError = (v1CurriculumAdminPlanVersionUpdateResponse400 | v1CurriculumAdminPlanVersionUpdateResponse401 | v1CurriculumAdminPlanVersionUpdateResponse404 | v1CurriculumAdminPlanVersionUpdateResponse409 | v1CurriculumAdminPlanVersionUpdateResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionUpdateResponse = (v1CurriculumAdminPlanVersionUpdateResponseSuccess | v1CurriculumAdminPlanVersionUpdateResponseError)

export const getV1CurriculumAdminPlanVersionUpdateUrl = (number: number,) => {




  return `/api/v1/curriculum/admin/plan/versions/${number}/`
}

/**
 * The one route here whose two methods sit on different sides of the role line.
 *
 * Everywhere else in this module a route is entirely a read or entirely a
 * write, and the base class settles it. The version snapshot and the version's
 * own title share a URL, so the permission has to be per method: reading the
 * plan is an admin's job, renaming a draft is not.
 *
 * `get_permissions` rather than a second route: `PATCH .../versions/3/name/`
 * would be a URL invented to dodge a two-line override, and the panel would
 * have to know that one field of the resource lives somewhere else.
 * @summary Edycja nazwy i opisu szkicu
 */
export const v1CurriculumAdminPlanVersionUpdate = async (number: number,
    patchedAdminCurriculumVersionWriteRequest?: PatchedAdminCurriculumVersionWriteRequest, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionUpdateResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionUpdateResponse>(getV1CurriculumAdminPlanVersionUpdateUrl(number),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminCurriculumVersionWriteRequest)
  }
);}




export const getV1CurriculumAdminPlanVersionUpdateMutationOptions = <TError = void | UnauthorizedResponse | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionUpdate>>, TError,{number: number;data?: PatchedAdminCurriculumVersionWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionUpdate>>, TError,{number: number;data?: PatchedAdminCurriculumVersionWriteRequest}, TContext> => {

const mutationKey = ['v1CurriculumAdminPlanVersionUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionUpdate>>, {number: number;data?: PatchedAdminCurriculumVersionWriteRequest}> = (props) => {
          const {number,data} = props ?? {};

          return  v1CurriculumAdminPlanVersionUpdate(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminPlanVersionUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionUpdate>>>
    export type V1CurriculumAdminPlanVersionUpdateMutationBody = PatchedAdminCurriculumVersionWriteRequest | undefined
    export type V1CurriculumAdminPlanVersionUpdateMutationError = void | UnauthorizedResponse | AdminCurriculumConflict | AccountGoneResponse

    /**
 * @summary Edycja nazwy i opisu szkicu
 */
export const useV1CurriculumAdminPlanVersionUpdate = <TError = void | UnauthorizedResponse | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionUpdate>>, TError,{number: number;data?: PatchedAdminCurriculumVersionWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionUpdate>>,
        TError,
        {number: number;data?: PatchedAdminCurriculumVersionWriteRequest},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminPlanVersionUpdateMutationOptions(options), queryClient);
    }

export type v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse200 = {
  data: AdminAnnualCalendarImportCommit
  status: 200
}

export type v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse400 = {
  data: AdminAnnualCalendarImportError
  status: 400
}

export type v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse403 = {
  data: void
  status: 403
}

export type v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse404 = {
  data: void
  status: 404
}

export type v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse409 = {
  data: AdminCurriculumConflict
  status: 409
}

export type v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponseSuccess = (v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponseError = (v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse400 | v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse401 | v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse403 | v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse404 | v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse409 | v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse = (v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponseSuccess | v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponseError)

export const getV1CurriculumAdminPlanVersionsCalendarImportsCommitCreateUrl = (number: number,
    importId: string,) => {




  return `/api/v1/curriculum/admin/plan/versions/${number}/calendar-imports/${importId}/commit/`
}

/**
 * Every state change to the plan — superadmin only.
 *
 * The rule is the one the quiz and mission recipe/revision surfaces follow:
 * reading a configuration is an admin's job, changing what students will be
 * served is not. The teaching plan is global and single, and publishing it
 * replaces the schedule for every class at once, so it sits on the same side
 * as `quiz/admin/cycle-recipes/.../activate/`.
 *
 * One deliberate divergence from `quiz`, so a later wave does not "fix" it
 * back: a closed authoring gate answers 400 with a `state` key here where
 * `quiz/rollout.py` answers 404 — see that module's docstring for why a
 * service that commands and tests call cannot pretend not to exist.
 * @summary Atomowe zatwierdzenie podglądu rocznego kalendarza quizów
 */
export const v1CurriculumAdminPlanVersionsCalendarImportsCommitCreate = async (number: number,
    importId: string, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionsCalendarImportsCommitCreateResponse>(getV1CurriculumAdminPlanVersionsCalendarImportsCommitCreateUrl(number,importId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1CurriculumAdminPlanVersionsCalendarImportsCommitCreateMutationOptions = <TError = AdminAnnualCalendarImportError | UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsCommitCreate>>, TError,{number: number;importId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsCommitCreate>>, TError,{number: number;importId: string}, TContext> => {

const mutationKey = ['v1CurriculumAdminPlanVersionsCalendarImportsCommitCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsCommitCreate>>, {number: number;importId: string}> = (props) => {
          const {number,importId} = props ?? {};

          return  v1CurriculumAdminPlanVersionsCalendarImportsCommitCreate(number,importId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminPlanVersionsCalendarImportsCommitCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsCommitCreate>>>

    export type V1CurriculumAdminPlanVersionsCalendarImportsCommitCreateMutationError = AdminAnnualCalendarImportError | UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse

    /**
 * @summary Atomowe zatwierdzenie podglądu rocznego kalendarza quizów
 */
export const useV1CurriculumAdminPlanVersionsCalendarImportsCommitCreate = <TError = AdminAnnualCalendarImportError | UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsCommitCreate>>, TError,{number: number;importId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsCommitCreate>>,
        TError,
        {number: number;importId: string},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminPlanVersionsCalendarImportsCommitCreateMutationOptions(options), queryClient);
    }

export type v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse201 = {
  data: AdminAnnualCalendarImportPreview
  status: 201
}

export type v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse400 = {
  data: AdminAnnualCalendarImportError
  status: 400
}

export type v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse403 = {
  data: void
  status: 403
}

export type v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse404 = {
  data: void
  status: 404
}

export type v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse409 = {
  data: AdminCurriculumConflict
  status: 409
}

export type v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponseSuccess = (v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse201) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponseError = (v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse400 | v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse401 | v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse403 | v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse404 | v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse409 | v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse = (v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponseSuccess | v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponseError)

export const getV1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateUrl = (number: number,) => {




  return `/api/v1/curriculum/admin/plan/versions/${number}/calendar-imports/preview/`
}

/**
 * Read side of the plan surface: admins and superadmins alike.
 *
 * `filter_backends` / `pagination_class` are cleared because
 * `DEFAULT_FILTER_BACKENDS` is set globally and drf-spectacular would otherwise
 * document filter parameters no view here implements.
 * @summary Podgląd importu rocznego kalendarza quizów XLSX
 */
export const v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreate = async (number: number,
    adminAnnualCalendarImportUploadRequest: AdminAnnualCalendarImportUploadRequest, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse> => {
    const formData = new FormData();
formData.append(`program_year`, adminAnnualCalendarImportUploadRequest.program_year.toString())
formData.append(`content_module`, adminAnnualCalendarImportUploadRequest.content_module);
formData.append(`file`, adminAnnualCalendarImportUploadRequest.file);

  return customFetch<v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateResponse>(getV1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateUrl(number),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getV1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateMutationOptions = <TError = AdminAnnualCalendarImportError | UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreate>>, TError,{number: number;data: AdminAnnualCalendarImportUploadRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreate>>, TError,{number: number;data: AdminAnnualCalendarImportUploadRequest}, TContext> => {

const mutationKey = ['v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreate>>, {number: number;data: AdminAnnualCalendarImportUploadRequest}> = (props) => {
          const {number,data} = props ?? {};

          return  v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreate(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreate>>>
    export type V1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateMutationBody = AdminAnnualCalendarImportUploadRequest
    export type V1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateMutationError = AdminAnnualCalendarImportError | UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse

    /**
 * @summary Podgląd importu rocznego kalendarza quizów XLSX
 */
export const useV1CurriculumAdminPlanVersionsCalendarImportsPreviewCreate = <TError = AdminAnnualCalendarImportError | UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreate>>, TError,{number: number;data: AdminAnnualCalendarImportUploadRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarImportsPreviewCreate>>,
        TError,
        {number: number;data: AdminAnnualCalendarImportUploadRequest},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminPlanVersionsCalendarImportsPreviewCreateMutationOptions(options), queryClient);
    }

export type v1CurriculumAdminPlanVersionsCalendarSlotsListResponse200 = {
  data: AdminCalendarSlotList[]
  status: 200
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsListResponseSuccess = (v1CurriculumAdminPlanVersionsCalendarSlotsListResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionsCalendarSlotsListResponseError = (v1CurriculumAdminPlanVersionsCalendarSlotsListResponse401 | v1CurriculumAdminPlanVersionsCalendarSlotsListResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionsCalendarSlotsListResponse = (v1CurriculumAdminPlanVersionsCalendarSlotsListResponseSuccess | v1CurriculumAdminPlanVersionsCalendarSlotsListResponseError)

export const getV1CurriculumAdminPlanVersionsCalendarSlotsListUrl = (number: number,) => {




  return `/api/v1/curriculum/admin/plan/versions/${number}/calendar-slots/`
}

/**
 * Read side of the plan surface: admins and superadmins alike.
 *
 * `filter_backends` / `pagination_class` are cleared because
 * `DEFAULT_FILTER_BACKENDS` is set globally and drf-spectacular would otherwise
 * document filter parameters no view here implements.
 */
export const v1CurriculumAdminPlanVersionsCalendarSlotsList = async (number: number, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionsCalendarSlotsListResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionsCalendarSlotsListResponse>(getV1CurriculumAdminPlanVersionsCalendarSlotsListUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1CurriculumAdminPlanVersionsCalendarSlotsListQueryKey = (number: number,) => {
    return [
    `/api/v1/curriculum/admin/plan/versions/${number}/calendar-slots/`
    ] as const;
    }


export const getV1CurriculumAdminPlanVersionsCalendarSlotsListQueryOptions = <TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CurriculumAdminPlanVersionsCalendarSlotsListQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>> = ({ signal }) => v1CurriculumAdminPlanVersionsCalendarSlotsList(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1CurriculumAdminPlanVersionsCalendarSlotsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>>
export type V1CurriculumAdminPlanVersionsCalendarSlotsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1CurriculumAdminPlanVersionsCalendarSlotsList<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 number: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>,
          TError,
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurriculumAdminPlanVersionsCalendarSlotsList<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>,
          TError,
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurriculumAdminPlanVersionsCalendarSlotsList<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1CurriculumAdminPlanVersionsCalendarSlotsList<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1CurriculumAdminPlanVersionsCalendarSlotsListQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponse201 = {
  data: AdminCalendarSlot
  status: 201
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponseSuccess = (v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponse201) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponseError = (v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponse401 | v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponse = (v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponseSuccess | v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponseError)

export const getV1CurriculumAdminPlanVersionsCalendarSlotsCreateUrl = (number: number,) => {




  return `/api/v1/curriculum/admin/plan/versions/${number}/calendar-slots/`
}

/**
 * Read side of the plan surface: admins and superadmins alike.
 *
 * `filter_backends` / `pagination_class` are cleared because
 * `DEFAULT_FILTER_BACKENDS` is set globally and drf-spectacular would otherwise
 * document filter parameters no view here implements.
 */
export const v1CurriculumAdminPlanVersionsCalendarSlotsCreate = async (number: number,
    adminCalendarSlotRequest: AdminCalendarSlotRequest, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionsCalendarSlotsCreateResponse>(getV1CurriculumAdminPlanVersionsCalendarSlotsCreateUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminCalendarSlotRequest)
  }
);}




export const getV1CurriculumAdminPlanVersionsCalendarSlotsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsCreate>>, TError,{number: number;data: AdminCalendarSlotRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsCreate>>, TError,{number: number;data: AdminCalendarSlotRequest}, TContext> => {

const mutationKey = ['v1CurriculumAdminPlanVersionsCalendarSlotsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsCreate>>, {number: number;data: AdminCalendarSlotRequest}> = (props) => {
          const {number,data} = props ?? {};

          return  v1CurriculumAdminPlanVersionsCalendarSlotsCreate(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminPlanVersionsCalendarSlotsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsCreate>>>
    export type V1CurriculumAdminPlanVersionsCalendarSlotsCreateMutationBody = AdminCalendarSlotRequest
    export type V1CurriculumAdminPlanVersionsCalendarSlotsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1CurriculumAdminPlanVersionsCalendarSlotsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsCreate>>, TError,{number: number;data: AdminCalendarSlotRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsCreate>>,
        TError,
        {number: number;data: AdminCalendarSlotRequest},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminPlanVersionsCalendarSlotsCreateMutationOptions(options), queryClient);
    }

export type v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponse200 = {
  data: AdminCalendarSlot
  status: 200
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponseSuccess = (v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponseError = (v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponse401 | v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponse = (v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponseSuccess | v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponseError)

export const getV1CurriculumAdminPlanVersionsCalendarSlotsRetrieveUrl = (number: number,
    slotId: string,) => {




  return `/api/v1/curriculum/admin/plan/versions/${number}/calendar-slots/${slotId}/`
}

/**
 * Read side of the plan surface: admins and superadmins alike.
 *
 * `filter_backends` / `pagination_class` are cleared because
 * `DEFAULT_FILTER_BACKENDS` is set globally and drf-spectacular would otherwise
 * document filter parameters no view here implements.
 */
export const v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve = async (number: number,
    slotId: string, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionsCalendarSlotsRetrieveResponse>(getV1CurriculumAdminPlanVersionsCalendarSlotsRetrieveUrl(number,slotId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1CurriculumAdminPlanVersionsCalendarSlotsRetrieveQueryKey = (number: number,
    slotId: string,) => {
    return [
    `/api/v1/curriculum/admin/plan/versions/${number}/calendar-slots/${slotId}/`
    ] as const;
    }


export const getV1CurriculumAdminPlanVersionsCalendarSlotsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(number: number,
    slotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CurriculumAdminPlanVersionsCalendarSlotsRetrieveQueryKey(number,slotId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>> = ({ signal }) => v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve(number,slotId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined && slotId !== null && slotId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1CurriculumAdminPlanVersionsCalendarSlotsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>>
export type V1CurriculumAdminPlanVersionsCalendarSlotsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1CurriculumAdminPlanVersionsCalendarSlotsRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 number: number,
    slotId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurriculumAdminPlanVersionsCalendarSlotsRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 number: number,
    slotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1CurriculumAdminPlanVersionsCalendarSlotsRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 number: number,
    slotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1CurriculumAdminPlanVersionsCalendarSlotsRetrieve<TData = Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 number: number,
    slotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1CurriculumAdminPlanVersionsCalendarSlotsRetrieveQueryOptions(number,slotId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponse200 = {
  data: AdminCalendarSlot
  status: 200
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponseSuccess = (v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponseError = (v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponse401 | v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponse = (v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponseSuccess | v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponseError)

export const getV1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateUrl = (number: number,
    slotId: string,) => {




  return `/api/v1/curriculum/admin/plan/versions/${number}/calendar-slots/${slotId}/`
}

/**
 * Read side of the plan surface: admins and superadmins alike.
 *
 * `filter_backends` / `pagination_class` are cleared because
 * `DEFAULT_FILTER_BACKENDS` is set globally and drf-spectacular would otherwise
 * document filter parameters no view here implements.
 */
export const v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdate = async (number: number,
    slotId: string,
    patchedAdminCalendarSlotRequest?: PatchedAdminCalendarSlotRequest, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateResponse>(getV1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateUrl(number,slotId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminCalendarSlotRequest)
  }
);}




export const getV1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdate>>, TError,{number: number;slotId: string;data?: PatchedAdminCalendarSlotRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdate>>, TError,{number: number;slotId: string;data?: PatchedAdminCalendarSlotRequest}, TContext> => {

const mutationKey = ['v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdate>>, {number: number;slotId: string;data?: PatchedAdminCalendarSlotRequest}> = (props) => {
          const {number,slotId,data} = props ?? {};

          return  v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdate(number,slotId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdate>>>
    export type V1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateMutationBody = PatchedAdminCalendarSlotRequest | undefined
    export type V1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdate>>, TError,{number: number;slotId: string;data?: PatchedAdminCalendarSlotRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdate>>,
        TError,
        {number: number;slotId: string;data?: PatchedAdminCalendarSlotRequest},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminPlanVersionsCalendarSlotsPartialUpdateMutationOptions(options), queryClient);
    }

export type v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponse204 = {
  data: void
  status: 204
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponseSuccess = (v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponse204) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponseError = (v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponse401 | v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponse = (v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponseSuccess | v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponseError)

export const getV1CurriculumAdminPlanVersionsCalendarSlotsDestroyUrl = (number: number,
    slotId: string,
    params: V1CurriculumAdminPlanVersionsCalendarSlotsDestroyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/curriculum/admin/plan/versions/${number}/calendar-slots/${slotId}/?${stringifiedParams}` : `/api/v1/curriculum/admin/plan/versions/${number}/calendar-slots/${slotId}/`
}

/**
 * Read side of the plan surface: admins and superadmins alike.
 *
 * `filter_backends` / `pagination_class` are cleared because
 * `DEFAULT_FILTER_BACKENDS` is set globally and drf-spectacular would otherwise
 * document filter parameters no view here implements.
 */
export const v1CurriculumAdminPlanVersionsCalendarSlotsDestroy = async (number: number,
    slotId: string,
    params: V1CurriculumAdminPlanVersionsCalendarSlotsDestroyParams, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionsCalendarSlotsDestroyResponse>(getV1CurriculumAdminPlanVersionsCalendarSlotsDestroyUrl(number,slotId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getV1CurriculumAdminPlanVersionsCalendarSlotsDestroyMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsDestroy>>, TError,{number: number;slotId: string;params: V1CurriculumAdminPlanVersionsCalendarSlotsDestroyParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsDestroy>>, TError,{number: number;slotId: string;params: V1CurriculumAdminPlanVersionsCalendarSlotsDestroyParams}, TContext> => {

const mutationKey = ['v1CurriculumAdminPlanVersionsCalendarSlotsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsDestroy>>, {number: number;slotId: string;params: V1CurriculumAdminPlanVersionsCalendarSlotsDestroyParams}> = (props) => {
          const {number,slotId,params} = props ?? {};

          return  v1CurriculumAdminPlanVersionsCalendarSlotsDestroy(number,slotId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminPlanVersionsCalendarSlotsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsDestroy>>>

    export type V1CurriculumAdminPlanVersionsCalendarSlotsDestroyMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1CurriculumAdminPlanVersionsCalendarSlotsDestroy = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsDestroy>>, TError,{number: number;slotId: string;params: V1CurriculumAdminPlanVersionsCalendarSlotsDestroyParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionsCalendarSlotsDestroy>>,
        TError,
        {number: number;slotId: string;params: V1CurriculumAdminPlanVersionsCalendarSlotsDestroyParams},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminPlanVersionsCalendarSlotsDestroyMutationOptions(options), queryClient);
    }

export type v1CurriculumAdminPlanVersionPublishResponse200 = {
  data: AdminCurriculumPlanVersion
  status: 200
}

export type v1CurriculumAdminPlanVersionPublishResponse400 = {
  data: AdminCurriculumPublicationError
  status: 400
}

export type v1CurriculumAdminPlanVersionPublishResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionPublishResponse404 = {
  data: void
  status: 404
}

export type v1CurriculumAdminPlanVersionPublishResponse409 = {
  data: AdminCurriculumConflict
  status: 409
}

export type v1CurriculumAdminPlanVersionPublishResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionPublishResponseSuccess = (v1CurriculumAdminPlanVersionPublishResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionPublishResponseError = (v1CurriculumAdminPlanVersionPublishResponse400 | v1CurriculumAdminPlanVersionPublishResponse401 | v1CurriculumAdminPlanVersionPublishResponse404 | v1CurriculumAdminPlanVersionPublishResponse409 | v1CurriculumAdminPlanVersionPublishResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionPublishResponse = (v1CurriculumAdminPlanVersionPublishResponseSuccess | v1CurriculumAdminPlanVersionPublishResponseError)

export const getV1CurriculumAdminPlanVersionPublishUrl = (number: number,) => {




  return `/api/v1/curriculum/admin/plan/versions/${number}/publish/`
}

/**
 * Every refusal this route can produce carries the declared body.
 *
 * `publish_plan_version` re-raises the rollout gate's refusal as a
 * `PlanPublicationError`, so a closed gate answers with the same
 * `{detail, validation}` envelope the readiness block on the version
 * screen already renders — one branch in the panel, not two.
 * @summary Publikacja wersji planu
 */
export const v1CurriculumAdminPlanVersionPublish = async (number: number,
    adminCurriculumPublishRequestRequest: AdminCurriculumPublishRequestRequest, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionPublishResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionPublishResponse>(getV1CurriculumAdminPlanVersionPublishUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminCurriculumPublishRequestRequest)
  }
);}




export const getV1CurriculumAdminPlanVersionPublishMutationOptions = <TError = AdminCurriculumPublicationError | UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionPublish>>, TError,{number: number;data: AdminCurriculumPublishRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionPublish>>, TError,{number: number;data: AdminCurriculumPublishRequestRequest}, TContext> => {

const mutationKey = ['v1CurriculumAdminPlanVersionPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionPublish>>, {number: number;data: AdminCurriculumPublishRequestRequest}> = (props) => {
          const {number,data} = props ?? {};

          return  v1CurriculumAdminPlanVersionPublish(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminPlanVersionPublishMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionPublish>>>
    export type V1CurriculumAdminPlanVersionPublishMutationBody = AdminCurriculumPublishRequestRequest
    export type V1CurriculumAdminPlanVersionPublishMutationError = AdminCurriculumPublicationError | UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse

    /**
 * @summary Publikacja wersji planu
 */
export const useV1CurriculumAdminPlanVersionPublish = <TError = AdminCurriculumPublicationError | UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionPublish>>, TError,{number: number;data: AdminCurriculumPublishRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionPublish>>,
        TError,
        {number: number;data: AdminCurriculumPublishRequestRequest},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminPlanVersionPublishMutationOptions(options), queryClient);
    }

export type v1CurriculumAdminPlanVersionWithdrawResponse200 = {
  data: AdminCurriculumPlanVersion
  status: 200
}

export type v1CurriculumAdminPlanVersionWithdrawResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1CurriculumAdminPlanVersionWithdrawResponse404 = {
  data: void
  status: 404
}

export type v1CurriculumAdminPlanVersionWithdrawResponse409 = {
  data: AdminCurriculumConflict
  status: 409
}

export type v1CurriculumAdminPlanVersionWithdrawResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1CurriculumAdminPlanVersionWithdrawResponseSuccess = (v1CurriculumAdminPlanVersionWithdrawResponse200) & {
  headers: Headers;
};
export type v1CurriculumAdminPlanVersionWithdrawResponseError = (v1CurriculumAdminPlanVersionWithdrawResponse401 | v1CurriculumAdminPlanVersionWithdrawResponse404 | v1CurriculumAdminPlanVersionWithdrawResponse409 | v1CurriculumAdminPlanVersionWithdrawResponse410) & {
  headers: Headers;
};

export type v1CurriculumAdminPlanVersionWithdrawResponse = (v1CurriculumAdminPlanVersionWithdrawResponseSuccess | v1CurriculumAdminPlanVersionWithdrawResponseError)

export const getV1CurriculumAdminPlanVersionWithdrawUrl = (number: number,) => {




  return `/api/v1/curriculum/admin/plan/versions/${number}/withdraw/`
}

/**
 * No body, and no rollout gate — both deliberately.
 *
 * No `expected_edit_version`: withdrawal targets THE current publication,
 * and `withdraw_plan_version` refuses anything that is not it. A published
 * version's `edit_version` is frozen (its content is), so there is no stale
 * read for a token to catch — the number in the path is the whole claim.
 *
 * No gate, for the reason `quiz/rollout.py` states about
 * `cycle-recipes/{cycle}/deactivate/`: an action that only REDUCES what
 * students are served has to stay available exactly when the rollout gates
 * are being switched off.
 * @summary Wycofanie bieżącej publikacji
 */
export const v1CurriculumAdminPlanVersionWithdraw = async (number: number, options?: RequestInit): Promise<v1CurriculumAdminPlanVersionWithdrawResponse> => {

  return customFetch<v1CurriculumAdminPlanVersionWithdrawResponse>(getV1CurriculumAdminPlanVersionWithdrawUrl(number),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1CurriculumAdminPlanVersionWithdrawMutationOptions = <TError = UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionWithdraw>>, TError,{number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionWithdraw>>, TError,{number: number}, TContext> => {

const mutationKey = ['v1CurriculumAdminPlanVersionWithdraw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionWithdraw>>, {number: number}> = (props) => {
          const {number} = props ?? {};

          return  v1CurriculumAdminPlanVersionWithdraw(number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1CurriculumAdminPlanVersionWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionWithdraw>>>

    export type V1CurriculumAdminPlanVersionWithdrawMutationError = UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse

    /**
 * @summary Wycofanie bieżącej publikacji
 */
export const useV1CurriculumAdminPlanVersionWithdraw = <TError = UnauthorizedResponse | void | AdminCurriculumConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionWithdraw>>, TError,{number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CurriculumAdminPlanVersionWithdraw>>,
        TError,
        {number: number},
        TContext
      > => {
      return useMutation(getV1CurriculumAdminPlanVersionWithdrawMutationOptions(options), queryClient);
    }

export type deviceDeregisterWithoutSessionResponse204 = {
  data: void
  status: 204
}

export type deviceDeregisterWithoutSessionResponse400 = {
  data: void
  status: 400
}

export type deviceDeregisterWithoutSessionResponse429 = {
  data: void
  status: 429
}

export type deviceDeregisterWithoutSessionResponseSuccess = (deviceDeregisterWithoutSessionResponse204) & {
  headers: Headers;
};
export type deviceDeregisterWithoutSessionResponseError = (deviceDeregisterWithoutSessionResponse400 | deviceDeregisterWithoutSessionResponse429) & {
  headers: Headers;
};

export type deviceDeregisterWithoutSessionResponse = (deviceDeregisterWithoutSessionResponseSuccess | deviceDeregisterWithoutSessionResponseError)

export const getDeviceDeregisterWithoutSessionUrl = (installationId: string,) => {




  return `/api/v1/devices/${installationId}/deregister/`
}

/**
 * Deregistration for an installation that has lost its session (spec 202).
 *
 * No authentication at all, so an expired or revoked Bearer cannot turn this into a
 * 401. Ownership is proven by the FCM token only the phone holds; every well-formed
 * request answers 204, whether or not anything was removed.
 * @summary Wyrejestrowanie urządzenia bez sesji
 */
export const deviceDeregisterWithoutSession = async (installationId: string,
    deviceDeregisterRequest: DeviceDeregisterRequest, options?: RequestInit): Promise<deviceDeregisterWithoutSessionResponse> => {

  return customFetch<deviceDeregisterWithoutSessionResponse>(getDeviceDeregisterWithoutSessionUrl(installationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deviceDeregisterRequest)
  }
);}




export const getDeviceDeregisterWithoutSessionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deviceDeregisterWithoutSession>>, TError,{installationId: string;data: DeviceDeregisterRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deviceDeregisterWithoutSession>>, TError,{installationId: string;data: DeviceDeregisterRequest}, TContext> => {

const mutationKey = ['deviceDeregisterWithoutSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deviceDeregisterWithoutSession>>, {installationId: string;data: DeviceDeregisterRequest}> = (props) => {
          const {installationId,data} = props ?? {};

          return  deviceDeregisterWithoutSession(installationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeviceDeregisterWithoutSessionMutationResult = NonNullable<Awaited<ReturnType<typeof deviceDeregisterWithoutSession>>>
    export type DeviceDeregisterWithoutSessionMutationBody = DeviceDeregisterRequest
    export type DeviceDeregisterWithoutSessionMutationError = void

    /**
 * @summary Wyrejestrowanie urządzenia bez sesji
 */
export const useDeviceDeregisterWithoutSession = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deviceDeregisterWithoutSession>>, TError,{installationId: string;data: DeviceDeregisterRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deviceDeregisterWithoutSession>>,
        TError,
        {installationId: string;data: DeviceDeregisterRequest},
        TContext
      > => {
      return useMutation(getDeviceDeregisterWithoutSessionMutationOptions(options), queryClient);
    }

export type emailChangeConfirmResponse200 = {
  data: void
  status: 200
}

export type emailChangeConfirmResponse404 = {
  data: void
  status: 404
}

export type emailChangeConfirmResponse409 = {
  data: void
  status: 409
}

export type emailChangeConfirmResponseSuccess = (emailChangeConfirmResponse200) & {
  headers: Headers;
};
export type emailChangeConfirmResponseError = (emailChangeConfirmResponse404 | emailChangeConfirmResponse409) & {
  headers: Headers;
};

export type emailChangeConfirmResponse = (emailChangeConfirmResponseSuccess | emailChangeConfirmResponseError)

export const getEmailChangeConfirmUrl = (token: string,) => {




  return `/api/v1/email-change/confirm/${token}/`
}

/**
 * Finalizacja po kliknięciu linku (TR-303 R5/R6, R10–R16).
 *
 * AllowAny — token jest jedynym poświadczeniem (link bywa otwierany na
 * urządzeniu bez sesji). POST, nigdy GET: prefetchery mailowe nie wykonują
 * POST, więc nie skonsumują jednorazowego tokena (research R5). Każdy
 * nieprawidłowy token (nieznany/wygasły/zużyty/anulowany) daje to samo 404.
 */
export const emailChangeConfirm = async (token: string, options?: RequestInit): Promise<emailChangeConfirmResponse> => {

  return customFetch<emailChangeConfirmResponse>(getEmailChangeConfirmUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}




export const getEmailChangeConfirmMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailChangeConfirm>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof emailChangeConfirm>>, TError,{token: string}, TContext> => {

const mutationKey = ['emailChangeConfirm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailChangeConfirm>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  emailChangeConfirm(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmailChangeConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof emailChangeConfirm>>>

    export type EmailChangeConfirmMutationError = void

    export const useEmailChangeConfirm = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailChangeConfirm>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof emailChangeConfirm>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getEmailChangeConfirmMutationOptions(options), queryClient);
    }

export type v1GoalsListResponse200 = {
  data: PaginatedGoalPullList
  status: 200
}

export type v1GoalsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1GoalsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1GoalsListResponseSuccess = (v1GoalsListResponse200) & {
  headers: Headers;
};
export type v1GoalsListResponseError = (v1GoalsListResponse401 | v1GoalsListResponse410) & {
  headers: Headers;
};

export type v1GoalsListResponse = (v1GoalsListResponseSuccess | v1GoalsListResponseError)

export const getV1GoalsListUrl = (params?: V1GoalsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/goals/?${stringifiedParams}` : `/api/v1/goals/`
}

/**
 * Base GET view for pulling a syncable entity to a fresh device.
 *
 * Subclasses set `queryset`/`model` + `serializer_class`. Owner scoping and the
 * `updated_since` filter are applied here; tombstones are intentionally retained.
 */
export const v1GoalsList = async (params?: V1GoalsListParams, options?: RequestInit): Promise<v1GoalsListResponse> => {

  return customFetch<v1GoalsListResponse>(getV1GoalsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1GoalsListQueryKey = (params?: V1GoalsListParams,) => {
    return [
    `/api/v1/goals/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1GoalsListQueryOptions = <TData = Awaited<ReturnType<typeof v1GoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1GoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1GoalsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1GoalsList>>> = ({ signal }) => v1GoalsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1GoalsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1GoalsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1GoalsList>>>
export type V1GoalsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1GoalsList<TData = Awaited<ReturnType<typeof v1GoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1GoalsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsList>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsList<TData = Awaited<ReturnType<typeof v1GoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsList>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsList<TData = Awaited<ReturnType<typeof v1GoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1GoalsList<TData = Awaited<ReturnType<typeof v1GoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1GoalsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1GoalsAllocationsListResponse200 = {
  data: PaginatedGoalAllocationPullList
  status: 200
}

export type v1GoalsAllocationsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1GoalsAllocationsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1GoalsAllocationsListResponseSuccess = (v1GoalsAllocationsListResponse200) & {
  headers: Headers;
};
export type v1GoalsAllocationsListResponseError = (v1GoalsAllocationsListResponse401 | v1GoalsAllocationsListResponse410) & {
  headers: Headers;
};

export type v1GoalsAllocationsListResponse = (v1GoalsAllocationsListResponseSuccess | v1GoalsAllocationsListResponseError)

export const getV1GoalsAllocationsListUrl = (params?: V1GoalsAllocationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/goals/allocations/?${stringifiedParams}` : `/api/v1/goals/allocations/`
}

/**
 * Base GET view for pulling a syncable entity to a fresh device.
 *
 * Subclasses set `queryset`/`model` + `serializer_class`. Owner scoping and the
 * `updated_since` filter are applied here; tombstones are intentionally retained.
 */
export const v1GoalsAllocationsList = async (params?: V1GoalsAllocationsListParams, options?: RequestInit): Promise<v1GoalsAllocationsListResponse> => {

  return customFetch<v1GoalsAllocationsListResponse>(getV1GoalsAllocationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1GoalsAllocationsListQueryKey = (params?: V1GoalsAllocationsListParams,) => {
    return [
    `/api/v1/goals/allocations/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1GoalsAllocationsListQueryOptions = <TData = Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1GoalsAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1GoalsAllocationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1GoalsAllocationsList>>> = ({ signal }) => v1GoalsAllocationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1GoalsAllocationsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1GoalsAllocationsList>>>
export type V1GoalsAllocationsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1GoalsAllocationsList<TData = Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1GoalsAllocationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsAllocationsList>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsAllocationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsAllocationsList<TData = Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsAllocationsList>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsAllocationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsAllocationsList<TData = Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1GoalsAllocationsList<TData = Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsAllocationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1GoalsAllocationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1GoalsConfigRetrieveResponse200 = {
  data: GoalLimitConfig
  status: 200
}

export type v1GoalsConfigRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1GoalsConfigRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1GoalsConfigRetrieveResponseSuccess = (v1GoalsConfigRetrieveResponse200) & {
  headers: Headers;
};
export type v1GoalsConfigRetrieveResponseError = (v1GoalsConfigRetrieveResponse401 | v1GoalsConfigRetrieveResponse410) & {
  headers: Headers;
};

export type v1GoalsConfigRetrieveResponse = (v1GoalsConfigRetrieveResponseSuccess | v1GoalsConfigRetrieveResponseError)

export const getV1GoalsConfigRetrieveUrl = () => {




  return `/api/v1/goals/config/`
}

/**
 * `GET /api/v1/goals/config/` — the operator-published goal limits.
 *
 * Decision (daily 2026-07-27): the "max 5 active thing goals" product limit is
 * backend-configurable, not baked into client code. This route only publishes
 * the current value for the mobile app to cache (offline fallback stays 5 on
 * the client); creation is still never refused server-side (059 FR-025).
 * @summary Limity celów (konfigurowane po stronie backendu)
 */
export const v1GoalsConfigRetrieve = async ( options?: RequestInit): Promise<v1GoalsConfigRetrieveResponse> => {

  return customFetch<v1GoalsConfigRetrieveResponse>(getV1GoalsConfigRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1GoalsConfigRetrieveQueryKey = () => {
    return [
    `/api/v1/goals/config/`
    ] as const;
    }


export const getV1GoalsConfigRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1GoalsConfigRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>> = ({ signal }) => v1GoalsConfigRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1GoalsConfigRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>>
export type V1GoalsConfigRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1GoalsConfigRetrieve<TData = Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsConfigRetrieve<TData = Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsConfigRetrieve<TData = Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Limity celów (konfigurowane po stronie backendu)
 */

export function useV1GoalsConfigRetrieve<TData = Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1GoalsConfigRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1GoalsDepositsListResponse200 = {
  data: PaginatedGoalDepositPullList
  status: 200
}

export type v1GoalsDepositsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1GoalsDepositsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1GoalsDepositsListResponseSuccess = (v1GoalsDepositsListResponse200) & {
  headers: Headers;
};
export type v1GoalsDepositsListResponseError = (v1GoalsDepositsListResponse401 | v1GoalsDepositsListResponse410) & {
  headers: Headers;
};

export type v1GoalsDepositsListResponse = (v1GoalsDepositsListResponseSuccess | v1GoalsDepositsListResponseError)

export const getV1GoalsDepositsListUrl = (params?: V1GoalsDepositsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/goals/deposits/?${stringifiedParams}` : `/api/v1/goals/deposits/`
}

/**
 * Base GET view for pulling a syncable entity to a fresh device.
 *
 * Subclasses set `queryset`/`model` + `serializer_class`. Owner scoping and the
 * `updated_since` filter are applied here; tombstones are intentionally retained.
 */
export const v1GoalsDepositsList = async (params?: V1GoalsDepositsListParams, options?: RequestInit): Promise<v1GoalsDepositsListResponse> => {

  return customFetch<v1GoalsDepositsListResponse>(getV1GoalsDepositsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1GoalsDepositsListQueryKey = (params?: V1GoalsDepositsListParams,) => {
    return [
    `/api/v1/goals/deposits/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1GoalsDepositsListQueryOptions = <TData = Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1GoalsDepositsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1GoalsDepositsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1GoalsDepositsList>>> = ({ signal }) => v1GoalsDepositsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1GoalsDepositsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1GoalsDepositsList>>>
export type V1GoalsDepositsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1GoalsDepositsList<TData = Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1GoalsDepositsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsDepositsList>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsDepositsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsDepositsList<TData = Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsDepositsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsDepositsList>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsDepositsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsDepositsList<TData = Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsDepositsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1GoalsDepositsList<TData = Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsDepositsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsDepositsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1GoalsDepositsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1GoalsMapPlansListResponse200 = {
  data: PaginatedGoalMapPlanPullList
  status: 200
}

export type v1GoalsMapPlansListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1GoalsMapPlansListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1GoalsMapPlansListResponseSuccess = (v1GoalsMapPlansListResponse200) & {
  headers: Headers;
};
export type v1GoalsMapPlansListResponseError = (v1GoalsMapPlansListResponse401 | v1GoalsMapPlansListResponse410) & {
  headers: Headers;
};

export type v1GoalsMapPlansListResponse = (v1GoalsMapPlansListResponseSuccess | v1GoalsMapPlansListResponseError)

export const getV1GoalsMapPlansListUrl = (params?: V1GoalsMapPlansListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/goals/map-plans/?${stringifiedParams}` : `/api/v1/goals/map-plans/`
}

/**
 * Base GET view for pulling a syncable entity to a fresh device.
 *
 * Subclasses set `queryset`/`model` + `serializer_class`. Owner scoping and the
 * `updated_since` filter are applied here; tombstones are intentionally retained.
 */
export const v1GoalsMapPlansList = async (params?: V1GoalsMapPlansListParams, options?: RequestInit): Promise<v1GoalsMapPlansListResponse> => {

  return customFetch<v1GoalsMapPlansListResponse>(getV1GoalsMapPlansListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1GoalsMapPlansListQueryKey = (params?: V1GoalsMapPlansListParams,) => {
    return [
    `/api/v1/goals/map-plans/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1GoalsMapPlansListQueryOptions = <TData = Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1GoalsMapPlansListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1GoalsMapPlansListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1GoalsMapPlansList>>> = ({ signal }) => v1GoalsMapPlansList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1GoalsMapPlansListQueryResult = NonNullable<Awaited<ReturnType<typeof v1GoalsMapPlansList>>>
export type V1GoalsMapPlansListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1GoalsMapPlansList<TData = Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1GoalsMapPlansListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsMapPlansList>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsMapPlansList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsMapPlansList<TData = Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsMapPlansListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsMapPlansList>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsMapPlansList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsMapPlansList<TData = Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsMapPlansListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1GoalsMapPlansList<TData = Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsMapPlansListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMapPlansList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1GoalsMapPlansListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1GoalsMovementsRetrieveResponse200 = {
  data: GoalMovementRevisionPage
  status: 200
}

export type v1GoalsMovementsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1GoalsMovementsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1GoalsMovementsRetrieveResponse422 = {
  data: SyncError
  status: 422
}

export type v1GoalsMovementsRetrieveResponseSuccess = (v1GoalsMovementsRetrieveResponse200) & {
  headers: Headers;
};
export type v1GoalsMovementsRetrieveResponseError = (v1GoalsMovementsRetrieveResponse401 | v1GoalsMovementsRetrieveResponse410 | v1GoalsMovementsRetrieveResponse422) & {
  headers: Headers;
};

export type v1GoalsMovementsRetrieveResponse = (v1GoalsMovementsRetrieveResponseSuccess | v1GoalsMovementsRetrieveResponseError)

export const getV1GoalsMovementsRetrieveUrl = (params?: V1GoalsMovementsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/goals/movements/?${stringifiedParams}` : `/api/v1/goals/movements/`
}

/**
 * Owner-scoped append-only revisions; wall clocks never drive restore.
 */
export const v1GoalsMovementsRetrieve = async (params?: V1GoalsMovementsRetrieveParams, options?: RequestInit): Promise<v1GoalsMovementsRetrieveResponse> => {

  return customFetch<v1GoalsMovementsRetrieveResponse>(getV1GoalsMovementsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1GoalsMovementsRetrieveQueryKey = (params?: V1GoalsMovementsRetrieveParams,) => {
    return [
    `/api/v1/goals/movements/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1GoalsMovementsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse | SyncError>(params?: V1GoalsMovementsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1GoalsMovementsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>> = ({ signal }) => v1GoalsMovementsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1GoalsMovementsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>>
export type V1GoalsMovementsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse | SyncError


export function useV1GoalsMovementsRetrieve<TData = Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse | SyncError>(
 params: undefined |  V1GoalsMovementsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsMovementsRetrieve<TData = Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse | SyncError>(
 params?: V1GoalsMovementsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsMovementsRetrieve<TData = Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse | SyncError>(
 params?: V1GoalsMovementsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1GoalsMovementsRetrieve<TData = Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse | SyncError>(
 params?: V1GoalsMovementsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsMovementsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1GoalsMovementsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1GoalsSubGoalsListResponse200 = {
  data: PaginatedSubGoalPullList
  status: 200
}

export type v1GoalsSubGoalsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1GoalsSubGoalsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1GoalsSubGoalsListResponseSuccess = (v1GoalsSubGoalsListResponse200) & {
  headers: Headers;
};
export type v1GoalsSubGoalsListResponseError = (v1GoalsSubGoalsListResponse401 | v1GoalsSubGoalsListResponse410) & {
  headers: Headers;
};

export type v1GoalsSubGoalsListResponse = (v1GoalsSubGoalsListResponseSuccess | v1GoalsSubGoalsListResponseError)

export const getV1GoalsSubGoalsListUrl = (params?: V1GoalsSubGoalsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/goals/sub-goals/?${stringifiedParams}` : `/api/v1/goals/sub-goals/`
}

/**
 * Base GET view for pulling a syncable entity to a fresh device.
 *
 * Subclasses set `queryset`/`model` + `serializer_class`. Owner scoping and the
 * `updated_since` filter are applied here; tombstones are intentionally retained.
 */
export const v1GoalsSubGoalsList = async (params?: V1GoalsSubGoalsListParams, options?: RequestInit): Promise<v1GoalsSubGoalsListResponse> => {

  return customFetch<v1GoalsSubGoalsListResponse>(getV1GoalsSubGoalsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1GoalsSubGoalsListQueryKey = (params?: V1GoalsSubGoalsListParams,) => {
    return [
    `/api/v1/goals/sub-goals/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1GoalsSubGoalsListQueryOptions = <TData = Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1GoalsSubGoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1GoalsSubGoalsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1GoalsSubGoalsList>>> = ({ signal }) => v1GoalsSubGoalsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1GoalsSubGoalsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1GoalsSubGoalsList>>>
export type V1GoalsSubGoalsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1GoalsSubGoalsList<TData = Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1GoalsSubGoalsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsSubGoalsList>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsSubGoalsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsSubGoalsList<TData = Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsSubGoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1GoalsSubGoalsList>>,
          TError,
          Awaited<ReturnType<typeof v1GoalsSubGoalsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1GoalsSubGoalsList<TData = Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsSubGoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1GoalsSubGoalsList<TData = Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1GoalsSubGoalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1GoalsSubGoalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1GoalsSubGoalsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type invitationRetrieveResponse200 = {
  data: Invitation
  status: 200
}

export type invitationRetrieveResponse404 = {
  data: void
  status: 404
}

export type invitationRetrieveResponseSuccess = (invitationRetrieveResponse200) & {
  headers: Headers;
};
export type invitationRetrieveResponseError = (invitationRetrieveResponse404) & {
  headers: Headers;
};

export type invitationRetrieveResponse = (invitationRetrieveResponseSuccess | invitationRetrieveResponseError)

export const getInvitationRetrieveUrl = (token: string,) => {




  return `/api/v1/invitations/${token}/`
}

/**
 * Walidacja linku zaproszeniowego (TR-100 §3.1 krok 7).
 *
 * Każdy nieprawidłowy stan tokena (nieistniejący, zużyty, wygasły,
 * anulowany) daje to samo 404 — ochrona przed enumeracją.
 */
export const invitationRetrieve = async (token: string, options?: RequestInit): Promise<invitationRetrieveResponse> => {

  return customFetch<invitationRetrieveResponse>(getInvitationRetrieveUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInvitationRetrieveQueryKey = (token: string,) => {
    return [
    `/api/v1/invitations/${token}/`
    ] as const;
    }


export const getInvitationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof invitationRetrieve>>, TError = void>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvitationRetrieveQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationRetrieve>>> = ({ signal }) => invitationRetrieve(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invitationRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvitationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof invitationRetrieve>>>
export type InvitationRetrieveQueryError = void


export function useInvitationRetrieve<TData = Awaited<ReturnType<typeof invitationRetrieve>>, TError = void>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof invitationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationRetrieve<TData = Awaited<ReturnType<typeof invitationRetrieve>>, TError = void>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof invitationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationRetrieve<TData = Awaited<ReturnType<typeof invitationRetrieve>>, TError = void>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useInvitationRetrieve<TData = Awaited<ReturnType<typeof invitationRetrieve>>, TError = void>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvitationRetrieveQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type invitationActivateResponse201 = {
  data: Me
  status: 201
}

export type invitationActivateResponse400 = {
  data: void
  status: 400
}

export type invitationActivateResponse404 = {
  data: void
  status: 404
}

export type invitationActivateResponseSuccess = (invitationActivateResponse201) & {
  headers: Headers;
};
export type invitationActivateResponseError = (invitationActivateResponse400 | invitationActivateResponse404) & {
  headers: Headers;
};

export type invitationActivateResponse = (invitationActivateResponseSuccess | invitationActivateResponseError)

export const getInvitationActivateUrl = (token: string,) => {




  return `/api/v1/invitations/${token}/activate/`
}

/**
 * Aktywacja konta z zaproszenia: nick + hasło (TR-100 §3.1 kroki 8-9).
 */
export const invitationActivate = async (token: string,
    invitationActivateRequest: InvitationActivateRequest, options?: RequestInit): Promise<invitationActivateResponse> => {

  return customFetch<invitationActivateResponse>(getInvitationActivateUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(invitationActivateRequest)
  }
);}




export const getInvitationActivateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationActivate>>, TError,{token: string;data: InvitationActivateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof invitationActivate>>, TError,{token: string;data: InvitationActivateRequest}, TContext> => {

const mutationKey = ['invitationActivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invitationActivate>>, {token: string;data: InvitationActivateRequest}> = (props) => {
          const {token,data} = props ?? {};

          return  invitationActivate(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InvitationActivateMutationResult = NonNullable<Awaited<ReturnType<typeof invitationActivate>>>
    export type InvitationActivateMutationBody = InvitationActivateRequest
    export type InvitationActivateMutationError = void

    export const useInvitationActivate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationActivate>>, TError,{token: string;data: InvitationActivateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof invitationActivate>>,
        TError,
        {token: string;data: InvitationActivateRequest},
        TContext
      > => {
      return useMutation(getInvitationActivateMutationOptions(options), queryClient);
    }

export type knowledgeBaseRetrieveResponse200 = {
  data: KnowledgeBase
  status: 200
}

export type knowledgeBaseRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseRetrieveResponseSuccess = (knowledgeBaseRetrieveResponse200) & {
  headers: Headers;
};
export type knowledgeBaseRetrieveResponseError = (knowledgeBaseRetrieveResponse401 | knowledgeBaseRetrieveResponse410) & {
  headers: Headers;
};

export type knowledgeBaseRetrieveResponse = (knowledgeBaseRetrieveResponseSuccess | knowledgeBaseRetrieveResponseError)

export const getKnowledgeBaseRetrieveUrl = () => {




  return `/api/v1/knowledge-base/`
}

export const knowledgeBaseRetrieve = async ( options?: RequestInit): Promise<knowledgeBaseRetrieveResponse> => {

  return customFetch<knowledgeBaseRetrieveResponse>(getKnowledgeBaseRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getKnowledgeBaseRetrieveQueryKey = () => {
    return [
    `/api/v1/knowledge-base/`
    ] as const;
    }


export const getKnowledgeBaseRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeBaseRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeBaseRetrieve>>> = ({ signal }) => knowledgeBaseRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeBaseRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseRetrieve>>>
export type KnowledgeBaseRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useKnowledgeBaseRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeBaseRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeBaseRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type knowledgeBaseAdminHintsListResponse200 = {
  data: AdminKnowledgeHint[]
  status: 200
}

export type knowledgeBaseAdminHintsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminHintsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminHintsListResponseSuccess = (knowledgeBaseAdminHintsListResponse200) & {
  headers: Headers;
};
export type knowledgeBaseAdminHintsListResponseError = (knowledgeBaseAdminHintsListResponse401 | knowledgeBaseAdminHintsListResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminHintsListResponse = (knowledgeBaseAdminHintsListResponseSuccess | knowledgeBaseAdminHintsListResponseError)

export const getKnowledgeBaseAdminHintsListUrl = (params?: KnowledgeBaseAdminHintsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/knowledge-base/admin/hints/?${stringifiedParams}` : `/api/v1/knowledge-base/admin/hints/`
}

export const knowledgeBaseAdminHintsList = async (params?: KnowledgeBaseAdminHintsListParams, options?: RequestInit): Promise<knowledgeBaseAdminHintsListResponse> => {

  return customFetch<knowledgeBaseAdminHintsListResponse>(getKnowledgeBaseAdminHintsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getKnowledgeBaseAdminHintsListQueryKey = (params?: KnowledgeBaseAdminHintsListParams,) => {
    return [
    `/api/v1/knowledge-base/admin/hints/`, ...(params ? [params] : [])
    ] as const;
    }


export const getKnowledgeBaseAdminHintsListQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: KnowledgeBaseAdminHintsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeBaseAdminHintsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>> = ({ signal }) => knowledgeBaseAdminHintsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeBaseAdminHintsListQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>>
export type KnowledgeBaseAdminHintsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useKnowledgeBaseAdminHintsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  KnowledgeBaseAdminHintsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseAdminHintsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: KnowledgeBaseAdminHintsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseAdminHintsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: KnowledgeBaseAdminHintsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeBaseAdminHintsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: KnowledgeBaseAdminHintsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeBaseAdminHintsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type knowledgeBaseAdminHintsCreateResponse201 = {
  data: AdminKnowledgeHint
  status: 201
}

export type knowledgeBaseAdminHintsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminHintsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminHintsCreateResponseSuccess = (knowledgeBaseAdminHintsCreateResponse201) & {
  headers: Headers;
};
export type knowledgeBaseAdminHintsCreateResponseError = (knowledgeBaseAdminHintsCreateResponse401 | knowledgeBaseAdminHintsCreateResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminHintsCreateResponse = (knowledgeBaseAdminHintsCreateResponseSuccess | knowledgeBaseAdminHintsCreateResponseError)

export const getKnowledgeBaseAdminHintsCreateUrl = () => {




  return `/api/v1/knowledge-base/admin/hints/`
}

export const knowledgeBaseAdminHintsCreate = async (adminKnowledgeHintRequest: AdminKnowledgeHintRequest, options?: RequestInit): Promise<knowledgeBaseAdminHintsCreateResponse> => {
    const formData = knowledgeHintFormData(adminKnowledgeHintRequest)
  return customFetch<knowledgeBaseAdminHintsCreateResponse>(getKnowledgeBaseAdminHintsCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getKnowledgeBaseAdminHintsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsCreate>>, TError,{data: AdminKnowledgeHintRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsCreate>>, TError,{data: AdminKnowledgeHintRequest}, TContext> => {

const mutationKey = ['knowledgeBaseAdminHintsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeBaseAdminHintsCreate>>, {data: AdminKnowledgeHintRequest}> = (props) => {
          const {data} = props ?? {};

          return  knowledgeBaseAdminHintsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeBaseAdminHintsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminHintsCreate>>>
    export type KnowledgeBaseAdminHintsCreateMutationBody = AdminKnowledgeHintRequest
    export type KnowledgeBaseAdminHintsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useKnowledgeBaseAdminHintsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsCreate>>, TError,{data: AdminKnowledgeHintRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeBaseAdminHintsCreate>>,
        TError,
        {data: AdminKnowledgeHintRequest},
        TContext
      > => {
      return useMutation(getKnowledgeBaseAdminHintsCreateMutationOptions(options), queryClient);
    }

export type knowledgeBaseAdminHintsRetrieveResponse200 = {
  data: AdminKnowledgeHint
  status: 200
}

export type knowledgeBaseAdminHintsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminHintsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminHintsRetrieveResponseSuccess = (knowledgeBaseAdminHintsRetrieveResponse200) & {
  headers: Headers;
};
export type knowledgeBaseAdminHintsRetrieveResponseError = (knowledgeBaseAdminHintsRetrieveResponse401 | knowledgeBaseAdminHintsRetrieveResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminHintsRetrieveResponse = (knowledgeBaseAdminHintsRetrieveResponseSuccess | knowledgeBaseAdminHintsRetrieveResponseError)

export const getKnowledgeBaseAdminHintsRetrieveUrl = (id: number,) => {




  return `/api/v1/knowledge-base/admin/hints/${id}/`
}

export const knowledgeBaseAdminHintsRetrieve = async (id: number, options?: RequestInit): Promise<knowledgeBaseAdminHintsRetrieveResponse> => {

  return customFetch<knowledgeBaseAdminHintsRetrieveResponse>(getKnowledgeBaseAdminHintsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getKnowledgeBaseAdminHintsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/v1/knowledge-base/admin/hints/${id}/`
    ] as const;
    }


export const getKnowledgeBaseAdminHintsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeBaseAdminHintsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>> = ({ signal }) => knowledgeBaseAdminHintsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeBaseAdminHintsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>>
export type KnowledgeBaseAdminHintsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useKnowledgeBaseAdminHintsRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseAdminHintsRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseAdminHintsRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeBaseAdminHintsRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeBaseAdminHintsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type knowledgeBaseAdminHintsUpdateResponse200 = {
  data: AdminKnowledgeHint
  status: 200
}

export type knowledgeBaseAdminHintsUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminHintsUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminHintsUpdateResponseSuccess = (knowledgeBaseAdminHintsUpdateResponse200) & {
  headers: Headers;
};
export type knowledgeBaseAdminHintsUpdateResponseError = (knowledgeBaseAdminHintsUpdateResponse401 | knowledgeBaseAdminHintsUpdateResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminHintsUpdateResponse = (knowledgeBaseAdminHintsUpdateResponseSuccess | knowledgeBaseAdminHintsUpdateResponseError)

export const getKnowledgeBaseAdminHintsUpdateUrl = (id: number,) => {




  return `/api/v1/knowledge-base/admin/hints/${id}/`
}

export const knowledgeBaseAdminHintsUpdate = async (id: number,
    adminKnowledgeHintRequest: AdminKnowledgeHintRequest, options?: RequestInit): Promise<knowledgeBaseAdminHintsUpdateResponse> => {
    const formData = knowledgeHintFormData(adminKnowledgeHintRequest)
  return customFetch<knowledgeBaseAdminHintsUpdateResponse>(getKnowledgeBaseAdminHintsUpdateUrl(id),
  {
    ...options,
    method: 'PUT'
    ,
    body: formData
  }
);}




export const getKnowledgeBaseAdminHintsUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsUpdate>>, TError,{id: number;data: AdminKnowledgeHintRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsUpdate>>, TError,{id: number;data: AdminKnowledgeHintRequest}, TContext> => {

const mutationKey = ['knowledgeBaseAdminHintsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeBaseAdminHintsUpdate>>, {id: number;data: AdminKnowledgeHintRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  knowledgeBaseAdminHintsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeBaseAdminHintsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminHintsUpdate>>>
    export type KnowledgeBaseAdminHintsUpdateMutationBody = AdminKnowledgeHintRequest
    export type KnowledgeBaseAdminHintsUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useKnowledgeBaseAdminHintsUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsUpdate>>, TError,{id: number;data: AdminKnowledgeHintRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeBaseAdminHintsUpdate>>,
        TError,
        {id: number;data: AdminKnowledgeHintRequest},
        TContext
      > => {
      return useMutation(getKnowledgeBaseAdminHintsUpdateMutationOptions(options), queryClient);
    }

export type knowledgeBaseAdminHintsPartialUpdateResponse200 = {
  data: AdminKnowledgeHint
  status: 200
}

export type knowledgeBaseAdminHintsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminHintsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminHintsPartialUpdateResponseSuccess = (knowledgeBaseAdminHintsPartialUpdateResponse200) & {
  headers: Headers;
};
export type knowledgeBaseAdminHintsPartialUpdateResponseError = (knowledgeBaseAdminHintsPartialUpdateResponse401 | knowledgeBaseAdminHintsPartialUpdateResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminHintsPartialUpdateResponse = (knowledgeBaseAdminHintsPartialUpdateResponseSuccess | knowledgeBaseAdminHintsPartialUpdateResponseError)

export const getKnowledgeBaseAdminHintsPartialUpdateUrl = (id: number,) => {




  return `/api/v1/knowledge-base/admin/hints/${id}/`
}

export const knowledgeBaseAdminHintsPartialUpdate = async (id: number,
    patchedAdminKnowledgeHintRequest?: PatchedAdminKnowledgeHintRequest, options?: RequestInit): Promise<knowledgeBaseAdminHintsPartialUpdateResponse> => {
    const formData = knowledgeHintFormData(patchedAdminKnowledgeHintRequest)
  return customFetch<knowledgeBaseAdminHintsPartialUpdateResponse>(getKnowledgeBaseAdminHintsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH'
    ,
    body: formData
  }
);}




export const getKnowledgeBaseAdminHintsPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsPartialUpdate>>, TError,{id: number;data?: PatchedAdminKnowledgeHintRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsPartialUpdate>>, TError,{id: number;data?: PatchedAdminKnowledgeHintRequest}, TContext> => {

const mutationKey = ['knowledgeBaseAdminHintsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeBaseAdminHintsPartialUpdate>>, {id: number;data?: PatchedAdminKnowledgeHintRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  knowledgeBaseAdminHintsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeBaseAdminHintsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminHintsPartialUpdate>>>
    export type KnowledgeBaseAdminHintsPartialUpdateMutationBody = PatchedAdminKnowledgeHintRequest | undefined
    export type KnowledgeBaseAdminHintsPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useKnowledgeBaseAdminHintsPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsPartialUpdate>>, TError,{id: number;data?: PatchedAdminKnowledgeHintRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeBaseAdminHintsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminKnowledgeHintRequest},
        TContext
      > => {
      return useMutation(getKnowledgeBaseAdminHintsPartialUpdateMutationOptions(options), queryClient);
    }

export type knowledgeBaseAdminHintsDestroyResponse204 = {
  data: void
  status: 204
}

export type knowledgeBaseAdminHintsDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminHintsDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminHintsDestroyResponseSuccess = (knowledgeBaseAdminHintsDestroyResponse204) & {
  headers: Headers;
};
export type knowledgeBaseAdminHintsDestroyResponseError = (knowledgeBaseAdminHintsDestroyResponse401 | knowledgeBaseAdminHintsDestroyResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminHintsDestroyResponse = (knowledgeBaseAdminHintsDestroyResponseSuccess | knowledgeBaseAdminHintsDestroyResponseError)

export const getKnowledgeBaseAdminHintsDestroyUrl = (id: number,) => {




  return `/api/v1/knowledge-base/admin/hints/${id}/`
}

export const knowledgeBaseAdminHintsDestroy = async (id: number, options?: RequestInit): Promise<knowledgeBaseAdminHintsDestroyResponse> => {

  return customFetch<knowledgeBaseAdminHintsDestroyResponse>(getKnowledgeBaseAdminHintsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getKnowledgeBaseAdminHintsDestroyMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['knowledgeBaseAdminHintsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeBaseAdminHintsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  knowledgeBaseAdminHintsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeBaseAdminHintsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminHintsDestroy>>>

    export type KnowledgeBaseAdminHintsDestroyMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useKnowledgeBaseAdminHintsDestroy = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminHintsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeBaseAdminHintsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getKnowledgeBaseAdminHintsDestroyMutationOptions(options), queryClient);
    }

export type knowledgeBaseAdminPlacementsListResponse200 = {
  data: KnowledgePlacement[]
  status: 200
}

export type knowledgeBaseAdminPlacementsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminPlacementsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminPlacementsListResponseSuccess = (knowledgeBaseAdminPlacementsListResponse200) & {
  headers: Headers;
};
export type knowledgeBaseAdminPlacementsListResponseError = (knowledgeBaseAdminPlacementsListResponse401 | knowledgeBaseAdminPlacementsListResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminPlacementsListResponse = (knowledgeBaseAdminPlacementsListResponseSuccess | knowledgeBaseAdminPlacementsListResponseError)

export const getKnowledgeBaseAdminPlacementsListUrl = () => {




  return `/api/v1/knowledge-base/admin/placements/`
}

export const knowledgeBaseAdminPlacementsList = async ( options?: RequestInit): Promise<knowledgeBaseAdminPlacementsListResponse> => {

  return customFetch<knowledgeBaseAdminPlacementsListResponse>(getKnowledgeBaseAdminPlacementsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getKnowledgeBaseAdminPlacementsListQueryKey = () => {
    return [
    `/api/v1/knowledge-base/admin/placements/`
    ] as const;
    }


export const getKnowledgeBaseAdminPlacementsListQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeBaseAdminPlacementsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>> = ({ signal }) => knowledgeBaseAdminPlacementsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeBaseAdminPlacementsListQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>>
export type KnowledgeBaseAdminPlacementsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useKnowledgeBaseAdminPlacementsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseAdminPlacementsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseAdminPlacementsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeBaseAdminPlacementsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminPlacementsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeBaseAdminPlacementsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type knowledgeBaseAdminTopicsListResponse200 = {
  data: AdminKnowledgeTopic[]
  status: 200
}

export type knowledgeBaseAdminTopicsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminTopicsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminTopicsListResponseSuccess = (knowledgeBaseAdminTopicsListResponse200) & {
  headers: Headers;
};
export type knowledgeBaseAdminTopicsListResponseError = (knowledgeBaseAdminTopicsListResponse401 | knowledgeBaseAdminTopicsListResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminTopicsListResponse = (knowledgeBaseAdminTopicsListResponseSuccess | knowledgeBaseAdminTopicsListResponseError)

export const getKnowledgeBaseAdminTopicsListUrl = (params?: KnowledgeBaseAdminTopicsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/knowledge-base/admin/topics/?${stringifiedParams}` : `/api/v1/knowledge-base/admin/topics/`
}

export const knowledgeBaseAdminTopicsList = async (params?: KnowledgeBaseAdminTopicsListParams, options?: RequestInit): Promise<knowledgeBaseAdminTopicsListResponse> => {

  return customFetch<knowledgeBaseAdminTopicsListResponse>(getKnowledgeBaseAdminTopicsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getKnowledgeBaseAdminTopicsListQueryKey = (params?: KnowledgeBaseAdminTopicsListParams,) => {
    return [
    `/api/v1/knowledge-base/admin/topics/`, ...(params ? [params] : [])
    ] as const;
    }


export const getKnowledgeBaseAdminTopicsListQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: KnowledgeBaseAdminTopicsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeBaseAdminTopicsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>> = ({ signal }) => knowledgeBaseAdminTopicsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeBaseAdminTopicsListQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>>
export type KnowledgeBaseAdminTopicsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useKnowledgeBaseAdminTopicsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  KnowledgeBaseAdminTopicsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseAdminTopicsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: KnowledgeBaseAdminTopicsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseAdminTopicsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: KnowledgeBaseAdminTopicsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeBaseAdminTopicsList<TData = Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: KnowledgeBaseAdminTopicsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeBaseAdminTopicsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type knowledgeBaseAdminTopicsCreateResponse201 = {
  data: AdminKnowledgeTopic
  status: 201
}

export type knowledgeBaseAdminTopicsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminTopicsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminTopicsCreateResponseSuccess = (knowledgeBaseAdminTopicsCreateResponse201) & {
  headers: Headers;
};
export type knowledgeBaseAdminTopicsCreateResponseError = (knowledgeBaseAdminTopicsCreateResponse401 | knowledgeBaseAdminTopicsCreateResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminTopicsCreateResponse = (knowledgeBaseAdminTopicsCreateResponseSuccess | knowledgeBaseAdminTopicsCreateResponseError)

export const getKnowledgeBaseAdminTopicsCreateUrl = () => {




  return `/api/v1/knowledge-base/admin/topics/`
}

export const knowledgeBaseAdminTopicsCreate = async (adminKnowledgeTopicRequest: AdminKnowledgeTopicRequest, options?: RequestInit): Promise<knowledgeBaseAdminTopicsCreateResponse> => {

  return customFetch<knowledgeBaseAdminTopicsCreateResponse>(getKnowledgeBaseAdminTopicsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminKnowledgeTopicRequest)
  }
);}




export const getKnowledgeBaseAdminTopicsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsCreate>>, TError,{data: AdminKnowledgeTopicRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsCreate>>, TError,{data: AdminKnowledgeTopicRequest}, TContext> => {

const mutationKey = ['knowledgeBaseAdminTopicsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsCreate>>, {data: AdminKnowledgeTopicRequest}> = (props) => {
          const {data} = props ?? {};

          return  knowledgeBaseAdminTopicsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeBaseAdminTopicsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsCreate>>>
    export type KnowledgeBaseAdminTopicsCreateMutationBody = AdminKnowledgeTopicRequest
    export type KnowledgeBaseAdminTopicsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useKnowledgeBaseAdminTopicsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsCreate>>, TError,{data: AdminKnowledgeTopicRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeBaseAdminTopicsCreate>>,
        TError,
        {data: AdminKnowledgeTopicRequest},
        TContext
      > => {
      return useMutation(getKnowledgeBaseAdminTopicsCreateMutationOptions(options), queryClient);
    }

export type knowledgeBaseAdminTopicsRetrieveResponse200 = {
  data: AdminKnowledgeTopic
  status: 200
}

export type knowledgeBaseAdminTopicsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminTopicsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminTopicsRetrieveResponseSuccess = (knowledgeBaseAdminTopicsRetrieveResponse200) & {
  headers: Headers;
};
export type knowledgeBaseAdminTopicsRetrieveResponseError = (knowledgeBaseAdminTopicsRetrieveResponse401 | knowledgeBaseAdminTopicsRetrieveResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminTopicsRetrieveResponse = (knowledgeBaseAdminTopicsRetrieveResponseSuccess | knowledgeBaseAdminTopicsRetrieveResponseError)

export const getKnowledgeBaseAdminTopicsRetrieveUrl = (id: number,) => {




  return `/api/v1/knowledge-base/admin/topics/${id}/`
}

export const knowledgeBaseAdminTopicsRetrieve = async (id: number, options?: RequestInit): Promise<knowledgeBaseAdminTopicsRetrieveResponse> => {

  return customFetch<knowledgeBaseAdminTopicsRetrieveResponse>(getKnowledgeBaseAdminTopicsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getKnowledgeBaseAdminTopicsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/v1/knowledge-base/admin/topics/${id}/`
    ] as const;
    }


export const getKnowledgeBaseAdminTopicsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeBaseAdminTopicsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>> = ({ signal }) => knowledgeBaseAdminTopicsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeBaseAdminTopicsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>>
export type KnowledgeBaseAdminTopicsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useKnowledgeBaseAdminTopicsRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseAdminTopicsRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeBaseAdminTopicsRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeBaseAdminTopicsRetrieve<TData = Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeBaseAdminTopicsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type knowledgeBaseAdminTopicsUpdateResponse200 = {
  data: AdminKnowledgeTopic
  status: 200
}

export type knowledgeBaseAdminTopicsUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminTopicsUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminTopicsUpdateResponseSuccess = (knowledgeBaseAdminTopicsUpdateResponse200) & {
  headers: Headers;
};
export type knowledgeBaseAdminTopicsUpdateResponseError = (knowledgeBaseAdminTopicsUpdateResponse401 | knowledgeBaseAdminTopicsUpdateResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminTopicsUpdateResponse = (knowledgeBaseAdminTopicsUpdateResponseSuccess | knowledgeBaseAdminTopicsUpdateResponseError)

export const getKnowledgeBaseAdminTopicsUpdateUrl = (id: number,) => {




  return `/api/v1/knowledge-base/admin/topics/${id}/`
}

export const knowledgeBaseAdminTopicsUpdate = async (id: number,
    adminKnowledgeTopicRequest: AdminKnowledgeTopicRequest, options?: RequestInit): Promise<knowledgeBaseAdminTopicsUpdateResponse> => {

  return customFetch<knowledgeBaseAdminTopicsUpdateResponse>(getKnowledgeBaseAdminTopicsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminKnowledgeTopicRequest)
  }
);}




export const getKnowledgeBaseAdminTopicsUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsUpdate>>, TError,{id: number;data: AdminKnowledgeTopicRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsUpdate>>, TError,{id: number;data: AdminKnowledgeTopicRequest}, TContext> => {

const mutationKey = ['knowledgeBaseAdminTopicsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsUpdate>>, {id: number;data: AdminKnowledgeTopicRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  knowledgeBaseAdminTopicsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeBaseAdminTopicsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsUpdate>>>
    export type KnowledgeBaseAdminTopicsUpdateMutationBody = AdminKnowledgeTopicRequest
    export type KnowledgeBaseAdminTopicsUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useKnowledgeBaseAdminTopicsUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsUpdate>>, TError,{id: number;data: AdminKnowledgeTopicRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeBaseAdminTopicsUpdate>>,
        TError,
        {id: number;data: AdminKnowledgeTopicRequest},
        TContext
      > => {
      return useMutation(getKnowledgeBaseAdminTopicsUpdateMutationOptions(options), queryClient);
    }

export type knowledgeBaseAdminTopicsPartialUpdateResponse200 = {
  data: AdminKnowledgeTopic
  status: 200
}

export type knowledgeBaseAdminTopicsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminTopicsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminTopicsPartialUpdateResponseSuccess = (knowledgeBaseAdminTopicsPartialUpdateResponse200) & {
  headers: Headers;
};
export type knowledgeBaseAdminTopicsPartialUpdateResponseError = (knowledgeBaseAdminTopicsPartialUpdateResponse401 | knowledgeBaseAdminTopicsPartialUpdateResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminTopicsPartialUpdateResponse = (knowledgeBaseAdminTopicsPartialUpdateResponseSuccess | knowledgeBaseAdminTopicsPartialUpdateResponseError)

export const getKnowledgeBaseAdminTopicsPartialUpdateUrl = (id: number,) => {




  return `/api/v1/knowledge-base/admin/topics/${id}/`
}

export const knowledgeBaseAdminTopicsPartialUpdate = async (id: number,
    patchedAdminKnowledgeTopicRequest?: PatchedAdminKnowledgeTopicRequest, options?: RequestInit): Promise<knowledgeBaseAdminTopicsPartialUpdateResponse> => {

  return customFetch<knowledgeBaseAdminTopicsPartialUpdateResponse>(getKnowledgeBaseAdminTopicsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminKnowledgeTopicRequest)
  }
);}




export const getKnowledgeBaseAdminTopicsPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsPartialUpdate>>, TError,{id: number;data?: PatchedAdminKnowledgeTopicRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsPartialUpdate>>, TError,{id: number;data?: PatchedAdminKnowledgeTopicRequest}, TContext> => {

const mutationKey = ['knowledgeBaseAdminTopicsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsPartialUpdate>>, {id: number;data?: PatchedAdminKnowledgeTopicRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  knowledgeBaseAdminTopicsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeBaseAdminTopicsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsPartialUpdate>>>
    export type KnowledgeBaseAdminTopicsPartialUpdateMutationBody = PatchedAdminKnowledgeTopicRequest | undefined
    export type KnowledgeBaseAdminTopicsPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useKnowledgeBaseAdminTopicsPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsPartialUpdate>>, TError,{id: number;data?: PatchedAdminKnowledgeTopicRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeBaseAdminTopicsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminKnowledgeTopicRequest},
        TContext
      > => {
      return useMutation(getKnowledgeBaseAdminTopicsPartialUpdateMutationOptions(options), queryClient);
    }

export type knowledgeBaseAdminTopicsDestroyResponse204 = {
  data: void
  status: 204
}

export type knowledgeBaseAdminTopicsDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeBaseAdminTopicsDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeBaseAdminTopicsDestroyResponseSuccess = (knowledgeBaseAdminTopicsDestroyResponse204) & {
  headers: Headers;
};
export type knowledgeBaseAdminTopicsDestroyResponseError = (knowledgeBaseAdminTopicsDestroyResponse401 | knowledgeBaseAdminTopicsDestroyResponse410) & {
  headers: Headers;
};

export type knowledgeBaseAdminTopicsDestroyResponse = (knowledgeBaseAdminTopicsDestroyResponseSuccess | knowledgeBaseAdminTopicsDestroyResponseError)

export const getKnowledgeBaseAdminTopicsDestroyUrl = (id: number,) => {




  return `/api/v1/knowledge-base/admin/topics/${id}/`
}

export const knowledgeBaseAdminTopicsDestroy = async (id: number, options?: RequestInit): Promise<knowledgeBaseAdminTopicsDestroyResponse> => {

  return customFetch<knowledgeBaseAdminTopicsDestroyResponse>(getKnowledgeBaseAdminTopicsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getKnowledgeBaseAdminTopicsDestroyMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['knowledgeBaseAdminTopicsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  knowledgeBaseAdminTopicsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeBaseAdminTopicsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsDestroy>>>

    export type KnowledgeBaseAdminTopicsDestroyMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useKnowledgeBaseAdminTopicsDestroy = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeBaseAdminTopicsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeBaseAdminTopicsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getKnowledgeBaseAdminTopicsDestroyMutationOptions(options), queryClient);
    }

export type lifeLineBootstrapRetrieveResponse200 = {
  data: LifeLineBootstrap
  status: 200
}

export type lifeLineBootstrapRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type lifeLineBootstrapRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type lifeLineBootstrapRetrieveResponseSuccess = (lifeLineBootstrapRetrieveResponse200) & {
  headers: Headers;
};
export type lifeLineBootstrapRetrieveResponseError = (lifeLineBootstrapRetrieveResponse401 | lifeLineBootstrapRetrieveResponse410) & {
  headers: Headers;
};

export type lifeLineBootstrapRetrieveResponse = (lifeLineBootstrapRetrieveResponseSuccess | lifeLineBootstrapRetrieveResponseError)

export const getLifeLineBootstrapRetrieveUrl = () => {




  return `/api/v1/life-line/bootstrap/`
}

export const lifeLineBootstrapRetrieve = async ( options?: RequestInit): Promise<lifeLineBootstrapRetrieveResponse> => {

  return customFetch<lifeLineBootstrapRetrieveResponse>(getLifeLineBootstrapRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLifeLineBootstrapRetrieveQueryKey = () => {
    return [
    `/api/v1/life-line/bootstrap/`
    ] as const;
    }


export const getLifeLineBootstrapRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLifeLineBootstrapRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>> = ({ signal }) => lifeLineBootstrapRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LifeLineBootstrapRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>>
export type LifeLineBootstrapRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useLifeLineBootstrapRetrieve<TData = Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>,
          TError,
          Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLifeLineBootstrapRetrieve<TData = Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>,
          TError,
          Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLifeLineBootstrapRetrieve<TData = Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLifeLineBootstrapRetrieve<TData = Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifeLineBootstrapRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLifeLineBootstrapRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type lifeLineReferencePackCurrentRetrieveResponse200 = {
  data: ReferencePack
  status: 200
}

export type lifeLineReferencePackCurrentRetrieveResponse304 = {
  data: void
  status: 304
}

export type lifeLineReferencePackCurrentRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type lifeLineReferencePackCurrentRetrieveResponse403 = {
  data: void
  status: 403
}

export type lifeLineReferencePackCurrentRetrieveResponse404 = {
  data: void
  status: 404
}

export type lifeLineReferencePackCurrentRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type lifeLineReferencePackCurrentRetrieveResponseSuccess = (lifeLineReferencePackCurrentRetrieveResponse200) & {
  headers: Headers;
};
export type lifeLineReferencePackCurrentRetrieveResponseError = (lifeLineReferencePackCurrentRetrieveResponse304 | lifeLineReferencePackCurrentRetrieveResponse401 | lifeLineReferencePackCurrentRetrieveResponse403 | lifeLineReferencePackCurrentRetrieveResponse404 | lifeLineReferencePackCurrentRetrieveResponse410) & {
  headers: Headers;
};

export type lifeLineReferencePackCurrentRetrieveResponse = (lifeLineReferencePackCurrentRetrieveResponseSuccess | lifeLineReferencePackCurrentRetrieveResponseError)

export const getLifeLineReferencePackCurrentRetrieveUrl = () => {




  return `/api/v1/life-line/reference-packs/current/`
}

export const lifeLineReferencePackCurrentRetrieve = async ( options?: RequestInit): Promise<lifeLineReferencePackCurrentRetrieveResponse> => {

  return customFetch<lifeLineReferencePackCurrentRetrieveResponse>(getLifeLineReferencePackCurrentRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLifeLineReferencePackCurrentRetrieveQueryKey = () => {
    return [
    `/api/v1/life-line/reference-packs/current/`
    ] as const;
    }


export const getLifeLineReferencePackCurrentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError = void | UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLifeLineReferencePackCurrentRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>> = ({ signal }) => lifeLineReferencePackCurrentRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LifeLineReferencePackCurrentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>>
export type LifeLineReferencePackCurrentRetrieveQueryError = void | UnauthorizedResponse | AccountGoneResponse


export function useLifeLineReferencePackCurrentRetrieve<TData = Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError = void | UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLifeLineReferencePackCurrentRetrieve<TData = Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError = void | UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLifeLineReferencePackCurrentRetrieve<TData = Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError = void | UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLifeLineReferencePackCurrentRetrieve<TData = Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError = void | UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifeLineReferencePackCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLifeLineReferencePackCurrentRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1LifeLineScenariosListResponse200 = {
  data: PaginatedLifeLineScenarioPullList
  status: 200
}

export type v1LifeLineScenariosListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1LifeLineScenariosListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1LifeLineScenariosListResponse503 = {
  data: SyncError
  status: 503
}

export type v1LifeLineScenariosListResponseSuccess = (v1LifeLineScenariosListResponse200) & {
  headers: Headers;
};
export type v1LifeLineScenariosListResponseError = (v1LifeLineScenariosListResponse401 | v1LifeLineScenariosListResponse410 | v1LifeLineScenariosListResponse503) & {
  headers: Headers;
};

export type v1LifeLineScenariosListResponse = (v1LifeLineScenariosListResponseSuccess | v1LifeLineScenariosListResponseError)

export const getV1LifeLineScenariosListUrl = (params?: V1LifeLineScenariosListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/life-line/scenarios/?${stringifiedParams}` : `/api/v1/life-line/scenarios/`
}

/**
 * Base GET view for pulling a syncable entity to a fresh device.
 *
 * Subclasses set `queryset`/`model` + `serializer_class`. Owner scoping and the
 * `updated_since` filter are applied here; tombstones are intentionally retained.
 */
export const v1LifeLineScenariosList = async (params?: V1LifeLineScenariosListParams, options?: RequestInit): Promise<v1LifeLineScenariosListResponse> => {

  return customFetch<v1LifeLineScenariosListResponse>(getV1LifeLineScenariosListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1LifeLineScenariosListQueryKey = (params?: V1LifeLineScenariosListParams,) => {
    return [
    `/api/v1/life-line/scenarios/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1LifeLineScenariosListQueryOptions = <TData = Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError = UnauthorizedResponse | AccountGoneResponse | SyncError>(params?: V1LifeLineScenariosListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1LifeLineScenariosListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1LifeLineScenariosList>>> = ({ signal }) => v1LifeLineScenariosList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1LifeLineScenariosListQueryResult = NonNullable<Awaited<ReturnType<typeof v1LifeLineScenariosList>>>
export type V1LifeLineScenariosListQueryError = UnauthorizedResponse | AccountGoneResponse | SyncError


export function useV1LifeLineScenariosList<TData = Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError = UnauthorizedResponse | AccountGoneResponse | SyncError>(
 params: undefined |  V1LifeLineScenariosListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1LifeLineScenariosList>>,
          TError,
          Awaited<ReturnType<typeof v1LifeLineScenariosList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1LifeLineScenariosList<TData = Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError = UnauthorizedResponse | AccountGoneResponse | SyncError>(
 params?: V1LifeLineScenariosListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1LifeLineScenariosList>>,
          TError,
          Awaited<ReturnType<typeof v1LifeLineScenariosList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1LifeLineScenariosList<TData = Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError = UnauthorizedResponse | AccountGoneResponse | SyncError>(
 params?: V1LifeLineScenariosListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1LifeLineScenariosList<TData = Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError = UnauthorizedResponse | AccountGoneResponse | SyncError>(
 params?: V1LifeLineScenariosListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1LifeLineScenariosList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1LifeLineScenariosListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1MeRetrieveResponse200 = {
  data: Me
  status: 200
}

export type v1MeRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MeRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MeRetrieveResponseSuccess = (v1MeRetrieveResponse200) & {
  headers: Headers;
};
export type v1MeRetrieveResponseError = (v1MeRetrieveResponse401 | v1MeRetrieveResponse410) & {
  headers: Headers;
};

export type v1MeRetrieveResponse = (v1MeRetrieveResponseSuccess | v1MeRetrieveResponseError)

export const getV1MeRetrieveUrl = () => {




  return `/api/v1/me/`
}

/**
 * Identity / auth fragment of the current user (WO-API-ME-001).
 *
 * GET response is polymorphic on `role`: a student gets `StudentMe`, staff
 * roles get `StaffMe`.
 *
 * PATCH/PUT updates the language preference (005-catalog-i18n) and, for staff
 * roles, the display nickname (TR-301, feature 029) — see `MeUpdateSerializer`.
 */
export const v1MeRetrieve = async ( options?: RequestInit): Promise<v1MeRetrieveResponse> => {

  return customFetch<v1MeRetrieveResponse>(getV1MeRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MeRetrieveQueryKey = () => {
    return [
    `/api/v1/me/`
    ] as const;
    }


export const getV1MeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MeRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MeRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MeRetrieve>>> = ({ signal }) => v1MeRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MeRetrieve>>>
export type V1MeRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1MeRetrieve<TData = Awaited<ReturnType<typeof v1MeRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MeRetrieve<TData = Awaited<ReturnType<typeof v1MeRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MeRetrieve<TData = Awaited<ReturnType<typeof v1MeRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1MeRetrieve<TData = Awaited<ReturnType<typeof v1MeRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1MeUpdateResponse200 = {
  data: Me
  status: 200
}

export type v1MeUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MeUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MeUpdateResponseSuccess = (v1MeUpdateResponse200) & {
  headers: Headers;
};
export type v1MeUpdateResponseError = (v1MeUpdateResponse401 | v1MeUpdateResponse410) & {
  headers: Headers;
};

export type v1MeUpdateResponse = (v1MeUpdateResponseSuccess | v1MeUpdateResponseError)

export const getV1MeUpdateUrl = () => {




  return `/api/v1/me/`
}

/**
 * Identity / auth fragment of the current user (WO-API-ME-001).
 *
 * GET response is polymorphic on `role`: a student gets `StudentMe`, staff
 * roles get `StaffMe`.
 *
 * PATCH/PUT updates the language preference (005-catalog-i18n) and, for staff
 * roles, the display nickname (TR-301, feature 029) — see `MeUpdateSerializer`.
 */
export const v1MeUpdate = async (meUpdateRequest?: MeUpdateRequest, options?: RequestInit): Promise<v1MeUpdateResponse> => {

  return customFetch<v1MeUpdateResponse>(getV1MeUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(meUpdateRequest)
  }
);}




export const getV1MeUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MeUpdate>>, TError,{data?: MeUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MeUpdate>>, TError,{data?: MeUpdateRequest}, TContext> => {

const mutationKey = ['v1MeUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MeUpdate>>, {data?: MeUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1MeUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MeUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MeUpdate>>>
    export type V1MeUpdateMutationBody = MeUpdateRequest | undefined
    export type V1MeUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1MeUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MeUpdate>>, TError,{data?: MeUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MeUpdate>>,
        TError,
        {data?: MeUpdateRequest},
        TContext
      > => {
      return useMutation(getV1MeUpdateMutationOptions(options), queryClient);
    }

export type v1MePartialUpdateResponse200 = {
  data: Me
  status: 200
}

export type v1MePartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MePartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MePartialUpdateResponseSuccess = (v1MePartialUpdateResponse200) & {
  headers: Headers;
};
export type v1MePartialUpdateResponseError = (v1MePartialUpdateResponse401 | v1MePartialUpdateResponse410) & {
  headers: Headers;
};

export type v1MePartialUpdateResponse = (v1MePartialUpdateResponseSuccess | v1MePartialUpdateResponseError)

export const getV1MePartialUpdateUrl = () => {




  return `/api/v1/me/`
}

/**
 * Identity / auth fragment of the current user (WO-API-ME-001).
 *
 * GET response is polymorphic on `role`: a student gets `StudentMe`, staff
 * roles get `StaffMe`.
 *
 * PATCH/PUT updates the language preference (005-catalog-i18n) and, for staff
 * roles, the display nickname (TR-301, feature 029) — see `MeUpdateSerializer`.
 */
export const v1MePartialUpdate = async (patchedMeUpdateRequest?: PatchedMeUpdateRequest, options?: RequestInit): Promise<v1MePartialUpdateResponse> => {

  return customFetch<v1MePartialUpdateResponse>(getV1MePartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedMeUpdateRequest)
  }
);}




export const getV1MePartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MePartialUpdate>>, TError,{data?: PatchedMeUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MePartialUpdate>>, TError,{data?: PatchedMeUpdateRequest}, TContext> => {

const mutationKey = ['v1MePartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MePartialUpdate>>, {data?: PatchedMeUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1MePartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MePartialUpdate>>>
    export type V1MePartialUpdateMutationBody = PatchedMeUpdateRequest | undefined
    export type V1MePartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1MePartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MePartialUpdate>>, TError,{data?: PatchedMeUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MePartialUpdate>>,
        TError,
        {data?: PatchedMeUpdateRequest},
        TContext
      > => {
      return useMutation(getV1MePartialUpdateMutationOptions(options), queryClient);
    }

export type meAvatarReadResponse200 = {
  data: AvatarConfig
  status: 200
}

export type meAvatarReadResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meAvatarReadResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meAvatarReadResponseSuccess = (meAvatarReadResponse200) & {
  headers: Headers;
};
export type meAvatarReadResponseError = (meAvatarReadResponse401 | meAvatarReadResponse410) & {
  headers: Headers;
};

export type meAvatarReadResponse = (meAvatarReadResponseSuccess | meAvatarReadResponseError)

export const getMeAvatarReadUrl = () => {




  return `/api/v1/me/avatar/`
}

/**
 * Read the account's avatar config (starter look on first access).
 */
export const meAvatarRead = async ( options?: RequestInit): Promise<meAvatarReadResponse> => {

  return customFetch<meAvatarReadResponse>(getMeAvatarReadUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeAvatarReadQueryKey = () => {
    return [
    `/api/v1/me/avatar/`
    ] as const;
    }


export const getMeAvatarReadQueryOptions = <TData = Awaited<ReturnType<typeof meAvatarRead>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meAvatarRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeAvatarReadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meAvatarRead>>> = ({ signal }) => meAvatarRead({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meAvatarRead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeAvatarReadQueryResult = NonNullable<Awaited<ReturnType<typeof meAvatarRead>>>
export type MeAvatarReadQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeAvatarRead<TData = Awaited<ReturnType<typeof meAvatarRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meAvatarRead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meAvatarRead>>,
          TError,
          Awaited<ReturnType<typeof meAvatarRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeAvatarRead<TData = Awaited<ReturnType<typeof meAvatarRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meAvatarRead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meAvatarRead>>,
          TError,
          Awaited<ReturnType<typeof meAvatarRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeAvatarRead<TData = Awaited<ReturnType<typeof meAvatarRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meAvatarRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMeAvatarRead<TData = Awaited<ReturnType<typeof meAvatarRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meAvatarRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeAvatarReadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meAvatarUpdateResponse200 = {
  data: AvatarConfig
  status: 200
}

export type meAvatarUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meAvatarUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meAvatarUpdateResponse422 = {
  data: SyncError
  status: 422
}

export type meAvatarUpdateResponseSuccess = (meAvatarUpdateResponse200) & {
  headers: Headers;
};
export type meAvatarUpdateResponseError = (meAvatarUpdateResponse401 | meAvatarUpdateResponse410 | meAvatarUpdateResponse422) & {
  headers: Headers;
};

export type meAvatarUpdateResponse = (meAvatarUpdateResponseSuccess | meAvatarUpdateResponseError)

export const getMeAvatarUpdateUrl = () => {




  return `/api/v1/me/avatar/`
}

/**
 * Replace the account's avatar config (last-write-wins).
 */
export const meAvatarUpdate = async (avatarConfigWriteRequest: AvatarConfigWriteRequest, options?: RequestInit): Promise<meAvatarUpdateResponse> => {

  return customFetch<meAvatarUpdateResponse>(getMeAvatarUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(avatarConfigWriteRequest)
  }
);}




export const getMeAvatarUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse | SyncError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meAvatarUpdate>>, TError,{data: AvatarConfigWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meAvatarUpdate>>, TError,{data: AvatarConfigWriteRequest}, TContext> => {

const mutationKey = ['meAvatarUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meAvatarUpdate>>, {data: AvatarConfigWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  meAvatarUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeAvatarUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof meAvatarUpdate>>>
    export type MeAvatarUpdateMutationBody = AvatarConfigWriteRequest
    export type MeAvatarUpdateMutationError = UnauthorizedResponse | AccountGoneResponse | SyncError

    export const useMeAvatarUpdate = <TError = UnauthorizedResponse | AccountGoneResponse | SyncError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meAvatarUpdate>>, TError,{data: AvatarConfigWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meAvatarUpdate>>,
        TError,
        {data: AvatarConfigWriteRequest},
        TContext
      > => {
      return useMutation(getMeAvatarUpdateMutationOptions(options), queryClient);
    }

export type meBadgesListResponse200 = {
  data: MeBadges
  status: 200
}

export type meBadgesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meBadgesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meBadgesListResponseSuccess = (meBadgesListResponse200) & {
  headers: Headers;
};
export type meBadgesListResponseError = (meBadgesListResponse401 | meBadgesListResponse410) & {
  headers: Headers;
};

export type meBadgesListResponse = (meBadgesListResponseSuccess | meBadgesListResponseError)

export const getMeBadgesListUrl = () => {




  return `/api/v1/me/badges/`
}

/**
 * `GET /api/v1/me/badges/` — the full catalog ⋈ the caller's earned state.
 *
 * Student-only (clarification Q2: staff-facing per-student badge reads are a
 * future feature). Unearned badges are included with `earned=false` so the
 * client renders locked states (FR-006); the whole read is two bounded
 * queries (catalog + the caller's awards). Only badges with an award rule are
 * served (spec 176): the rest cannot be earned yet and stay in the catalog.
 * @summary Katalog odznak z per-uczniowskim stanem zdobycia
 */
export const meBadgesList = async ( options?: RequestInit): Promise<meBadgesListResponse> => {

  return customFetch<meBadgesListResponse>(getMeBadgesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeBadgesListQueryKey = () => {
    return [
    `/api/v1/me/badges/`
    ] as const;
    }


export const getMeBadgesListQueryOptions = <TData = Awaited<ReturnType<typeof meBadgesList>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBadgesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeBadgesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meBadgesList>>> = ({ signal }) => meBadgesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meBadgesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeBadgesListQueryResult = NonNullable<Awaited<ReturnType<typeof meBadgesList>>>
export type MeBadgesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeBadgesList<TData = Awaited<ReturnType<typeof meBadgesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBadgesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meBadgesList>>,
          TError,
          Awaited<ReturnType<typeof meBadgesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeBadgesList<TData = Awaited<ReturnType<typeof meBadgesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBadgesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meBadgesList>>,
          TError,
          Awaited<ReturnType<typeof meBadgesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeBadgesList<TData = Awaited<ReturnType<typeof meBadgesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBadgesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Katalog odznak z per-uczniowskim stanem zdobycia
 */

export function useMeBadgesList<TData = Awaited<ReturnType<typeof meBadgesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBadgesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeBadgesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meBarometerResponse200 = {
  data: BarometerRead
  status: 200
}

export type meBarometerResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meBarometerResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meBarometerResponseSuccess = (meBarometerResponse200) & {
  headers: Headers;
};
export type meBarometerResponseError = (meBarometerResponse401 | meBarometerResponse410) & {
  headers: Headers;
};

export type meBarometerResponse = (meBarometerResponseSuccess | meBarometerResponseError)

export const getMeBarometerUrl = () => {




  return `/api/v1/me/barometer/`
}

/**
 * @summary Barometr ucznia — zamrożony snapshot dnia albo wyliczenie na żywo
 */
export const meBarometer = async ( options?: RequestInit): Promise<meBarometerResponse> => {

  return customFetch<meBarometerResponse>(getMeBarometerUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeBarometerQueryKey = () => {
    return [
    `/api/v1/me/barometer/`
    ] as const;
    }


export const getMeBarometerQueryOptions = <TData = Awaited<ReturnType<typeof meBarometer>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBarometer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeBarometerQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meBarometer>>> = ({ signal }) => meBarometer({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meBarometer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeBarometerQueryResult = NonNullable<Awaited<ReturnType<typeof meBarometer>>>
export type MeBarometerQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeBarometer<TData = Awaited<ReturnType<typeof meBarometer>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBarometer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meBarometer>>,
          TError,
          Awaited<ReturnType<typeof meBarometer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeBarometer<TData = Awaited<ReturnType<typeof meBarometer>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBarometer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meBarometer>>,
          TError,
          Awaited<ReturnType<typeof meBarometer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeBarometer<TData = Awaited<ReturnType<typeof meBarometer>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBarometer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Barometr ucznia — zamrożony snapshot dnia albo wyliczenie na żywo
 */

export function useMeBarometer<TData = Awaited<ReturnType<typeof meBarometer>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBarometer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeBarometerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meBarometerMonthsResponse200 = {
  data: BarometerMonths
  status: 200
}

export type meBarometerMonthsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meBarometerMonthsResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meBarometerMonthsResponseSuccess = (meBarometerMonthsResponse200) & {
  headers: Headers;
};
export type meBarometerMonthsResponseError = (meBarometerMonthsResponse401 | meBarometerMonthsResponse410) & {
  headers: Headers;
};

export type meBarometerMonthsResponse = (meBarometerMonthsResponseSuccess | meBarometerMonthsResponseError)

export const getMeBarometerMonthsUrl = () => {




  return `/api/v1/me/barometer/months/`
}

/**
 * @summary Historia barometru ucznia — zapisy końca zamkniętych miesięcy
 */
export const meBarometerMonths = async ( options?: RequestInit): Promise<meBarometerMonthsResponse> => {

  return customFetch<meBarometerMonthsResponse>(getMeBarometerMonthsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeBarometerMonthsQueryKey = () => {
    return [
    `/api/v1/me/barometer/months/`
    ] as const;
    }


export const getMeBarometerMonthsQueryOptions = <TData = Awaited<ReturnType<typeof meBarometerMonths>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBarometerMonths>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeBarometerMonthsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meBarometerMonths>>> = ({ signal }) => meBarometerMonths({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meBarometerMonths>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeBarometerMonthsQueryResult = NonNullable<Awaited<ReturnType<typeof meBarometerMonths>>>
export type MeBarometerMonthsQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeBarometerMonths<TData = Awaited<ReturnType<typeof meBarometerMonths>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBarometerMonths>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meBarometerMonths>>,
          TError,
          Awaited<ReturnType<typeof meBarometerMonths>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeBarometerMonths<TData = Awaited<ReturnType<typeof meBarometerMonths>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBarometerMonths>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meBarometerMonths>>,
          TError,
          Awaited<ReturnType<typeof meBarometerMonths>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeBarometerMonths<TData = Awaited<ReturnType<typeof meBarometerMonths>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBarometerMonths>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Historia barometru ucznia — zapisy końca zamkniętych miesięcy
 */

export function useMeBarometerMonths<TData = Awaited<ReturnType<typeof meBarometerMonths>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBarometerMonths>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeBarometerMonthsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meBudgetSettingsReadResponse200 = {
  data: BudgetSettings
  status: 200
}

export type meBudgetSettingsReadResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meBudgetSettingsReadResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meBudgetSettingsReadResponseSuccess = (meBudgetSettingsReadResponse200) & {
  headers: Headers;
};
export type meBudgetSettingsReadResponseError = (meBudgetSettingsReadResponse401 | meBudgetSettingsReadResponse410) & {
  headers: Headers;
};

export type meBudgetSettingsReadResponse = (meBudgetSettingsReadResponseSuccess | meBudgetSettingsReadResponseError)

export const getMeBudgetSettingsReadUrl = () => {




  return `/api/v1/me/budget-settings/`
}

/**
 * Read the account's budget settings (defaults on first access).
 */
export const meBudgetSettingsRead = async ( options?: RequestInit): Promise<meBudgetSettingsReadResponse> => {

  return customFetch<meBudgetSettingsReadResponse>(getMeBudgetSettingsReadUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeBudgetSettingsReadQueryKey = () => {
    return [
    `/api/v1/me/budget-settings/`
    ] as const;
    }


export const getMeBudgetSettingsReadQueryOptions = <TData = Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeBudgetSettingsReadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meBudgetSettingsRead>>> = ({ signal }) => meBudgetSettingsRead({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeBudgetSettingsReadQueryResult = NonNullable<Awaited<ReturnType<typeof meBudgetSettingsRead>>>
export type MeBudgetSettingsReadQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeBudgetSettingsRead<TData = Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meBudgetSettingsRead>>,
          TError,
          Awaited<ReturnType<typeof meBudgetSettingsRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeBudgetSettingsRead<TData = Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meBudgetSettingsRead>>,
          TError,
          Awaited<ReturnType<typeof meBudgetSettingsRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeBudgetSettingsRead<TData = Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMeBudgetSettingsRead<TData = Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meBudgetSettingsRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeBudgetSettingsReadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meBudgetSettingsUpdateResponse200 = {
  data: BudgetSettings
  status: 200
}

export type meBudgetSettingsUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meBudgetSettingsUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meBudgetSettingsUpdateResponseSuccess = (meBudgetSettingsUpdateResponse200) & {
  headers: Headers;
};
export type meBudgetSettingsUpdateResponseError = (meBudgetSettingsUpdateResponse401 | meBudgetSettingsUpdateResponse410) & {
  headers: Headers;
};

export type meBudgetSettingsUpdateResponse = (meBudgetSettingsUpdateResponseSuccess | meBudgetSettingsUpdateResponseError)

export const getMeBudgetSettingsUpdateUrl = () => {




  return `/api/v1/me/budget-settings/`
}

/**
 * Replace the account's budget settings (last-write-wins).
 */
export const meBudgetSettingsUpdate = async (budgetSettingsRequest: BudgetSettingsRequest, options?: RequestInit): Promise<meBudgetSettingsUpdateResponse> => {

  return customFetch<meBudgetSettingsUpdateResponse>(getMeBudgetSettingsUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(budgetSettingsRequest)
  }
);}




export const getMeBudgetSettingsUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meBudgetSettingsUpdate>>, TError,{data: BudgetSettingsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meBudgetSettingsUpdate>>, TError,{data: BudgetSettingsRequest}, TContext> => {

const mutationKey = ['meBudgetSettingsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meBudgetSettingsUpdate>>, {data: BudgetSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  meBudgetSettingsUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeBudgetSettingsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof meBudgetSettingsUpdate>>>
    export type MeBudgetSettingsUpdateMutationBody = BudgetSettingsRequest
    export type MeBudgetSettingsUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useMeBudgetSettingsUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meBudgetSettingsUpdate>>, TError,{data: BudgetSettingsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meBudgetSettingsUpdate>>,
        TError,
        {data: BudgetSettingsRequest},
        TContext
      > => {
      return useMutation(getMeBudgetSettingsUpdateMutationOptions(options), queryClient);
    }

export type meCategoriesReadResponse200 = {
  data: CategorySelection
  status: 200
}

export type meCategoriesReadResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meCategoriesReadResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meCategoriesReadResponseSuccess = (meCategoriesReadResponse200) & {
  headers: Headers;
};
export type meCategoriesReadResponseError = (meCategoriesReadResponse401 | meCategoriesReadResponse410) & {
  headers: Headers;
};

export type meCategoriesReadResponse = (meCategoriesReadResponseSuccess | meCategoriesReadResponseError)

export const getMeCategoriesReadUrl = () => {




  return `/api/v1/me/categories/`
}

/**
 * Read the account's onboarding category selection.
 */
export const meCategoriesRead = async ( options?: RequestInit): Promise<meCategoriesReadResponse> => {

  return customFetch<meCategoriesReadResponse>(getMeCategoriesReadUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeCategoriesReadQueryKey = () => {
    return [
    `/api/v1/me/categories/`
    ] as const;
    }


export const getMeCategoriesReadQueryOptions = <TData = Awaited<ReturnType<typeof meCategoriesRead>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meCategoriesRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeCategoriesReadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meCategoriesRead>>> = ({ signal }) => meCategoriesRead({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meCategoriesRead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeCategoriesReadQueryResult = NonNullable<Awaited<ReturnType<typeof meCategoriesRead>>>
export type MeCategoriesReadQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeCategoriesRead<TData = Awaited<ReturnType<typeof meCategoriesRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meCategoriesRead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meCategoriesRead>>,
          TError,
          Awaited<ReturnType<typeof meCategoriesRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeCategoriesRead<TData = Awaited<ReturnType<typeof meCategoriesRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meCategoriesRead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meCategoriesRead>>,
          TError,
          Awaited<ReturnType<typeof meCategoriesRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeCategoriesRead<TData = Awaited<ReturnType<typeof meCategoriesRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meCategoriesRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMeCategoriesRead<TData = Awaited<ReturnType<typeof meCategoriesRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meCategoriesRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeCategoriesReadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meCategoriesUpdateResponse200 = {
  data: CategorySelection
  status: 200
}

export type meCategoriesUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meCategoriesUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meCategoriesUpdateResponseSuccess = (meCategoriesUpdateResponse200) & {
  headers: Headers;
};
export type meCategoriesUpdateResponseError = (meCategoriesUpdateResponse401 | meCategoriesUpdateResponse410) & {
  headers: Headers;
};

export type meCategoriesUpdateResponse = (meCategoriesUpdateResponseSuccess | meCategoriesUpdateResponseError)

export const getMeCategoriesUpdateUrl = () => {




  return `/api/v1/me/categories/`
}

/**
 * Replace the account's onboarding category selection (last-write-wins).
 */
export const meCategoriesUpdate = async (categorySelectionRequest: CategorySelectionRequest, options?: RequestInit): Promise<meCategoriesUpdateResponse> => {

  return customFetch<meCategoriesUpdateResponse>(getMeCategoriesUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(categorySelectionRequest)
  }
);}




export const getMeCategoriesUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meCategoriesUpdate>>, TError,{data: CategorySelectionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meCategoriesUpdate>>, TError,{data: CategorySelectionRequest}, TContext> => {

const mutationKey = ['meCategoriesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meCategoriesUpdate>>, {data: CategorySelectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  meCategoriesUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeCategoriesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof meCategoriesUpdate>>>
    export type MeCategoriesUpdateMutationBody = CategorySelectionRequest
    export type MeCategoriesUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useMeCategoriesUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meCategoriesUpdate>>, TError,{data: CategorySelectionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meCategoriesUpdate>>,
        TError,
        {data: CategorySelectionRequest},
        TContext
      > => {
      return useMutation(getMeCategoriesUpdateMutationOptions(options), queryClient);
    }

export type meDeletionRequestRetrieveResponse200 = {
  data: AccountDeletionRequest
  status: 200
}

export type meDeletionRequestRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meDeletionRequestRetrieveResponse404 = {
  data: void
  status: 404
}

export type meDeletionRequestRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meDeletionRequestRetrieveResponseSuccess = (meDeletionRequestRetrieveResponse200) & {
  headers: Headers;
};
export type meDeletionRequestRetrieveResponseError = (meDeletionRequestRetrieveResponse401 | meDeletionRequestRetrieveResponse404 | meDeletionRequestRetrieveResponse410) & {
  headers: Headers;
};

export type meDeletionRequestRetrieveResponse = (meDeletionRequestRetrieveResponseSuccess | meDeletionRequestRetrieveResponseError)

export const getMeDeletionRequestRetrieveUrl = () => {




  return `/api/v1/me/deletion-request/`
}

/**
 * @summary Stan zgłoszenia usunięcia konta ucznia
 */
export const meDeletionRequestRetrieve = async ( options?: RequestInit): Promise<meDeletionRequestRetrieveResponse> => {

  return customFetch<meDeletionRequestRetrieveResponse>(getMeDeletionRequestRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeDeletionRequestRetrieveQueryKey = () => {
    return [
    `/api/v1/me/deletion-request/`
    ] as const;
    }


export const getMeDeletionRequestRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeDeletionRequestRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meDeletionRequestRetrieve>>> = ({ signal }) => meDeletionRequestRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeDeletionRequestRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof meDeletionRequestRetrieve>>>
export type MeDeletionRequestRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useMeDeletionRequestRetrieve<TData = Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meDeletionRequestRetrieve>>,
          TError,
          Awaited<ReturnType<typeof meDeletionRequestRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeDeletionRequestRetrieve<TData = Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meDeletionRequestRetrieve>>,
          TError,
          Awaited<ReturnType<typeof meDeletionRequestRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeDeletionRequestRetrieve<TData = Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stan zgłoszenia usunięcia konta ucznia
 */

export function useMeDeletionRequestRetrieve<TData = Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meDeletionRequestRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeDeletionRequestRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meDeletionRequestCreateResponse200 = {
  data: AccountDeletionRequest
  status: 200
}

export type meDeletionRequestCreateResponse201 = {
  data: AccountDeletionRequest
  status: 201
}

export type meDeletionRequestCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meDeletionRequestCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meDeletionRequestCreateResponse429 = {
  data: void
  status: 429
}

export type meDeletionRequestCreateResponseSuccess = (meDeletionRequestCreateResponse200 | meDeletionRequestCreateResponse201) & {
  headers: Headers;
};
export type meDeletionRequestCreateResponseError = (meDeletionRequestCreateResponse401 | meDeletionRequestCreateResponse410 | meDeletionRequestCreateResponse429) & {
  headers: Headers;
};

export type meDeletionRequestCreateResponse = (meDeletionRequestCreateResponseSuccess | meDeletionRequestCreateResponseError)

export const getMeDeletionRequestCreateUrl = () => {




  return `/api/v1/me/deletion-request/`
}

/**
 * @summary Złożenie zgłoszenia usunięcia konta ucznia
 */
export const meDeletionRequestCreate = async ( options?: RequestInit): Promise<meDeletionRequestCreateResponse> => {

  return customFetch<meDeletionRequestCreateResponse>(getMeDeletionRequestCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getMeDeletionRequestCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meDeletionRequestCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meDeletionRequestCreate>>, TError,void, TContext> => {

const mutationKey = ['meDeletionRequestCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meDeletionRequestCreate>>, void> = () => {


          return  meDeletionRequestCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeDeletionRequestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof meDeletionRequestCreate>>>

    export type MeDeletionRequestCreateMutationError = UnauthorizedResponse | AccountGoneResponse | void

    /**
 * @summary Złożenie zgłoszenia usunięcia konta ucznia
 */
export const useMeDeletionRequestCreate = <TError = UnauthorizedResponse | AccountGoneResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meDeletionRequestCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meDeletionRequestCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeDeletionRequestCreateMutationOptions(options), queryClient);
    }

export type meDeletionRequestCancelResponse200 = {
  data: AccountDeletionRequest
  status: 200
}

export type meDeletionRequestCancelResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meDeletionRequestCancelResponse404 = {
  data: void
  status: 404
}

export type meDeletionRequestCancelResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meDeletionRequestCancelResponseSuccess = (meDeletionRequestCancelResponse200) & {
  headers: Headers;
};
export type meDeletionRequestCancelResponseError = (meDeletionRequestCancelResponse401 | meDeletionRequestCancelResponse404 | meDeletionRequestCancelResponse410) & {
  headers: Headers;
};

export type meDeletionRequestCancelResponse = (meDeletionRequestCancelResponseSuccess | meDeletionRequestCancelResponseError)

export const getMeDeletionRequestCancelUrl = () => {




  return `/api/v1/me/deletion-request/`
}

/**
 * @summary Wycofanie oczekującego zgłoszenia usunięcia konta
 */
export const meDeletionRequestCancel = async ( options?: RequestInit): Promise<meDeletionRequestCancelResponse> => {

  return customFetch<meDeletionRequestCancelResponse>(getMeDeletionRequestCancelUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getMeDeletionRequestCancelMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meDeletionRequestCancel>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meDeletionRequestCancel>>, TError,void, TContext> => {

const mutationKey = ['meDeletionRequestCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meDeletionRequestCancel>>, void> = () => {


          return  meDeletionRequestCancel(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeDeletionRequestCancelMutationResult = NonNullable<Awaited<ReturnType<typeof meDeletionRequestCancel>>>

    export type MeDeletionRequestCancelMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Wycofanie oczekującego zgłoszenia usunięcia konta
 */
export const useMeDeletionRequestCancel = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meDeletionRequestCancel>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meDeletionRequestCancel>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeDeletionRequestCancelMutationOptions(options), queryClient);
    }

export type meDeviceRegisterResponse200 = {
  data: Device
  status: 200
}

export type meDeviceRegisterResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meDeviceRegisterResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meDeviceRegisterResponseSuccess = (meDeviceRegisterResponse200) & {
  headers: Headers;
};
export type meDeviceRegisterResponseError = (meDeviceRegisterResponse401 | meDeviceRegisterResponse410) & {
  headers: Headers;
};

export type meDeviceRegisterResponse = (meDeviceRegisterResponseSuccess | meDeviceRegisterResponseError)

export const getMeDeviceRegisterUrl = (installationId: string,) => {




  return `/api/v1/me/devices/${installationId}/`
}

/**
 * Register or refresh the FCM token for this installation (idempotent upsert).
 */
export const meDeviceRegister = async (installationId: string,
    deviceRequest: DeviceRequest, options?: RequestInit): Promise<meDeviceRegisterResponse> => {

  return customFetch<meDeviceRegisterResponse>(getMeDeviceRegisterUrl(installationId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deviceRequest)
  }
);}




export const getMeDeviceRegisterMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meDeviceRegister>>, TError,{installationId: string;data: DeviceRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meDeviceRegister>>, TError,{installationId: string;data: DeviceRequest}, TContext> => {

const mutationKey = ['meDeviceRegister'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meDeviceRegister>>, {installationId: string;data: DeviceRequest}> = (props) => {
          const {installationId,data} = props ?? {};

          return  meDeviceRegister(installationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeDeviceRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof meDeviceRegister>>>
    export type MeDeviceRegisterMutationBody = DeviceRequest
    export type MeDeviceRegisterMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useMeDeviceRegister = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meDeviceRegister>>, TError,{installationId: string;data: DeviceRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meDeviceRegister>>,
        TError,
        {installationId: string;data: DeviceRequest},
        TContext
      > => {
      return useMutation(getMeDeviceRegisterMutationOptions(options), queryClient);
    }

export type meDeviceDeregisterResponse204 = {
  data: void
  status: 204
}

export type meDeviceDeregisterResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meDeviceDeregisterResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meDeviceDeregisterResponseSuccess = (meDeviceDeregisterResponse204) & {
  headers: Headers;
};
export type meDeviceDeregisterResponseError = (meDeviceDeregisterResponse401 | meDeviceDeregisterResponse410) & {
  headers: Headers;
};

export type meDeviceDeregisterResponse = (meDeviceDeregisterResponseSuccess | meDeviceDeregisterResponseError)

export const getMeDeviceDeregisterUrl = (installationId: string,) => {




  return `/api/v1/me/devices/${installationId}/`
}

/**
 * Deregister this installation (logout / push opt-out). Idempotent: a
 * missing device is still a 204 — the post-condition (no such device) holds.
 */
export const meDeviceDeregister = async (installationId: string, options?: RequestInit): Promise<meDeviceDeregisterResponse> => {

  return customFetch<meDeviceDeregisterResponse>(getMeDeviceDeregisterUrl(installationId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getMeDeviceDeregisterMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meDeviceDeregister>>, TError,{installationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meDeviceDeregister>>, TError,{installationId: string}, TContext> => {

const mutationKey = ['meDeviceDeregister'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meDeviceDeregister>>, {installationId: string}> = (props) => {
          const {installationId} = props ?? {};

          return  meDeviceDeregister(installationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeDeviceDeregisterMutationResult = NonNullable<Awaited<ReturnType<typeof meDeviceDeregister>>>

    export type MeDeviceDeregisterMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useMeDeviceDeregister = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meDeviceDeregister>>, TError,{installationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meDeviceDeregister>>,
        TError,
        {installationId: string},
        TContext
      > => {
      return useMutation(getMeDeviceDeregisterMutationOptions(options), queryClient);
    }

export type meEmailChangePendingResponse200 = {
  data: EmailChangePending
  status: 200
}

export type meEmailChangePendingResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meEmailChangePendingResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meEmailChangePendingResponseSuccess = (meEmailChangePendingResponse200) & {
  headers: Headers;
};
export type meEmailChangePendingResponseError = (meEmailChangePendingResponse401 | meEmailChangePendingResponse410) & {
  headers: Headers;
};

export type meEmailChangePendingResponse = (meEmailChangePendingResponseSuccess | meEmailChangePendingResponseError)

export const getMeEmailChangePendingUrl = () => {




  return `/api/v1/me/email-change/`
}

/**
 * Oczekująca zmiana adresu: odczyt (GET) i inicjacja (POST) — TR-303 R3–R9.
 */
export const meEmailChangePending = async ( options?: RequestInit): Promise<meEmailChangePendingResponse> => {

  return customFetch<meEmailChangePendingResponse>(getMeEmailChangePendingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeEmailChangePendingQueryKey = () => {
    return [
    `/api/v1/me/email-change/`
    ] as const;
    }


export const getMeEmailChangePendingQueryOptions = <TData = Awaited<ReturnType<typeof meEmailChangePending>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meEmailChangePending>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeEmailChangePendingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meEmailChangePending>>> = ({ signal }) => meEmailChangePending({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meEmailChangePending>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeEmailChangePendingQueryResult = NonNullable<Awaited<ReturnType<typeof meEmailChangePending>>>
export type MeEmailChangePendingQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeEmailChangePending<TData = Awaited<ReturnType<typeof meEmailChangePending>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meEmailChangePending>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meEmailChangePending>>,
          TError,
          Awaited<ReturnType<typeof meEmailChangePending>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeEmailChangePending<TData = Awaited<ReturnType<typeof meEmailChangePending>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meEmailChangePending>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meEmailChangePending>>,
          TError,
          Awaited<ReturnType<typeof meEmailChangePending>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeEmailChangePending<TData = Awaited<ReturnType<typeof meEmailChangePending>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meEmailChangePending>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMeEmailChangePending<TData = Awaited<ReturnType<typeof meEmailChangePending>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meEmailChangePending>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeEmailChangePendingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meEmailChangeStartResponse200 = {
  data: EmailChangePending
  status: 200
}

export type meEmailChangeStartResponse400 = {
  data: void
  status: 400
}

export type meEmailChangeStartResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meEmailChangeStartResponse403 = {
  data: void
  status: 403
}

export type meEmailChangeStartResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meEmailChangeStartResponseSuccess = (meEmailChangeStartResponse200) & {
  headers: Headers;
};
export type meEmailChangeStartResponseError = (meEmailChangeStartResponse400 | meEmailChangeStartResponse401 | meEmailChangeStartResponse403 | meEmailChangeStartResponse410) & {
  headers: Headers;
};

export type meEmailChangeStartResponse = (meEmailChangeStartResponseSuccess | meEmailChangeStartResponseError)

export const getMeEmailChangeStartUrl = () => {




  return `/api/v1/me/email-change/`
}

/**
 * Oczekująca zmiana adresu: odczyt (GET) i inicjacja (POST) — TR-303 R3–R9.
 */
export const meEmailChangeStart = async (emailChangeStartRequest: EmailChangeStartRequest, options?: RequestInit): Promise<meEmailChangeStartResponse> => {

  return customFetch<meEmailChangeStartResponse>(getMeEmailChangeStartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailChangeStartRequest)
  }
);}




export const getMeEmailChangeStartMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meEmailChangeStart>>, TError,{data: EmailChangeStartRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meEmailChangeStart>>, TError,{data: EmailChangeStartRequest}, TContext> => {

const mutationKey = ['meEmailChangeStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meEmailChangeStart>>, {data: EmailChangeStartRequest}> = (props) => {
          const {data} = props ?? {};

          return  meEmailChangeStart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeEmailChangeStartMutationResult = NonNullable<Awaited<ReturnType<typeof meEmailChangeStart>>>
    export type MeEmailChangeStartMutationBody = EmailChangeStartRequest
    export type MeEmailChangeStartMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useMeEmailChangeStart = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meEmailChangeStart>>, TError,{data: EmailChangeStartRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meEmailChangeStart>>,
        TError,
        {data: EmailChangeStartRequest},
        TContext
      > => {
      return useMutation(getMeEmailChangeStartMutationOptions(options), queryClient);
    }

export type meEmailChangeReauthResponse200 = {
  data: void
  status: 200
}

export type meEmailChangeReauthResponse400 = {
  data: void
  status: 400
}

export type meEmailChangeReauthResponse401 = {
  data: void
  status: 401
}

export type meEmailChangeReauthResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meEmailChangeReauthResponseSuccess = (meEmailChangeReauthResponse200) & {
  headers: Headers;
};
export type meEmailChangeReauthResponseError = (meEmailChangeReauthResponse400 | meEmailChangeReauthResponse401 | meEmailChangeReauthResponse410) & {
  headers: Headers;
};

export type meEmailChangeReauthResponse = (meEmailChangeReauthResponseSuccess | meEmailChangeReauthResponseError)

export const getMeEmailChangeReauthUrl = () => {




  return `/api/v1/me/email-change/reauth/`
}

/**
 * Re-autoryzacja hasłem przed formularzem zmiany adresu (TR-303 R2).
 */
export const meEmailChangeReauth = async (emailChangeReauthRequest: EmailChangeReauthRequest, options?: RequestInit): Promise<meEmailChangeReauthResponse> => {

  return customFetch<meEmailChangeReauthResponse>(getMeEmailChangeReauthUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailChangeReauthRequest)
  }
);}




export const getMeEmailChangeReauthMutationOptions = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meEmailChangeReauth>>, TError,{data: EmailChangeReauthRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meEmailChangeReauth>>, TError,{data: EmailChangeReauthRequest}, TContext> => {

const mutationKey = ['meEmailChangeReauth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meEmailChangeReauth>>, {data: EmailChangeReauthRequest}> = (props) => {
          const {data} = props ?? {};

          return  meEmailChangeReauth(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeEmailChangeReauthMutationResult = NonNullable<Awaited<ReturnType<typeof meEmailChangeReauth>>>
    export type MeEmailChangeReauthMutationBody = EmailChangeReauthRequest
    export type MeEmailChangeReauthMutationError = void | AccountGoneResponse

    export const useMeEmailChangeReauth = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meEmailChangeReauth>>, TError,{data: EmailChangeReauthRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meEmailChangeReauth>>,
        TError,
        {data: EmailChangeReauthRequest},
        TContext
      > => {
      return useMutation(getMeEmailChangeReauthMutationOptions(options), queryClient);
    }

export type meFincoinsSummaryResponse200 = {
  data: FinCoinSummary
  status: 200
}

export type meFincoinsSummaryResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meFincoinsSummaryResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meFincoinsSummaryResponseSuccess = (meFincoinsSummaryResponse200) & {
  headers: Headers;
};
export type meFincoinsSummaryResponseError = (meFincoinsSummaryResponse401 | meFincoinsSummaryResponse410) & {
  headers: Headers;
};

export type meFincoinsSummaryResponse = (meFincoinsSummaryResponseSuccess | meFincoinsSummaryResponseError)

export const getMeFincoinsSummaryUrl = () => {




  return `/api/v1/me/fincoins/`
}

/**
 * @summary Saldo FinCoin ucznia i pozycja strumienia rewizji
 */
export const meFincoinsSummary = async ( options?: RequestInit): Promise<meFincoinsSummaryResponse> => {

  return customFetch<meFincoinsSummaryResponse>(getMeFincoinsSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeFincoinsSummaryQueryKey = () => {
    return [
    `/api/v1/me/fincoins/`
    ] as const;
    }


export const getMeFincoinsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof meFincoinsSummary>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meFincoinsSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeFincoinsSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meFincoinsSummary>>> = ({ signal }) => meFincoinsSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meFincoinsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeFincoinsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof meFincoinsSummary>>>
export type MeFincoinsSummaryQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeFincoinsSummary<TData = Awaited<ReturnType<typeof meFincoinsSummary>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meFincoinsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meFincoinsSummary>>,
          TError,
          Awaited<ReturnType<typeof meFincoinsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeFincoinsSummary<TData = Awaited<ReturnType<typeof meFincoinsSummary>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meFincoinsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meFincoinsSummary>>,
          TError,
          Awaited<ReturnType<typeof meFincoinsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeFincoinsSummary<TData = Awaited<ReturnType<typeof meFincoinsSummary>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meFincoinsSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Saldo FinCoin ucznia i pozycja strumienia rewizji
 */

export function useMeFincoinsSummary<TData = Awaited<ReturnType<typeof meFincoinsSummary>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meFincoinsSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeFincoinsSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meFincoinsMovementsResponse200 = {
  data: FinCoinMovementList
  status: 200
}

export type meFincoinsMovementsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meFincoinsMovementsResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meFincoinsMovementsResponseSuccess = (meFincoinsMovementsResponse200) & {
  headers: Headers;
};
export type meFincoinsMovementsResponseError = (meFincoinsMovementsResponse401 | meFincoinsMovementsResponse410) & {
  headers: Headers;
};

export type meFincoinsMovementsResponse = (meFincoinsMovementsResponseSuccess | meFincoinsMovementsResponseError)

export const getMeFincoinsMovementsUrl = (params?: MeFincoinsMovementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/fincoins/movements/?${stringifiedParams}` : `/api/v1/me/fincoins/movements/`
}

/**
 * @summary Rewizje FinCoin ucznia po wskazanej pozycji
 */
export const meFincoinsMovements = async (params?: MeFincoinsMovementsParams, options?: RequestInit): Promise<meFincoinsMovementsResponse> => {

  return customFetch<meFincoinsMovementsResponse>(getMeFincoinsMovementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeFincoinsMovementsQueryKey = (params?: MeFincoinsMovementsParams,) => {
    return [
    `/api/v1/me/fincoins/movements/`, ...(params ? [params] : [])
    ] as const;
    }


export const getMeFincoinsMovementsQueryOptions = <TData = Awaited<ReturnType<typeof meFincoinsMovements>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: MeFincoinsMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meFincoinsMovements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeFincoinsMovementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meFincoinsMovements>>> = ({ signal }) => meFincoinsMovements(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meFincoinsMovements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeFincoinsMovementsQueryResult = NonNullable<Awaited<ReturnType<typeof meFincoinsMovements>>>
export type MeFincoinsMovementsQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeFincoinsMovements<TData = Awaited<ReturnType<typeof meFincoinsMovements>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  MeFincoinsMovementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meFincoinsMovements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meFincoinsMovements>>,
          TError,
          Awaited<ReturnType<typeof meFincoinsMovements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeFincoinsMovements<TData = Awaited<ReturnType<typeof meFincoinsMovements>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: MeFincoinsMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meFincoinsMovements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meFincoinsMovements>>,
          TError,
          Awaited<ReturnType<typeof meFincoinsMovements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeFincoinsMovements<TData = Awaited<ReturnType<typeof meFincoinsMovements>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: MeFincoinsMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meFincoinsMovements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Rewizje FinCoin ucznia po wskazanej pozycji
 */

export function useMeFincoinsMovements<TData = Awaited<ReturnType<typeof meFincoinsMovements>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: MeFincoinsMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meFincoinsMovements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeFincoinsMovementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meGamificationRevisionsResponse200 = {
  data: GamificationRevisionList
  status: 200
}

export type meGamificationRevisionsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meGamificationRevisionsResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meGamificationRevisionsResponseSuccess = (meGamificationRevisionsResponse200) & {
  headers: Headers;
};
export type meGamificationRevisionsResponseError = (meGamificationRevisionsResponse401 | meGamificationRevisionsResponse410) & {
  headers: Headers;
};

export type meGamificationRevisionsResponse = (meGamificationRevisionsResponseSuccess | meGamificationRevisionsResponseError)

export const getMeGamificationRevisionsUrl = (params?: MeGamificationRevisionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/gamification/revisions/?${stringifiedParams}` : `/api/v1/me/gamification/revisions/`
}

/**
 * @summary Zmiany gamifikacji po wskazanej pozycji
 */
export const meGamificationRevisions = async (params?: MeGamificationRevisionsParams, options?: RequestInit): Promise<meGamificationRevisionsResponse> => {

  return customFetch<meGamificationRevisionsResponse>(getMeGamificationRevisionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeGamificationRevisionsQueryKey = (params?: MeGamificationRevisionsParams,) => {
    return [
    `/api/v1/me/gamification/revisions/`, ...(params ? [params] : [])
    ] as const;
    }


export const getMeGamificationRevisionsQueryOptions = <TData = Awaited<ReturnType<typeof meGamificationRevisions>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: MeGamificationRevisionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meGamificationRevisions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeGamificationRevisionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meGamificationRevisions>>> = ({ signal }) => meGamificationRevisions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meGamificationRevisions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeGamificationRevisionsQueryResult = NonNullable<Awaited<ReturnType<typeof meGamificationRevisions>>>
export type MeGamificationRevisionsQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeGamificationRevisions<TData = Awaited<ReturnType<typeof meGamificationRevisions>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  MeGamificationRevisionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meGamificationRevisions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meGamificationRevisions>>,
          TError,
          Awaited<ReturnType<typeof meGamificationRevisions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeGamificationRevisions<TData = Awaited<ReturnType<typeof meGamificationRevisions>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: MeGamificationRevisionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meGamificationRevisions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meGamificationRevisions>>,
          TError,
          Awaited<ReturnType<typeof meGamificationRevisions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeGamificationRevisions<TData = Awaited<ReturnType<typeof meGamificationRevisions>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: MeGamificationRevisionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meGamificationRevisions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Zmiany gamifikacji po wskazanej pozycji
 */

export function useMeGamificationRevisions<TData = Awaited<ReturnType<typeof meGamificationRevisions>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: MeGamificationRevisionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meGamificationRevisions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeGamificationRevisionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meGamificationSummaryResponse200 = {
  data: GamificationSummary
  status: 200
}

export type meGamificationSummaryResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meGamificationSummaryResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meGamificationSummaryResponseSuccess = (meGamificationSummaryResponse200) & {
  headers: Headers;
};
export type meGamificationSummaryResponseError = (meGamificationSummaryResponse401 | meGamificationSummaryResponse410) & {
  headers: Headers;
};

export type meGamificationSummaryResponse = (meGamificationSummaryResponseSuccess | meGamificationSummaryResponseError)

export const getMeGamificationSummaryUrl = () => {




  return `/api/v1/me/gamification/summary/`
}

/**
 * @summary Autorytatywny snapshot stanu gamifikacji ucznia
 */
export const meGamificationSummary = async ( options?: RequestInit): Promise<meGamificationSummaryResponse> => {

  return customFetch<meGamificationSummaryResponse>(getMeGamificationSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeGamificationSummaryQueryKey = () => {
    return [
    `/api/v1/me/gamification/summary/`
    ] as const;
    }


export const getMeGamificationSummaryQueryOptions = <TData = Awaited<ReturnType<typeof meGamificationSummary>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meGamificationSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeGamificationSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meGamificationSummary>>> = ({ signal }) => meGamificationSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meGamificationSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeGamificationSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof meGamificationSummary>>>
export type MeGamificationSummaryQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeGamificationSummary<TData = Awaited<ReturnType<typeof meGamificationSummary>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meGamificationSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meGamificationSummary>>,
          TError,
          Awaited<ReturnType<typeof meGamificationSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeGamificationSummary<TData = Awaited<ReturnType<typeof meGamificationSummary>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meGamificationSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meGamificationSummary>>,
          TError,
          Awaited<ReturnType<typeof meGamificationSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeGamificationSummary<TData = Awaited<ReturnType<typeof meGamificationSummary>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meGamificationSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Autorytatywny snapshot stanu gamifikacji ucznia
 */

export function useMeGamificationSummary<TData = Awaited<ReturnType<typeof meGamificationSummary>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meGamificationSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeGamificationSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type knowledgeHintVisibilityUpdateResponse200 = {
  data: KnowledgeHintVisibility
  status: 200
}

export type knowledgeHintVisibilityUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type knowledgeHintVisibilityUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type knowledgeHintVisibilityUpdateResponseSuccess = (knowledgeHintVisibilityUpdateResponse200) & {
  headers: Headers;
};
export type knowledgeHintVisibilityUpdateResponseError = (knowledgeHintVisibilityUpdateResponse401 | knowledgeHintVisibilityUpdateResponse410) & {
  headers: Headers;
};

export type knowledgeHintVisibilityUpdateResponse = (knowledgeHintVisibilityUpdateResponseSuccess | knowledgeHintVisibilityUpdateResponseError)

export const getKnowledgeHintVisibilityUpdateUrl = (hintId: number,) => {




  return `/api/v1/me/knowledge-hints/${hintId}/visibility/`
}

export const knowledgeHintVisibilityUpdate = async (hintId: number,
    knowledgeHintVisibilityWriteRequest: KnowledgeHintVisibilityWriteRequest, options?: RequestInit): Promise<knowledgeHintVisibilityUpdateResponse> => {

  return customFetch<knowledgeHintVisibilityUpdateResponse>(getKnowledgeHintVisibilityUpdateUrl(hintId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(knowledgeHintVisibilityWriteRequest)
  }
);}




export const getKnowledgeHintVisibilityUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeHintVisibilityUpdate>>, TError,{hintId: number;data: KnowledgeHintVisibilityWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeHintVisibilityUpdate>>, TError,{hintId: number;data: KnowledgeHintVisibilityWriteRequest}, TContext> => {

const mutationKey = ['knowledgeHintVisibilityUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeHintVisibilityUpdate>>, {hintId: number;data: KnowledgeHintVisibilityWriteRequest}> = (props) => {
          const {hintId,data} = props ?? {};

          return  knowledgeHintVisibilityUpdate(hintId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeHintVisibilityUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeHintVisibilityUpdate>>>
    export type KnowledgeHintVisibilityUpdateMutationBody = KnowledgeHintVisibilityWriteRequest
    export type KnowledgeHintVisibilityUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useKnowledgeHintVisibilityUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeHintVisibilityUpdate>>, TError,{hintId: number;data: KnowledgeHintVisibilityWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeHintVisibilityUpdate>>,
        TError,
        {hintId: number;data: KnowledgeHintVisibilityWriteRequest},
        TContext
      > => {
      return useMutation(getKnowledgeHintVisibilityUpdateMutationOptions(options), queryClient);
    }

export type meModulesRetrieveResponse200 = {
  data: MeModules
  status: 200
}

export type meModulesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meModulesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meModulesRetrieveResponseSuccess = (meModulesRetrieveResponse200) & {
  headers: Headers;
};
export type meModulesRetrieveResponseError = (meModulesRetrieveResponse401 | meModulesRetrieveResponse410) & {
  headers: Headers;
};

export type meModulesRetrieveResponse = (meModulesRetrieveResponseSuccess | meModulesRetrieveResponseError)

export const getMeModulesRetrieveUrl = () => {




  return `/api/v1/me/modules/`
}

/**
 * The set of educational modules enabled for the calling account (TR-1200 hierarchy resolution). `version` grows monotonically with every audited configuration change; the response carries an opaque ETag and a matching `If-None-Match` yields `304 Not Modified` with no body.
 */
export const meModulesRetrieve = async ( options?: RequestInit): Promise<meModulesRetrieveResponse> => {

  return customFetch<meModulesRetrieveResponse>(getMeModulesRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeModulesRetrieveQueryKey = () => {
    return [
    `/api/v1/me/modules/`
    ] as const;
    }


export const getMeModulesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof meModulesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meModulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeModulesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meModulesRetrieve>>> = ({ signal }) => meModulesRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meModulesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeModulesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof meModulesRetrieve>>>
export type MeModulesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeModulesRetrieve<TData = Awaited<ReturnType<typeof meModulesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meModulesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meModulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof meModulesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeModulesRetrieve<TData = Awaited<ReturnType<typeof meModulesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meModulesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meModulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof meModulesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeModulesRetrieve<TData = Awaited<ReturnType<typeof meModulesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meModulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMeModulesRetrieve<TData = Awaited<ReturnType<typeof meModulesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meModulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeModulesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1MeNotificationPreferencesRetrieveResponse200 = {
  data: NotificationPreference
  status: 200
}

export type v1MeNotificationPreferencesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MeNotificationPreferencesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MeNotificationPreferencesRetrieveResponseSuccess = (v1MeNotificationPreferencesRetrieveResponse200) & {
  headers: Headers;
};
export type v1MeNotificationPreferencesRetrieveResponseError = (v1MeNotificationPreferencesRetrieveResponse401 | v1MeNotificationPreferencesRetrieveResponse410) & {
  headers: Headers;
};

export type v1MeNotificationPreferencesRetrieveResponse = (v1MeNotificationPreferencesRetrieveResponseSuccess | v1MeNotificationPreferencesRetrieveResponseError)

export const getV1MeNotificationPreferencesRetrieveUrl = () => {




  return `/api/v1/me/notification-preferences/`
}

/**
 * Full-document owner preferences; first GET returns defaults without writing.
 */
export const v1MeNotificationPreferencesRetrieve = async ( options?: RequestInit): Promise<v1MeNotificationPreferencesRetrieveResponse> => {

  return customFetch<v1MeNotificationPreferencesRetrieveResponse>(getV1MeNotificationPreferencesRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MeNotificationPreferencesRetrieveQueryKey = () => {
    return [
    `/api/v1/me/notification-preferences/`
    ] as const;
    }


export const getV1MeNotificationPreferencesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MeNotificationPreferencesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>> = ({ signal }) => v1MeNotificationPreferencesRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MeNotificationPreferencesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>>
export type V1MeNotificationPreferencesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1MeNotificationPreferencesRetrieve<TData = Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MeNotificationPreferencesRetrieve<TData = Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MeNotificationPreferencesRetrieve<TData = Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1MeNotificationPreferencesRetrieve<TData = Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeNotificationPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MeNotificationPreferencesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1MeNotificationPreferencesUpdateResponse200 = {
  data: NotificationPreference
  status: 200
}

export type v1MeNotificationPreferencesUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MeNotificationPreferencesUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MeNotificationPreferencesUpdateResponseSuccess = (v1MeNotificationPreferencesUpdateResponse200) & {
  headers: Headers;
};
export type v1MeNotificationPreferencesUpdateResponseError = (v1MeNotificationPreferencesUpdateResponse401 | v1MeNotificationPreferencesUpdateResponse410) & {
  headers: Headers;
};

export type v1MeNotificationPreferencesUpdateResponse = (v1MeNotificationPreferencesUpdateResponseSuccess | v1MeNotificationPreferencesUpdateResponseError)

export const getV1MeNotificationPreferencesUpdateUrl = () => {




  return `/api/v1/me/notification-preferences/`
}

/**
 * Full-document owner preferences; first GET returns defaults without writing.
 */
export const v1MeNotificationPreferencesUpdate = async (notificationPreferenceRequest: NotificationPreferenceRequest, options?: RequestInit): Promise<v1MeNotificationPreferencesUpdateResponse> => {

  return customFetch<v1MeNotificationPreferencesUpdateResponse>(getV1MeNotificationPreferencesUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationPreferenceRequest)
  }
);}




export const getV1MeNotificationPreferencesUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MeNotificationPreferencesUpdate>>, TError,{data: NotificationPreferenceRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MeNotificationPreferencesUpdate>>, TError,{data: NotificationPreferenceRequest}, TContext> => {

const mutationKey = ['v1MeNotificationPreferencesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MeNotificationPreferencesUpdate>>, {data: NotificationPreferenceRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1MeNotificationPreferencesUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MeNotificationPreferencesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MeNotificationPreferencesUpdate>>>
    export type V1MeNotificationPreferencesUpdateMutationBody = NotificationPreferenceRequest
    export type V1MeNotificationPreferencesUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1MeNotificationPreferencesUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MeNotificationPreferencesUpdate>>, TError,{data: NotificationPreferenceRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MeNotificationPreferencesUpdate>>,
        TError,
        {data: NotificationPreferenceRequest},
        TContext
      > => {
      return useMutation(getV1MeNotificationPreferencesUpdateMutationOptions(options), queryClient);
    }

export type meNotificationReceiptRecordResponse200 = {
  data: NotificationReceipt
  status: 200
}

export type meNotificationReceiptRecordResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meNotificationReceiptRecordResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meNotificationReceiptRecordResponseSuccess = (meNotificationReceiptRecordResponse200) & {
  headers: Headers;
};
export type meNotificationReceiptRecordResponseError = (meNotificationReceiptRecordResponse401 | meNotificationReceiptRecordResponse410) & {
  headers: Headers;
};

export type meNotificationReceiptRecordResponse = (meNotificationReceiptRecordResponseSuccess | meNotificationReceiptRecordResponseError)

export const getMeNotificationReceiptRecordUrl = (receiptId: string,) => {




  return `/api/v1/me/notification-receipts/${receiptId}/`
}

export const meNotificationReceiptRecord = async (receiptId: string,
    notificationReceiptCommandRequest: NotificationReceiptCommandRequest, options?: RequestInit): Promise<meNotificationReceiptRecordResponse> => {

  return customFetch<meNotificationReceiptRecordResponse>(getMeNotificationReceiptRecordUrl(receiptId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationReceiptCommandRequest)
  }
);}




export const getMeNotificationReceiptRecordMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meNotificationReceiptRecord>>, TError,{receiptId: string;data: NotificationReceiptCommandRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meNotificationReceiptRecord>>, TError,{receiptId: string;data: NotificationReceiptCommandRequest}, TContext> => {

const mutationKey = ['meNotificationReceiptRecord'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meNotificationReceiptRecord>>, {receiptId: string;data: NotificationReceiptCommandRequest}> = (props) => {
          const {receiptId,data} = props ?? {};

          return  meNotificationReceiptRecord(receiptId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeNotificationReceiptRecordMutationResult = NonNullable<Awaited<ReturnType<typeof meNotificationReceiptRecord>>>
    export type MeNotificationReceiptRecordMutationBody = NotificationReceiptCommandRequest
    export type MeNotificationReceiptRecordMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useMeNotificationReceiptRecord = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meNotificationReceiptRecord>>, TError,{receiptId: string;data: NotificationReceiptCommandRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meNotificationReceiptRecord>>,
        TError,
        {receiptId: string;data: NotificationReceiptCommandRequest},
        TContext
      > => {
      return useMutation(getMeNotificationReceiptRecordMutationOptions(options), queryClient);
    }

export type mePointsResponse200 = {
  data: PointsBalance
  status: 200
}

export type mePointsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type mePointsResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type mePointsResponseSuccess = (mePointsResponse200) & {
  headers: Headers;
};
export type mePointsResponseError = (mePointsResponse401 | mePointsResponse410) & {
  headers: Headers;
};

export type mePointsResponse = (mePointsResponseSuccess | mePointsResponseError)

export const getMePointsUrl = () => {




  return `/api/v1/me/points/`
}

/**
 * `GET /api/v1/me/points/` — the caller's ledger sum (T036, C9).
 *
 * Student-only; balance = SUM(amount) over the append-only ledger, 0 for a
 * student with no entries. Includes chest bonuses: the balance grows by
 * `points + chest.bonus_points` per completed chest-granting session.
 * @summary Saldo punktów ucznia (suma wpisów rejestru punktów)
 */
export const mePoints = async ( options?: RequestInit): Promise<mePointsResponse> => {

  return customFetch<mePointsResponse>(getMePointsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMePointsQueryKey = () => {
    return [
    `/api/v1/me/points/`
    ] as const;
    }


export const getMePointsQueryOptions = <TData = Awaited<ReturnType<typeof mePoints>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mePoints>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMePointsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mePoints>>> = ({ signal }) => mePoints({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mePoints>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MePointsQueryResult = NonNullable<Awaited<ReturnType<typeof mePoints>>>
export type MePointsQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMePoints<TData = Awaited<ReturnType<typeof mePoints>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mePoints>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mePoints>>,
          TError,
          Awaited<ReturnType<typeof mePoints>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMePoints<TData = Awaited<ReturnType<typeof mePoints>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mePoints>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mePoints>>,
          TError,
          Awaited<ReturnType<typeof mePoints>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMePoints<TData = Awaited<ReturnType<typeof mePoints>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mePoints>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Saldo punktów ucznia (suma wpisów rejestru punktów)
 */

export function useMePoints<TData = Awaited<ReturnType<typeof mePoints>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mePoints>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMePointsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meRankingReadResponse200 = {
  data: MeRanking
  status: 200
}

export type meRankingReadResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meRankingReadResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meRankingReadResponseSuccess = (meRankingReadResponse200) & {
  headers: Headers;
};
export type meRankingReadResponseError = (meRankingReadResponse401 | meRankingReadResponse410) & {
  headers: Headers;
};

export type meRankingReadResponse = (meRankingReadResponseSuccess | meRankingReadResponseError)

export const getMeRankingReadUrl = () => {




  return `/api/v1/me/ranking/`
}

/**
 * 404 gdy uczeń nie ma aktualnego przypisania do klasy (D7) albo nie ma jeszcze rankingu globalnego.
 * @summary Dokument rankingu ucznia: moje punkty/miejsce i listy klasa/szkoła/szkoły
 */
export const meRankingRead = async ( options?: RequestInit): Promise<meRankingReadResponse> => {

  return customFetch<meRankingReadResponse>(getMeRankingReadUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeRankingReadQueryKey = () => {
    return [
    `/api/v1/me/ranking/`
    ] as const;
    }


export const getMeRankingReadQueryOptions = <TData = Awaited<ReturnType<typeof meRankingRead>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meRankingRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeRankingReadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meRankingRead>>> = ({ signal }) => meRankingRead({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meRankingRead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeRankingReadQueryResult = NonNullable<Awaited<ReturnType<typeof meRankingRead>>>
export type MeRankingReadQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeRankingRead<TData = Awaited<ReturnType<typeof meRankingRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meRankingRead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meRankingRead>>,
          TError,
          Awaited<ReturnType<typeof meRankingRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeRankingRead<TData = Awaited<ReturnType<typeof meRankingRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meRankingRead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meRankingRead>>,
          TError,
          Awaited<ReturnType<typeof meRankingRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeRankingRead<TData = Awaited<ReturnType<typeof meRankingRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meRankingRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Dokument rankingu ucznia: moje punkty/miejsce i listy klasa/szkoła/szkoły
 */

export function useMeRankingRead<TData = Awaited<ReturnType<typeof meRankingRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meRankingRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeRankingReadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meRankingVisibilityReadResponse200 = {
  data: RankingVisibility
  status: 200
}

export type meRankingVisibilityReadResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meRankingVisibilityReadResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meRankingVisibilityReadResponseSuccess = (meRankingVisibilityReadResponse200) & {
  headers: Headers;
};
export type meRankingVisibilityReadResponseError = (meRankingVisibilityReadResponse401 | meRankingVisibilityReadResponse410) & {
  headers: Headers;
};

export type meRankingVisibilityReadResponse = (meRankingVisibilityReadResponseSuccess | meRankingVisibilityReadResponseError)

export const getMeRankingVisibilityReadUrl = () => {




  return `/api/v1/me/ranking/visibility/`
}

/**
 * Bez zapisanej decyzji zwraca {visible: false, decided: false} — sam odczyt nie zapisuje wiersza.
 * @summary Zgoda ucznia na widoczność w rankingu rówieśników
 */
export const meRankingVisibilityRead = async ( options?: RequestInit): Promise<meRankingVisibilityReadResponse> => {

  return customFetch<meRankingVisibilityReadResponse>(getMeRankingVisibilityReadUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeRankingVisibilityReadQueryKey = () => {
    return [
    `/api/v1/me/ranking/visibility/`
    ] as const;
    }


export const getMeRankingVisibilityReadQueryOptions = <TData = Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeRankingVisibilityReadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meRankingVisibilityRead>>> = ({ signal }) => meRankingVisibilityRead({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeRankingVisibilityReadQueryResult = NonNullable<Awaited<ReturnType<typeof meRankingVisibilityRead>>>
export type MeRankingVisibilityReadQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeRankingVisibilityRead<TData = Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meRankingVisibilityRead>>,
          TError,
          Awaited<ReturnType<typeof meRankingVisibilityRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeRankingVisibilityRead<TData = Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meRankingVisibilityRead>>,
          TError,
          Awaited<ReturnType<typeof meRankingVisibilityRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeRankingVisibilityRead<TData = Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Zgoda ucznia na widoczność w rankingu rówieśników
 */

export function useMeRankingVisibilityRead<TData = Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meRankingVisibilityRead>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeRankingVisibilityReadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type meRankingVisibilityUpdateResponse200 = {
  data: RankingVisibility
  status: 200
}

export type meRankingVisibilityUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meRankingVisibilityUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meRankingVisibilityUpdateResponseSuccess = (meRankingVisibilityUpdateResponse200) & {
  headers: Headers;
};
export type meRankingVisibilityUpdateResponseError = (meRankingVisibilityUpdateResponse401 | meRankingVisibilityUpdateResponse410) & {
  headers: Headers;
};

export type meRankingVisibilityUpdateResponse = (meRankingVisibilityUpdateResponseSuccess | meRankingVisibilityUpdateResponseError)

export const getMeRankingVisibilityUpdateUrl = () => {




  return `/api/v1/me/ranking/visibility/`
}

/**
 * Tworzy albo aktualizuje wiersz; decided_at ustawiane tylko przy pierwszym zapisie.
 * @summary Ustawienie zgody ucznia na widoczność w rankingu rówieśników
 */
export const meRankingVisibilityUpdate = async (rankingVisibilityWriteRequest: RankingVisibilityWriteRequest, options?: RequestInit): Promise<meRankingVisibilityUpdateResponse> => {

  return customFetch<meRankingVisibilityUpdateResponse>(getMeRankingVisibilityUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rankingVisibilityWriteRequest)
  }
);}




export const getMeRankingVisibilityUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meRankingVisibilityUpdate>>, TError,{data: RankingVisibilityWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meRankingVisibilityUpdate>>, TError,{data: RankingVisibilityWriteRequest}, TContext> => {

const mutationKey = ['meRankingVisibilityUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meRankingVisibilityUpdate>>, {data: RankingVisibilityWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  meRankingVisibilityUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeRankingVisibilityUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof meRankingVisibilityUpdate>>>
    export type MeRankingVisibilityUpdateMutationBody = RankingVisibilityWriteRequest
    export type MeRankingVisibilityUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Ustawienie zgody ucznia na widoczność w rankingu rówieśników
 */
export const useMeRankingVisibilityUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meRankingVisibilityUpdate>>, TError,{data: RankingVisibilityWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meRankingVisibilityUpdate>>,
        TError,
        {data: RankingVisibilityWriteRequest},
        TContext
      > => {
      return useMutation(getMeRankingVisibilityUpdateMutationOptions(options), queryClient);
    }

export type meRecoveryCredentialsUpdateResponse200 = {
  data: RecoveryCredentialsUpdateResponse
  status: 200
}

export type meRecoveryCredentialsUpdateResponse400 = {
  data: void
  status: 400
}

export type meRecoveryCredentialsUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meRecoveryCredentialsUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meRecoveryCredentialsUpdateResponse429 = {
  data: void
  status: 429
}

export type meRecoveryCredentialsUpdateResponseSuccess = (meRecoveryCredentialsUpdateResponse200) & {
  headers: Headers;
};
export type meRecoveryCredentialsUpdateResponseError = (meRecoveryCredentialsUpdateResponse400 | meRecoveryCredentialsUpdateResponse401 | meRecoveryCredentialsUpdateResponse410 | meRecoveryCredentialsUpdateResponse429) & {
  headers: Headers;
};

export type meRecoveryCredentialsUpdateResponse = (meRecoveryCredentialsUpdateResponseSuccess | meRecoveryCredentialsUpdateResponseError)

export const getMeRecoveryCredentialsUpdateUrl = () => {




  return `/api/v1/me/recovery-credentials/`
}

/**
 * @summary Zmiana składników odzyskiwania ucznia
 */
export const meRecoveryCredentialsUpdate = async (recoveryCredentialsUpdateRequest: RecoveryCredentialsUpdateRequest, options?: RequestInit): Promise<meRecoveryCredentialsUpdateResponse> => {

  return customFetch<meRecoveryCredentialsUpdateResponse>(getMeRecoveryCredentialsUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recoveryCredentialsUpdateRequest)
  }
);}




export const getMeRecoveryCredentialsUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meRecoveryCredentialsUpdate>>, TError,{data: RecoveryCredentialsUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof meRecoveryCredentialsUpdate>>, TError,{data: RecoveryCredentialsUpdateRequest}, TContext> => {

const mutationKey = ['meRecoveryCredentialsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meRecoveryCredentialsUpdate>>, {data: RecoveryCredentialsUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  meRecoveryCredentialsUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeRecoveryCredentialsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof meRecoveryCredentialsUpdate>>>
    export type MeRecoveryCredentialsUpdateMutationBody = RecoveryCredentialsUpdateRequest
    export type MeRecoveryCredentialsUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Zmiana składników odzyskiwania ucznia
 */
export const useMeRecoveryCredentialsUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meRecoveryCredentialsUpdate>>, TError,{data: RecoveryCredentialsUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meRecoveryCredentialsUpdate>>,
        TError,
        {data: RecoveryCredentialsUpdateRequest},
        TContext
      > => {
      return useMutation(getMeRecoveryCredentialsUpdateMutationOptions(options), queryClient);
    }

export type meStreakRetrieveResponse200 = {
  data: Streak
  status: 200
}

export type meStreakRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type meStreakRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type meStreakRetrieveResponseSuccess = (meStreakRetrieveResponse200) & {
  headers: Headers;
};
export type meStreakRetrieveResponseError = (meStreakRetrieveResponse401 | meStreakRetrieveResponse410) & {
  headers: Headers;
};

export type meStreakRetrieveResponse = (meStreakRetrieveResponseSuccess | meStreakRetrieveResponseError)

export const getMeStreakRetrieveUrl = (params?: MeStreakRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/streak/?${stringifiedParams}` : `/api/v1/me/streak/`
}

/**
 * `GET /api/v1/me/streak/` — the server-counted streak and its calendar (spec 176).
 * @summary Seria dni liczona przez serwer
 */
export const meStreakRetrieve = async (params?: MeStreakRetrieveParams, options?: RequestInit): Promise<meStreakRetrieveResponse> => {

  return customFetch<meStreakRetrieveResponse>(getMeStreakRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeStreakRetrieveQueryKey = (params?: MeStreakRetrieveParams,) => {
    return [
    `/api/v1/me/streak/`, ...(params ? [params] : [])
    ] as const;
    }


export const getMeStreakRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof meStreakRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: MeStreakRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meStreakRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeStreakRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meStreakRetrieve>>> = ({ signal }) => meStreakRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meStreakRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeStreakRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof meStreakRetrieve>>>
export type MeStreakRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMeStreakRetrieve<TData = Awaited<ReturnType<typeof meStreakRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  MeStreakRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meStreakRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meStreakRetrieve>>,
          TError,
          Awaited<ReturnType<typeof meStreakRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeStreakRetrieve<TData = Awaited<ReturnType<typeof meStreakRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: MeStreakRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meStreakRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meStreakRetrieve>>,
          TError,
          Awaited<ReturnType<typeof meStreakRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeStreakRetrieve<TData = Awaited<ReturnType<typeof meStreakRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: MeStreakRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meStreakRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Seria dni liczona przez serwer
 */

export function useMeStreakRetrieve<TData = Awaited<ReturnType<typeof meStreakRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: MeStreakRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meStreakRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeStreakRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type missionsAdvanceResponse200 = {
  data: Mission
  status: 200
}

export type missionsAdvanceResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionsAdvanceResponse404 = {
  data: MissionError
  status: 404
}

export type missionsAdvanceResponse409 = {
  data: MissionError
  status: 409
}

export type missionsAdvanceResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionsAdvanceResponseSuccess = (missionsAdvanceResponse200) & {
  headers: Headers;
};
export type missionsAdvanceResponseError = (missionsAdvanceResponse401 | missionsAdvanceResponse404 | missionsAdvanceResponse409 | missionsAdvanceResponse410) & {
  headers: Headers;
};

export type missionsAdvanceResponse = (missionsAdvanceResponseSuccess | missionsAdvanceResponseError)

export const getMissionsAdvanceUrl = (key: string,) => {




  return `/api/v1/missions/${key}/advance/`
}

/**
 * `POST /api/v1/missions/{key}/advance/` — declared missions only.
 *
 * A `derived` key answers 409 `mission_not_declarable`. That refusal is the
 * whole point of the endpoint's existence: it makes "tapping a tile grants a
 * reward" unbuildable rather than merely discouraged.
 * @summary Zgłoszenie postępu misji deklarowanej (uczeń)
 */
export const missionsAdvance = async (key: string,
    missionAdvanceRequestRequest?: MissionAdvanceRequestRequest, options?: RequestInit): Promise<missionsAdvanceResponse> => {

  return customFetch<missionsAdvanceResponse>(getMissionsAdvanceUrl(key),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(missionAdvanceRequestRequest)
  }
);}




export const getMissionsAdvanceMutationOptions = <TError = UnauthorizedResponse | MissionError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionsAdvance>>, TError,{key: string;data?: MissionAdvanceRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof missionsAdvance>>, TError,{key: string;data?: MissionAdvanceRequestRequest}, TContext> => {

const mutationKey = ['missionsAdvance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof missionsAdvance>>, {key: string;data?: MissionAdvanceRequestRequest}> = (props) => {
          const {key,data} = props ?? {};

          return  missionsAdvance(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MissionsAdvanceMutationResult = NonNullable<Awaited<ReturnType<typeof missionsAdvance>>>
    export type MissionsAdvanceMutationBody = MissionAdvanceRequestRequest | undefined
    export type MissionsAdvanceMutationError = UnauthorizedResponse | MissionError | AccountGoneResponse

    /**
 * @summary Zgłoszenie postępu misji deklarowanej (uczeń)
 */
export const useMissionsAdvance = <TError = UnauthorizedResponse | MissionError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionsAdvance>>, TError,{key: string;data?: MissionAdvanceRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof missionsAdvance>>,
        TError,
        {key: string;data?: MissionAdvanceRequestRequest},
        TContext
      > => {
      return useMutation(getMissionsAdvanceMutationOptions(options), queryClient);
    }

export type missionsClaimResponse200 = {
  data: MissionClaim
  status: 200
}

export type missionsClaimResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionsClaimResponse404 = {
  data: MissionError
  status: 404
}

export type missionsClaimResponse409 = {
  data: MissionError
  status: 409
}

export type missionsClaimResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionsClaimResponseSuccess = (missionsClaimResponse200) & {
  headers: Headers;
};
export type missionsClaimResponseError = (missionsClaimResponse401 | missionsClaimResponse404 | missionsClaimResponse409 | missionsClaimResponse410) & {
  headers: Headers;
};

export type missionsClaimResponse = (missionsClaimResponseSuccess | missionsClaimResponseError)

export const getMissionsClaimUrl = (key: string,) => {




  return `/api/v1/missions/${key}/claim/`
}

/**
 * Compatibility adapter for clients predating automatic settlement.
 *
 * New completions are already paid. The endpoint returns their frozen numbers
 * and lazily settles historical ``done && !claimed`` rows without duplication.
 * @summary Zgodnościowy odczyt nagrody za ukończoną misję (uczeń)
 */
export const missionsClaim = async (key: string, options?: RequestInit): Promise<missionsClaimResponse> => {

  return customFetch<missionsClaimResponse>(getMissionsClaimUrl(key),
  {
    ...options,
    method: 'POST'


  }
);}




export const getMissionsClaimMutationOptions = <TError = UnauthorizedResponse | MissionError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionsClaim>>, TError,{key: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof missionsClaim>>, TError,{key: string}, TContext> => {

const mutationKey = ['missionsClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof missionsClaim>>, {key: string}> = (props) => {
          const {key} = props ?? {};

          return  missionsClaim(key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MissionsClaimMutationResult = NonNullable<Awaited<ReturnType<typeof missionsClaim>>>

    export type MissionsClaimMutationError = UnauthorizedResponse | MissionError | AccountGoneResponse

    /**
 * @summary Zgodnościowy odczyt nagrody za ukończoną misję (uczeń)
 */
export const useMissionsClaim = <TError = UnauthorizedResponse | MissionError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionsClaim>>, TError,{key: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof missionsClaim>>,
        TError,
        {key: string},
        TContext
      > => {
      return useMutation(getMissionsClaimMutationOptions(options), queryClient);
    }

export type v1MissionsAdminCadenceRecipesListResponse200 = {
  data: AdminMissionCadenceRecipes
  status: 200
}

export type v1MissionsAdminCadenceRecipesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MissionsAdminCadenceRecipesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MissionsAdminCadenceRecipesListResponseSuccess = (v1MissionsAdminCadenceRecipesListResponse200) & {
  headers: Headers;
};
export type v1MissionsAdminCadenceRecipesListResponseError = (v1MissionsAdminCadenceRecipesListResponse401 | v1MissionsAdminCadenceRecipesListResponse410) & {
  headers: Headers;
};

export type v1MissionsAdminCadenceRecipesListResponse = (v1MissionsAdminCadenceRecipesListResponseSuccess | v1MissionsAdminCadenceRecipesListResponseError)

export const getV1MissionsAdminCadenceRecipesListUrl = () => {




  return `/api/v1/missions/admin/cadence-recipes/`
}

/**
 * @summary Konfiguracja i diagnostyka kadencji misji dziennych
 */
export const v1MissionsAdminCadenceRecipesList = async ( options?: RequestInit): Promise<v1MissionsAdminCadenceRecipesListResponse> => {

  return customFetch<v1MissionsAdminCadenceRecipesListResponse>(getV1MissionsAdminCadenceRecipesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MissionsAdminCadenceRecipesListQueryKey = () => {
    return [
    `/api/v1/missions/admin/cadence-recipes/`
    ] as const;
    }


export const getV1MissionsAdminCadenceRecipesListQueryOptions = <TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MissionsAdminCadenceRecipesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>> = ({ signal }) => v1MissionsAdminCadenceRecipesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MissionsAdminCadenceRecipesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>>
export type V1MissionsAdminCadenceRecipesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1MissionsAdminCadenceRecipesList<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>,
          TError,
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MissionsAdminCadenceRecipesList<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>,
          TError,
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MissionsAdminCadenceRecipesList<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Konfiguracja i diagnostyka kadencji misji dziennych
 */

export function useV1MissionsAdminCadenceRecipesList<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MissionsAdminCadenceRecipesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1MissionsAdminCadenceRecipesRetrieveResponse200 = {
  data: AdminMissionCadenceRecipe
  status: 200
}

export type v1MissionsAdminCadenceRecipesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MissionsAdminCadenceRecipesRetrieveResponse404 = {
  data: void
  status: 404
}

export type v1MissionsAdminCadenceRecipesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MissionsAdminCadenceRecipesRetrieveResponseSuccess = (v1MissionsAdminCadenceRecipesRetrieveResponse200) & {
  headers: Headers;
};
export type v1MissionsAdminCadenceRecipesRetrieveResponseError = (v1MissionsAdminCadenceRecipesRetrieveResponse401 | v1MissionsAdminCadenceRecipesRetrieveResponse404 | v1MissionsAdminCadenceRecipesRetrieveResponse410) & {
  headers: Headers;
};

export type v1MissionsAdminCadenceRecipesRetrieveResponse = (v1MissionsAdminCadenceRecipesRetrieveResponseSuccess | v1MissionsAdminCadenceRecipesRetrieveResponseError)

export const getV1MissionsAdminCadenceRecipesRetrieveUrl = (cadence: string,) => {




  return `/api/v1/missions/admin/cadence-recipes/${cadence}/`
}

/**
 * @summary Szczegóły efektywnej konfiguracji kadencji misji
 */
export const v1MissionsAdminCadenceRecipesRetrieve = async (cadence: string, options?: RequestInit): Promise<v1MissionsAdminCadenceRecipesRetrieveResponse> => {

  return customFetch<v1MissionsAdminCadenceRecipesRetrieveResponse>(getV1MissionsAdminCadenceRecipesRetrieveUrl(cadence),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MissionsAdminCadenceRecipesRetrieveQueryKey = (cadence: string,) => {
    return [
    `/api/v1/missions/admin/cadence-recipes/${cadence}/`
    ] as const;
    }


export const getV1MissionsAdminCadenceRecipesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(cadence: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MissionsAdminCadenceRecipesRetrieveQueryKey(cadence);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>> = ({ signal }) => v1MissionsAdminCadenceRecipesRetrieve(cadence, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: cadence !== null && cadence !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MissionsAdminCadenceRecipesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>>
export type V1MissionsAdminCadenceRecipesRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1MissionsAdminCadenceRecipesRetrieve<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MissionsAdminCadenceRecipesRetrieve<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MissionsAdminCadenceRecipesRetrieve<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły efektywnej konfiguracji kadencji misji
 */

export function useV1MissionsAdminCadenceRecipesRetrieve<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MissionsAdminCadenceRecipesRetrieveQueryOptions(cadence,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1MissionsAdminCadenceRecipeDeactivateResponse200 = {
  data: AdminMissionCadenceRecipeRevision
  status: 200
}

export type v1MissionsAdminCadenceRecipeDeactivateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MissionsAdminCadenceRecipeDeactivateResponse404 = {
  data: void
  status: 404
}

export type v1MissionsAdminCadenceRecipeDeactivateResponse409 = {
  data: void
  status: 409
}

export type v1MissionsAdminCadenceRecipeDeactivateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MissionsAdminCadenceRecipeDeactivateResponseSuccess = (v1MissionsAdminCadenceRecipeDeactivateResponse200) & {
  headers: Headers;
};
export type v1MissionsAdminCadenceRecipeDeactivateResponseError = (v1MissionsAdminCadenceRecipeDeactivateResponse401 | v1MissionsAdminCadenceRecipeDeactivateResponse404 | v1MissionsAdminCadenceRecipeDeactivateResponse409 | v1MissionsAdminCadenceRecipeDeactivateResponse410) & {
  headers: Headers;
};

export type v1MissionsAdminCadenceRecipeDeactivateResponse = (v1MissionsAdminCadenceRecipeDeactivateResponseSuccess | v1MissionsAdminCadenceRecipeDeactivateResponseError)

export const getV1MissionsAdminCadenceRecipeDeactivateUrl = (cadence: string,) => {




  return `/api/v1/missions/admin/cadence-recipes/${cadence}/deactivate/`
}

/**
 * @summary Natychmiastowe wyłączenie kadencji (z pominięciem granicy dnia)
 */
export const v1MissionsAdminCadenceRecipeDeactivate = async (cadence: string, options?: RequestInit): Promise<v1MissionsAdminCadenceRecipeDeactivateResponse> => {

  return customFetch<v1MissionsAdminCadenceRecipeDeactivateResponse>(getV1MissionsAdminCadenceRecipeDeactivateUrl(cadence),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1MissionsAdminCadenceRecipeDeactivateMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeDeactivate>>, TError,{cadence: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeDeactivate>>, TError,{cadence: string}, TContext> => {

const mutationKey = ['v1MissionsAdminCadenceRecipeDeactivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeDeactivate>>, {cadence: string}> = (props) => {
          const {cadence} = props ?? {};

          return  v1MissionsAdminCadenceRecipeDeactivate(cadence,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MissionsAdminCadenceRecipeDeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeDeactivate>>>

    export type V1MissionsAdminCadenceRecipeDeactivateMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Natychmiastowe wyłączenie kadencji (z pominięciem granicy dnia)
 */
export const useV1MissionsAdminCadenceRecipeDeactivate = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeDeactivate>>, TError,{cadence: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeDeactivate>>,
        TError,
        {cadence: string},
        TContext
      > => {
      return useMutation(getV1MissionsAdminCadenceRecipeDeactivateMutationOptions(options), queryClient);
    }

export type v1MissionsAdminCadenceRecipeRevisionsListResponse200 = {
  data: AdminMissionCadenceRecipeRevisions
  status: 200
}

export type v1MissionsAdminCadenceRecipeRevisionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MissionsAdminCadenceRecipeRevisionsListResponse404 = {
  data: void
  status: 404
}

export type v1MissionsAdminCadenceRecipeRevisionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MissionsAdminCadenceRecipeRevisionsListResponseSuccess = (v1MissionsAdminCadenceRecipeRevisionsListResponse200) & {
  headers: Headers;
};
export type v1MissionsAdminCadenceRecipeRevisionsListResponseError = (v1MissionsAdminCadenceRecipeRevisionsListResponse401 | v1MissionsAdminCadenceRecipeRevisionsListResponse404 | v1MissionsAdminCadenceRecipeRevisionsListResponse410) & {
  headers: Headers;
};

export type v1MissionsAdminCadenceRecipeRevisionsListResponse = (v1MissionsAdminCadenceRecipeRevisionsListResponseSuccess | v1MissionsAdminCadenceRecipeRevisionsListResponseError)

export const getV1MissionsAdminCadenceRecipeRevisionsListUrl = (cadence: string,) => {




  return `/api/v1/missions/admin/cadence-recipes/${cadence}/revisions/`
}

/**
 * @summary Historia wersji konfiguracji kadencji misji
 */
export const v1MissionsAdminCadenceRecipeRevisionsList = async (cadence: string, options?: RequestInit): Promise<v1MissionsAdminCadenceRecipeRevisionsListResponse> => {

  return customFetch<v1MissionsAdminCadenceRecipeRevisionsListResponse>(getV1MissionsAdminCadenceRecipeRevisionsListUrl(cadence),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MissionsAdminCadenceRecipeRevisionsListQueryKey = (cadence: string,) => {
    return [
    `/api/v1/missions/admin/cadence-recipes/${cadence}/revisions/`
    ] as const;
    }


export const getV1MissionsAdminCadenceRecipeRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(cadence: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MissionsAdminCadenceRecipeRevisionsListQueryKey(cadence);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>> = ({ signal }) => v1MissionsAdminCadenceRecipeRevisionsList(cadence, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: cadence !== null && cadence !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MissionsAdminCadenceRecipeRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>>
export type V1MissionsAdminCadenceRecipeRevisionsListQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1MissionsAdminCadenceRecipeRevisionsList<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MissionsAdminCadenceRecipeRevisionsList<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MissionsAdminCadenceRecipeRevisionsList<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Historia wersji konfiguracji kadencji misji
 */

export function useV1MissionsAdminCadenceRecipeRevisionsList<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MissionsAdminCadenceRecipeRevisionsListQueryOptions(cadence,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1MissionsAdminCadenceRecipeRevisionsCreateResponse201 = {
  data: AdminMissionCadenceRecipeRevision
  status: 201
}

export type v1MissionsAdminCadenceRecipeRevisionsCreateResponse400 = {
  data: void
  status: 400
}

export type v1MissionsAdminCadenceRecipeRevisionsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MissionsAdminCadenceRecipeRevisionsCreateResponse409 = {
  data: void
  status: 409
}

export type v1MissionsAdminCadenceRecipeRevisionsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MissionsAdminCadenceRecipeRevisionsCreateResponseSuccess = (v1MissionsAdminCadenceRecipeRevisionsCreateResponse201) & {
  headers: Headers;
};
export type v1MissionsAdminCadenceRecipeRevisionsCreateResponseError = (v1MissionsAdminCadenceRecipeRevisionsCreateResponse400 | v1MissionsAdminCadenceRecipeRevisionsCreateResponse401 | v1MissionsAdminCadenceRecipeRevisionsCreateResponse409 | v1MissionsAdminCadenceRecipeRevisionsCreateResponse410) & {
  headers: Headers;
};

export type v1MissionsAdminCadenceRecipeRevisionsCreateResponse = (v1MissionsAdminCadenceRecipeRevisionsCreateResponseSuccess | v1MissionsAdminCadenceRecipeRevisionsCreateResponseError)

export const getV1MissionsAdminCadenceRecipeRevisionsCreateUrl = (cadence: string,) => {




  return `/api/v1/missions/admin/cadence-recipes/${cadence}/revisions/`
}

/**
 * @summary Utworzenie niezmiennej wersji roboczej konfiguracji
 */
export const v1MissionsAdminCadenceRecipeRevisionsCreate = async (cadence: string,
    adminMissionCadenceRecipeWriteRequest: AdminMissionCadenceRecipeWriteRequest, options?: RequestInit): Promise<v1MissionsAdminCadenceRecipeRevisionsCreateResponse> => {

  return customFetch<v1MissionsAdminCadenceRecipeRevisionsCreateResponse>(getV1MissionsAdminCadenceRecipeRevisionsCreateUrl(cadence),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminMissionCadenceRecipeWriteRequest)
  }
);}




export const getV1MissionsAdminCadenceRecipeRevisionsCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsCreate>>, TError,{cadence: string;data: AdminMissionCadenceRecipeWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsCreate>>, TError,{cadence: string;data: AdminMissionCadenceRecipeWriteRequest}, TContext> => {

const mutationKey = ['v1MissionsAdminCadenceRecipeRevisionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsCreate>>, {cadence: string;data: AdminMissionCadenceRecipeWriteRequest}> = (props) => {
          const {cadence,data} = props ?? {};

          return  v1MissionsAdminCadenceRecipeRevisionsCreate(cadence,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MissionsAdminCadenceRecipeRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsCreate>>>
    export type V1MissionsAdminCadenceRecipeRevisionsCreateMutationBody = AdminMissionCadenceRecipeWriteRequest
    export type V1MissionsAdminCadenceRecipeRevisionsCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Utworzenie niezmiennej wersji roboczej konfiguracji
 */
export const useV1MissionsAdminCadenceRecipeRevisionsCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsCreate>>, TError,{cadence: string;data: AdminMissionCadenceRecipeWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionsCreate>>,
        TError,
        {cadence: string;data: AdminMissionCadenceRecipeWriteRequest},
        TContext
      > => {
      return useMutation(getV1MissionsAdminCadenceRecipeRevisionsCreateMutationOptions(options), queryClient);
    }

export type v1MissionsAdminCadenceRecipeRevisionActivateResponse200 = {
  data: AdminMissionCadenceRecipeRevision
  status: 200
}

export type v1MissionsAdminCadenceRecipeRevisionActivateResponse400 = {
  data: void
  status: 400
}

export type v1MissionsAdminCadenceRecipeRevisionActivateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MissionsAdminCadenceRecipeRevisionActivateResponse404 = {
  data: void
  status: 404
}

export type v1MissionsAdminCadenceRecipeRevisionActivateResponse409 = {
  data: void
  status: 409
}

export type v1MissionsAdminCadenceRecipeRevisionActivateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MissionsAdminCadenceRecipeRevisionActivateResponseSuccess = (v1MissionsAdminCadenceRecipeRevisionActivateResponse200) & {
  headers: Headers;
};
export type v1MissionsAdminCadenceRecipeRevisionActivateResponseError = (v1MissionsAdminCadenceRecipeRevisionActivateResponse400 | v1MissionsAdminCadenceRecipeRevisionActivateResponse401 | v1MissionsAdminCadenceRecipeRevisionActivateResponse404 | v1MissionsAdminCadenceRecipeRevisionActivateResponse409 | v1MissionsAdminCadenceRecipeRevisionActivateResponse410) & {
  headers: Headers;
};

export type v1MissionsAdminCadenceRecipeRevisionActivateResponse = (v1MissionsAdminCadenceRecipeRevisionActivateResponseSuccess | v1MissionsAdminCadenceRecipeRevisionActivateResponseError)

export const getV1MissionsAdminCadenceRecipeRevisionActivateUrl = (cadence: string,
    number: number,) => {




  return `/api/v1/missions/admin/cadence-recipes/${cadence}/revisions/${number}/activate/`
}

/**
 * @summary Publikacja wersji od następnej bezpiecznej granicy dnia
 */
export const v1MissionsAdminCadenceRecipeRevisionActivate = async (cadence: string,
    number: number, options?: RequestInit): Promise<v1MissionsAdminCadenceRecipeRevisionActivateResponse> => {

  return customFetch<v1MissionsAdminCadenceRecipeRevisionActivateResponse>(getV1MissionsAdminCadenceRecipeRevisionActivateUrl(cadence,number),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1MissionsAdminCadenceRecipeRevisionActivateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionActivate>>, TError,{cadence: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionActivate>>, TError,{cadence: string;number: number}, TContext> => {

const mutationKey = ['v1MissionsAdminCadenceRecipeRevisionActivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionActivate>>, {cadence: string;number: number}> = (props) => {
          const {cadence,number} = props ?? {};

          return  v1MissionsAdminCadenceRecipeRevisionActivate(cadence,number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MissionsAdminCadenceRecipeRevisionActivateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionActivate>>>

    export type V1MissionsAdminCadenceRecipeRevisionActivateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Publikacja wersji od następnej bezpiecznej granicy dnia
 */
export const useV1MissionsAdminCadenceRecipeRevisionActivate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionActivate>>, TError,{cadence: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionActivate>>,
        TError,
        {cadence: string;number: number},
        TContext
      > => {
      return useMutation(getV1MissionsAdminCadenceRecipeRevisionActivateMutationOptions(options), queryClient);
    }

export type v1MissionsAdminCadenceRecipeRevisionCancelResponse200 = {
  data: AdminMissionCadenceRecipeRevision
  status: 200
}

export type v1MissionsAdminCadenceRecipeRevisionCancelResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MissionsAdminCadenceRecipeRevisionCancelResponse404 = {
  data: void
  status: 404
}

export type v1MissionsAdminCadenceRecipeRevisionCancelResponse409 = {
  data: void
  status: 409
}

export type v1MissionsAdminCadenceRecipeRevisionCancelResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MissionsAdminCadenceRecipeRevisionCancelResponseSuccess = (v1MissionsAdminCadenceRecipeRevisionCancelResponse200) & {
  headers: Headers;
};
export type v1MissionsAdminCadenceRecipeRevisionCancelResponseError = (v1MissionsAdminCadenceRecipeRevisionCancelResponse401 | v1MissionsAdminCadenceRecipeRevisionCancelResponse404 | v1MissionsAdminCadenceRecipeRevisionCancelResponse409 | v1MissionsAdminCadenceRecipeRevisionCancelResponse410) & {
  headers: Headers;
};

export type v1MissionsAdminCadenceRecipeRevisionCancelResponse = (v1MissionsAdminCadenceRecipeRevisionCancelResponseSuccess | v1MissionsAdminCadenceRecipeRevisionCancelResponseError)

export const getV1MissionsAdminCadenceRecipeRevisionCancelUrl = (cadence: string,
    number: number,) => {




  return `/api/v1/missions/admin/cadence-recipes/${cadence}/revisions/${number}/cancel/`
}

/**
 * @summary Anulowanie porzuconej wersji roboczej
 */
export const v1MissionsAdminCadenceRecipeRevisionCancel = async (cadence: string,
    number: number, options?: RequestInit): Promise<v1MissionsAdminCadenceRecipeRevisionCancelResponse> => {

  return customFetch<v1MissionsAdminCadenceRecipeRevisionCancelResponse>(getV1MissionsAdminCadenceRecipeRevisionCancelUrl(cadence,number),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1MissionsAdminCadenceRecipeRevisionCancelMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionCancel>>, TError,{cadence: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionCancel>>, TError,{cadence: string;number: number}, TContext> => {

const mutationKey = ['v1MissionsAdminCadenceRecipeRevisionCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionCancel>>, {cadence: string;number: number}> = (props) => {
          const {cadence,number} = props ?? {};

          return  v1MissionsAdminCadenceRecipeRevisionCancel(cadence,number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MissionsAdminCadenceRecipeRevisionCancelMutationResult = NonNullable<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionCancel>>>

    export type V1MissionsAdminCadenceRecipeRevisionCancelMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Anulowanie porzuconej wersji roboczej
 */
export const useV1MissionsAdminCadenceRecipeRevisionCancel = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionCancel>>, TError,{cadence: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionCancel>>,
        TError,
        {cadence: string;number: number},
        TContext
      > => {
      return useMutation(getV1MissionsAdminCadenceRecipeRevisionCancelMutationOptions(options), queryClient);
    }

export type v1MissionsAdminCadenceRecipeRevisionPreviewResponse200 = {
  data: AdminMissionCadencePreview
  status: 200
}

export type v1MissionsAdminCadenceRecipeRevisionPreviewResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MissionsAdminCadenceRecipeRevisionPreviewResponse404 = {
  data: void
  status: 404
}

export type v1MissionsAdminCadenceRecipeRevisionPreviewResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MissionsAdminCadenceRecipeRevisionPreviewResponseSuccess = (v1MissionsAdminCadenceRecipeRevisionPreviewResponse200) & {
  headers: Headers;
};
export type v1MissionsAdminCadenceRecipeRevisionPreviewResponseError = (v1MissionsAdminCadenceRecipeRevisionPreviewResponse401 | v1MissionsAdminCadenceRecipeRevisionPreviewResponse404 | v1MissionsAdminCadenceRecipeRevisionPreviewResponse410) & {
  headers: Headers;
};

export type v1MissionsAdminCadenceRecipeRevisionPreviewResponse = (v1MissionsAdminCadenceRecipeRevisionPreviewResponseSuccess | v1MissionsAdminCadenceRecipeRevisionPreviewResponseError)

export const getV1MissionsAdminCadenceRecipeRevisionPreviewUrl = (cadence: string,
    number: number,) => {




  return `/api/v1/missions/admin/cadence-recipes/${cadence}/revisions/${number}/preview/`
}

/**
 * `GET .../revisions/{number}/preview/` — dry-run the real selector.
 *
 * This is the M1-078 answer screen: an operator sets `fixed_keys` +
 * `rotating_count` on a draft and sees the exact set `select_day_set` would
 * hand a real student, without deploying anything and without spending a
 * student's day. `recipes.preview_selection` runs the selector against a
 * stand-in student id derived from `(cadence, number)` alone, so refreshing
 * the panel never reshuffles the draw, and it stops at the selector's return
 * value — no `MissionAssignment` row is ever written by this endpoint.
 * @summary Podgląd zestawu dnia przykładowego ucznia dla wersji konfiguracji
 */
export const v1MissionsAdminCadenceRecipeRevisionPreview = async (cadence: string,
    number: number, options?: RequestInit): Promise<v1MissionsAdminCadenceRecipeRevisionPreviewResponse> => {

  return customFetch<v1MissionsAdminCadenceRecipeRevisionPreviewResponse>(getV1MissionsAdminCadenceRecipeRevisionPreviewUrl(cadence,number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MissionsAdminCadenceRecipeRevisionPreviewQueryKey = (cadence: string,
    number: number,) => {
    return [
    `/api/v1/missions/admin/cadence-recipes/${cadence}/revisions/${number}/preview/`
    ] as const;
    }


export const getV1MissionsAdminCadenceRecipeRevisionPreviewQueryOptions = <TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(cadence: string,
    number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MissionsAdminCadenceRecipeRevisionPreviewQueryKey(cadence,number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>> = ({ signal }) => v1MissionsAdminCadenceRecipeRevisionPreview(cadence,number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: cadence !== null && cadence !== undefined && number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MissionsAdminCadenceRecipeRevisionPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>>
export type V1MissionsAdminCadenceRecipeRevisionPreviewQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1MissionsAdminCadenceRecipeRevisionPreview<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string,
    number: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>,
          TError,
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MissionsAdminCadenceRecipeRevisionPreview<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string,
    number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>,
          TError,
          Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MissionsAdminCadenceRecipeRevisionPreview<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string,
    number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Podgląd zestawu dnia przykładowego ucznia dla wersji konfiguracji
 */

export function useV1MissionsAdminCadenceRecipeRevisionPreview<TData = Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cadence: string,
    number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionPreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MissionsAdminCadenceRecipeRevisionPreviewQueryOptions(cadence,number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1MissionsAdminCadenceRecipeRevisionValidateResponse200 = {
  data: AdminMissionCadenceRecipeValidation
  status: 200
}

export type v1MissionsAdminCadenceRecipeRevisionValidateResponse400 = {
  data: void
  status: 400
}

export type v1MissionsAdminCadenceRecipeRevisionValidateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MissionsAdminCadenceRecipeRevisionValidateResponse404 = {
  data: void
  status: 404
}

export type v1MissionsAdminCadenceRecipeRevisionValidateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MissionsAdminCadenceRecipeRevisionValidateResponseSuccess = (v1MissionsAdminCadenceRecipeRevisionValidateResponse200) & {
  headers: Headers;
};
export type v1MissionsAdminCadenceRecipeRevisionValidateResponseError = (v1MissionsAdminCadenceRecipeRevisionValidateResponse400 | v1MissionsAdminCadenceRecipeRevisionValidateResponse401 | v1MissionsAdminCadenceRecipeRevisionValidateResponse404 | v1MissionsAdminCadenceRecipeRevisionValidateResponse410) & {
  headers: Headers;
};

export type v1MissionsAdminCadenceRecipeRevisionValidateResponse = (v1MissionsAdminCadenceRecipeRevisionValidateResponseSuccess | v1MissionsAdminCadenceRecipeRevisionValidateResponseError)

export const getV1MissionsAdminCadenceRecipeRevisionValidateUrl = (cadence: string,
    number: number,) => {




  return `/api/v1/missions/admin/cadence-recipes/${cadence}/revisions/${number}/validate/`
}

/**
 * @summary Walidacja wersji i gotowości puli przed publikacją
 */
export const v1MissionsAdminCadenceRecipeRevisionValidate = async (cadence: string,
    number: number, options?: RequestInit): Promise<v1MissionsAdminCadenceRecipeRevisionValidateResponse> => {

  return customFetch<v1MissionsAdminCadenceRecipeRevisionValidateResponse>(getV1MissionsAdminCadenceRecipeRevisionValidateUrl(cadence,number),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1MissionsAdminCadenceRecipeRevisionValidateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionValidate>>, TError,{cadence: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionValidate>>, TError,{cadence: string;number: number}, TContext> => {

const mutationKey = ['v1MissionsAdminCadenceRecipeRevisionValidate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionValidate>>, {cadence: string;number: number}> = (props) => {
          const {cadence,number} = props ?? {};

          return  v1MissionsAdminCadenceRecipeRevisionValidate(cadence,number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MissionsAdminCadenceRecipeRevisionValidateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionValidate>>>

    export type V1MissionsAdminCadenceRecipeRevisionValidateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Walidacja wersji i gotowości puli przed publikacją
 */
export const useV1MissionsAdminCadenceRecipeRevisionValidate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionValidate>>, TError,{cadence: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MissionsAdminCadenceRecipeRevisionValidate>>,
        TError,
        {cadence: string;number: number},
        TContext
      > => {
      return useMutation(getV1MissionsAdminCadenceRecipeRevisionValidateMutationOptions(options), queryClient);
    }

export type missionPeriodCatalogRetrieveResponse200 = {
  data: PeriodCatalog
  status: 200
}

export type missionPeriodCatalogRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionPeriodCatalogRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionPeriodCatalogRetrieveResponseSuccess = (missionPeriodCatalogRetrieveResponse200) & {
  headers: Headers;
};
export type missionPeriodCatalogRetrieveResponseError = (missionPeriodCatalogRetrieveResponse401 | missionPeriodCatalogRetrieveResponse410) & {
  headers: Headers;
};

export type missionPeriodCatalogRetrieveResponse = (missionPeriodCatalogRetrieveResponseSuccess | missionPeriodCatalogRetrieveResponseError)

export const getMissionPeriodCatalogRetrieveUrl = () => {




  return `/api/v1/missions/catalog/`
}

export const missionPeriodCatalogRetrieve = async ( options?: RequestInit): Promise<missionPeriodCatalogRetrieveResponse> => {

  return customFetch<missionPeriodCatalogRetrieveResponse>(getMissionPeriodCatalogRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMissionPeriodCatalogRetrieveQueryKey = () => {
    return [
    `/api/v1/missions/catalog/`
    ] as const;
    }


export const getMissionPeriodCatalogRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMissionPeriodCatalogRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>> = ({ signal }) => missionPeriodCatalogRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MissionPeriodCatalogRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>>
export type MissionPeriodCatalogRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMissionPeriodCatalogRetrieve<TData = Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMissionPeriodCatalogRetrieve<TData = Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMissionPeriodCatalogRetrieve<TData = Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMissionPeriodCatalogRetrieve<TData = Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionPeriodCatalogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMissionPeriodCatalogRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type missionsDayRetrieveResponse200 = {
  data: MissionDay
  status: 200
}

export type missionsDayRetrieveResponse400 = {
  data: MissionError
  status: 400
}

export type missionsDayRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionsDayRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionsDayRetrieveResponseSuccess = (missionsDayRetrieveResponse200) & {
  headers: Headers;
};
export type missionsDayRetrieveResponseError = (missionsDayRetrieveResponse400 | missionsDayRetrieveResponse401 | missionsDayRetrieveResponse410) & {
  headers: Headers;
};

export type missionsDayRetrieveResponse = (missionsDayRetrieveResponseSuccess | missionsDayRetrieveResponseError)

export const getMissionsDayRetrieveUrl = (date: string,) => {




  return `/api/v1/missions/day/${date}/`
}

/**
 * `GET /api/v1/missions/day/{date}/` — a closed day's set, read-only (spec 160).
 *
 * Pure read over `MissionAssignment`/`MissionProgress`: no materialization, no
 * `sync_daily_activity_assignments`, no write of any kind. ``date`` equal to
 * today delegates to `day_payload` — the one path that is allowed to
 * materialize, so `today/` and this endpoint can never disagree on what
 * today contains. A future ``date`` is refused: nothing has happened there
 * yet.
 * @summary Zestaw misji wybranego dnia (uczeń)
 */
export const missionsDayRetrieve = async (date: string, options?: RequestInit): Promise<missionsDayRetrieveResponse> => {

  return customFetch<missionsDayRetrieveResponse>(getMissionsDayRetrieveUrl(date),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMissionsDayRetrieveQueryKey = (date: string,) => {
    return [
    `/api/v1/missions/day/${date}/`
    ] as const;
    }


export const getMissionsDayRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof missionsDayRetrieve>>, TError = MissionError | UnauthorizedResponse | AccountGoneResponse>(date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionsDayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMissionsDayRetrieveQueryKey(date);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof missionsDayRetrieve>>> = ({ signal }) => missionsDayRetrieve(date, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: date !== null && date !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof missionsDayRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MissionsDayRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof missionsDayRetrieve>>>
export type MissionsDayRetrieveQueryError = MissionError | UnauthorizedResponse | AccountGoneResponse


export function useMissionsDayRetrieve<TData = Awaited<ReturnType<typeof missionsDayRetrieve>>, TError = MissionError | UnauthorizedResponse | AccountGoneResponse>(
 date: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionsDayRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof missionsDayRetrieve>>,
          TError,
          Awaited<ReturnType<typeof missionsDayRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMissionsDayRetrieve<TData = Awaited<ReturnType<typeof missionsDayRetrieve>>, TError = MissionError | UnauthorizedResponse | AccountGoneResponse>(
 date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionsDayRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof missionsDayRetrieve>>,
          TError,
          Awaited<ReturnType<typeof missionsDayRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMissionsDayRetrieve<TData = Awaited<ReturnType<typeof missionsDayRetrieve>>, TError = MissionError | UnauthorizedResponse | AccountGoneResponse>(
 date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionsDayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Zestaw misji wybranego dnia (uczeń)
 */

export function useMissionsDayRetrieve<TData = Awaited<ReturnType<typeof missionsDayRetrieve>>, TError = MissionError | UnauthorizedResponse | AccountGoneResponse>(
 date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionsDayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMissionsDayRetrieveQueryOptions(date,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type missionGecResponsesListResponse200 = {
  data: GecResponseList
  status: 200
}

export type missionGecResponsesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionGecResponsesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionGecResponsesListResponseSuccess = (missionGecResponsesListResponse200) & {
  headers: Headers;
};
export type missionGecResponsesListResponseError = (missionGecResponsesListResponse401 | missionGecResponsesListResponse410) & {
  headers: Headers;
};

export type missionGecResponsesListResponse = (missionGecResponsesListResponseSuccess | missionGecResponsesListResponseError)

export const getMissionGecResponsesListUrl = () => {




  return `/api/v1/missions/gec/responses/`
}

export const missionGecResponsesList = async ( options?: RequestInit): Promise<missionGecResponsesListResponse> => {

  return customFetch<missionGecResponsesListResponse>(getMissionGecResponsesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMissionGecResponsesListQueryKey = () => {
    return [
    `/api/v1/missions/gec/responses/`
    ] as const;
    }


export const getMissionGecResponsesListQueryOptions = <TData = Awaited<ReturnType<typeof missionGecResponsesList>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionGecResponsesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMissionGecResponsesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof missionGecResponsesList>>> = ({ signal }) => missionGecResponsesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof missionGecResponsesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MissionGecResponsesListQueryResult = NonNullable<Awaited<ReturnType<typeof missionGecResponsesList>>>
export type MissionGecResponsesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMissionGecResponsesList<TData = Awaited<ReturnType<typeof missionGecResponsesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionGecResponsesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof missionGecResponsesList>>,
          TError,
          Awaited<ReturnType<typeof missionGecResponsesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMissionGecResponsesList<TData = Awaited<ReturnType<typeof missionGecResponsesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionGecResponsesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof missionGecResponsesList>>,
          TError,
          Awaited<ReturnType<typeof missionGecResponsesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMissionGecResponsesList<TData = Awaited<ReturnType<typeof missionGecResponsesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionGecResponsesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMissionGecResponsesList<TData = Awaited<ReturnType<typeof missionGecResponsesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionGecResponsesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMissionGecResponsesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type missionGecResponseCreateResponse200 = {
  data: PeriodTask
  status: 200
}

export type missionGecResponseCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionGecResponseCreateResponse409 = {
  data: PeriodClosedError
  status: 409
}

export type missionGecResponseCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionGecResponseCreateResponseSuccess = (missionGecResponseCreateResponse200) & {
  headers: Headers;
};
export type missionGecResponseCreateResponseError = (missionGecResponseCreateResponse401 | missionGecResponseCreateResponse409 | missionGecResponseCreateResponse410) & {
  headers: Headers;
};

export type missionGecResponseCreateResponse = (missionGecResponseCreateResponseSuccess | missionGecResponseCreateResponseError)

export const getMissionGecResponseCreateUrl = () => {




  return `/api/v1/missions/gec/responses/`
}

/**
 * Record one idea in the Europe/Warsaw week of `performed_at`. Every idea is kept; the first one of a week completes that week's `gec_response` task and its reward, later ones return the already completed task.
 */
export const missionGecResponseCreate = async (periodResponseWriteRequest: PeriodResponseWriteRequest, options?: RequestInit): Promise<missionGecResponseCreateResponse> => {

  return customFetch<missionGecResponseCreateResponse>(getMissionGecResponseCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(periodResponseWriteRequest)
  }
);}




export const getMissionGecResponseCreateMutationOptions = <TError = UnauthorizedResponse | PeriodClosedError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionGecResponseCreate>>, TError,{data: PeriodResponseWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof missionGecResponseCreate>>, TError,{data: PeriodResponseWriteRequest}, TContext> => {

const mutationKey = ['missionGecResponseCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof missionGecResponseCreate>>, {data: PeriodResponseWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  missionGecResponseCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MissionGecResponseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof missionGecResponseCreate>>>
    export type MissionGecResponseCreateMutationBody = PeriodResponseWriteRequest
    export type MissionGecResponseCreateMutationError = UnauthorizedResponse | PeriodClosedError | AccountGoneResponse

    export const useMissionGecResponseCreate = <TError = UnauthorizedResponse | PeriodClosedError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionGecResponseCreate>>, TError,{data: PeriodResponseWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof missionGecResponseCreate>>,
        TError,
        {data: PeriodResponseWriteRequest},
        TContext
      > => {
      return useMutation(getMissionGecResponseCreateMutationOptions(options), queryClient);
    }

export type missionGecResponseUpdateResponse200 = {
  data: PeriodTask
  status: 200
}

export type missionGecResponseUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionGecResponseUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionGecResponseUpdateResponseSuccess = (missionGecResponseUpdateResponse200) & {
  headers: Headers;
};
export type missionGecResponseUpdateResponseError = (missionGecResponseUpdateResponse401 | missionGecResponseUpdateResponse410) & {
  headers: Headers;
};

export type missionGecResponseUpdateResponse = (missionGecResponseUpdateResponseSuccess | missionGecResponseUpdateResponseError)

export const getMissionGecResponseUpdateUrl = (operationId: string,) => {




  return `/api/v1/missions/gec/responses/${operationId}/`
}

/**
 * Change the text of an existing idea. Does not complete the week task again or pay `gec_response` a second time. Closed weeks stay editable.
 */
export const missionGecResponseUpdate = async (operationId: string,
    gecResponseEditRequest: GecResponseEditRequest, options?: RequestInit): Promise<missionGecResponseUpdateResponse> => {

  return customFetch<missionGecResponseUpdateResponse>(getMissionGecResponseUpdateUrl(operationId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(gecResponseEditRequest)
  }
);}




export const getMissionGecResponseUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionGecResponseUpdate>>, TError,{operationId: string;data: GecResponseEditRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof missionGecResponseUpdate>>, TError,{operationId: string;data: GecResponseEditRequest}, TContext> => {

const mutationKey = ['missionGecResponseUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof missionGecResponseUpdate>>, {operationId: string;data: GecResponseEditRequest}> = (props) => {
          const {operationId,data} = props ?? {};

          return  missionGecResponseUpdate(operationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MissionGecResponseUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof missionGecResponseUpdate>>>
    export type MissionGecResponseUpdateMutationBody = GecResponseEditRequest
    export type MissionGecResponseUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useMissionGecResponseUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionGecResponseUpdate>>, TError,{operationId: string;data: GecResponseEditRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof missionGecResponseUpdate>>,
        TError,
        {operationId: string;data: GecResponseEditRequest},
        TContext
      > => {
      return useMutation(getMissionGecResponseUpdateMutationOptions(options), queryClient);
    }

export type missionGecResponseDeleteResponse200 = {
  data: PeriodTask
  status: 200
}

export type missionGecResponseDeleteResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionGecResponseDeleteResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionGecResponseDeleteResponseSuccess = (missionGecResponseDeleteResponse200) & {
  headers: Headers;
};
export type missionGecResponseDeleteResponseError = (missionGecResponseDeleteResponse401 | missionGecResponseDeleteResponse410) & {
  headers: Headers;
};

export type missionGecResponseDeleteResponse = (missionGecResponseDeleteResponseSuccess | missionGecResponseDeleteResponseError)

export const getMissionGecResponseDeleteUrl = (operationId: string,) => {




  return `/api/v1/missions/gec/responses/${operationId}/`
}

/**
 * Remove one idea from the student's list. The week task keeps its state and its reward, and a later idea in the same week is still not paid twice.
 */
export const missionGecResponseDelete = async (operationId: string, options?: RequestInit): Promise<missionGecResponseDeleteResponse> => {

  return customFetch<missionGecResponseDeleteResponse>(getMissionGecResponseDeleteUrl(operationId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getMissionGecResponseDeleteMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionGecResponseDelete>>, TError,{operationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof missionGecResponseDelete>>, TError,{operationId: string}, TContext> => {

const mutationKey = ['missionGecResponseDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof missionGecResponseDelete>>, {operationId: string}> = (props) => {
          const {operationId} = props ?? {};

          return  missionGecResponseDelete(operationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MissionGecResponseDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof missionGecResponseDelete>>>

    export type MissionGecResponseDeleteMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useMissionGecResponseDelete = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionGecResponseDelete>>, TError,{operationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof missionGecResponseDelete>>,
        TError,
        {operationId: string},
        TContext
      > => {
      return useMutation(getMissionGecResponseDeleteMutationOptions(options), queryClient);
    }

export type missionPeriodRetrieveResponse200 = {
  data: PeriodDocument
  status: 200
}

export type missionPeriodRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionPeriodRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionPeriodRetrieveResponseSuccess = (missionPeriodRetrieveResponse200) & {
  headers: Headers;
};
export type missionPeriodRetrieveResponseError = (missionPeriodRetrieveResponse401 | missionPeriodRetrieveResponse410) & {
  headers: Headers;
};

export type missionPeriodRetrieveResponse = (missionPeriodRetrieveResponseSuccess | missionPeriodRetrieveResponseError)

export const getMissionPeriodRetrieveUrl = (params: MissionPeriodRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/missions/period/?${stringifiedParams}` : `/api/v1/missions/period/`
}

/**
 * Any period from the student's first one up to today, past ones included: their open tasks can still be caught up. A period that ended before the catalog start or before the day the account was created is 404.
 */
export const missionPeriodRetrieve = async (params: MissionPeriodRetrieveParams, options?: RequestInit): Promise<missionPeriodRetrieveResponse> => {

  return customFetch<missionPeriodRetrieveResponse>(getMissionPeriodRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMissionPeriodRetrieveQueryKey = (params?: MissionPeriodRetrieveParams,) => {
    return [
    `/api/v1/missions/period/`, ...(params ? [params] : [])
    ] as const;
    }


export const getMissionPeriodRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(params: MissionPeriodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMissionPeriodRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof missionPeriodRetrieve>>> = ({ signal }) => missionPeriodRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MissionPeriodRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof missionPeriodRetrieve>>>
export type MissionPeriodRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMissionPeriodRetrieve<TData = Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: MissionPeriodRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof missionPeriodRetrieve>>,
          TError,
          Awaited<ReturnType<typeof missionPeriodRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMissionPeriodRetrieve<TData = Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: MissionPeriodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof missionPeriodRetrieve>>,
          TError,
          Awaited<ReturnType<typeof missionPeriodRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMissionPeriodRetrieve<TData = Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: MissionPeriodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMissionPeriodRetrieve<TData = Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: MissionPeriodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMissionPeriodRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type missionPeriodResponseUpdateResponse200 = {
  data: PeriodTask
  status: 200
}

export type missionPeriodResponseUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionPeriodResponseUpdateResponse409 = {
  data: PeriodClosedError
  status: 409
}

export type missionPeriodResponseUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionPeriodResponseUpdateResponseSuccess = (missionPeriodResponseUpdateResponse200) & {
  headers: Headers;
};
export type missionPeriodResponseUpdateResponseError = (missionPeriodResponseUpdateResponse401 | missionPeriodResponseUpdateResponse409 | missionPeriodResponseUpdateResponse410) & {
  headers: Headers;
};

export type missionPeriodResponseUpdateResponse = (missionPeriodResponseUpdateResponseSuccess | missionPeriodResponseUpdateResponseError)

export const getMissionPeriodResponseUpdateUrl = (assignmentUid: string,) => {




  return `/api/v1/missions/period/tasks/${assignmentUid}/response/`
}

export const missionPeriodResponseUpdate = async (assignmentUid: string,
    periodResponseWriteRequest: PeriodResponseWriteRequest, options?: RequestInit): Promise<missionPeriodResponseUpdateResponse> => {

  return customFetch<missionPeriodResponseUpdateResponse>(getMissionPeriodResponseUpdateUrl(assignmentUid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(periodResponseWriteRequest)
  }
);}




export const getMissionPeriodResponseUpdateMutationOptions = <TError = UnauthorizedResponse | PeriodClosedError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionPeriodResponseUpdate>>, TError,{assignmentUid: string;data: PeriodResponseWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof missionPeriodResponseUpdate>>, TError,{assignmentUid: string;data: PeriodResponseWriteRequest}, TContext> => {

const mutationKey = ['missionPeriodResponseUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof missionPeriodResponseUpdate>>, {assignmentUid: string;data: PeriodResponseWriteRequest}> = (props) => {
          const {assignmentUid,data} = props ?? {};

          return  missionPeriodResponseUpdate(assignmentUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MissionPeriodResponseUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof missionPeriodResponseUpdate>>>
    export type MissionPeriodResponseUpdateMutationBody = PeriodResponseWriteRequest
    export type MissionPeriodResponseUpdateMutationError = UnauthorizedResponse | PeriodClosedError | AccountGoneResponse

    export const useMissionPeriodResponseUpdate = <TError = UnauthorizedResponse | PeriodClosedError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof missionPeriodResponseUpdate>>, TError,{assignmentUid: string;data: PeriodResponseWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof missionPeriodResponseUpdate>>,
        TError,
        {assignmentUid: string;data: PeriodResponseWriteRequest},
        TContext
      > => {
      return useMutation(getMissionPeriodResponseUpdateMutationOptions(options), queryClient);
    }

export type missionsTodayResponse200 = {
  data: MissionDay
  status: 200
}

export type missionsTodayResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type missionsTodayResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type missionsTodayResponseSuccess = (missionsTodayResponse200) & {
  headers: Headers;
};
export type missionsTodayResponseError = (missionsTodayResponse401 | missionsTodayResponse410) & {
  headers: Headers;
};

export type missionsTodayResponse = (missionsTodayResponseSuccess | missionsTodayResponseError)

export const getMissionsTodayUrl = () => {




  return `/api/v1/missions/today/`
}

/**
 * `GET /api/v1/missions/today/` — the day set, materialized on first read.
 * @summary Misje dnia (uczeń)
 */
export const missionsToday = async ( options?: RequestInit): Promise<missionsTodayResponse> => {

  return customFetch<missionsTodayResponse>(getMissionsTodayUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMissionsTodayQueryKey = () => {
    return [
    `/api/v1/missions/today/`
    ] as const;
    }


export const getMissionsTodayQueryOptions = <TData = Awaited<ReturnType<typeof missionsToday>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionsToday>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMissionsTodayQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof missionsToday>>> = ({ signal }) => missionsToday({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof missionsToday>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MissionsTodayQueryResult = NonNullable<Awaited<ReturnType<typeof missionsToday>>>
export type MissionsTodayQueryError = UnauthorizedResponse | AccountGoneResponse


export function useMissionsToday<TData = Awaited<ReturnType<typeof missionsToday>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionsToday>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof missionsToday>>,
          TError,
          Awaited<ReturnType<typeof missionsToday>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMissionsToday<TData = Awaited<ReturnType<typeof missionsToday>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionsToday>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof missionsToday>>,
          TError,
          Awaited<ReturnType<typeof missionsToday>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMissionsToday<TData = Awaited<ReturnType<typeof missionsToday>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionsToday>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Misje dnia (uczeń)
 */

export function useMissionsToday<TData = Awaited<ReturnType<typeof missionsToday>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof missionsToday>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMissionsTodayQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type modulesCatalogListResponse200 = {
  data: ModuleCatalogItem[]
  status: 200
}

export type modulesCatalogListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesCatalogListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesCatalogListResponseSuccess = (modulesCatalogListResponse200) & {
  headers: Headers;
};
export type modulesCatalogListResponseError = (modulesCatalogListResponse401 | modulesCatalogListResponse410) & {
  headers: Headers;
};

export type modulesCatalogListResponse = (modulesCatalogListResponseSuccess | modulesCatalogListResponseError)

export const getModulesCatalogListUrl = () => {




  return `/api/v1/modules/catalog/`
}

/**
 * The module catalogue: labels, toggleability, always-on rules (TR-1200).
 */
export const modulesCatalogList = async ( options?: RequestInit): Promise<modulesCatalogListResponse> => {

  return customFetch<modulesCatalogListResponse>(getModulesCatalogListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getModulesCatalogListQueryKey = () => {
    return [
    `/api/v1/modules/catalog/`
    ] as const;
    }


export const getModulesCatalogListQueryOptions = <TData = Awaited<ReturnType<typeof modulesCatalogList>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesCatalogList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModulesCatalogListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modulesCatalogList>>> = ({ signal }) => modulesCatalogList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modulesCatalogList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ModulesCatalogListQueryResult = NonNullable<Awaited<ReturnType<typeof modulesCatalogList>>>
export type ModulesCatalogListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useModulesCatalogList<TData = Awaited<ReturnType<typeof modulesCatalogList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesCatalogList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesCatalogList>>,
          TError,
          Awaited<ReturnType<typeof modulesCatalogList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesCatalogList<TData = Awaited<ReturnType<typeof modulesCatalogList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesCatalogList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesCatalogList>>,
          TError,
          Awaited<ReturnType<typeof modulesCatalogList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesCatalogList<TData = Awaited<ReturnType<typeof modulesCatalogList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesCatalogList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useModulesCatalogList<TData = Awaited<ReturnType<typeof modulesCatalogList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesCatalogList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModulesCatalogListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type modulesConfigAuditListResponse200 = {
  data: PaginatedModuleAuditEntryList
  status: 200
}

export type modulesConfigAuditListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigAuditListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigAuditListResponseSuccess = (modulesConfigAuditListResponse200) & {
  headers: Headers;
};
export type modulesConfigAuditListResponseError = (modulesConfigAuditListResponse401 | modulesConfigAuditListResponse410) & {
  headers: Headers;
};

export type modulesConfigAuditListResponse = (modulesConfigAuditListResponseSuccess | modulesConfigAuditListResponseError)

export const getModulesConfigAuditListUrl = (params?: ModulesConfigAuditListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/modules/config/audit/?${stringifiedParams}` : `/api/v1/modules/config/audit/`
}

/**
 * Module-configuration audit trail (TR-1200 R11/R12), newest first. Actor is resolved at presentation; target_label is the write-time snapshot.
 */
export const modulesConfigAuditList = async (params?: ModulesConfigAuditListParams, options?: RequestInit): Promise<modulesConfigAuditListResponse> => {

  return customFetch<modulesConfigAuditListResponse>(getModulesConfigAuditListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getModulesConfigAuditListQueryKey = (params?: ModulesConfigAuditListParams,) => {
    return [
    `/api/v1/modules/config/audit/`, ...(params ? [params] : [])
    ] as const;
    }


export const getModulesConfigAuditListQueryOptions = <TData = Awaited<ReturnType<typeof modulesConfigAuditList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: ModulesConfigAuditListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigAuditList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModulesConfigAuditListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modulesConfigAuditList>>> = ({ signal }) => modulesConfigAuditList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modulesConfigAuditList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ModulesConfigAuditListQueryResult = NonNullable<Awaited<ReturnType<typeof modulesConfigAuditList>>>
export type ModulesConfigAuditListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useModulesConfigAuditList<TData = Awaited<ReturnType<typeof modulesConfigAuditList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  ModulesConfigAuditListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigAuditList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigAuditList>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigAuditList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigAuditList<TData = Awaited<ReturnType<typeof modulesConfigAuditList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ModulesConfigAuditListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigAuditList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigAuditList>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigAuditList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigAuditList<TData = Awaited<ReturnType<typeof modulesConfigAuditList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ModulesConfigAuditListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigAuditList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useModulesConfigAuditList<TData = Awaited<ReturnType<typeof modulesConfigAuditList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ModulesConfigAuditListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigAuditList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModulesConfigAuditListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type modulesConfigClassRetrieveResponse200 = {
  data: ModuleLevelConfig
  status: 200
}

export type modulesConfigClassRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigClassRetrieveResponse404 = {
  data: void
  status: 404
}

export type modulesConfigClassRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigClassRetrieveResponseSuccess = (modulesConfigClassRetrieveResponse200) & {
  headers: Headers;
};
export type modulesConfigClassRetrieveResponseError = (modulesConfigClassRetrieveResponse401 | modulesConfigClassRetrieveResponse404 | modulesConfigClassRetrieveResponse410) & {
  headers: Headers;
};

export type modulesConfigClassRetrieveResponse = (modulesConfigClassRetrieveResponseSuccess | modulesConfigClassRetrieveResponseError)

export const getModulesConfigClassRetrieveUrl = (classId: number,) => {




  return `/api/v1/modules/config/classes/${classId}/`
}

/**
 * Class-level config with the R13 has_student_overrides signal.
 */
export const modulesConfigClassRetrieve = async (classId: number, options?: RequestInit): Promise<modulesConfigClassRetrieveResponse> => {

  return customFetch<modulesConfigClassRetrieveResponse>(getModulesConfigClassRetrieveUrl(classId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getModulesConfigClassRetrieveQueryKey = (classId: number,) => {
    return [
    `/api/v1/modules/config/classes/${classId}/`
    ] as const;
    }


export const getModulesConfigClassRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModulesConfigClassRetrieveQueryKey(classId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modulesConfigClassRetrieve>>> = ({ signal }) => modulesConfigClassRetrieve(classId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: classId !== null && classId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ModulesConfigClassRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof modulesConfigClassRetrieve>>>
export type ModulesConfigClassRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useModulesConfigClassRetrieve<TData = Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 classId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigClassRetrieve>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigClassRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigClassRetrieve<TData = Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigClassRetrieve>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigClassRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigClassRetrieve<TData = Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useModulesConfigClassRetrieve<TData = Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModulesConfigClassRetrieveQueryOptions(classId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type modulesConfigClassSetResponse200 = {
  data: ModuleLevelConfig
  status: 200
}

export type modulesConfigClassSetResponse400 = {
  data: void
  status: 400
}

export type modulesConfigClassSetResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigClassSetResponse404 = {
  data: void
  status: 404
}

export type modulesConfigClassSetResponse409 = {
  data: void
  status: 409
}

export type modulesConfigClassSetResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigClassSetResponseSuccess = (modulesConfigClassSetResponse200) & {
  headers: Headers;
};
export type modulesConfigClassSetResponseError = (modulesConfigClassSetResponse400 | modulesConfigClassSetResponse401 | modulesConfigClassSetResponse404 | modulesConfigClassSetResponse409 | modulesConfigClassSetResponse410) & {
  headers: Headers;
};

export type modulesConfigClassSetResponse = (modulesConfigClassSetResponseSuccess | modulesConfigClassSetResponseError)

export const getModulesConfigClassSetUrl = (classId: number,
    module: string,) => {




  return `/api/v1/modules/config/classes/${classId}/${module}/`
}

export const modulesConfigClassSet = async (classId: number,
    module: string,
    moduleOverrideWriteRequest: ModuleOverrideWriteRequest, options?: RequestInit): Promise<modulesConfigClassSetResponse> => {

  return customFetch<modulesConfigClassSetResponse>(getModulesConfigClassSetUrl(classId,module),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(moduleOverrideWriteRequest)
  }
);}




export const getModulesConfigClassSetMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigClassSet>>, TError,{classId: number;module: string;data: ModuleOverrideWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof modulesConfigClassSet>>, TError,{classId: number;module: string;data: ModuleOverrideWriteRequest}, TContext> => {

const mutationKey = ['modulesConfigClassSet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modulesConfigClassSet>>, {classId: number;module: string;data: ModuleOverrideWriteRequest}> = (props) => {
          const {classId,module,data} = props ?? {};

          return  modulesConfigClassSet(classId,module,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModulesConfigClassSetMutationResult = NonNullable<Awaited<ReturnType<typeof modulesConfigClassSet>>>
    export type ModulesConfigClassSetMutationBody = ModuleOverrideWriteRequest
    export type ModulesConfigClassSetMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useModulesConfigClassSet = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigClassSet>>, TError,{classId: number;module: string;data: ModuleOverrideWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modulesConfigClassSet>>,
        TError,
        {classId: number;module: string;data: ModuleOverrideWriteRequest},
        TContext
      > => {
      return useMutation(getModulesConfigClassSetMutationOptions(options), queryClient);
    }

export type modulesConfigClassUnsetResponse200 = {
  data: ModuleLevelConfig
  status: 200
}

export type modulesConfigClassUnsetResponse400 = {
  data: void
  status: 400
}

export type modulesConfigClassUnsetResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigClassUnsetResponse404 = {
  data: void
  status: 404
}

export type modulesConfigClassUnsetResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigClassUnsetResponseSuccess = (modulesConfigClassUnsetResponse200) & {
  headers: Headers;
};
export type modulesConfigClassUnsetResponseError = (modulesConfigClassUnsetResponse400 | modulesConfigClassUnsetResponse401 | modulesConfigClassUnsetResponse404 | modulesConfigClassUnsetResponse410) & {
  headers: Headers;
};

export type modulesConfigClassUnsetResponse = (modulesConfigClassUnsetResponseSuccess | modulesConfigClassUnsetResponseError)

export const getModulesConfigClassUnsetUrl = (classId: number,
    module: string,) => {




  return `/api/v1/modules/config/classes/${classId}/${module}/`
}

export const modulesConfigClassUnset = async (classId: number,
    module: string, options?: RequestInit): Promise<modulesConfigClassUnsetResponse> => {

  return customFetch<modulesConfigClassUnsetResponse>(getModulesConfigClassUnsetUrl(classId,module),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getModulesConfigClassUnsetMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigClassUnset>>, TError,{classId: number;module: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof modulesConfigClassUnset>>, TError,{classId: number;module: string}, TContext> => {

const mutationKey = ['modulesConfigClassUnset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modulesConfigClassUnset>>, {classId: number;module: string}> = (props) => {
          const {classId,module} = props ?? {};

          return  modulesConfigClassUnset(classId,module,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModulesConfigClassUnsetMutationResult = NonNullable<Awaited<ReturnType<typeof modulesConfigClassUnset>>>

    export type ModulesConfigClassUnsetMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useModulesConfigClassUnset = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigClassUnset>>, TError,{classId: number;module: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modulesConfigClassUnset>>,
        TError,
        {classId: number;module: string},
        TContext
      > => {
      return useMutation(getModulesConfigClassUnsetMutationOptions(options), queryClient);
    }

export type modulesConfigClassStudentsListResponse200 = {
  data: StudentModulesRow[]
  status: 200
}

export type modulesConfigClassStudentsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigClassStudentsListResponse404 = {
  data: void
  status: 404
}

export type modulesConfigClassStudentsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigClassStudentsListResponseSuccess = (modulesConfigClassStudentsListResponse200) & {
  headers: Headers;
};
export type modulesConfigClassStudentsListResponseError = (modulesConfigClassStudentsListResponse401 | modulesConfigClassStudentsListResponse404 | modulesConfigClassStudentsListResponse410) & {
  headers: Headers;
};

export type modulesConfigClassStudentsListResponse = (modulesConfigClassStudentsListResponseSuccess | modulesConfigClassStudentsListResponseError)

export const getModulesConfigClassStudentsListUrl = (classId: number,) => {




  return `/api/v1/modules/config/classes/${classId}/students/`
}

/**
 * Bulk-resolved roster: per-student effective state, provenance, override and divergence-from-class detail (clarified R13). Constant query count.
 */
export const modulesConfigClassStudentsList = async (classId: number, options?: RequestInit): Promise<modulesConfigClassStudentsListResponse> => {

  return customFetch<modulesConfigClassStudentsListResponse>(getModulesConfigClassStudentsListUrl(classId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getModulesConfigClassStudentsListQueryKey = (classId: number,) => {
    return [
    `/api/v1/modules/config/classes/${classId}/students/`
    ] as const;
    }


export const getModulesConfigClassStudentsListQueryOptions = <TData = Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModulesConfigClassStudentsListQueryKey(classId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modulesConfigClassStudentsList>>> = ({ signal }) => modulesConfigClassStudentsList(classId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: classId !== null && classId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ModulesConfigClassStudentsListQueryResult = NonNullable<Awaited<ReturnType<typeof modulesConfigClassStudentsList>>>
export type ModulesConfigClassStudentsListQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useModulesConfigClassStudentsList<TData = Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 classId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigClassStudentsList>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigClassStudentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigClassStudentsList<TData = Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigClassStudentsList>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigClassStudentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigClassStudentsList<TData = Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useModulesConfigClassStudentsList<TData = Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigClassStudentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModulesConfigClassStudentsListQueryOptions(classId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type modulesConfigGlobalRetrieveResponse200 = {
  data: ModuleLevelConfig
  status: 200
}

export type modulesConfigGlobalRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigGlobalRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigGlobalRetrieveResponseSuccess = (modulesConfigGlobalRetrieveResponse200) & {
  headers: Headers;
};
export type modulesConfigGlobalRetrieveResponseError = (modulesConfigGlobalRetrieveResponse401 | modulesConfigGlobalRetrieveResponse410) & {
  headers: Headers;
};

export type modulesConfigGlobalRetrieveResponse = (modulesConfigGlobalRetrieveResponseSuccess | modulesConfigGlobalRetrieveResponseError)

export const getModulesConfigGlobalRetrieveUrl = (params?: ModulesConfigGlobalRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/modules/config/global/?${stringifiedParams}` : `/api/v1/modules/config/global/`
}

/**
 * Global-level config for one audience tree, with per-level override counts.
 */
export const modulesConfigGlobalRetrieve = async (params?: ModulesConfigGlobalRetrieveParams, options?: RequestInit): Promise<modulesConfigGlobalRetrieveResponse> => {

  return customFetch<modulesConfigGlobalRetrieveResponse>(getModulesConfigGlobalRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getModulesConfigGlobalRetrieveQueryKey = (params?: ModulesConfigGlobalRetrieveParams,) => {
    return [
    `/api/v1/modules/config/global/`, ...(params ? [params] : [])
    ] as const;
    }


export const getModulesConfigGlobalRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: ModulesConfigGlobalRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModulesConfigGlobalRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>> = ({ signal }) => modulesConfigGlobalRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ModulesConfigGlobalRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>>
export type ModulesConfigGlobalRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useModulesConfigGlobalRetrieve<TData = Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  ModulesConfigGlobalRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigGlobalRetrieve<TData = Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ModulesConfigGlobalRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigGlobalRetrieve<TData = Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ModulesConfigGlobalRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useModulesConfigGlobalRetrieve<TData = Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: ModulesConfigGlobalRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigGlobalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModulesConfigGlobalRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type modulesConfigGlobalSetResponse200 = {
  data: ModuleLevelConfig
  status: 200
}

export type modulesConfigGlobalSetResponse400 = {
  data: void
  status: 400
}

export type modulesConfigGlobalSetResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigGlobalSetResponse404 = {
  data: void
  status: 404
}

export type modulesConfigGlobalSetResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigGlobalSetResponseSuccess = (modulesConfigGlobalSetResponse200) & {
  headers: Headers;
};
export type modulesConfigGlobalSetResponseError = (modulesConfigGlobalSetResponse400 | modulesConfigGlobalSetResponse401 | modulesConfigGlobalSetResponse404 | modulesConfigGlobalSetResponse410) & {
  headers: Headers;
};

export type modulesConfigGlobalSetResponse = (modulesConfigGlobalSetResponseSuccess | modulesConfigGlobalSetResponseError)

export const getModulesConfigGlobalSetUrl = (module: string,
    params?: ModulesConfigGlobalSetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/modules/config/global/${module}/?${stringifiedParams}` : `/api/v1/modules/config/global/${module}/`
}

export const modulesConfigGlobalSet = async (module: string,
    moduleOverrideWriteRequest: ModuleOverrideWriteRequest,
    params?: ModulesConfigGlobalSetParams, options?: RequestInit): Promise<modulesConfigGlobalSetResponse> => {

  return customFetch<modulesConfigGlobalSetResponse>(getModulesConfigGlobalSetUrl(module,params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(moduleOverrideWriteRequest)
  }
);}




export const getModulesConfigGlobalSetMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigGlobalSet>>, TError,{module: string;data: ModuleOverrideWriteRequest;params?: ModulesConfigGlobalSetParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof modulesConfigGlobalSet>>, TError,{module: string;data: ModuleOverrideWriteRequest;params?: ModulesConfigGlobalSetParams}, TContext> => {

const mutationKey = ['modulesConfigGlobalSet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modulesConfigGlobalSet>>, {module: string;data: ModuleOverrideWriteRequest;params?: ModulesConfigGlobalSetParams}> = (props) => {
          const {module,data,params} = props ?? {};

          return  modulesConfigGlobalSet(module,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModulesConfigGlobalSetMutationResult = NonNullable<Awaited<ReturnType<typeof modulesConfigGlobalSet>>>
    export type ModulesConfigGlobalSetMutationBody = ModuleOverrideWriteRequest
    export type ModulesConfigGlobalSetMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useModulesConfigGlobalSet = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigGlobalSet>>, TError,{module: string;data: ModuleOverrideWriteRequest;params?: ModulesConfigGlobalSetParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modulesConfigGlobalSet>>,
        TError,
        {module: string;data: ModuleOverrideWriteRequest;params?: ModulesConfigGlobalSetParams},
        TContext
      > => {
      return useMutation(getModulesConfigGlobalSetMutationOptions(options), queryClient);
    }

export type modulesConfigGlobalUnsetResponse400 = {
  data: void
  status: 400
}

export type modulesConfigGlobalUnsetResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigGlobalUnsetResponse404 = {
  data: void
  status: 404
}

export type modulesConfigGlobalUnsetResponse409 = {
  data: void
  status: 409
}

export type modulesConfigGlobalUnsetResponse410 = {
  data: AccountGoneResponse
  status: 410
}

;
export type modulesConfigGlobalUnsetResponseError = (modulesConfigGlobalUnsetResponse400 | modulesConfigGlobalUnsetResponse401 | modulesConfigGlobalUnsetResponse404 | modulesConfigGlobalUnsetResponse409 | modulesConfigGlobalUnsetResponse410) & {
  headers: Headers;
};

export type modulesConfigGlobalUnsetResponse = (modulesConfigGlobalUnsetResponseError)

export const getModulesConfigGlobalUnsetUrl = (module: string,) => {




  return `/api/v1/modules/config/global/${module}/`
}

/**
 * Always 409 — the global level is UPDATE-only (R3).
 */
export const modulesConfigGlobalUnset = async (module: string, options?: RequestInit): Promise<modulesConfigGlobalUnsetResponse> => {

  return customFetch<modulesConfigGlobalUnsetResponse>(getModulesConfigGlobalUnsetUrl(module),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getModulesConfigGlobalUnsetMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigGlobalUnset>>, TError,{module: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof modulesConfigGlobalUnset>>, TError,{module: string}, TContext> => {

const mutationKey = ['modulesConfigGlobalUnset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modulesConfigGlobalUnset>>, {module: string}> = (props) => {
          const {module} = props ?? {};

          return  modulesConfigGlobalUnset(module,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModulesConfigGlobalUnsetMutationResult = NonNullable<Awaited<ReturnType<typeof modulesConfigGlobalUnset>>>

    export type ModulesConfigGlobalUnsetMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useModulesConfigGlobalUnset = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigGlobalUnset>>, TError,{module: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modulesConfigGlobalUnset>>,
        TError,
        {module: string},
        TContext
      > => {
      return useMutation(getModulesConfigGlobalUnsetMutationOptions(options), queryClient);
    }

export type modulesConfigSchoolRetrieveResponse200 = {
  data: ModuleLevelConfig
  status: 200
}

export type modulesConfigSchoolRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigSchoolRetrieveResponse404 = {
  data: void
  status: 404
}

export type modulesConfigSchoolRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigSchoolRetrieveResponseSuccess = (modulesConfigSchoolRetrieveResponse200) & {
  headers: Headers;
};
export type modulesConfigSchoolRetrieveResponseError = (modulesConfigSchoolRetrieveResponse401 | modulesConfigSchoolRetrieveResponse404 | modulesConfigSchoolRetrieveResponse410) & {
  headers: Headers;
};

export type modulesConfigSchoolRetrieveResponse = (modulesConfigSchoolRetrieveResponseSuccess | modulesConfigSchoolRetrieveResponseError)

export const getModulesConfigSchoolRetrieveUrl = (schoolId: number,) => {




  return `/api/v1/modules/config/schools/${schoolId}/`
}

/**
 * School-level config: effective state, provenance, subtree override counts.
 */
export const modulesConfigSchoolRetrieve = async (schoolId: number, options?: RequestInit): Promise<modulesConfigSchoolRetrieveResponse> => {

  return customFetch<modulesConfigSchoolRetrieveResponse>(getModulesConfigSchoolRetrieveUrl(schoolId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getModulesConfigSchoolRetrieveQueryKey = (schoolId: number,) => {
    return [
    `/api/v1/modules/config/schools/${schoolId}/`
    ] as const;
    }


export const getModulesConfigSchoolRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModulesConfigSchoolRetrieveQueryKey(schoolId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>> = ({ signal }) => modulesConfigSchoolRetrieve(schoolId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: schoolId !== null && schoolId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ModulesConfigSchoolRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>>
export type ModulesConfigSchoolRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useModulesConfigSchoolRetrieve<TData = Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 schoolId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigSchoolRetrieve<TData = Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigSchoolRetrieve<TData = Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useModulesConfigSchoolRetrieve<TData = Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModulesConfigSchoolRetrieveQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type modulesConfigSchoolSetResponse200 = {
  data: ModuleLevelConfig
  status: 200
}

export type modulesConfigSchoolSetResponse400 = {
  data: void
  status: 400
}

export type modulesConfigSchoolSetResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigSchoolSetResponse404 = {
  data: void
  status: 404
}

export type modulesConfigSchoolSetResponse409 = {
  data: void
  status: 409
}

export type modulesConfigSchoolSetResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigSchoolSetResponseSuccess = (modulesConfigSchoolSetResponse200) & {
  headers: Headers;
};
export type modulesConfigSchoolSetResponseError = (modulesConfigSchoolSetResponse400 | modulesConfigSchoolSetResponse401 | modulesConfigSchoolSetResponse404 | modulesConfigSchoolSetResponse409 | modulesConfigSchoolSetResponse410) & {
  headers: Headers;
};

export type modulesConfigSchoolSetResponse = (modulesConfigSchoolSetResponseSuccess | modulesConfigSchoolSetResponseError)

export const getModulesConfigSchoolSetUrl = (schoolId: number,
    module: string,) => {




  return `/api/v1/modules/config/schools/${schoolId}/${module}/`
}

export const modulesConfigSchoolSet = async (schoolId: number,
    module: string,
    moduleOverrideWriteRequest: ModuleOverrideWriteRequest, options?: RequestInit): Promise<modulesConfigSchoolSetResponse> => {

  return customFetch<modulesConfigSchoolSetResponse>(getModulesConfigSchoolSetUrl(schoolId,module),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(moduleOverrideWriteRequest)
  }
);}




export const getModulesConfigSchoolSetMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigSchoolSet>>, TError,{schoolId: number;module: string;data: ModuleOverrideWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof modulesConfigSchoolSet>>, TError,{schoolId: number;module: string;data: ModuleOverrideWriteRequest}, TContext> => {

const mutationKey = ['modulesConfigSchoolSet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modulesConfigSchoolSet>>, {schoolId: number;module: string;data: ModuleOverrideWriteRequest}> = (props) => {
          const {schoolId,module,data} = props ?? {};

          return  modulesConfigSchoolSet(schoolId,module,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModulesConfigSchoolSetMutationResult = NonNullable<Awaited<ReturnType<typeof modulesConfigSchoolSet>>>
    export type ModulesConfigSchoolSetMutationBody = ModuleOverrideWriteRequest
    export type ModulesConfigSchoolSetMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useModulesConfigSchoolSet = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigSchoolSet>>, TError,{schoolId: number;module: string;data: ModuleOverrideWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modulesConfigSchoolSet>>,
        TError,
        {schoolId: number;module: string;data: ModuleOverrideWriteRequest},
        TContext
      > => {
      return useMutation(getModulesConfigSchoolSetMutationOptions(options), queryClient);
    }

export type modulesConfigSchoolUnsetResponse200 = {
  data: ModuleLevelConfig
  status: 200
}

export type modulesConfigSchoolUnsetResponse400 = {
  data: void
  status: 400
}

export type modulesConfigSchoolUnsetResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigSchoolUnsetResponse404 = {
  data: void
  status: 404
}

export type modulesConfigSchoolUnsetResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigSchoolUnsetResponseSuccess = (modulesConfigSchoolUnsetResponse200) & {
  headers: Headers;
};
export type modulesConfigSchoolUnsetResponseError = (modulesConfigSchoolUnsetResponse400 | modulesConfigSchoolUnsetResponse401 | modulesConfigSchoolUnsetResponse404 | modulesConfigSchoolUnsetResponse410) & {
  headers: Headers;
};

export type modulesConfigSchoolUnsetResponse = (modulesConfigSchoolUnsetResponseSuccess | modulesConfigSchoolUnsetResponseError)

export const getModulesConfigSchoolUnsetUrl = (schoolId: number,
    module: string,) => {




  return `/api/v1/modules/config/schools/${schoolId}/${module}/`
}

export const modulesConfigSchoolUnset = async (schoolId: number,
    module: string, options?: RequestInit): Promise<modulesConfigSchoolUnsetResponse> => {

  return customFetch<modulesConfigSchoolUnsetResponse>(getModulesConfigSchoolUnsetUrl(schoolId,module),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getModulesConfigSchoolUnsetMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigSchoolUnset>>, TError,{schoolId: number;module: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof modulesConfigSchoolUnset>>, TError,{schoolId: number;module: string}, TContext> => {

const mutationKey = ['modulesConfigSchoolUnset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modulesConfigSchoolUnset>>, {schoolId: number;module: string}> = (props) => {
          const {schoolId,module} = props ?? {};

          return  modulesConfigSchoolUnset(schoolId,module,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModulesConfigSchoolUnsetMutationResult = NonNullable<Awaited<ReturnType<typeof modulesConfigSchoolUnset>>>

    export type ModulesConfigSchoolUnsetMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useModulesConfigSchoolUnset = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigSchoolUnset>>, TError,{schoolId: number;module: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modulesConfigSchoolUnset>>,
        TError,
        {schoolId: number;module: string},
        TContext
      > => {
      return useMutation(getModulesConfigSchoolUnsetMutationOptions(options), queryClient);
    }

export type modulesConfigSchoolClassesListResponse200 = {
  data: ClassModulesSummary[]
  status: 200
}

export type modulesConfigSchoolClassesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigSchoolClassesListResponse404 = {
  data: void
  status: 404
}

export type modulesConfigSchoolClassesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigSchoolClassesListResponseSuccess = (modulesConfigSchoolClassesListResponse200) & {
  headers: Headers;
};
export type modulesConfigSchoolClassesListResponseError = (modulesConfigSchoolClassesListResponse401 | modulesConfigSchoolClassesListResponse404 | modulesConfigSchoolClassesListResponse410) & {
  headers: Headers;
};

export type modulesConfigSchoolClassesListResponse = (modulesConfigSchoolClassesListResponseSuccess | modulesConfigSchoolClassesListResponseError)

export const getModulesConfigSchoolClassesListUrl = (schoolId: number,) => {




  return `/api/v1/modules/config/schools/${schoolId}/classes/`
}

/**
 * Per-class effective state for a school + the R13 existence flag.
 */
export const modulesConfigSchoolClassesList = async (schoolId: number, options?: RequestInit): Promise<modulesConfigSchoolClassesListResponse> => {

  return customFetch<modulesConfigSchoolClassesListResponse>(getModulesConfigSchoolClassesListUrl(schoolId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getModulesConfigSchoolClassesListQueryKey = (schoolId: number,) => {
    return [
    `/api/v1/modules/config/schools/${schoolId}/classes/`
    ] as const;
    }


export const getModulesConfigSchoolClassesListQueryOptions = <TData = Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModulesConfigSchoolClassesListQueryKey(schoolId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>> = ({ signal }) => modulesConfigSchoolClassesList(schoolId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: schoolId !== null && schoolId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ModulesConfigSchoolClassesListQueryResult = NonNullable<Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>>
export type ModulesConfigSchoolClassesListQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useModulesConfigSchoolClassesList<TData = Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 schoolId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigSchoolClassesList<TData = Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>,
          TError,
          Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useModulesConfigSchoolClassesList<TData = Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useModulesConfigSchoolClassesList<TData = Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modulesConfigSchoolClassesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModulesConfigSchoolClassesListQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type modulesConfigStudentSetResponse200 = {
  data: ModuleLevelConfig
  status: 200
}

export type modulesConfigStudentSetResponse400 = {
  data: void
  status: 400
}

export type modulesConfigStudentSetResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigStudentSetResponse404 = {
  data: void
  status: 404
}

export type modulesConfigStudentSetResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigStudentSetResponseSuccess = (modulesConfigStudentSetResponse200) & {
  headers: Headers;
};
export type modulesConfigStudentSetResponseError = (modulesConfigStudentSetResponse400 | modulesConfigStudentSetResponse401 | modulesConfigStudentSetResponse404 | modulesConfigStudentSetResponse410) & {
  headers: Headers;
};

export type modulesConfigStudentSetResponse = (modulesConfigStudentSetResponseSuccess | modulesConfigStudentSetResponseError)

export const getModulesConfigStudentSetUrl = (studentId: number,
    module: string,) => {




  return `/api/v1/modules/config/students/${studentId}/${module}/`
}

export const modulesConfigStudentSet = async (studentId: number,
    module: string,
    moduleOverrideWriteRequest: ModuleOverrideWriteRequest, options?: RequestInit): Promise<modulesConfigStudentSetResponse> => {

  return customFetch<modulesConfigStudentSetResponse>(getModulesConfigStudentSetUrl(studentId,module),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(moduleOverrideWriteRequest)
  }
);}




export const getModulesConfigStudentSetMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigStudentSet>>, TError,{studentId: number;module: string;data: ModuleOverrideWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof modulesConfigStudentSet>>, TError,{studentId: number;module: string;data: ModuleOverrideWriteRequest}, TContext> => {

const mutationKey = ['modulesConfigStudentSet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modulesConfigStudentSet>>, {studentId: number;module: string;data: ModuleOverrideWriteRequest}> = (props) => {
          const {studentId,module,data} = props ?? {};

          return  modulesConfigStudentSet(studentId,module,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModulesConfigStudentSetMutationResult = NonNullable<Awaited<ReturnType<typeof modulesConfigStudentSet>>>
    export type ModulesConfigStudentSetMutationBody = ModuleOverrideWriteRequest
    export type ModulesConfigStudentSetMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useModulesConfigStudentSet = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigStudentSet>>, TError,{studentId: number;module: string;data: ModuleOverrideWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modulesConfigStudentSet>>,
        TError,
        {studentId: number;module: string;data: ModuleOverrideWriteRequest},
        TContext
      > => {
      return useMutation(getModulesConfigStudentSetMutationOptions(options), queryClient);
    }

export type modulesConfigStudentUnsetResponse200 = {
  data: ModuleLevelConfig
  status: 200
}

export type modulesConfigStudentUnsetResponse400 = {
  data: void
  status: 400
}

export type modulesConfigStudentUnsetResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type modulesConfigStudentUnsetResponse404 = {
  data: void
  status: 404
}

export type modulesConfigStudentUnsetResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type modulesConfigStudentUnsetResponseSuccess = (modulesConfigStudentUnsetResponse200) & {
  headers: Headers;
};
export type modulesConfigStudentUnsetResponseError = (modulesConfigStudentUnsetResponse400 | modulesConfigStudentUnsetResponse401 | modulesConfigStudentUnsetResponse404 | modulesConfigStudentUnsetResponse410) & {
  headers: Headers;
};

export type modulesConfigStudentUnsetResponse = (modulesConfigStudentUnsetResponseSuccess | modulesConfigStudentUnsetResponseError)

export const getModulesConfigStudentUnsetUrl = (studentId: number,
    module: string,) => {




  return `/api/v1/modules/config/students/${studentId}/${module}/`
}

export const modulesConfigStudentUnset = async (studentId: number,
    module: string, options?: RequestInit): Promise<modulesConfigStudentUnsetResponse> => {

  return customFetch<modulesConfigStudentUnsetResponse>(getModulesConfigStudentUnsetUrl(studentId,module),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getModulesConfigStudentUnsetMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigStudentUnset>>, TError,{studentId: number;module: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof modulesConfigStudentUnset>>, TError,{studentId: number;module: string}, TContext> => {

const mutationKey = ['modulesConfigStudentUnset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modulesConfigStudentUnset>>, {studentId: number;module: string}> = (props) => {
          const {studentId,module} = props ?? {};

          return  modulesConfigStudentUnset(studentId,module,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModulesConfigStudentUnsetMutationResult = NonNullable<Awaited<ReturnType<typeof modulesConfigStudentUnset>>>

    export type ModulesConfigStudentUnsetMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useModulesConfigStudentUnset = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modulesConfigStudentUnset>>, TError,{studentId: number;module: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modulesConfigStudentUnset>>,
        TError,
        {studentId: number;module: string},
        TContext
      > => {
      return useMutation(getModulesConfigStudentUnsetMutationOptions(options), queryClient);
    }

export type v1MoodEntriesListResponse200 = {
  data: PaginatedMoodEntryPullList
  status: 200
}

export type v1MoodEntriesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1MoodEntriesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1MoodEntriesListResponseSuccess = (v1MoodEntriesListResponse200) & {
  headers: Headers;
};
export type v1MoodEntriesListResponseError = (v1MoodEntriesListResponse401 | v1MoodEntriesListResponse410) & {
  headers: Headers;
};

export type v1MoodEntriesListResponse = (v1MoodEntriesListResponseSuccess | v1MoodEntriesListResponseError)

export const getV1MoodEntriesListUrl = (params?: V1MoodEntriesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/mood/entries/?${stringifiedParams}` : `/api/v1/mood/entries/`
}

/**
 * Pull the account's mood check-in history on a fresh device (cloud restore).
 *
 * Owner scoping, the `updated_since` filter, tombstone retention, and the cursor
 * envelope are inherited from `SyncPullView`/`SyncCursorPagination`. Push
 * (create/update/delete) rides the shared `POST /api/v1/sync/operations/`.
 */
export const v1MoodEntriesList = async (params?: V1MoodEntriesListParams, options?: RequestInit): Promise<v1MoodEntriesListResponse> => {

  return customFetch<v1MoodEntriesListResponse>(getV1MoodEntriesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MoodEntriesListQueryKey = (params?: V1MoodEntriesListParams,) => {
    return [
    `/api/v1/mood/entries/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1MoodEntriesListQueryOptions = <TData = Awaited<ReturnType<typeof v1MoodEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1MoodEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MoodEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MoodEntriesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MoodEntriesList>>> = ({ signal }) => v1MoodEntriesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MoodEntriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MoodEntriesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MoodEntriesList>>>
export type V1MoodEntriesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1MoodEntriesList<TData = Awaited<ReturnType<typeof v1MoodEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1MoodEntriesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MoodEntriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MoodEntriesList>>,
          TError,
          Awaited<ReturnType<typeof v1MoodEntriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MoodEntriesList<TData = Awaited<ReturnType<typeof v1MoodEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1MoodEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MoodEntriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MoodEntriesList>>,
          TError,
          Awaited<ReturnType<typeof v1MoodEntriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MoodEntriesList<TData = Awaited<ReturnType<typeof v1MoodEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1MoodEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MoodEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1MoodEntriesList<TData = Awaited<ReturnType<typeof v1MoodEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1MoodEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MoodEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MoodEntriesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1NoIncomeDeclarationsListResponse200 = {
  data: PaginatedNoIncomeDeclarationPullList
  status: 200
}

export type v1NoIncomeDeclarationsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1NoIncomeDeclarationsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1NoIncomeDeclarationsListResponseSuccess = (v1NoIncomeDeclarationsListResponse200) & {
  headers: Headers;
};
export type v1NoIncomeDeclarationsListResponseError = (v1NoIncomeDeclarationsListResponse401 | v1NoIncomeDeclarationsListResponse410) & {
  headers: Headers;
};

export type v1NoIncomeDeclarationsListResponse = (v1NoIncomeDeclarationsListResponseSuccess | v1NoIncomeDeclarationsListResponseError)

export const getV1NoIncomeDeclarationsListUrl = (params?: V1NoIncomeDeclarationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/no-income/declarations/?${stringifiedParams}` : `/api/v1/no-income/declarations/`
}

/**
 * Pull historii deklaracji braku przychodów, lustro `NoSpendDeclarationPullView`.
 *
 * Tombstone'y (także wycofania przez żywy przychód dnia) wracają w pullu, żeby
 * urządzenie zdjęło deklarację lokalnie.
 */
export const v1NoIncomeDeclarationsList = async (params?: V1NoIncomeDeclarationsListParams, options?: RequestInit): Promise<v1NoIncomeDeclarationsListResponse> => {

  return customFetch<v1NoIncomeDeclarationsListResponse>(getV1NoIncomeDeclarationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1NoIncomeDeclarationsListQueryKey = (params?: V1NoIncomeDeclarationsListParams,) => {
    return [
    `/api/v1/no-income/declarations/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1NoIncomeDeclarationsListQueryOptions = <TData = Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1NoIncomeDeclarationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1NoIncomeDeclarationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>> = ({ signal }) => v1NoIncomeDeclarationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1NoIncomeDeclarationsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>>
export type V1NoIncomeDeclarationsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1NoIncomeDeclarationsList<TData = Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1NoIncomeDeclarationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>,
          TError,
          Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1NoIncomeDeclarationsList<TData = Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1NoIncomeDeclarationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>,
          TError,
          Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1NoIncomeDeclarationsList<TData = Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1NoIncomeDeclarationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1NoIncomeDeclarationsList<TData = Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1NoIncomeDeclarationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1NoIncomeDeclarationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1NoIncomeDeclarationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1NoSpendDeclarationsListResponse200 = {
  data: PaginatedNoSpendDeclarationPullList
  status: 200
}

export type v1NoSpendDeclarationsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1NoSpendDeclarationsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1NoSpendDeclarationsListResponseSuccess = (v1NoSpendDeclarationsListResponse200) & {
  headers: Headers;
};
export type v1NoSpendDeclarationsListResponseError = (v1NoSpendDeclarationsListResponse401 | v1NoSpendDeclarationsListResponse410) & {
  headers: Headers;
};

export type v1NoSpendDeclarationsListResponse = (v1NoSpendDeclarationsListResponseSuccess | v1NoSpendDeclarationsListResponseError)

export const getV1NoSpendDeclarationsListUrl = (params?: V1NoSpendDeclarationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/no-spend/declarations/?${stringifiedParams}` : `/api/v1/no-spend/declarations/`
}

/**
 * Pull historii deklaracji na świeżym urządzeniu (odtworzenie z chmury).
 *
 * Zakres właściciela, filtr `updated_since`, retencja tombstone'ów i koperta
 * kursora są dziedziczone z `SyncPullView`. Push jedzie wspólnym
 * `POST /api/v1/sync/operations/`.
 */
export const v1NoSpendDeclarationsList = async (params?: V1NoSpendDeclarationsListParams, options?: RequestInit): Promise<v1NoSpendDeclarationsListResponse> => {

  return customFetch<v1NoSpendDeclarationsListResponse>(getV1NoSpendDeclarationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1NoSpendDeclarationsListQueryKey = (params?: V1NoSpendDeclarationsListParams,) => {
    return [
    `/api/v1/no-spend/declarations/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1NoSpendDeclarationsListQueryOptions = <TData = Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1NoSpendDeclarationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1NoSpendDeclarationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>> = ({ signal }) => v1NoSpendDeclarationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1NoSpendDeclarationsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>>
export type V1NoSpendDeclarationsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1NoSpendDeclarationsList<TData = Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1NoSpendDeclarationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>,
          TError,
          Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1NoSpendDeclarationsList<TData = Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1NoSpendDeclarationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>,
          TError,
          Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1NoSpendDeclarationsList<TData = Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1NoSpendDeclarationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1NoSpendDeclarationsList<TData = Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1NoSpendDeclarationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1NoSpendDeclarationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1NoSpendDeclarationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1PlansFinancialListResponse200 = {
  data: PaginatedStudentFinancialPlanPullList
  status: 200
}

export type v1PlansFinancialListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PlansFinancialListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PlansFinancialListResponseSuccess = (v1PlansFinancialListResponse200) & {
  headers: Headers;
};
export type v1PlansFinancialListResponseError = (v1PlansFinancialListResponse401 | v1PlansFinancialListResponse410) & {
  headers: Headers;
};

export type v1PlansFinancialListResponse = (v1PlansFinancialListResponseSuccess | v1PlansFinancialListResponseError)

export const getV1PlansFinancialListUrl = (params?: V1PlansFinancialListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/plans/financial/?${stringifiedParams}` : `/api/v1/plans/financial/`
}

/**
 * Base GET view for pulling a syncable entity to a fresh device.
 *
 * Subclasses set `queryset`/`model` + `serializer_class`. Owner scoping and the
 * `updated_since` filter are applied here; tombstones are intentionally retained.
 */
export const v1PlansFinancialList = async (params?: V1PlansFinancialListParams, options?: RequestInit): Promise<v1PlansFinancialListResponse> => {

  return customFetch<v1PlansFinancialListResponse>(getV1PlansFinancialListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1PlansFinancialListQueryKey = (params?: V1PlansFinancialListParams,) => {
    return [
    `/api/v1/plans/financial/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1PlansFinancialListQueryOptions = <TData = Awaited<ReturnType<typeof v1PlansFinancialList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1PlansFinancialListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlansFinancialList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlansFinancialListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlansFinancialList>>> = ({ signal }) => v1PlansFinancialList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlansFinancialList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1PlansFinancialListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlansFinancialList>>>
export type V1PlansFinancialListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1PlansFinancialList<TData = Awaited<ReturnType<typeof v1PlansFinancialList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1PlansFinancialListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlansFinancialList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlansFinancialList>>,
          TError,
          Awaited<ReturnType<typeof v1PlansFinancialList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PlansFinancialList<TData = Awaited<ReturnType<typeof v1PlansFinancialList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1PlansFinancialListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlansFinancialList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlansFinancialList>>,
          TError,
          Awaited<ReturnType<typeof v1PlansFinancialList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PlansFinancialList<TData = Awaited<ReturnType<typeof v1PlansFinancialList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1PlansFinancialListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlansFinancialList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1PlansFinancialList<TData = Awaited<ReturnType<typeof v1PlansFinancialList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1PlansFinancialListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlansFinancialList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1PlansFinancialListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type pollsStudentDiscoveryResponse200 = {
  data: PollDiscovery
  status: 200
}

export type pollsStudentDiscoveryResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type pollsStudentDiscoveryResponse403 = {
  data: PollError
  status: 403
}

export type pollsStudentDiscoveryResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type pollsStudentDiscoveryResponse422 = {
  data: PollError
  status: 422
}

export type pollsStudentDiscoveryResponseSuccess = (pollsStudentDiscoveryResponse200) & {
  headers: Headers;
};
export type pollsStudentDiscoveryResponseError = (pollsStudentDiscoveryResponse401 | pollsStudentDiscoveryResponse403 | pollsStudentDiscoveryResponse410 | pollsStudentDiscoveryResponse422) & {
  headers: Headers;
};

export type pollsStudentDiscoveryResponse = (pollsStudentDiscoveryResponseSuccess | pollsStudentDiscoveryResponseError)

export const getPollsStudentDiscoveryUrl = () => {




  return `/api/v1/polls/`
}

export const pollsStudentDiscovery = async ( options?: RequestInit): Promise<pollsStudentDiscoveryResponse> => {

  return customFetch<pollsStudentDiscoveryResponse>(getPollsStudentDiscoveryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPollsStudentDiscoveryQueryKey = () => {
    return [
    `/api/v1/polls/`
    ] as const;
    }


export const getPollsStudentDiscoveryQueryOptions = <TData = Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPollsStudentDiscoveryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pollsStudentDiscovery>>> = ({ signal }) => pollsStudentDiscovery({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PollsStudentDiscoveryQueryResult = NonNullable<Awaited<ReturnType<typeof pollsStudentDiscovery>>>
export type PollsStudentDiscoveryQueryError = UnauthorizedResponse | PollError | AccountGoneResponse


export function usePollsStudentDiscovery<TData = Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollsStudentDiscovery>>,
          TError,
          Awaited<ReturnType<typeof pollsStudentDiscovery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollsStudentDiscovery<TData = Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollsStudentDiscovery>>,
          TError,
          Awaited<ReturnType<typeof pollsStudentDiscovery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollsStudentDiscovery<TData = Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePollsStudentDiscovery<TData = Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDiscovery>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPollsStudentDiscoveryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type pollsStudentDetailResponse200 = {
  data: StudentPoll
  status: 200
}

export type pollsStudentDetailResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type pollsStudentDetailResponse403 = {
  data: PollError
  status: 403
}

export type pollsStudentDetailResponse404 = {
  data: PollError
  status: 404
}

export type pollsStudentDetailResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type pollsStudentDetailResponse422 = {
  data: PollError
  status: 422
}

export type pollsStudentDetailResponseSuccess = (pollsStudentDetailResponse200) & {
  headers: Headers;
};
export type pollsStudentDetailResponseError = (pollsStudentDetailResponse401 | pollsStudentDetailResponse403 | pollsStudentDetailResponse404 | pollsStudentDetailResponse410 | pollsStudentDetailResponse422) & {
  headers: Headers;
};

export type pollsStudentDetailResponse = (pollsStudentDetailResponseSuccess | pollsStudentDetailResponseError)

export const getPollsStudentDetailUrl = (pollId: string,) => {




  return `/api/v1/polls/${pollId}/`
}

export const pollsStudentDetail = async (pollId: string, options?: RequestInit): Promise<pollsStudentDetailResponse> => {

  return customFetch<pollsStudentDetailResponse>(getPollsStudentDetailUrl(pollId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPollsStudentDetailQueryKey = (pollId: string,) => {
    return [
    `/api/v1/polls/${pollId}/`
    ] as const;
    }


export const getPollsStudentDetailQueryOptions = <TData = Awaited<ReturnType<typeof pollsStudentDetail>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(pollId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPollsStudentDetailQueryKey(pollId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pollsStudentDetail>>> = ({ signal }) => pollsStudentDetail(pollId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pollId !== null && pollId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PollsStudentDetailQueryResult = NonNullable<Awaited<ReturnType<typeof pollsStudentDetail>>>
export type PollsStudentDetailQueryError = UnauthorizedResponse | PollError | AccountGoneResponse


export function usePollsStudentDetail<TData = Awaited<ReturnType<typeof pollsStudentDetail>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 pollId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollsStudentDetail>>,
          TError,
          Awaited<ReturnType<typeof pollsStudentDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollsStudentDetail<TData = Awaited<ReturnType<typeof pollsStudentDetail>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 pollId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollsStudentDetail>>,
          TError,
          Awaited<ReturnType<typeof pollsStudentDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollsStudentDetail<TData = Awaited<ReturnType<typeof pollsStudentDetail>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 pollId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePollsStudentDetail<TData = Awaited<ReturnType<typeof pollsStudentDetail>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 pollId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollsStudentDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPollsStudentDetailQueryOptions(pollId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1PollsSessionsCreateResponse200 = {
  data: PollSession
  status: 200
}

export type v1PollsSessionsCreateResponse201 = {
  data: PollSession
  status: 201
}

export type v1PollsSessionsCreateResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsSessionsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsSessionsCreateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsSessionsCreateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsSessionsCreateResponse409 = {
  data: PollError
  status: 409
}

export type v1PollsSessionsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsSessionsCreateResponse422 = {
  data: PollError
  status: 422
}

export type v1PollsSessionsCreateResponseSuccess = (v1PollsSessionsCreateResponse200 | v1PollsSessionsCreateResponse201) & {
  headers: Headers;
};
export type v1PollsSessionsCreateResponseError = (v1PollsSessionsCreateResponse400 | v1PollsSessionsCreateResponse401 | v1PollsSessionsCreateResponse403 | v1PollsSessionsCreateResponse404 | v1PollsSessionsCreateResponse409 | v1PollsSessionsCreateResponse410 | v1PollsSessionsCreateResponse422) & {
  headers: Headers;
};

export type v1PollsSessionsCreateResponse = (v1PollsSessionsCreateResponseSuccess | v1PollsSessionsCreateResponseError)

export const getV1PollsSessionsCreateUrl = (pollId: string,) => {




  return `/api/v1/polls/${pollId}/sessions/`
}

export const v1PollsSessionsCreate = async (pollId: string, options?: RequestInit): Promise<v1PollsSessionsCreateResponse> => {

  return customFetch<v1PollsSessionsCreateResponse>(getV1PollsSessionsCreateUrl(pollId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1PollsSessionsCreateMutationOptions = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsSessionsCreate>>, TError,{pollId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsSessionsCreate>>, TError,{pollId: string}, TContext> => {

const mutationKey = ['v1PollsSessionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsSessionsCreate>>, {pollId: string}> = (props) => {
          const {pollId} = props ?? {};

          return  v1PollsSessionsCreate(pollId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsSessionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsSessionsCreate>>>

    export type V1PollsSessionsCreateMutationError = PollError | UnauthorizedResponse | AccountGoneResponse

    export const useV1PollsSessionsCreate = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsSessionsCreate>>, TError,{pollId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsSessionsCreate>>,
        TError,
        {pollId: string},
        TContext
      > => {
      return useMutation(getV1PollsSessionsCreateMutationOptions(options), queryClient);
    }

export type v1PollsAdminCapabilitiesRetrieveResponse200 = {
  data: PollCapabilities
  status: 200
}

export type v1PollsAdminCapabilitiesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminCapabilitiesRetrieveResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminCapabilitiesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminCapabilitiesRetrieveResponseSuccess = (v1PollsAdminCapabilitiesRetrieveResponse200) & {
  headers: Headers;
};
export type v1PollsAdminCapabilitiesRetrieveResponseError = (v1PollsAdminCapabilitiesRetrieveResponse401 | v1PollsAdminCapabilitiesRetrieveResponse403 | v1PollsAdminCapabilitiesRetrieveResponse410) & {
  headers: Headers;
};

export type v1PollsAdminCapabilitiesRetrieveResponse = (v1PollsAdminCapabilitiesRetrieveResponseSuccess | v1PollsAdminCapabilitiesRetrieveResponseError)

export const getV1PollsAdminCapabilitiesRetrieveUrl = () => {




  return `/api/v1/polls/admin/capabilities/`
}

export const v1PollsAdminCapabilitiesRetrieve = async ( options?: RequestInit): Promise<v1PollsAdminCapabilitiesRetrieveResponse> => {

  return customFetch<v1PollsAdminCapabilitiesRetrieveResponse>(getV1PollsAdminCapabilitiesRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1PollsAdminCapabilitiesRetrieveQueryKey = () => {
    return [
    `/api/v1/polls/admin/capabilities/`
    ] as const;
    }


export const getV1PollsAdminCapabilitiesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PollsAdminCapabilitiesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>> = ({ signal }) => v1PollsAdminCapabilitiesRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1PollsAdminCapabilitiesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>>
export type V1PollsAdminCapabilitiesRetrieveQueryError = UnauthorizedResponse | PollError | AccountGoneResponse


export function useV1PollsAdminCapabilitiesRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsAdminCapabilitiesRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsAdminCapabilitiesRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1PollsAdminCapabilitiesRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminCapabilitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1PollsAdminCapabilitiesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1PollsAdminPollsListResponse200 = {
  data: PaginatedAdminPollList
  status: 200
}

export type v1PollsAdminPollsListResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsAdminPollsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsListResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsListResponseSuccess = (v1PollsAdminPollsListResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsListResponseError = (v1PollsAdminPollsListResponse400 | v1PollsAdminPollsListResponse401 | v1PollsAdminPollsListResponse403 | v1PollsAdminPollsListResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsListResponse = (v1PollsAdminPollsListResponseSuccess | v1PollsAdminPollsListResponseError)

export const getV1PollsAdminPollsListUrl = (params?: V1PollsAdminPollsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/polls/admin/polls/?${stringifiedParams}` : `/api/v1/polls/admin/polls/`
}

/**
 * @summary Lista neutralnych ankiet (operator)
 */
export const v1PollsAdminPollsList = async (params?: V1PollsAdminPollsListParams, options?: RequestInit): Promise<v1PollsAdminPollsListResponse> => {

  return customFetch<v1PollsAdminPollsListResponse>(getV1PollsAdminPollsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1PollsAdminPollsListQueryKey = (params?: V1PollsAdminPollsListParams,) => {
    return [
    `/api/v1/polls/admin/polls/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1PollsAdminPollsListQueryOptions = <TData = Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError = PollError | UnauthorizedResponse | AccountGoneResponse>(params?: V1PollsAdminPollsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PollsAdminPollsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PollsAdminPollsList>>> = ({ signal }) => v1PollsAdminPollsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1PollsAdminPollsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsList>>>
export type V1PollsAdminPollsListQueryError = PollError | UnauthorizedResponse | AccountGoneResponse


export function useV1PollsAdminPollsList<TData = Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError = PollError | UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1PollsAdminPollsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsAdminPollsList>>,
          TError,
          Awaited<ReturnType<typeof v1PollsAdminPollsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsAdminPollsList<TData = Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError = PollError | UnauthorizedResponse | AccountGoneResponse>(
 params?: V1PollsAdminPollsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsAdminPollsList>>,
          TError,
          Awaited<ReturnType<typeof v1PollsAdminPollsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsAdminPollsList<TData = Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError = PollError | UnauthorizedResponse | AccountGoneResponse>(
 params?: V1PollsAdminPollsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista neutralnych ankiet (operator)
 */

export function useV1PollsAdminPollsList<TData = Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError = PollError | UnauthorizedResponse | AccountGoneResponse>(
 params?: V1PollsAdminPollsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1PollsAdminPollsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1PollsAdminPollsCreateResponse201 = {
  data: AdminPoll
  status: 201
}

export type v1PollsAdminPollsCreateResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsAdminPollsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsCreateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsCreateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsCreateResponseSuccess = (v1PollsAdminPollsCreateResponse201) & {
  headers: Headers;
};
export type v1PollsAdminPollsCreateResponseError = (v1PollsAdminPollsCreateResponse400 | v1PollsAdminPollsCreateResponse401 | v1PollsAdminPollsCreateResponse403 | v1PollsAdminPollsCreateResponse404 | v1PollsAdminPollsCreateResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsCreateResponse = (v1PollsAdminPollsCreateResponseSuccess | v1PollsAdminPollsCreateResponseError)

export const getV1PollsAdminPollsCreateUrl = () => {




  return `/api/v1/polls/admin/polls/`
}

export const v1PollsAdminPollsCreate = async (adminPollWriteRequest: AdminPollWriteRequest, options?: RequestInit): Promise<v1PollsAdminPollsCreateResponse> => {

  return customFetch<v1PollsAdminPollsCreateResponse>(getV1PollsAdminPollsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminPollWriteRequest)
  }
);}




export const getV1PollsAdminPollsCreateMutationOptions = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsCreate>>, TError,{data: AdminPollWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsCreate>>, TError,{data: AdminPollWriteRequest}, TContext> => {

const mutationKey = ['v1PollsAdminPollsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsAdminPollsCreate>>, {data: AdminPollWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1PollsAdminPollsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsAdminPollsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsCreate>>>
    export type V1PollsAdminPollsCreateMutationBody = AdminPollWriteRequest
    export type V1PollsAdminPollsCreateMutationError = PollError | UnauthorizedResponse | AccountGoneResponse

    export const useV1PollsAdminPollsCreate = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsCreate>>, TError,{data: AdminPollWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsAdminPollsCreate>>,
        TError,
        {data: AdminPollWriteRequest},
        TContext
      > => {
      return useMutation(getV1PollsAdminPollsCreateMutationOptions(options), queryClient);
    }

export type v1PollsAdminPollsRetrieveResponse200 = {
  data: AdminPoll
  status: 200
}

export type v1PollsAdminPollsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsRetrieveResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsRetrieveResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsRetrieveResponseSuccess = (v1PollsAdminPollsRetrieveResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsRetrieveResponseError = (v1PollsAdminPollsRetrieveResponse401 | v1PollsAdminPollsRetrieveResponse403 | v1PollsAdminPollsRetrieveResponse404 | v1PollsAdminPollsRetrieveResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsRetrieveResponse = (v1PollsAdminPollsRetrieveResponseSuccess | v1PollsAdminPollsRetrieveResponseError)

export const getV1PollsAdminPollsRetrieveUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/`
}

/**
 * @summary Szczegóły neutralnej ankiety (operator)
 */
export const v1PollsAdminPollsRetrieve = async (id: string, options?: RequestInit): Promise<v1PollsAdminPollsRetrieveResponse> => {

  return customFetch<v1PollsAdminPollsRetrieveResponse>(getV1PollsAdminPollsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1PollsAdminPollsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/v1/polls/admin/polls/${id}/`
    ] as const;
    }


export const getV1PollsAdminPollsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PollsAdminPollsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>> = ({ signal }) => v1PollsAdminPollsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1PollsAdminPollsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>>
export type V1PollsAdminPollsRetrieveQueryError = UnauthorizedResponse | PollError | AccountGoneResponse


export function useV1PollsAdminPollsRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsAdminPollsRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsAdminPollsRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły neutralnej ankiety (operator)
 */

export function useV1PollsAdminPollsRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1PollsAdminPollsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1PollsAdminPollsUpdateResponse200 = {
  data: AdminPoll
  status: 200
}

export type v1PollsAdminPollsUpdateResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsAdminPollsUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsUpdateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsUpdateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsUpdateResponseSuccess = (v1PollsAdminPollsUpdateResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsUpdateResponseError = (v1PollsAdminPollsUpdateResponse400 | v1PollsAdminPollsUpdateResponse401 | v1PollsAdminPollsUpdateResponse403 | v1PollsAdminPollsUpdateResponse404 | v1PollsAdminPollsUpdateResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsUpdateResponse = (v1PollsAdminPollsUpdateResponseSuccess | v1PollsAdminPollsUpdateResponseError)

export const getV1PollsAdminPollsUpdateUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/`
}

export const v1PollsAdminPollsUpdate = async (id: string,
    adminPollWriteRequest: AdminPollWriteRequest, options?: RequestInit): Promise<v1PollsAdminPollsUpdateResponse> => {

  return customFetch<v1PollsAdminPollsUpdateResponse>(getV1PollsAdminPollsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminPollWriteRequest)
  }
);}




export const getV1PollsAdminPollsUpdateMutationOptions = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsUpdate>>, TError,{id: string;data: AdminPollWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsUpdate>>, TError,{id: string;data: AdminPollWriteRequest}, TContext> => {

const mutationKey = ['v1PollsAdminPollsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsAdminPollsUpdate>>, {id: string;data: AdminPollWriteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PollsAdminPollsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsAdminPollsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsUpdate>>>
    export type V1PollsAdminPollsUpdateMutationBody = AdminPollWriteRequest
    export type V1PollsAdminPollsUpdateMutationError = PollError | UnauthorizedResponse | AccountGoneResponse

    export const useV1PollsAdminPollsUpdate = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsUpdate>>, TError,{id: string;data: AdminPollWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsAdminPollsUpdate>>,
        TError,
        {id: string;data: AdminPollWriteRequest},
        TContext
      > => {
      return useMutation(getV1PollsAdminPollsUpdateMutationOptions(options), queryClient);
    }

export type v1PollsAdminPollsPartialUpdateResponse200 = {
  data: AdminPoll
  status: 200
}

export type v1PollsAdminPollsPartialUpdateResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsAdminPollsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsPartialUpdateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsPartialUpdateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsPartialUpdateResponseSuccess = (v1PollsAdminPollsPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsPartialUpdateResponseError = (v1PollsAdminPollsPartialUpdateResponse400 | v1PollsAdminPollsPartialUpdateResponse401 | v1PollsAdminPollsPartialUpdateResponse403 | v1PollsAdminPollsPartialUpdateResponse404 | v1PollsAdminPollsPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsPartialUpdateResponse = (v1PollsAdminPollsPartialUpdateResponseSuccess | v1PollsAdminPollsPartialUpdateResponseError)

export const getV1PollsAdminPollsPartialUpdateUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/`
}

export const v1PollsAdminPollsPartialUpdate = async (id: string,
    patchedAdminPollWriteRequest?: PatchedAdminPollWriteRequest, options?: RequestInit): Promise<v1PollsAdminPollsPartialUpdateResponse> => {

  return customFetch<v1PollsAdminPollsPartialUpdateResponse>(getV1PollsAdminPollsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminPollWriteRequest)
  }
);}




export const getV1PollsAdminPollsPartialUpdateMutationOptions = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPartialUpdate>>, TError,{id: string;data?: PatchedAdminPollWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPartialUpdate>>, TError,{id: string;data?: PatchedAdminPollWriteRequest}, TContext> => {

const mutationKey = ['v1PollsAdminPollsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsAdminPollsPartialUpdate>>, {id: string;data?: PatchedAdminPollWriteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PollsAdminPollsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsAdminPollsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsPartialUpdate>>>
    export type V1PollsAdminPollsPartialUpdateMutationBody = PatchedAdminPollWriteRequest | undefined
    export type V1PollsAdminPollsPartialUpdateMutationError = PollError | UnauthorizedResponse | AccountGoneResponse

    export const useV1PollsAdminPollsPartialUpdate = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPartialUpdate>>, TError,{id: string;data?: PatchedAdminPollWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsAdminPollsPartialUpdate>>,
        TError,
        {id: string;data?: PatchedAdminPollWriteRequest},
        TContext
      > => {
      return useMutation(getV1PollsAdminPollsPartialUpdateMutationOptions(options), queryClient);
    }

export type v1PollsAdminPollsDestroyResponse204 = {
  data: void
  status: 204
}

export type v1PollsAdminPollsDestroyResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsAdminPollsDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsDestroyResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsDestroyResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsDestroyResponseSuccess = (v1PollsAdminPollsDestroyResponse204) & {
  headers: Headers;
};
export type v1PollsAdminPollsDestroyResponseError = (v1PollsAdminPollsDestroyResponse400 | v1PollsAdminPollsDestroyResponse401 | v1PollsAdminPollsDestroyResponse403 | v1PollsAdminPollsDestroyResponse404 | v1PollsAdminPollsDestroyResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsDestroyResponse = (v1PollsAdminPollsDestroyResponseSuccess | v1PollsAdminPollsDestroyResponseError)

export const getV1PollsAdminPollsDestroyUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/`
}

export const v1PollsAdminPollsDestroy = async (id: string, options?: RequestInit): Promise<v1PollsAdminPollsDestroyResponse> => {

  return customFetch<v1PollsAdminPollsDestroyResponse>(getV1PollsAdminPollsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getV1PollsAdminPollsDestroyMutationOptions = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PollsAdminPollsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsAdminPollsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PollsAdminPollsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsAdminPollsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsDestroy>>>

    export type V1PollsAdminPollsDestroyMutationError = PollError | UnauthorizedResponse | AccountGoneResponse

    export const useV1PollsAdminPollsDestroy = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsAdminPollsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getV1PollsAdminPollsDestroyMutationOptions(options), queryClient);
    }

export type v1PollsAdminPollsArchiveCreateResponse200 = {
  data: AdminPoll
  status: 200
}

export type v1PollsAdminPollsArchiveCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsArchiveCreateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsArchiveCreateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsArchiveCreateResponse409 = {
  data: PollError
  status: 409
}

export type v1PollsAdminPollsArchiveCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsArchiveCreateResponseSuccess = (v1PollsAdminPollsArchiveCreateResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsArchiveCreateResponseError = (v1PollsAdminPollsArchiveCreateResponse401 | v1PollsAdminPollsArchiveCreateResponse403 | v1PollsAdminPollsArchiveCreateResponse404 | v1PollsAdminPollsArchiveCreateResponse409 | v1PollsAdminPollsArchiveCreateResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsArchiveCreateResponse = (v1PollsAdminPollsArchiveCreateResponseSuccess | v1PollsAdminPollsArchiveCreateResponseError)

export const getV1PollsAdminPollsArchiveCreateUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/archive/`
}

export const v1PollsAdminPollsArchiveCreate = async (id: string, options?: RequestInit): Promise<v1PollsAdminPollsArchiveCreateResponse> => {

  return customFetch<v1PollsAdminPollsArchiveCreateResponse>(getV1PollsAdminPollsArchiveCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1PollsAdminPollsArchiveCreateMutationOptions = <TError = UnauthorizedResponse | PollError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsArchiveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsArchiveCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PollsAdminPollsArchiveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsAdminPollsArchiveCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PollsAdminPollsArchiveCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsAdminPollsArchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsArchiveCreate>>>

    export type V1PollsAdminPollsArchiveCreateMutationError = UnauthorizedResponse | PollError | AccountGoneResponse

    export const useV1PollsAdminPollsArchiveCreate = <TError = UnauthorizedResponse | PollError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsArchiveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsAdminPollsArchiveCreate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getV1PollsAdminPollsArchiveCreateMutationOptions(options), queryClient);
    }

export type v1PollsAdminPollsCancelCreateResponse200 = {
  data: AdminPoll
  status: 200
}

export type v1PollsAdminPollsCancelCreateResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsAdminPollsCancelCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsCancelCreateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsCancelCreateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsCancelCreateResponse409 = {
  data: PollError
  status: 409
}

export type v1PollsAdminPollsCancelCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsCancelCreateResponseSuccess = (v1PollsAdminPollsCancelCreateResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsCancelCreateResponseError = (v1PollsAdminPollsCancelCreateResponse400 | v1PollsAdminPollsCancelCreateResponse401 | v1PollsAdminPollsCancelCreateResponse403 | v1PollsAdminPollsCancelCreateResponse404 | v1PollsAdminPollsCancelCreateResponse409 | v1PollsAdminPollsCancelCreateResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsCancelCreateResponse = (v1PollsAdminPollsCancelCreateResponseSuccess | v1PollsAdminPollsCancelCreateResponseError)

export const getV1PollsAdminPollsCancelCreateUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/cancel/`
}

export const v1PollsAdminPollsCancelCreate = async (id: string,
    adminPollCancelRequest: AdminPollCancelRequest, options?: RequestInit): Promise<v1PollsAdminPollsCancelCreateResponse> => {

  return customFetch<v1PollsAdminPollsCancelCreateResponse>(getV1PollsAdminPollsCancelCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminPollCancelRequest)
  }
);}




export const getV1PollsAdminPollsCancelCreateMutationOptions = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsCancelCreate>>, TError,{id: string;data: AdminPollCancelRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsCancelCreate>>, TError,{id: string;data: AdminPollCancelRequest}, TContext> => {

const mutationKey = ['v1PollsAdminPollsCancelCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsAdminPollsCancelCreate>>, {id: string;data: AdminPollCancelRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PollsAdminPollsCancelCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsAdminPollsCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsCancelCreate>>>
    export type V1PollsAdminPollsCancelCreateMutationBody = AdminPollCancelRequest
    export type V1PollsAdminPollsCancelCreateMutationError = PollError | UnauthorizedResponse | AccountGoneResponse

    export const useV1PollsAdminPollsCancelCreate = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsCancelCreate>>, TError,{id: string;data: AdminPollCancelRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsAdminPollsCancelCreate>>,
        TError,
        {id: string;data: AdminPollCancelRequest},
        TContext
      > => {
      return useMutation(getV1PollsAdminPollsCancelCreateMutationOptions(options), queryClient);
    }

export type v1PollsAdminPollsCancelScheduleCreateResponse200 = {
  data: AdminPoll
  status: 200
}

export type v1PollsAdminPollsCancelScheduleCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsCancelScheduleCreateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsCancelScheduleCreateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsCancelScheduleCreateResponse409 = {
  data: PollError
  status: 409
}

export type v1PollsAdminPollsCancelScheduleCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsCancelScheduleCreateResponseSuccess = (v1PollsAdminPollsCancelScheduleCreateResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsCancelScheduleCreateResponseError = (v1PollsAdminPollsCancelScheduleCreateResponse401 | v1PollsAdminPollsCancelScheduleCreateResponse403 | v1PollsAdminPollsCancelScheduleCreateResponse404 | v1PollsAdminPollsCancelScheduleCreateResponse409 | v1PollsAdminPollsCancelScheduleCreateResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsCancelScheduleCreateResponse = (v1PollsAdminPollsCancelScheduleCreateResponseSuccess | v1PollsAdminPollsCancelScheduleCreateResponseError)

export const getV1PollsAdminPollsCancelScheduleCreateUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/cancel-schedule/`
}

export const v1PollsAdminPollsCancelScheduleCreate = async (id: string, options?: RequestInit): Promise<v1PollsAdminPollsCancelScheduleCreateResponse> => {

  return customFetch<v1PollsAdminPollsCancelScheduleCreateResponse>(getV1PollsAdminPollsCancelScheduleCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1PollsAdminPollsCancelScheduleCreateMutationOptions = <TError = UnauthorizedResponse | PollError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsCancelScheduleCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsCancelScheduleCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PollsAdminPollsCancelScheduleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsAdminPollsCancelScheduleCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PollsAdminPollsCancelScheduleCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsAdminPollsCancelScheduleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsCancelScheduleCreate>>>

    export type V1PollsAdminPollsCancelScheduleCreateMutationError = UnauthorizedResponse | PollError | AccountGoneResponse

    export const useV1PollsAdminPollsCancelScheduleCreate = <TError = UnauthorizedResponse | PollError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsCancelScheduleCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsAdminPollsCancelScheduleCreate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getV1PollsAdminPollsCancelScheduleCreateMutationOptions(options), queryClient);
    }

export type v1PollsAdminPollsPreviewRetrieveResponse200 = {
  data: AdminPollPreview
  status: 200
}

export type v1PollsAdminPollsPreviewRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsPreviewRetrieveResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsPreviewRetrieveResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsPreviewRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsPreviewRetrieveResponseSuccess = (v1PollsAdminPollsPreviewRetrieveResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsPreviewRetrieveResponseError = (v1PollsAdminPollsPreviewRetrieveResponse401 | v1PollsAdminPollsPreviewRetrieveResponse403 | v1PollsAdminPollsPreviewRetrieveResponse404 | v1PollsAdminPollsPreviewRetrieveResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsPreviewRetrieveResponse = (v1PollsAdminPollsPreviewRetrieveResponseSuccess | v1PollsAdminPollsPreviewRetrieveResponseError)

export const getV1PollsAdminPollsPreviewRetrieveUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/preview/`
}

export const v1PollsAdminPollsPreviewRetrieve = async (id: string, options?: RequestInit): Promise<v1PollsAdminPollsPreviewRetrieveResponse> => {

  return customFetch<v1PollsAdminPollsPreviewRetrieveResponse>(getV1PollsAdminPollsPreviewRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1PollsAdminPollsPreviewRetrieveQueryKey = (id: string,) => {
    return [
    `/api/v1/polls/admin/polls/${id}/preview/`
    ] as const;
    }


export const getV1PollsAdminPollsPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PollsAdminPollsPreviewRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>> = ({ signal }) => v1PollsAdminPollsPreviewRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1PollsAdminPollsPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>>
export type V1PollsAdminPollsPreviewRetrieveQueryError = UnauthorizedResponse | PollError | AccountGoneResponse


export function useV1PollsAdminPollsPreviewRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsAdminPollsPreviewRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsAdminPollsPreviewRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1PollsAdminPollsPreviewRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1PollsAdminPollsPreviewRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1PollsAdminPollsPublishCreateResponse200 = {
  data: AdminPoll
  status: 200
}

export type v1PollsAdminPollsPublishCreateResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsAdminPollsPublishCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsPublishCreateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsPublishCreateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsPublishCreateResponse409 = {
  data: PollError
  status: 409
}

export type v1PollsAdminPollsPublishCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsPublishCreateResponse422 = {
  data: PollError
  status: 422
}

export type v1PollsAdminPollsPublishCreateResponseSuccess = (v1PollsAdminPollsPublishCreateResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsPublishCreateResponseError = (v1PollsAdminPollsPublishCreateResponse400 | v1PollsAdminPollsPublishCreateResponse401 | v1PollsAdminPollsPublishCreateResponse403 | v1PollsAdminPollsPublishCreateResponse404 | v1PollsAdminPollsPublishCreateResponse409 | v1PollsAdminPollsPublishCreateResponse410 | v1PollsAdminPollsPublishCreateResponse422) & {
  headers: Headers;
};

export type v1PollsAdminPollsPublishCreateResponse = (v1PollsAdminPollsPublishCreateResponseSuccess | v1PollsAdminPollsPublishCreateResponseError)

export const getV1PollsAdminPollsPublishCreateUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/publish/`
}

export const v1PollsAdminPollsPublishCreate = async (id: string, options?: RequestInit): Promise<v1PollsAdminPollsPublishCreateResponse> => {

  return customFetch<v1PollsAdminPollsPublishCreateResponse>(getV1PollsAdminPollsPublishCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1PollsAdminPollsPublishCreateMutationOptions = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPublishCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PollsAdminPollsPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsAdminPollsPublishCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PollsAdminPollsPublishCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsAdminPollsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsPublishCreate>>>

    export type V1PollsAdminPollsPublishCreateMutationError = PollError | UnauthorizedResponse | AccountGoneResponse

    export const useV1PollsAdminPollsPublishCreate = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsAdminPollsPublishCreate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getV1PollsAdminPollsPublishCreateMutationOptions(options), queryClient);
    }

export type v1PollsAdminPollsResultsRetrieveResponse200 = {
  data: AdminPollResults
  status: 200
}

export type v1PollsAdminPollsResultsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsResultsRetrieveResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsResultsRetrieveResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsResultsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsResultsRetrieveResponseSuccess = (v1PollsAdminPollsResultsRetrieveResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsResultsRetrieveResponseError = (v1PollsAdminPollsResultsRetrieveResponse401 | v1PollsAdminPollsResultsRetrieveResponse403 | v1PollsAdminPollsResultsRetrieveResponse404 | v1PollsAdminPollsResultsRetrieveResponse410) & {
  headers: Headers;
};

export type v1PollsAdminPollsResultsRetrieveResponse = (v1PollsAdminPollsResultsRetrieveResponseSuccess | v1PollsAdminPollsResultsRetrieveResponseError)

export const getV1PollsAdminPollsResultsRetrieveUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/results/`
}

export const v1PollsAdminPollsResultsRetrieve = async (id: string, options?: RequestInit): Promise<v1PollsAdminPollsResultsRetrieveResponse> => {

  return customFetch<v1PollsAdminPollsResultsRetrieveResponse>(getV1PollsAdminPollsResultsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1PollsAdminPollsResultsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/v1/polls/admin/polls/${id}/results/`
    ] as const;
    }


export const getV1PollsAdminPollsResultsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PollsAdminPollsResultsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>> = ({ signal }) => v1PollsAdminPollsResultsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1PollsAdminPollsResultsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>>
export type V1PollsAdminPollsResultsRetrieveQueryError = UnauthorizedResponse | PollError | AccountGoneResponse


export function useV1PollsAdminPollsResultsRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsAdminPollsResultsRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsAdminPollsResultsRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1PollsAdminPollsResultsRetrieve<TData = Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsAdminPollsResultsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1PollsAdminPollsResultsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1PollsAdminPollsScheduleCreateResponse200 = {
  data: AdminPoll
  status: 200
}

export type v1PollsAdminPollsScheduleCreateResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsAdminPollsScheduleCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsAdminPollsScheduleCreateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsAdminPollsScheduleCreateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsAdminPollsScheduleCreateResponse409 = {
  data: PollError
  status: 409
}

export type v1PollsAdminPollsScheduleCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsAdminPollsScheduleCreateResponse422 = {
  data: PollError
  status: 422
}

export type v1PollsAdminPollsScheduleCreateResponseSuccess = (v1PollsAdminPollsScheduleCreateResponse200) & {
  headers: Headers;
};
export type v1PollsAdminPollsScheduleCreateResponseError = (v1PollsAdminPollsScheduleCreateResponse400 | v1PollsAdminPollsScheduleCreateResponse401 | v1PollsAdminPollsScheduleCreateResponse403 | v1PollsAdminPollsScheduleCreateResponse404 | v1PollsAdminPollsScheduleCreateResponse409 | v1PollsAdminPollsScheduleCreateResponse410 | v1PollsAdminPollsScheduleCreateResponse422) & {
  headers: Headers;
};

export type v1PollsAdminPollsScheduleCreateResponse = (v1PollsAdminPollsScheduleCreateResponseSuccess | v1PollsAdminPollsScheduleCreateResponseError)

export const getV1PollsAdminPollsScheduleCreateUrl = (id: string,) => {




  return `/api/v1/polls/admin/polls/${id}/schedule/`
}

export const v1PollsAdminPollsScheduleCreate = async (id: string,
    adminPollScheduleRequest: AdminPollScheduleRequest, options?: RequestInit): Promise<v1PollsAdminPollsScheduleCreateResponse> => {

  return customFetch<v1PollsAdminPollsScheduleCreateResponse>(getV1PollsAdminPollsScheduleCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminPollScheduleRequest)
  }
);}




export const getV1PollsAdminPollsScheduleCreateMutationOptions = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsScheduleCreate>>, TError,{id: string;data: AdminPollScheduleRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsScheduleCreate>>, TError,{id: string;data: AdminPollScheduleRequest}, TContext> => {

const mutationKey = ['v1PollsAdminPollsScheduleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsAdminPollsScheduleCreate>>, {id: string;data: AdminPollScheduleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PollsAdminPollsScheduleCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsAdminPollsScheduleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsAdminPollsScheduleCreate>>>
    export type V1PollsAdminPollsScheduleCreateMutationBody = AdminPollScheduleRequest
    export type V1PollsAdminPollsScheduleCreateMutationError = PollError | UnauthorizedResponse | AccountGoneResponse

    export const useV1PollsAdminPollsScheduleCreate = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsAdminPollsScheduleCreate>>, TError,{id: string;data: AdminPollScheduleRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsAdminPollsScheduleCreate>>,
        TError,
        {id: string;data: AdminPollScheduleRequest},
        TContext
      > => {
      return useMutation(getV1PollsAdminPollsScheduleCreateMutationOptions(options), queryClient);
    }

export type v1PollsSessionsRetrieveResponse200 = {
  data: PollSession
  status: 200
}

export type v1PollsSessionsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsSessionsRetrieveResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsSessionsRetrieveResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsSessionsRetrieveResponse409 = {
  data: PollError
  status: 409
}

export type v1PollsSessionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsSessionsRetrieveResponse422 = {
  data: PollError
  status: 422
}

export type v1PollsSessionsRetrieveResponseSuccess = (v1PollsSessionsRetrieveResponse200) & {
  headers: Headers;
};
export type v1PollsSessionsRetrieveResponseError = (v1PollsSessionsRetrieveResponse401 | v1PollsSessionsRetrieveResponse403 | v1PollsSessionsRetrieveResponse404 | v1PollsSessionsRetrieveResponse409 | v1PollsSessionsRetrieveResponse410 | v1PollsSessionsRetrieveResponse422) & {
  headers: Headers;
};

export type v1PollsSessionsRetrieveResponse = (v1PollsSessionsRetrieveResponseSuccess | v1PollsSessionsRetrieveResponseError)

export const getV1PollsSessionsRetrieveUrl = (sessionId: string,) => {




  return `/api/v1/polls/sessions/${sessionId}/`
}

export const v1PollsSessionsRetrieve = async (sessionId: string, options?: RequestInit): Promise<v1PollsSessionsRetrieveResponse> => {

  return customFetch<v1PollsSessionsRetrieveResponse>(getV1PollsSessionsRetrieveUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1PollsSessionsRetrieveQueryKey = (sessionId: string,) => {
    return [
    `/api/v1/polls/sessions/${sessionId}/`
    ] as const;
    }


export const getV1PollsSessionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PollsSessionsRetrieveQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>> = ({ signal }) => v1PollsSessionsRetrieve(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1PollsSessionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>>
export type V1PollsSessionsRetrieveQueryError = UnauthorizedResponse | PollError | AccountGoneResponse


export function useV1PollsSessionsRetrieve<TData = Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsSessionsRetrieve<TData = Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1PollsSessionsRetrieve<TData = Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1PollsSessionsRetrieve<TData = Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError = UnauthorizedResponse | PollError | AccountGoneResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PollsSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1PollsSessionsRetrieveQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1PollsSessionsCompleteCreateResponse200 = {
  data: PollSessionComplete
  status: 200
}

export type v1PollsSessionsCompleteCreateResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsSessionsCompleteCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsSessionsCompleteCreateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsSessionsCompleteCreateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsSessionsCompleteCreateResponse409 = {
  data: PollError
  status: 409
}

export type v1PollsSessionsCompleteCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsSessionsCompleteCreateResponse422 = {
  data: PollError
  status: 422
}

export type v1PollsSessionsCompleteCreateResponseSuccess = (v1PollsSessionsCompleteCreateResponse200) & {
  headers: Headers;
};
export type v1PollsSessionsCompleteCreateResponseError = (v1PollsSessionsCompleteCreateResponse400 | v1PollsSessionsCompleteCreateResponse401 | v1PollsSessionsCompleteCreateResponse403 | v1PollsSessionsCompleteCreateResponse404 | v1PollsSessionsCompleteCreateResponse409 | v1PollsSessionsCompleteCreateResponse410 | v1PollsSessionsCompleteCreateResponse422) & {
  headers: Headers;
};

export type v1PollsSessionsCompleteCreateResponse = (v1PollsSessionsCompleteCreateResponseSuccess | v1PollsSessionsCompleteCreateResponseError)

export const getV1PollsSessionsCompleteCreateUrl = (sessionId: string,) => {




  return `/api/v1/polls/sessions/${sessionId}/complete/`
}

export const v1PollsSessionsCompleteCreate = async (sessionId: string,
    pollSessionCompleteInputRequest: PollSessionCompleteInputRequest, options?: RequestInit): Promise<v1PollsSessionsCompleteCreateResponse> => {

  return customFetch<v1PollsSessionsCompleteCreateResponse>(getV1PollsSessionsCompleteCreateUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pollSessionCompleteInputRequest)
  }
);}




export const getV1PollsSessionsCompleteCreateMutationOptions = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsSessionsCompleteCreate>>, TError,{sessionId: string;data: PollSessionCompleteInputRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsSessionsCompleteCreate>>, TError,{sessionId: string;data: PollSessionCompleteInputRequest}, TContext> => {

const mutationKey = ['v1PollsSessionsCompleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsSessionsCompleteCreate>>, {sessionId: string;data: PollSessionCompleteInputRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  v1PollsSessionsCompleteCreate(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsSessionsCompleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsSessionsCompleteCreate>>>
    export type V1PollsSessionsCompleteCreateMutationBody = PollSessionCompleteInputRequest
    export type V1PollsSessionsCompleteCreateMutationError = PollError | UnauthorizedResponse | AccountGoneResponse

    export const useV1PollsSessionsCompleteCreate = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsSessionsCompleteCreate>>, TError,{sessionId: string;data: PollSessionCompleteInputRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsSessionsCompleteCreate>>,
        TError,
        {sessionId: string;data: PollSessionCompleteInputRequest},
        TContext
      > => {
      return useMutation(getV1PollsSessionsCompleteCreateMutationOptions(options), queryClient);
    }

export type v1PollsSessionsResponsesUpdateResponse200 = {
  data: PollResponseAck
  status: 200
}

export type v1PollsSessionsResponsesUpdateResponse400 = {
  data: PollError
  status: 400
}

export type v1PollsSessionsResponsesUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1PollsSessionsResponsesUpdateResponse403 = {
  data: PollError
  status: 403
}

export type v1PollsSessionsResponsesUpdateResponse404 = {
  data: PollError
  status: 404
}

export type v1PollsSessionsResponsesUpdateResponse409 = {
  data: PollError
  status: 409
}

export type v1PollsSessionsResponsesUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1PollsSessionsResponsesUpdateResponse422 = {
  data: PollError
  status: 422
}

export type v1PollsSessionsResponsesUpdateResponseSuccess = (v1PollsSessionsResponsesUpdateResponse200) & {
  headers: Headers;
};
export type v1PollsSessionsResponsesUpdateResponseError = (v1PollsSessionsResponsesUpdateResponse400 | v1PollsSessionsResponsesUpdateResponse401 | v1PollsSessionsResponsesUpdateResponse403 | v1PollsSessionsResponsesUpdateResponse404 | v1PollsSessionsResponsesUpdateResponse409 | v1PollsSessionsResponsesUpdateResponse410 | v1PollsSessionsResponsesUpdateResponse422) & {
  headers: Headers;
};

export type v1PollsSessionsResponsesUpdateResponse = (v1PollsSessionsResponsesUpdateResponseSuccess | v1PollsSessionsResponsesUpdateResponseError)

export const getV1PollsSessionsResponsesUpdateUrl = (sessionId: string,
    questionId: string,) => {




  return `/api/v1/polls/sessions/${sessionId}/responses/${questionId}/`
}

export const v1PollsSessionsResponsesUpdate = async (sessionId: string,
    questionId: string,
    pollResponseWriteRequest: PollResponseWriteRequest, options?: RequestInit): Promise<v1PollsSessionsResponsesUpdateResponse> => {

  return customFetch<v1PollsSessionsResponsesUpdateResponse>(getV1PollsSessionsResponsesUpdateUrl(sessionId,questionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pollResponseWriteRequest)
  }
);}




export const getV1PollsSessionsResponsesUpdateMutationOptions = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsSessionsResponsesUpdate>>, TError,{sessionId: string;questionId: string;data: PollResponseWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1PollsSessionsResponsesUpdate>>, TError,{sessionId: string;questionId: string;data: PollResponseWriteRequest}, TContext> => {

const mutationKey = ['v1PollsSessionsResponsesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PollsSessionsResponsesUpdate>>, {sessionId: string;questionId: string;data: PollResponseWriteRequest}> = (props) => {
          const {sessionId,questionId,data} = props ?? {};

          return  v1PollsSessionsResponsesUpdate(sessionId,questionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1PollsSessionsResponsesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PollsSessionsResponsesUpdate>>>
    export type V1PollsSessionsResponsesUpdateMutationBody = PollResponseWriteRequest
    export type V1PollsSessionsResponsesUpdateMutationError = PollError | UnauthorizedResponse | AccountGoneResponse

    export const useV1PollsSessionsResponsesUpdate = <TError = PollError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PollsSessionsResponsesUpdate>>, TError,{sessionId: string;questionId: string;data: PollResponseWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PollsSessionsResponsesUpdate>>,
        TError,
        {sessionId: string;questionId: string;data: PollResponseWriteRequest},
        TContext
      > => {
      return useMutation(getV1PollsSessionsResponsesUpdateMutationOptions(options), queryClient);
    }

export type v1QuizAdminCapabilitiesResponse200 = {
  data: AdminQuizCapabilities
  status: 200
}

export type v1QuizAdminCapabilitiesResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminCapabilitiesResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminCapabilitiesResponseSuccess = (v1QuizAdminCapabilitiesResponse200) & {
  headers: Headers;
};
export type v1QuizAdminCapabilitiesResponseError = (v1QuizAdminCapabilitiesResponse401 | v1QuizAdminCapabilitiesResponse410) & {
  headers: Headers;
};

export type v1QuizAdminCapabilitiesResponse = (v1QuizAdminCapabilitiesResponseSuccess | v1QuizAdminCapabilitiesResponseError)

export const getV1QuizAdminCapabilitiesUrl = () => {




  return `/api/v1/quiz/admin/capabilities/`
}

/**
 * GET /quiz/admin/capabilities/ — the operator rollout contract.
 * @summary Stan rolloutu quizów
 */
export const v1QuizAdminCapabilities = async ( options?: RequestInit): Promise<v1QuizAdminCapabilitiesResponse> => {

  return customFetch<v1QuizAdminCapabilitiesResponse>(getV1QuizAdminCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminCapabilitiesQueryKey = () => {
    return [
    `/api/v1/quiz/admin/capabilities/`
    ] as const;
    }


export const getV1QuizAdminCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminCapabilities>>> = ({ signal }) => v1QuizAdminCapabilities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminCapabilities>>>
export type V1QuizAdminCapabilitiesQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminCapabilities<TData = Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminCapabilities>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminCapabilities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminCapabilities<TData = Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminCapabilities>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminCapabilities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminCapabilities<TData = Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stan rolloutu quizów
 */

export function useV1QuizAdminCapabilities<TData = Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCapabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminCycleRecipesListResponse200 = {
  data: AdminQuizCycleRecipes
  status: 200
}

export type v1QuizAdminCycleRecipesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminCycleRecipesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminCycleRecipesListResponseSuccess = (v1QuizAdminCycleRecipesListResponse200) & {
  headers: Headers;
};
export type v1QuizAdminCycleRecipesListResponseError = (v1QuizAdminCycleRecipesListResponse401 | v1QuizAdminCycleRecipesListResponse410) & {
  headers: Headers;
};

export type v1QuizAdminCycleRecipesListResponse = (v1QuizAdminCycleRecipesListResponseSuccess | v1QuizAdminCycleRecipesListResponseError)

export const getV1QuizAdminCycleRecipesListUrl = () => {




  return `/api/v1/quiz/admin/cycle-recipes/`
}

/**
 * @summary Konfiguracja i diagnostyka automatycznych cykli quizowych
 */
export const v1QuizAdminCycleRecipesList = async ( options?: RequestInit): Promise<v1QuizAdminCycleRecipesListResponse> => {

  return customFetch<v1QuizAdminCycleRecipesListResponse>(getV1QuizAdminCycleRecipesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminCycleRecipesListQueryKey = () => {
    return [
    `/api/v1/quiz/admin/cycle-recipes/`
    ] as const;
    }


export const getV1QuizAdminCycleRecipesListQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminCycleRecipesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>> = ({ signal }) => v1QuizAdminCycleRecipesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminCycleRecipesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>>
export type V1QuizAdminCycleRecipesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminCycleRecipesList<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminCycleRecipesList<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminCycleRecipesList<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Konfiguracja i diagnostyka automatycznych cykli quizowych
 */

export function useV1QuizAdminCycleRecipesList<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminCycleRecipesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminCycleRecipesRetrieveResponse200 = {
  data: AdminQuizCycleRecipe
  status: 200
}

export type v1QuizAdminCycleRecipesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminCycleRecipesRetrieveResponse404 = {
  data: void
  status: 404
}

export type v1QuizAdminCycleRecipesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminCycleRecipesRetrieveResponseSuccess = (v1QuizAdminCycleRecipesRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizAdminCycleRecipesRetrieveResponseError = (v1QuizAdminCycleRecipesRetrieveResponse401 | v1QuizAdminCycleRecipesRetrieveResponse404 | v1QuizAdminCycleRecipesRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizAdminCycleRecipesRetrieveResponse = (v1QuizAdminCycleRecipesRetrieveResponseSuccess | v1QuizAdminCycleRecipesRetrieveResponseError)

export const getV1QuizAdminCycleRecipesRetrieveUrl = (cycle: string,) => {




  return `/api/v1/quiz/admin/cycle-recipes/${cycle}/`
}

/**
 * @summary Szczegóły efektywnej konfiguracji cyklu automatycznego
 */
export const v1QuizAdminCycleRecipesRetrieve = async (cycle: string, options?: RequestInit): Promise<v1QuizAdminCycleRecipesRetrieveResponse> => {

  return customFetch<v1QuizAdminCycleRecipesRetrieveResponse>(getV1QuizAdminCycleRecipesRetrieveUrl(cycle),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminCycleRecipesRetrieveQueryKey = (cycle: string,) => {
    return [
    `/api/v1/quiz/admin/cycle-recipes/${cycle}/`
    ] as const;
    }


export const getV1QuizAdminCycleRecipesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(cycle: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminCycleRecipesRetrieveQueryKey(cycle);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>> = ({ signal }) => v1QuizAdminCycleRecipesRetrieve(cycle, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: cycle !== null && cycle !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminCycleRecipesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>>
export type V1QuizAdminCycleRecipesRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1QuizAdminCycleRecipesRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cycle: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminCycleRecipesRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cycle: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminCycleRecipesRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cycle: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły efektywnej konfiguracji cyklu automatycznego
 */

export function useV1QuizAdminCycleRecipesRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cycle: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminCycleRecipesRetrieveQueryOptions(cycle,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminCycleRecipeDeactivateResponse200 = {
  data: AdminQuizCycleRecipeRevision
  status: 200
}

export type v1QuizAdminCycleRecipeDeactivateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminCycleRecipeDeactivateResponse404 = {
  data: void
  status: 404
}

export type v1QuizAdminCycleRecipeDeactivateResponse409 = {
  data: void
  status: 409
}

export type v1QuizAdminCycleRecipeDeactivateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminCycleRecipeDeactivateResponseSuccess = (v1QuizAdminCycleRecipeDeactivateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminCycleRecipeDeactivateResponseError = (v1QuizAdminCycleRecipeDeactivateResponse401 | v1QuizAdminCycleRecipeDeactivateResponse404 | v1QuizAdminCycleRecipeDeactivateResponse409 | v1QuizAdminCycleRecipeDeactivateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminCycleRecipeDeactivateResponse = (v1QuizAdminCycleRecipeDeactivateResponseSuccess | v1QuizAdminCycleRecipeDeactivateResponseError)

export const getV1QuizAdminCycleRecipeDeactivateUrl = (cycle: string,) => {




  return `/api/v1/quiz/admin/cycle-recipes/${cycle}/deactivate/`
}

/**
 * @summary Natychmiastowe wyłączenie cyklu (z pominięciem granicy okna)
 */
export const v1QuizAdminCycleRecipeDeactivate = async (cycle: string, options?: RequestInit): Promise<v1QuizAdminCycleRecipeDeactivateResponse> => {

  return customFetch<v1QuizAdminCycleRecipeDeactivateResponse>(getV1QuizAdminCycleRecipeDeactivateUrl(cycle),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminCycleRecipeDeactivateMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeDeactivate>>, TError,{cycle: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeDeactivate>>, TError,{cycle: string}, TContext> => {

const mutationKey = ['v1QuizAdminCycleRecipeDeactivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeDeactivate>>, {cycle: string}> = (props) => {
          const {cycle} = props ?? {};

          return  v1QuizAdminCycleRecipeDeactivate(cycle,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminCycleRecipeDeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeDeactivate>>>

    export type V1QuizAdminCycleRecipeDeactivateMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Natychmiastowe wyłączenie cyklu (z pominięciem granicy okna)
 */
export const useV1QuizAdminCycleRecipeDeactivate = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeDeactivate>>, TError,{cycle: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminCycleRecipeDeactivate>>,
        TError,
        {cycle: string},
        TContext
      > => {
      return useMutation(getV1QuizAdminCycleRecipeDeactivateMutationOptions(options), queryClient);
    }

export type v1QuizAdminCycleRecipeRevisionsListResponse200 = {
  data: AdminQuizCycleRecipeRevisions
  status: 200
}

export type v1QuizAdminCycleRecipeRevisionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminCycleRecipeRevisionsListResponse404 = {
  data: void
  status: 404
}

export type v1QuizAdminCycleRecipeRevisionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminCycleRecipeRevisionsListResponseSuccess = (v1QuizAdminCycleRecipeRevisionsListResponse200) & {
  headers: Headers;
};
export type v1QuizAdminCycleRecipeRevisionsListResponseError = (v1QuizAdminCycleRecipeRevisionsListResponse401 | v1QuizAdminCycleRecipeRevisionsListResponse404 | v1QuizAdminCycleRecipeRevisionsListResponse410) & {
  headers: Headers;
};

export type v1QuizAdminCycleRecipeRevisionsListResponse = (v1QuizAdminCycleRecipeRevisionsListResponseSuccess | v1QuizAdminCycleRecipeRevisionsListResponseError)

export const getV1QuizAdminCycleRecipeRevisionsListUrl = (cycle: string,) => {




  return `/api/v1/quiz/admin/cycle-recipes/${cycle}/revisions/`
}

/**
 * @summary Historia wersji konfiguracji cyklu automatycznego
 */
export const v1QuizAdminCycleRecipeRevisionsList = async (cycle: string, options?: RequestInit): Promise<v1QuizAdminCycleRecipeRevisionsListResponse> => {

  return customFetch<v1QuizAdminCycleRecipeRevisionsListResponse>(getV1QuizAdminCycleRecipeRevisionsListUrl(cycle),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminCycleRecipeRevisionsListQueryKey = (cycle: string,) => {
    return [
    `/api/v1/quiz/admin/cycle-recipes/${cycle}/revisions/`
    ] as const;
    }


export const getV1QuizAdminCycleRecipeRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(cycle: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminCycleRecipeRevisionsListQueryKey(cycle);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>> = ({ signal }) => v1QuizAdminCycleRecipeRevisionsList(cycle, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: cycle !== null && cycle !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminCycleRecipeRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>>
export type V1QuizAdminCycleRecipeRevisionsListQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1QuizAdminCycleRecipeRevisionsList<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cycle: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminCycleRecipeRevisionsList<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cycle: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminCycleRecipeRevisionsList<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cycle: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Historia wersji konfiguracji cyklu automatycznego
 */

export function useV1QuizAdminCycleRecipeRevisionsList<TData = Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 cycle: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminCycleRecipeRevisionsListQueryOptions(cycle,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminCycleRecipeRevisionsCreateResponse201 = {
  data: AdminQuizCycleRecipeRevision
  status: 201
}

export type v1QuizAdminCycleRecipeRevisionsCreateResponse400 = {
  data: void
  status: 400
}

export type v1QuizAdminCycleRecipeRevisionsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminCycleRecipeRevisionsCreateResponse409 = {
  data: void
  status: 409
}

export type v1QuizAdminCycleRecipeRevisionsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminCycleRecipeRevisionsCreateResponseSuccess = (v1QuizAdminCycleRecipeRevisionsCreateResponse201) & {
  headers: Headers;
};
export type v1QuizAdminCycleRecipeRevisionsCreateResponseError = (v1QuizAdminCycleRecipeRevisionsCreateResponse400 | v1QuizAdminCycleRecipeRevisionsCreateResponse401 | v1QuizAdminCycleRecipeRevisionsCreateResponse409 | v1QuizAdminCycleRecipeRevisionsCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminCycleRecipeRevisionsCreateResponse = (v1QuizAdminCycleRecipeRevisionsCreateResponseSuccess | v1QuizAdminCycleRecipeRevisionsCreateResponseError)

export const getV1QuizAdminCycleRecipeRevisionsCreateUrl = (cycle: string,) => {




  return `/api/v1/quiz/admin/cycle-recipes/${cycle}/revisions/`
}

/**
 * @summary Utworzenie niezmiennej wersji roboczej konfiguracji
 */
export const v1QuizAdminCycleRecipeRevisionsCreate = async (cycle: string,
    adminQuizCycleRecipeWriteRequest: AdminQuizCycleRecipeWriteRequest, options?: RequestInit): Promise<v1QuizAdminCycleRecipeRevisionsCreateResponse> => {

  return customFetch<v1QuizAdminCycleRecipeRevisionsCreateResponse>(getV1QuizAdminCycleRecipeRevisionsCreateUrl(cycle),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminQuizCycleRecipeWriteRequest)
  }
);}




export const getV1QuizAdminCycleRecipeRevisionsCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsCreate>>, TError,{cycle: string;data: AdminQuizCycleRecipeWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsCreate>>, TError,{cycle: string;data: AdminQuizCycleRecipeWriteRequest}, TContext> => {

const mutationKey = ['v1QuizAdminCycleRecipeRevisionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsCreate>>, {cycle: string;data: AdminQuizCycleRecipeWriteRequest}> = (props) => {
          const {cycle,data} = props ?? {};

          return  v1QuizAdminCycleRecipeRevisionsCreate(cycle,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminCycleRecipeRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsCreate>>>
    export type V1QuizAdminCycleRecipeRevisionsCreateMutationBody = AdminQuizCycleRecipeWriteRequest
    export type V1QuizAdminCycleRecipeRevisionsCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Utworzenie niezmiennej wersji roboczej konfiguracji
 */
export const useV1QuizAdminCycleRecipeRevisionsCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsCreate>>, TError,{cycle: string;data: AdminQuizCycleRecipeWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionsCreate>>,
        TError,
        {cycle: string;data: AdminQuizCycleRecipeWriteRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminCycleRecipeRevisionsCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminCycleRecipeRevisionActivateResponse200 = {
  data: AdminQuizCycleRecipeRevision
  status: 200
}

export type v1QuizAdminCycleRecipeRevisionActivateResponse400 = {
  data: void
  status: 400
}

export type v1QuizAdminCycleRecipeRevisionActivateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminCycleRecipeRevisionActivateResponse404 = {
  data: void
  status: 404
}

export type v1QuizAdminCycleRecipeRevisionActivateResponse409 = {
  data: void
  status: 409
}

export type v1QuizAdminCycleRecipeRevisionActivateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminCycleRecipeRevisionActivateResponseSuccess = (v1QuizAdminCycleRecipeRevisionActivateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminCycleRecipeRevisionActivateResponseError = (v1QuizAdminCycleRecipeRevisionActivateResponse400 | v1QuizAdminCycleRecipeRevisionActivateResponse401 | v1QuizAdminCycleRecipeRevisionActivateResponse404 | v1QuizAdminCycleRecipeRevisionActivateResponse409 | v1QuizAdminCycleRecipeRevisionActivateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminCycleRecipeRevisionActivateResponse = (v1QuizAdminCycleRecipeRevisionActivateResponseSuccess | v1QuizAdminCycleRecipeRevisionActivateResponseError)

export const getV1QuizAdminCycleRecipeRevisionActivateUrl = (cycle: string,
    number: number,) => {




  return `/api/v1/quiz/admin/cycle-recipes/${cycle}/revisions/${number}/activate/`
}

/**
 * @summary Publikacja wersji od następnej bezpiecznej granicy cyklu
 */
export const v1QuizAdminCycleRecipeRevisionActivate = async (cycle: string,
    number: number, options?: RequestInit): Promise<v1QuizAdminCycleRecipeRevisionActivateResponse> => {

  return customFetch<v1QuizAdminCycleRecipeRevisionActivateResponse>(getV1QuizAdminCycleRecipeRevisionActivateUrl(cycle,number),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminCycleRecipeRevisionActivateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionActivate>>, TError,{cycle: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionActivate>>, TError,{cycle: string;number: number}, TContext> => {

const mutationKey = ['v1QuizAdminCycleRecipeRevisionActivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionActivate>>, {cycle: string;number: number}> = (props) => {
          const {cycle,number} = props ?? {};

          return  v1QuizAdminCycleRecipeRevisionActivate(cycle,number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminCycleRecipeRevisionActivateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionActivate>>>

    export type V1QuizAdminCycleRecipeRevisionActivateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Publikacja wersji od następnej bezpiecznej granicy cyklu
 */
export const useV1QuizAdminCycleRecipeRevisionActivate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionActivate>>, TError,{cycle: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionActivate>>,
        TError,
        {cycle: string;number: number},
        TContext
      > => {
      return useMutation(getV1QuizAdminCycleRecipeRevisionActivateMutationOptions(options), queryClient);
    }

export type v1QuizAdminCycleRecipeRevisionCancelResponse200 = {
  data: AdminQuizCycleRecipeRevision
  status: 200
}

export type v1QuizAdminCycleRecipeRevisionCancelResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminCycleRecipeRevisionCancelResponse404 = {
  data: void
  status: 404
}

export type v1QuizAdminCycleRecipeRevisionCancelResponse409 = {
  data: void
  status: 409
}

export type v1QuizAdminCycleRecipeRevisionCancelResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminCycleRecipeRevisionCancelResponseSuccess = (v1QuizAdminCycleRecipeRevisionCancelResponse200) & {
  headers: Headers;
};
export type v1QuizAdminCycleRecipeRevisionCancelResponseError = (v1QuizAdminCycleRecipeRevisionCancelResponse401 | v1QuizAdminCycleRecipeRevisionCancelResponse404 | v1QuizAdminCycleRecipeRevisionCancelResponse409 | v1QuizAdminCycleRecipeRevisionCancelResponse410) & {
  headers: Headers;
};

export type v1QuizAdminCycleRecipeRevisionCancelResponse = (v1QuizAdminCycleRecipeRevisionCancelResponseSuccess | v1QuizAdminCycleRecipeRevisionCancelResponseError)

export const getV1QuizAdminCycleRecipeRevisionCancelUrl = (cycle: string,
    number: number,) => {




  return `/api/v1/quiz/admin/cycle-recipes/${cycle}/revisions/${number}/cancel/`
}

/**
 * @summary Anulowanie porzuconej wersji roboczej
 */
export const v1QuizAdminCycleRecipeRevisionCancel = async (cycle: string,
    number: number, options?: RequestInit): Promise<v1QuizAdminCycleRecipeRevisionCancelResponse> => {

  return customFetch<v1QuizAdminCycleRecipeRevisionCancelResponse>(getV1QuizAdminCycleRecipeRevisionCancelUrl(cycle,number),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminCycleRecipeRevisionCancelMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionCancel>>, TError,{cycle: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionCancel>>, TError,{cycle: string;number: number}, TContext> => {

const mutationKey = ['v1QuizAdminCycleRecipeRevisionCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionCancel>>, {cycle: string;number: number}> = (props) => {
          const {cycle,number} = props ?? {};

          return  v1QuizAdminCycleRecipeRevisionCancel(cycle,number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminCycleRecipeRevisionCancelMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionCancel>>>

    export type V1QuizAdminCycleRecipeRevisionCancelMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Anulowanie porzuconej wersji roboczej
 */
export const useV1QuizAdminCycleRecipeRevisionCancel = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionCancel>>, TError,{cycle: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionCancel>>,
        TError,
        {cycle: string;number: number},
        TContext
      > => {
      return useMutation(getV1QuizAdminCycleRecipeRevisionCancelMutationOptions(options), queryClient);
    }

export type v1QuizAdminCycleRecipeRevisionPreviewResponse200 = {
  data: AdminQuizCyclePreview
  status: 200
}

export type v1QuizAdminCycleRecipeRevisionPreviewResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminCycleRecipeRevisionPreviewResponse404 = {
  data: void
  status: 404
}

export type v1QuizAdminCycleRecipeRevisionPreviewResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminCycleRecipeRevisionPreviewResponseSuccess = (v1QuizAdminCycleRecipeRevisionPreviewResponse200) & {
  headers: Headers;
};
export type v1QuizAdminCycleRecipeRevisionPreviewResponseError = (v1QuizAdminCycleRecipeRevisionPreviewResponse401 | v1QuizAdminCycleRecipeRevisionPreviewResponse404 | v1QuizAdminCycleRecipeRevisionPreviewResponse410) & {
  headers: Headers;
};

export type v1QuizAdminCycleRecipeRevisionPreviewResponse = (v1QuizAdminCycleRecipeRevisionPreviewResponseSuccess | v1QuizAdminCycleRecipeRevisionPreviewResponseError)

export const getV1QuizAdminCycleRecipeRevisionPreviewUrl = (cycle: string,
    number: number,) => {




  return `/api/v1/quiz/admin/cycle-recipes/${cycle}/revisions/${number}/preview/`
}

/**
 * @summary Podgląd doboru pytań dla wersji konfiguracji
 */
export const v1QuizAdminCycleRecipeRevisionPreview = async (cycle: string,
    number: number,
    adminQuizCyclePreviewRequestRequest?: AdminQuizCyclePreviewRequestRequest, options?: RequestInit): Promise<v1QuizAdminCycleRecipeRevisionPreviewResponse> => {

  return customFetch<v1QuizAdminCycleRecipeRevisionPreviewResponse>(getV1QuizAdminCycleRecipeRevisionPreviewUrl(cycle,number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminQuizCyclePreviewRequestRequest)
  }
);}




export const getV1QuizAdminCycleRecipeRevisionPreviewMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionPreview>>, TError,{cycle: string;number: number;data?: AdminQuizCyclePreviewRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionPreview>>, TError,{cycle: string;number: number;data?: AdminQuizCyclePreviewRequestRequest}, TContext> => {

const mutationKey = ['v1QuizAdminCycleRecipeRevisionPreview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionPreview>>, {cycle: string;number: number;data?: AdminQuizCyclePreviewRequestRequest}> = (props) => {
          const {cycle,number,data} = props ?? {};

          return  v1QuizAdminCycleRecipeRevisionPreview(cycle,number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminCycleRecipeRevisionPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionPreview>>>
    export type V1QuizAdminCycleRecipeRevisionPreviewMutationBody = AdminQuizCyclePreviewRequestRequest | undefined
    export type V1QuizAdminCycleRecipeRevisionPreviewMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Podgląd doboru pytań dla wersji konfiguracji
 */
export const useV1QuizAdminCycleRecipeRevisionPreview = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionPreview>>, TError,{cycle: string;number: number;data?: AdminQuizCyclePreviewRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionPreview>>,
        TError,
        {cycle: string;number: number;data?: AdminQuizCyclePreviewRequestRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminCycleRecipeRevisionPreviewMutationOptions(options), queryClient);
    }

export type v1QuizAdminCycleRecipeRevisionValidateResponse200 = {
  data: AdminQuizCycleRecipeValidation
  status: 200
}

export type v1QuizAdminCycleRecipeRevisionValidateResponse400 = {
  data: void
  status: 400
}

export type v1QuizAdminCycleRecipeRevisionValidateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminCycleRecipeRevisionValidateResponse404 = {
  data: void
  status: 404
}

export type v1QuizAdminCycleRecipeRevisionValidateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminCycleRecipeRevisionValidateResponseSuccess = (v1QuizAdminCycleRecipeRevisionValidateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminCycleRecipeRevisionValidateResponseError = (v1QuizAdminCycleRecipeRevisionValidateResponse400 | v1QuizAdminCycleRecipeRevisionValidateResponse401 | v1QuizAdminCycleRecipeRevisionValidateResponse404 | v1QuizAdminCycleRecipeRevisionValidateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminCycleRecipeRevisionValidateResponse = (v1QuizAdminCycleRecipeRevisionValidateResponseSuccess | v1QuizAdminCycleRecipeRevisionValidateResponseError)

export const getV1QuizAdminCycleRecipeRevisionValidateUrl = (cycle: string,
    number: number,) => {




  return `/api/v1/quiz/admin/cycle-recipes/${cycle}/revisions/${number}/validate/`
}

/**
 * @summary Walidacja wersji i gotowości banku przed publikacją
 */
export const v1QuizAdminCycleRecipeRevisionValidate = async (cycle: string,
    number: number, options?: RequestInit): Promise<v1QuizAdminCycleRecipeRevisionValidateResponse> => {

  return customFetch<v1QuizAdminCycleRecipeRevisionValidateResponse>(getV1QuizAdminCycleRecipeRevisionValidateUrl(cycle,number),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminCycleRecipeRevisionValidateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionValidate>>, TError,{cycle: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionValidate>>, TError,{cycle: string;number: number}, TContext> => {

const mutationKey = ['v1QuizAdminCycleRecipeRevisionValidate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionValidate>>, {cycle: string;number: number}> = (props) => {
          const {cycle,number} = props ?? {};

          return  v1QuizAdminCycleRecipeRevisionValidate(cycle,number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminCycleRecipeRevisionValidateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionValidate>>>

    export type V1QuizAdminCycleRecipeRevisionValidateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Walidacja wersji i gotowości banku przed publikacją
 */
export const useV1QuizAdminCycleRecipeRevisionValidate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionValidate>>, TError,{cycle: string;number: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminCycleRecipeRevisionValidate>>,
        TError,
        {cycle: string;number: number},
        TContext
      > => {
      return useMutation(getV1QuizAdminCycleRecipeRevisionValidateMutationOptions(options), queryClient);
    }

export type v1QuizAdminPushQuizzesListResponse200 = {
  data: PaginatedAdminPushQuizList
  status: 200
}

export type v1QuizAdminPushQuizzesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesListResponseSuccess = (v1QuizAdminPushQuizzesListResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesListResponseError = (v1QuizAdminPushQuizzesListResponse401 | v1QuizAdminPushQuizzesListResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesListResponse = (v1QuizAdminPushQuizzesListResponseSuccess | v1QuizAdminPushQuizzesListResponseError)

export const getV1QuizAdminPushQuizzesListUrl = (params?: V1QuizAdminPushQuizzesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/quiz/admin/push-quizzes/?${stringifiedParams}` : `/api/v1/quiz/admin/push-quizzes/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Lista quizów push (operator)
 */
export const v1QuizAdminPushQuizzesList = async (params?: V1QuizAdminPushQuizzesListParams, options?: RequestInit): Promise<v1QuizAdminPushQuizzesListResponse> => {

  return customFetch<v1QuizAdminPushQuizzesListResponse>(getV1QuizAdminPushQuizzesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminPushQuizzesListQueryKey = (params?: V1QuizAdminPushQuizzesListParams,) => {
    return [
    `/api/v1/quiz/admin/push-quizzes/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1QuizAdminPushQuizzesListQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1QuizAdminPushQuizzesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminPushQuizzesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>> = ({ signal }) => v1QuizAdminPushQuizzesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminPushQuizzesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>>
export type V1QuizAdminPushQuizzesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminPushQuizzesList<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1QuizAdminPushQuizzesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminPushQuizzesList<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1QuizAdminPushQuizzesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminPushQuizzesList<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1QuizAdminPushQuizzesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista quizów push (operator)
 */

export function useV1QuizAdminPushQuizzesList<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1QuizAdminPushQuizzesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminPushQuizzesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminPushQuizzesCreateResponse201 = {
  data: AdminPushQuiz
  status: 201
}

export type v1QuizAdminPushQuizzesCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesCreateResponseSuccess = (v1QuizAdminPushQuizzesCreateResponse201) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesCreateResponseError = (v1QuizAdminPushQuizzesCreateResponse401 | v1QuizAdminPushQuizzesCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesCreateResponse = (v1QuizAdminPushQuizzesCreateResponseSuccess | v1QuizAdminPushQuizzesCreateResponseError)

export const getV1QuizAdminPushQuizzesCreateUrl = () => {




  return `/api/v1/quiz/admin/push-quizzes/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Utworzenie szkicu quizu push
 */
export const v1QuizAdminPushQuizzesCreate = async (adminPushQuizWriteRequest: AdminPushQuizWriteRequest, options?: RequestInit): Promise<v1QuizAdminPushQuizzesCreateResponse> => {

  return customFetch<v1QuizAdminPushQuizzesCreateResponse>(getV1QuizAdminPushQuizzesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminPushQuizWriteRequest)
  }
);}




export const getV1QuizAdminPushQuizzesCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCreate>>, TError,{data: AdminPushQuizWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCreate>>, TError,{data: AdminPushQuizWriteRequest}, TContext> => {

const mutationKey = ['v1QuizAdminPushQuizzesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCreate>>, {data: AdminPushQuizWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1QuizAdminPushQuizzesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminPushQuizzesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCreate>>>
    export type V1QuizAdminPushQuizzesCreateMutationBody = AdminPushQuizWriteRequest
    export type V1QuizAdminPushQuizzesCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Utworzenie szkicu quizu push
 */
export const useV1QuizAdminPushQuizzesCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCreate>>, TError,{data: AdminPushQuizWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCreate>>,
        TError,
        {data: AdminPushQuizWriteRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminPushQuizzesCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminPushQuizzesRetrieveResponse200 = {
  data: AdminPushQuiz
  status: 200
}

export type v1QuizAdminPushQuizzesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesRetrieveResponseSuccess = (v1QuizAdminPushQuizzesRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesRetrieveResponseError = (v1QuizAdminPushQuizzesRetrieveResponse401 | v1QuizAdminPushQuizzesRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesRetrieveResponse = (v1QuizAdminPushQuizzesRetrieveResponseSuccess | v1QuizAdminPushQuizzesRetrieveResponseError)

export const getV1QuizAdminPushQuizzesRetrieveUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Szczegóły quizu push (operator)
 */
export const v1QuizAdminPushQuizzesRetrieve = async (uid: string, options?: RequestInit): Promise<v1QuizAdminPushQuizzesRetrieveResponse> => {

  return customFetch<v1QuizAdminPushQuizzesRetrieveResponse>(getV1QuizAdminPushQuizzesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminPushQuizzesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/quiz/admin/push-quizzes/${uid}/`
    ] as const;
    }


export const getV1QuizAdminPushQuizzesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminPushQuizzesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>> = ({ signal }) => v1QuizAdminPushQuizzesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminPushQuizzesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>>
export type V1QuizAdminPushQuizzesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminPushQuizzesRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminPushQuizzesRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminPushQuizzesRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły quizu push (operator)
 */

export function useV1QuizAdminPushQuizzesRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminPushQuizzesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminPushQuizzesUpdateResponse200 = {
  data: AdminPushQuiz
  status: 200
}

export type v1QuizAdminPushQuizzesUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesUpdateResponseSuccess = (v1QuizAdminPushQuizzesUpdateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesUpdateResponseError = (v1QuizAdminPushQuizzesUpdateResponse401 | v1QuizAdminPushQuizzesUpdateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesUpdateResponse = (v1QuizAdminPushQuizzesUpdateResponseSuccess | v1QuizAdminPushQuizzesUpdateResponseError)

export const getV1QuizAdminPushQuizzesUpdateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Edycja quizu push (szkic: wszystkie pola; opublikowany: nazwa i opis)
 */
export const v1QuizAdminPushQuizzesUpdate = async (uid: string,
    adminPushQuizWriteRequest: AdminPushQuizWriteRequest, options?: RequestInit): Promise<v1QuizAdminPushQuizzesUpdateResponse> => {

  return customFetch<v1QuizAdminPushQuizzesUpdateResponse>(getV1QuizAdminPushQuizzesUpdateUrl(uid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminPushQuizWriteRequest)
  }
);}




export const getV1QuizAdminPushQuizzesUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesUpdate>>, TError,{uid: string;data: AdminPushQuizWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesUpdate>>, TError,{uid: string;data: AdminPushQuizWriteRequest}, TContext> => {

const mutationKey = ['v1QuizAdminPushQuizzesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesUpdate>>, {uid: string;data: AdminPushQuizWriteRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1QuizAdminPushQuizzesUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminPushQuizzesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesUpdate>>>
    export type V1QuizAdminPushQuizzesUpdateMutationBody = AdminPushQuizWriteRequest
    export type V1QuizAdminPushQuizzesUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Edycja quizu push (szkic: wszystkie pola; opublikowany: nazwa i opis)
 */
export const useV1QuizAdminPushQuizzesUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesUpdate>>, TError,{uid: string;data: AdminPushQuizWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminPushQuizzesUpdate>>,
        TError,
        {uid: string;data: AdminPushQuizWriteRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminPushQuizzesUpdateMutationOptions(options), queryClient);
    }

export type v1QuizAdminPushQuizzesPartialUpdateResponse200 = {
  data: AdminPushQuiz
  status: 200
}

export type v1QuizAdminPushQuizzesPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesPartialUpdateResponseSuccess = (v1QuizAdminPushQuizzesPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesPartialUpdateResponseError = (v1QuizAdminPushQuizzesPartialUpdateResponse401 | v1QuizAdminPushQuizzesPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesPartialUpdateResponse = (v1QuizAdminPushQuizzesPartialUpdateResponseSuccess | v1QuizAdminPushQuizzesPartialUpdateResponseError)

export const getV1QuizAdminPushQuizzesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Częściowa edycja quizu push
 */
export const v1QuizAdminPushQuizzesPartialUpdate = async (uid: string,
    patchedAdminPushQuizWriteRequest?: PatchedAdminPushQuizWriteRequest, options?: RequestInit): Promise<v1QuizAdminPushQuizzesPartialUpdateResponse> => {

  return customFetch<v1QuizAdminPushQuizzesPartialUpdateResponse>(getV1QuizAdminPushQuizzesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminPushQuizWriteRequest)
  }
);}




export const getV1QuizAdminPushQuizzesPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPartialUpdate>>, TError,{uid: string;data?: PatchedAdminPushQuizWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPartialUpdate>>, TError,{uid: string;data?: PatchedAdminPushQuizWriteRequest}, TContext> => {

const mutationKey = ['v1QuizAdminPushQuizzesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPartialUpdate>>, {uid: string;data?: PatchedAdminPushQuizWriteRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1QuizAdminPushQuizzesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminPushQuizzesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPartialUpdate>>>
    export type V1QuizAdminPushQuizzesPartialUpdateMutationBody = PatchedAdminPushQuizWriteRequest | undefined
    export type V1QuizAdminPushQuizzesPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Częściowa edycja quizu push
 */
export const useV1QuizAdminPushQuizzesPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPartialUpdate>>, TError,{uid: string;data?: PatchedAdminPushQuizWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPartialUpdate>>,
        TError,
        {uid: string;data?: PatchedAdminPushQuizWriteRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminPushQuizzesPartialUpdateMutationOptions(options), queryClient);
    }

export type v1QuizAdminPushQuizzesDestroyResponse204 = {
  data: void
  status: 204
}

export type v1QuizAdminPushQuizzesDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesDestroyResponseSuccess = (v1QuizAdminPushQuizzesDestroyResponse204) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesDestroyResponseError = (v1QuizAdminPushQuizzesDestroyResponse401 | v1QuizAdminPushQuizzesDestroyResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesDestroyResponse = (v1QuizAdminPushQuizzesDestroyResponseSuccess | v1QuizAdminPushQuizzesDestroyResponseError)

export const getV1QuizAdminPushQuizzesDestroyUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Usunięcie quizu push (tylko szkic)
 */
export const v1QuizAdminPushQuizzesDestroy = async (uid: string, options?: RequestInit): Promise<v1QuizAdminPushQuizzesDestroyResponse> => {

  return customFetch<v1QuizAdminPushQuizzesDestroyResponse>(getV1QuizAdminPushQuizzesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getV1QuizAdminPushQuizzesDestroyMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDestroy>>, TError,{uid: string}, TContext> => {

const mutationKey = ['v1QuizAdminPushQuizzesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDestroy>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  v1QuizAdminPushQuizzesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminPushQuizzesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDestroy>>>

    export type V1QuizAdminPushQuizzesDestroyMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Usunięcie quizu push (tylko szkic)
 */
export const useV1QuizAdminPushQuizzesDestroy = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDestroy>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDestroy>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getV1QuizAdminPushQuizzesDestroyMutationOptions(options), queryClient);
    }

export type v1QuizAdminPushQuizzesArchiveCreateResponse200 = {
  data: AdminPushQuiz
  status: 200
}

export type v1QuizAdminPushQuizzesArchiveCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesArchiveCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesArchiveCreateResponseSuccess = (v1QuizAdminPushQuizzesArchiveCreateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesArchiveCreateResponseError = (v1QuizAdminPushQuizzesArchiveCreateResponse401 | v1QuizAdminPushQuizzesArchiveCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesArchiveCreateResponse = (v1QuizAdminPushQuizzesArchiveCreateResponseSuccess | v1QuizAdminPushQuizzesArchiveCreateResponseError)

export const getV1QuizAdminPushQuizzesArchiveCreateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/archive/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Archiwizacja quizu push (tylko opublikowany; nieodwracalna)
 */
export const v1QuizAdminPushQuizzesArchiveCreate = async (uid: string, options?: RequestInit): Promise<v1QuizAdminPushQuizzesArchiveCreateResponse> => {

  return customFetch<v1QuizAdminPushQuizzesArchiveCreateResponse>(getV1QuizAdminPushQuizzesArchiveCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminPushQuizzesArchiveCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesArchiveCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesArchiveCreate>>, TError,{uid: string}, TContext> => {

const mutationKey = ['v1QuizAdminPushQuizzesArchiveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesArchiveCreate>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  v1QuizAdminPushQuizzesArchiveCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminPushQuizzesArchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesArchiveCreate>>>

    export type V1QuizAdminPushQuizzesArchiveCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Archiwizacja quizu push (tylko opublikowany; nieodwracalna)
 */
export const useV1QuizAdminPushQuizzesArchiveCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesArchiveCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminPushQuizzesArchiveCreate>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getV1QuizAdminPushQuizzesArchiveCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminPushQuizzesCancelCreateResponse200 = {
  data: AdminPushQuiz
  status: 200
}

export type v1QuizAdminPushQuizzesCancelCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesCancelCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesCancelCreateResponseSuccess = (v1QuizAdminPushQuizzesCancelCreateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesCancelCreateResponseError = (v1QuizAdminPushQuizzesCancelCreateResponse401 | v1QuizAdminPushQuizzesCancelCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesCancelCreateResponse = (v1QuizAdminPushQuizzesCancelCreateResponseSuccess | v1QuizAdminPushQuizzesCancelCreateResponseError)

export const getV1QuizAdminPushQuizzesCancelCreateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/cancel/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Awaryjne anulowanie opublikowanego quizu — blokuje nowe sesje, zachowuje rozpoczęte sesje i punkty
 */
export const v1QuizAdminPushQuizzesCancelCreate = async (uid: string,
    adminPushQuizCancelRequest: AdminPushQuizCancelRequest, options?: RequestInit): Promise<v1QuizAdminPushQuizzesCancelCreateResponse> => {

  return customFetch<v1QuizAdminPushQuizzesCancelCreateResponse>(getV1QuizAdminPushQuizzesCancelCreateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminPushQuizCancelRequest)
  }
);}




export const getV1QuizAdminPushQuizzesCancelCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelCreate>>, TError,{uid: string;data: AdminPushQuizCancelRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelCreate>>, TError,{uid: string;data: AdminPushQuizCancelRequest}, TContext> => {

const mutationKey = ['v1QuizAdminPushQuizzesCancelCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelCreate>>, {uid: string;data: AdminPushQuizCancelRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1QuizAdminPushQuizzesCancelCreate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminPushQuizzesCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelCreate>>>
    export type V1QuizAdminPushQuizzesCancelCreateMutationBody = AdminPushQuizCancelRequest
    export type V1QuizAdminPushQuizzesCancelCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Awaryjne anulowanie opublikowanego quizu — blokuje nowe sesje, zachowuje rozpoczęte sesje i punkty
 */
export const useV1QuizAdminPushQuizzesCancelCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelCreate>>, TError,{uid: string;data: AdminPushQuizCancelRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelCreate>>,
        TError,
        {uid: string;data: AdminPushQuizCancelRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminPushQuizzesCancelCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminPushQuizzesCancelScheduleCreateResponse200 = {
  data: AdminPushQuiz
  status: 200
}

export type v1QuizAdminPushQuizzesCancelScheduleCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesCancelScheduleCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesCancelScheduleCreateResponseSuccess = (v1QuizAdminPushQuizzesCancelScheduleCreateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesCancelScheduleCreateResponseError = (v1QuizAdminPushQuizzesCancelScheduleCreateResponse401 | v1QuizAdminPushQuizzesCancelScheduleCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesCancelScheduleCreateResponse = (v1QuizAdminPushQuizzesCancelScheduleCreateResponseSuccess | v1QuizAdminPushQuizzesCancelScheduleCreateResponseError)

export const getV1QuizAdminPushQuizzesCancelScheduleCreateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/cancel-schedule/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Anulowanie planowania quizu push — powrót do szkicu
 */
export const v1QuizAdminPushQuizzesCancelScheduleCreate = async (uid: string, options?: RequestInit): Promise<v1QuizAdminPushQuizzesCancelScheduleCreateResponse> => {

  return customFetch<v1QuizAdminPushQuizzesCancelScheduleCreateResponse>(getV1QuizAdminPushQuizzesCancelScheduleCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminPushQuizzesCancelScheduleCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelScheduleCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelScheduleCreate>>, TError,{uid: string}, TContext> => {

const mutationKey = ['v1QuizAdminPushQuizzesCancelScheduleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelScheduleCreate>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  v1QuizAdminPushQuizzesCancelScheduleCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminPushQuizzesCancelScheduleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelScheduleCreate>>>

    export type V1QuizAdminPushQuizzesCancelScheduleCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Anulowanie planowania quizu push — powrót do szkicu
 */
export const useV1QuizAdminPushQuizzesCancelScheduleCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelScheduleCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminPushQuizzesCancelScheduleCreate>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getV1QuizAdminPushQuizzesCancelScheduleCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponse200 = {
  data: AdminPushQuizDistributionPreview
  status: 200
}

export type v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponseSuccess = (v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponseError = (v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponse401 | v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponse = (v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponseSuccess | v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponseError)

export const getV1QuizAdminPushQuizzesDistributionPreviewRetrieveUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/distribution-preview/`
}

/**
 * Pre-flight before committing a distribution (feature 080, A13).
 *
 * Advisory, never blocking — the operator decides. Publishing and scheduling
 * record the same warnings in their audit event, so the decision is legible
 * afterwards even for a client that never calls this.
 * @summary Podgląd dystrybucji: liczba odbiorców + kolizje terminów (ostrzeżenia)
 */
export const v1QuizAdminPushQuizzesDistributionPreviewRetrieve = async (uid: string, options?: RequestInit): Promise<v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponse> => {

  return customFetch<v1QuizAdminPushQuizzesDistributionPreviewRetrieveResponse>(getV1QuizAdminPushQuizzesDistributionPreviewRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminPushQuizzesDistributionPreviewRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/quiz/admin/push-quizzes/${uid}/distribution-preview/`
    ] as const;
    }


export const getV1QuizAdminPushQuizzesDistributionPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminPushQuizzesDistributionPreviewRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>> = ({ signal }) => v1QuizAdminPushQuizzesDistributionPreviewRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminPushQuizzesDistributionPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>>
export type V1QuizAdminPushQuizzesDistributionPreviewRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminPushQuizzesDistributionPreviewRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminPushQuizzesDistributionPreviewRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminPushQuizzesDistributionPreviewRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Podgląd dystrybucji: liczba odbiorców + kolizje terminów (ostrzeżenia)
 */

export function useV1QuizAdminPushQuizzesDistributionPreviewRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesDistributionPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminPushQuizzesDistributionPreviewRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminPushQuizzesPreviewRetrieveResponse200 = {
  data: AdminPushQuizPreview
  status: 200
}

export type v1QuizAdminPushQuizzesPreviewRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesPreviewRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesPreviewRetrieveResponseSuccess = (v1QuizAdminPushQuizzesPreviewRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesPreviewRetrieveResponseError = (v1QuizAdminPushQuizzesPreviewRetrieveResponse401 | v1QuizAdminPushQuizzesPreviewRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesPreviewRetrieveResponse = (v1QuizAdminPushQuizzesPreviewRetrieveResponseSuccess | v1QuizAdminPushQuizzesPreviewRetrieveResponseError)

export const getV1QuizAdminPushQuizzesPreviewRetrieveUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/preview/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Podgląd quizu push przed publikacją — aktualna liczba odbiorców i treść bez kluczy odpowiedzi
 */
export const v1QuizAdminPushQuizzesPreviewRetrieve = async (uid: string, options?: RequestInit): Promise<v1QuizAdminPushQuizzesPreviewRetrieveResponse> => {

  return customFetch<v1QuizAdminPushQuizzesPreviewRetrieveResponse>(getV1QuizAdminPushQuizzesPreviewRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminPushQuizzesPreviewRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/quiz/admin/push-quizzes/${uid}/preview/`
    ] as const;
    }


export const getV1QuizAdminPushQuizzesPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminPushQuizzesPreviewRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>> = ({ signal }) => v1QuizAdminPushQuizzesPreviewRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminPushQuizzesPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>>
export type V1QuizAdminPushQuizzesPreviewRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminPushQuizzesPreviewRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminPushQuizzesPreviewRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminPushQuizzesPreviewRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Podgląd quizu push przed publikacją — aktualna liczba odbiorców i treść bez kluczy odpowiedzi
 */

export function useV1QuizAdminPushQuizzesPreviewRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminPushQuizzesPreviewRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminPushQuizzesPublishCreateResponse200 = {
  data: AdminPushQuiz
  status: 200
}

export type v1QuizAdminPushQuizzesPublishCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesPublishCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesPublishCreateResponseSuccess = (v1QuizAdminPushQuizzesPublishCreateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesPublishCreateResponseError = (v1QuizAdminPushQuizzesPublishCreateResponse401 | v1QuizAdminPushQuizzesPublishCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesPublishCreateResponse = (v1QuizAdminPushQuizzesPublishCreateResponseSuccess | v1QuizAdminPushQuizzesPublishCreateResponseError)

export const getV1QuizAdminPushQuizzesPublishCreateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/publish/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Publikacja quizu push — przypina rewizje i uruchamia powiadomienia
 */
export const v1QuizAdminPushQuizzesPublishCreate = async (uid: string, options?: RequestInit): Promise<v1QuizAdminPushQuizzesPublishCreateResponse> => {

  return customFetch<v1QuizAdminPushQuizzesPublishCreateResponse>(getV1QuizAdminPushQuizzesPublishCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminPushQuizzesPublishCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPublishCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPublishCreate>>, TError,{uid: string}, TContext> => {

const mutationKey = ['v1QuizAdminPushQuizzesPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPublishCreate>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  v1QuizAdminPushQuizzesPublishCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminPushQuizzesPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPublishCreate>>>

    export type V1QuizAdminPushQuizzesPublishCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Publikacja quizu push — przypina rewizje i uruchamia powiadomienia
 */
export const useV1QuizAdminPushQuizzesPublishCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPublishCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminPushQuizzesPublishCreate>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getV1QuizAdminPushQuizzesPublishCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminPushQuizzesResultsRetrieveResponse200 = {
  data: AdminPushQuizResults
  status: 200
}

export type v1QuizAdminPushQuizzesResultsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesResultsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesResultsRetrieveResponseSuccess = (v1QuizAdminPushQuizzesResultsRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesResultsRetrieveResponseError = (v1QuizAdminPushQuizzesResultsRetrieveResponse401 | v1QuizAdminPushQuizzesResultsRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesResultsRetrieveResponse = (v1QuizAdminPushQuizzesResultsRetrieveResponseSuccess | v1QuizAdminPushQuizzesResultsRetrieveResponseError)

export const getV1QuizAdminPushQuizzesResultsRetrieveUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/results/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Zbiorcze wyniki quizu push (operator; bez danych per uczeń)
 */
export const v1QuizAdminPushQuizzesResultsRetrieve = async (uid: string, options?: RequestInit): Promise<v1QuizAdminPushQuizzesResultsRetrieveResponse> => {

  return customFetch<v1QuizAdminPushQuizzesResultsRetrieveResponse>(getV1QuizAdminPushQuizzesResultsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminPushQuizzesResultsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/quiz/admin/push-quizzes/${uid}/results/`
    ] as const;
    }


export const getV1QuizAdminPushQuizzesResultsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminPushQuizzesResultsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>> = ({ signal }) => v1QuizAdminPushQuizzesResultsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminPushQuizzesResultsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>>
export type V1QuizAdminPushQuizzesResultsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminPushQuizzesResultsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminPushQuizzesResultsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminPushQuizzesResultsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Zbiorcze wyniki quizu push (operator; bez danych per uczeń)
 */

export function useV1QuizAdminPushQuizzesResultsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesResultsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminPushQuizzesResultsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminPushQuizzesRetryNotificationsCreateResponse200 = {
  data: AdminPushQuiz
  status: 200
}

export type v1QuizAdminPushQuizzesRetryNotificationsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesRetryNotificationsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesRetryNotificationsCreateResponseSuccess = (v1QuizAdminPushQuizzesRetryNotificationsCreateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesRetryNotificationsCreateResponseError = (v1QuizAdminPushQuizzesRetryNotificationsCreateResponse401 | v1QuizAdminPushQuizzesRetryNotificationsCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesRetryNotificationsCreateResponse = (v1QuizAdminPushQuizzesRetryNotificationsCreateResponseSuccess | v1QuizAdminPushQuizzesRetryNotificationsCreateResponseError)

export const getV1QuizAdminPushQuizzesRetryNotificationsCreateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/retry-notifications/`
}

/**
 * Re-run a publication fan-out that failed or reached nobody (feature 079, A2).
 *
 * Until this existed a fan-out that died mid-run — a killed worker, or FCM
 * credentials that were broken at publish time — had **no way out**: the claim
 * is committed before the first send, so the redelivered task saw the quiz was
 * no longer `pending` and returned 0, and the operator had no button.
 *
 * Safe to press repeatedly: a student gets a new intent only when they have none
 * yet (a crashed run, a class that joined the scope) or when their current one
 * failed on the transport after the outbox's own retries. Anyone already
 * delivered, without a capable device, rejected by FCM or held back by the policy
 * is skipped, so nobody is notified twice.
 *
 * The reminder is deliberately not retryable — it is at-most-once by design
 * (feature 071), and re-sending it risks a duplicate push to students who
 * already got one.
 * @summary Ponowienie nieudanej wysyłki powiadomień (pomija już powiadomionych)
 */
export const v1QuizAdminPushQuizzesRetryNotificationsCreate = async (uid: string, options?: RequestInit): Promise<v1QuizAdminPushQuizzesRetryNotificationsCreateResponse> => {

  return customFetch<v1QuizAdminPushQuizzesRetryNotificationsCreateResponse>(getV1QuizAdminPushQuizzesRetryNotificationsCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminPushQuizzesRetryNotificationsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetryNotificationsCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetryNotificationsCreate>>, TError,{uid: string}, TContext> => {

const mutationKey = ['v1QuizAdminPushQuizzesRetryNotificationsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetryNotificationsCreate>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  v1QuizAdminPushQuizzesRetryNotificationsCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminPushQuizzesRetryNotificationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetryNotificationsCreate>>>

    export type V1QuizAdminPushQuizzesRetryNotificationsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Ponowienie nieudanej wysyłki powiadomień (pomija już powiadomionych)
 */
export const useV1QuizAdminPushQuizzesRetryNotificationsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetryNotificationsCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminPushQuizzesRetryNotificationsCreate>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getV1QuizAdminPushQuizzesRetryNotificationsCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminPushQuizzesScheduleCreateResponse200 = {
  data: AdminPushQuiz
  status: 200
}

export type v1QuizAdminPushQuizzesScheduleCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminPushQuizzesScheduleCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminPushQuizzesScheduleCreateResponseSuccess = (v1QuizAdminPushQuizzesScheduleCreateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminPushQuizzesScheduleCreateResponseError = (v1QuizAdminPushQuizzesScheduleCreateResponse401 | v1QuizAdminPushQuizzesScheduleCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminPushQuizzesScheduleCreateResponse = (v1QuizAdminPushQuizzesScheduleCreateResponseSuccess | v1QuizAdminPushQuizzesScheduleCreateResponseError)

export const getV1QuizAdminPushQuizzesScheduleCreateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/push-quizzes/${uid}/schedule/`
}

/**
 * Push-quiz compose/lifecycle/results surface. Operator-only (P1).
 * @summary Zaplanowanie publikacji quizu push
 */
export const v1QuizAdminPushQuizzesScheduleCreate = async (uid: string,
    adminPushQuizScheduleRequest: AdminPushQuizScheduleRequest, options?: RequestInit): Promise<v1QuizAdminPushQuizzesScheduleCreateResponse> => {

  return customFetch<v1QuizAdminPushQuizzesScheduleCreateResponse>(getV1QuizAdminPushQuizzesScheduleCreateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminPushQuizScheduleRequest)
  }
);}




export const getV1QuizAdminPushQuizzesScheduleCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesScheduleCreate>>, TError,{uid: string;data: AdminPushQuizScheduleRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesScheduleCreate>>, TError,{uid: string;data: AdminPushQuizScheduleRequest}, TContext> => {

const mutationKey = ['v1QuizAdminPushQuizzesScheduleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesScheduleCreate>>, {uid: string;data: AdminPushQuizScheduleRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1QuizAdminPushQuizzesScheduleCreate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminPushQuizzesScheduleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesScheduleCreate>>>
    export type V1QuizAdminPushQuizzesScheduleCreateMutationBody = AdminPushQuizScheduleRequest
    export type V1QuizAdminPushQuizzesScheduleCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Zaplanowanie publikacji quizu push
 */
export const useV1QuizAdminPushQuizzesScheduleCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminPushQuizzesScheduleCreate>>, TError,{uid: string;data: AdminPushQuizScheduleRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminPushQuizzesScheduleCreate>>,
        TError,
        {uid: string;data: AdminPushQuizScheduleRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminPushQuizzesScheduleCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminQuestionImportsCommitCreateResponse200 = {
  data: AdminQuestionImportCommit
  status: 200
}

export type v1QuizAdminQuestionImportsCommitCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionImportsCommitCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionImportsCommitCreateResponseSuccess = (v1QuizAdminQuestionImportsCommitCreateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminQuestionImportsCommitCreateResponseError = (v1QuizAdminQuestionImportsCommitCreateResponse401 | v1QuizAdminQuestionImportsCommitCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionImportsCommitCreateResponse = (v1QuizAdminQuestionImportsCommitCreateResponseSuccess | v1QuizAdminQuestionImportsCommitCreateResponseError)

export const getV1QuizAdminQuestionImportsCommitCreateUrl = (importId: string,) => {




  return `/api/v1/quiz/admin/question-imports/${importId}/commit/`
}

/**
 * `created_count` obejmuje nowe pytania oraz zastąpienia (`replaced_count` — kod przeniesiony z wycofanego pytania albo pytania innego typu na nowy szkic). `updated_count` to nowe rewizje istniejących pytań, `skipped_count` — wiersze identyczne z bieżącą treścią.
 * @summary Atomowe zatwierdzenie podglądu importu (upsert po content_code)
 */
export const v1QuizAdminQuestionImportsCommitCreate = async (importId: string, options?: RequestInit): Promise<v1QuizAdminQuestionImportsCommitCreateResponse> => {

  return customFetch<v1QuizAdminQuestionImportsCommitCreateResponse>(getV1QuizAdminQuestionImportsCommitCreateUrl(importId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminQuestionImportsCommitCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsCommitCreate>>, TError,{importId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsCommitCreate>>, TError,{importId: string}, TContext> => {

const mutationKey = ['v1QuizAdminQuestionImportsCommitCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsCommitCreate>>, {importId: string}> = (props) => {
          const {importId} = props ?? {};

          return  v1QuizAdminQuestionImportsCommitCreate(importId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminQuestionImportsCommitCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsCommitCreate>>>

    export type V1QuizAdminQuestionImportsCommitCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Atomowe zatwierdzenie podglądu importu (upsert po content_code)
 */
export const useV1QuizAdminQuestionImportsCommitCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsCommitCreate>>, TError,{importId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminQuestionImportsCommitCreate>>,
        TError,
        {importId: string},
        TContext
      > => {
      return useMutation(getV1QuizAdminQuestionImportsCommitCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminQuestionImportsPreviewCreateResponse201 = {
  data: AdminQuestionImportPreview
  status: 201
}

export type v1QuizAdminQuestionImportsPreviewCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionImportsPreviewCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionImportsPreviewCreateResponseSuccess = (v1QuizAdminQuestionImportsPreviewCreateResponse201) & {
  headers: Headers;
};
export type v1QuizAdminQuestionImportsPreviewCreateResponseError = (v1QuizAdminQuestionImportsPreviewCreateResponse401 | v1QuizAdminQuestionImportsPreviewCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionImportsPreviewCreateResponse = (v1QuizAdminQuestionImportsPreviewCreateResponseSuccess | v1QuizAdminQuestionImportsPreviewCreateResponseError)

export const getV1QuizAdminQuestionImportsPreviewCreateUrl = () => {




  return `/api/v1/quiz/admin/question-imports/preview/`
}

/**
 * @summary Walidacja XLSX lub JSON przed importem
 */
export const v1QuizAdminQuestionImportsPreviewCreate = async (adminQuestionImportUploadRequest: AdminQuestionImportUploadRequest, options?: RequestInit): Promise<v1QuizAdminQuestionImportsPreviewCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, adminQuestionImportUploadRequest.file);

  return customFetch<v1QuizAdminQuestionImportsPreviewCreateResponse>(getV1QuizAdminQuestionImportsPreviewCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getV1QuizAdminQuestionImportsPreviewCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsPreviewCreate>>, TError,{data: AdminQuestionImportUploadRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsPreviewCreate>>, TError,{data: AdminQuestionImportUploadRequest}, TContext> => {

const mutationKey = ['v1QuizAdminQuestionImportsPreviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsPreviewCreate>>, {data: AdminQuestionImportUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1QuizAdminQuestionImportsPreviewCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminQuestionImportsPreviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsPreviewCreate>>>
    export type V1QuizAdminQuestionImportsPreviewCreateMutationBody = AdminQuestionImportUploadRequest
    export type V1QuizAdminQuestionImportsPreviewCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Walidacja XLSX lub JSON przed importem
 */
export const useV1QuizAdminQuestionImportsPreviewCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsPreviewCreate>>, TError,{data: AdminQuestionImportUploadRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminQuestionImportsPreviewCreate>>,
        TError,
        {data: AdminQuestionImportUploadRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminQuestionImportsPreviewCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminQuestionImportsTemplateRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type v1QuizAdminQuestionImportsTemplateRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionImportsTemplateRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionImportsTemplateRetrieveResponseSuccess = (v1QuizAdminQuestionImportsTemplateRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizAdminQuestionImportsTemplateRetrieveResponseError = (v1QuizAdminQuestionImportsTemplateRetrieveResponse401 | v1QuizAdminQuestionImportsTemplateRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionImportsTemplateRetrieveResponse = (v1QuizAdminQuestionImportsTemplateRetrieveResponseSuccess | v1QuizAdminQuestionImportsTemplateRetrieveResponseError)

export const getV1QuizAdminQuestionImportsTemplateRetrieveUrl = () => {




  return `/api/v1/quiz/admin/question-imports/template/`
}

/**
 * @summary Szablon XLSX importu banku pytań
 */
export const v1QuizAdminQuestionImportsTemplateRetrieve = async ( options?: RequestInit): Promise<v1QuizAdminQuestionImportsTemplateRetrieveResponse> => {

  return customFetch<v1QuizAdminQuestionImportsTemplateRetrieveResponse>(getV1QuizAdminQuestionImportsTemplateRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminQuestionImportsTemplateRetrieveQueryKey = () => {
    return [
    `/api/v1/quiz/admin/question-imports/template/`
    ] as const;
    }


export const getV1QuizAdminQuestionImportsTemplateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminQuestionImportsTemplateRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>> = ({ signal }) => v1QuizAdminQuestionImportsTemplateRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminQuestionImportsTemplateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>>
export type V1QuizAdminQuestionImportsTemplateRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminQuestionImportsTemplateRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminQuestionImportsTemplateRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminQuestionImportsTemplateRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szablon XLSX importu banku pytań
 */

export function useV1QuizAdminQuestionImportsTemplateRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionImportsTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminQuestionImportsTemplateRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminQuestionsListResponse200 = {
  data: PaginatedAdminQuestionList
  status: 200
}

export type v1QuizAdminQuestionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionsListResponseSuccess = (v1QuizAdminQuestionsListResponse200) & {
  headers: Headers;
};
export type v1QuizAdminQuestionsListResponseError = (v1QuizAdminQuestionsListResponse401 | v1QuizAdminQuestionsListResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionsListResponse = (v1QuizAdminQuestionsListResponseSuccess | v1QuizAdminQuestionsListResponseError)

export const getV1QuizAdminQuestionsListUrl = (params?: V1QuizAdminQuestionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/quiz/admin/questions/?${stringifiedParams}` : `/api/v1/quiz/admin/questions/`
}

/**
 * Question bank CRUD-minus-delete + lifecycle actions. Operator-only.
 * @summary Lista pytań quizowych (operator)
 */
export const v1QuizAdminQuestionsList = async (params?: V1QuizAdminQuestionsListParams, options?: RequestInit): Promise<v1QuizAdminQuestionsListResponse> => {

  return customFetch<v1QuizAdminQuestionsListResponse>(getV1QuizAdminQuestionsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminQuestionsListQueryKey = (params?: V1QuizAdminQuestionsListParams,) => {
    return [
    `/api/v1/quiz/admin/questions/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1QuizAdminQuestionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1QuizAdminQuestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminQuestionsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>> = ({ signal }) => v1QuizAdminQuestionsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminQuestionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>>
export type V1QuizAdminQuestionsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminQuestionsList<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1QuizAdminQuestionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminQuestionsList<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1QuizAdminQuestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminQuestionsList<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1QuizAdminQuestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista pytań quizowych (operator)
 */

export function useV1QuizAdminQuestionsList<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1QuizAdminQuestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminQuestionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminQuestionsCreateResponse201 = {
  data: AdminQuestion
  status: 201
}

export type v1QuizAdminQuestionsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionsCreateResponseSuccess = (v1QuizAdminQuestionsCreateResponse201) & {
  headers: Headers;
};
export type v1QuizAdminQuestionsCreateResponseError = (v1QuizAdminQuestionsCreateResponse401 | v1QuizAdminQuestionsCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionsCreateResponse = (v1QuizAdminQuestionsCreateResponseSuccess | v1QuizAdminQuestionsCreateResponseError)

export const getV1QuizAdminQuestionsCreateUrl = () => {




  return `/api/v1/quiz/admin/questions/`
}

/**
 * Question bank CRUD-minus-delete + lifecycle actions. Operator-only.
 * @summary Utworzenie pytania (szkic, rewizja 1)
 */
export const v1QuizAdminQuestionsCreate = async (adminQuestionCreateRequest: AdminQuestionCreateRequest, options?: RequestInit): Promise<v1QuizAdminQuestionsCreateResponse> => {

  return customFetch<v1QuizAdminQuestionsCreateResponse>(getV1QuizAdminQuestionsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminQuestionCreateRequest)
  }
);}




export const getV1QuizAdminQuestionsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsCreate>>, TError,{data: AdminQuestionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsCreate>>, TError,{data: AdminQuestionCreateRequest}, TContext> => {

const mutationKey = ['v1QuizAdminQuestionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionsCreate>>, {data: AdminQuestionCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1QuizAdminQuestionsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminQuestionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionsCreate>>>
    export type V1QuizAdminQuestionsCreateMutationBody = AdminQuestionCreateRequest
    export type V1QuizAdminQuestionsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Utworzenie pytania (szkic, rewizja 1)
 */
export const useV1QuizAdminQuestionsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsCreate>>, TError,{data: AdminQuestionCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminQuestionsCreate>>,
        TError,
        {data: AdminQuestionCreateRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminQuestionsCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminQuestionsRetrieveResponse200 = {
  data: AdminQuestion
  status: 200
}

export type v1QuizAdminQuestionsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionsRetrieveResponseSuccess = (v1QuizAdminQuestionsRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizAdminQuestionsRetrieveResponseError = (v1QuizAdminQuestionsRetrieveResponse401 | v1QuizAdminQuestionsRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionsRetrieveResponse = (v1QuizAdminQuestionsRetrieveResponseSuccess | v1QuizAdminQuestionsRetrieveResponseError)

export const getV1QuizAdminQuestionsRetrieveUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/questions/${uid}/`
}

/**
 * Question bank CRUD-minus-delete + lifecycle actions. Operator-only.
 * @summary Szczegóły pytania z rewizjami i kluczem (operator)
 */
export const v1QuizAdminQuestionsRetrieve = async (uid: string, options?: RequestInit): Promise<v1QuizAdminQuestionsRetrieveResponse> => {

  return customFetch<v1QuizAdminQuestionsRetrieveResponse>(getV1QuizAdminQuestionsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminQuestionsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/quiz/admin/questions/${uid}/`
    ] as const;
    }


export const getV1QuizAdminQuestionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminQuestionsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>> = ({ signal }) => v1QuizAdminQuestionsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminQuestionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>>
export type V1QuizAdminQuestionsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminQuestionsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminQuestionsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminQuestionsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły pytania z rewizjami i kluczem (operator)
 */

export function useV1QuizAdminQuestionsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminQuestionsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminQuestionsModulesPartialUpdateResponse200 = {
  data: AdminQuestion
  status: 200
}

export type v1QuizAdminQuestionsModulesPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionsModulesPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionsModulesPartialUpdateResponseSuccess = (v1QuizAdminQuestionsModulesPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminQuestionsModulesPartialUpdateResponseError = (v1QuizAdminQuestionsModulesPartialUpdateResponse401 | v1QuizAdminQuestionsModulesPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionsModulesPartialUpdateResponse = (v1QuizAdminQuestionsModulesPartialUpdateResponseSuccess | v1QuizAdminQuestionsModulesPartialUpdateResponseError)

export const getV1QuizAdminQuestionsModulesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/questions/${uid}/modules/`
}

/**
 * Question bank CRUD-minus-delete + lifecycle actions. Operator-only.
 * @summary Ustaw moduły pytania (metadana, bez nowej rewizji)
 */
export const v1QuizAdminQuestionsModulesPartialUpdate = async (uid: string,
    patchedAdminQuestionModulesRequest?: PatchedAdminQuestionModulesRequest, options?: RequestInit): Promise<v1QuizAdminQuestionsModulesPartialUpdateResponse> => {

  return customFetch<v1QuizAdminQuestionsModulesPartialUpdateResponse>(getV1QuizAdminQuestionsModulesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminQuestionModulesRequest)
  }
);}




export const getV1QuizAdminQuestionsModulesPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsModulesPartialUpdate>>, TError,{uid: string;data?: PatchedAdminQuestionModulesRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsModulesPartialUpdate>>, TError,{uid: string;data?: PatchedAdminQuestionModulesRequest}, TContext> => {

const mutationKey = ['v1QuizAdminQuestionsModulesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionsModulesPartialUpdate>>, {uid: string;data?: PatchedAdminQuestionModulesRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1QuizAdminQuestionsModulesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminQuestionsModulesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionsModulesPartialUpdate>>>
    export type V1QuizAdminQuestionsModulesPartialUpdateMutationBody = PatchedAdminQuestionModulesRequest | undefined
    export type V1QuizAdminQuestionsModulesPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Ustaw moduły pytania (metadana, bez nowej rewizji)
 */
export const useV1QuizAdminQuestionsModulesPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsModulesPartialUpdate>>, TError,{uid: string;data?: PatchedAdminQuestionModulesRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminQuestionsModulesPartialUpdate>>,
        TError,
        {uid: string;data?: PatchedAdminQuestionModulesRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminQuestionsModulesPartialUpdateMutationOptions(options), queryClient);
    }

export type v1QuizAdminQuestionsPublishCreateResponse200 = {
  data: AdminQuestion
  status: 200
}

export type v1QuizAdminQuestionsPublishCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionsPublishCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionsPublishCreateResponseSuccess = (v1QuizAdminQuestionsPublishCreateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminQuestionsPublishCreateResponseError = (v1QuizAdminQuestionsPublishCreateResponse401 | v1QuizAdminQuestionsPublishCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionsPublishCreateResponse = (v1QuizAdminQuestionsPublishCreateResponseSuccess | v1QuizAdminQuestionsPublishCreateResponseError)

export const getV1QuizAdminQuestionsPublishCreateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/questions/${uid}/publish/`
}

/**
 * Question bank CRUD-minus-delete + lifecycle actions. Operator-only.
 * @summary Publikacja najnowszej rewizji (repoints current_revision)
 */
export const v1QuizAdminQuestionsPublishCreate = async (uid: string, options?: RequestInit): Promise<v1QuizAdminQuestionsPublishCreateResponse> => {

  return customFetch<v1QuizAdminQuestionsPublishCreateResponse>(getV1QuizAdminQuestionsPublishCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminQuestionsPublishCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsPublishCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsPublishCreate>>, TError,{uid: string}, TContext> => {

const mutationKey = ['v1QuizAdminQuestionsPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionsPublishCreate>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  v1QuizAdminQuestionsPublishCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminQuestionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionsPublishCreate>>>

    export type V1QuizAdminQuestionsPublishCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Publikacja najnowszej rewizji (repoints current_revision)
 */
export const useV1QuizAdminQuestionsPublishCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsPublishCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminQuestionsPublishCreate>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getV1QuizAdminQuestionsPublishCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminQuestionsRetireCreateResponse200 = {
  data: AdminQuestion
  status: 200
}

export type v1QuizAdminQuestionsRetireCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionsRetireCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionsRetireCreateResponseSuccess = (v1QuizAdminQuestionsRetireCreateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminQuestionsRetireCreateResponseError = (v1QuizAdminQuestionsRetireCreateResponse401 | v1QuizAdminQuestionsRetireCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionsRetireCreateResponse = (v1QuizAdminQuestionsRetireCreateResponseSuccess | v1QuizAdminQuestionsRetireCreateResponseError)

export const getV1QuizAdminQuestionsRetireCreateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/questions/${uid}/retire/`
}

/**
 * Question bank CRUD-minus-delete + lifecycle actions. Operator-only.
 * @summary Wycofanie pytania (historia zostaje, O3)
 */
export const v1QuizAdminQuestionsRetireCreate = async (uid: string, options?: RequestInit): Promise<v1QuizAdminQuestionsRetireCreateResponse> => {

  return customFetch<v1QuizAdminQuestionsRetireCreateResponse>(getV1QuizAdminQuestionsRetireCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1QuizAdminQuestionsRetireCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetireCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetireCreate>>, TError,{uid: string}, TContext> => {

const mutationKey = ['v1QuizAdminQuestionsRetireCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetireCreate>>, {uid: string}> = (props) => {
          const {uid} = props ?? {};

          return  v1QuizAdminQuestionsRetireCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminQuestionsRetireCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetireCreate>>>

    export type V1QuizAdminQuestionsRetireCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Wycofanie pytania (historia zostaje, O3)
 */
export const useV1QuizAdminQuestionsRetireCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsRetireCreate>>, TError,{uid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminQuestionsRetireCreate>>,
        TError,
        {uid: string},
        TContext
      > => {
      return useMutation(getV1QuizAdminQuestionsRetireCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminQuestionsReviseCreateResponse200 = {
  data: AdminQuestion
  status: 200
}

export type v1QuizAdminQuestionsReviseCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionsReviseCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionsReviseCreateResponseSuccess = (v1QuizAdminQuestionsReviseCreateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminQuestionsReviseCreateResponseError = (v1QuizAdminQuestionsReviseCreateResponse401 | v1QuizAdminQuestionsReviseCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionsReviseCreateResponse = (v1QuizAdminQuestionsReviseCreateResponseSuccess | v1QuizAdminQuestionsReviseCreateResponseError)

export const getV1QuizAdminQuestionsReviseCreateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/questions/${uid}/revise/`
}

/**
 * Question bank CRUD-minus-delete + lifecycle actions. Operator-only.
 * @summary Nowa rewizja pytania (edycja = nowa wersja, O3)
 */
export const v1QuizAdminQuestionsReviseCreate = async (uid: string,
    adminQuestionReviseRequest: AdminQuestionReviseRequest, options?: RequestInit): Promise<v1QuizAdminQuestionsReviseCreateResponse> => {

  return customFetch<v1QuizAdminQuestionsReviseCreateResponse>(getV1QuizAdminQuestionsReviseCreateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminQuestionReviseRequest)
  }
);}




export const getV1QuizAdminQuestionsReviseCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsReviseCreate>>, TError,{uid: string;data: AdminQuestionReviseRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsReviseCreate>>, TError,{uid: string;data: AdminQuestionReviseRequest}, TContext> => {

const mutationKey = ['v1QuizAdminQuestionsReviseCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionsReviseCreate>>, {uid: string;data: AdminQuestionReviseRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1QuizAdminQuestionsReviseCreate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminQuestionsReviseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionsReviseCreate>>>
    export type V1QuizAdminQuestionsReviseCreateMutationBody = AdminQuestionReviseRequest
    export type V1QuizAdminQuestionsReviseCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Nowa rewizja pytania (edycja = nowa wersja, O3)
 */
export const useV1QuizAdminQuestionsReviseCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsReviseCreate>>, TError,{uid: string;data: AdminQuestionReviseRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminQuestionsReviseCreate>>,
        TError,
        {uid: string;data: AdminQuestionReviseRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminQuestionsReviseCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminQuestionsTopicsPartialUpdateResponse200 = {
  data: AdminQuestion
  status: 200
}

export type v1QuizAdminQuestionsTopicsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionsTopicsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionsTopicsPartialUpdateResponseSuccess = (v1QuizAdminQuestionsTopicsPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminQuestionsTopicsPartialUpdateResponseError = (v1QuizAdminQuestionsTopicsPartialUpdateResponse401 | v1QuizAdminQuestionsTopicsPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionsTopicsPartialUpdateResponse = (v1QuizAdminQuestionsTopicsPartialUpdateResponseSuccess | v1QuizAdminQuestionsTopicsPartialUpdateResponseError)

export const getV1QuizAdminQuestionsTopicsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/quiz/admin/questions/${uid}/topics/`
}

/**
 * Question bank CRUD-minus-delete + lifecycle actions. Operator-only.
 * @summary Ustaw tematy pytania (metadana, bez nowej rewizji)
 */
export const v1QuizAdminQuestionsTopicsPartialUpdate = async (uid: string,
    patchedAdminQuestionTopicsRequest?: PatchedAdminQuestionTopicsRequest, options?: RequestInit): Promise<v1QuizAdminQuestionsTopicsPartialUpdateResponse> => {

  return customFetch<v1QuizAdminQuestionsTopicsPartialUpdateResponse>(getV1QuizAdminQuestionsTopicsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminQuestionTopicsRequest)
  }
);}




export const getV1QuizAdminQuestionsTopicsPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsTopicsPartialUpdate>>, TError,{uid: string;data?: PatchedAdminQuestionTopicsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsTopicsPartialUpdate>>, TError,{uid: string;data?: PatchedAdminQuestionTopicsRequest}, TContext> => {

const mutationKey = ['v1QuizAdminQuestionsTopicsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionsTopicsPartialUpdate>>, {uid: string;data?: PatchedAdminQuestionTopicsRequest}> = (props) => {
          const {uid,data} = props ?? {};

          return  v1QuizAdminQuestionsTopicsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminQuestionsTopicsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionsTopicsPartialUpdate>>>
    export type V1QuizAdminQuestionsTopicsPartialUpdateMutationBody = PatchedAdminQuestionTopicsRequest | undefined
    export type V1QuizAdminQuestionsTopicsPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Ustaw tematy pytania (metadana, bez nowej rewizji)
 */
export const useV1QuizAdminQuestionsTopicsPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsTopicsPartialUpdate>>, TError,{uid: string;data?: PatchedAdminQuestionTopicsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminQuestionsTopicsPartialUpdate>>,
        TError,
        {uid: string;data?: PatchedAdminQuestionTopicsRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminQuestionsTopicsPartialUpdateMutationOptions(options), queryClient);
    }

export type v1QuizAdminQuestionsBulkPublishResponse200 = {
  data: AdminQuestionBulkPublishResponse
  status: 200
}

export type v1QuizAdminQuestionsBulkPublishResponse400 = {
  data: void
  status: 400
}

export type v1QuizAdminQuestionsBulkPublishResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminQuestionsBulkPublishResponse403 = {
  data: void
  status: 403
}

export type v1QuizAdminQuestionsBulkPublishResponse409 = {
  data: AdminQuestionBulkPublishConflict
  status: 409
}

export type v1QuizAdminQuestionsBulkPublishResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminQuestionsBulkPublishResponseSuccess = (v1QuizAdminQuestionsBulkPublishResponse200) & {
  headers: Headers;
};
export type v1QuizAdminQuestionsBulkPublishResponseError = (v1QuizAdminQuestionsBulkPublishResponse400 | v1QuizAdminQuestionsBulkPublishResponse401 | v1QuizAdminQuestionsBulkPublishResponse403 | v1QuizAdminQuestionsBulkPublishResponse409 | v1QuizAdminQuestionsBulkPublishResponse410) & {
  headers: Headers;
};

export type v1QuizAdminQuestionsBulkPublishResponse = (v1QuizAdminQuestionsBulkPublishResponseSuccess | v1QuizAdminQuestionsBulkPublishResponseError)

export const getV1QuizAdminQuestionsBulkPublishUrl = () => {




  return `/api/v1/quiz/admin/questions/bulk-publish/`
}

/**
 * Question bank CRUD-minus-delete + lifecycle actions. Operator-only.
 * @summary Masowa publikacja szkiców pytań
 */
export const v1QuizAdminQuestionsBulkPublish = async (adminQuestionBulkPublishRequest: AdminQuestionBulkPublishRequest, options?: RequestInit): Promise<v1QuizAdminQuestionsBulkPublishResponse> => {

  return customFetch<v1QuizAdminQuestionsBulkPublishResponse>(getV1QuizAdminQuestionsBulkPublishUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminQuestionBulkPublishRequest)
  }
);}




export const getV1QuizAdminQuestionsBulkPublishMutationOptions = <TError = void | UnauthorizedResponse | AdminQuestionBulkPublishConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsBulkPublish>>, TError,{data: AdminQuestionBulkPublishRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsBulkPublish>>, TError,{data: AdminQuestionBulkPublishRequest}, TContext> => {

const mutationKey = ['v1QuizAdminQuestionsBulkPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminQuestionsBulkPublish>>, {data: AdminQuestionBulkPublishRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1QuizAdminQuestionsBulkPublish(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminQuestionsBulkPublishMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminQuestionsBulkPublish>>>
    export type V1QuizAdminQuestionsBulkPublishMutationBody = AdminQuestionBulkPublishRequest
    export type V1QuizAdminQuestionsBulkPublishMutationError = void | UnauthorizedResponse | AdminQuestionBulkPublishConflict | AccountGoneResponse

    /**
 * @summary Masowa publikacja szkiców pytań
 */
export const useV1QuizAdminQuestionsBulkPublish = <TError = void | UnauthorizedResponse | AdminQuestionBulkPublishConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminQuestionsBulkPublish>>, TError,{data: AdminQuestionBulkPublishRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminQuestionsBulkPublish>>,
        TError,
        {data: AdminQuestionBulkPublishRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminQuestionsBulkPublishMutationOptions(options), queryClient);
    }

export type v1QuizAdminTopicsListResponse200 = {
  data: PaginatedAdminQuizTopicList
  status: 200
}

export type v1QuizAdminTopicsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminTopicsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminTopicsListResponseSuccess = (v1QuizAdminTopicsListResponse200) & {
  headers: Headers;
};
export type v1QuizAdminTopicsListResponseError = (v1QuizAdminTopicsListResponse401 | v1QuizAdminTopicsListResponse410) & {
  headers: Headers;
};

export type v1QuizAdminTopicsListResponse = (v1QuizAdminTopicsListResponseSuccess | v1QuizAdminTopicsListResponseError)

export const getV1QuizAdminTopicsListUrl = (params?: V1QuizAdminTopicsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/quiz/admin/topics/?${stringifiedParams}` : `/api/v1/quiz/admin/topics/`
}

/**
 * Tematy pytań. Operator-only, bez DELETE.
 * @summary Słownik tematów pytań (z licznikami użycia)
 */
export const v1QuizAdminTopicsList = async (params?: V1QuizAdminTopicsListParams, options?: RequestInit): Promise<v1QuizAdminTopicsListResponse> => {

  return customFetch<v1QuizAdminTopicsListResponse>(getV1QuizAdminTopicsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminTopicsListQueryKey = (params?: V1QuizAdminTopicsListParams,) => {
    return [
    `/api/v1/quiz/admin/topics/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1QuizAdminTopicsListQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1QuizAdminTopicsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminTopicsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminTopicsList>>> = ({ signal }) => v1QuizAdminTopicsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminTopicsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminTopicsList>>>
export type V1QuizAdminTopicsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminTopicsList<TData = Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1QuizAdminTopicsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminTopicsList>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminTopicsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminTopicsList<TData = Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1QuizAdminTopicsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminTopicsList>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminTopicsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminTopicsList<TData = Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1QuizAdminTopicsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Słownik tematów pytań (z licznikami użycia)
 */

export function useV1QuizAdminTopicsList<TData = Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1QuizAdminTopicsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminTopicsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminTopicsCreateResponse201 = {
  data: AdminQuizTopic
  status: 201
}

export type v1QuizAdminTopicsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminTopicsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminTopicsCreateResponseSuccess = (v1QuizAdminTopicsCreateResponse201) & {
  headers: Headers;
};
export type v1QuizAdminTopicsCreateResponseError = (v1QuizAdminTopicsCreateResponse401 | v1QuizAdminTopicsCreateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminTopicsCreateResponse = (v1QuizAdminTopicsCreateResponseSuccess | v1QuizAdminTopicsCreateResponseError)

export const getV1QuizAdminTopicsCreateUrl = () => {




  return `/api/v1/quiz/admin/topics/`
}

/**
 * Tematy pytań. Operator-only, bez DELETE.
 * @summary Nowy temat w słowniku
 */
export const v1QuizAdminTopicsCreate = async (adminQuizTopicRequest: AdminQuizTopicRequest, options?: RequestInit): Promise<v1QuizAdminTopicsCreateResponse> => {

  return customFetch<v1QuizAdminTopicsCreateResponse>(getV1QuizAdminTopicsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminQuizTopicRequest)
  }
);}




export const getV1QuizAdminTopicsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsCreate>>, TError,{data: AdminQuizTopicRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsCreate>>, TError,{data: AdminQuizTopicRequest}, TContext> => {

const mutationKey = ['v1QuizAdminTopicsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminTopicsCreate>>, {data: AdminQuizTopicRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1QuizAdminTopicsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminTopicsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminTopicsCreate>>>
    export type V1QuizAdminTopicsCreateMutationBody = AdminQuizTopicRequest
    export type V1QuizAdminTopicsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Nowy temat w słowniku
 */
export const useV1QuizAdminTopicsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsCreate>>, TError,{data: AdminQuizTopicRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminTopicsCreate>>,
        TError,
        {data: AdminQuizTopicRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminTopicsCreateMutationOptions(options), queryClient);
    }

export type v1QuizAdminTopicsRetrieveResponse200 = {
  data: AdminQuizTopic
  status: 200
}

export type v1QuizAdminTopicsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminTopicsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminTopicsRetrieveResponseSuccess = (v1QuizAdminTopicsRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizAdminTopicsRetrieveResponseError = (v1QuizAdminTopicsRetrieveResponse401 | v1QuizAdminTopicsRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizAdminTopicsRetrieveResponse = (v1QuizAdminTopicsRetrieveResponseSuccess | v1QuizAdminTopicsRetrieveResponseError)

export const getV1QuizAdminTopicsRetrieveUrl = (slug: string,) => {




  return `/api/v1/quiz/admin/topics/${slug}/`
}

/**
 * Tematy pytań. Operator-only, bez DELETE.
 * @summary Temat ze słownika
 */
export const v1QuizAdminTopicsRetrieve = async (slug: string, options?: RequestInit): Promise<v1QuizAdminTopicsRetrieveResponse> => {

  return customFetch<v1QuizAdminTopicsRetrieveResponse>(getV1QuizAdminTopicsRetrieveUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAdminTopicsRetrieveQueryKey = (slug: string,) => {
    return [
    `/api/v1/quiz/admin/topics/${slug}/`
    ] as const;
    }


export const getV1QuizAdminTopicsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAdminTopicsRetrieveQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>> = ({ signal }) => v1QuizAdminTopicsRetrieve(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAdminTopicsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>>
export type V1QuizAdminTopicsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAdminTopicsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminTopicsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAdminTopicsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Temat ze słownika
 */

export function useV1QuizAdminTopicsRetrieve<TData = Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAdminTopicsRetrieveQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizAdminTopicsPartialUpdateResponse200 = {
  data: AdminQuizTopic
  status: 200
}

export type v1QuizAdminTopicsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAdminTopicsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAdminTopicsPartialUpdateResponseSuccess = (v1QuizAdminTopicsPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1QuizAdminTopicsPartialUpdateResponseError = (v1QuizAdminTopicsPartialUpdateResponse401 | v1QuizAdminTopicsPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1QuizAdminTopicsPartialUpdateResponse = (v1QuizAdminTopicsPartialUpdateResponseSuccess | v1QuizAdminTopicsPartialUpdateResponseError)

export const getV1QuizAdminTopicsPartialUpdateUrl = (slug: string,) => {




  return `/api/v1/quiz/admin/topics/${slug}/`
}

/**
 * Tematy pytań. Operator-only, bez DELETE.
 * @summary Edycja tematu (slug niezmienny)
 */
export const v1QuizAdminTopicsPartialUpdate = async (slug: string,
    patchedAdminQuizTopicRequest?: PatchedAdminQuizTopicRequest, options?: RequestInit): Promise<v1QuizAdminTopicsPartialUpdateResponse> => {

  return customFetch<v1QuizAdminTopicsPartialUpdateResponse>(getV1QuizAdminTopicsPartialUpdateUrl(slug),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedAdminQuizTopicRequest)
  }
);}




export const getV1QuizAdminTopicsPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsPartialUpdate>>, TError,{slug: string;data?: PatchedAdminQuizTopicRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsPartialUpdate>>, TError,{slug: string;data?: PatchedAdminQuizTopicRequest}, TContext> => {

const mutationKey = ['v1QuizAdminTopicsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QuizAdminTopicsPartialUpdate>>, {slug: string;data?: PatchedAdminQuizTopicRequest}> = (props) => {
          const {slug,data} = props ?? {};

          return  v1QuizAdminTopicsPartialUpdate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1QuizAdminTopicsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QuizAdminTopicsPartialUpdate>>>
    export type V1QuizAdminTopicsPartialUpdateMutationBody = PatchedAdminQuizTopicRequest | undefined
    export type V1QuizAdminTopicsPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Edycja tematu (slug niezmienny)
 */
export const useV1QuizAdminTopicsPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QuizAdminTopicsPartialUpdate>>, TError,{slug: string;data?: PatchedAdminQuizTopicRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QuizAdminTopicsPartialUpdate>>,
        TError,
        {slug: string;data?: PatchedAdminQuizTopicRequest},
        TContext
      > => {
      return useMutation(getV1QuizAdminTopicsPartialUpdateMutationOptions(options), queryClient);
    }

export type v1QuizAvailabilityRetrieveResponse200 = {
  data: Availability
  status: 200
}

export type v1QuizAvailabilityRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizAvailabilityRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizAvailabilityRetrieveResponseSuccess = (v1QuizAvailabilityRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizAvailabilityRetrieveResponseError = (v1QuizAvailabilityRetrieveResponse401 | v1QuizAvailabilityRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizAvailabilityRetrieveResponse = (v1QuizAvailabilityRetrieveResponseSuccess | v1QuizAvailabilityRetrieveResponseError)

export const getV1QuizAvailabilityRetrieveUrl = () => {




  return `/api/v1/quiz/availability/`
}

/**
 * `GET /api/v1/quiz/availability/` — every cycle gate in one call (T026, C6/C7).
 *
 * Student-only (FR-024). The response always carries exactly the five v1
 * cycles in the stable order daily, weekly, monthly, weekend, concept. Every
 * entry carries the effective recipe metadata needed by discovery cards;
 * a non-null `open_session_id` implies `state: available` (safe resume).
 *
 * Read-only and computed on read (research R7): recipes + the student's own
 * sessions + the frozen-in-tests `student_now()` clock. No filter backends
 * and no pagination — fixed small payload, no phantom query params in the
 * schema (research R12).
 * @summary Dostępność cykli quizowych (uczeń)
 */
export const v1QuizAvailabilityRetrieve = async ( options?: RequestInit): Promise<v1QuizAvailabilityRetrieveResponse> => {

  return customFetch<v1QuizAvailabilityRetrieveResponse>(getV1QuizAvailabilityRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizAvailabilityRetrieveQueryKey = () => {
    return [
    `/api/v1/quiz/availability/`
    ] as const;
    }


export const getV1QuizAvailabilityRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizAvailabilityRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>> = ({ signal }) => v1QuizAvailabilityRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizAvailabilityRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>>
export type V1QuizAvailabilityRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizAvailabilityRetrieve<TData = Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAvailabilityRetrieve<TData = Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizAvailabilityRetrieve<TData = Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Dostępność cykli quizowych (uczeń)
 */

export function useV1QuizAvailabilityRetrieve<TData = Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizAvailabilityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizAvailabilityRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizCalendarRetrieveResponse200 = {
  data: CalendarQuizList
  status: 200
}

export type v1QuizCalendarRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizCalendarRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizCalendarRetrieveResponseSuccess = (v1QuizCalendarRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizCalendarRetrieveResponseError = (v1QuizCalendarRetrieveResponse401 | v1QuizCalendarRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizCalendarRetrieveResponse = (v1QuizCalendarRetrieveResponseSuccess | v1QuizCalendarRetrieveResponseError)

export const getV1QuizCalendarRetrieveUrl = (params: V1QuizCalendarRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/quiz/calendar/?${stringifiedParams}` : `/api/v1/quiz/calendar/`
}

/**
 * Calendar slots for the caller's active enrolled published plan.
 * @summary Kalendarz quizów ucznia w zakresie dat
 */
export const v1QuizCalendarRetrieve = async (params: V1QuizCalendarRetrieveParams, options?: RequestInit): Promise<v1QuizCalendarRetrieveResponse> => {

  return customFetch<v1QuizCalendarRetrieveResponse>(getV1QuizCalendarRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizCalendarRetrieveQueryKey = (params?: V1QuizCalendarRetrieveParams,) => {
    return [
    `/api/v1/quiz/calendar/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1QuizCalendarRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(params: V1QuizCalendarRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizCalendarRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>> = ({ signal }) => v1QuizCalendarRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizCalendarRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>>
export type V1QuizCalendarRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizCalendarRetrieve<TData = Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: V1QuizCalendarRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizCalendarRetrieve<TData = Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: V1QuizCalendarRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizCalendarRetrieve<TData = Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: V1QuizCalendarRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Kalendarz quizów ucznia w zakresie dat
 */

export function useV1QuizCalendarRetrieve<TData = Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: V1QuizCalendarRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizCalendarRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizCalendarSummaryRetrieveResponse200 = {
  data: CalendarQuizSummary
  status: 200
}

export type v1QuizCalendarSummaryRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizCalendarSummaryRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizCalendarSummaryRetrieveResponseSuccess = (v1QuizCalendarSummaryRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizCalendarSummaryRetrieveResponseError = (v1QuizCalendarSummaryRetrieveResponse401 | v1QuizCalendarSummaryRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizCalendarSummaryRetrieveResponse = (v1QuizCalendarSummaryRetrieveResponseSuccess | v1QuizCalendarSummaryRetrieveResponseError)

export const getV1QuizCalendarSummaryRetrieveUrl = () => {




  return `/api/v1/quiz/calendar/summary/`
}

/**
 * `GET /api/v1/quiz/calendar/summary/` — one row per calendar month of
 * the caller's whole program (spec 151).
 *
 * No parameters (research R12 idiom, like `QuizAvailabilityView`): a
 * program spans at most a few dozen months, so a fixed small payload beats
 * a client walking the 93-day-limited list endpoint a year at a time.
 * @summary Podsumowanie kalendarza ucznia per miesiąc
 */
export const v1QuizCalendarSummaryRetrieve = async ( options?: RequestInit): Promise<v1QuizCalendarSummaryRetrieveResponse> => {

  return customFetch<v1QuizCalendarSummaryRetrieveResponse>(getV1QuizCalendarSummaryRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizCalendarSummaryRetrieveQueryKey = () => {
    return [
    `/api/v1/quiz/calendar/summary/`
    ] as const;
    }


export const getV1QuizCalendarSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizCalendarSummaryRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>> = ({ signal }) => v1QuizCalendarSummaryRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizCalendarSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>>
export type V1QuizCalendarSummaryRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizCalendarSummaryRetrieve<TData = Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizCalendarSummaryRetrieve<TData = Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizCalendarSummaryRetrieve<TData = Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Podsumowanie kalendarza ucznia per miesiąc
 */

export function useV1QuizCalendarSummaryRetrieve<TData = Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizCalendarSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizCalendarSummaryRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1QuizPushQuizzesRetrieveResponse200 = {
  data: PushQuizList
  status: 200
}

export type v1QuizPushQuizzesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1QuizPushQuizzesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1QuizPushQuizzesRetrieveResponseSuccess = (v1QuizPushQuizzesRetrieveResponse200) & {
  headers: Headers;
};
export type v1QuizPushQuizzesRetrieveResponseError = (v1QuizPushQuizzesRetrieveResponse401 | v1QuizPushQuizzesRetrieveResponse410) & {
  headers: Headers;
};

export type v1QuizPushQuizzesRetrieveResponse = (v1QuizPushQuizzesRetrieveResponseSuccess | v1QuizPushQuizzesRetrieveResponseError)

export const getV1QuizPushQuizzesRetrieveUrl = () => {




  return `/api/v1/quiz/push-quizzes/`
}

/**
 * `GET /api/v1/quiz/push-quizzes/` — student discovery (T024, P9).
 *
 * Student-only, envelope errors. Lists every `published` push quiz whose
 * scope covers the caller AT READ TIME (Q9 — a student who joined a
 * targeted class after publish IS included), newest `published_at` first,
 * each with the caller's own status (`notStarted`/`inProgress`/`completed`)
 * and the open session id for resume. Any open session remains discoverable
 * even when the quiz is archived or the student's dynamic membership moves
 * outside its original scope. It drops out after completion unless the
 * published quiz covers the caller again.
 *
 * No filter backends and no pagination — a recorded decision (P9): the list
 * grows through publication and shrinks through the optional availability
 * end or operator archiving.
 * @summary Lista quizów push dostępnych dla ucznia
 */
export const v1QuizPushQuizzesRetrieve = async ( options?: RequestInit): Promise<v1QuizPushQuizzesRetrieveResponse> => {

  return customFetch<v1QuizPushQuizzesRetrieveResponse>(getV1QuizPushQuizzesRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1QuizPushQuizzesRetrieveQueryKey = () => {
    return [
    `/api/v1/quiz/push-quizzes/`
    ] as const;
    }


export const getV1QuizPushQuizzesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QuizPushQuizzesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>> = ({ signal }) => v1QuizPushQuizzesRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1QuizPushQuizzesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>>
export type V1QuizPushQuizzesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1QuizPushQuizzesRetrieve<TData = Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizPushQuizzesRetrieve<TData = Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1QuizPushQuizzesRetrieve<TData = Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista quizów push dostępnych dla ucznia
 */

export function useV1QuizPushQuizzesRetrieve<TData = Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QuizPushQuizzesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1QuizPushQuizzesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type quizSessionStartResponse200 = {
  data: SessionStart
  status: 200
}

export type quizSessionStartResponse201 = {
  data: SessionStart
  status: 201
}

export type quizSessionStartResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type quizSessionStartResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type quizSessionStartResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type quizSessionStartResponse422 = {
  data: ErrorEnvelope
  status: 422
}

export type quizSessionStartResponseSuccess = (quizSessionStartResponse200 | quizSessionStartResponse201) & {
  headers: Headers;
};
export type quizSessionStartResponseError = (quizSessionStartResponse401 | quizSessionStartResponse409 | quizSessionStartResponse410 | quizSessionStartResponse422) & {
  headers: Headers;
};

export type quizSessionStartResponse = (quizSessionStartResponseSuccess | quizSessionStartResponseError)

export const getQuizSessionStartUrl = () => {




  return `/api/v1/quiz/sessions/`
}

/**
 * `POST /api/v1/quiz/sessions/` — start or resume a session (T029, C2/C3/C6).
 *
 * The backend selects the questions for the requested `cycle` (seeded,
 * auditable) and snapshots (revision, permutation) per served question; the
 * client only renders and submits answers — it never selects or scores.
 *
 * Outcomes:
 *
 * - **201** — a fresh session was issued for this cycle's current window.
 * - **200 resume** — the cycle's window instance already has an open session;
 *   the IDENTICAL pinned questions/permutations are rebuilt from the snapshot,
 *   plus `answers` (already-graded slots), so a restart never guesses which
 *   first-answer-final slots are consumed.
 * - **200 concept no-quiz** — `cycle: concept` with an unknown/unstocked
 *   `concept_key`: `session_id: null`, empty `questions`; no session is created.
 * - **409** — the cycle is not startable: already done for this window, locked
 *   (monthly gate), window closed, inactive, or the **bank cannot be composed**
 *   — there are not enough *published* questions of the required types to fill
 *   the recipe. The distinct `message` says which; the fix for the last case is
 *   to publish questions in the operator panel („Bank pytań”) before starting.
 * - **422** — a malformed request body (the mobile envelope; does not create a
 *   session).
 * @summary Rozpoczęcie (lub wznowienie) sesji quizu — pytania wybiera serwer
 */
export const quizSessionStart = async (quizSessionStartRequestRequest?: QuizSessionStartRequestRequest, options?: RequestInit): Promise<quizSessionStartResponse> => {

  return customFetch<quizSessionStartResponse>(getQuizSessionStartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(quizSessionStartRequestRequest)
  }
);}




export const getQuizSessionStartMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizSessionStart>>, TError,{data?: QuizSessionStartRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof quizSessionStart>>, TError,{data?: QuizSessionStartRequestRequest}, TContext> => {

const mutationKey = ['quizSessionStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quizSessionStart>>, {data?: QuizSessionStartRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  quizSessionStart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QuizSessionStartMutationResult = NonNullable<Awaited<ReturnType<typeof quizSessionStart>>>
    export type QuizSessionStartMutationBody = QuizSessionStartRequestRequest | undefined
    export type QuizSessionStartMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @summary Rozpoczęcie (lub wznowienie) sesji quizu — pytania wybiera serwer
 */
export const useQuizSessionStart = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizSessionStart>>, TError,{data?: QuizSessionStartRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof quizSessionStart>>,
        TError,
        {data?: QuizSessionStartRequestRequest},
        TContext
      > => {
      return useMutation(getQuizSessionStartMutationOptions(options), queryClient);
    }

export type quizAnswerSubmitResponse200 = {
  data: AnswerResult
  status: 200
}

export type quizAnswerSubmitResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type quizAnswerSubmitResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type quizAnswerSubmitResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type quizAnswerSubmitResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type quizAnswerSubmitResponse422 = {
  data: ErrorEnvelope
  status: 422
}

export type quizAnswerSubmitResponseSuccess = (quizAnswerSubmitResponse200) & {
  headers: Headers;
};
export type quizAnswerSubmitResponseError = (quizAnswerSubmitResponse401 | quizAnswerSubmitResponse404 | quizAnswerSubmitResponse409 | quizAnswerSubmitResponse410 | quizAnswerSubmitResponse422) & {
  headers: Headers;
};

export type quizAnswerSubmitResponse = (quizAnswerSubmitResponseSuccess | quizAnswerSubmitResponseError)

export const getQuizAnswerSubmitUrl = (sessionId: string,) => {




  return `/api/v1/quiz/sessions/${sessionId}/answers/`
}

/**
 * `POST /api/v1/quiz/sessions/{session_id}/answers/` (T030, C4/C5).
 *
 * Strict per-type validation (422 leaves the first-answer-final slot
 * unconsumed), served→authored index mapping through the snapshot
 * permutation, grading against the pinned revision's secret, insert-only
 * race-safe attempts (IntegrityError → re-read), stored-result replay.
 * @summary Odpowiedź na jedno pytanie — oceniana od razu, pierwsza jest ostateczna
 */
export const quizAnswerSubmit = async (sessionId: string,
    quizAnswerSubmissionRequest?: QuizAnswerSubmissionRequest, options?: RequestInit): Promise<quizAnswerSubmitResponse> => {

  return customFetch<quizAnswerSubmitResponse>(getQuizAnswerSubmitUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(quizAnswerSubmissionRequest)
  }
);}




export const getQuizAnswerSubmitMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizAnswerSubmit>>, TError,{sessionId: string;data?: QuizAnswerSubmissionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof quizAnswerSubmit>>, TError,{sessionId: string;data?: QuizAnswerSubmissionRequest}, TContext> => {

const mutationKey = ['quizAnswerSubmit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quizAnswerSubmit>>, {sessionId: string;data?: QuizAnswerSubmissionRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  quizAnswerSubmit(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QuizAnswerSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof quizAnswerSubmit>>>
    export type QuizAnswerSubmitMutationBody = QuizAnswerSubmissionRequest | undefined
    export type QuizAnswerSubmitMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @summary Odpowiedź na jedno pytanie — oceniana od razu, pierwsza jest ostateczna
 */
export const useQuizAnswerSubmit = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizAnswerSubmit>>, TError,{sessionId: string;data?: QuizAnswerSubmissionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof quizAnswerSubmit>>,
        TError,
        {sessionId: string;data?: QuizAnswerSubmissionRequest},
        TContext
      > => {
      return useMutation(getQuizAnswerSubmitMutationOptions(options), queryClient);
    }

export type quizSessionCompleteResponse200 = {
  data: SessionResult
  status: 200
}

export type quizSessionCompleteResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type quizSessionCompleteResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type quizSessionCompleteResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type quizSessionCompleteResponseSuccess = (quizSessionCompleteResponse200) & {
  headers: Headers;
};
export type quizSessionCompleteResponseError = (quizSessionCompleteResponse401 | quizSessionCompleteResponse404 | quizSessionCompleteResponse410) & {
  headers: Headers;
};

export type quizSessionCompleteResponse = (quizSessionCompleteResponseSuccess | quizSessionCompleteResponseError)

export const getQuizSessionCompleteUrl = (sessionId: string,) => {




  return `/api/v1/quiz/sessions/${sessionId}/complete/`
}

/**
 * `POST /api/v1/quiz/sessions/{session_id}/complete/` (T032/T035, C8/C9).
 *
 * Closes the session in one transaction: authoritative 3-component score
 * from the stored attempts (participation per ANSWERED question), persisted
 * breakdown, then the ledger consequences per recipe flags — exactly one
 * `session_score` and (for chest-granting cycles) one `chest_bonus` entry.
 * Idempotent: an already-completed session returns the STORED result
 * byte-identically; the `(session, source)` ledger unique constraint is the
 * concurrent-replay backstop (research R11). Concept recipes grant nothing:
 * zero ledger entries, all points components 0 (C10).
 * @summary Zamknięcie sesji quizu — autorytatywny wynik, punkty, skrzynka
 */
export const quizSessionComplete = async (sessionId: string, options?: RequestInit): Promise<quizSessionCompleteResponse> => {

  return customFetch<quizSessionCompleteResponse>(getQuizSessionCompleteUrl(sessionId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getQuizSessionCompleteMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizSessionComplete>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof quizSessionComplete>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['quizSessionComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quizSessionComplete>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  quizSessionComplete(sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QuizSessionCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof quizSessionComplete>>>

    export type QuizSessionCompleteMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @summary Zamknięcie sesji quizu — autorytatywny wynik, punkty, skrzynka
 */
export const useQuizSessionComplete = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizSessionComplete>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof quizSessionComplete>>,
        TError,
        {sessionId: string},
        TContext
      > => {
      return useMutation(getQuizSessionCompleteMutationOptions(options), queryClient);
    }

export type quizPairsPickResponse200 = {
  data: PairPickResult
  status: 200
}

export type quizPairsPickResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type quizPairsPickResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type quizPairsPickResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type quizPairsPickResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type quizPairsPickResponse422 = {
  data: ErrorEnvelope
  status: 422
}

export type quizPairsPickResponseSuccess = (quizPairsPickResponse200) & {
  headers: Headers;
};
export type quizPairsPickResponseError = (quizPairsPickResponse401 | quizPairsPickResponse404 | quizPairsPickResponse409 | quizPairsPickResponse410 | quizPairsPickResponse422) & {
  headers: Headers;
};

export type quizPairsPickResponse = (quizPairsPickResponseSuccess | quizPairsPickResponseError)

export const getQuizPairsPickUrl = (sessionId: string,
    questionUid: string,) => {




  return `/api/v1/quiz/sessions/${sessionId}/pairs/${questionUid}/picks/`
}

/**
 * `POST /api/v1/quiz/sessions/{session_id}/pairs/{question_uid}/picks/` (163).
 *
 * A matching question is a grid of shuffled cards, and the student taps two
 * of them at a time. The key never leaves the server (C1), so every pair is
 * checked here; the row of confirmed pairs lives in `QuizPairsProgress`
 * until the grid is full, and only then does the ordinary first-answer-final
 * `QuizAttempt` land — with the mistake count deciding `is_correct`.
 * @summary Jedna para w dopasowaniu — sprawdzana natychmiast, bez odsłaniania klucza
 */
export const quizPairsPick = async (sessionId: string,
    questionUid: string,
    pairPickRequest: PairPickRequest, options?: RequestInit): Promise<quizPairsPickResponse> => {

  return customFetch<quizPairsPickResponse>(getQuizPairsPickUrl(sessionId,questionUid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pairPickRequest)
  }
);}




export const getQuizPairsPickMutationOptions = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizPairsPick>>, TError,{sessionId: string;questionUid: string;data: PairPickRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof quizPairsPick>>, TError,{sessionId: string;questionUid: string;data: PairPickRequest}, TContext> => {

const mutationKey = ['quizPairsPick'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quizPairsPick>>, {sessionId: string;questionUid: string;data: PairPickRequest}> = (props) => {
          const {sessionId,questionUid,data} = props ?? {};

          return  quizPairsPick(sessionId,questionUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QuizPairsPickMutationResult = NonNullable<Awaited<ReturnType<typeof quizPairsPick>>>
    export type QuizPairsPickMutationBody = PairPickRequest
    export type QuizPairsPickMutationError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse

    /**
 * @summary Jedna para w dopasowaniu — sprawdzana natychmiast, bez odsłaniania klucza
 */
export const useQuizPairsPick = <TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizPairsPick>>, TError,{sessionId: string;questionUid: string;data: PairPickRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof quizPairsPick>>,
        TError,
        {sessionId: string;questionUid: string;data: PairPickRequest},
        TContext
      > => {
      return useMutation(getQuizPairsPickMutationOptions(options), queryClient);
    }

export type quizSessionReplayResponse200 = {
  data: SessionReplay
  status: 200
}

export type quizSessionReplayResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type quizSessionReplayResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type quizSessionReplayResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type quizSessionReplayResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type quizSessionReplayResponseSuccess = (quizSessionReplayResponse200) & {
  headers: Headers;
};
export type quizSessionReplayResponseError = (quizSessionReplayResponse401 | quizSessionReplayResponse404 | quizSessionReplayResponse409 | quizSessionReplayResponse410) & {
  headers: Headers;
};

export type quizSessionReplayResponse = (quizSessionReplayResponseSuccess | quizSessionReplayResponseError)

export const getQuizSessionReplayUrl = (sessionId: string,) => {




  return `/api/v1/quiz/sessions/${sessionId}/replay/`
}

/**
 * `GET /api/v1/quiz/sessions/{session_id}/replay/` (R8, D4-D6).
 *
 * A completed slot's quiz stays walkable again, not just visible, so this
 * serves the EXACT snapshot the student originally played — same pinned
 * revisions, same served-order permutation — read-only: no session, attempt
 * or ledger row is ever touched, so it works forever without a retention
 * policy and the `(student, calendar_slot)` unique that keeps the
 * calendar's whole progress read cheap stays untouched.
 * @summary Powtórka ukończonej sesji quizu do przećwiczenia — bez zapisu stanu
 */
export const quizSessionReplay = async (sessionId: string, options?: RequestInit): Promise<quizSessionReplayResponse> => {

  return customFetch<quizSessionReplayResponse>(getQuizSessionReplayUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getQuizSessionReplayQueryKey = (sessionId: string,) => {
    return [
    `/api/v1/quiz/sessions/${sessionId}/replay/`
    ] as const;
    }


export const getQuizSessionReplayQueryOptions = <TData = Awaited<ReturnType<typeof quizSessionReplay>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quizSessionReplay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuizSessionReplayQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof quizSessionReplay>>> = ({ signal }) => quizSessionReplay(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof quizSessionReplay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QuizSessionReplayQueryResult = NonNullable<Awaited<ReturnType<typeof quizSessionReplay>>>
export type QuizSessionReplayQueryError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse


export function useQuizSessionReplay<TData = Awaited<ReturnType<typeof quizSessionReplay>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof quizSessionReplay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof quizSessionReplay>>,
          TError,
          Awaited<ReturnType<typeof quizSessionReplay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQuizSessionReplay<TData = Awaited<ReturnType<typeof quizSessionReplay>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quizSessionReplay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof quizSessionReplay>>,
          TError,
          Awaited<ReturnType<typeof quizSessionReplay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQuizSessionReplay<TData = Awaited<ReturnType<typeof quizSessionReplay>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quizSessionReplay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Powtórka ukończonej sesji quizu do przećwiczenia — bez zapisu stanu
 */

export function useQuizSessionReplay<TData = Awaited<ReturnType<typeof quizSessionReplay>>, TError = UnauthorizedResponse | ErrorEnvelope | AccountGoneResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quizSessionReplay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQuizSessionReplayQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type quizSessionReplayAnswerResponse200 = {
  data: AnswerResult
  status: 200
}

export type quizSessionReplayAnswerResponse400 = {
  data: ErrorEnvelope
  status: 400
}

export type quizSessionReplayAnswerResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type quizSessionReplayAnswerResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type quizSessionReplayAnswerResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type quizSessionReplayAnswerResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type quizSessionReplayAnswerResponse422 = {
  data: ErrorEnvelope
  status: 422
}

export type quizSessionReplayAnswerResponseSuccess = (quizSessionReplayAnswerResponse200) & {
  headers: Headers;
};
export type quizSessionReplayAnswerResponseError = (quizSessionReplayAnswerResponse400 | quizSessionReplayAnswerResponse401 | quizSessionReplayAnswerResponse404 | quizSessionReplayAnswerResponse409 | quizSessionReplayAnswerResponse410 | quizSessionReplayAnswerResponse422) & {
  headers: Headers;
};

export type quizSessionReplayAnswerResponse = (quizSessionReplayAnswerResponseSuccess | quizSessionReplayAnswerResponseError)

export const getQuizSessionReplayAnswerUrl = (sessionId: string,) => {




  return `/api/v1/quiz/sessions/${sessionId}/replay/answers/`
}

/**
 * `POST /api/v1/quiz/sessions/{session_id}/replay/answers/` (R8, D4/D6).
 *
 * Grades the IDENTICAL input shape as the live answer endpoint, statelessly,
 * against the session's pinned snapshot: same `is_correct`/`explanation`
 * feedback (D6), but no `QuizAttempt` row, so first-answer-final does not
 * apply here — there is nothing to consume, and answering the same question
 * twice (even with a different submission) grades both times independently.
 * @summary Odpowiedź w powtórce ukończonej sesji — ocena bez zapisu stanu
 */
export const quizSessionReplayAnswer = async (sessionId: string,
    quizAnswerSubmissionRequest?: QuizAnswerSubmissionRequest, options?: RequestInit): Promise<quizSessionReplayAnswerResponse> => {

  return customFetch<quizSessionReplayAnswerResponse>(getQuizSessionReplayAnswerUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(quizAnswerSubmissionRequest)
  }
);}




export const getQuizSessionReplayAnswerMutationOptions = <TError = ErrorEnvelope | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizSessionReplayAnswer>>, TError,{sessionId: string;data?: QuizAnswerSubmissionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof quizSessionReplayAnswer>>, TError,{sessionId: string;data?: QuizAnswerSubmissionRequest}, TContext> => {

const mutationKey = ['quizSessionReplayAnswer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quizSessionReplayAnswer>>, {sessionId: string;data?: QuizAnswerSubmissionRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  quizSessionReplayAnswer(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QuizSessionReplayAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof quizSessionReplayAnswer>>>
    export type QuizSessionReplayAnswerMutationBody = QuizAnswerSubmissionRequest | undefined
    export type QuizSessionReplayAnswerMutationError = ErrorEnvelope | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Odpowiedź w powtórce ukończonej sesji — ocena bez zapisu stanu
 */
export const useQuizSessionReplayAnswer = <TError = ErrorEnvelope | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizSessionReplayAnswer>>, TError,{sessionId: string;data?: QuizAnswerSubmissionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof quizSessionReplayAnswer>>,
        TError,
        {sessionId: string;data?: QuizAnswerSubmissionRequest},
        TContext
      > => {
      return useMutation(getQuizSessionReplayAnswerMutationOptions(options), queryClient);
    }

export type quizSessionReplayPairsPickResponse200 = {
  data: ReplayPairPickResult
  status: 200
}

export type quizSessionReplayPairsPickResponse400 = {
  data: ErrorEnvelope
  status: 400
}

export type quizSessionReplayPairsPickResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type quizSessionReplayPairsPickResponse404 = {
  data: ErrorEnvelope
  status: 404
}

export type quizSessionReplayPairsPickResponse409 = {
  data: ErrorEnvelope
  status: 409
}

export type quizSessionReplayPairsPickResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type quizSessionReplayPairsPickResponse422 = {
  data: ErrorEnvelope
  status: 422
}

export type quizSessionReplayPairsPickResponseSuccess = (quizSessionReplayPairsPickResponse200) & {
  headers: Headers;
};
export type quizSessionReplayPairsPickResponseError = (quizSessionReplayPairsPickResponse400 | quizSessionReplayPairsPickResponse401 | quizSessionReplayPairsPickResponse404 | quizSessionReplayPairsPickResponse409 | quizSessionReplayPairsPickResponse410 | quizSessionReplayPairsPickResponse422) & {
  headers: Headers;
};

export type quizSessionReplayPairsPickResponse = (quizSessionReplayPairsPickResponseSuccess | quizSessionReplayPairsPickResponseError)

export const getQuizSessionReplayPairsPickUrl = (sessionId: string,
    questionUid: string,) => {




  return `/api/v1/quiz/sessions/${sessionId}/replay/pairs/${questionUid}/picks/`
}

/**
 * `POST .../sessions/{session_id}/replay/pairs/{question_uid}/picks/` (163, D4).
 *
 * The same tap, graded the same way, over the same pinned snapshot — with
 * nothing stored, so there is no progress row and no attempt: the client
 * keeps the grid state and its own mistake count. The pinned explanation
 * rides along so it can be shown once the student finishes the grid.
 * @summary Para w powtórce dopasowania — ocena bez zapisu stanu
 */
export const quizSessionReplayPairsPick = async (sessionId: string,
    questionUid: string,
    pairPickRequest: PairPickRequest, options?: RequestInit): Promise<quizSessionReplayPairsPickResponse> => {

  return customFetch<quizSessionReplayPairsPickResponse>(getQuizSessionReplayPairsPickUrl(sessionId,questionUid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pairPickRequest)
  }
);}




export const getQuizSessionReplayPairsPickMutationOptions = <TError = ErrorEnvelope | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizSessionReplayPairsPick>>, TError,{sessionId: string;questionUid: string;data: PairPickRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof quizSessionReplayPairsPick>>, TError,{sessionId: string;questionUid: string;data: PairPickRequest}, TContext> => {

const mutationKey = ['quizSessionReplayPairsPick'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quizSessionReplayPairsPick>>, {sessionId: string;questionUid: string;data: PairPickRequest}> = (props) => {
          const {sessionId,questionUid,data} = props ?? {};

          return  quizSessionReplayPairsPick(sessionId,questionUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QuizSessionReplayPairsPickMutationResult = NonNullable<Awaited<ReturnType<typeof quizSessionReplayPairsPick>>>
    export type QuizSessionReplayPairsPickMutationBody = PairPickRequest
    export type QuizSessionReplayPairsPickMutationError = ErrorEnvelope | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Para w powtórce dopasowania — ocena bez zapisu stanu
 */
export const useQuizSessionReplayPairsPick = <TError = ErrorEnvelope | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quizSessionReplayPairsPick>>, TError,{sessionId: string;questionUid: string;data: PairPickRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof quizSessionReplayPairsPick>>,
        TError,
        {sessionId: string;questionUid: string;data: PairPickRequest},
        TContext
      > => {
      return useMutation(getQuizSessionReplayPairsPickMutationOptions(options), queryClient);
    }

export type v1RankingsChallengesListResponse200 = {
  data: ChallengeList
  status: 200
}

export type v1RankingsChallengesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsChallengesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsChallengesListResponseSuccess = (v1RankingsChallengesListResponse200) & {
  headers: Headers;
};
export type v1RankingsChallengesListResponseError = (v1RankingsChallengesListResponse401 | v1RankingsChallengesListResponse410) & {
  headers: Headers;
};

export type v1RankingsChallengesListResponse = (v1RankingsChallengesListResponseSuccess | v1RankingsChallengesListResponseError)

export const getV1RankingsChallengesListUrl = () => {




  return `/api/v1/rankings/challenges/`
}

export const v1RankingsChallengesList = async ( options?: RequestInit): Promise<v1RankingsChallengesListResponse> => {

  return customFetch<v1RankingsChallengesListResponse>(getV1RankingsChallengesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsChallengesListQueryKey = () => {
    return [
    `/api/v1/rankings/challenges/`
    ] as const;
    }


export const getV1RankingsChallengesListQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsChallengesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsChallengesList>>> = ({ signal }) => v1RankingsChallengesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsChallengesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsChallengesList>>>
export type V1RankingsChallengesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsChallengesList<TData = Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesList>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesList<TData = Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesList>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesList<TData = Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsChallengesList<TData = Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsChallengesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RankingsChallengesRetrieveResponse200 = {
  data: ChallengeRead
  status: 200
}

export type v1RankingsChallengesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsChallengesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsChallengesRetrieveResponseSuccess = (v1RankingsChallengesRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsChallengesRetrieveResponseError = (v1RankingsChallengesRetrieveResponse401 | v1RankingsChallengesRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsChallengesRetrieveResponse = (v1RankingsChallengesRetrieveResponseSuccess | v1RankingsChallengesRetrieveResponseError)

export const getV1RankingsChallengesRetrieveUrl = (challengeId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/`
}

export const v1RankingsChallengesRetrieve = async (challengeId: number, options?: RequestInit): Promise<v1RankingsChallengesRetrieveResponse> => {

  return customFetch<v1RankingsChallengesRetrieveResponse>(getV1RankingsChallengesRetrieveUrl(challengeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsChallengesRetrieveQueryKey = (challengeId: number,) => {
    return [
    `/api/v1/rankings/challenges/${challengeId}/`
    ] as const;
    }


export const getV1RankingsChallengesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsChallengesRetrieveQueryKey(challengeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>> = ({ signal }) => v1RankingsChallengesRetrieve(challengeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: challengeId !== null && challengeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsChallengesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>>
export type V1RankingsChallengesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsChallengesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsChallengesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsChallengesRetrieveQueryOptions(challengeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RankingsChallengesClassesProgressRetrieveResponse200 = {
  data: ClassProgressResponse
  status: 200
}

export type v1RankingsChallengesClassesProgressRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsChallengesClassesProgressRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsChallengesClassesProgressRetrieveResponseSuccess = (v1RankingsChallengesClassesProgressRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsChallengesClassesProgressRetrieveResponseError = (v1RankingsChallengesClassesProgressRetrieveResponse401 | v1RankingsChallengesClassesProgressRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsChallengesClassesProgressRetrieveResponse = (v1RankingsChallengesClassesProgressRetrieveResponseSuccess | v1RankingsChallengesClassesProgressRetrieveResponseError)

export const getV1RankingsChallengesClassesProgressRetrieveUrl = (challengeId: number,
    classId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/classes/${classId}/progress/`
}

export const v1RankingsChallengesClassesProgressRetrieve = async (challengeId: number,
    classId: number, options?: RequestInit): Promise<v1RankingsChallengesClassesProgressRetrieveResponse> => {

  return customFetch<v1RankingsChallengesClassesProgressRetrieveResponse>(getV1RankingsChallengesClassesProgressRetrieveUrl(challengeId,classId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsChallengesClassesProgressRetrieveQueryKey = (challengeId: number,
    classId: number,) => {
    return [
    `/api/v1/rankings/challenges/${challengeId}/classes/${classId}/progress/`
    ] as const;
    }


export const getV1RankingsChallengesClassesProgressRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(challengeId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsChallengesClassesProgressRetrieveQueryKey(challengeId,classId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>> = ({ signal }) => v1RankingsChallengesClassesProgressRetrieve(challengeId,classId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: challengeId !== null && challengeId !== undefined && classId !== null && classId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsChallengesClassesProgressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>>
export type V1RankingsChallengesClassesProgressRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsChallengesClassesProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesClassesProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesClassesProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsChallengesClassesProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsChallengesClassesProgressRetrieveQueryOptions(challengeId,classId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RankingsChallengesClassesStudentsRetrieveResponse200 = {
  data: StudentLeaderboard
  status: 200
}

export type v1RankingsChallengesClassesStudentsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsChallengesClassesStudentsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsChallengesClassesStudentsRetrieveResponseSuccess = (v1RankingsChallengesClassesStudentsRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsChallengesClassesStudentsRetrieveResponseError = (v1RankingsChallengesClassesStudentsRetrieveResponse401 | v1RankingsChallengesClassesStudentsRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsChallengesClassesStudentsRetrieveResponse = (v1RankingsChallengesClassesStudentsRetrieveResponseSuccess | v1RankingsChallengesClassesStudentsRetrieveResponseError)

export const getV1RankingsChallengesClassesStudentsRetrieveUrl = (challengeId: number,
    classId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/classes/${classId}/students/`
}

export const v1RankingsChallengesClassesStudentsRetrieve = async (challengeId: number,
    classId: number, options?: RequestInit): Promise<v1RankingsChallengesClassesStudentsRetrieveResponse> => {

  return customFetch<v1RankingsChallengesClassesStudentsRetrieveResponse>(getV1RankingsChallengesClassesStudentsRetrieveUrl(challengeId,classId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsChallengesClassesStudentsRetrieveQueryKey = (challengeId: number,
    classId: number,) => {
    return [
    `/api/v1/rankings/challenges/${challengeId}/classes/${classId}/students/`
    ] as const;
    }


export const getV1RankingsChallengesClassesStudentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(challengeId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsChallengesClassesStudentsRetrieveQueryKey(challengeId,classId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>> = ({ signal }) => v1RankingsChallengesClassesStudentsRetrieve(challengeId,classId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: challengeId !== null && challengeId !== undefined && classId !== null && classId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsChallengesClassesStudentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>>
export type V1RankingsChallengesClassesStudentsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsChallengesClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsChallengesClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsChallengesClassesStudentsRetrieveQueryOptions(challengeId,classId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RankingsChallengesClassesStudentsProgressRetrieveResponse200 = {
  data: StudentProgressResponse
  status: 200
}

export type v1RankingsChallengesClassesStudentsProgressRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsChallengesClassesStudentsProgressRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsChallengesClassesStudentsProgressRetrieveResponseSuccess = (v1RankingsChallengesClassesStudentsProgressRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsChallengesClassesStudentsProgressRetrieveResponseError = (v1RankingsChallengesClassesStudentsProgressRetrieveResponse401 | v1RankingsChallengesClassesStudentsProgressRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsChallengesClassesStudentsProgressRetrieveResponse = (v1RankingsChallengesClassesStudentsProgressRetrieveResponseSuccess | v1RankingsChallengesClassesStudentsProgressRetrieveResponseError)

export const getV1RankingsChallengesClassesStudentsProgressRetrieveUrl = (challengeId: number,
    classId: number,
    studentId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/classes/${classId}/students/${studentId}/progress/`
}

export const v1RankingsChallengesClassesStudentsProgressRetrieve = async (challengeId: number,
    classId: number,
    studentId: number, options?: RequestInit): Promise<v1RankingsChallengesClassesStudentsProgressRetrieveResponse> => {

  return customFetch<v1RankingsChallengesClassesStudentsProgressRetrieveResponse>(getV1RankingsChallengesClassesStudentsProgressRetrieveUrl(challengeId,classId,studentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsChallengesClassesStudentsProgressRetrieveQueryKey = (challengeId: number,
    classId: number,
    studentId: number,) => {
    return [
    `/api/v1/rankings/challenges/${challengeId}/classes/${classId}/students/${studentId}/progress/`
    ] as const;
    }


export const getV1RankingsChallengesClassesStudentsProgressRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(challengeId: number,
    classId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsChallengesClassesStudentsProgressRetrieveQueryKey(challengeId,classId,studentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>> = ({ signal }) => v1RankingsChallengesClassesStudentsProgressRetrieve(challengeId,classId,studentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: challengeId !== null && challengeId !== undefined && classId !== null && classId !== undefined && studentId !== null && studentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsChallengesClassesStudentsProgressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>>
export type V1RankingsChallengesClassesStudentsProgressRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsChallengesClassesStudentsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number,
    studentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesClassesStudentsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesClassesStudentsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsChallengesClassesStudentsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    classId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesClassesStudentsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsChallengesClassesStudentsProgressRetrieveQueryOptions(challengeId,classId,studentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type rankingsChallengeCloseResponse200 = {
  data: ChallengeAdminRead
  status: 200
}

export type rankingsChallengeCloseResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsChallengeCloseResponse403 = {
  data: void
  status: 403
}

export type rankingsChallengeCloseResponse404 = {
  data: void
  status: 404
}

export type rankingsChallengeCloseResponse409 = {
  data: void
  status: 409
}

export type rankingsChallengeCloseResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsChallengeCloseResponseSuccess = (rankingsChallengeCloseResponse200) & {
  headers: Headers;
};
export type rankingsChallengeCloseResponseError = (rankingsChallengeCloseResponse401 | rankingsChallengeCloseResponse403 | rankingsChallengeCloseResponse404 | rankingsChallengeCloseResponse409 | rankingsChallengeCloseResponse410) & {
  headers: Headers;
};

export type rankingsChallengeCloseResponse = (rankingsChallengeCloseResponseSuccess | rankingsChallengeCloseResponseError)

export const getRankingsChallengeCloseUrl = (challengeId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/close/`
}

/**
 * Base for every operator write — the role gate lives here, not in docs.
 */
export const rankingsChallengeClose = async (challengeId: number, options?: RequestInit): Promise<rankingsChallengeCloseResponse> => {

  return customFetch<rankingsChallengeCloseResponse>(getRankingsChallengeCloseUrl(challengeId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRankingsChallengeCloseMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeClose>>, TError,{challengeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeClose>>, TError,{challengeId: number}, TContext> => {

const mutationKey = ['rankingsChallengeClose'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rankingsChallengeClose>>, {challengeId: number}> = (props) => {
          const {challengeId} = props ?? {};

          return  rankingsChallengeClose(challengeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RankingsChallengeCloseMutationResult = NonNullable<Awaited<ReturnType<typeof rankingsChallengeClose>>>

    export type RankingsChallengeCloseMutationError = UnauthorizedResponse | void | AccountGoneResponse

    export const useRankingsChallengeClose = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeClose>>, TError,{challengeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rankingsChallengeClose>>,
        TError,
        {challengeId: number},
        TContext
      > => {
      return useMutation(getRankingsChallengeCloseMutationOptions(options), queryClient);
    }

export type rankingsChallengeConfigRetrieveResponse200 = {
  data: ChallengeAdminRead
  status: 200
}

export type rankingsChallengeConfigRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsChallengeConfigRetrieveResponse403 = {
  data: void
  status: 403
}

export type rankingsChallengeConfigRetrieveResponse404 = {
  data: void
  status: 404
}

export type rankingsChallengeConfigRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsChallengeConfigRetrieveResponseSuccess = (rankingsChallengeConfigRetrieveResponse200) & {
  headers: Headers;
};
export type rankingsChallengeConfigRetrieveResponseError = (rankingsChallengeConfigRetrieveResponse401 | rankingsChallengeConfigRetrieveResponse403 | rankingsChallengeConfigRetrieveResponse404 | rankingsChallengeConfigRetrieveResponse410) & {
  headers: Headers;
};

export type rankingsChallengeConfigRetrieveResponse = (rankingsChallengeConfigRetrieveResponseSuccess | rankingsChallengeConfigRetrieveResponseError)

export const getRankingsChallengeConfigRetrieveUrl = (challengeId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/config/`
}

/**
 * Base for every operator write — the role gate lives here, not in docs.
 */
export const rankingsChallengeConfigRetrieve = async (challengeId: number, options?: RequestInit): Promise<rankingsChallengeConfigRetrieveResponse> => {

  return customFetch<rankingsChallengeConfigRetrieveResponse>(getRankingsChallengeConfigRetrieveUrl(challengeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRankingsChallengeConfigRetrieveQueryKey = (challengeId: number,) => {
    return [
    `/api/v1/rankings/challenges/${challengeId}/config/`
    ] as const;
    }


export const getRankingsChallengeConfigRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRankingsChallengeConfigRetrieveQueryKey(challengeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>> = ({ signal }) => rankingsChallengeConfigRetrieve(challengeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: challengeId !== null && challengeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RankingsChallengeConfigRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>>
export type RankingsChallengeConfigRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useRankingsChallengeConfigRetrieve<TData = Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 challengeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRankingsChallengeConfigRetrieve<TData = Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRankingsChallengeConfigRetrieve<TData = Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRankingsChallengeConfigRetrieve<TData = Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsChallengeConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRankingsChallengeConfigRetrieveQueryOptions(challengeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type rankingsChallengeUpdateResponse200 = {
  data: ChallengeAdminRead
  status: 200
}

export type rankingsChallengeUpdateResponse400 = {
  data: void
  status: 400
}

export type rankingsChallengeUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsChallengeUpdateResponse403 = {
  data: void
  status: 403
}

export type rankingsChallengeUpdateResponse404 = {
  data: void
  status: 404
}

export type rankingsChallengeUpdateResponse409 = {
  data: void
  status: 409
}

export type rankingsChallengeUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsChallengeUpdateResponseSuccess = (rankingsChallengeUpdateResponse200) & {
  headers: Headers;
};
export type rankingsChallengeUpdateResponseError = (rankingsChallengeUpdateResponse400 | rankingsChallengeUpdateResponse401 | rankingsChallengeUpdateResponse403 | rankingsChallengeUpdateResponse404 | rankingsChallengeUpdateResponse409 | rankingsChallengeUpdateResponse410) & {
  headers: Headers;
};

export type rankingsChallengeUpdateResponse = (rankingsChallengeUpdateResponseSuccess | rankingsChallengeUpdateResponseError)

export const getRankingsChallengeUpdateUrl = (challengeId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/edit/`
}

/**
 * Base for every operator write — the role gate lives here, not in docs.
 */
export const rankingsChallengeUpdate = async (challengeId: number,
    patchedChallengeEditRequest?: PatchedChallengeEditRequest, options?: RequestInit): Promise<rankingsChallengeUpdateResponse> => {

  return customFetch<rankingsChallengeUpdateResponse>(getRankingsChallengeUpdateUrl(challengeId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedChallengeEditRequest)
  }
);}




export const getRankingsChallengeUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeUpdate>>, TError,{challengeId: number;data?: PatchedChallengeEditRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeUpdate>>, TError,{challengeId: number;data?: PatchedChallengeEditRequest}, TContext> => {

const mutationKey = ['rankingsChallengeUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rankingsChallengeUpdate>>, {challengeId: number;data?: PatchedChallengeEditRequest}> = (props) => {
          const {challengeId,data} = props ?? {};

          return  rankingsChallengeUpdate(challengeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RankingsChallengeUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof rankingsChallengeUpdate>>>
    export type RankingsChallengeUpdateMutationBody = PatchedChallengeEditRequest | undefined
    export type RankingsChallengeUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useRankingsChallengeUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeUpdate>>, TError,{challengeId: number;data?: PatchedChallengeEditRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rankingsChallengeUpdate>>,
        TError,
        {challengeId: number;data?: PatchedChallengeEditRequest},
        TContext
      > => {
      return useMutation(getRankingsChallengeUpdateMutationOptions(options), queryClient);
    }

export type rankingsChallengeDeleteResponse204 = {
  data: void
  status: 204
}

export type rankingsChallengeDeleteResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsChallengeDeleteResponse403 = {
  data: void
  status: 403
}

export type rankingsChallengeDeleteResponse404 = {
  data: void
  status: 404
}

export type rankingsChallengeDeleteResponse409 = {
  data: void
  status: 409
}

export type rankingsChallengeDeleteResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsChallengeDeleteResponseSuccess = (rankingsChallengeDeleteResponse204) & {
  headers: Headers;
};
export type rankingsChallengeDeleteResponseError = (rankingsChallengeDeleteResponse401 | rankingsChallengeDeleteResponse403 | rankingsChallengeDeleteResponse404 | rankingsChallengeDeleteResponse409 | rankingsChallengeDeleteResponse410) & {
  headers: Headers;
};

export type rankingsChallengeDeleteResponse = (rankingsChallengeDeleteResponseSuccess | rankingsChallengeDeleteResponseError)

export const getRankingsChallengeDeleteUrl = (challengeId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/edit/`
}

/**
 * Base for every operator write — the role gate lives here, not in docs.
 */
export const rankingsChallengeDelete = async (challengeId: number, options?: RequestInit): Promise<rankingsChallengeDeleteResponse> => {

  return customFetch<rankingsChallengeDeleteResponse>(getRankingsChallengeDeleteUrl(challengeId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRankingsChallengeDeleteMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeDelete>>, TError,{challengeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeDelete>>, TError,{challengeId: number}, TContext> => {

const mutationKey = ['rankingsChallengeDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rankingsChallengeDelete>>, {challengeId: number}> = (props) => {
          const {challengeId} = props ?? {};

          return  rankingsChallengeDelete(challengeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RankingsChallengeDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof rankingsChallengeDelete>>>

    export type RankingsChallengeDeleteMutationError = UnauthorizedResponse | void | AccountGoneResponse

    export const useRankingsChallengeDelete = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeDelete>>, TError,{challengeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rankingsChallengeDelete>>,
        TError,
        {challengeId: number},
        TContext
      > => {
      return useMutation(getRankingsChallengeDeleteMutationOptions(options), queryClient);
    }

export type rankingsChallengeManualEntryCreateResponse201 = {
  data: ManualEntryRead
  status: 201
}

export type rankingsChallengeManualEntryCreateResponse400 = {
  data: void
  status: 400
}

export type rankingsChallengeManualEntryCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsChallengeManualEntryCreateResponse403 = {
  data: void
  status: 403
}

export type rankingsChallengeManualEntryCreateResponse404 = {
  data: void
  status: 404
}

export type rankingsChallengeManualEntryCreateResponse409 = {
  data: void
  status: 409
}

export type rankingsChallengeManualEntryCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsChallengeManualEntryCreateResponseSuccess = (rankingsChallengeManualEntryCreateResponse201) & {
  headers: Headers;
};
export type rankingsChallengeManualEntryCreateResponseError = (rankingsChallengeManualEntryCreateResponse400 | rankingsChallengeManualEntryCreateResponse401 | rankingsChallengeManualEntryCreateResponse403 | rankingsChallengeManualEntryCreateResponse404 | rankingsChallengeManualEntryCreateResponse409 | rankingsChallengeManualEntryCreateResponse410) & {
  headers: Headers;
};

export type rankingsChallengeManualEntryCreateResponse = (rankingsChallengeManualEntryCreateResponseSuccess | rankingsChallengeManualEntryCreateResponseError)

export const getRankingsChallengeManualEntryCreateUrl = (challengeId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/manual-entries/`
}

/**
 * Base for every operator write — the role gate lives here, not in docs.
 */
export const rankingsChallengeManualEntryCreate = async (challengeId: number,
    manualEntryWriteRequest: ManualEntryWriteRequest, options?: RequestInit): Promise<rankingsChallengeManualEntryCreateResponse> => {

  return customFetch<rankingsChallengeManualEntryCreateResponse>(getRankingsChallengeManualEntryCreateUrl(challengeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(manualEntryWriteRequest)
  }
);}




export const getRankingsChallengeManualEntryCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeManualEntryCreate>>, TError,{challengeId: number;data: ManualEntryWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeManualEntryCreate>>, TError,{challengeId: number;data: ManualEntryWriteRequest}, TContext> => {

const mutationKey = ['rankingsChallengeManualEntryCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rankingsChallengeManualEntryCreate>>, {challengeId: number;data: ManualEntryWriteRequest}> = (props) => {
          const {challengeId,data} = props ?? {};

          return  rankingsChallengeManualEntryCreate(challengeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RankingsChallengeManualEntryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof rankingsChallengeManualEntryCreate>>>
    export type RankingsChallengeManualEntryCreateMutationBody = ManualEntryWriteRequest
    export type RankingsChallengeManualEntryCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useRankingsChallengeManualEntryCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeManualEntryCreate>>, TError,{challengeId: number;data: ManualEntryWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rankingsChallengeManualEntryCreate>>,
        TError,
        {challengeId: number;data: ManualEntryWriteRequest},
        TContext
      > => {
      return useMutation(getRankingsChallengeManualEntryCreateMutationOptions(options), queryClient);
    }

export type v1RankingsChallengesSchoolsRetrieveResponse200 = {
  data: SchoolLeaderboard
  status: 200
}

export type v1RankingsChallengesSchoolsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsChallengesSchoolsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsChallengesSchoolsRetrieveResponseSuccess = (v1RankingsChallengesSchoolsRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsChallengesSchoolsRetrieveResponseError = (v1RankingsChallengesSchoolsRetrieveResponse401 | v1RankingsChallengesSchoolsRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsChallengesSchoolsRetrieveResponse = (v1RankingsChallengesSchoolsRetrieveResponseSuccess | v1RankingsChallengesSchoolsRetrieveResponseError)

export const getV1RankingsChallengesSchoolsRetrieveUrl = (challengeId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/schools/`
}

export const v1RankingsChallengesSchoolsRetrieve = async (challengeId: number, options?: RequestInit): Promise<v1RankingsChallengesSchoolsRetrieveResponse> => {

  return customFetch<v1RankingsChallengesSchoolsRetrieveResponse>(getV1RankingsChallengesSchoolsRetrieveUrl(challengeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsChallengesSchoolsRetrieveQueryKey = (challengeId: number,) => {
    return [
    `/api/v1/rankings/challenges/${challengeId}/schools/`
    ] as const;
    }


export const getV1RankingsChallengesSchoolsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsChallengesSchoolsRetrieveQueryKey(challengeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>> = ({ signal }) => v1RankingsChallengesSchoolsRetrieve(challengeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: challengeId !== null && challengeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsChallengesSchoolsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>>
export type V1RankingsChallengesSchoolsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsChallengesSchoolsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesSchoolsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesSchoolsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsChallengesSchoolsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsChallengesSchoolsRetrieveQueryOptions(challengeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RankingsChallengesSchoolsClassesRetrieveResponse200 = {
  data: ClassLeaderboard
  status: 200
}

export type v1RankingsChallengesSchoolsClassesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsChallengesSchoolsClassesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsChallengesSchoolsClassesRetrieveResponseSuccess = (v1RankingsChallengesSchoolsClassesRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsChallengesSchoolsClassesRetrieveResponseError = (v1RankingsChallengesSchoolsClassesRetrieveResponse401 | v1RankingsChallengesSchoolsClassesRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsChallengesSchoolsClassesRetrieveResponse = (v1RankingsChallengesSchoolsClassesRetrieveResponseSuccess | v1RankingsChallengesSchoolsClassesRetrieveResponseError)

export const getV1RankingsChallengesSchoolsClassesRetrieveUrl = (challengeId: number,
    schoolId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/schools/${schoolId}/classes/`
}

export const v1RankingsChallengesSchoolsClassesRetrieve = async (challengeId: number,
    schoolId: number, options?: RequestInit): Promise<v1RankingsChallengesSchoolsClassesRetrieveResponse> => {

  return customFetch<v1RankingsChallengesSchoolsClassesRetrieveResponse>(getV1RankingsChallengesSchoolsClassesRetrieveUrl(challengeId,schoolId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsChallengesSchoolsClassesRetrieveQueryKey = (challengeId: number,
    schoolId: number,) => {
    return [
    `/api/v1/rankings/challenges/${challengeId}/schools/${schoolId}/classes/`
    ] as const;
    }


export const getV1RankingsChallengesSchoolsClassesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(challengeId: number,
    schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsChallengesSchoolsClassesRetrieveQueryKey(challengeId,schoolId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>> = ({ signal }) => v1RankingsChallengesSchoolsClassesRetrieve(challengeId,schoolId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: challengeId !== null && challengeId !== undefined && schoolId !== null && schoolId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsChallengesSchoolsClassesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>>
export type V1RankingsChallengesSchoolsClassesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsChallengesSchoolsClassesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    schoolId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesSchoolsClassesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesSchoolsClassesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsChallengesSchoolsClassesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsChallengesSchoolsClassesRetrieveQueryOptions(challengeId,schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RankingsChallengesSchoolsProgressRetrieveResponse200 = {
  data: SchoolProgressResponse
  status: 200
}

export type v1RankingsChallengesSchoolsProgressRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsChallengesSchoolsProgressRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsChallengesSchoolsProgressRetrieveResponseSuccess = (v1RankingsChallengesSchoolsProgressRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsChallengesSchoolsProgressRetrieveResponseError = (v1RankingsChallengesSchoolsProgressRetrieveResponse401 | v1RankingsChallengesSchoolsProgressRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsChallengesSchoolsProgressRetrieveResponse = (v1RankingsChallengesSchoolsProgressRetrieveResponseSuccess | v1RankingsChallengesSchoolsProgressRetrieveResponseError)

export const getV1RankingsChallengesSchoolsProgressRetrieveUrl = (challengeId: number,
    schoolId: number,) => {




  return `/api/v1/rankings/challenges/${challengeId}/schools/${schoolId}/progress/`
}

export const v1RankingsChallengesSchoolsProgressRetrieve = async (challengeId: number,
    schoolId: number, options?: RequestInit): Promise<v1RankingsChallengesSchoolsProgressRetrieveResponse> => {

  return customFetch<v1RankingsChallengesSchoolsProgressRetrieveResponse>(getV1RankingsChallengesSchoolsProgressRetrieveUrl(challengeId,schoolId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsChallengesSchoolsProgressRetrieveQueryKey = (challengeId: number,
    schoolId: number,) => {
    return [
    `/api/v1/rankings/challenges/${challengeId}/schools/${schoolId}/progress/`
    ] as const;
    }


export const getV1RankingsChallengesSchoolsProgressRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(challengeId: number,
    schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsChallengesSchoolsProgressRetrieveQueryKey(challengeId,schoolId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>> = ({ signal }) => v1RankingsChallengesSchoolsProgressRetrieve(challengeId,schoolId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: challengeId !== null && challengeId !== undefined && schoolId !== null && schoolId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsChallengesSchoolsProgressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>>
export type V1RankingsChallengesSchoolsProgressRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsChallengesSchoolsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    schoolId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesSchoolsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsChallengesSchoolsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsChallengesSchoolsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 challengeId: number,
    schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsChallengesSchoolsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsChallengesSchoolsProgressRetrieveQueryOptions(challengeId,schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type rankingsChallengeCreateResponse201 = {
  data: ChallengeAdminRead
  status: 201
}

export type rankingsChallengeCreateResponse400 = {
  data: void
  status: 400
}

export type rankingsChallengeCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsChallengeCreateResponse403 = {
  data: void
  status: 403
}

export type rankingsChallengeCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsChallengeCreateResponseSuccess = (rankingsChallengeCreateResponse201) & {
  headers: Headers;
};
export type rankingsChallengeCreateResponseError = (rankingsChallengeCreateResponse400 | rankingsChallengeCreateResponse401 | rankingsChallengeCreateResponse403 | rankingsChallengeCreateResponse410) & {
  headers: Headers;
};

export type rankingsChallengeCreateResponse = (rankingsChallengeCreateResponseSuccess | rankingsChallengeCreateResponseError)

export const getRankingsChallengeCreateUrl = () => {




  return `/api/v1/rankings/challenges/new/`
}

/**
 * Base for every operator write — the role gate lives here, not in docs.
 */
export const rankingsChallengeCreate = async (challengeWriteRequest: ChallengeWriteRequest, options?: RequestInit): Promise<rankingsChallengeCreateResponse> => {

  return customFetch<rankingsChallengeCreateResponse>(getRankingsChallengeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(challengeWriteRequest)
  }
);}




export const getRankingsChallengeCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeCreate>>, TError,{data: ChallengeWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeCreate>>, TError,{data: ChallengeWriteRequest}, TContext> => {

const mutationKey = ['rankingsChallengeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rankingsChallengeCreate>>, {data: ChallengeWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  rankingsChallengeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RankingsChallengeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof rankingsChallengeCreate>>>
    export type RankingsChallengeCreateMutationBody = ChallengeWriteRequest
    export type RankingsChallengeCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useRankingsChallengeCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsChallengeCreate>>, TError,{data: ChallengeWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rankingsChallengeCreate>>,
        TError,
        {data: ChallengeWriteRequest},
        TContext
      > => {
      return useMutation(getRankingsChallengeCreateMutationOptions(options), queryClient);
    }

export type v1RankingsGlobalClassesProgressRetrieveResponse200 = {
  data: ClassProgressResponse
  status: 200
}

export type v1RankingsGlobalClassesProgressRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsGlobalClassesProgressRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsGlobalClassesProgressRetrieveResponseSuccess = (v1RankingsGlobalClassesProgressRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsGlobalClassesProgressRetrieveResponseError = (v1RankingsGlobalClassesProgressRetrieveResponse401 | v1RankingsGlobalClassesProgressRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsGlobalClassesProgressRetrieveResponse = (v1RankingsGlobalClassesProgressRetrieveResponseSuccess | v1RankingsGlobalClassesProgressRetrieveResponseError)

export const getV1RankingsGlobalClassesProgressRetrieveUrl = (classId: number,) => {




  return `/api/v1/rankings/global/classes/${classId}/progress/`
}

export const v1RankingsGlobalClassesProgressRetrieve = async (classId: number, options?: RequestInit): Promise<v1RankingsGlobalClassesProgressRetrieveResponse> => {

  return customFetch<v1RankingsGlobalClassesProgressRetrieveResponse>(getV1RankingsGlobalClassesProgressRetrieveUrl(classId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsGlobalClassesProgressRetrieveQueryKey = (classId: number,) => {
    return [
    `/api/v1/rankings/global/classes/${classId}/progress/`
    ] as const;
    }


export const getV1RankingsGlobalClassesProgressRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsGlobalClassesProgressRetrieveQueryKey(classId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>> = ({ signal }) => v1RankingsGlobalClassesProgressRetrieve(classId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: classId !== null && classId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsGlobalClassesProgressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>>
export type V1RankingsGlobalClassesProgressRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsGlobalClassesProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalClassesProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalClassesProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsGlobalClassesProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsGlobalClassesProgressRetrieveQueryOptions(classId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RankingsGlobalClassesStudentsRetrieveResponse200 = {
  data: StudentLeaderboard
  status: 200
}

export type v1RankingsGlobalClassesStudentsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsGlobalClassesStudentsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsGlobalClassesStudentsRetrieveResponseSuccess = (v1RankingsGlobalClassesStudentsRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsGlobalClassesStudentsRetrieveResponseError = (v1RankingsGlobalClassesStudentsRetrieveResponse401 | v1RankingsGlobalClassesStudentsRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsGlobalClassesStudentsRetrieveResponse = (v1RankingsGlobalClassesStudentsRetrieveResponseSuccess | v1RankingsGlobalClassesStudentsRetrieveResponseError)

export const getV1RankingsGlobalClassesStudentsRetrieveUrl = (classId: number,) => {




  return `/api/v1/rankings/global/classes/${classId}/students/`
}

export const v1RankingsGlobalClassesStudentsRetrieve = async (classId: number, options?: RequestInit): Promise<v1RankingsGlobalClassesStudentsRetrieveResponse> => {

  return customFetch<v1RankingsGlobalClassesStudentsRetrieveResponse>(getV1RankingsGlobalClassesStudentsRetrieveUrl(classId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsGlobalClassesStudentsRetrieveQueryKey = (classId: number,) => {
    return [
    `/api/v1/rankings/global/classes/${classId}/students/`
    ] as const;
    }


export const getV1RankingsGlobalClassesStudentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsGlobalClassesStudentsRetrieveQueryKey(classId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>> = ({ signal }) => v1RankingsGlobalClassesStudentsRetrieve(classId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: classId !== null && classId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsGlobalClassesStudentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>>
export type V1RankingsGlobalClassesStudentsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsGlobalClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsGlobalClassesStudentsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsGlobalClassesStudentsRetrieveQueryOptions(classId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RankingsGlobalClassesStudentsProgressRetrieveResponse200 = {
  data: StudentProgressResponse
  status: 200
}

export type v1RankingsGlobalClassesStudentsProgressRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsGlobalClassesStudentsProgressRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsGlobalClassesStudentsProgressRetrieveResponseSuccess = (v1RankingsGlobalClassesStudentsProgressRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsGlobalClassesStudentsProgressRetrieveResponseError = (v1RankingsGlobalClassesStudentsProgressRetrieveResponse401 | v1RankingsGlobalClassesStudentsProgressRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsGlobalClassesStudentsProgressRetrieveResponse = (v1RankingsGlobalClassesStudentsProgressRetrieveResponseSuccess | v1RankingsGlobalClassesStudentsProgressRetrieveResponseError)

export const getV1RankingsGlobalClassesStudentsProgressRetrieveUrl = (classId: number,
    studentId: number,) => {




  return `/api/v1/rankings/global/classes/${classId}/students/${studentId}/progress/`
}

export const v1RankingsGlobalClassesStudentsProgressRetrieve = async (classId: number,
    studentId: number, options?: RequestInit): Promise<v1RankingsGlobalClassesStudentsProgressRetrieveResponse> => {

  return customFetch<v1RankingsGlobalClassesStudentsProgressRetrieveResponse>(getV1RankingsGlobalClassesStudentsProgressRetrieveUrl(classId,studentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsGlobalClassesStudentsProgressRetrieveQueryKey = (classId: number,
    studentId: number,) => {
    return [
    `/api/v1/rankings/global/classes/${classId}/students/${studentId}/progress/`
    ] as const;
    }


export const getV1RankingsGlobalClassesStudentsProgressRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(classId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsGlobalClassesStudentsProgressRetrieveQueryKey(classId,studentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>> = ({ signal }) => v1RankingsGlobalClassesStudentsProgressRetrieve(classId,studentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: classId !== null && classId !== undefined && studentId !== null && studentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsGlobalClassesStudentsProgressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>>
export type V1RankingsGlobalClassesStudentsProgressRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsGlobalClassesStudentsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number,
    studentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalClassesStudentsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalClassesStudentsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsGlobalClassesStudentsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 classId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalClassesStudentsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsGlobalClassesStudentsProgressRetrieveQueryOptions(classId,studentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type rankingsGlobalConfigRetrieveResponse200 = {
  data: GlobalConfigRead
  status: 200
}

export type rankingsGlobalConfigRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsGlobalConfigRetrieveResponse403 = {
  data: void
  status: 403
}

export type rankingsGlobalConfigRetrieveResponse404 = {
  data: void
  status: 404
}

export type rankingsGlobalConfigRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsGlobalConfigRetrieveResponseSuccess = (rankingsGlobalConfigRetrieveResponse200) & {
  headers: Headers;
};
export type rankingsGlobalConfigRetrieveResponseError = (rankingsGlobalConfigRetrieveResponse401 | rankingsGlobalConfigRetrieveResponse403 | rankingsGlobalConfigRetrieveResponse404 | rankingsGlobalConfigRetrieveResponse410) & {
  headers: Headers;
};

export type rankingsGlobalConfigRetrieveResponse = (rankingsGlobalConfigRetrieveResponseSuccess | rankingsGlobalConfigRetrieveResponseError)

export const getRankingsGlobalConfigRetrieveUrl = () => {




  return `/api/v1/rankings/global/config/`
}

/**
 * Base for every operator write — the role gate lives here, not in docs.
 */
export const rankingsGlobalConfigRetrieve = async ( options?: RequestInit): Promise<rankingsGlobalConfigRetrieveResponse> => {

  return customFetch<rankingsGlobalConfigRetrieveResponse>(getRankingsGlobalConfigRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRankingsGlobalConfigRetrieveQueryKey = () => {
    return [
    `/api/v1/rankings/global/config/`
    ] as const;
    }


export const getRankingsGlobalConfigRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRankingsGlobalConfigRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>> = ({ signal }) => rankingsGlobalConfigRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RankingsGlobalConfigRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>>
export type RankingsGlobalConfigRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useRankingsGlobalConfigRetrieve<TData = Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRankingsGlobalConfigRetrieve<TData = Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRankingsGlobalConfigRetrieve<TData = Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRankingsGlobalConfigRetrieve<TData = Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsGlobalConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRankingsGlobalConfigRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type rankingsGlobalConfigUpdateResponse200 = {
  data: GlobalConfigRead
  status: 200
}

export type rankingsGlobalConfigUpdateResponse400 = {
  data: void
  status: 400
}

export type rankingsGlobalConfigUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsGlobalConfigUpdateResponse403 = {
  data: void
  status: 403
}

export type rankingsGlobalConfigUpdateResponse404 = {
  data: void
  status: 404
}

export type rankingsGlobalConfigUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsGlobalConfigUpdateResponseSuccess = (rankingsGlobalConfigUpdateResponse200) & {
  headers: Headers;
};
export type rankingsGlobalConfigUpdateResponseError = (rankingsGlobalConfigUpdateResponse400 | rankingsGlobalConfigUpdateResponse401 | rankingsGlobalConfigUpdateResponse403 | rankingsGlobalConfigUpdateResponse404 | rankingsGlobalConfigUpdateResponse410) & {
  headers: Headers;
};

export type rankingsGlobalConfigUpdateResponse = (rankingsGlobalConfigUpdateResponseSuccess | rankingsGlobalConfigUpdateResponseError)

export const getRankingsGlobalConfigUpdateUrl = () => {




  return `/api/v1/rankings/global/config/`
}

/**
 * Base for every operator write — the role gate lives here, not in docs.
 */
export const rankingsGlobalConfigUpdate = async (patchedGlobalConfigWriteRequest?: PatchedGlobalConfigWriteRequest, options?: RequestInit): Promise<rankingsGlobalConfigUpdateResponse> => {

  return customFetch<rankingsGlobalConfigUpdateResponse>(getRankingsGlobalConfigUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedGlobalConfigWriteRequest)
  }
);}




export const getRankingsGlobalConfigUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsGlobalConfigUpdate>>, TError,{data?: PatchedGlobalConfigWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rankingsGlobalConfigUpdate>>, TError,{data?: PatchedGlobalConfigWriteRequest}, TContext> => {

const mutationKey = ['rankingsGlobalConfigUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rankingsGlobalConfigUpdate>>, {data?: PatchedGlobalConfigWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  rankingsGlobalConfigUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RankingsGlobalConfigUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof rankingsGlobalConfigUpdate>>>
    export type RankingsGlobalConfigUpdateMutationBody = PatchedGlobalConfigWriteRequest | undefined
    export type RankingsGlobalConfigUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useRankingsGlobalConfigUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsGlobalConfigUpdate>>, TError,{data?: PatchedGlobalConfigWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rankingsGlobalConfigUpdate>>,
        TError,
        {data?: PatchedGlobalConfigWriteRequest},
        TContext
      > => {
      return useMutation(getRankingsGlobalConfigUpdateMutationOptions(options), queryClient);
    }

export type rankingsGlobalScoringUpdateResponse200 = {
  data: GlobalConfigRead
  status: 200
}

export type rankingsGlobalScoringUpdateResponse400 = {
  data: void
  status: 400
}

export type rankingsGlobalScoringUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsGlobalScoringUpdateResponse403 = {
  data: void
  status: 403
}

export type rankingsGlobalScoringUpdateResponse404 = {
  data: void
  status: 404
}

export type rankingsGlobalScoringUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsGlobalScoringUpdateResponseSuccess = (rankingsGlobalScoringUpdateResponse200) & {
  headers: Headers;
};
export type rankingsGlobalScoringUpdateResponseError = (rankingsGlobalScoringUpdateResponse400 | rankingsGlobalScoringUpdateResponse401 | rankingsGlobalScoringUpdateResponse403 | rankingsGlobalScoringUpdateResponse404 | rankingsGlobalScoringUpdateResponse410) & {
  headers: Headers;
};

export type rankingsGlobalScoringUpdateResponse = (rankingsGlobalScoringUpdateResponseSuccess | rankingsGlobalScoringUpdateResponseError)

export const getRankingsGlobalScoringUpdateUrl = () => {




  return `/api/v1/rankings/global/config/scoring/`
}

/**
 * Base for every operator write — the role gate lives here, not in docs.
 */
export const rankingsGlobalScoringUpdate = async (scoringRulesWriteRequest: ScoringRulesWriteRequest, options?: RequestInit): Promise<rankingsGlobalScoringUpdateResponse> => {

  return customFetch<rankingsGlobalScoringUpdateResponse>(getRankingsGlobalScoringUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scoringRulesWriteRequest)
  }
);}




export const getRankingsGlobalScoringUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsGlobalScoringUpdate>>, TError,{data: ScoringRulesWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rankingsGlobalScoringUpdate>>, TError,{data: ScoringRulesWriteRequest}, TContext> => {

const mutationKey = ['rankingsGlobalScoringUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rankingsGlobalScoringUpdate>>, {data: ScoringRulesWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  rankingsGlobalScoringUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RankingsGlobalScoringUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof rankingsGlobalScoringUpdate>>>
    export type RankingsGlobalScoringUpdateMutationBody = ScoringRulesWriteRequest
    export type RankingsGlobalScoringUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useRankingsGlobalScoringUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsGlobalScoringUpdate>>, TError,{data: ScoringRulesWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rankingsGlobalScoringUpdate>>,
        TError,
        {data: ScoringRulesWriteRequest},
        TContext
      > => {
      return useMutation(getRankingsGlobalScoringUpdateMutationOptions(options), queryClient);
    }

export type rankingsGlobalManualEntryCreateResponse201 = {
  data: ManualEntryRead
  status: 201
}

export type rankingsGlobalManualEntryCreateResponse400 = {
  data: void
  status: 400
}

export type rankingsGlobalManualEntryCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsGlobalManualEntryCreateResponse403 = {
  data: void
  status: 403
}

export type rankingsGlobalManualEntryCreateResponse404 = {
  data: void
  status: 404
}

export type rankingsGlobalManualEntryCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsGlobalManualEntryCreateResponseSuccess = (rankingsGlobalManualEntryCreateResponse201) & {
  headers: Headers;
};
export type rankingsGlobalManualEntryCreateResponseError = (rankingsGlobalManualEntryCreateResponse400 | rankingsGlobalManualEntryCreateResponse401 | rankingsGlobalManualEntryCreateResponse403 | rankingsGlobalManualEntryCreateResponse404 | rankingsGlobalManualEntryCreateResponse410) & {
  headers: Headers;
};

export type rankingsGlobalManualEntryCreateResponse = (rankingsGlobalManualEntryCreateResponseSuccess | rankingsGlobalManualEntryCreateResponseError)

export const getRankingsGlobalManualEntryCreateUrl = () => {




  return `/api/v1/rankings/global/manual-entries/`
}

/**
 * Base for every operator write — the role gate lives here, not in docs.
 */
export const rankingsGlobalManualEntryCreate = async (manualEntryWriteRequest: ManualEntryWriteRequest, options?: RequestInit): Promise<rankingsGlobalManualEntryCreateResponse> => {

  return customFetch<rankingsGlobalManualEntryCreateResponse>(getRankingsGlobalManualEntryCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(manualEntryWriteRequest)
  }
);}




export const getRankingsGlobalManualEntryCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsGlobalManualEntryCreate>>, TError,{data: ManualEntryWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rankingsGlobalManualEntryCreate>>, TError,{data: ManualEntryWriteRequest}, TContext> => {

const mutationKey = ['rankingsGlobalManualEntryCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rankingsGlobalManualEntryCreate>>, {data: ManualEntryWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  rankingsGlobalManualEntryCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RankingsGlobalManualEntryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof rankingsGlobalManualEntryCreate>>>
    export type RankingsGlobalManualEntryCreateMutationBody = ManualEntryWriteRequest
    export type RankingsGlobalManualEntryCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useRankingsGlobalManualEntryCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rankingsGlobalManualEntryCreate>>, TError,{data: ManualEntryWriteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rankingsGlobalManualEntryCreate>>,
        TError,
        {data: ManualEntryWriteRequest},
        TContext
      > => {
      return useMutation(getRankingsGlobalManualEntryCreateMutationOptions(options), queryClient);
    }

export type v1RankingsGlobalSchoolsRetrieveResponse200 = {
  data: SchoolLeaderboard
  status: 200
}

export type v1RankingsGlobalSchoolsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsGlobalSchoolsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsGlobalSchoolsRetrieveResponseSuccess = (v1RankingsGlobalSchoolsRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsGlobalSchoolsRetrieveResponseError = (v1RankingsGlobalSchoolsRetrieveResponse401 | v1RankingsGlobalSchoolsRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsGlobalSchoolsRetrieveResponse = (v1RankingsGlobalSchoolsRetrieveResponseSuccess | v1RankingsGlobalSchoolsRetrieveResponseError)

export const getV1RankingsGlobalSchoolsRetrieveUrl = () => {




  return `/api/v1/rankings/global/schools/`
}

export const v1RankingsGlobalSchoolsRetrieve = async ( options?: RequestInit): Promise<v1RankingsGlobalSchoolsRetrieveResponse> => {

  return customFetch<v1RankingsGlobalSchoolsRetrieveResponse>(getV1RankingsGlobalSchoolsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsGlobalSchoolsRetrieveQueryKey = () => {
    return [
    `/api/v1/rankings/global/schools/`
    ] as const;
    }


export const getV1RankingsGlobalSchoolsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsGlobalSchoolsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>> = ({ signal }) => v1RankingsGlobalSchoolsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsGlobalSchoolsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>>
export type V1RankingsGlobalSchoolsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsGlobalSchoolsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalSchoolsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalSchoolsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsGlobalSchoolsRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsGlobalSchoolsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RankingsGlobalSchoolsClassesRetrieveResponse200 = {
  data: ClassLeaderboard
  status: 200
}

export type v1RankingsGlobalSchoolsClassesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsGlobalSchoolsClassesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsGlobalSchoolsClassesRetrieveResponseSuccess = (v1RankingsGlobalSchoolsClassesRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsGlobalSchoolsClassesRetrieveResponseError = (v1RankingsGlobalSchoolsClassesRetrieveResponse401 | v1RankingsGlobalSchoolsClassesRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsGlobalSchoolsClassesRetrieveResponse = (v1RankingsGlobalSchoolsClassesRetrieveResponseSuccess | v1RankingsGlobalSchoolsClassesRetrieveResponseError)

export const getV1RankingsGlobalSchoolsClassesRetrieveUrl = (schoolId: number,) => {




  return `/api/v1/rankings/global/schools/${schoolId}/classes/`
}

export const v1RankingsGlobalSchoolsClassesRetrieve = async (schoolId: number, options?: RequestInit): Promise<v1RankingsGlobalSchoolsClassesRetrieveResponse> => {

  return customFetch<v1RankingsGlobalSchoolsClassesRetrieveResponse>(getV1RankingsGlobalSchoolsClassesRetrieveUrl(schoolId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsGlobalSchoolsClassesRetrieveQueryKey = (schoolId: number,) => {
    return [
    `/api/v1/rankings/global/schools/${schoolId}/classes/`
    ] as const;
    }


export const getV1RankingsGlobalSchoolsClassesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsGlobalSchoolsClassesRetrieveQueryKey(schoolId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>> = ({ signal }) => v1RankingsGlobalSchoolsClassesRetrieve(schoolId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: schoolId !== null && schoolId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsGlobalSchoolsClassesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>>
export type V1RankingsGlobalSchoolsClassesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsGlobalSchoolsClassesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 schoolId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalSchoolsClassesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalSchoolsClassesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsGlobalSchoolsClassesRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsGlobalSchoolsClassesRetrieveQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RankingsGlobalSchoolsProgressRetrieveResponse200 = {
  data: SchoolProgressResponse
  status: 200
}

export type v1RankingsGlobalSchoolsProgressRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RankingsGlobalSchoolsProgressRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RankingsGlobalSchoolsProgressRetrieveResponseSuccess = (v1RankingsGlobalSchoolsProgressRetrieveResponse200) & {
  headers: Headers;
};
export type v1RankingsGlobalSchoolsProgressRetrieveResponseError = (v1RankingsGlobalSchoolsProgressRetrieveResponse401 | v1RankingsGlobalSchoolsProgressRetrieveResponse410) & {
  headers: Headers;
};

export type v1RankingsGlobalSchoolsProgressRetrieveResponse = (v1RankingsGlobalSchoolsProgressRetrieveResponseSuccess | v1RankingsGlobalSchoolsProgressRetrieveResponseError)

export const getV1RankingsGlobalSchoolsProgressRetrieveUrl = (schoolId: number,) => {




  return `/api/v1/rankings/global/schools/${schoolId}/progress/`
}

export const v1RankingsGlobalSchoolsProgressRetrieve = async (schoolId: number, options?: RequestInit): Promise<v1RankingsGlobalSchoolsProgressRetrieveResponse> => {

  return customFetch<v1RankingsGlobalSchoolsProgressRetrieveResponse>(getV1RankingsGlobalSchoolsProgressRetrieveUrl(schoolId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RankingsGlobalSchoolsProgressRetrieveQueryKey = (schoolId: number,) => {
    return [
    `/api/v1/rankings/global/schools/${schoolId}/progress/`
    ] as const;
    }


export const getV1RankingsGlobalSchoolsProgressRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RankingsGlobalSchoolsProgressRetrieveQueryKey(schoolId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>> = ({ signal }) => v1RankingsGlobalSchoolsProgressRetrieve(schoolId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: schoolId !== null && schoolId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RankingsGlobalSchoolsProgressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>>
export type V1RankingsGlobalSchoolsProgressRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RankingsGlobalSchoolsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 schoolId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalSchoolsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RankingsGlobalSchoolsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1RankingsGlobalSchoolsProgressRetrieve<TData = Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 schoolId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RankingsGlobalSchoolsProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RankingsGlobalSchoolsProgressRetrieveQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type rankingsManualEntriesListResponse200 = {
  data: PaginatedManualEntryHistoryList
  status: 200
}

export type rankingsManualEntriesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rankingsManualEntriesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rankingsManualEntriesListResponseSuccess = (rankingsManualEntriesListResponse200) & {
  headers: Headers;
};
export type rankingsManualEntriesListResponseError = (rankingsManualEntriesListResponse401 | rankingsManualEntriesListResponse410) & {
  headers: Headers;
};

export type rankingsManualEntriesListResponse = (rankingsManualEntriesListResponseSuccess | rankingsManualEntriesListResponseError)

export const getRankingsManualEntriesListUrl = (params?: RankingsManualEntriesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/rankings/manual-entries/?${stringifiedParams}` : `/api/v1/rankings/manual-entries/`
}

/**
 * Manual point-entry history (TR-1302), newest first. Filterable by ranking, earn-time class, and time range. Pseudonym-only; no name/login/financial field.
 */
export const rankingsManualEntriesList = async (params?: RankingsManualEntriesListParams, options?: RequestInit): Promise<rankingsManualEntriesListResponse> => {

  return customFetch<rankingsManualEntriesListResponse>(getRankingsManualEntriesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRankingsManualEntriesListQueryKey = (params?: RankingsManualEntriesListParams,) => {
    return [
    `/api/v1/rankings/manual-entries/`, ...(params ? [params] : [])
    ] as const;
    }


export const getRankingsManualEntriesListQueryOptions = <TData = Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: RankingsManualEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRankingsManualEntriesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rankingsManualEntriesList>>> = ({ signal }) => rankingsManualEntriesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RankingsManualEntriesListQueryResult = NonNullable<Awaited<ReturnType<typeof rankingsManualEntriesList>>>
export type RankingsManualEntriesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useRankingsManualEntriesList<TData = Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  RankingsManualEntriesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rankingsManualEntriesList>>,
          TError,
          Awaited<ReturnType<typeof rankingsManualEntriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRankingsManualEntriesList<TData = Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: RankingsManualEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rankingsManualEntriesList>>,
          TError,
          Awaited<ReturnType<typeof rankingsManualEntriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRankingsManualEntriesList<TData = Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: RankingsManualEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRankingsManualEntriesList<TData = Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: RankingsManualEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rankingsManualEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRankingsManualEntriesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ReportingBudgetEntriesListResponse200 = {
  data: PaginatedBudgetEntryReportRowList
  status: 200
}

export type v1ReportingBudgetEntriesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ReportingBudgetEntriesListResponse403 = {
  data: void
  status: 403
}

export type v1ReportingBudgetEntriesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ReportingBudgetEntriesListResponseSuccess = (v1ReportingBudgetEntriesListResponse200) & {
  headers: Headers;
};
export type v1ReportingBudgetEntriesListResponseError = (v1ReportingBudgetEntriesListResponse401 | v1ReportingBudgetEntriesListResponse403 | v1ReportingBudgetEntriesListResponse410) & {
  headers: Headers;
};

export type v1ReportingBudgetEntriesListResponse = (v1ReportingBudgetEntriesListResponseSuccess | v1ReportingBudgetEntriesListResponseError)

export const getV1ReportingBudgetEntriesListUrl = (params?: V1ReportingBudgetEntriesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reporting/budget-entries/?${stringifiedParams}` : `/api/v1/reporting/budget-entries/`
}

/**
 * Pseudonimizowana, stronicowana lista nieusuniętych wpisów budżetowych uczniów. Daty filtrów oznaczają lokalne dni Europe/Warsaw.
 * @summary Tabela wpisów budżetowych uczniów (spec 171)
 */
export const v1ReportingBudgetEntriesList = async (params?: V1ReportingBudgetEntriesListParams, options?: RequestInit): Promise<v1ReportingBudgetEntriesListResponse> => {

  return customFetch<v1ReportingBudgetEntriesListResponse>(getV1ReportingBudgetEntriesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ReportingBudgetEntriesListQueryKey = (params?: V1ReportingBudgetEntriesListParams,) => {
    return [
    `/api/v1/reporting/budget-entries/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1ReportingBudgetEntriesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(params?: V1ReportingBudgetEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingBudgetEntriesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>> = ({ signal }) => v1ReportingBudgetEntriesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ReportingBudgetEntriesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>>
export type V1ReportingBudgetEntriesListQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1ReportingBudgetEntriesList<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params: undefined |  V1ReportingBudgetEntriesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingBudgetEntriesList<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingBudgetEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingBudgetEntriesList<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingBudgetEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Tabela wpisów budżetowych uczniów (spec 171)
 */

export function useV1ReportingBudgetEntriesList<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingBudgetEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ReportingBudgetEntriesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ReportingBudgetEntriesExportRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type v1ReportingBudgetEntriesExportRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ReportingBudgetEntriesExportRetrieveResponse403 = {
  data: void
  status: 403
}

export type v1ReportingBudgetEntriesExportRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ReportingBudgetEntriesExportRetrieveResponseSuccess = (v1ReportingBudgetEntriesExportRetrieveResponse200) & {
  headers: Headers;
};
export type v1ReportingBudgetEntriesExportRetrieveResponseError = (v1ReportingBudgetEntriesExportRetrieveResponse401 | v1ReportingBudgetEntriesExportRetrieveResponse403 | v1ReportingBudgetEntriesExportRetrieveResponse410) & {
  headers: Headers;
};

export type v1ReportingBudgetEntriesExportRetrieveResponse = (v1ReportingBudgetEntriesExportRetrieveResponseSuccess | v1ReportingBudgetEntriesExportRetrieveResponseError)

export const getV1ReportingBudgetEntriesExportRetrieveUrl = (params?: V1ReportingBudgetEntriesExportRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reporting/budget-entries/export/?${stringifiedParams}` : `/api/v1/reporting/budget-entries/export/`
}

/**
 * Arkusz „Wydatki i przychody” zawężony tymi samymi parametrami co tabela. Eksport pomija stronicowanie i zwraca wszystkie pasujące wiersze.
 * @summary Eksport zawężonej tabeli wpisów budżetowych do XLSX (spec 198)
 */
export const v1ReportingBudgetEntriesExportRetrieve = async (params?: V1ReportingBudgetEntriesExportRetrieveParams, options?: RequestInit): Promise<v1ReportingBudgetEntriesExportRetrieveResponse> => {

  return customFetch<v1ReportingBudgetEntriesExportRetrieveResponse>(getV1ReportingBudgetEntriesExportRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ReportingBudgetEntriesExportRetrieveQueryKey = (params?: V1ReportingBudgetEntriesExportRetrieveParams,) => {
    return [
    `/api/v1/reporting/budget-entries/export/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1ReportingBudgetEntriesExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(params?: V1ReportingBudgetEntriesExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingBudgetEntriesExportRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>> = ({ signal }) => v1ReportingBudgetEntriesExportRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ReportingBudgetEntriesExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>>
export type V1ReportingBudgetEntriesExportRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1ReportingBudgetEntriesExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params: undefined |  V1ReportingBudgetEntriesExportRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingBudgetEntriesExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingBudgetEntriesExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingBudgetEntriesExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingBudgetEntriesExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Eksport zawężonej tabeli wpisów budżetowych do XLSX (spec 198)
 */

export function useV1ReportingBudgetEntriesExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingBudgetEntriesExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntriesExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ReportingBudgetEntriesExportRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ReportingBudgetEntryOptionsRetrieveResponse200 = {
  data: BudgetEntryOptions
  status: 200
}

export type v1ReportingBudgetEntryOptionsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ReportingBudgetEntryOptionsRetrieveResponse403 = {
  data: void
  status: 403
}

export type v1ReportingBudgetEntryOptionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ReportingBudgetEntryOptionsRetrieveResponseSuccess = (v1ReportingBudgetEntryOptionsRetrieveResponse200) & {
  headers: Headers;
};
export type v1ReportingBudgetEntryOptionsRetrieveResponseError = (v1ReportingBudgetEntryOptionsRetrieveResponse401 | v1ReportingBudgetEntryOptionsRetrieveResponse403 | v1ReportingBudgetEntryOptionsRetrieveResponse410) & {
  headers: Headers;
};

export type v1ReportingBudgetEntryOptionsRetrieveResponse = (v1ReportingBudgetEntryOptionsRetrieveResponseSuccess | v1ReportingBudgetEntryOptionsRetrieveResponseError)

export const getV1ReportingBudgetEntryOptionsRetrieveUrl = () => {




  return `/api/v1/reporting/budget-entry-options/`
}

/**
 * @summary Opcje filtrów wpisów budżetowych (spec 171)
 */
export const v1ReportingBudgetEntryOptionsRetrieve = async ( options?: RequestInit): Promise<v1ReportingBudgetEntryOptionsRetrieveResponse> => {

  return customFetch<v1ReportingBudgetEntryOptionsRetrieveResponse>(getV1ReportingBudgetEntryOptionsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ReportingBudgetEntryOptionsRetrieveQueryKey = () => {
    return [
    `/api/v1/reporting/budget-entry-options/`
    ] as const;
    }


export const getV1ReportingBudgetEntryOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingBudgetEntryOptionsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>> = ({ signal }) => v1ReportingBudgetEntryOptionsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ReportingBudgetEntryOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>>
export type V1ReportingBudgetEntryOptionsRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1ReportingBudgetEntryOptionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingBudgetEntryOptionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingBudgetEntryOptionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Opcje filtrów wpisów budżetowych (spec 171)
 */

export function useV1ReportingBudgetEntryOptionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingBudgetEntryOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ReportingBudgetEntryOptionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ReportingPollResponseOptionsRetrieveResponse200 = {
  data: PollResponseOptions
  status: 200
}

export type v1ReportingPollResponseOptionsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ReportingPollResponseOptionsRetrieveResponse403 = {
  data: void
  status: 403
}

export type v1ReportingPollResponseOptionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ReportingPollResponseOptionsRetrieveResponseSuccess = (v1ReportingPollResponseOptionsRetrieveResponse200) & {
  headers: Headers;
};
export type v1ReportingPollResponseOptionsRetrieveResponseError = (v1ReportingPollResponseOptionsRetrieveResponse401 | v1ReportingPollResponseOptionsRetrieveResponse403 | v1ReportingPollResponseOptionsRetrieveResponse410) & {
  headers: Headers;
};

export type v1ReportingPollResponseOptionsRetrieveResponse = (v1ReportingPollResponseOptionsRetrieveResponseSuccess | v1ReportingPollResponseOptionsRetrieveResponseError)

export const getV1ReportingPollResponseOptionsRetrieveUrl = () => {




  return `/api/v1/reporting/poll-response-options/`
}

/**
 * @summary Opcje filtrów odpowiedzi w ankietach (spec 198)
 */
export const v1ReportingPollResponseOptionsRetrieve = async ( options?: RequestInit): Promise<v1ReportingPollResponseOptionsRetrieveResponse> => {

  return customFetch<v1ReportingPollResponseOptionsRetrieveResponse>(getV1ReportingPollResponseOptionsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ReportingPollResponseOptionsRetrieveQueryKey = () => {
    return [
    `/api/v1/reporting/poll-response-options/`
    ] as const;
    }


export const getV1ReportingPollResponseOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingPollResponseOptionsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>> = ({ signal }) => v1ReportingPollResponseOptionsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ReportingPollResponseOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>>
export type V1ReportingPollResponseOptionsRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1ReportingPollResponseOptionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingPollResponseOptionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingPollResponseOptionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Opcje filtrów odpowiedzi w ankietach (spec 198)
 */

export function useV1ReportingPollResponseOptionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponseOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ReportingPollResponseOptionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ReportingPollResponsesListResponse200 = {
  data: PaginatedPollResponseReportRowList
  status: 200
}

export type v1ReportingPollResponsesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ReportingPollResponsesListResponse403 = {
  data: void
  status: 403
}

export type v1ReportingPollResponsesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ReportingPollResponsesListResponseSuccess = (v1ReportingPollResponsesListResponse200) & {
  headers: Headers;
};
export type v1ReportingPollResponsesListResponseError = (v1ReportingPollResponsesListResponse401 | v1ReportingPollResponsesListResponse403 | v1ReportingPollResponsesListResponse410) & {
  headers: Headers;
};

export type v1ReportingPollResponsesListResponse = (v1ReportingPollResponsesListResponseSuccess | v1ReportingPollResponsesListResponseError)

export const getV1ReportingPollResponsesListUrl = (params?: V1ReportingPollResponsesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reporting/poll-responses/?${stringifiedParams}` : `/api/v1/reporting/poll-responses/`
}

/**
 * Pseudonimizowana, stronicowana lista odpowiedzi uczniów na pytania ankiet push — jeden wiersz na odpowiedź, czyli na parę uczeń–pytanie. Daty filtrów oznaczają lokalne dni Europe/Warsaw.
 * @summary Tabela odpowiedzi w ankietach (spec 198)
 */
export const v1ReportingPollResponsesList = async (params?: V1ReportingPollResponsesListParams, options?: RequestInit): Promise<v1ReportingPollResponsesListResponse> => {

  return customFetch<v1ReportingPollResponsesListResponse>(getV1ReportingPollResponsesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ReportingPollResponsesListQueryKey = (params?: V1ReportingPollResponsesListParams,) => {
    return [
    `/api/v1/reporting/poll-responses/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1ReportingPollResponsesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(params?: V1ReportingPollResponsesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingPollResponsesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingPollResponsesList>>> = ({ signal }) => v1ReportingPollResponsesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ReportingPollResponsesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingPollResponsesList>>>
export type V1ReportingPollResponsesListQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1ReportingPollResponsesList<TData = Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params: undefined |  V1ReportingPollResponsesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingPollResponsesList>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingPollResponsesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingPollResponsesList<TData = Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingPollResponsesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingPollResponsesList>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingPollResponsesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingPollResponsesList<TData = Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingPollResponsesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Tabela odpowiedzi w ankietach (spec 198)
 */

export function useV1ReportingPollResponsesList<TData = Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingPollResponsesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ReportingPollResponsesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ReportingPollResponsesExportRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type v1ReportingPollResponsesExportRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ReportingPollResponsesExportRetrieveResponse403 = {
  data: void
  status: 403
}

export type v1ReportingPollResponsesExportRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ReportingPollResponsesExportRetrieveResponseSuccess = (v1ReportingPollResponsesExportRetrieveResponse200) & {
  headers: Headers;
};
export type v1ReportingPollResponsesExportRetrieveResponseError = (v1ReportingPollResponsesExportRetrieveResponse401 | v1ReportingPollResponsesExportRetrieveResponse403 | v1ReportingPollResponsesExportRetrieveResponse410) & {
  headers: Headers;
};

export type v1ReportingPollResponsesExportRetrieveResponse = (v1ReportingPollResponsesExportRetrieveResponseSuccess | v1ReportingPollResponsesExportRetrieveResponseError)

export const getV1ReportingPollResponsesExportRetrieveUrl = (params?: V1ReportingPollResponsesExportRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reporting/poll-responses/export/?${stringifiedParams}` : `/api/v1/reporting/poll-responses/export/`
}

/**
 * Arkusz „Odpowiedzi w ankietach” zawężony tymi samymi parametrami co tabela. Eksport pomija stronicowanie i zwraca wszystkie pasujące wiersze.
 * @summary Eksport zawężonej tabeli odpowiedzi w ankietach do XLSX (spec 198)
 */
export const v1ReportingPollResponsesExportRetrieve = async (params?: V1ReportingPollResponsesExportRetrieveParams, options?: RequestInit): Promise<v1ReportingPollResponsesExportRetrieveResponse> => {

  return customFetch<v1ReportingPollResponsesExportRetrieveResponse>(getV1ReportingPollResponsesExportRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ReportingPollResponsesExportRetrieveQueryKey = (params?: V1ReportingPollResponsesExportRetrieveParams,) => {
    return [
    `/api/v1/reporting/poll-responses/export/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1ReportingPollResponsesExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(params?: V1ReportingPollResponsesExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingPollResponsesExportRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>> = ({ signal }) => v1ReportingPollResponsesExportRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ReportingPollResponsesExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>>
export type V1ReportingPollResponsesExportRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1ReportingPollResponsesExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params: undefined |  V1ReportingPollResponsesExportRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingPollResponsesExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingPollResponsesExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingPollResponsesExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingPollResponsesExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Eksport zawężonej tabeli odpowiedzi w ankietach do XLSX (spec 198)
 */

export function useV1ReportingPollResponsesExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
 params?: V1ReportingPollResponsesExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingPollResponsesExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ReportingPollResponsesExportRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1ReportingStudentDataExportRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type v1ReportingStudentDataExportRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1ReportingStudentDataExportRetrieveResponse403 = {
  data: void
  status: 403
}

export type v1ReportingStudentDataExportRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1ReportingStudentDataExportRetrieveResponseSuccess = (v1ReportingStudentDataExportRetrieveResponse200) & {
  headers: Headers;
};
export type v1ReportingStudentDataExportRetrieveResponseError = (v1ReportingStudentDataExportRetrieveResponse401 | v1ReportingStudentDataExportRetrieveResponse403 | v1ReportingStudentDataExportRetrieveResponse410) & {
  headers: Headers;
};

export type v1ReportingStudentDataExportRetrieveResponse = (v1ReportingStudentDataExportRetrieveResponseSuccess | v1ReportingStudentDataExportRetrieveResponseError)

export const getV1ReportingStudentDataExportRetrieveUrl = () => {




  return `/api/v1/reporting/student-data-export/`
}

/**
 * Plik XLSX ze wszystkimi danymi wprowadzonymi przez uczniów, bez loginów (spec 167).
 * @summary Eksport danych uczniów do XLSX (spec 167)
 */
export const v1ReportingStudentDataExportRetrieve = async ( options?: RequestInit): Promise<v1ReportingStudentDataExportRetrieveResponse> => {

  return customFetch<v1ReportingStudentDataExportRetrieveResponse>(getV1ReportingStudentDataExportRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1ReportingStudentDataExportRetrieveQueryKey = () => {
    return [
    `/api/v1/reporting/student-data-export/`
    ] as const;
    }


export const getV1ReportingStudentDataExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingStudentDataExportRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>> = ({ signal }) => v1ReportingStudentDataExportRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1ReportingStudentDataExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>>
export type V1ReportingStudentDataExportRetrieveQueryError = UnauthorizedResponse | void | AccountGoneResponse


export function useV1ReportingStudentDataExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingStudentDataExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1ReportingStudentDataExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Eksport danych uczniów do XLSX (spec 167)
 */

export function useV1ReportingStudentDataExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError = UnauthorizedResponse | void | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingStudentDataExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1ReportingStudentDataExportRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type rewardPricingRetrieveResponse200 = {
  data: PricingDocument
  status: 200
}

export type rewardPricingRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rewardPricingRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rewardPricingRetrieveResponseSuccess = (rewardPricingRetrieveResponse200) & {
  headers: Headers;
};
export type rewardPricingRetrieveResponseError = (rewardPricingRetrieveResponse401 | rewardPricingRetrieveResponse410) & {
  headers: Headers;
};

export type rewardPricingRetrieveResponse = (rewardPricingRetrieveResponseSuccess | rewardPricingRetrieveResponseError)

export const getRewardPricingRetrieveUrl = () => {




  return `/api/v1/rewards/pricing/`
}

export const rewardPricingRetrieve = async ( options?: RequestInit): Promise<rewardPricingRetrieveResponse> => {

  return customFetch<rewardPricingRetrieveResponse>(getRewardPricingRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRewardPricingRetrieveQueryKey = () => {
    return [
    `/api/v1/rewards/pricing/`
    ] as const;
    }


export const getRewardPricingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRewardPricingRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rewardPricingRetrieve>>> = ({ signal }) => rewardPricingRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RewardPricingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof rewardPricingRetrieve>>>
export type RewardPricingRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useRewardPricingRetrieve<TData = Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardPricingRetrieve>>,
          TError,
          Awaited<ReturnType<typeof rewardPricingRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRewardPricingRetrieve<TData = Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardPricingRetrieve>>,
          TError,
          Awaited<ReturnType<typeof rewardPricingRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRewardPricingRetrieve<TData = Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRewardPricingRetrieve<TData = Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewardPricingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRewardPricingRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type rewardPricingPublishResponse200 = {
  data: PricingDocument
  status: 200
}

export type rewardPricingPublishResponse400 = {
  data: PricingError
  status: 400
}

export type rewardPricingPublishResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type rewardPricingPublishResponse403 = {
  data: PricingError
  status: 403
}

export type rewardPricingPublishResponse409 = {
  data: PricingError
  status: 409
}

export type rewardPricingPublishResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type rewardPricingPublishResponseSuccess = (rewardPricingPublishResponse200) & {
  headers: Headers;
};
export type rewardPricingPublishResponseError = (rewardPricingPublishResponse400 | rewardPricingPublishResponse401 | rewardPricingPublishResponse403 | rewardPricingPublishResponse409 | rewardPricingPublishResponse410) & {
  headers: Headers;
};

export type rewardPricingPublishResponse = (rewardPricingPublishResponseSuccess | rewardPricingPublishResponseError)

export const getRewardPricingPublishUrl = () => {




  return `/api/v1/rewards/pricing/`
}

export const rewardPricingPublish = async (pricingPublishRequest: PricingPublishRequest, options?: RequestInit): Promise<rewardPricingPublishResponse> => {

  return customFetch<rewardPricingPublishResponse>(getRewardPricingPublishUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingPublishRequest)
  }
);}




export const getRewardPricingPublishMutationOptions = <TError = PricingError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rewardPricingPublish>>, TError,{data: PricingPublishRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rewardPricingPublish>>, TError,{data: PricingPublishRequest}, TContext> => {

const mutationKey = ['rewardPricingPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rewardPricingPublish>>, {data: PricingPublishRequest}> = (props) => {
          const {data} = props ?? {};

          return  rewardPricingPublish(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RewardPricingPublishMutationResult = NonNullable<Awaited<ReturnType<typeof rewardPricingPublish>>>
    export type RewardPricingPublishMutationBody = PricingPublishRequest
    export type RewardPricingPublishMutationError = PricingError | UnauthorizedResponse | AccountGoneResponse

    export const useRewardPricingPublish = <TError = PricingError | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rewardPricingPublish>>, TError,{data: PricingPublishRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rewardPricingPublish>>,
        TError,
        {data: PricingPublishRequest},
        TContext
      > => {
      return useMutation(getRewardPricingPublishMutationOptions(options), queryClient);
    }

export type v1RspoInstitutionsListResponse200 = {
  data: PaginatedRspoInstitutionListList
  status: 200
}

export type v1RspoInstitutionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RspoInstitutionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RspoInstitutionsListResponseSuccess = (v1RspoInstitutionsListResponse200) & {
  headers: Headers;
};
export type v1RspoInstitutionsListResponseError = (v1RspoInstitutionsListResponse401 | v1RspoInstitutionsListResponse410) & {
  headers: Headers;
};

export type v1RspoInstitutionsListResponse = (v1RspoInstitutionsListResponseSuccess | v1RspoInstitutionsListResponseError)

export const getV1RspoInstitutionsListUrl = (params?: V1RspoInstitutionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/rspo-institutions/?${stringifiedParams}` : `/api/v1/rspo-institutions/`
}

/**
 * Read-only RSPO dictionary. Admin/superadmin only.
 *
 * `list` returns a flat paginated page (filterable + searchable + orderable);
 * `retrieve` returns the root of the requested node's tree with the full
 * 3-level subtree nested under `children`.
 * @summary Lista instytucji RSPO (słownik)
 */
export const v1RspoInstitutionsList = async (params?: V1RspoInstitutionsListParams, options?: RequestInit): Promise<v1RspoInstitutionsListResponse> => {

  return customFetch<v1RspoInstitutionsListResponse>(getV1RspoInstitutionsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RspoInstitutionsListQueryKey = (params?: V1RspoInstitutionsListParams,) => {
    return [
    `/api/v1/rspo-institutions/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1RspoInstitutionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1RspoInstitutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RspoInstitutionsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RspoInstitutionsList>>> = ({ signal }) => v1RspoInstitutionsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RspoInstitutionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1RspoInstitutionsList>>>
export type V1RspoInstitutionsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RspoInstitutionsList<TData = Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1RspoInstitutionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RspoInstitutionsList>>,
          TError,
          Awaited<ReturnType<typeof v1RspoInstitutionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RspoInstitutionsList<TData = Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1RspoInstitutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RspoInstitutionsList>>,
          TError,
          Awaited<ReturnType<typeof v1RspoInstitutionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RspoInstitutionsList<TData = Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1RspoInstitutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista instytucji RSPO (słownik)
 */

export function useV1RspoInstitutionsList<TData = Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1RspoInstitutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RspoInstitutionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1RspoInstitutionsRetrieveResponse200 = {
  data: RspoInstitutionDetail
  status: 200
}

export type v1RspoInstitutionsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1RspoInstitutionsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1RspoInstitutionsRetrieveResponseSuccess = (v1RspoInstitutionsRetrieveResponse200) & {
  headers: Headers;
};
export type v1RspoInstitutionsRetrieveResponseError = (v1RspoInstitutionsRetrieveResponse401 | v1RspoInstitutionsRetrieveResponse410) & {
  headers: Headers;
};

export type v1RspoInstitutionsRetrieveResponse = (v1RspoInstitutionsRetrieveResponseSuccess | v1RspoInstitutionsRetrieveResponseError)

export const getV1RspoInstitutionsRetrieveUrl = (rspo: number,) => {




  return `/api/v1/rspo-institutions/${rspo}/`
}

/**
 * Read-only RSPO dictionary. Admin/superadmin only.
 *
 * `list` returns a flat paginated page (filterable + searchable + orderable);
 * `retrieve` returns the root of the requested node's tree with the full
 * 3-level subtree nested under `children`.
 * @summary Drzewo instytucji RSPO (root z poddrzewem)
 */
export const v1RspoInstitutionsRetrieve = async (rspo: number, options?: RequestInit): Promise<v1RspoInstitutionsRetrieveResponse> => {

  return customFetch<v1RspoInstitutionsRetrieveResponse>(getV1RspoInstitutionsRetrieveUrl(rspo),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1RspoInstitutionsRetrieveQueryKey = (rspo: number,) => {
    return [
    `/api/v1/rspo-institutions/${rspo}/`
    ] as const;
    }


export const getV1RspoInstitutionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(rspo: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1RspoInstitutionsRetrieveQueryKey(rspo);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>> = ({ signal }) => v1RspoInstitutionsRetrieve(rspo, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: rspo !== null && rspo !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1RspoInstitutionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>>
export type V1RspoInstitutionsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1RspoInstitutionsRetrieve<TData = Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 rspo: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RspoInstitutionsRetrieve<TData = Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 rspo: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1RspoInstitutionsRetrieve<TData = Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 rspo: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Drzewo instytucji RSPO (root z poddrzewem)
 */

export function useV1RspoInstitutionsRetrieve<TData = Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 rspo: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1RspoInstitutionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1RspoInstitutionsRetrieveQueryOptions(rspo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type schoolChangeProposalsListResponse200 = {
  data: PaginatedSchoolChangeProposalList
  status: 200
}

export type schoolChangeProposalsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type schoolChangeProposalsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type schoolChangeProposalsListResponseSuccess = (schoolChangeProposalsListResponse200) & {
  headers: Headers;
};
export type schoolChangeProposalsListResponseError = (schoolChangeProposalsListResponse401 | schoolChangeProposalsListResponse410) & {
  headers: Headers;
};

export type schoolChangeProposalsListResponse = (schoolChangeProposalsListResponseSuccess | schoolChangeProposalsListResponseError)

export const getSchoolChangeProposalsListUrl = (params?: SchoolChangeProposalsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/school-change-proposals/?${stringifiedParams}` : `/api/v1/school-change-proposals/`
}

/**
 * Nauczyciel widzi własne propozycje (dowolny stan), operator (admin/superadmin) wszystkie. Filtr `state`: stan albo `decided` (zatwierdzone, odrzucone i zastąpione); bez niego operator dostaje propozycje oczekujące, nauczyciel wszystkie własne. `school` zawęża do jednej szkoły. `ordering`: `submitted_at`, `decided_at` (z `-`); domyślnie oczekujące od najstarszej, rozstrzygnięte od najnowszej decyzji.
 * @summary Propozycje zmian danych szkół (TR-501 R10)
 */
export const schoolChangeProposalsList = async (params?: SchoolChangeProposalsListParams, options?: RequestInit): Promise<schoolChangeProposalsListResponse> => {

  return customFetch<schoolChangeProposalsListResponse>(getSchoolChangeProposalsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSchoolChangeProposalsListQueryKey = (params?: SchoolChangeProposalsListParams,) => {
    return [
    `/api/v1/school-change-proposals/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSchoolChangeProposalsListQueryOptions = <TData = Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: SchoolChangeProposalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolChangeProposalsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolChangeProposalsList>>> = ({ signal }) => schoolChangeProposalsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolChangeProposalsListQueryResult = NonNullable<Awaited<ReturnType<typeof schoolChangeProposalsList>>>
export type SchoolChangeProposalsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useSchoolChangeProposalsList<TData = Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  SchoolChangeProposalsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolChangeProposalsList>>,
          TError,
          Awaited<ReturnType<typeof schoolChangeProposalsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolChangeProposalsList<TData = Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: SchoolChangeProposalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolChangeProposalsList>>,
          TError,
          Awaited<ReturnType<typeof schoolChangeProposalsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolChangeProposalsList<TData = Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: SchoolChangeProposalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Propozycje zmian danych szkół (TR-501 R10)
 */

export function useSchoolChangeProposalsList<TData = Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: SchoolChangeProposalsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolChangeProposalsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type schoolChangeProposalsCreateResponse201 = {
  data: SchoolChangeProposal
  status: 201
}

export type schoolChangeProposalsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type schoolChangeProposalsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type schoolChangeProposalsCreateResponseSuccess = (schoolChangeProposalsCreateResponse201) & {
  headers: Headers;
};
export type schoolChangeProposalsCreateResponseError = (schoolChangeProposalsCreateResponse401 | schoolChangeProposalsCreateResponse410) & {
  headers: Headers;
};

export type schoolChangeProposalsCreateResponse = (schoolChangeProposalsCreateResponseSuccess | schoolChangeProposalsCreateResponseError)

export const getSchoolChangeProposalsCreateUrl = () => {




  return `/api/v1/school-change-proposals/`
}

/**
 * Teacher-proposed school-data changes with operator approval (feature 019).
 *
 * Teacher surface (`IsTeacher`): create a proposal, list own. Operator surface
 * (`IsAdminOrSuperadmin`): list pending, approve/reject. The list is
 * role-polymorphic by queryset — the same self-filtering the pending-tasks tray
 * relies on, so a teacher never sees the pending queue and vice versa.
 * @summary Zgłoś zmianę danych szkoły (nauczyciel)
 */
export const schoolChangeProposalsCreate = async (schoolChangeProposalRequest: SchoolChangeProposalRequest, options?: RequestInit): Promise<schoolChangeProposalsCreateResponse> => {

  return customFetch<schoolChangeProposalsCreateResponse>(getSchoolChangeProposalsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolChangeProposalRequest)
  }
);}




export const getSchoolChangeProposalsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolChangeProposalsCreate>>, TError,{data: SchoolChangeProposalRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolChangeProposalsCreate>>, TError,{data: SchoolChangeProposalRequest}, TContext> => {

const mutationKey = ['schoolChangeProposalsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolChangeProposalsCreate>>, {data: SchoolChangeProposalRequest}> = (props) => {
          const {data} = props ?? {};

          return  schoolChangeProposalsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolChangeProposalsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof schoolChangeProposalsCreate>>>
    export type SchoolChangeProposalsCreateMutationBody = SchoolChangeProposalRequest
    export type SchoolChangeProposalsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Zgłoś zmianę danych szkoły (nauczyciel)
 */
export const useSchoolChangeProposalsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolChangeProposalsCreate>>, TError,{data: SchoolChangeProposalRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolChangeProposalsCreate>>,
        TError,
        {data: SchoolChangeProposalRequest},
        TContext
      > => {
      return useMutation(getSchoolChangeProposalsCreateMutationOptions(options), queryClient);
    }

export type schoolChangeProposalsApproveResponse200 = {
  data: SchoolChangeProposal
  status: 200
}

export type schoolChangeProposalsApproveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type schoolChangeProposalsApproveResponse409 = {
  data: SchoolChangeProposalConflict
  status: 409
}

export type schoolChangeProposalsApproveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type schoolChangeProposalsApproveResponseSuccess = (schoolChangeProposalsApproveResponse200) & {
  headers: Headers;
};
export type schoolChangeProposalsApproveResponseError = (schoolChangeProposalsApproveResponse401 | schoolChangeProposalsApproveResponse409 | schoolChangeProposalsApproveResponse410) & {
  headers: Headers;
};

export type schoolChangeProposalsApproveResponse = (schoolChangeProposalsApproveResponseSuccess | schoolChangeProposalsApproveResponseError)

export const getSchoolChangeProposalsApproveUrl = (id: number,) => {




  return `/api/v1/school-change-proposals/${id}/approve/`
}

/**
 * Nakłada zmiany nauczyciela (od stanu przy zgłoszeniu do propozycji) na bieżące dane szkoły; zmiany operatora w innych miejscach zostają. Gdy obie strony zmieniły to samo miejsce inaczej (`is_stale`), wymaga `confirm_current: true`, inaczej 409 `school_changed`. 409 `not_pending`, gdy propozycja jest już rozstrzygnięta; 409 `school_not_active`, gdy szkoła nie jest aktywna.
 * @summary Zatwierdź propozycję (operator)
 */
export const schoolChangeProposalsApprove = async (id: number,
    schoolChangeProposalApproveRequest?: SchoolChangeProposalApproveRequest, options?: RequestInit): Promise<schoolChangeProposalsApproveResponse> => {

  return customFetch<schoolChangeProposalsApproveResponse>(getSchoolChangeProposalsApproveUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolChangeProposalApproveRequest)
  }
);}




export const getSchoolChangeProposalsApproveMutationOptions = <TError = UnauthorizedResponse | SchoolChangeProposalConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolChangeProposalsApprove>>, TError,{id: number;data?: SchoolChangeProposalApproveRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolChangeProposalsApprove>>, TError,{id: number;data?: SchoolChangeProposalApproveRequest}, TContext> => {

const mutationKey = ['schoolChangeProposalsApprove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolChangeProposalsApprove>>, {id: number;data?: SchoolChangeProposalApproveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  schoolChangeProposalsApprove(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolChangeProposalsApproveMutationResult = NonNullable<Awaited<ReturnType<typeof schoolChangeProposalsApprove>>>
    export type SchoolChangeProposalsApproveMutationBody = SchoolChangeProposalApproveRequest | undefined
    export type SchoolChangeProposalsApproveMutationError = UnauthorizedResponse | SchoolChangeProposalConflict | AccountGoneResponse

    /**
 * @summary Zatwierdź propozycję (operator)
 */
export const useSchoolChangeProposalsApprove = <TError = UnauthorizedResponse | SchoolChangeProposalConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolChangeProposalsApprove>>, TError,{id: number;data?: SchoolChangeProposalApproveRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolChangeProposalsApprove>>,
        TError,
        {id: number;data?: SchoolChangeProposalApproveRequest},
        TContext
      > => {
      return useMutation(getSchoolChangeProposalsApproveMutationOptions(options), queryClient);
    }

export type schoolChangeProposalsRejectResponse200 = {
  data: SchoolChangeProposal
  status: 200
}

export type schoolChangeProposalsRejectResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type schoolChangeProposalsRejectResponse409 = {
  data: SchoolChangeProposalConflict
  status: 409
}

export type schoolChangeProposalsRejectResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type schoolChangeProposalsRejectResponseSuccess = (schoolChangeProposalsRejectResponse200) & {
  headers: Headers;
};
export type schoolChangeProposalsRejectResponseError = (schoolChangeProposalsRejectResponse401 | schoolChangeProposalsRejectResponse409 | schoolChangeProposalsRejectResponse410) & {
  headers: Headers;
};

export type schoolChangeProposalsRejectResponse = (schoolChangeProposalsRejectResponseSuccess | schoolChangeProposalsRejectResponseError)

export const getSchoolChangeProposalsRejectUrl = (id: number,) => {




  return `/api/v1/school-change-proposals/${id}/reject/`
}

/**
 * Teacher-proposed school-data changes with operator approval (feature 019).
 *
 * Teacher surface (`IsTeacher`): create a proposal, list own. Operator surface
 * (`IsAdminOrSuperadmin`): list pending, approve/reject. The list is
 * role-polymorphic by queryset — the same self-filtering the pending-tasks tray
 * relies on, so a teacher never sees the pending queue and vice versa.
 * @summary Odrzuć propozycję (operator)
 */
export const schoolChangeProposalsReject = async (id: number, options?: RequestInit): Promise<schoolChangeProposalsRejectResponse> => {

  return customFetch<schoolChangeProposalsRejectResponse>(getSchoolChangeProposalsRejectUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSchoolChangeProposalsRejectMutationOptions = <TError = UnauthorizedResponse | SchoolChangeProposalConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolChangeProposalsReject>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolChangeProposalsReject>>, TError,{id: number}, TContext> => {

const mutationKey = ['schoolChangeProposalsReject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolChangeProposalsReject>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  schoolChangeProposalsReject(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolChangeProposalsRejectMutationResult = NonNullable<Awaited<ReturnType<typeof schoolChangeProposalsReject>>>

    export type SchoolChangeProposalsRejectMutationError = UnauthorizedResponse | SchoolChangeProposalConflict | AccountGoneResponse

    /**
 * @summary Odrzuć propozycję (operator)
 */
export const useSchoolChangeProposalsReject = <TError = UnauthorizedResponse | SchoolChangeProposalConflict | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolChangeProposalsReject>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolChangeProposalsReject>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getSchoolChangeProposalsRejectMutationOptions(options), queryClient);
    }

export type schoolChangeProposalsAssignedSchoolsResponse200 = {
  data: PaginatedTeacherAssignedSchoolList
  status: 200
}

export type schoolChangeProposalsAssignedSchoolsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type schoolChangeProposalsAssignedSchoolsResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type schoolChangeProposalsAssignedSchoolsResponseSuccess = (schoolChangeProposalsAssignedSchoolsResponse200) & {
  headers: Headers;
};
export type schoolChangeProposalsAssignedSchoolsResponseError = (schoolChangeProposalsAssignedSchoolsResponse401 | schoolChangeProposalsAssignedSchoolsResponse410) & {
  headers: Headers;
};

export type schoolChangeProposalsAssignedSchoolsResponse = (schoolChangeProposalsAssignedSchoolsResponseSuccess | schoolChangeProposalsAssignedSchoolsResponseError)

export const getSchoolChangeProposalsAssignedSchoolsUrl = (params?: SchoolChangeProposalsAssignedSchoolsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/school-change-proposals/assigned-schools/?${stringifiedParams}` : `/api/v1/school-change-proposals/assigned-schools/`
}

/**
 * Teacher-proposed school-data changes with operator approval (feature 019).
 *
 * Teacher surface (`IsTeacher`): create a proposal, list own. Operator surface
 * (`IsAdminOrSuperadmin`): list pending, approve/reject. The list is
 * role-polymorphic by queryset — the same self-filtering the pending-tasks tray
 * relies on, so a teacher never sees the pending queue and vice versa.
 * @summary Szkoły przypisane do nauczyciela (do zgłoszenia zmiany)
 */
export const schoolChangeProposalsAssignedSchools = async (params?: SchoolChangeProposalsAssignedSchoolsParams, options?: RequestInit): Promise<schoolChangeProposalsAssignedSchoolsResponse> => {

  return customFetch<schoolChangeProposalsAssignedSchoolsResponse>(getSchoolChangeProposalsAssignedSchoolsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSchoolChangeProposalsAssignedSchoolsQueryKey = (params?: SchoolChangeProposalsAssignedSchoolsParams,) => {
    return [
    `/api/v1/school-change-proposals/assigned-schools/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSchoolChangeProposalsAssignedSchoolsQueryOptions = <TData = Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: SchoolChangeProposalsAssignedSchoolsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolChangeProposalsAssignedSchoolsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>> = ({ signal }) => schoolChangeProposalsAssignedSchools(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolChangeProposalsAssignedSchoolsQueryResult = NonNullable<Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>>
export type SchoolChangeProposalsAssignedSchoolsQueryError = UnauthorizedResponse | AccountGoneResponse


export function useSchoolChangeProposalsAssignedSchools<TData = Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  SchoolChangeProposalsAssignedSchoolsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>,
          TError,
          Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolChangeProposalsAssignedSchools<TData = Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: SchoolChangeProposalsAssignedSchoolsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>,
          TError,
          Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolChangeProposalsAssignedSchools<TData = Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: SchoolChangeProposalsAssignedSchoolsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szkoły przypisane do nauczyciela (do zgłoszenia zmiany)
 */

export function useSchoolChangeProposalsAssignedSchools<TData = Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: SchoolChangeProposalsAssignedSchoolsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolChangeProposalsAssignedSchools>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolChangeProposalsAssignedSchoolsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1SchoolNamesListResponse200 = {
  data: PaginatedSchoolNameEntryListList
  status: 200
}

export type v1SchoolNamesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolNamesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolNamesListResponseSuccess = (v1SchoolNamesListResponse200) & {
  headers: Headers;
};
export type v1SchoolNamesListResponseError = (v1SchoolNamesListResponse401 | v1SchoolNamesListResponse410) & {
  headers: Headers;
};

export type v1SchoolNamesListResponse = (v1SchoolNamesListResponseSuccess | v1SchoolNamesListResponseError)

export const getV1SchoolNamesListUrl = (params?: V1SchoolNamesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/school-names/?${stringifiedParams}` : `/api/v1/school-names/`
}

/**
 * List-only school-name dictionary powering the name-field autocomplete
 * (TR-500 R11). Mirrors `SchoolTypeViewSet`.
 * @summary Lista nazw szkół (słownik autouzupełniania, TR-500 R11)
 */
export const v1SchoolNamesList = async (params?: V1SchoolNamesListParams, options?: RequestInit): Promise<v1SchoolNamesListResponse> => {

  return customFetch<v1SchoolNamesListResponse>(getV1SchoolNamesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1SchoolNamesListQueryKey = (params?: V1SchoolNamesListParams,) => {
    return [
    `/api/v1/school-names/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1SchoolNamesListQueryOptions = <TData = Awaited<ReturnType<typeof v1SchoolNamesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1SchoolNamesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolNamesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1SchoolNamesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1SchoolNamesList>>> = ({ signal }) => v1SchoolNamesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1SchoolNamesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1SchoolNamesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1SchoolNamesList>>>
export type V1SchoolNamesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1SchoolNamesList<TData = Awaited<ReturnType<typeof v1SchoolNamesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1SchoolNamesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolNamesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SchoolNamesList>>,
          TError,
          Awaited<ReturnType<typeof v1SchoolNamesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SchoolNamesList<TData = Awaited<ReturnType<typeof v1SchoolNamesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SchoolNamesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolNamesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SchoolNamesList>>,
          TError,
          Awaited<ReturnType<typeof v1SchoolNamesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SchoolNamesList<TData = Awaited<ReturnType<typeof v1SchoolNamesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SchoolNamesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolNamesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista nazw szkół (słownik autouzupełniania, TR-500 R11)
 */

export function useV1SchoolNamesList<TData = Awaited<ReturnType<typeof v1SchoolNamesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SchoolNamesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolNamesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1SchoolNamesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1SchoolTypesListResponse200 = {
  data: PaginatedSchoolTypeListList
  status: 200
}

export type v1SchoolTypesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolTypesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolTypesListResponseSuccess = (v1SchoolTypesListResponse200) & {
  headers: Headers;
};
export type v1SchoolTypesListResponseError = (v1SchoolTypesListResponse401 | v1SchoolTypesListResponse410) & {
  headers: Headers;
};

export type v1SchoolTypesListResponse = (v1SchoolTypesListResponseSuccess | v1SchoolTypesListResponseError)

export const getV1SchoolTypesListUrl = (params?: V1SchoolTypesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/school-types/?${stringifiedParams}` : `/api/v1/school-types/`
}

/**
 * List-only school-type dictionary. Admin/superadmin only (WO-SCHOOL-003).
 *
 * Explicit `ListModelMixin` (not
 * `ReadOnlyModelViewSet`) so only the list route is registered — no detail op
 * leaks into the schema; the panel needs the collection, not single rows. Reuses
 * `SchoolListPagination` (same envelope as `/schools/`).
 * @summary Lista typów szkół (słownik, TR-500 R12)
 */
export const v1SchoolTypesList = async (params?: V1SchoolTypesListParams, options?: RequestInit): Promise<v1SchoolTypesListResponse> => {

  return customFetch<v1SchoolTypesListResponse>(getV1SchoolTypesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1SchoolTypesListQueryKey = (params?: V1SchoolTypesListParams,) => {
    return [
    `/api/v1/school-types/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1SchoolTypesListQueryOptions = <TData = Awaited<ReturnType<typeof v1SchoolTypesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1SchoolTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolTypesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1SchoolTypesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1SchoolTypesList>>> = ({ signal }) => v1SchoolTypesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1SchoolTypesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1SchoolTypesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1SchoolTypesList>>>
export type V1SchoolTypesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1SchoolTypesList<TData = Awaited<ReturnType<typeof v1SchoolTypesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1SchoolTypesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolTypesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SchoolTypesList>>,
          TError,
          Awaited<ReturnType<typeof v1SchoolTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SchoolTypesList<TData = Awaited<ReturnType<typeof v1SchoolTypesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SchoolTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolTypesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SchoolTypesList>>,
          TError,
          Awaited<ReturnType<typeof v1SchoolTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SchoolTypesList<TData = Awaited<ReturnType<typeof v1SchoolTypesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SchoolTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolTypesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista typów szkół (słownik, TR-500 R12)
 */

export function useV1SchoolTypesList<TData = Awaited<ReturnType<typeof v1SchoolTypesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SchoolTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolTypesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1SchoolTypesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1SchoolsListResponse200 = {
  data: PaginatedSchoolListList
  status: 200
}

export type v1SchoolsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsListResponseSuccess = (v1SchoolsListResponse200) & {
  headers: Headers;
};
export type v1SchoolsListResponseError = (v1SchoolsListResponse401 | v1SchoolsListResponse410) & {
  headers: Headers;
};

export type v1SchoolsListResponse = (v1SchoolsListResponseSuccess | v1SchoolsListResponseError)

export const getV1SchoolsListUrl = (params?: V1SchoolsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/schools/?${stringifiedParams}` : `/api/v1/schools/`
}

/**
 * School CRUD (no destroy) + TR-502 list. Admin/superadmin only.
 *
 * Explicit mixin composition (not `ModelViewSet` minus `destroy`) so the DELETE
 * route is never registered and no delete operation leaks into the schema.
 * @summary Lista szkół (TR-502)
 */
export const v1SchoolsList = async (params?: V1SchoolsListParams, options?: RequestInit): Promise<v1SchoolsListResponse> => {

  return customFetch<v1SchoolsListResponse>(getV1SchoolsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1SchoolsListQueryKey = (params?: V1SchoolsListParams,) => {
    return [
    `/api/v1/schools/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1SchoolsListQueryOptions = <TData = Awaited<ReturnType<typeof v1SchoolsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1SchoolsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1SchoolsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1SchoolsList>>> = ({ signal }) => v1SchoolsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1SchoolsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsList>>>
export type V1SchoolsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1SchoolsList<TData = Awaited<ReturnType<typeof v1SchoolsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1SchoolsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SchoolsList>>,
          TError,
          Awaited<ReturnType<typeof v1SchoolsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SchoolsList<TData = Awaited<ReturnType<typeof v1SchoolsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SchoolsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SchoolsList>>,
          TError,
          Awaited<ReturnType<typeof v1SchoolsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SchoolsList<TData = Awaited<ReturnType<typeof v1SchoolsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SchoolsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista szkół (TR-502)
 */

export function useV1SchoolsList<TData = Awaited<ReturnType<typeof v1SchoolsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SchoolsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1SchoolsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1SchoolsCreateResponse201 = {
  data: School
  status: 201
}

export type v1SchoolsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsCreateResponseSuccess = (v1SchoolsCreateResponse201) & {
  headers: Headers;
};
export type v1SchoolsCreateResponseError = (v1SchoolsCreateResponse401 | v1SchoolsCreateResponse410) & {
  headers: Headers;
};

export type v1SchoolsCreateResponse = (v1SchoolsCreateResponseSuccess | v1SchoolsCreateResponseError)

export const getV1SchoolsCreateUrl = () => {




  return `/api/v1/schools/`
}

/**
 * School CRUD (no destroy) + TR-502 list. Admin/superadmin only.
 *
 * Explicit mixin composition (not `ModelViewSet` minus `destroy`) so the DELETE
 * route is never registered and no delete operation leaks into the schema.
 * @summary Założenie szkoły (TR-500)
 */
export const v1SchoolsCreate = async (schoolRequest: SchoolRequest, options?: RequestInit): Promise<v1SchoolsCreateResponse> => {

  return customFetch<v1SchoolsCreateResponse>(getV1SchoolsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolRequest)
  }
);}




export const getV1SchoolsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsCreate>>, TError,{data: SchoolRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsCreate>>, TError,{data: SchoolRequest}, TContext> => {

const mutationKey = ['v1SchoolsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SchoolsCreate>>, {data: SchoolRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1SchoolsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SchoolsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsCreate>>>
    export type V1SchoolsCreateMutationBody = SchoolRequest
    export type V1SchoolsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Założenie szkoły (TR-500)
 */
export const useV1SchoolsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsCreate>>, TError,{data: SchoolRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SchoolsCreate>>,
        TError,
        {data: SchoolRequest},
        TContext
      > => {
      return useMutation(getV1SchoolsCreateMutationOptions(options), queryClient);
    }

export type v1SchoolsRetrieveResponse200 = {
  data: School
  status: 200
}

export type v1SchoolsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsRetrieveResponseSuccess = (v1SchoolsRetrieveResponse200) & {
  headers: Headers;
};
export type v1SchoolsRetrieveResponseError = (v1SchoolsRetrieveResponse401 | v1SchoolsRetrieveResponse410) & {
  headers: Headers;
};

export type v1SchoolsRetrieveResponse = (v1SchoolsRetrieveResponseSuccess | v1SchoolsRetrieveResponseError)

export const getV1SchoolsRetrieveUrl = (id: number,) => {




  return `/api/v1/schools/${id}/`
}

/**
 * School CRUD (no destroy) + TR-502 list. Admin/superadmin only.
 *
 * Explicit mixin composition (not `ModelViewSet` minus `destroy`) so the DELETE
 * route is never registered and no delete operation leaks into the schema.
 * @summary Szczegóły szkoły (TR-500/501)
 */
export const v1SchoolsRetrieve = async (id: number, options?: RequestInit): Promise<v1SchoolsRetrieveResponse> => {

  return customFetch<v1SchoolsRetrieveResponse>(getV1SchoolsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1SchoolsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/v1/schools/${id}/`
    ] as const;
    }


export const getV1SchoolsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1SchoolsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1SchoolsRetrieve>>> = ({ signal }) => v1SchoolsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1SchoolsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsRetrieve>>>
export type V1SchoolsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1SchoolsRetrieve<TData = Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SchoolsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1SchoolsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SchoolsRetrieve<TData = Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SchoolsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1SchoolsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SchoolsRetrieve<TData = Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły szkoły (TR-500/501)
 */

export function useV1SchoolsRetrieve<TData = Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1SchoolsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1SchoolsUpdateResponse200 = {
  data: SchoolEditResult
  status: 200
}

export type v1SchoolsUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsUpdateResponseSuccess = (v1SchoolsUpdateResponse200) & {
  headers: Headers;
};
export type v1SchoolsUpdateResponseError = (v1SchoolsUpdateResponse401 | v1SchoolsUpdateResponse410) & {
  headers: Headers;
};

export type v1SchoolsUpdateResponse = (v1SchoolsUpdateResponseSuccess | v1SchoolsUpdateResponseError)

export const getV1SchoolsUpdateUrl = (id: number,) => {




  return `/api/v1/schools/${id}/`
}

/**
 * School CRUD (no destroy) + TR-502 list. Admin/superadmin only.
 *
 * Explicit mixin composition (not `ModelViewSet` minus `destroy`) so the DELETE
 * route is never registered and no delete operation leaks into the schema.
 * @summary Edycja szkoły (TR-501)
 */
export const v1SchoolsUpdate = async (id: number,
    schoolRequest: SchoolRequest, options?: RequestInit): Promise<v1SchoolsUpdateResponse> => {

  return customFetch<v1SchoolsUpdateResponse>(getV1SchoolsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolRequest)
  }
);}




export const getV1SchoolsUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsUpdate>>, TError,{id: number;data: SchoolRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsUpdate>>, TError,{id: number;data: SchoolRequest}, TContext> => {

const mutationKey = ['v1SchoolsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SchoolsUpdate>>, {id: number;data: SchoolRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1SchoolsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SchoolsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsUpdate>>>
    export type V1SchoolsUpdateMutationBody = SchoolRequest
    export type V1SchoolsUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Edycja szkoły (TR-501)
 */
export const useV1SchoolsUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsUpdate>>, TError,{id: number;data: SchoolRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SchoolsUpdate>>,
        TError,
        {id: number;data: SchoolRequest},
        TContext
      > => {
      return useMutation(getV1SchoolsUpdateMutationOptions(options), queryClient);
    }

export type v1SchoolsPartialUpdateResponse200 = {
  data: SchoolEditResult
  status: 200
}

export type v1SchoolsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsPartialUpdateResponseSuccess = (v1SchoolsPartialUpdateResponse200) & {
  headers: Headers;
};
export type v1SchoolsPartialUpdateResponseError = (v1SchoolsPartialUpdateResponse401 | v1SchoolsPartialUpdateResponse410) & {
  headers: Headers;
};

export type v1SchoolsPartialUpdateResponse = (v1SchoolsPartialUpdateResponseSuccess | v1SchoolsPartialUpdateResponseError)

export const getV1SchoolsPartialUpdateUrl = (id: number,) => {




  return `/api/v1/schools/${id}/`
}

/**
 * School CRUD (no destroy) + TR-502 list. Admin/superadmin only.
 *
 * Explicit mixin composition (not `ModelViewSet` minus `destroy`) so the DELETE
 * route is never registered and no delete operation leaks into the schema.
 * @summary Częściowa edycja szkoły (TR-501)
 */
export const v1SchoolsPartialUpdate = async (id: number,
    patchedSchoolRequest?: PatchedSchoolRequest, options?: RequestInit): Promise<v1SchoolsPartialUpdateResponse> => {

  return customFetch<v1SchoolsPartialUpdateResponse>(getV1SchoolsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedSchoolRequest)
  }
);}




export const getV1SchoolsPartialUpdateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsPartialUpdate>>, TError,{id: number;data?: PatchedSchoolRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsPartialUpdate>>, TError,{id: number;data?: PatchedSchoolRequest}, TContext> => {

const mutationKey = ['v1SchoolsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SchoolsPartialUpdate>>, {id: number;data?: PatchedSchoolRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1SchoolsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SchoolsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsPartialUpdate>>>
    export type V1SchoolsPartialUpdateMutationBody = PatchedSchoolRequest | undefined
    export type V1SchoolsPartialUpdateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Częściowa edycja szkoły (TR-501)
 */
export const useV1SchoolsPartialUpdate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsPartialUpdate>>, TError,{id: number;data?: PatchedSchoolRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SchoolsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedSchoolRequest},
        TContext
      > => {
      return useMutation(getV1SchoolsPartialUpdateMutationOptions(options), queryClient);
    }

export type v1SchoolsAnonymizeCreateResponse201 = {
  data: BulkOperationRequest
  status: 201
}

export type v1SchoolsAnonymizeCreateResponse400 = {
  data: void
  status: 400
}

export type v1SchoolsAnonymizeCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsAnonymizeCreateResponse409 = {
  data: void
  status: 409
}

export type v1SchoolsAnonymizeCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsAnonymizeCreateResponseSuccess = (v1SchoolsAnonymizeCreateResponse201) & {
  headers: Headers;
};
export type v1SchoolsAnonymizeCreateResponseError = (v1SchoolsAnonymizeCreateResponse400 | v1SchoolsAnonymizeCreateResponse401 | v1SchoolsAnonymizeCreateResponse409 | v1SchoolsAnonymizeCreateResponse410) & {
  headers: Headers;
};

export type v1SchoolsAnonymizeCreateResponse = (v1SchoolsAnonymizeCreateResponseSuccess | v1SchoolsAnonymizeCreateResponseError)

export const getV1SchoolsAnonymizeCreateUrl = (id: number,) => {




  return `/api/v1/schools/${id}/anonymize/`
}

/**
 * Superadmin-only, one-way school destruction — the single school-deletion path
 * (D4/TR-1103). Rerouted from the former synchronous TR-504 anonymize onto the
 * four-eyes cascade: the three-step safeguard (acknowledgement + exact school name +
 * password) initiates a cascade `BulkOperationRequest`; a second superadmin must
 * approve before background execution (Phase 1 accounts → Phase 2 entity). Only an
 * active/archived school qualifies; a `deleted` school is already a tombstone.
 * @summary Usunięcie (anonimizacja) szkoły przez kaskadę TR-1103
 */
export const v1SchoolsAnonymizeCreate = async (id: number,
    cascadeInitiateRequest: CascadeInitiateRequest, options?: RequestInit): Promise<v1SchoolsAnonymizeCreateResponse> => {

  return customFetch<v1SchoolsAnonymizeCreateResponse>(getV1SchoolsAnonymizeCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cascadeInitiateRequest)
  }
);}




export const getV1SchoolsAnonymizeCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsAnonymizeCreate>>, TError,{id: number;data: CascadeInitiateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsAnonymizeCreate>>, TError,{id: number;data: CascadeInitiateRequest}, TContext> => {

const mutationKey = ['v1SchoolsAnonymizeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SchoolsAnonymizeCreate>>, {id: number;data: CascadeInitiateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1SchoolsAnonymizeCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SchoolsAnonymizeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsAnonymizeCreate>>>
    export type V1SchoolsAnonymizeCreateMutationBody = CascadeInitiateRequest
    export type V1SchoolsAnonymizeCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Usunięcie (anonimizacja) szkoły przez kaskadę TR-1103
 */
export const useV1SchoolsAnonymizeCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsAnonymizeCreate>>, TError,{id: number;data: CascadeInitiateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SchoolsAnonymizeCreate>>,
        TError,
        {id: number;data: CascadeInitiateRequest},
        TContext
      > => {
      return useMutation(getV1SchoolsAnonymizeCreateMutationOptions(options), queryClient);
    }

export type v1SchoolsArchiveCreateResponse200 = {
  data: School
  status: 200
}

export type v1SchoolsArchiveCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsArchiveCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsArchiveCreateResponseSuccess = (v1SchoolsArchiveCreateResponse200) & {
  headers: Headers;
};
export type v1SchoolsArchiveCreateResponseError = (v1SchoolsArchiveCreateResponse401 | v1SchoolsArchiveCreateResponse410) & {
  headers: Headers;
};

export type v1SchoolsArchiveCreateResponse = (v1SchoolsArchiveCreateResponseSuccess | v1SchoolsArchiveCreateResponseError)

export const getV1SchoolsArchiveCreateUrl = (id: number,) => {




  return `/api/v1/schools/${id}/archive/`
}

/**
 * School CRUD (no destroy) + TR-502 list. Admin/superadmin only.
 *
 * Explicit mixin composition (not `ModelViewSet` minus `destroy`) so the DELETE
 * route is never registered and no delete operation leaks into the schema.
 * @summary Archiwizacja szkoły (TR-503)
 */
export const v1SchoolsArchiveCreate = async (id: number, options?: RequestInit): Promise<v1SchoolsArchiveCreateResponse> => {

  return customFetch<v1SchoolsArchiveCreateResponse>(getV1SchoolsArchiveCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1SchoolsArchiveCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsArchiveCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsArchiveCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1SchoolsArchiveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SchoolsArchiveCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1SchoolsArchiveCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SchoolsArchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsArchiveCreate>>>

    export type V1SchoolsArchiveCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Archiwizacja szkoły (TR-503)
 */
export const useV1SchoolsArchiveCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsArchiveCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SchoolsArchiveCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1SchoolsArchiveCreateMutationOptions(options), queryClient);
    }

export type v1SchoolsBulkDisableCreateResponse201 = {
  data: BulkOperationRequest
  status: 201
}

export type v1SchoolsBulkDisableCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsBulkDisableCreateResponse409 = {
  data: void
  status: 409
}

export type v1SchoolsBulkDisableCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsBulkDisableCreateResponseSuccess = (v1SchoolsBulkDisableCreateResponse201) & {
  headers: Headers;
};
export type v1SchoolsBulkDisableCreateResponseError = (v1SchoolsBulkDisableCreateResponse401 | v1SchoolsBulkDisableCreateResponse409 | v1SchoolsBulkDisableCreateResponse410) & {
  headers: Headers;
};

export type v1SchoolsBulkDisableCreateResponse = (v1SchoolsBulkDisableCreateResponseSuccess | v1SchoolsBulkDisableCreateResponseError)

export const getV1SchoolsBulkDisableCreateUrl = (id: number,) => {




  return `/api/v1/schools/${id}/bulk-disable/`
}

/**
 * TR-1102: initiate a mass disable of the school's active student accounts
 * (superadmin/admin). Requires a second-operator approval before execution. The
 * school must be active; the summary counts candidates + per-state skips.
 * @summary Masowe wyłączenie kont uczniów szkoły (TR-1102)
 */
export const v1SchoolsBulkDisableCreate = async (id: number, options?: RequestInit): Promise<v1SchoolsBulkDisableCreateResponse> => {

  return customFetch<v1SchoolsBulkDisableCreateResponse>(getV1SchoolsBulkDisableCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1SchoolsBulkDisableCreateMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsBulkDisableCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsBulkDisableCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1SchoolsBulkDisableCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SchoolsBulkDisableCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1SchoolsBulkDisableCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SchoolsBulkDisableCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsBulkDisableCreate>>>

    export type V1SchoolsBulkDisableCreateMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Masowe wyłączenie kont uczniów szkoły (TR-1102)
 */
export const useV1SchoolsBulkDisableCreate = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsBulkDisableCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SchoolsBulkDisableCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1SchoolsBulkDisableCreateMutationOptions(options), queryClient);
    }

export type v1SchoolsLogoCreateResponse200 = {
  data: School
  status: 200
}

export type v1SchoolsLogoCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsLogoCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsLogoCreateResponseSuccess = (v1SchoolsLogoCreateResponse200) & {
  headers: Headers;
};
export type v1SchoolsLogoCreateResponseError = (v1SchoolsLogoCreateResponse401 | v1SchoolsLogoCreateResponse410) & {
  headers: Headers;
};

export type v1SchoolsLogoCreateResponse = (v1SchoolsLogoCreateResponseSuccess | v1SchoolsLogoCreateResponseError)

export const getV1SchoolsLogoCreateUrl = (id: number,) => {




  return `/api/v1/schools/${id}/logo/`
}

/**
 * POST: upload/replace the logo (multipart `logo` file, sanitised on write).
 * DELETE: clear it. Both atomic; return the fresh school detail.
 * @summary Upload / usunięcie logo szkoły (TR-500 R8)
 */
export const v1SchoolsLogoCreate = async (id: number,
    schoolLogoUploadRequest: SchoolLogoUploadRequest, options?: RequestInit): Promise<v1SchoolsLogoCreateResponse> => {
    const formData = new FormData();
formData.append(`logo`, schoolLogoUploadRequest.logo);

  return customFetch<v1SchoolsLogoCreateResponse>(getV1SchoolsLogoCreateUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getV1SchoolsLogoCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsLogoCreate>>, TError,{id: number;data: SchoolLogoUploadRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsLogoCreate>>, TError,{id: number;data: SchoolLogoUploadRequest}, TContext> => {

const mutationKey = ['v1SchoolsLogoCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SchoolsLogoCreate>>, {id: number;data: SchoolLogoUploadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1SchoolsLogoCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SchoolsLogoCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsLogoCreate>>>
    export type V1SchoolsLogoCreateMutationBody = SchoolLogoUploadRequest
    export type V1SchoolsLogoCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Upload / usunięcie logo szkoły (TR-500 R8)
 */
export const useV1SchoolsLogoCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsLogoCreate>>, TError,{id: number;data: SchoolLogoUploadRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SchoolsLogoCreate>>,
        TError,
        {id: number;data: SchoolLogoUploadRequest},
        TContext
      > => {
      return useMutation(getV1SchoolsLogoCreateMutationOptions(options), queryClient);
    }

export type v1SchoolsLogoDestroyResponse200 = {
  data: School
  status: 200
}

export type v1SchoolsLogoDestroyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsLogoDestroyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsLogoDestroyResponseSuccess = (v1SchoolsLogoDestroyResponse200) & {
  headers: Headers;
};
export type v1SchoolsLogoDestroyResponseError = (v1SchoolsLogoDestroyResponse401 | v1SchoolsLogoDestroyResponse410) & {
  headers: Headers;
};

export type v1SchoolsLogoDestroyResponse = (v1SchoolsLogoDestroyResponseSuccess | v1SchoolsLogoDestroyResponseError)

export const getV1SchoolsLogoDestroyUrl = (id: number,) => {




  return `/api/v1/schools/${id}/logo/`
}

/**
 * POST: upload/replace the logo (multipart `logo` file, sanitised on write).
 * DELETE: clear it. Both atomic; return the fresh school detail.
 * @summary Upload / usunięcie logo szkoły (TR-500 R8)
 */
export const v1SchoolsLogoDestroy = async (id: number, options?: RequestInit): Promise<v1SchoolsLogoDestroyResponse> => {

  return customFetch<v1SchoolsLogoDestroyResponse>(getV1SchoolsLogoDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getV1SchoolsLogoDestroyMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsLogoDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsLogoDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1SchoolsLogoDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SchoolsLogoDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1SchoolsLogoDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SchoolsLogoDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsLogoDestroy>>>

    export type V1SchoolsLogoDestroyMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Upload / usunięcie logo szkoły (TR-500 R8)
 */
export const useV1SchoolsLogoDestroy = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsLogoDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SchoolsLogoDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1SchoolsLogoDestroyMutationOptions(options), queryClient);
    }

export type v1SchoolsRestoreCreateResponse200 = {
  data: School
  status: 200
}

export type v1SchoolsRestoreCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsRestoreCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsRestoreCreateResponseSuccess = (v1SchoolsRestoreCreateResponse200) & {
  headers: Headers;
};
export type v1SchoolsRestoreCreateResponseError = (v1SchoolsRestoreCreateResponse401 | v1SchoolsRestoreCreateResponse410) & {
  headers: Headers;
};

export type v1SchoolsRestoreCreateResponse = (v1SchoolsRestoreCreateResponseSuccess | v1SchoolsRestoreCreateResponseError)

export const getV1SchoolsRestoreCreateUrl = (id: number,) => {




  return `/api/v1/schools/${id}/restore/`
}

/**
 * School CRUD (no destroy) + TR-502 list. Admin/superadmin only.
 *
 * Explicit mixin composition (not `ModelViewSet` minus `destroy`) so the DELETE
 * route is never registered and no delete operation leaks into the schema.
 * @summary Przywrócenie szkoły (TR-503)
 */
export const v1SchoolsRestoreCreate = async (id: number, options?: RequestInit): Promise<v1SchoolsRestoreCreateResponse> => {

  return customFetch<v1SchoolsRestoreCreateResponse>(getV1SchoolsRestoreCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getV1SchoolsRestoreCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsRestoreCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsRestoreCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['v1SchoolsRestoreCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SchoolsRestoreCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  v1SchoolsRestoreCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SchoolsRestoreCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsRestoreCreate>>>

    export type V1SchoolsRestoreCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Przywrócenie szkoły (TR-503)
 */
export const useV1SchoolsRestoreCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsRestoreCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SchoolsRestoreCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getV1SchoolsRestoreCreateMutationOptions(options), queryClient);
    }

export type v1SchoolsCitiesRetrieveResponse200 = {
  data: SchoolCities
  status: 200
}

export type v1SchoolsCitiesRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsCitiesRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsCitiesRetrieveResponseSuccess = (v1SchoolsCitiesRetrieveResponse200) & {
  headers: Headers;
};
export type v1SchoolsCitiesRetrieveResponseError = (v1SchoolsCitiesRetrieveResponse401 | v1SchoolsCitiesRetrieveResponse410) & {
  headers: Headers;
};

export type v1SchoolsCitiesRetrieveResponse = (v1SchoolsCitiesRetrieveResponseSuccess | v1SchoolsCitiesRetrieveResponseError)

export const getV1SchoolsCitiesRetrieveUrl = () => {




  return `/api/v1/schools/cities/`
}

/**
 * Distinct non-empty cities present in the current `state` scope (each
 * once), folded-alphabetical — the source for the city-filter picker
 * (TR-502 "wybór jednej z miejscowości obecnych w danych szkół"). Empty
 * data yields an empty list, not an error.
 * @summary Miejscowości obecne w danych szkół (źródło filtra, TR-502)
 */
export const v1SchoolsCitiesRetrieve = async ( options?: RequestInit): Promise<v1SchoolsCitiesRetrieveResponse> => {

  return customFetch<v1SchoolsCitiesRetrieveResponse>(getV1SchoolsCitiesRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1SchoolsCitiesRetrieveQueryKey = () => {
    return [
    `/api/v1/schools/cities/`
    ] as const;
    }


export const getV1SchoolsCitiesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1SchoolsCitiesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>> = ({ signal }) => v1SchoolsCitiesRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1SchoolsCitiesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>>
export type V1SchoolsCitiesRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1SchoolsCitiesRetrieve<TData = Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SchoolsCitiesRetrieve<TData = Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SchoolsCitiesRetrieve<TData = Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Miejscowości obecne w danych szkół (źródło filtra, TR-502)
 */

export function useV1SchoolsCitiesRetrieve<TData = Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SchoolsCitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1SchoolsCitiesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1SchoolsNameCheckCreateResponse200 = {
  data: SchoolNameCheckResponse
  status: 200
}

export type v1SchoolsNameCheckCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SchoolsNameCheckCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SchoolsNameCheckCreateResponseSuccess = (v1SchoolsNameCheckCreateResponse200) & {
  headers: Headers;
};
export type v1SchoolsNameCheckCreateResponseError = (v1SchoolsNameCheckCreateResponse401 | v1SchoolsNameCheckCreateResponse410) & {
  headers: Headers;
};

export type v1SchoolsNameCheckCreateResponse = (v1SchoolsNameCheckCreateResponseSuccess | v1SchoolsNameCheckCreateResponseError)

export const getV1SchoolsNameCheckCreateUrl = () => {




  return `/api/v1/schools/name-check/`
}

/**
 * Advisory duplicate-name check (TR-500 R4). Compares the normalised name
 * (trim + collapse whitespace + case-insensitive) across active + archived
 * schools, excluding `deleted` (their names are anonymisation tokens) and an
 * optional `exclude_id` (self, on edit). No audit, no state change — the write
 * endpoints are unchanged; the conscious confirm is a FE gate.
 * @summary Sprawdzenie duplikatu nazwy szkoły (TR-500 R4)
 */
export const v1SchoolsNameCheckCreate = async (schoolNameCheckRequest: SchoolNameCheckRequest, options?: RequestInit): Promise<v1SchoolsNameCheckCreateResponse> => {

  return customFetch<v1SchoolsNameCheckCreateResponse>(getV1SchoolsNameCheckCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolNameCheckRequest)
  }
);}




export const getV1SchoolsNameCheckCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsNameCheckCreate>>, TError,{data: SchoolNameCheckRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsNameCheckCreate>>, TError,{data: SchoolNameCheckRequest}, TContext> => {

const mutationKey = ['v1SchoolsNameCheckCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SchoolsNameCheckCreate>>, {data: SchoolNameCheckRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1SchoolsNameCheckCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SchoolsNameCheckCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1SchoolsNameCheckCreate>>>
    export type V1SchoolsNameCheckCreateMutationBody = SchoolNameCheckRequest
    export type V1SchoolsNameCheckCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Sprawdzenie duplikatu nazwy szkoły (TR-500 R4)
 */
export const useV1SchoolsNameCheckCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SchoolsNameCheckCreate>>, TError,{data: SchoolNameCheckRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SchoolsNameCheckCreate>>,
        TError,
        {data: SchoolNameCheckRequest},
        TContext
      > => {
      return useMutation(getV1SchoolsNameCheckCreateMutationOptions(options), queryClient);
    }

export type sessionsListResponse200 = {
  data: SessionsList
  status: 200
}

export type sessionsListResponse400 = {
  data: void
  status: 400
}

export type sessionsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type sessionsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type sessionsListResponseSuccess = (sessionsListResponse200) & {
  headers: Headers;
};
export type sessionsListResponseError = (sessionsListResponse400 | sessionsListResponse401 | sessionsListResponse410) & {
  headers: Headers;
};

export type sessionsListResponse = (sessionsListResponseSuccess | sessionsListResponseError)

export const getSessionsListUrl = () => {




  return `/api/v1/sessions/`
}

/**
 * TR-300: lista aktywnych sesji właściciela. Wyłącznie kanał przeglądarki
 * (bez sesji Django nie da się oznaczyć sesji bieżącej); kadra only —
 * moduł profilu wyklucza ucznia.
 */
export const sessionsList = async ( options?: RequestInit): Promise<sessionsListResponse> => {

  return customFetch<sessionsListResponse>(getSessionsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSessionsListQueryKey = () => {
    return [
    `/api/v1/sessions/`
    ] as const;
    }


export const getSessionsListQueryOptions = <TData = Awaited<ReturnType<typeof sessionsList>>, TError = void | UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionsList>>> = ({ signal }) => sessionsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SessionsListQueryResult = NonNullable<Awaited<ReturnType<typeof sessionsList>>>
export type SessionsListQueryError = void | UnauthorizedResponse | AccountGoneResponse


export function useSessionsList<TData = Awaited<ReturnType<typeof sessionsList>>, TError = void | UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsList>>,
          TError,
          Awaited<ReturnType<typeof sessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsList<TData = Awaited<ReturnType<typeof sessionsList>>, TError = void | UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsList>>,
          TError,
          Awaited<ReturnType<typeof sessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsList<TData = Awaited<ReturnType<typeof sessionsList>>, TError = void | UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSessionsList<TData = Awaited<ReturnType<typeof sessionsList>>, TError = void | UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSessionsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type sessionRevokeResponse200 = {
  data: SessionRevokeResult
  status: 200
}

export type sessionRevokeResponse400 = {
  data: void
  status: 400
}

export type sessionRevokeResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type sessionRevokeResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type sessionRevokeResponseSuccess = (sessionRevokeResponse200) & {
  headers: Headers;
};
export type sessionRevokeResponseError = (sessionRevokeResponse400 | sessionRevokeResponse401 | sessionRevokeResponse410) & {
  headers: Headers;
};

export type sessionRevokeResponse = (sessionRevokeResponseSuccess | sessionRevokeResponseError)

export const getSessionRevokeUrl = (ref: string,) => {




  return `/api/v1/sessions/${ref}/revoke/`
}

/**
 * TR-300 R5/R6: rewokacja pojedynczej INNEJ sesji po jej opaque ref.
 *
 * Sesja bieżąca jest wykluczona (od tego jest wylogowanie). Brak dopasowania
 * = „sesja już zakończona" — celowo nieodróżnialne od ref-a, który nigdy nie
 * istniał (żadnej wyroczni ważności). Skasowanie sesji app odrzuca związany
 * z nią stateful JWT natychmiast.
 */
export const sessionRevoke = async (ref: string, options?: RequestInit): Promise<sessionRevokeResponse> => {

  return customFetch<sessionRevokeResponse>(getSessionRevokeUrl(ref),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSessionRevokeMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionRevoke>>, TError,{ref: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sessionRevoke>>, TError,{ref: string}, TContext> => {

const mutationKey = ['sessionRevoke'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionRevoke>>, {ref: string}> = (props) => {
          const {ref} = props ?? {};

          return  sessionRevoke(ref,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SessionRevokeMutationResult = NonNullable<Awaited<ReturnType<typeof sessionRevoke>>>

    export type SessionRevokeMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useSessionRevoke = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionRevoke>>, TError,{ref: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionRevoke>>,
        TError,
        {ref: string},
        TContext
      > => {
      return useMutation(getSessionRevokeMutationOptions(options), queryClient);
    }

export type sessionsOtherCountResponse200 = {
  data: SessionsCount
  status: 200
}

export type sessionsOtherCountResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type sessionsOtherCountResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type sessionsOtherCountResponseSuccess = (sessionsOtherCountResponse200) & {
  headers: Headers;
};
export type sessionsOtherCountResponseError = (sessionsOtherCountResponse401 | sessionsOtherCountResponse410) & {
  headers: Headers;
};

export type sessionsOtherCountResponse = (sessionsOtherCountResponseSuccess | sessionsOtherCountResponseError)

export const getSessionsOtherCountUrl = () => {




  return `/api/v1/sessions/logout-others/`
}

/**
 * TR-123: liczba innych sesji (GET) i ich unieważnienie po re-autoryzacji
 * hasłem (POST). Wyłącznie sesja przeglądarki — klient app/JWT nie ma sesji
 * Django, więc bez wykluczenia bieżącej sesji ubiłby sam siebie.
 */
export const sessionsOtherCount = async ( options?: RequestInit): Promise<sessionsOtherCountResponse> => {

  return customFetch<sessionsOtherCountResponse>(getSessionsOtherCountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSessionsOtherCountQueryKey = () => {
    return [
    `/api/v1/sessions/logout-others/`
    ] as const;
    }


export const getSessionsOtherCountQueryOptions = <TData = Awaited<ReturnType<typeof sessionsOtherCount>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsOtherCount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionsOtherCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionsOtherCount>>> = ({ signal }) => sessionsOtherCount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionsOtherCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SessionsOtherCountQueryResult = NonNullable<Awaited<ReturnType<typeof sessionsOtherCount>>>
export type SessionsOtherCountQueryError = UnauthorizedResponse | AccountGoneResponse


export function useSessionsOtherCount<TData = Awaited<ReturnType<typeof sessionsOtherCount>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsOtherCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsOtherCount>>,
          TError,
          Awaited<ReturnType<typeof sessionsOtherCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsOtherCount<TData = Awaited<ReturnType<typeof sessionsOtherCount>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsOtherCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsOtherCount>>,
          TError,
          Awaited<ReturnType<typeof sessionsOtherCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsOtherCount<TData = Awaited<ReturnType<typeof sessionsOtherCount>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsOtherCount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSessionsOtherCount<TData = Awaited<ReturnType<typeof sessionsOtherCount>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsOtherCount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSessionsOtherCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type sessionsLogoutOthersResponse200 = {
  data: SessionsCount
  status: 200
}

export type sessionsLogoutOthersResponse400 = {
  data: void
  status: 400
}

export type sessionsLogoutOthersResponse401 = {
  data: void
  status: 401
}

export type sessionsLogoutOthersResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type sessionsLogoutOthersResponseSuccess = (sessionsLogoutOthersResponse200) & {
  headers: Headers;
};
export type sessionsLogoutOthersResponseError = (sessionsLogoutOthersResponse400 | sessionsLogoutOthersResponse401 | sessionsLogoutOthersResponse410) & {
  headers: Headers;
};

export type sessionsLogoutOthersResponse = (sessionsLogoutOthersResponseSuccess | sessionsLogoutOthersResponseError)

export const getSessionsLogoutOthersUrl = () => {




  return `/api/v1/sessions/logout-others/`
}

/**
 * TR-123: liczba innych sesji (GET) i ich unieważnienie po re-autoryzacji
 * hasłem (POST). Wyłącznie sesja przeglądarki — klient app/JWT nie ma sesji
 * Django, więc bez wykluczenia bieżącej sesji ubiłby sam siebie.
 */
export const sessionsLogoutOthers = async (sessionsLogoutOthersRequest: SessionsLogoutOthersRequest, options?: RequestInit): Promise<sessionsLogoutOthersResponse> => {

  return customFetch<sessionsLogoutOthersResponse>(getSessionsLogoutOthersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sessionsLogoutOthersRequest)
  }
);}




export const getSessionsLogoutOthersMutationOptions = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsLogoutOthers>>, TError,{data: SessionsLogoutOthersRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sessionsLogoutOthers>>, TError,{data: SessionsLogoutOthersRequest}, TContext> => {

const mutationKey = ['sessionsLogoutOthers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionsLogoutOthers>>, {data: SessionsLogoutOthersRequest}> = (props) => {
          const {data} = props ?? {};

          return  sessionsLogoutOthers(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SessionsLogoutOthersMutationResult = NonNullable<Awaited<ReturnType<typeof sessionsLogoutOthers>>>
    export type SessionsLogoutOthersMutationBody = SessionsLogoutOthersRequest
    export type SessionsLogoutOthersMutationError = void | AccountGoneResponse

    export const useSessionsLogoutOthers = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsLogoutOthers>>, TError,{data: SessionsLogoutOthersRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionsLogoutOthers>>,
        TError,
        {data: SessionsLogoutOthersRequest},
        TContext
      > => {
      return useMutation(getSessionsLogoutOthersMutationOptions(options), queryClient);
    }

export type studentRecoveryCompleteResponse200 = {
  data: RecoveryCompleteResponse
  status: 200
}

export type studentRecoveryCompleteResponse400 = {
  data: RecoveryError
  status: 400
}

export type studentRecoveryCompleteResponse429 = {
  data: void
  status: 429
}

export type studentRecoveryCompleteResponseSuccess = (studentRecoveryCompleteResponse200) & {
  headers: Headers;
};
export type studentRecoveryCompleteResponseError = (studentRecoveryCompleteResponse400 | studentRecoveryCompleteResponse429) & {
  headers: Headers;
};

export type studentRecoveryCompleteResponse = (studentRecoveryCompleteResponseSuccess | studentRecoveryCompleteResponseError)

export const getStudentRecoveryCompleteUrl = () => {




  return `/api/v1/student-recovery/complete/`
}

/**
 * @summary Ustawienie nowego hasła po odzyskaniu konta ucznia
 */
export const studentRecoveryComplete = async (recoveryCompleteRequestRequest: RecoveryCompleteRequestRequest, options?: RequestInit): Promise<studentRecoveryCompleteResponse> => {

  return customFetch<studentRecoveryCompleteResponse>(getStudentRecoveryCompleteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recoveryCompleteRequestRequest)
  }
);}




export const getStudentRecoveryCompleteMutationOptions = <TError = RecoveryError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studentRecoveryComplete>>, TError,{data: RecoveryCompleteRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studentRecoveryComplete>>, TError,{data: RecoveryCompleteRequestRequest}, TContext> => {

const mutationKey = ['studentRecoveryComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studentRecoveryComplete>>, {data: RecoveryCompleteRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  studentRecoveryComplete(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StudentRecoveryCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof studentRecoveryComplete>>>
    export type StudentRecoveryCompleteMutationBody = RecoveryCompleteRequestRequest
    export type StudentRecoveryCompleteMutationError = RecoveryError | void

    /**
 * @summary Ustawienie nowego hasła po odzyskaniu konta ucznia
 */
export const useStudentRecoveryComplete = <TError = RecoveryError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studentRecoveryComplete>>, TError,{data: RecoveryCompleteRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studentRecoveryComplete>>,
        TError,
        {data: RecoveryCompleteRequestRequest},
        TContext
      > => {
      return useMutation(getStudentRecoveryCompleteMutationOptions(options), queryClient);
    }

export type studentRecoveryQuestionsResponse200 = {
  data: RecoveryQuestionsResponse
  status: 200
}

export type studentRecoveryQuestionsResponse429 = {
  data: void
  status: 429
}

export type studentRecoveryQuestionsResponseSuccess = (studentRecoveryQuestionsResponse200) & {
  headers: Headers;
};
export type studentRecoveryQuestionsResponseError = (studentRecoveryQuestionsResponse429) & {
  headers: Headers;
};

export type studentRecoveryQuestionsResponse = (studentRecoveryQuestionsResponseSuccess | studentRecoveryQuestionsResponseError)

export const getStudentRecoveryQuestionsUrl = () => {




  return `/api/v1/student-recovery/questions/`
}

/**
 * @summary Systemowe pytania odzyskiwania konta ucznia
 */
export const studentRecoveryQuestions = async ( options?: RequestInit): Promise<studentRecoveryQuestionsResponse> => {

  return customFetch<studentRecoveryQuestionsResponse>(getStudentRecoveryQuestionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStudentRecoveryQuestionsQueryKey = () => {
    return [
    `/api/v1/student-recovery/questions/`
    ] as const;
    }


export const getStudentRecoveryQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStudentRecoveryQuestionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof studentRecoveryQuestions>>> = ({ signal }) => studentRecoveryQuestions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StudentRecoveryQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof studentRecoveryQuestions>>>
export type StudentRecoveryQuestionsQueryError = void


export function useStudentRecoveryQuestions<TData = Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentRecoveryQuestions>>,
          TError,
          Awaited<ReturnType<typeof studentRecoveryQuestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudentRecoveryQuestions<TData = Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentRecoveryQuestions>>,
          TError,
          Awaited<ReturnType<typeof studentRecoveryQuestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudentRecoveryQuestions<TData = Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Systemowe pytania odzyskiwania konta ucznia
 */

export function useStudentRecoveryQuestions<TData = Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studentRecoveryQuestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStudentRecoveryQuestionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type studentRecoveryStartResponse200 = {
  data: StudentRecoveryStartResponse
  status: 200
}

export type studentRecoveryStartResponse429 = {
  data: void
  status: 429
}

export type studentRecoveryStartResponseSuccess = (studentRecoveryStartResponse200) & {
  headers: Headers;
};
export type studentRecoveryStartResponseError = (studentRecoveryStartResponse429) & {
  headers: Headers;
};

export type studentRecoveryStartResponse = (studentRecoveryStartResponseSuccess | studentRecoveryStartResponseError)

export const getStudentRecoveryStartUrl = () => {




  return `/api/v1/student-recovery/start/`
}

/**
 * @summary Rozpoczęcie samoobsługowego resetu ucznia
 */
export const studentRecoveryStart = async (recoveryStartRequestRequest: RecoveryStartRequestRequest, options?: RequestInit): Promise<studentRecoveryStartResponse> => {

  return customFetch<studentRecoveryStartResponse>(getStudentRecoveryStartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recoveryStartRequestRequest)
  }
);}




export const getStudentRecoveryStartMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studentRecoveryStart>>, TError,{data: RecoveryStartRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studentRecoveryStart>>, TError,{data: RecoveryStartRequestRequest}, TContext> => {

const mutationKey = ['studentRecoveryStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studentRecoveryStart>>, {data: RecoveryStartRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  studentRecoveryStart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StudentRecoveryStartMutationResult = NonNullable<Awaited<ReturnType<typeof studentRecoveryStart>>>
    export type StudentRecoveryStartMutationBody = RecoveryStartRequestRequest
    export type StudentRecoveryStartMutationError = void

    /**
 * @summary Rozpoczęcie samoobsługowego resetu ucznia
 */
export const useStudentRecoveryStart = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studentRecoveryStart>>, TError,{data: RecoveryStartRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studentRecoveryStart>>,
        TError,
        {data: RecoveryStartRequestRequest},
        TContext
      > => {
      return useMutation(getStudentRecoveryStartMutationOptions(options), queryClient);
    }

export type studentRecoveryVerifyResponse200 = {
  data: RecoveryVerifyResponse
  status: 200
}

export type studentRecoveryVerifyResponse400 = {
  data: RecoveryError
  status: 400
}

export type studentRecoveryVerifyResponse429 = {
  data: void
  status: 429
}

export type studentRecoveryVerifyResponseSuccess = (studentRecoveryVerifyResponse200) & {
  headers: Headers;
};
export type studentRecoveryVerifyResponseError = (studentRecoveryVerifyResponse400 | studentRecoveryVerifyResponse429) & {
  headers: Headers;
};

export type studentRecoveryVerifyResponse = (studentRecoveryVerifyResponseSuccess | studentRecoveryVerifyResponseError)

export const getStudentRecoveryVerifyUrl = () => {




  return `/api/v1/student-recovery/verify/`
}

/**
 * @summary Weryfikacja odpowiedzi ucznia
 */
export const studentRecoveryVerify = async (recoveryVerifyRequestRequest: RecoveryVerifyRequestRequest, options?: RequestInit): Promise<studentRecoveryVerifyResponse> => {

  return customFetch<studentRecoveryVerifyResponse>(getStudentRecoveryVerifyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recoveryVerifyRequestRequest)
  }
);}




export const getStudentRecoveryVerifyMutationOptions = <TError = RecoveryError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studentRecoveryVerify>>, TError,{data: RecoveryVerifyRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studentRecoveryVerify>>, TError,{data: RecoveryVerifyRequestRequest}, TContext> => {

const mutationKey = ['studentRecoveryVerify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studentRecoveryVerify>>, {data: RecoveryVerifyRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  studentRecoveryVerify(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StudentRecoveryVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof studentRecoveryVerify>>>
    export type StudentRecoveryVerifyMutationBody = RecoveryVerifyRequestRequest
    export type StudentRecoveryVerifyMutationError = RecoveryError | void

    /**
 * @summary Weryfikacja odpowiedzi ucznia
 */
export const useStudentRecoveryVerify = <TError = RecoveryError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studentRecoveryVerify>>, TError,{data: RecoveryVerifyRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studentRecoveryVerify>>,
        TError,
        {data: RecoveryVerifyRequestRequest},
        TContext
      > => {
      return useMutation(getStudentRecoveryVerifyMutationOptions(options), queryClient);
    }

export type studentsPasswordOverrideResponse200 = {
  data: OverrideStudentPasswordResponse
  status: 200
}

export type studentsPasswordOverrideResponse400 = {
  data: void
  status: 400
}

export type studentsPasswordOverrideResponse401 = {
  data: void
  status: 401
}

export type studentsPasswordOverrideResponse403 = {
  data: void
  status: 403
}

export type studentsPasswordOverrideResponse404 = {
  data: void
  status: 404
}

export type studentsPasswordOverrideResponse409 = {
  data: ResetStudentError
  status: 409
}

export type studentsPasswordOverrideResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type studentsPasswordOverrideResponse429 = {
  data: void
  status: 429
}

export type studentsPasswordOverrideResponseSuccess = (studentsPasswordOverrideResponse200) & {
  headers: Headers;
};
export type studentsPasswordOverrideResponseError = (studentsPasswordOverrideResponse400 | studentsPasswordOverrideResponse401 | studentsPasswordOverrideResponse403 | studentsPasswordOverrideResponse404 | studentsPasswordOverrideResponse409 | studentsPasswordOverrideResponse410 | studentsPasswordOverrideResponse429) & {
  headers: Headers;
};

export type studentsPasswordOverrideResponse = (studentsPasswordOverrideResponseSuccess | studentsPasswordOverrideResponseError)

export const getStudentsPasswordOverrideUrl = () => {




  return `/api/v1/students/password-override/`
}

/**
 * Superadministrator resetuje hasło ucznia bez odpowiedzi bezpieczeństwa.
 *
 * Tylko sesja panelu przeglądarkowego: licznik re-autoryzacji żyje w sesji Django.
 * @summary Reset hasła ucznia przez superadministratora bez odpowiedzi bezpieczeństwa
 */
export const studentsPasswordOverride = async (overrideStudentPasswordRequest: OverrideStudentPasswordRequest, options?: RequestInit): Promise<studentsPasswordOverrideResponse> => {

  return customFetch<studentsPasswordOverrideResponse>(getStudentsPasswordOverrideUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(overrideStudentPasswordRequest)
  }
);}




export const getStudentsPasswordOverrideMutationOptions = <TError = void | ResetStudentError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studentsPasswordOverride>>, TError,{data: OverrideStudentPasswordRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studentsPasswordOverride>>, TError,{data: OverrideStudentPasswordRequest}, TContext> => {

const mutationKey = ['studentsPasswordOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studentsPasswordOverride>>, {data: OverrideStudentPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  studentsPasswordOverride(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StudentsPasswordOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof studentsPasswordOverride>>>
    export type StudentsPasswordOverrideMutationBody = OverrideStudentPasswordRequest
    export type StudentsPasswordOverrideMutationError = void | ResetStudentError | AccountGoneResponse

    /**
 * @summary Reset hasła ucznia przez superadministratora bez odpowiedzi bezpieczeństwa
 */
export const useStudentsPasswordOverride = <TError = void | ResetStudentError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studentsPasswordOverride>>, TError,{data: OverrideStudentPasswordRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studentsPasswordOverride>>,
        TError,
        {data: OverrideStudentPasswordRequest},
        TContext
      > => {
      return useMutation(getStudentsPasswordOverrideMutationOptions(options), queryClient);
    }

export type v1StudentsPasswordResetCreateResponse200 = {
  data: ResetByCodeResponse
  status: 200
}

export type v1StudentsPasswordResetCreateResponse400 = {
  data: ResetStudentError
  status: 400
}

export type v1StudentsPasswordResetCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1StudentsPasswordResetCreateResponse404 = {
  data: void
  status: 404
}

export type v1StudentsPasswordResetCreateResponse409 = {
  data: void
  status: 409
}

export type v1StudentsPasswordResetCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1StudentsPasswordResetCreateResponse429 = {
  data: ResetStudentError
  status: 429
}

export type v1StudentsPasswordResetCreateResponseSuccess = (v1StudentsPasswordResetCreateResponse200) & {
  headers: Headers;
};
export type v1StudentsPasswordResetCreateResponseError = (v1StudentsPasswordResetCreateResponse400 | v1StudentsPasswordResetCreateResponse401 | v1StudentsPasswordResetCreateResponse404 | v1StudentsPasswordResetCreateResponse409 | v1StudentsPasswordResetCreateResponse410 | v1StudentsPasswordResetCreateResponse429) & {
  headers: Headers;
};

export type v1StudentsPasswordResetCreateResponse = (v1StudentsPasswordResetCreateResponseSuccess | v1StudentsPasswordResetCreateResponseError)

export const getV1StudentsPasswordResetCreateUrl = () => {




  return `/api/v1/students/password-reset/`
}

/**
 * TR-1000: reset a student's password by immutable login (FR-001).
 *
 * Admits both teachers and operators; the operator-vs-teacher scope split is enforced in
 * the resolver (an out-of-scope code 404s — anti-enumeration), never at the permission gate
 * (a 403 would itself confirm the target's shape).
 * @summary Reset hasła ucznia po loginie (TR-1000)
 */
export const v1StudentsPasswordResetCreate = async (resetByCodeRequestRequest: ResetByCodeRequestRequest, options?: RequestInit): Promise<v1StudentsPasswordResetCreateResponse> => {

  return customFetch<v1StudentsPasswordResetCreateResponse>(getV1StudentsPasswordResetCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resetByCodeRequestRequest)
  }
);}




export const getV1StudentsPasswordResetCreateMutationOptions = <TError = ResetStudentError | UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1StudentsPasswordResetCreate>>, TError,{data: ResetByCodeRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1StudentsPasswordResetCreate>>, TError,{data: ResetByCodeRequestRequest}, TContext> => {

const mutationKey = ['v1StudentsPasswordResetCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1StudentsPasswordResetCreate>>, {data: ResetByCodeRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1StudentsPasswordResetCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1StudentsPasswordResetCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1StudentsPasswordResetCreate>>>
    export type V1StudentsPasswordResetCreateMutationBody = ResetByCodeRequestRequest
    export type V1StudentsPasswordResetCreateMutationError = ResetStudentError | UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Reset hasła ucznia po loginie (TR-1000)
 */
export const useV1StudentsPasswordResetCreate = <TError = ResetStudentError | UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1StudentsPasswordResetCreate>>, TError,{data: ResetByCodeRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1StudentsPasswordResetCreate>>,
        TError,
        {data: ResetByCodeRequestRequest},
        TContext
      > => {
      return useMutation(getV1StudentsPasswordResetCreateMutationOptions(options), queryClient);
    }

export type v1StudentsPasswordResetQuestionCreateResponse200 = {
  data: ResetStudentQuestionResponse
  status: 200
}

export type v1StudentsPasswordResetQuestionCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1StudentsPasswordResetQuestionCreateResponse404 = {
  data: void
  status: 404
}

export type v1StudentsPasswordResetQuestionCreateResponse409 = {
  data: ResetStudentError
  status: 409
}

export type v1StudentsPasswordResetQuestionCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1StudentsPasswordResetQuestionCreateResponse429 = {
  data: void
  status: 429
}

export type v1StudentsPasswordResetQuestionCreateResponseSuccess = (v1StudentsPasswordResetQuestionCreateResponse200) & {
  headers: Headers;
};
export type v1StudentsPasswordResetQuestionCreateResponseError = (v1StudentsPasswordResetQuestionCreateResponse401 | v1StudentsPasswordResetQuestionCreateResponse404 | v1StudentsPasswordResetQuestionCreateResponse409 | v1StudentsPasswordResetQuestionCreateResponse410 | v1StudentsPasswordResetQuestionCreateResponse429) & {
  headers: Headers;
};

export type v1StudentsPasswordResetQuestionCreateResponse = (v1StudentsPasswordResetQuestionCreateResponseSuccess | v1StudentsPasswordResetQuestionCreateResponseError)

export const getV1StudentsPasswordResetQuestionCreateUrl = () => {




  return `/api/v1/students/password-reset/question/`
}

/**
 * TR-1000: reset a student's password by immutable login (FR-001).
 *
 * Admits both teachers and operators; the operator-vs-teacher scope split is enforced in
 * the resolver (an out-of-scope code 404s — anti-enumeration), never at the permission gate
 * (a 403 would itself confirm the target's shape).
 * @summary Pytanie bezpieczeństwa ucznia dla uprawnionego pracownika
 */
export const v1StudentsPasswordResetQuestionCreate = async (resetStudentQuestionRequestRequest?: ResetStudentQuestionRequestRequest, options?: RequestInit): Promise<v1StudentsPasswordResetQuestionCreateResponse> => {

  return customFetch<v1StudentsPasswordResetQuestionCreateResponse>(getV1StudentsPasswordResetQuestionCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resetStudentQuestionRequestRequest)
  }
);}




export const getV1StudentsPasswordResetQuestionCreateMutationOptions = <TError = UnauthorizedResponse | void | ResetStudentError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1StudentsPasswordResetQuestionCreate>>, TError,{data?: ResetStudentQuestionRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1StudentsPasswordResetQuestionCreate>>, TError,{data?: ResetStudentQuestionRequestRequest}, TContext> => {

const mutationKey = ['v1StudentsPasswordResetQuestionCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1StudentsPasswordResetQuestionCreate>>, {data?: ResetStudentQuestionRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1StudentsPasswordResetQuestionCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1StudentsPasswordResetQuestionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1StudentsPasswordResetQuestionCreate>>>
    export type V1StudentsPasswordResetQuestionCreateMutationBody = ResetStudentQuestionRequestRequest | undefined
    export type V1StudentsPasswordResetQuestionCreateMutationError = UnauthorizedResponse | void | ResetStudentError | AccountGoneResponse

    /**
 * @summary Pytanie bezpieczeństwa ucznia dla uprawnionego pracownika
 */
export const useV1StudentsPasswordResetQuestionCreate = <TError = UnauthorizedResponse | void | ResetStudentError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1StudentsPasswordResetQuestionCreate>>, TError,{data?: ResetStudentQuestionRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1StudentsPasswordResetQuestionCreate>>,
        TError,
        {data?: ResetStudentQuestionRequestRequest},
        TContext
      > => {
      return useMutation(getV1StudentsPasswordResetQuestionCreateMutationOptions(options), queryClient);
    }

export type v1SyncDemoEntriesListResponse200 = {
  data: PaginatedSyncDemoEntryList
  status: 200
}

export type v1SyncDemoEntriesListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SyncDemoEntriesListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SyncDemoEntriesListResponseSuccess = (v1SyncDemoEntriesListResponse200) & {
  headers: Headers;
};
export type v1SyncDemoEntriesListResponseError = (v1SyncDemoEntriesListResponse401 | v1SyncDemoEntriesListResponse410) & {
  headers: Headers;
};

export type v1SyncDemoEntriesListResponse = (v1SyncDemoEntriesListResponseSuccess | v1SyncDemoEntriesListResponseError)

export const getV1SyncDemoEntriesListUrl = (params?: V1SyncDemoEntriesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/sync/demo/entries/?${stringifiedParams}` : `/api/v1/sync/demo/entries/`
}

/**
 * Pull route for the demo entity — exercises the reusable cursor machinery.
 *
 * Not a product endpoint: it exists so AC3/AC4 (tombstones, cursor stability)
 * have a live GET to assert against before a real entity lands.
 */
export const v1SyncDemoEntriesList = async (params?: V1SyncDemoEntriesListParams, options?: RequestInit): Promise<v1SyncDemoEntriesListResponse> => {

  return customFetch<v1SyncDemoEntriesListResponse>(getV1SyncDemoEntriesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1SyncDemoEntriesListQueryKey = (params?: V1SyncDemoEntriesListParams,) => {
    return [
    `/api/v1/sync/demo/entries/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1SyncDemoEntriesListQueryOptions = <TData = Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1SyncDemoEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1SyncDemoEntriesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1SyncDemoEntriesList>>> = ({ signal }) => v1SyncDemoEntriesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1SyncDemoEntriesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1SyncDemoEntriesList>>>
export type V1SyncDemoEntriesListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1SyncDemoEntriesList<TData = Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1SyncDemoEntriesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SyncDemoEntriesList>>,
          TError,
          Awaited<ReturnType<typeof v1SyncDemoEntriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SyncDemoEntriesList<TData = Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SyncDemoEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SyncDemoEntriesList>>,
          TError,
          Awaited<ReturnType<typeof v1SyncDemoEntriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SyncDemoEntriesList<TData = Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SyncDemoEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1SyncDemoEntriesList<TData = Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SyncDemoEntriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SyncDemoEntriesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1SyncDemoEntriesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type syncOperationApplyResponse200 = {
  data: SyncOperationResult
  status: 200
}

export type syncOperationApplyResponse201 = {
  data: SyncOperationResult
  status: 201
}

export type syncOperationApplyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type syncOperationApplyResponse403 = {
  data: SyncError
  status: 403
}

export type syncOperationApplyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type syncOperationApplyResponse422 = {
  data: SyncError
  status: 422
}

export type syncOperationApplyResponse503 = {
  data: SyncError
  status: 503
}

export type syncOperationApplyResponseSuccess = (syncOperationApplyResponse200 | syncOperationApplyResponse201) & {
  headers: Headers;
};
export type syncOperationApplyResponseError = (syncOperationApplyResponse401 | syncOperationApplyResponse403 | syncOperationApplyResponse410 | syncOperationApplyResponse422 | syncOperationApplyResponse503) & {
  headers: Headers;
};

export type syncOperationApplyResponse = (syncOperationApplyResponseSuccess | syncOperationApplyResponseError)

export const getSyncOperationApplyUrl = () => {




  return `/api/v1/sync/operations/`
}

/**
 * Apply one offline-sync operation (push half of the mobile outbox).
 *
 * Owner is always `request.user` (Bearer JWT) — never read from the payload.
 * See `operations.apply_operation` for idempotency / LWW / soft-delete rules.
 */
export const syncOperationApply = async (syncOperationVariantsRequest?: SyncOperationVariantsRequest, options?: RequestInit): Promise<syncOperationApplyResponse> => {

  return customFetch<syncOperationApplyResponse>(getSyncOperationApplyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(syncOperationVariantsRequest)
  }
);}




export const getSyncOperationApplyMutationOptions = <TError = UnauthorizedResponse | SyncError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncOperationApply>>, TError,{data?: SyncOperationVariantsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncOperationApply>>, TError,{data?: SyncOperationVariantsRequest}, TContext> => {

const mutationKey = ['syncOperationApply'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncOperationApply>>, {data?: SyncOperationVariantsRequest}> = (props) => {
          const {data} = props ?? {};

          return  syncOperationApply(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncOperationApplyMutationResult = NonNullable<Awaited<ReturnType<typeof syncOperationApply>>>
    export type SyncOperationApplyMutationBody = SyncOperationVariantsRequest | undefined
    export type SyncOperationApplyMutationError = UnauthorizedResponse | SyncError | AccountGoneResponse

    export const useSyncOperationApply = <TError = UnauthorizedResponse | SyncError | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncOperationApply>>, TError,{data?: SyncOperationVariantsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof syncOperationApply>>,
        TError,
        {data?: SyncOperationVariantsRequest},
        TContext
      > => {
      return useMutation(getSyncOperationApplyMutationOptions(options), queryClient);
    }

export type v1SystemErrorsListResponse200 = {
  data: PaginatedSyncDeadLetterList
  status: 200
}

export type v1SystemErrorsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SystemErrorsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SystemErrorsListResponseSuccess = (v1SystemErrorsListResponse200) & {
  headers: Headers;
};
export type v1SystemErrorsListResponseError = (v1SystemErrorsListResponse401 | v1SystemErrorsListResponse410) & {
  headers: Headers;
};

export type v1SystemErrorsListResponse = (v1SystemErrorsListResponseSuccess | v1SystemErrorsListResponseError)

export const getV1SystemErrorsListUrl = (params?: V1SystemErrorsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/system-errors/?${stringifiedParams}` : `/api/v1/system-errors/`
}

export const v1SystemErrorsList = async (params?: V1SystemErrorsListParams, options?: RequestInit): Promise<v1SystemErrorsListResponse> => {

  return customFetch<v1SystemErrorsListResponse>(getV1SystemErrorsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1SystemErrorsListQueryKey = (params?: V1SystemErrorsListParams,) => {
    return [
    `/api/v1/system-errors/`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1SystemErrorsListQueryOptions = <TData = Awaited<ReturnType<typeof v1SystemErrorsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: V1SystemErrorsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SystemErrorsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1SystemErrorsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1SystemErrorsList>>> = ({ signal }) => v1SystemErrorsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1SystemErrorsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1SystemErrorsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1SystemErrorsList>>>
export type V1SystemErrorsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useV1SystemErrorsList<TData = Awaited<ReturnType<typeof v1SystemErrorsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  V1SystemErrorsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SystemErrorsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SystemErrorsList>>,
          TError,
          Awaited<ReturnType<typeof v1SystemErrorsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SystemErrorsList<TData = Awaited<ReturnType<typeof v1SystemErrorsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SystemErrorsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SystemErrorsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SystemErrorsList>>,
          TError,
          Awaited<ReturnType<typeof v1SystemErrorsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1SystemErrorsList<TData = Awaited<ReturnType<typeof v1SystemErrorsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SystemErrorsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SystemErrorsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useV1SystemErrorsList<TData = Awaited<ReturnType<typeof v1SystemErrorsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: V1SystemErrorsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SystemErrorsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1SystemErrorsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type v1SystemErrorsSyncEventsCreateResponse200 = {
  data: SyncDeadLetter
  status: 200
}

export type v1SystemErrorsSyncEventsCreateResponse201 = {
  data: SyncDeadLetter
  status: 201
}

export type v1SystemErrorsSyncEventsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type v1SystemErrorsSyncEventsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type v1SystemErrorsSyncEventsCreateResponseSuccess = (v1SystemErrorsSyncEventsCreateResponse200 | v1SystemErrorsSyncEventsCreateResponse201) & {
  headers: Headers;
};
export type v1SystemErrorsSyncEventsCreateResponseError = (v1SystemErrorsSyncEventsCreateResponse401 | v1SystemErrorsSyncEventsCreateResponse410) & {
  headers: Headers;
};

export type v1SystemErrorsSyncEventsCreateResponse = (v1SystemErrorsSyncEventsCreateResponseSuccess | v1SystemErrorsSyncEventsCreateResponseError)

export const getV1SystemErrorsSyncEventsCreateUrl = () => {




  return `/api/v1/system-errors/sync-events/`
}

export const v1SystemErrorsSyncEventsCreate = async (syncDeadLetterCreateRequest: SyncDeadLetterCreateRequest, options?: RequestInit): Promise<v1SystemErrorsSyncEventsCreateResponse> => {

  return customFetch<v1SystemErrorsSyncEventsCreateResponse>(getV1SystemErrorsSyncEventsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(syncDeadLetterCreateRequest)
  }
);}




export const getV1SystemErrorsSyncEventsCreateMutationOptions = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SystemErrorsSyncEventsCreate>>, TError,{data: SyncDeadLetterCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1SystemErrorsSyncEventsCreate>>, TError,{data: SyncDeadLetterCreateRequest}, TContext> => {

const mutationKey = ['v1SystemErrorsSyncEventsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1SystemErrorsSyncEventsCreate>>, {data: SyncDeadLetterCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  v1SystemErrorsSyncEventsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1SystemErrorsSyncEventsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1SystemErrorsSyncEventsCreate>>>
    export type V1SystemErrorsSyncEventsCreateMutationBody = SyncDeadLetterCreateRequest
    export type V1SystemErrorsSyncEventsCreateMutationError = UnauthorizedResponse | AccountGoneResponse

    export const useV1SystemErrorsSyncEventsCreate = <TError = UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1SystemErrorsSyncEventsCreate>>, TError,{data: SyncDeadLetterCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1SystemErrorsSyncEventsCreate>>,
        TError,
        {data: SyncDeadLetterCreateRequest},
        TContext
      > => {
      return useMutation(getV1SystemErrorsSyncEventsCreateMutationOptions(options), queryClient);
    }

export type teacherAccountsListResponse200 = {
  data: PaginatedTeacherAccountRowList
  status: 200
}

export type teacherAccountsListResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsListResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsListResponseSuccess = (teacherAccountsListResponse200) & {
  headers: Headers;
};
export type teacherAccountsListResponseError = (teacherAccountsListResponse401 | teacherAccountsListResponse410) & {
  headers: Headers;
};

export type teacherAccountsListResponse = (teacherAccountsListResponseSuccess | teacherAccountsListResponseError)

export const getTeacherAccountsListUrl = (params?: TeacherAccountsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teacher-accounts/?${stringifiedParams}` : `/api/v1/teacher-accounts/`
}

/**
 * @summary Lista kont nauczycieli (TR-702)
 */
export const teacherAccountsList = async (params?: TeacherAccountsListParams, options?: RequestInit): Promise<teacherAccountsListResponse> => {

  return customFetch<teacherAccountsListResponse>(getTeacherAccountsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTeacherAccountsListQueryKey = (params?: TeacherAccountsListParams,) => {
    return [
    `/api/v1/teacher-accounts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeacherAccountsListQueryOptions = <TData = Awaited<ReturnType<typeof teacherAccountsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(params?: TeacherAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeacherAccountsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teacherAccountsList>>> = ({ signal }) => teacherAccountsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeacherAccountsListQueryResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsList>>>
export type TeacherAccountsListQueryError = UnauthorizedResponse | AccountGoneResponse


export function useTeacherAccountsList<TData = Awaited<ReturnType<typeof teacherAccountsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params: undefined |  TeacherAccountsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teacherAccountsList>>,
          TError,
          Awaited<ReturnType<typeof teacherAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeacherAccountsList<TData = Awaited<ReturnType<typeof teacherAccountsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: TeacherAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teacherAccountsList>>,
          TError,
          Awaited<ReturnType<typeof teacherAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeacherAccountsList<TData = Awaited<ReturnType<typeof teacherAccountsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: TeacherAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista kont nauczycieli (TR-702)
 */

export function useTeacherAccountsList<TData = Awaited<ReturnType<typeof teacherAccountsList>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 params?: TeacherAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeacherAccountsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type teacherAccountsCreateResponse201 = {
  data: TeacherAccountCreateResponse
  status: 201
}

export type teacherAccountsCreateResponse400 = {
  data: void
  status: 400
}

export type teacherAccountsCreateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsCreateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsCreateResponseSuccess = (teacherAccountsCreateResponse201) & {
  headers: Headers;
};
export type teacherAccountsCreateResponseError = (teacherAccountsCreateResponse400 | teacherAccountsCreateResponse401 | teacherAccountsCreateResponse410) & {
  headers: Headers;
};

export type teacherAccountsCreateResponse = (teacherAccountsCreateResponseSuccess | teacherAccountsCreateResponseError)

export const getTeacherAccountsCreateUrl = () => {




  return `/api/v1/teacher-accounts/`
}

/**
 * @summary Założenie konta nauczyciela (TR-700)
 */
export const teacherAccountsCreate = async (teacherAccountCreateRequest: TeacherAccountCreateRequest, options?: RequestInit): Promise<teacherAccountsCreateResponse> => {

  return customFetch<teacherAccountsCreateResponse>(getTeacherAccountsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(teacherAccountCreateRequest)
  }
);}




export const getTeacherAccountsCreateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsCreate>>, TError,{data: TeacherAccountCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsCreate>>, TError,{data: TeacherAccountCreateRequest}, TContext> => {

const mutationKey = ['teacherAccountsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsCreate>>, {data: TeacherAccountCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  teacherAccountsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsCreate>>>
    export type TeacherAccountsCreateMutationBody = TeacherAccountCreateRequest
    export type TeacherAccountsCreateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Założenie konta nauczyciela (TR-700)
 */
export const useTeacherAccountsCreate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsCreate>>, TError,{data: TeacherAccountCreateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsCreate>>,
        TError,
        {data: TeacherAccountCreateRequest},
        TContext
      > => {
      return useMutation(getTeacherAccountsCreateMutationOptions(options), queryClient);
    }

export type teacherAccountsRetrieveResponse200 = {
  data: TeacherAccountDetail
  status: 200
}

export type teacherAccountsRetrieveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsRetrieveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsRetrieveResponseSuccess = (teacherAccountsRetrieveResponse200) & {
  headers: Headers;
};
export type teacherAccountsRetrieveResponseError = (teacherAccountsRetrieveResponse401 | teacherAccountsRetrieveResponse410) & {
  headers: Headers;
};

export type teacherAccountsRetrieveResponse = (teacherAccountsRetrieveResponseSuccess | teacherAccountsRetrieveResponseError)

export const getTeacherAccountsRetrieveUrl = (id: number,) => {




  return `/api/v1/teacher-accounts/${id}/`
}

/**
 * @summary Szczegóły konta nauczyciela
 */
export const teacherAccountsRetrieve = async (id: number, options?: RequestInit): Promise<teacherAccountsRetrieveResponse> => {

  return customFetch<teacherAccountsRetrieveResponse>(getTeacherAccountsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTeacherAccountsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/v1/teacher-accounts/${id}/`
    ] as const;
    }


export const getTeacherAccountsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeacherAccountsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teacherAccountsRetrieve>>> = ({ signal }) => teacherAccountsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeacherAccountsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsRetrieve>>>
export type TeacherAccountsRetrieveQueryError = UnauthorizedResponse | AccountGoneResponse


export function useTeacherAccountsRetrieve<TData = Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teacherAccountsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof teacherAccountsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeacherAccountsRetrieve<TData = Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teacherAccountsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof teacherAccountsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeacherAccountsRetrieve<TData = Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Szczegóły konta nauczyciela
 */

export function useTeacherAccountsRetrieve<TData = Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError = UnauthorizedResponse | AccountGoneResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherAccountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeacherAccountsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type teacherAccountsPartialUpdateResponse200 = {
  data: TeacherAccountUpdateResponse
  status: 200
}

export type teacherAccountsPartialUpdateResponse400 = {
  data: void
  status: 400
}

export type teacherAccountsPartialUpdateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsPartialUpdateResponse409 = {
  data: void
  status: 409
}

export type teacherAccountsPartialUpdateResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsPartialUpdateResponseSuccess = (teacherAccountsPartialUpdateResponse200) & {
  headers: Headers;
};
export type teacherAccountsPartialUpdateResponseError = (teacherAccountsPartialUpdateResponse400 | teacherAccountsPartialUpdateResponse401 | teacherAccountsPartialUpdateResponse409 | teacherAccountsPartialUpdateResponse410) & {
  headers: Headers;
};

export type teacherAccountsPartialUpdateResponse = (teacherAccountsPartialUpdateResponseSuccess | teacherAccountsPartialUpdateResponseError)

export const getTeacherAccountsPartialUpdateUrl = (id: number,) => {




  return `/api/v1/teacher-accounts/${id}/`
}

/**
 * @summary Edycja danych konta nauczyciela (TR-701)
 */
export const teacherAccountsPartialUpdate = async (id: number,
    patchedTeacherAccountUpdateRequest?: PatchedTeacherAccountUpdateRequest, options?: RequestInit): Promise<teacherAccountsPartialUpdateResponse> => {

  return customFetch<teacherAccountsPartialUpdateResponse>(getTeacherAccountsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedTeacherAccountUpdateRequest)
  }
);}




export const getTeacherAccountsPartialUpdateMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsPartialUpdate>>, TError,{id: number;data?: PatchedTeacherAccountUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsPartialUpdate>>, TError,{id: number;data?: PatchedTeacherAccountUpdateRequest}, TContext> => {

const mutationKey = ['teacherAccountsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsPartialUpdate>>, {id: number;data?: PatchedTeacherAccountUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  teacherAccountsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsPartialUpdate>>>
    export type TeacherAccountsPartialUpdateMutationBody = PatchedTeacherAccountUpdateRequest | undefined
    export type TeacherAccountsPartialUpdateMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Edycja danych konta nauczyciela (TR-701)
 */
export const useTeacherAccountsPartialUpdate = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsPartialUpdate>>, TError,{id: number;data?: PatchedTeacherAccountUpdateRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedTeacherAccountUpdateRequest},
        TContext
      > => {
      return useMutation(getTeacherAccountsPartialUpdateMutationOptions(options), queryClient);
    }

export type teacherAccountsArchiveResponse200 = {
  data: TeacherAccountArchiveResponse
  status: 200
}

export type teacherAccountsArchiveResponse400 = {
  data: void
  status: 400
}

export type teacherAccountsArchiveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsArchiveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsArchiveResponseSuccess = (teacherAccountsArchiveResponse200) & {
  headers: Headers;
};
export type teacherAccountsArchiveResponseError = (teacherAccountsArchiveResponse400 | teacherAccountsArchiveResponse401 | teacherAccountsArchiveResponse410) & {
  headers: Headers;
};

export type teacherAccountsArchiveResponse = (teacherAccountsArchiveResponseSuccess | teacherAccountsArchiveResponseError)

export const getTeacherAccountsArchiveUrl = (id: number,) => {




  return `/api/v1/teacher-accounts/${id}/archive/`
}

/**
 * @summary Archiwizacja konta nauczyciela (TR-703)
 */
export const teacherAccountsArchive = async (id: number, options?: RequestInit): Promise<teacherAccountsArchiveResponse> => {

  return customFetch<teacherAccountsArchiveResponse>(getTeacherAccountsArchiveUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTeacherAccountsArchiveMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsArchive>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsArchive>>, TError,{id: number}, TContext> => {

const mutationKey = ['teacherAccountsArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsArchive>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  teacherAccountsArchive(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsArchive>>>

    export type TeacherAccountsArchiveMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Archiwizacja konta nauczyciela (TR-703)
 */
export const useTeacherAccountsArchive = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsArchive>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsArchive>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getTeacherAccountsArchiveMutationOptions(options), queryClient);
    }

export type teacherAccountsClassAddResponse201 = {
  data: TeacherAccountDetail
  status: 201
}

export type teacherAccountsClassAddResponse400 = {
  data: void
  status: 400
}

export type teacherAccountsClassAddResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsClassAddResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsClassAddResponseSuccess = (teacherAccountsClassAddResponse201) & {
  headers: Headers;
};
export type teacherAccountsClassAddResponseError = (teacherAccountsClassAddResponse400 | teacherAccountsClassAddResponse401 | teacherAccountsClassAddResponse410) & {
  headers: Headers;
};

export type teacherAccountsClassAddResponse = (teacherAccountsClassAddResponseSuccess | teacherAccountsClassAddResponseError)

export const getTeacherAccountsClassAddUrl = (id: number,) => {




  return `/api/v1/teacher-accounts/${id}/classes/`
}

/**
 * @summary Dodanie powiązania nauczyciel–klasa (TR-705)
 */
export const teacherAccountsClassAdd = async (id: number,
    teacherClassLinkAddRequest: TeacherClassLinkAddRequest, options?: RequestInit): Promise<teacherAccountsClassAddResponse> => {

  return customFetch<teacherAccountsClassAddResponse>(getTeacherAccountsClassAddUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(teacherClassLinkAddRequest)
  }
);}




export const getTeacherAccountsClassAddMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsClassAdd>>, TError,{id: number;data: TeacherClassLinkAddRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsClassAdd>>, TError,{id: number;data: TeacherClassLinkAddRequest}, TContext> => {

const mutationKey = ['teacherAccountsClassAdd'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsClassAdd>>, {id: number;data: TeacherClassLinkAddRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  teacherAccountsClassAdd(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsClassAddMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsClassAdd>>>
    export type TeacherAccountsClassAddMutationBody = TeacherClassLinkAddRequest
    export type TeacherAccountsClassAddMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Dodanie powiązania nauczyciel–klasa (TR-705)
 */
export const useTeacherAccountsClassAdd = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsClassAdd>>, TError,{id: number;data: TeacherClassLinkAddRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsClassAdd>>,
        TError,
        {id: number;data: TeacherClassLinkAddRequest},
        TContext
      > => {
      return useMutation(getTeacherAccountsClassAddMutationOptions(options), queryClient);
    }

export type teacherAccountsClassRemoveResponse200 = {
  data: TeacherAccountDetail
  status: 200
}

export type teacherAccountsClassRemoveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsClassRemoveResponse404 = {
  data: void
  status: 404
}

export type teacherAccountsClassRemoveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsClassRemoveResponseSuccess = (teacherAccountsClassRemoveResponse200) & {
  headers: Headers;
};
export type teacherAccountsClassRemoveResponseError = (teacherAccountsClassRemoveResponse401 | teacherAccountsClassRemoveResponse404 | teacherAccountsClassRemoveResponse410) & {
  headers: Headers;
};

export type teacherAccountsClassRemoveResponse = (teacherAccountsClassRemoveResponseSuccess | teacherAccountsClassRemoveResponseError)

export const getTeacherAccountsClassRemoveUrl = (id: number,
    classId: string,) => {




  return `/api/v1/teacher-accounts/${id}/classes/${classId}/`
}

/**
 * @summary Odebranie powiązania nauczyciel–klasa (TR-705)
 */
export const teacherAccountsClassRemove = async (id: number,
    classId: string, options?: RequestInit): Promise<teacherAccountsClassRemoveResponse> => {

  return customFetch<teacherAccountsClassRemoveResponse>(getTeacherAccountsClassRemoveUrl(id,classId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getTeacherAccountsClassRemoveMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsClassRemove>>, TError,{id: number;classId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsClassRemove>>, TError,{id: number;classId: string}, TContext> => {

const mutationKey = ['teacherAccountsClassRemove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsClassRemove>>, {id: number;classId: string}> = (props) => {
          const {id,classId} = props ?? {};

          return  teacherAccountsClassRemove(id,classId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsClassRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsClassRemove>>>

    export type TeacherAccountsClassRemoveMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Odebranie powiązania nauczyciel–klasa (TR-705)
 */
export const useTeacherAccountsClassRemove = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsClassRemove>>, TError,{id: number;classId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsClassRemove>>,
        TError,
        {id: number;classId: string},
        TContext
      > => {
      return useMutation(getTeacherAccountsClassRemoveMutationOptions(options), queryClient);
    }

export type teacherAccountsDeleteResponse204 = {
  data: void
  status: 204
}

export type teacherAccountsDeleteResponse400 = {
  data: void
  status: 400
}

export type teacherAccountsDeleteResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsDeleteResponse403 = {
  data: void
  status: 403
}

export type teacherAccountsDeleteResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsDeleteResponseSuccess = (teacherAccountsDeleteResponse204) & {
  headers: Headers;
};
export type teacherAccountsDeleteResponseError = (teacherAccountsDeleteResponse400 | teacherAccountsDeleteResponse401 | teacherAccountsDeleteResponse403 | teacherAccountsDeleteResponse410) & {
  headers: Headers;
};

export type teacherAccountsDeleteResponse = (teacherAccountsDeleteResponseSuccess | teacherAccountsDeleteResponseError)

export const getTeacherAccountsDeleteUrl = (id: number,) => {




  return `/api/v1/teacher-accounts/${id}/delete/`
}

/**
 * @summary Trwałe usunięcie konta nauczyciela (TR-704, superadmin)
 */
export const teacherAccountsDelete = async (id: number,
    teacherAccountDeleteRequest: TeacherAccountDeleteRequest, options?: RequestInit): Promise<teacherAccountsDeleteResponse> => {

  return customFetch<teacherAccountsDeleteResponse>(getTeacherAccountsDeleteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(teacherAccountDeleteRequest)
  }
);}




export const getTeacherAccountsDeleteMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsDelete>>, TError,{id: number;data: TeacherAccountDeleteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsDelete>>, TError,{id: number;data: TeacherAccountDeleteRequest}, TContext> => {

const mutationKey = ['teacherAccountsDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsDelete>>, {id: number;data: TeacherAccountDeleteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  teacherAccountsDelete(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsDelete>>>
    export type TeacherAccountsDeleteMutationBody = TeacherAccountDeleteRequest
    export type TeacherAccountsDeleteMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Trwałe usunięcie konta nauczyciela (TR-704, superadmin)
 */
export const useTeacherAccountsDelete = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsDelete>>, TError,{id: number;data: TeacherAccountDeleteRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsDelete>>,
        TError,
        {id: number;data: TeacherAccountDeleteRequest},
        TContext
      > => {
      return useMutation(getTeacherAccountsDeleteMutationOptions(options), queryClient);
    }

export type teacherAccountsPasswordResetResponse200 = {
  data: TeacherPasswordResetResponse
  status: 200
}

export type teacherAccountsPasswordResetResponse400 = {
  data: void
  status: 400
}

export type teacherAccountsPasswordResetResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsPasswordResetResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsPasswordResetResponseSuccess = (teacherAccountsPasswordResetResponse200) & {
  headers: Headers;
};
export type teacherAccountsPasswordResetResponseError = (teacherAccountsPasswordResetResponse400 | teacherAccountsPasswordResetResponse401 | teacherAccountsPasswordResetResponse410) & {
  headers: Headers;
};

export type teacherAccountsPasswordResetResponse = (teacherAccountsPasswordResetResponseSuccess | teacherAccountsPasswordResetResponseError)

export const getTeacherAccountsPasswordResetUrl = (id: number,) => {




  return `/api/v1/teacher-accounts/${id}/password-reset/`
}

/**
 * @summary Administracyjna inicjacja resetu hasła (TR-706)
 */
export const teacherAccountsPasswordReset = async (id: number, options?: RequestInit): Promise<teacherAccountsPasswordResetResponse> => {

  return customFetch<teacherAccountsPasswordResetResponse>(getTeacherAccountsPasswordResetUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTeacherAccountsPasswordResetMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsPasswordReset>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsPasswordReset>>, TError,{id: number}, TContext> => {

const mutationKey = ['teacherAccountsPasswordReset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsPasswordReset>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  teacherAccountsPasswordReset(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsPasswordReset>>>

    export type TeacherAccountsPasswordResetMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Administracyjna inicjacja resetu hasła (TR-706)
 */
export const useTeacherAccountsPasswordReset = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsPasswordReset>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsPasswordReset>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getTeacherAccountsPasswordResetMutationOptions(options), queryClient);
    }

export type teacherAccountsResendInvitationResponse200 = {
  data: TeacherInvitationResendResponse
  status: 200
}

export type teacherAccountsResendInvitationResponse400 = {
  data: void
  status: 400
}

export type teacherAccountsResendInvitationResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsResendInvitationResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsResendInvitationResponseSuccess = (teacherAccountsResendInvitationResponse200) & {
  headers: Headers;
};
export type teacherAccountsResendInvitationResponseError = (teacherAccountsResendInvitationResponse400 | teacherAccountsResendInvitationResponse401 | teacherAccountsResendInvitationResponse410) & {
  headers: Headers;
};

export type teacherAccountsResendInvitationResponse = (teacherAccountsResendInvitationResponseSuccess | teacherAccountsResendInvitationResponseError)

export const getTeacherAccountsResendInvitationUrl = (id: number,) => {




  return `/api/v1/teacher-accounts/${id}/resend-invitation/`
}

/**
 * @summary Ponowne wysłanie zaproszenia nauczyciela (TR-700)
 */
export const teacherAccountsResendInvitation = async (id: number, options?: RequestInit): Promise<teacherAccountsResendInvitationResponse> => {

  return customFetch<teacherAccountsResendInvitationResponse>(getTeacherAccountsResendInvitationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTeacherAccountsResendInvitationMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsResendInvitation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsResendInvitation>>, TError,{id: number}, TContext> => {

const mutationKey = ['teacherAccountsResendInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsResendInvitation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  teacherAccountsResendInvitation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsResendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsResendInvitation>>>

    export type TeacherAccountsResendInvitationMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Ponowne wysłanie zaproszenia nauczyciela (TR-700)
 */
export const useTeacherAccountsResendInvitation = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsResendInvitation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsResendInvitation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getTeacherAccountsResendInvitationMutationOptions(options), queryClient);
    }

export type teacherAccountsRestoreResponse200 = {
  data: TeacherAccountRestoreResponse
  status: 200
}

export type teacherAccountsRestoreResponse400 = {
  data: void
  status: 400
}

export type teacherAccountsRestoreResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsRestoreResponse403 = {
  data: void
  status: 403
}

export type teacherAccountsRestoreResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsRestoreResponseSuccess = (teacherAccountsRestoreResponse200) & {
  headers: Headers;
};
export type teacherAccountsRestoreResponseError = (teacherAccountsRestoreResponse400 | teacherAccountsRestoreResponse401 | teacherAccountsRestoreResponse403 | teacherAccountsRestoreResponse410) & {
  headers: Headers;
};

export type teacherAccountsRestoreResponse = (teacherAccountsRestoreResponseSuccess | teacherAccountsRestoreResponseError)

export const getTeacherAccountsRestoreUrl = (id: number,) => {




  return `/api/v1/teacher-accounts/${id}/restore/`
}

/**
 * @summary Przywrócenie zarchiwizowanego konta nauczyciela (superadmin)
 */
export const teacherAccountsRestore = async (id: number, options?: RequestInit): Promise<teacherAccountsRestoreResponse> => {

  return customFetch<teacherAccountsRestoreResponse>(getTeacherAccountsRestoreUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTeacherAccountsRestoreMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsRestore>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsRestore>>, TError,{id: number}, TContext> => {

const mutationKey = ['teacherAccountsRestore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsRestore>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  teacherAccountsRestore(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsRestoreMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsRestore>>>

    export type TeacherAccountsRestoreMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Przywrócenie zarchiwizowanego konta nauczyciela (superadmin)
 */
export const useTeacherAccountsRestore = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsRestore>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsRestore>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getTeacherAccountsRestoreMutationOptions(options), queryClient);
    }

export type teacherAccountsSchoolAddResponse201 = {
  data: TeacherAccountDetail
  status: 201
}

export type teacherAccountsSchoolAddResponse400 = {
  data: void
  status: 400
}

export type teacherAccountsSchoolAddResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsSchoolAddResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsSchoolAddResponseSuccess = (teacherAccountsSchoolAddResponse201) & {
  headers: Headers;
};
export type teacherAccountsSchoolAddResponseError = (teacherAccountsSchoolAddResponse400 | teacherAccountsSchoolAddResponse401 | teacherAccountsSchoolAddResponse410) & {
  headers: Headers;
};

export type teacherAccountsSchoolAddResponse = (teacherAccountsSchoolAddResponseSuccess | teacherAccountsSchoolAddResponseError)

export const getTeacherAccountsSchoolAddUrl = (id: number,) => {




  return `/api/v1/teacher-accounts/${id}/schools/`
}

/**
 * @summary Dodanie przypisania nauczyciel–szkoła (TR-707)
 */
export const teacherAccountsSchoolAdd = async (id: number,
    teacherSchoolAssignmentAddRequest: TeacherSchoolAssignmentAddRequest, options?: RequestInit): Promise<teacherAccountsSchoolAddResponse> => {

  return customFetch<teacherAccountsSchoolAddResponse>(getTeacherAccountsSchoolAddUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(teacherSchoolAssignmentAddRequest)
  }
);}




export const getTeacherAccountsSchoolAddMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsSchoolAdd>>, TError,{id: number;data: TeacherSchoolAssignmentAddRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsSchoolAdd>>, TError,{id: number;data: TeacherSchoolAssignmentAddRequest}, TContext> => {

const mutationKey = ['teacherAccountsSchoolAdd'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsSchoolAdd>>, {id: number;data: TeacherSchoolAssignmentAddRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  teacherAccountsSchoolAdd(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsSchoolAddMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsSchoolAdd>>>
    export type TeacherAccountsSchoolAddMutationBody = TeacherSchoolAssignmentAddRequest
    export type TeacherAccountsSchoolAddMutationError = void | UnauthorizedResponse | AccountGoneResponse

    /**
 * @summary Dodanie przypisania nauczyciel–szkoła (TR-707)
 */
export const useTeacherAccountsSchoolAdd = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsSchoolAdd>>, TError,{id: number;data: TeacherSchoolAssignmentAddRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsSchoolAdd>>,
        TError,
        {id: number;data: TeacherSchoolAssignmentAddRequest},
        TContext
      > => {
      return useMutation(getTeacherAccountsSchoolAddMutationOptions(options), queryClient);
    }

export type teacherAccountsSchoolRemoveResponse200 = {
  data: TeacherAccountSchoolRemoveResponse
  status: 200
}

export type teacherAccountsSchoolRemoveResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type teacherAccountsSchoolRemoveResponse404 = {
  data: void
  status: 404
}

export type teacherAccountsSchoolRemoveResponse409 = {
  data: void
  status: 409
}

export type teacherAccountsSchoolRemoveResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teacherAccountsSchoolRemoveResponseSuccess = (teacherAccountsSchoolRemoveResponse200) & {
  headers: Headers;
};
export type teacherAccountsSchoolRemoveResponseError = (teacherAccountsSchoolRemoveResponse401 | teacherAccountsSchoolRemoveResponse404 | teacherAccountsSchoolRemoveResponse409 | teacherAccountsSchoolRemoveResponse410) & {
  headers: Headers;
};

export type teacherAccountsSchoolRemoveResponse = (teacherAccountsSchoolRemoveResponseSuccess | teacherAccountsSchoolRemoveResponseError)

export const getTeacherAccountsSchoolRemoveUrl = (id: number,
    schoolId: string,) => {




  return `/api/v1/teacher-accounts/${id}/schools/${schoolId}/`
}

/**
 * @summary Odebranie przypisania nauczyciel–szkoła (TR-707)
 */
export const teacherAccountsSchoolRemove = async (id: number,
    schoolId: string, options?: RequestInit): Promise<teacherAccountsSchoolRemoveResponse> => {

  return customFetch<teacherAccountsSchoolRemoveResponse>(getTeacherAccountsSchoolRemoveUrl(id,schoolId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getTeacherAccountsSchoolRemoveMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsSchoolRemove>>, TError,{id: number;schoolId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsSchoolRemove>>, TError,{id: number;schoolId: string}, TContext> => {

const mutationKey = ['teacherAccountsSchoolRemove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teacherAccountsSchoolRemove>>, {id: number;schoolId: string}> = (props) => {
          const {id,schoolId} = props ?? {};

          return  teacherAccountsSchoolRemove(id,schoolId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeacherAccountsSchoolRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof teacherAccountsSchoolRemove>>>

    export type TeacherAccountsSchoolRemoveMutationError = UnauthorizedResponse | void | AccountGoneResponse

    /**
 * @summary Odebranie przypisania nauczyciel–szkoła (TR-707)
 */
export const useTeacherAccountsSchoolRemove = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teacherAccountsSchoolRemove>>, TError,{id: number;schoolId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teacherAccountsSchoolRemove>>,
        TError,
        {id: number;schoolId: string},
        TContext
      > => {
      return useMutation(getTeacherAccountsSchoolRemoveMutationOptions(options), queryClient);
    }

export type teachersTemporaryPasswordResponse200 = {
  data: AdminAccountTemporaryPasswordResponse
  status: 200
}

export type teachersTemporaryPasswordResponse400 = {
  data: void
  status: 400
}

export type teachersTemporaryPasswordResponse401 = {
  data: void
  status: 401
}

export type teachersTemporaryPasswordResponse403 = {
  data: void
  status: 403
}

export type teachersTemporaryPasswordResponse404 = {
  data: void
  status: 404
}

export type teachersTemporaryPasswordResponse409 = {
  data: void
  status: 409
}

export type teachersTemporaryPasswordResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type teachersTemporaryPasswordResponse429 = {
  data: void
  status: 429
}

export type teachersTemporaryPasswordResponseSuccess = (teachersTemporaryPasswordResponse200) & {
  headers: Headers;
};
export type teachersTemporaryPasswordResponseError = (teachersTemporaryPasswordResponse400 | teachersTemporaryPasswordResponse401 | teachersTemporaryPasswordResponse403 | teachersTemporaryPasswordResponse404 | teachersTemporaryPasswordResponse409 | teachersTemporaryPasswordResponse410 | teachersTemporaryPasswordResponse429) & {
  headers: Headers;
};

export type teachersTemporaryPasswordResponse = (teachersTemporaryPasswordResponseSuccess | teachersTemporaryPasswordResponseError)

export const getTeachersTemporaryPasswordUrl = (id: number,) => {




  return `/api/v1/teacher-accounts/${id}/temporary-password/`
}

/**
 * Superadmin nadaje nauczycielowi hasło tymczasowe ważne 24 h.
 *
 * Hasło wraca w odpowiedzi jeden raz, a operator przekazuje je poza systemem.
 * Nauczyciel po zalogowaniu ustawia własne hasło. Reset linkiem e-mail
 * (`password-reset/`) działa bez zmian i nadal nie ujawnia hasła operatorowi.
 * @summary Hasło tymczasowe konta nauczyciela (superadmin)
 */
export const teachersTemporaryPassword = async (id: number,
    adminAccountTemporaryPasswordRequestRequest: AdminAccountTemporaryPasswordRequestRequest, options?: RequestInit): Promise<teachersTemporaryPasswordResponse> => {

  return customFetch<teachersTemporaryPasswordResponse>(getTeachersTemporaryPasswordUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAccountTemporaryPasswordRequestRequest)
  }
);}




export const getTeachersTemporaryPasswordMutationOptions = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teachersTemporaryPassword>>, TError,{id: number;data: AdminAccountTemporaryPasswordRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teachersTemporaryPassword>>, TError,{id: number;data: AdminAccountTemporaryPasswordRequestRequest}, TContext> => {

const mutationKey = ['teachersTemporaryPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teachersTemporaryPassword>>, {id: number;data: AdminAccountTemporaryPasswordRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  teachersTemporaryPassword(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeachersTemporaryPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof teachersTemporaryPassword>>>
    export type TeachersTemporaryPasswordMutationBody = AdminAccountTemporaryPasswordRequestRequest
    export type TeachersTemporaryPasswordMutationError = void | AccountGoneResponse

    /**
 * @summary Hasło tymczasowe konta nauczyciela (superadmin)
 */
export const useTeachersTemporaryPassword = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teachersTemporaryPassword>>, TError,{id: number;data: AdminAccountTemporaryPasswordRequestRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teachersTemporaryPassword>>,
        TError,
        {id: number;data: AdminAccountTemporaryPasswordRequestRequest},
        TContext
      > => {
      return useMutation(getTeachersTemporaryPasswordMutationOptions(options), queryClient);
    }

export type totpExchangeStatusResponse200 = {
  data: TotpExchangeStatus
  status: 200
}

export type totpExchangeStatusResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type totpExchangeStatusResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type totpExchangeStatusResponseSuccess = (totpExchangeStatusResponse200) & {
  headers: Headers;
};
export type totpExchangeStatusResponseError = (totpExchangeStatusResponse401 | totpExchangeStatusResponse410) & {
  headers: Headers;
};

export type totpExchangeStatusResponse = (totpExchangeStatusResponseSuccess | totpExchangeStatusResponseError)

export const getTotpExchangeStatusUrl = () => {




  return `/api/v1/totp-exchange/`
}

/**
 * Stan wymiany: własne oczekujące żądanie + (dla superadmina) cudze do
 * zatwierdzenia.
 */
export const totpExchangeStatus = async ( options?: RequestInit): Promise<totpExchangeStatusResponse> => {

  return customFetch<totpExchangeStatusResponse>(getTotpExchangeStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTotpExchangeStatusQueryKey = () => {
    return [
    `/api/v1/totp-exchange/`
    ] as const;
    }


export const getTotpExchangeStatusQueryOptions = <TData = Awaited<ReturnType<typeof totpExchangeStatus>>, TError = UnauthorizedResponse | AccountGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof totpExchangeStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTotpExchangeStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof totpExchangeStatus>>> = ({ signal }) => totpExchangeStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof totpExchangeStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TotpExchangeStatusQueryResult = NonNullable<Awaited<ReturnType<typeof totpExchangeStatus>>>
export type TotpExchangeStatusQueryError = UnauthorizedResponse | AccountGoneResponse


export function useTotpExchangeStatus<TData = Awaited<ReturnType<typeof totpExchangeStatus>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof totpExchangeStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof totpExchangeStatus>>,
          TError,
          Awaited<ReturnType<typeof totpExchangeStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTotpExchangeStatus<TData = Awaited<ReturnType<typeof totpExchangeStatus>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof totpExchangeStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof totpExchangeStatus>>,
          TError,
          Awaited<ReturnType<typeof totpExchangeStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTotpExchangeStatus<TData = Awaited<ReturnType<typeof totpExchangeStatus>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof totpExchangeStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTotpExchangeStatus<TData = Awaited<ReturnType<typeof totpExchangeStatus>>, TError = UnauthorizedResponse | AccountGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof totpExchangeStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTotpExchangeStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type totpExchangeDecisionResponse200 = {
  data: TotpExchangeRequest
  status: 200
}

export type totpExchangeDecisionResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type totpExchangeDecisionResponse403 = {
  data: void
  status: 403
}

export type totpExchangeDecisionResponse409 = {
  data: void
  status: 409
}

export type totpExchangeDecisionResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type totpExchangeDecisionResponseSuccess = (totpExchangeDecisionResponse200) & {
  headers: Headers;
};
export type totpExchangeDecisionResponseError = (totpExchangeDecisionResponse401 | totpExchangeDecisionResponse403 | totpExchangeDecisionResponse409 | totpExchangeDecisionResponse410) & {
  headers: Headers;
};

export type totpExchangeDecisionResponse = (totpExchangeDecisionResponseSuccess | totpExchangeDecisionResponseError)

export const getTotpExchangeDecisionUrl = (id: number,) => {




  return `/api/v1/totp-exchange/${id}/decision/`
}

/**
 * Decyzja drugiego superadmina (R12): zatwierdzenie = atomowa podmiana (R5).
 */
export const totpExchangeDecision = async (id: number,
    totpExchangeDecisionRequest: TotpExchangeDecisionRequest, options?: RequestInit): Promise<totpExchangeDecisionResponse> => {

  return customFetch<totpExchangeDecisionResponse>(getTotpExchangeDecisionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(totpExchangeDecisionRequest)
  }
);}




export const getTotpExchangeDecisionMutationOptions = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof totpExchangeDecision>>, TError,{id: number;data: TotpExchangeDecisionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof totpExchangeDecision>>, TError,{id: number;data: TotpExchangeDecisionRequest}, TContext> => {

const mutationKey = ['totpExchangeDecision'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof totpExchangeDecision>>, {id: number;data: TotpExchangeDecisionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  totpExchangeDecision(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TotpExchangeDecisionMutationResult = NonNullable<Awaited<ReturnType<typeof totpExchangeDecision>>>
    export type TotpExchangeDecisionMutationBody = TotpExchangeDecisionRequest
    export type TotpExchangeDecisionMutationError = UnauthorizedResponse | void | AccountGoneResponse

    export const useTotpExchangeDecision = <TError = UnauthorizedResponse | void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof totpExchangeDecision>>, TError,{id: number;data: TotpExchangeDecisionRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof totpExchangeDecision>>,
        TError,
        {id: number;data: TotpExchangeDecisionRequest},
        TContext
      > => {
      return useMutation(getTotpExchangeDecisionMutationOptions(options), queryClient);
    }

export type totpExchangeStartResponse200 = {
  data: TotpExchangeSecret
  status: 200
}

export type totpExchangeStartResponse400 = {
  data: void
  status: 400
}

export type totpExchangeStartResponse401 = {
  data: void
  status: 401
}

export type totpExchangeStartResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type totpExchangeStartResponseSuccess = (totpExchangeStartResponse200) & {
  headers: Headers;
};
export type totpExchangeStartResponseError = (totpExchangeStartResponse400 | totpExchangeStartResponse401 | totpExchangeStartResponse410) & {
  headers: Headers;
};

export type totpExchangeStartResponse = (totpExchangeStartResponseSuccess | totpExchangeStartResponseError)

export const getTotpExchangeStartUrl = () => {




  return `/api/v1/totp-exchange/start/`
}

/**
 * Re-autoryzacja hasłem (R1, limit 5 → unieważnienie sesji R9) i wydanie
 * świeżego, niezatwierdzonego sekretu (każde wejście = nowy sekret, R6).
 */
export const totpExchangeStart = async (totpExchangeStartRequest?: TotpExchangeStartRequest, options?: RequestInit): Promise<totpExchangeStartResponse> => {

  return customFetch<totpExchangeStartResponse>(getTotpExchangeStartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(totpExchangeStartRequest)
  }
);}




export const getTotpExchangeStartMutationOptions = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof totpExchangeStart>>, TError,{data?: TotpExchangeStartRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof totpExchangeStart>>, TError,{data?: TotpExchangeStartRequest}, TContext> => {

const mutationKey = ['totpExchangeStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof totpExchangeStart>>, {data?: TotpExchangeStartRequest}> = (props) => {
          const {data} = props ?? {};

          return  totpExchangeStart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TotpExchangeStartMutationResult = NonNullable<Awaited<ReturnType<typeof totpExchangeStart>>>
    export type TotpExchangeStartMutationBody = TotpExchangeStartRequest | undefined
    export type TotpExchangeStartMutationError = void | AccountGoneResponse

    export const useTotpExchangeStart = <TError = void | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof totpExchangeStart>>, TError,{data?: TotpExchangeStartRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof totpExchangeStart>>,
        TError,
        {data?: TotpExchangeStartRequest},
        TContext
      > => {
      return useMutation(getTotpExchangeStartMutationOptions(options), queryClient);
    }

export type totpExchangeVerifyResponse201 = {
  data: TotpExchangeRequest
  status: 201
}

export type totpExchangeVerifyResponse400 = {
  data: void
  status: 400
}

export type totpExchangeVerifyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type totpExchangeVerifyResponse409 = {
  data: void
  status: 409
}

export type totpExchangeVerifyResponse410 = {
  data: AccountGoneResponse
  status: 410
}

export type totpExchangeVerifyResponseSuccess = (totpExchangeVerifyResponse201) & {
  headers: Headers;
};
export type totpExchangeVerifyResponseError = (totpExchangeVerifyResponse400 | totpExchangeVerifyResponse401 | totpExchangeVerifyResponse409 | totpExchangeVerifyResponse410) & {
  headers: Headers;
};

export type totpExchangeVerifyResponse = (totpExchangeVerifyResponseSuccess | totpExchangeVerifyResponseError)

export const getTotpExchangeVerifyUrl = () => {




  return `/api/v1/totp-exchange/verify/`
}

/**
 * Weryfikacja kodu z nowej aplikacji → żądanie zatwierdzenia (R12).
 */
export const totpExchangeVerify = async (totpExchangeVerifyRequest: TotpExchangeVerifyRequest, options?: RequestInit): Promise<totpExchangeVerifyResponse> => {

  return customFetch<totpExchangeVerifyResponse>(getTotpExchangeVerifyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(totpExchangeVerifyRequest)
  }
);}




export const getTotpExchangeVerifyMutationOptions = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof totpExchangeVerify>>, TError,{data: TotpExchangeVerifyRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof totpExchangeVerify>>, TError,{data: TotpExchangeVerifyRequest}, TContext> => {

const mutationKey = ['totpExchangeVerify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof totpExchangeVerify>>, {data: TotpExchangeVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  totpExchangeVerify(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TotpExchangeVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof totpExchangeVerify>>>
    export type TotpExchangeVerifyMutationBody = TotpExchangeVerifyRequest
    export type TotpExchangeVerifyMutationError = void | UnauthorizedResponse | AccountGoneResponse

    export const useTotpExchangeVerify = <TError = void | UnauthorizedResponse | AccountGoneResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof totpExchangeVerify>>, TError,{data: TotpExchangeVerifyRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof totpExchangeVerify>>,
        TError,
        {data: TotpExchangeVerifyRequest},
        TContext
      > => {
      return useMutation(getTotpExchangeVerifyMutationOptions(options), queryClient);
    }

export type authPasswordChangeRequiredResponse200 = {
  data: AllauthAuthEnvelope
  status: 200
}

export type authPasswordChangeRequiredResponse400 = {
  data: AllauthAuthEnvelope
  status: 400
}

export type authPasswordChangeRequiredResponse401 = {
  data: AllauthAuthEnvelope
  status: 401
}

export type authPasswordChangeRequiredResponseSuccess = (authPasswordChangeRequiredResponse200) & {
  headers: Headers;
};
export type authPasswordChangeRequiredResponseError = (authPasswordChangeRequiredResponse400 | authPasswordChangeRequiredResponse401) & {
  headers: Headers;
};

export type authPasswordChangeRequiredResponse = (authPasswordChangeRequiredResponseSuccess | authPasswordChangeRequiredResponseError)

export const getAuthPasswordChangeRequiredUrl = () => {




  return `/_allauth/app/v1/auth/password/change-required`
}

/**
 * Sets a new password during the restricted login session a student lands in at first login (`force_password_change`, TR-801/TR-125). This is a login **stage**, not the regular change-password endpoint: it is reachable only while the `password_change_required` pending flow is active (read it off the login response, not `/api/v1/me/`). On success the stage closes and the login finishes and may next expose `recovery_setup_required`; tokens arrive only after all mandatory stages finish.
 *
 * Hand-written into the schema by a postprocessing hook (`core/schema.py`): the view is mounted directly in `config/urls.py` and is an allauth headless view, not a DRF `APIView`, so drf-spectacular cannot discover it automatically.
 * @summary Finish the forced first-login password change (mobile app client)
 */
export const authPasswordChangeRequired = async (authPasswordChangeRequiredBody: AuthPasswordChangeRequiredBody, options?: RequestInit): Promise<authPasswordChangeRequiredResponse> => {

  return customFetch<authPasswordChangeRequiredResponse>(getAuthPasswordChangeRequiredUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authPasswordChangeRequiredBody)
  }
);}




export const getAuthPasswordChangeRequiredMutationOptions = <TError = AllauthAuthEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authPasswordChangeRequired>>, TError,{data: AuthPasswordChangeRequiredBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authPasswordChangeRequired>>, TError,{data: AuthPasswordChangeRequiredBody}, TContext> => {

const mutationKey = ['authPasswordChangeRequired'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authPasswordChangeRequired>>, {data: AuthPasswordChangeRequiredBody}> = (props) => {
          const {data} = props ?? {};

          return  authPasswordChangeRequired(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthPasswordChangeRequiredMutationResult = NonNullable<Awaited<ReturnType<typeof authPasswordChangeRequired>>>
    export type AuthPasswordChangeRequiredMutationBody = AuthPasswordChangeRequiredBody
    export type AuthPasswordChangeRequiredMutationError = AllauthAuthEnvelope

    /**
 * @summary Finish the forced first-login password change (mobile app client)
 */
export const useAuthPasswordChangeRequired = <TError = AllauthAuthEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authPasswordChangeRequired>>, TError,{data: AuthPasswordChangeRequiredBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authPasswordChangeRequired>>,
        TError,
        {data: AuthPasswordChangeRequiredBody},
        TContext
      > => {
      return useMutation(getAuthPasswordChangeRequiredMutationOptions(options), queryClient);
    }

export type authRecoverySetupRequiredResponse200 = {
  data: AllauthAuthEnvelope
  status: 200
}

export type authRecoverySetupRequiredResponse400 = {
  data: AllauthAuthEnvelope
  status: 400
}

export type authRecoverySetupRequiredResponse401 = {
  data: AllauthAuthEnvelope
  status: 401
}

export type authRecoverySetupRequiredResponseSuccess = (authRecoverySetupRequiredResponse200) & {
  headers: Headers;
};
export type authRecoverySetupRequiredResponseError = (authRecoverySetupRequiredResponse400 | authRecoverySetupRequiredResponse401) & {
  headers: Headers;
};

export type authRecoverySetupRequiredResponse = (authRecoverySetupRequiredResponseSuccess | authRecoverySetupRequiredResponseError)

export const getAuthRecoverySetupRequiredUrl = () => {




  return `/_allauth/app/v1/auth/recovery/setup`
}

/**
 * Completes the `recovery_setup_required` restricted-login stage. The normalized answer is stored only as a password hash. On the final stage, the successful app login also trusts `X-Installation-ID`.
 * @summary Set mandatory student recovery factors and continue mobile login
 */
export const authRecoverySetupRequired = async (authRecoverySetupRequiredBody: AuthRecoverySetupRequiredBody, options?: RequestInit): Promise<authRecoverySetupRequiredResponse> => {

  return customFetch<authRecoverySetupRequiredResponse>(getAuthRecoverySetupRequiredUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authRecoverySetupRequiredBody)
  }
);}




export const getAuthRecoverySetupRequiredMutationOptions = <TError = AllauthAuthEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRecoverySetupRequired>>, TError,{data: AuthRecoverySetupRequiredBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authRecoverySetupRequired>>, TError,{data: AuthRecoverySetupRequiredBody}, TContext> => {

const mutationKey = ['authRecoverySetupRequired'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRecoverySetupRequired>>, {data: AuthRecoverySetupRequiredBody}> = (props) => {
          const {data} = props ?? {};

          return  authRecoverySetupRequired(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthRecoverySetupRequiredMutationResult = NonNullable<Awaited<ReturnType<typeof authRecoverySetupRequired>>>
    export type AuthRecoverySetupRequiredMutationBody = AuthRecoverySetupRequiredBody
    export type AuthRecoverySetupRequiredMutationError = AllauthAuthEnvelope

    /**
 * @summary Set mandatory student recovery factors and continue mobile login
 */
export const useAuthRecoverySetupRequired = <TError = AllauthAuthEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRecoverySetupRequired>>, TError,{data: AuthRecoverySetupRequiredBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRecoverySetupRequired>>,
        TError,
        {data: AuthRecoverySetupRequiredBody},
        TContext
      > => {
      return useMutation(getAuthRecoverySetupRequiredMutationOptions(options), queryClient);
    }

export type auth2faEnrollBeginResponse401 = {
  data: AllauthAuthEnvelope
  status: 401
}

export type auth2faEnrollBeginResponse404 = {
  data: AllauthAuthEnvelope
  status: 404
}

;
export type auth2faEnrollBeginResponseError = (auth2faEnrollBeginResponse401 | auth2faEnrollBeginResponse404) & {
  headers: Headers;
};

export type auth2faEnrollBeginResponse = (auth2faEnrollBeginResponseError)

export const getAuth2faEnrollBeginUrl = () => {




  return `/_allauth/browser/v1/auth/2fa/enroll`
}

/**
 * Issues a fresh, unconfirmed TOTP secret for the restricted login session a superadmin/admin without an authenticator is forced into (TR-111, login stage `mfa_enroll`). Reachable only while that stage is active. Every GET regenerates the secret (R5). The secret + `otpauth://` URL come back in **`meta`** with a `404` status — that 404 is the contract ("no authenticator yet, here is one to enrol"), not an error.
 *
 * Hand-mounted in `config/urls.py` as an allauth headless view (not a DRF `APIView`), so drf-spectacular cannot discover it; injected by a postprocessing hook (`core/schema.py`). Browser client only — there is no `app` variant.
 * @summary Begin forced TOTP enrollment — issue a fresh secret (browser client)
 */
export const auth2faEnrollBegin = async ( options?: RequestInit): Promise<auth2faEnrollBeginResponse> => {

  return customFetch<auth2faEnrollBeginResponse>(getAuth2faEnrollBeginUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuth2faEnrollBeginQueryKey = () => {
    return [
    `/_allauth/browser/v1/auth/2fa/enroll`
    ] as const;
    }


export const getAuth2faEnrollBeginQueryOptions = <TData = Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError = AllauthAuthEnvelope>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuth2faEnrollBeginQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auth2faEnrollBegin>>> = ({ signal }) => auth2faEnrollBegin({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Auth2faEnrollBeginQueryResult = NonNullable<Awaited<ReturnType<typeof auth2faEnrollBegin>>>
export type Auth2faEnrollBeginQueryError = AllauthAuthEnvelope


export function useAuth2faEnrollBegin<TData = Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError = AllauthAuthEnvelope>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auth2faEnrollBegin>>,
          TError,
          Awaited<ReturnType<typeof auth2faEnrollBegin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuth2faEnrollBegin<TData = Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError = AllauthAuthEnvelope>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auth2faEnrollBegin>>,
          TError,
          Awaited<ReturnType<typeof auth2faEnrollBegin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuth2faEnrollBegin<TData = Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError = AllauthAuthEnvelope>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Begin forced TOTP enrollment — issue a fresh secret (browser client)
 */

export function useAuth2faEnrollBegin<TData = Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError = AllauthAuthEnvelope>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth2faEnrollBegin>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuth2faEnrollBeginQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type auth2faEnrollActivateResponse200 = {
  data: AllauthAuthEnvelope
  status: 200
}

export type auth2faEnrollActivateResponse400 = {
  data: AllauthAuthEnvelope
  status: 400
}

export type auth2faEnrollActivateResponse401 = {
  data: AllauthAuthEnvelope
  status: 401
}

export type auth2faEnrollActivateResponseSuccess = (auth2faEnrollActivateResponse200) & {
  headers: Headers;
};
export type auth2faEnrollActivateResponseError = (auth2faEnrollActivateResponse400 | auth2faEnrollActivateResponse401) & {
  headers: Headers;
};

export type auth2faEnrollActivateResponse = (auth2faEnrollActivateResponseSuccess | auth2faEnrollActivateResponseError)

export const getAuth2faEnrollActivateUrl = () => {




  return `/_allauth/browser/v1/auth/2fa/enroll`
}

/**
 * Confirms enrollment by verifying a code against the secret issued by the GET above. On success the authenticator is created, the `mfa_enroll` stage closes, and the login finishes.
 * @summary Activate TOTP with a code and finish the login stage (browser client)
 */
export const auth2faEnrollActivate = async (auth2faEnrollActivateBody: Auth2faEnrollActivateBody, options?: RequestInit): Promise<auth2faEnrollActivateResponse> => {

  return customFetch<auth2faEnrollActivateResponse>(getAuth2faEnrollActivateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(auth2faEnrollActivateBody)
  }
);}




export const getAuth2faEnrollActivateMutationOptions = <TError = AllauthAuthEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof auth2faEnrollActivate>>, TError,{data: Auth2faEnrollActivateBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof auth2faEnrollActivate>>, TError,{data: Auth2faEnrollActivateBody}, TContext> => {

const mutationKey = ['auth2faEnrollActivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof auth2faEnrollActivate>>, {data: Auth2faEnrollActivateBody}> = (props) => {
          const {data} = props ?? {};

          return  auth2faEnrollActivate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Auth2faEnrollActivateMutationResult = NonNullable<Awaited<ReturnType<typeof auth2faEnrollActivate>>>
    export type Auth2faEnrollActivateMutationBody = Auth2faEnrollActivateBody
    export type Auth2faEnrollActivateMutationError = AllauthAuthEnvelope

    /**
 * @summary Activate TOTP with a code and finish the login stage (browser client)
 */
export const useAuth2faEnrollActivate = <TError = AllauthAuthEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof auth2faEnrollActivate>>, TError,{data: Auth2faEnrollActivateBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof auth2faEnrollActivate>>,
        TError,
        {data: Auth2faEnrollActivateBody},
        TContext
      > => {
      return useMutation(getAuth2faEnrollActivateMutationOptions(options), queryClient);
    }

export type allauthAuthLoginPostResponse200 = {
  data: AllauthAuthenticatedByPasswordResponse
  status: 200
}

export type allauthAuthLoginPostResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthAuthLoginPostResponse401 = {
  data: AllauthAuthenticationResponse
  status: 401
}

export type allauthAuthLoginPostResponse409 = {
  data: AllauthConflictResponse
  status: 409
}

export type allauthAuthLoginPostResponseSuccess = (allauthAuthLoginPostResponse200) & {
  headers: Headers;
};
export type allauthAuthLoginPostResponseError = (allauthAuthLoginPostResponse400 | allauthAuthLoginPostResponse401 | allauthAuthLoginPostResponse409) & {
  headers: Headers;
};

export type allauthAuthLoginPostResponse = (allauthAuthLoginPostResponseSuccess | allauthAuthLoginPostResponseError)

export const getAllauthAuthLoginPostUrl = () => {




  return `/_allauth/app/v1/auth/login`
}

/**
 * Login using a username-password or email-password combination.
 * @summary Login
 */
export const allauthAuthLoginPost = async (allauthLoginBody: AllauthLoginBody, options?: RequestInit): Promise<allauthAuthLoginPostResponse> => {

  return customFetch<allauthAuthLoginPostResponse>(getAllauthAuthLoginPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allauthLoginBody)
  }
);}




export const getAllauthAuthLoginPostMutationOptions = <TError = AllauthErrorResponse | AllauthAuthenticationResponse | AllauthConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthLoginPost>>, TError,{data: AllauthLoginBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthAuthLoginPost>>, TError,{data: AllauthLoginBody}, TContext> => {

const mutationKey = ['allauthAuthLoginPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAuthLoginPost>>, {data: AllauthLoginBody}> = (props) => {
          const {data} = props ?? {};

          return  allauthAuthLoginPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthAuthLoginPostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAuthLoginPost>>>
    export type AllauthAuthLoginPostMutationBody = AllauthLoginBody
    export type AllauthAuthLoginPostMutationError = AllauthErrorResponse | AllauthAuthenticationResponse | AllauthConflictResponse

    /**
 * @summary Login
 */
export const useAllauthAuthLoginPost = <TError = AllauthErrorResponse | AllauthAuthenticationResponse | AllauthConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthLoginPost>>, TError,{data: AllauthLoginBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthAuthLoginPost>>,
        TError,
        {data: AllauthLoginBody},
        TContext
      > => {
      return useMutation(getAllauthAuthLoginPostMutationOptions(options), queryClient);
    }

export type allauthAuthSessionGetResponse200 = {
  data: AllauthAuthenticatedResponse
  status: 200
}

export type allauthAuthSessionGetResponse401 = {
  data: AllauthAuthenticationResponse
  status: 401
}

export type allauthAuthSessionGetResponse410 = {
  data: AllauthSessionGoneResponse
  status: 410
}

export type allauthAuthSessionGetResponseSuccess = (allauthAuthSessionGetResponse200) & {
  headers: Headers;
};
export type allauthAuthSessionGetResponseError = (allauthAuthSessionGetResponse401 | allauthAuthSessionGetResponse410) & {
  headers: Headers;
};

export type allauthAuthSessionGetResponse = (allauthAuthSessionGetResponseSuccess | allauthAuthSessionGetResponseError)

export const getAllauthAuthSessionGetUrl = () => {




  return `/_allauth/app/v1/auth/session`
}

/**
 * Retrieve information about the authentication status for the current
 * session.
 * @summary Get authentication status

 */
export const allauthAuthSessionGet = async ( options?: RequestInit): Promise<allauthAuthSessionGetResponse> => {

  return customFetch<allauthAuthSessionGetResponse>(getAllauthAuthSessionGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllauthAuthSessionGetQueryKey = () => {
    return [
    `/_allauth/app/v1/auth/session`
    ] as const;
    }


export const getAllauthAuthSessionGetQueryOptions = <TData = Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError = AllauthAuthenticationResponse | AllauthSessionGoneResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllauthAuthSessionGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAuthSessionGet>>> = ({ signal }) => allauthAuthSessionGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllauthAuthSessionGetQueryResult = NonNullable<Awaited<ReturnType<typeof allauthAuthSessionGet>>>
export type AllauthAuthSessionGetQueryError = AllauthAuthenticationResponse | AllauthSessionGoneResponse


export function useAllauthAuthSessionGet<TData = Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError = AllauthAuthenticationResponse | AllauthSessionGoneResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allauthAuthSessionGet>>,
          TError,
          Awaited<ReturnType<typeof allauthAuthSessionGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllauthAuthSessionGet<TData = Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError = AllauthAuthenticationResponse | AllauthSessionGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allauthAuthSessionGet>>,
          TError,
          Awaited<ReturnType<typeof allauthAuthSessionGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllauthAuthSessionGet<TData = Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError = AllauthAuthenticationResponse | AllauthSessionGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get authentication status

 */

export function useAllauthAuthSessionGet<TData = Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError = AllauthAuthenticationResponse | AllauthSessionGoneResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthSessionGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllauthAuthSessionGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type allauthAuthSessionDeleteResponse401 = {
  data: AllauthUnauthenticatedResponse
  status: 401
}

;
export type allauthAuthSessionDeleteResponseError = (allauthAuthSessionDeleteResponse401) & {
  headers: Headers;
};

export type allauthAuthSessionDeleteResponse = (allauthAuthSessionDeleteResponseError)

export const getAllauthAuthSessionDeleteUrl = () => {




  return `/_allauth/app/v1/auth/session`
}

/**
 * Logs out the user from the current session.
 * @summary Logout
 */
export const allauthAuthSessionDelete = async ( options?: RequestInit): Promise<allauthAuthSessionDeleteResponse> => {

  return customFetch<allauthAuthSessionDeleteResponse>(getAllauthAuthSessionDeleteUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAllauthAuthSessionDeleteMutationOptions = <TError = AllauthUnauthenticatedResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthSessionDelete>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthAuthSessionDelete>>, TError,void, TContext> => {

const mutationKey = ['allauthAuthSessionDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAuthSessionDelete>>, void> = () => {


          return  allauthAuthSessionDelete(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthAuthSessionDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAuthSessionDelete>>>

    export type AllauthAuthSessionDeleteMutationError = AllauthUnauthenticatedResponse

    /**
 * @summary Logout
 */
export const useAllauthAuthSessionDelete = <TError = AllauthUnauthenticatedResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthSessionDelete>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthAuthSessionDelete>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAllauthAuthSessionDeleteMutationOptions(options), queryClient);
    }

export type allauthConfigGetResponse200 = {
  data: AllauthConfigurationResponse
  status: 200
}

export type allauthConfigGetResponseSuccess = (allauthConfigGetResponse200) & {
  headers: Headers;
};
;

export type allauthConfigGetResponse = (allauthConfigGetResponseSuccess)

export const getAllauthConfigGetUrl = () => {




  return `/_allauth/app/v1/config`
}

/**
 * There are many configuration options that alter the functionality
 * and behavior of django-allauth, some of which can also impact the
 * frontend. Therefore, relevant configuration options are exposed via
 * this endpoint. The data returned is not user/authentication
 * dependent. Hence, it suffices to only fetch this data once at boot
 * time of your application.
 * @summary Get configuration
 */
export const allauthConfigGet = async ( options?: RequestInit): Promise<allauthConfigGetResponse> => {

  return customFetch<allauthConfigGetResponse>(getAllauthConfigGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllauthConfigGetQueryKey = () => {
    return [
    `/_allauth/app/v1/config`
    ] as const;
    }


export const getAllauthConfigGetQueryOptions = <TData = Awaited<ReturnType<typeof allauthConfigGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthConfigGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllauthConfigGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthConfigGet>>> = ({ signal }) => allauthConfigGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allauthConfigGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllauthConfigGetQueryResult = NonNullable<Awaited<ReturnType<typeof allauthConfigGet>>>
export type AllauthConfigGetQueryError = unknown


export function useAllauthConfigGet<TData = Awaited<ReturnType<typeof allauthConfigGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthConfigGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allauthConfigGet>>,
          TError,
          Awaited<ReturnType<typeof allauthConfigGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllauthConfigGet<TData = Awaited<ReturnType<typeof allauthConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthConfigGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allauthConfigGet>>,
          TError,
          Awaited<ReturnType<typeof allauthConfigGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllauthConfigGet<TData = Awaited<ReturnType<typeof allauthConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthConfigGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get configuration
 */

export function useAllauthConfigGet<TData = Awaited<ReturnType<typeof allauthConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthConfigGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllauthConfigGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type allauthAuth2faAuthenticatePostResponse200 = {
  data: AllauthAuthenticatedByPasswordAnd2FAResponse
  status: 200
}

export type allauthAuth2faAuthenticatePostResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthAuth2faAuthenticatePostResponse401 = {
  data: AllauthAuthenticationResponse
  status: 401
}

export type allauthAuth2faAuthenticatePostResponseSuccess = (allauthAuth2faAuthenticatePostResponse200) & {
  headers: Headers;
};
export type allauthAuth2faAuthenticatePostResponseError = (allauthAuth2faAuthenticatePostResponse400 | allauthAuth2faAuthenticatePostResponse401) & {
  headers: Headers;
};

export type allauthAuth2faAuthenticatePostResponse = (allauthAuth2faAuthenticatePostResponseSuccess | allauthAuth2faAuthenticatePostResponseError)

export const getAllauthAuth2faAuthenticatePostUrl = () => {




  return `/_allauth/app/v1/auth/2fa/authenticate`
}

/**
 * If, during authentication,  a response with status 401 is encountered where one of the pending
 * flows has ID `mfa_authenticate`, that indicates that the Two-Factor Authentication stage needs to
 * be completed.
 * @summary Two-factor authentication
 */
export const allauthAuth2faAuthenticatePost = async (allauthMFAAuthenticateBody: AllauthMFAAuthenticateBody, options?: RequestInit): Promise<allauthAuth2faAuthenticatePostResponse> => {

  return customFetch<allauthAuth2faAuthenticatePostResponse>(getAllauthAuth2faAuthenticatePostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allauthMFAAuthenticateBody)
  }
);}




export const getAllauthAuth2faAuthenticatePostMutationOptions = <TError = AllauthErrorResponse | AllauthAuthenticationResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuth2faAuthenticatePost>>, TError,{data: AllauthMFAAuthenticateBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthAuth2faAuthenticatePost>>, TError,{data: AllauthMFAAuthenticateBody}, TContext> => {

const mutationKey = ['allauthAuth2faAuthenticatePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAuth2faAuthenticatePost>>, {data: AllauthMFAAuthenticateBody}> = (props) => {
          const {data} = props ?? {};

          return  allauthAuth2faAuthenticatePost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthAuth2faAuthenticatePostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAuth2faAuthenticatePost>>>
    export type AllauthAuth2faAuthenticatePostMutationBody = AllauthMFAAuthenticateBody
    export type AllauthAuth2faAuthenticatePostMutationError = AllauthErrorResponse | AllauthAuthenticationResponse

    /**
 * @summary Two-factor authentication
 */
export const useAllauthAuth2faAuthenticatePost = <TError = AllauthErrorResponse | AllauthAuthenticationResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuth2faAuthenticatePost>>, TError,{data: AllauthMFAAuthenticateBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthAuth2faAuthenticatePost>>,
        TError,
        {data: AllauthMFAAuthenticateBody},
        TContext
      > => {
      return useMutation(getAllauthAuth2faAuthenticatePostMutationOptions(options), queryClient);
    }

export type allauthAuthReauthenticatePostResponse200 = {
  data: AllauthAuthenticatedByPasswordResponse
  status: 200
}

export type allauthAuthReauthenticatePostResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthAuthReauthenticatePostResponseSuccess = (allauthAuthReauthenticatePostResponse200) & {
  headers: Headers;
};
export type allauthAuthReauthenticatePostResponseError = (allauthAuthReauthenticatePostResponse400) & {
  headers: Headers;
};

export type allauthAuthReauthenticatePostResponse = (allauthAuthReauthenticatePostResponseSuccess | allauthAuthReauthenticatePostResponseError)

export const getAllauthAuthReauthenticatePostUrl = () => {




  return `/_allauth/app/v1/auth/reauthenticate`
}

/**
 * In order to safeguard the account, some actions require the user to be
 * recently authenticated.  If you try to perform such an action without
 * having been recently authenticated, a `401` status is returned, listing
 * flows that can be performed to reauthenticate. One such flow is the flow
 * with ID `reauthenticate`, which allows for the user to input the
 * password. This is the endpoint related towards that flow.
 * @summary Reauthenticate
 */
export const allauthAuthReauthenticatePost = async (allauthReauthenticateBody: AllauthReauthenticateBody, options?: RequestInit): Promise<allauthAuthReauthenticatePostResponse> => {

  return customFetch<allauthAuthReauthenticatePostResponse>(getAllauthAuthReauthenticatePostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allauthReauthenticateBody)
  }
);}




export const getAllauthAuthReauthenticatePostMutationOptions = <TError = AllauthErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthReauthenticatePost>>, TError,{data: AllauthReauthenticateBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthAuthReauthenticatePost>>, TError,{data: AllauthReauthenticateBody}, TContext> => {

const mutationKey = ['allauthAuthReauthenticatePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAuthReauthenticatePost>>, {data: AllauthReauthenticateBody}> = (props) => {
          const {data} = props ?? {};

          return  allauthAuthReauthenticatePost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthAuthReauthenticatePostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAuthReauthenticatePost>>>
    export type AllauthAuthReauthenticatePostMutationBody = AllauthReauthenticateBody
    export type AllauthAuthReauthenticatePostMutationError = AllauthErrorResponse

    /**
 * @summary Reauthenticate
 */
export const useAllauthAuthReauthenticatePost = <TError = AllauthErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthReauthenticatePost>>, TError,{data: AllauthReauthenticateBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthAuthReauthenticatePost>>,
        TError,
        {data: AllauthReauthenticateBody},
        TContext
      > => {
      return useMutation(getAllauthAuthReauthenticatePostMutationOptions(options), queryClient);
    }

export type allauthAuth2faReauthenticatePostResponse200 = {
  data: AllauthAuthenticatedByPasswordAnd2FAResponse
  status: 200
}

export type allauthAuth2faReauthenticatePostResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthAuth2faReauthenticatePostResponseSuccess = (allauthAuth2faReauthenticatePostResponse200) & {
  headers: Headers;
};
export type allauthAuth2faReauthenticatePostResponseError = (allauthAuth2faReauthenticatePostResponse400) & {
  headers: Headers;
};

export type allauthAuth2faReauthenticatePostResponse = (allauthAuth2faReauthenticatePostResponseSuccess | allauthAuth2faReauthenticatePostResponseError)

export const getAllauthAuth2faReauthenticatePostUrl = () => {




  return `/_allauth/app/v1/auth/2fa/reauthenticate`
}

/**
 * In order to safeguard the account, some actions require the user to be
 * recently authenticated.  If you try to perform such an action without
 * having been recently authenticated, a `401` status is returned, listing
 * flows that can be performed to reauthenticate. One such flow is the flow
 * with ID `mfa_reauthenticate`, which allows for the user to input an
 * authenticator code (e.g. TOTP or recovery code). This is the endpoint
 * related towards that flow.
 * @summary Reauthenticate using 2FA
 */
export const allauthAuth2faReauthenticatePost = async (allauthMFAAuthenticateBody: AllauthMFAAuthenticateBody, options?: RequestInit): Promise<allauthAuth2faReauthenticatePostResponse> => {

  return customFetch<allauthAuth2faReauthenticatePostResponse>(getAllauthAuth2faReauthenticatePostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allauthMFAAuthenticateBody)
  }
);}




export const getAllauthAuth2faReauthenticatePostMutationOptions = <TError = AllauthErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuth2faReauthenticatePost>>, TError,{data: AllauthMFAAuthenticateBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthAuth2faReauthenticatePost>>, TError,{data: AllauthMFAAuthenticateBody}, TContext> => {

const mutationKey = ['allauthAuth2faReauthenticatePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAuth2faReauthenticatePost>>, {data: AllauthMFAAuthenticateBody}> = (props) => {
          const {data} = props ?? {};

          return  allauthAuth2faReauthenticatePost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthAuth2faReauthenticatePostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAuth2faReauthenticatePost>>>
    export type AllauthAuth2faReauthenticatePostMutationBody = AllauthMFAAuthenticateBody
    export type AllauthAuth2faReauthenticatePostMutationError = AllauthErrorResponse

    /**
 * @summary Reauthenticate using 2FA
 */
export const useAllauthAuth2faReauthenticatePost = <TError = AllauthErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuth2faReauthenticatePost>>, TError,{data: AllauthMFAAuthenticateBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthAuth2faReauthenticatePost>>,
        TError,
        {data: AllauthMFAAuthenticateBody},
        TContext
      > => {
      return useMutation(getAllauthAuth2faReauthenticatePostMutationOptions(options), queryClient);
    }

export type allauthAuthPasswordRequestPostResponse200 = {
  data: AllauthStatusOKResponse
  status: 200
}

export type allauthAuthPasswordRequestPostResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthAuthPasswordRequestPostResponse401 = {
  data: AllauthAuthenticationResponse
  status: 401
}

export type allauthAuthPasswordRequestPostResponseSuccess = (allauthAuthPasswordRequestPostResponse200) & {
  headers: Headers;
};
export type allauthAuthPasswordRequestPostResponseError = (allauthAuthPasswordRequestPostResponse400 | allauthAuthPasswordRequestPostResponse401) & {
  headers: Headers;
};

export type allauthAuthPasswordRequestPostResponse = (allauthAuthPasswordRequestPostResponseSuccess | allauthAuthPasswordRequestPostResponseError)

export const getAllauthAuthPasswordRequestPostUrl = () => {




  return `/_allauth/app/v1/auth/password/request`
}

/**
 * Initiates the password reset procedure. Depending on whether or not
 * `ACCOUNT_PASSWORD_RESET_BY_CODE_ENABLED` is `True`, the procedure is
 * either stateless or stateful.
 *
 * In case codes are used, it is stateful, and a new
 * `password_reset_by_code` flow is started. In this case, on a successful
 * password reset request, you will receive a 401 indicating the pending
 * status of this flow.
 *
 * In case password reset is configured to use (stateless) links, you will
 * receive a 200 on a successful password reset request.
 * @summary Request password
 */
export const allauthAuthPasswordRequestPost = async (allauthRequestPasswordBody: AllauthRequestPasswordBody, options?: RequestInit): Promise<allauthAuthPasswordRequestPostResponse> => {

  return customFetch<allauthAuthPasswordRequestPostResponse>(getAllauthAuthPasswordRequestPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allauthRequestPasswordBody)
  }
);}




export const getAllauthAuthPasswordRequestPostMutationOptions = <TError = AllauthErrorResponse | AllauthAuthenticationResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthPasswordRequestPost>>, TError,{data: AllauthRequestPasswordBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthAuthPasswordRequestPost>>, TError,{data: AllauthRequestPasswordBody}, TContext> => {

const mutationKey = ['allauthAuthPasswordRequestPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAuthPasswordRequestPost>>, {data: AllauthRequestPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  allauthAuthPasswordRequestPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthAuthPasswordRequestPostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAuthPasswordRequestPost>>>
    export type AllauthAuthPasswordRequestPostMutationBody = AllauthRequestPasswordBody
    export type AllauthAuthPasswordRequestPostMutationError = AllauthErrorResponse | AllauthAuthenticationResponse

    /**
 * @summary Request password
 */
export const useAllauthAuthPasswordRequestPost = <TError = AllauthErrorResponse | AllauthAuthenticationResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthPasswordRequestPost>>, TError,{data: AllauthRequestPasswordBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthAuthPasswordRequestPost>>,
        TError,
        {data: AllauthRequestPasswordBody},
        TContext
      > => {
      return useMutation(getAllauthAuthPasswordRequestPostMutationOptions(options), queryClient);
    }

export type allauthAuthPasswordResetGetResponse200 = {
  data: AllauthPasswordResetInfoResponse
  status: 200
}

export type allauthAuthPasswordResetGetResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthAuthPasswordResetGetResponse409 = {
  data: AllauthConflictResponse
  status: 409
}

export type allauthAuthPasswordResetGetResponseSuccess = (allauthAuthPasswordResetGetResponse200) & {
  headers: Headers;
};
export type allauthAuthPasswordResetGetResponseError = (allauthAuthPasswordResetGetResponse400 | allauthAuthPasswordResetGetResponse409) & {
  headers: Headers;
};

export type allauthAuthPasswordResetGetResponse = (allauthAuthPasswordResetGetResponseSuccess | allauthAuthPasswordResetGetResponseError)

export const getAllauthAuthPasswordResetGetUrl = () => {




  return `/_allauth/app/v1/auth/password/reset`
}

/**
 * Used to obtain information on and validate a password reset key.  The
 * key passed is either the key encoded in the password reset URL that the
 * user has received per email, or, the password reset code in case of
 * `ACCOUNT_PASSWORD_RESET_BY_CODE_ENABLED`. Note that in case of a code,
 * the number of requests you can make is limited (by
 * `ACCOUNT_PASSWORD_RESET_BY_CODE_MAX_ATTEMPTS`).
 * @summary Get password reset information
 */
export const allauthAuthPasswordResetGet = async ( options?: RequestInit): Promise<allauthAuthPasswordResetGetResponse> => {

  return customFetch<allauthAuthPasswordResetGetResponse>(getAllauthAuthPasswordResetGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllauthAuthPasswordResetGetQueryKey = () => {
    return [
    `/_allauth/app/v1/auth/password/reset`
    ] as const;
    }


export const getAllauthAuthPasswordResetGetQueryOptions = <TData = Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError = AllauthErrorResponse | AllauthConflictResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllauthAuthPasswordResetGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>> = ({ signal }) => allauthAuthPasswordResetGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllauthAuthPasswordResetGetQueryResult = NonNullable<Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>>
export type AllauthAuthPasswordResetGetQueryError = AllauthErrorResponse | AllauthConflictResponse


export function useAllauthAuthPasswordResetGet<TData = Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError = AllauthErrorResponse | AllauthConflictResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>,
          TError,
          Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllauthAuthPasswordResetGet<TData = Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError = AllauthErrorResponse | AllauthConflictResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>,
          TError,
          Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllauthAuthPasswordResetGet<TData = Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError = AllauthErrorResponse | AllauthConflictResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get password reset information
 */

export function useAllauthAuthPasswordResetGet<TData = Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError = AllauthErrorResponse | AllauthConflictResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthPasswordResetGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllauthAuthPasswordResetGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type allauthAuthPasswordResetPostResponse200 = {
  data: AllauthAuthenticatedByPasswordResponse
  status: 200
}

export type allauthAuthPasswordResetPostResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthAuthPasswordResetPostResponse401 = {
  data: AllauthAuthenticationResponse
  status: 401
}

export type allauthAuthPasswordResetPostResponse409 = {
  data: AllauthConflictResponse
  status: 409
}

export type allauthAuthPasswordResetPostResponseSuccess = (allauthAuthPasswordResetPostResponse200) & {
  headers: Headers;
};
export type allauthAuthPasswordResetPostResponseError = (allauthAuthPasswordResetPostResponse400 | allauthAuthPasswordResetPostResponse401 | allauthAuthPasswordResetPostResponse409) & {
  headers: Headers;
};

export type allauthAuthPasswordResetPostResponse = (allauthAuthPasswordResetPostResponseSuccess | allauthAuthPasswordResetPostResponseError)

export const getAllauthAuthPasswordResetPostUrl = () => {




  return `/_allauth/app/v1/auth/password/reset`
}

/**
 * Perform the password reset, by handing over the password reset key and
 * the new password. After successfully completing the password reset, the
 * user is either logged in (in case `ACCOUNT_LOGIN_ON_PASSWORD_RESET` is
 * `True`), or, the user will need to proceed to the login page.  In case
 * of the former, a `200` status code is returned, in case of the latter a
 * 401.
 * @summary Reset password
 */
export const allauthAuthPasswordResetPost = async (allauthResetPasswordBody?: AllauthResetPasswordBody, options?: RequestInit): Promise<allauthAuthPasswordResetPostResponse> => {

  return customFetch<allauthAuthPasswordResetPostResponse>(getAllauthAuthPasswordResetPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allauthResetPasswordBody)
  }
);}




export const getAllauthAuthPasswordResetPostMutationOptions = <TError = AllauthErrorResponse | AllauthAuthenticationResponse | AllauthConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthPasswordResetPost>>, TError,{data?: AllauthResetPasswordBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthAuthPasswordResetPost>>, TError,{data?: AllauthResetPasswordBody}, TContext> => {

const mutationKey = ['allauthAuthPasswordResetPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAuthPasswordResetPost>>, {data?: AllauthResetPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  allauthAuthPasswordResetPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthAuthPasswordResetPostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAuthPasswordResetPost>>>
    export type AllauthAuthPasswordResetPostMutationBody = AllauthResetPasswordBody | undefined
    export type AllauthAuthPasswordResetPostMutationError = AllauthErrorResponse | AllauthAuthenticationResponse | AllauthConflictResponse

    /**
 * @summary Reset password
 */
export const useAllauthAuthPasswordResetPost = <TError = AllauthErrorResponse | AllauthAuthenticationResponse | AllauthConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthPasswordResetPost>>, TError,{data?: AllauthResetPasswordBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthAuthPasswordResetPost>>,
        TError,
        {data?: AllauthResetPasswordBody},
        TContext
      > => {
      return useMutation(getAllauthAuthPasswordResetPostMutationOptions(options), queryClient);
    }

export type allauthAuthSignupPostResponse200 = {
  data: AllauthAuthenticatedByPasswordResponse
  status: 200
}

export type allauthAuthSignupPostResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthAuthSignupPostResponse401 = {
  data: AllauthAuthenticationResponse
  status: 401
}

export type allauthAuthSignupPostResponse403 = {
  data: AllauthForbiddenResponse
  status: 403
}

export type allauthAuthSignupPostResponse409 = {
  data: AllauthConflictResponse
  status: 409
}

export type allauthAuthSignupPostResponseSuccess = (allauthAuthSignupPostResponse200) & {
  headers: Headers;
};
export type allauthAuthSignupPostResponseError = (allauthAuthSignupPostResponse400 | allauthAuthSignupPostResponse401 | allauthAuthSignupPostResponse403 | allauthAuthSignupPostResponse409) & {
  headers: Headers;
};

export type allauthAuthSignupPostResponse = (allauthAuthSignupPostResponseSuccess | allauthAuthSignupPostResponseError)

export const getAllauthAuthSignupPostUrl = () => {




  return `/_allauth/app/v1/auth/signup`
}

/**
 * Whether or not `username`, `email`, `phone` or combination of those are
 * required depends on the configuration of django-allauth. Additionally,
 * if a custom signup form is used there may be other custom properties
 * required.
 * @summary Signup
 */
export const allauthAuthSignupPost = async (allauthSignupBody: AllauthSignupBody, options?: RequestInit): Promise<allauthAuthSignupPostResponse> => {

  return customFetch<allauthAuthSignupPostResponse>(getAllauthAuthSignupPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allauthSignupBody)
  }
);}




export const getAllauthAuthSignupPostMutationOptions = <TError = AllauthErrorResponse | AllauthAuthenticationResponse | AllauthForbiddenResponse | AllauthConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthSignupPost>>, TError,{data: AllauthSignupBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthAuthSignupPost>>, TError,{data: AllauthSignupBody}, TContext> => {

const mutationKey = ['allauthAuthSignupPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAuthSignupPost>>, {data: AllauthSignupBody}> = (props) => {
          const {data} = props ?? {};

          return  allauthAuthSignupPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthAuthSignupPostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAuthSignupPost>>>
    export type AllauthAuthSignupPostMutationBody = AllauthSignupBody
    export type AllauthAuthSignupPostMutationError = AllauthErrorResponse | AllauthAuthenticationResponse | AllauthForbiddenResponse | AllauthConflictResponse

    /**
 * @summary Signup
 */
export const useAllauthAuthSignupPost = <TError = AllauthErrorResponse | AllauthAuthenticationResponse | AllauthForbiddenResponse | AllauthConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthSignupPost>>, TError,{data: AllauthSignupBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthAuthSignupPost>>,
        TError,
        {data: AllauthSignupBody},
        TContext
      > => {
      return useMutation(getAllauthAuthSignupPostMutationOptions(options), queryClient);
    }

export type allauthAuthEmailVerifyGetResponse200 = {
  data: AllauthEmailVerificationInfoResponse
  status: 200
}

export type allauthAuthEmailVerifyGetResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthAuthEmailVerifyGetResponse409 = {
  data: AllauthConflictResponse
  status: 409
}

export type allauthAuthEmailVerifyGetResponseSuccess = (allauthAuthEmailVerifyGetResponse200) & {
  headers: Headers;
};
export type allauthAuthEmailVerifyGetResponseError = (allauthAuthEmailVerifyGetResponse400 | allauthAuthEmailVerifyGetResponse409) & {
  headers: Headers;
};

export type allauthAuthEmailVerifyGetResponse = (allauthAuthEmailVerifyGetResponseSuccess | allauthAuthEmailVerifyGetResponseError)

export const getAllauthAuthEmailVerifyGetUrl = () => {




  return `/_allauth/app/v1/auth/email/verify`
}

/**
 * Obtain email verification information, given the token that was sent to
 * the user by email.
 * @summary Get email verification information
 */
export const allauthAuthEmailVerifyGet = async ( options?: RequestInit): Promise<allauthAuthEmailVerifyGetResponse> => {

  return customFetch<allauthAuthEmailVerifyGetResponse>(getAllauthAuthEmailVerifyGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllauthAuthEmailVerifyGetQueryKey = () => {
    return [
    `/_allauth/app/v1/auth/email/verify`
    ] as const;
    }


export const getAllauthAuthEmailVerifyGetQueryOptions = <TData = Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError = AllauthErrorResponse | AllauthConflictResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllauthAuthEmailVerifyGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>> = ({ signal }) => allauthAuthEmailVerifyGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllauthAuthEmailVerifyGetQueryResult = NonNullable<Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>>
export type AllauthAuthEmailVerifyGetQueryError = AllauthErrorResponse | AllauthConflictResponse


export function useAllauthAuthEmailVerifyGet<TData = Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError = AllauthErrorResponse | AllauthConflictResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>,
          TError,
          Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllauthAuthEmailVerifyGet<TData = Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError = AllauthErrorResponse | AllauthConflictResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>,
          TError,
          Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllauthAuthEmailVerifyGet<TData = Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError = AllauthErrorResponse | AllauthConflictResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get email verification information
 */

export function useAllauthAuthEmailVerifyGet<TData = Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError = AllauthErrorResponse | AllauthConflictResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllauthAuthEmailVerifyGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type allauthAuthEmailVerifyPostResponse200 = {
  data: AllauthAuthenticatedResponse
  status: 200
}

export type allauthAuthEmailVerifyPostResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthAuthEmailVerifyPostResponse401 = {
  data: AllauthUnauthenticatedResponse
  status: 401
}

export type allauthAuthEmailVerifyPostResponse409 = {
  data: AllauthConflictResponse
  status: 409
}

export type allauthAuthEmailVerifyPostResponseSuccess = (allauthAuthEmailVerifyPostResponse200) & {
  headers: Headers;
};
export type allauthAuthEmailVerifyPostResponseError = (allauthAuthEmailVerifyPostResponse400 | allauthAuthEmailVerifyPostResponse401 | allauthAuthEmailVerifyPostResponse409) & {
  headers: Headers;
};

export type allauthAuthEmailVerifyPostResponse = (allauthAuthEmailVerifyPostResponseSuccess | allauthAuthEmailVerifyPostResponseError)

export const getAllauthAuthEmailVerifyPostUrl = () => {




  return `/_allauth/app/v1/auth/email/verify`
}

/**
 * Complete the email verification process. Depending on the configuration,
 * email addresses are either verified by opening a link that is sent to
 * their email address, or, by inputting a code that is sent. On the API,
 * both cases are handled identically. Meaning, the required key is either
 * the one from the link, or, the code itself.
 *
 * Note that a status code of 401 does not imply failure. It indicates that
 * the email verification was successful, yet, the user is still not signed
 * in. For example, in case `ACCOUNT_LOGIN_ON_EMAIL_CONFIRMATION` is set to
 * `False`, a 401 is returned when verifying as part of login/signup.
 * @summary Verify an email
 */
export const allauthAuthEmailVerifyPost = async (allauthVerifyEmailBody?: AllauthVerifyEmailBody, options?: RequestInit): Promise<allauthAuthEmailVerifyPostResponse> => {

  return customFetch<allauthAuthEmailVerifyPostResponse>(getAllauthAuthEmailVerifyPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allauthVerifyEmailBody)
  }
);}




export const getAllauthAuthEmailVerifyPostMutationOptions = <TError = AllauthErrorResponse | AllauthUnauthenticatedResponse | AllauthConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyPost>>, TError,{data?: AllauthVerifyEmailBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyPost>>, TError,{data?: AllauthVerifyEmailBody}, TContext> => {

const mutationKey = ['allauthAuthEmailVerifyPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAuthEmailVerifyPost>>, {data?: AllauthVerifyEmailBody}> = (props) => {
          const {data} = props ?? {};

          return  allauthAuthEmailVerifyPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthAuthEmailVerifyPostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAuthEmailVerifyPost>>>
    export type AllauthAuthEmailVerifyPostMutationBody = AllauthVerifyEmailBody | undefined
    export type AllauthAuthEmailVerifyPostMutationError = AllauthErrorResponse | AllauthUnauthenticatedResponse | AllauthConflictResponse

    /**
 * @summary Verify an email
 */
export const useAllauthAuthEmailVerifyPost = <TError = AllauthErrorResponse | AllauthUnauthenticatedResponse | AllauthConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyPost>>, TError,{data?: AllauthVerifyEmailBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthAuthEmailVerifyPost>>,
        TError,
        {data?: AllauthVerifyEmailBody},
        TContext
      > => {
      return useMutation(getAllauthAuthEmailVerifyPostMutationOptions(options), queryClient);
    }

export type allauthAuthEmailVerifyResendPostResponse200 = {
  data: AllauthStatusOKResponse
  status: 200
}

export type allauthAuthEmailVerifyResendPostResponse409 = {
  data: AllauthConflictResponse
  status: 409
}

export type allauthAuthEmailVerifyResendPostResponse429 = {
  data: AllauthTooManyRequestsResponse
  status: 429
}

export type allauthAuthEmailVerifyResendPostResponseSuccess = (allauthAuthEmailVerifyResendPostResponse200) & {
  headers: Headers;
};
export type allauthAuthEmailVerifyResendPostResponseError = (allauthAuthEmailVerifyResendPostResponse409 | allauthAuthEmailVerifyResendPostResponse429) & {
  headers: Headers;
};

export type allauthAuthEmailVerifyResendPostResponse = (allauthAuthEmailVerifyResendPostResponseSuccess | allauthAuthEmailVerifyResendPostResponseError)

export const getAllauthAuthEmailVerifyResendPostUrl = () => {




  return `/_allauth/app/v1/auth/email/verify/resend`
}

/**
 * Requests a new email verification code.
 * Requires `ACCOUNT_EMAIL_VERIFICATION_SUPPORTS_RESEND = True`.
 * @summary Resend email verification code
 */
export const allauthAuthEmailVerifyResendPost = async ( options?: RequestInit): Promise<allauthAuthEmailVerifyResendPostResponse> => {

  return customFetch<allauthAuthEmailVerifyResendPostResponse>(getAllauthAuthEmailVerifyResendPostUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAllauthAuthEmailVerifyResendPostMutationOptions = <TError = AllauthConflictResponse | AllauthTooManyRequestsResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyResendPost>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyResendPost>>, TError,void, TContext> => {

const mutationKey = ['allauthAuthEmailVerifyResendPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAuthEmailVerifyResendPost>>, void> = () => {


          return  allauthAuthEmailVerifyResendPost(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthAuthEmailVerifyResendPostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAuthEmailVerifyResendPost>>>

    export type AllauthAuthEmailVerifyResendPostMutationError = AllauthConflictResponse | AllauthTooManyRequestsResponse

    /**
 * @summary Resend email verification code
 */
export const useAllauthAuthEmailVerifyResendPost = <TError = AllauthConflictResponse | AllauthTooManyRequestsResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthAuthEmailVerifyResendPost>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthAuthEmailVerifyResendPost>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAllauthAuthEmailVerifyResendPostMutationOptions(options), queryClient);
    }

export type allauthTokensRefreshPostResponse200 = {
  data: AllauthRefreshTokenResponse
  status: 200
}

export type allauthTokensRefreshPostResponse400 = {
  data: AllauthErrorResponse
  status: 400
}

export type allauthTokensRefreshPostResponseSuccess = (allauthTokensRefreshPostResponse200) & {
  headers: Headers;
};
export type allauthTokensRefreshPostResponseError = (allauthTokensRefreshPostResponse400) & {
  headers: Headers;
};

export type allauthTokensRefreshPostResponse = (allauthTokensRefreshPostResponseSuccess | allauthTokensRefreshPostResponseError)

export const getAllauthTokensRefreshPostUrl = () => {




  return `/_allauth/app/v1/tokens/refresh`
}

/**
 * Used to retrieve a new access token. Depending on `settings.HEADLESS_JWT_ROTATE_REFRESH_TOKEN`,
 * a new refresh token is returned as well.
 * @summary Refresh the access token

 */
export const allauthTokensRefreshPost = async (allauthRefreshTokenBody?: AllauthRefreshTokenBody, options?: RequestInit): Promise<allauthTokensRefreshPostResponse> => {

  return customFetch<allauthTokensRefreshPostResponse>(getAllauthTokensRefreshPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allauthRefreshTokenBody)
  }
);}




export const getAllauthTokensRefreshPostMutationOptions = <TError = AllauthErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthTokensRefreshPost>>, TError,{data?: AllauthRefreshTokenBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allauthTokensRefreshPost>>, TError,{data?: AllauthRefreshTokenBody}, TContext> => {

const mutationKey = ['allauthTokensRefreshPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthTokensRefreshPost>>, {data?: AllauthRefreshTokenBody}> = (props) => {
          const {data} = props ?? {};

          return  allauthTokensRefreshPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllauthTokensRefreshPostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthTokensRefreshPost>>>
    export type AllauthTokensRefreshPostMutationBody = AllauthRefreshTokenBody | undefined
    export type AllauthTokensRefreshPostMutationError = AllauthErrorResponse

    /**
 * @summary Refresh the access token

 */
export const useAllauthTokensRefreshPost = <TError = AllauthErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allauthTokensRefreshPost>>, TError,{data?: AllauthRefreshTokenBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof allauthTokensRefreshPost>>,
        TError,
        {data?: AllauthRefreshTokenBody},
        TContext
      > => {
      return useMutation(getAllauthTokensRefreshPostMutationOptions(options), queryClient);
    }
